var _2 = Object.defineProperty;
var O2 = (n, e, t) => e in n ? _2(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var Dx = (n, e, t) => O2(n, typeof e != "symbol" ? e + "" : e, t);
import { Group as Fe, ActionIcon as hi, UnstyledButton as Lc, Text as ae, Button as hn, Input as fc, Box as yt, Stack as ct, Container as fy, Paper as er, ThemeIcon as p1, Title as Ga, Collapse as I2, Tooltip as ss, Code as N2, LoadingOverlay as Wf, Avatar as hy, Table as Ze, Select as py, Pagination as P2, Modal as m1, Checkbox as Gl, Badge as on, Anchor as Rx, Alert as Ws, createTheme as L2, MantineProvider as B2, mergeThemeOverrides as j2, Menu as Ct, Flex as $m, ScrollArea as Bc, NumberInput as g1, Textarea as F2, Divider as z2, rem as Vn, ColorSwatch as V2, SimpleGrid as H2 } from "@mantine/core";
export * from "@mantine/core";
import { Button as XQ } from "@mantine/core";
export * from "@mantine/dates";
import { MonthPickerInput as nZ, TimeInput as rZ } from "@mantine/dates";
export * from "@mantine/form";
import { useDisclosure as y1 } from "@mantine/hooks";
export * from "@mantine/hooks";
import { openConfirmModal as U2, ModalsProvider as W2, modals as Ap } from "@mantine/modals";
export * from "@mantine/modals";
import { notifications as Cl, Notifications as $2 } from "@mantine/notifications";
export * from "@mantine/notifications";
import { RichTextEditor as jt } from "@mantine/tiptap";
export * from "@mantine/tiptap";
import ze, { Component as my, createRef as G2, PureComponent as Y2, forwardRef as hs, createElement as Gm, useRef as bt, useEffect as wt, useState as Et, createContext as ps, useLayoutEffect as gy, useContext as Nn, useId as q2, useCallback as fn, useMemo as Wt, Fragment as v1, useInsertionEffect as b1, useImperativeHandle as K2, useDebugValue as x1, memo as jc } from "react";
import { createPageViewParams as yy, createClientAnalyticsEvent as J2, sanitizeClientScreen as Q2, useAuth as Z2, parseJwt as X2, uploadFile as eB, mapClientError as tB, logClientWarning as nB, getJobPositions as rB, queryKeys as iB, findAllWorkShifts as sB } from "@dutyon/apis";
import { useLocation as oB, Outlet as S1, Navigate as aB, useRouteError as lB, useNavigate as cB } from "react-router-dom";
import uB, { flushSync as kx, createPortal as w1 } from "react-dom";
import { QueryClient as dB, QueryClientProvider as fB, useQuery as E1 } from "@tanstack/react-query";
var Da = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function A1(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Ym = { exports: {} }, Dl = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mx;
function hB() {
  if (Mx) return Dl;
  Mx = 1;
  var n = ze, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, c, u) {
    var d, h = {}, p = null, g = null;
    u !== void 0 && (p = "" + u), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (g = c.ref);
    for (d in c) r.call(c, d) && !s.hasOwnProperty(d) && (h[d] = c[d]);
    if (a && a.defaultProps) for (d in c = a.defaultProps, c) h[d] === void 0 && (h[d] = c[d]);
    return { $$typeof: e, type: a, key: p, ref: g, props: h, _owner: i.current };
  }
  return Dl.Fragment = t, Dl.jsx = o, Dl.jsxs = o, Dl;
}
var Rl = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _x;
function pB() {
  return _x || (_x = 1, process.env.NODE_ENV !== "production" && function() {
    var n = ze, e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), y = Symbol.iterator, b = "@@iterator";
    function S(O) {
      if (O === null || typeof O != "object")
        return null;
      var ie = y && O[y] || O[b];
      return typeof ie == "function" ? ie : null;
    }
    var w = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function T(O) {
      {
        for (var ie = arguments.length, be = new Array(ie > 1 ? ie - 1 : 0), Ie = 1; Ie < ie; Ie++)
          be[Ie - 1] = arguments[Ie];
        C("error", O, be);
      }
    }
    function C(O, ie, be) {
      {
        var Ie = w.ReactDebugCurrentFrame, st = Ie.getStackAddendum();
        st !== "" && (ie += "%s", be = be.concat([st]));
        var at = be.map(function(We) {
          return String(We);
        });
        at.unshift("Warning: " + ie), Function.prototype.apply.call(console[O], console, at);
      }
    }
    var k = !1, R = !1, N = !1, L = !1, j = !1, W;
    W = Symbol.for("react.module.reference");
    function Z(O) {
      return !!(typeof O == "string" || typeof O == "function" || O === r || O === s || j || O === i || O === u || O === d || L || O === g || k || R || N || typeof O == "object" && O !== null && (O.$$typeof === p || O.$$typeof === h || O.$$typeof === o || O.$$typeof === a || O.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      O.$$typeof === W || O.getModuleId !== void 0));
    }
    function fe(O, ie, be) {
      var Ie = O.displayName;
      if (Ie)
        return Ie;
      var st = ie.displayName || ie.name || "";
      return st !== "" ? be + "(" + st + ")" : be;
    }
    function Oe(O) {
      return O.displayName || "Context";
    }
    function Ae(O) {
      if (O == null)
        return null;
      if (typeof O.tag == "number" && T("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof O == "function")
        return O.displayName || O.name || null;
      if (typeof O == "string")
        return O;
      switch (O) {
        case r:
          return "Fragment";
        case t:
          return "Portal";
        case s:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof O == "object")
        switch (O.$$typeof) {
          case a:
            var ie = O;
            return Oe(ie) + ".Consumer";
          case o:
            var be = O;
            return Oe(be._context) + ".Provider";
          case c:
            return fe(O, O.render, "ForwardRef");
          case h:
            var Ie = O.displayName || null;
            return Ie !== null ? Ie : Ae(O.type) || "Memo";
          case p: {
            var st = O, at = st._payload, We = st._init;
            try {
              return Ae(We(at));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Y = Object.assign, re = 0, q, U, J, we, z, X, me;
    function pe() {
    }
    pe.__reactDisabledLog = !0;
    function he() {
      {
        if (re === 0) {
          q = console.log, U = console.info, J = console.warn, we = console.error, z = console.group, X = console.groupCollapsed, me = console.groupEnd;
          var O = {
            configurable: !0,
            enumerable: !0,
            value: pe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: O,
            log: O,
            warn: O,
            error: O,
            group: O,
            groupCollapsed: O,
            groupEnd: O
          });
        }
        re++;
      }
    }
    function xe() {
      {
        if (re--, re === 0) {
          var O = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Y({}, O, {
              value: q
            }),
            info: Y({}, O, {
              value: U
            }),
            warn: Y({}, O, {
              value: J
            }),
            error: Y({}, O, {
              value: we
            }),
            group: Y({}, O, {
              value: z
            }),
            groupCollapsed: Y({}, O, {
              value: X
            }),
            groupEnd: Y({}, O, {
              value: me
            })
          });
        }
        re < 0 && T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var H = w.ReactCurrentDispatcher, le;
    function G(O, ie, be) {
      {
        if (le === void 0)
          try {
            throw Error();
          } catch (st) {
            var Ie = st.stack.trim().match(/\n( *(at )?)/);
            le = Ie && Ie[1] || "";
          }
        return `
` + le + O;
      }
    }
    var oe = !1, ue;
    {
      var ge = typeof WeakMap == "function" ? WeakMap : Map;
      ue = new ge();
    }
    function Q(O, ie) {
      if (!O || oe)
        return "";
      {
        var be = ue.get(O);
        if (be !== void 0)
          return be;
      }
      var Ie;
      oe = !0;
      var st = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var at;
      at = H.current, H.current = null, he();
      try {
        if (ie) {
          var We = function() {
            throw Error();
          };
          if (Object.defineProperty(We.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(We, []);
            } catch (Lt) {
              Ie = Lt;
            }
            Reflect.construct(O, [], We);
          } else {
            try {
              We.call();
            } catch (Lt) {
              Ie = Lt;
            }
            O.call(We.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Lt) {
            Ie = Lt;
          }
          O();
        }
      } catch (Lt) {
        if (Lt && Ie && typeof Lt.stack == "string") {
          for (var je = Lt.stack.split(`
`), tn = Ie.stack.split(`
`), At = je.length - 1, Pt = tn.length - 1; At >= 1 && Pt >= 0 && je[At] !== tn[Pt]; )
            Pt--;
          for (; At >= 1 && Pt >= 0; At--, Pt--)
            if (je[At] !== tn[Pt]) {
              if (At !== 1 || Pt !== 1)
                do
                  if (At--, Pt--, Pt < 0 || je[At] !== tn[Pt]) {
                    var Cn = `
` + je[At].replace(" at new ", " at ");
                    return O.displayName && Cn.includes("<anonymous>") && (Cn = Cn.replace("<anonymous>", O.displayName)), typeof O == "function" && ue.set(O, Cn), Cn;
                  }
                while (At >= 1 && Pt >= 0);
              break;
            }
        }
      } finally {
        oe = !1, H.current = at, xe(), Error.prepareStackTrace = st;
      }
      var ar = O ? O.displayName || O.name : "", br = ar ? G(ar) : "";
      return typeof O == "function" && ue.set(O, br), br;
    }
    function ke(O, ie, be) {
      return Q(O, !1);
    }
    function Ye(O) {
      var ie = O.prototype;
      return !!(ie && ie.isReactComponent);
    }
    function it(O, ie, be) {
      if (O == null)
        return "";
      if (typeof O == "function")
        return Q(O, Ye(O));
      if (typeof O == "string")
        return G(O);
      switch (O) {
        case u:
          return G("Suspense");
        case d:
          return G("SuspenseList");
      }
      if (typeof O == "object")
        switch (O.$$typeof) {
          case c:
            return ke(O.render);
          case h:
            return it(O.type, ie, be);
          case p: {
            var Ie = O, st = Ie._payload, at = Ie._init;
            try {
              return it(at(st), ie, be);
            } catch {
            }
          }
        }
      return "";
    }
    var It = Object.prototype.hasOwnProperty, kt = {}, pn = w.ReactDebugCurrentFrame;
    function _r(O) {
      if (O) {
        var ie = O._owner, be = it(O.type, O._source, ie ? ie.type : null);
        pn.setExtraStackFrame(be);
      } else
        pn.setExtraStackFrame(null);
    }
    function ir(O, ie, be, Ie, st) {
      {
        var at = Function.call.bind(It);
        for (var We in O)
          if (at(O, We)) {
            var je = void 0;
            try {
              if (typeof O[We] != "function") {
                var tn = Error((Ie || "React class") + ": " + be + " type `" + We + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof O[We] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw tn.name = "Invariant Violation", tn;
              }
              je = O[We](ie, We, Ie, be, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (At) {
              je = At;
            }
            je && !(je instanceof Error) && (_r(st), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ie || "React class", be, We, typeof je), _r(null)), je instanceof Error && !(je.message in kt) && (kt[je.message] = !0, _r(st), T("Failed %s type: %s", be, je.message), _r(null));
          }
      }
    }
    var Qt = Array.isArray;
    function Ln(O) {
      return Qt(O);
    }
    function sr(O) {
      {
        var ie = typeof Symbol == "function" && Symbol.toStringTag, be = ie && O[Symbol.toStringTag] || O.constructor.name || "Object";
        return be;
      }
    }
    function qe(O) {
      try {
        return ut(O), !1;
      } catch {
        return !0;
      }
    }
    function ut(O) {
      return "" + O;
    }
    function vr(O) {
      if (qe(O))
        return T("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", sr(O)), ut(O);
    }
    var Nt = w.ReactCurrentOwner, Tn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Gn, cn;
    function ei(O) {
      if (It.call(O, "ref")) {
        var ie = Object.getOwnPropertyDescriptor(O, "ref").get;
        if (ie && ie.isReactWarning)
          return !1;
      }
      return O.ref !== void 0;
    }
    function or(O) {
      if (It.call(O, "key")) {
        var ie = Object.getOwnPropertyDescriptor(O, "key").get;
        if (ie && ie.isReactWarning)
          return !1;
      }
      return O.key !== void 0;
    }
    function Or(O, ie) {
      typeof O.ref == "string" && Nt.current;
    }
    function ti(O, ie) {
      {
        var be = function() {
          Gn || (Gn = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ie));
        };
        be.isReactWarning = !0, Object.defineProperty(O, "key", {
          get: be,
          configurable: !0
        });
      }
    }
    function gs(O, ie) {
      {
        var be = function() {
          cn || (cn = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ie));
        };
        be.isReactWarning = !0, Object.defineProperty(O, "ref", {
          get: be,
          configurable: !0
        });
      }
    }
    var gi = function(O, ie, be, Ie, st, at, We) {
      var je = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: O,
        key: ie,
        ref: be,
        props: We,
        // Record the component responsible for creating this element.
        _owner: at
      };
      return je._store = {}, Object.defineProperty(je._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(je, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ie
      }), Object.defineProperty(je, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: st
      }), Object.freeze && (Object.freeze(je.props), Object.freeze(je)), je;
    };
    function yi(O, ie, be, Ie, st) {
      {
        var at, We = {}, je = null, tn = null;
        be !== void 0 && (vr(be), je = "" + be), or(ie) && (vr(ie.key), je = "" + ie.key), ei(ie) && (tn = ie.ref, Or(ie, st));
        for (at in ie)
          It.call(ie, at) && !Tn.hasOwnProperty(at) && (We[at] = ie[at]);
        if (O && O.defaultProps) {
          var At = O.defaultProps;
          for (at in At)
            We[at] === void 0 && (We[at] = At[at]);
        }
        if (je || tn) {
          var Pt = typeof O == "function" ? O.displayName || O.name || "Unknown" : O;
          je && ti(We, Pt), tn && gs(We, Pt);
        }
        return gi(O, je, tn, st, Ie, Nt.current, We);
      }
    }
    var Bn = w.ReactCurrentOwner, ni = w.ReactDebugCurrentFrame;
    function Ir(O) {
      if (O) {
        var ie = O._owner, be = it(O.type, O._source, ie ? ie.type : null);
        ni.setExtraStackFrame(be);
      } else
        ni.setExtraStackFrame(null);
    }
    var vi;
    vi = !1;
    function ys(O) {
      return typeof O == "object" && O !== null && O.$$typeof === e;
    }
    function vs() {
      {
        if (Bn.current) {
          var O = Ae(Bn.current.type);
          if (O)
            return `

Check the render method of \`` + O + "`.";
        }
        return "";
      }
    }
    function oo(O) {
      return "";
    }
    var ea = {};
    function Bi(O) {
      {
        var ie = vs();
        if (!ie) {
          var be = typeof O == "string" ? O : O.displayName || O.name;
          be && (ie = `

Check the top-level render call using <` + be + ">.");
        }
        return ie;
      }
    }
    function ao(O, ie) {
      {
        if (!O._store || O._store.validated || O.key != null)
          return;
        O._store.validated = !0;
        var be = Bi(ie);
        if (ea[be])
          return;
        ea[be] = !0;
        var Ie = "";
        O && O._owner && O._owner !== Bn.current && (Ie = " It was passed a child from " + Ae(O._owner.type) + "."), Ir(O), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', be, Ie), Ir(null);
      }
    }
    function ta(O, ie) {
      {
        if (typeof O != "object")
          return;
        if (Ln(O))
          for (var be = 0; be < O.length; be++) {
            var Ie = O[be];
            ys(Ie) && ao(Ie, ie);
          }
        else if (ys(O))
          O._store && (O._store.validated = !0);
        else if (O) {
          var st = S(O);
          if (typeof st == "function" && st !== O.entries)
            for (var at = st.call(O), We; !(We = at.next()).done; )
              ys(We.value) && ao(We.value, ie);
        }
      }
    }
    function zt(O) {
      {
        var ie = O.type;
        if (ie == null || typeof ie == "string")
          return;
        var be;
        if (typeof ie == "function")
          be = ie.propTypes;
        else if (typeof ie == "object" && (ie.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ie.$$typeof === h))
          be = ie.propTypes;
        else
          return;
        if (be) {
          var Ie = Ae(ie);
          ir(be, O.props, "prop", Ie, O);
        } else if (ie.PropTypes !== void 0 && !vi) {
          vi = !0;
          var st = Ae(ie);
          T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", st || "Unknown");
        }
        typeof ie.getDefaultProps == "function" && !ie.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function bi(O) {
      {
        for (var ie = Object.keys(O.props), be = 0; be < ie.length; be++) {
          var Ie = ie[be];
          if (Ie !== "children" && Ie !== "key") {
            Ir(O), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ie), Ir(null);
            break;
          }
        }
        O.ref !== null && (Ir(O), T("Invalid attribute `ref` supplied to `React.Fragment`."), Ir(null));
      }
    }
    var bs = {};
    function lo(O, ie, be, Ie, st, at) {
      {
        var We = Z(O);
        if (!We) {
          var je = "";
          (O === void 0 || typeof O == "object" && O !== null && Object.keys(O).length === 0) && (je += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var tn = oo();
          tn ? je += tn : je += vs();
          var At;
          O === null ? At = "null" : Ln(O) ? At = "array" : O !== void 0 && O.$$typeof === e ? (At = "<" + (Ae(O.type) || "Unknown") + " />", je = " Did you accidentally export a JSX literal instead of a component?") : At = typeof O, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", At, je);
        }
        var Pt = yi(O, ie, be, st, at);
        if (Pt == null)
          return Pt;
        if (We) {
          var Cn = ie.children;
          if (Cn !== void 0)
            if (Ie)
              if (Ln(Cn)) {
                for (var ar = 0; ar < Cn.length; ar++)
                  ta(Cn[ar], O);
                Object.freeze && Object.freeze(Cn);
              } else
                T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ta(Cn, O);
        }
        if (It.call(ie, "key")) {
          var br = Ae(O), Lt = Object.keys(ie).filter(function(ne) {
            return ne !== "key";
          }), De = Lt.length > 0 ? "{key: someKey, " + Lt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bs[br + De]) {
            var _ = Lt.length > 0 ? "{" + Lt.join(": ..., ") + ": ...}" : "{}";
            T(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, De, br, _, br), bs[br + De] = !0;
          }
        }
        return O === r ? bi(Pt) : zt(Pt), Pt;
      }
    }
    function ji(O, ie, be) {
      return lo(O, ie, be, !0);
    }
    function na(O, ie, be) {
      return lo(O, ie, be, !1);
    }
    var ra = na, cl = ji;
    Rl.Fragment = r, Rl.jsx = ra, Rl.jsxs = cl;
  }()), Rl;
}
process.env.NODE_ENV === "production" ? Ym.exports = hB() : Ym.exports = pB();
var x = Ym.exports, mB = {
  code: "ko",
  buttonText: {
    prev: "이전달",
    next: "다음달",
    today: "오늘",
    year: "년도",
    month: "월",
    week: "주",
    day: "일",
    list: "일정목록"
  },
  weekText: "주",
  allDayText: "종일",
  moreLinkText: "개",
  noEventsText: "일정이 없습니다"
}, $f, _e, T1, C1, Ya, Co, Ox, D1, R1, kd = {}, k1 = [], gB = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function Bs(n, e) {
  for (var t in e) n[t] = e[t];
  return n;
}
function M1(n) {
  var e = n.parentNode;
  e && e.removeChild(n);
}
function I(n, e, t) {
  var r, i, s, o = {};
  for (s in e) s == "key" ? r = e[s] : s == "ref" ? i = e[s] : o[s] = e[s];
  if (arguments.length > 2 && (o.children = arguments.length > 3 ? $f.call(arguments, 2) : t), typeof n == "function" && n.defaultProps != null) for (s in n.defaultProps) o[s] === void 0 && (o[s] = n.defaultProps[s]);
  return hd(n, o, r, i, null);
}
function hd(n, e, t, r, i) {
  var s = { type: n, props: e, key: t, ref: r, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: i ?? ++T1 };
  return i == null && _e.vnode != null && _e.vnode(s), s;
}
function Xn() {
  return { current: null };
}
function Dt(n) {
  return n.children;
}
function yB(n, e, t, r, i) {
  var s;
  for (s in t) s === "children" || s === "key" || s in e || Md(n, s, null, t[s], r);
  for (s in e) i && typeof e[s] != "function" || s === "children" || s === "key" || s === "value" || s === "checked" || t[s] === e[s] || Md(n, s, e[s], t[s], r);
}
function Ix(n, e, t) {
  e[0] === "-" ? n.setProperty(e, t ?? "") : n[e] = t == null ? "" : typeof t != "number" || gB.test(e) ? t : t + "px";
}
function Md(n, e, t, r, i) {
  var s;
  e: if (e === "style") if (typeof t == "string") n.style.cssText = t;
  else {
    if (typeof r == "string" && (n.style.cssText = r = ""), r) for (e in r) t && e in t || Ix(n.style, e, "");
    if (t) for (e in t) r && t[e] === r[e] || Ix(n.style, e, t[e]);
  }
  else if (e[0] === "o" && e[1] === "n") s = e !== (e = e.replace(/Capture$/, "")), e = e.toLowerCase() in n ? e.toLowerCase().slice(2) : e.slice(2), n.l || (n.l = {}), n.l[e + s] = t, t ? r || n.addEventListener(e, s ? Px : Nx, s) : n.removeEventListener(e, s ? Px : Nx, s);
  else if (e !== "dangerouslySetInnerHTML") {
    if (i) e = e.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if (e !== "width" && e !== "height" && e !== "href" && e !== "list" && e !== "form" && e !== "tabIndex" && e !== "download" && e in n) try {
      n[e] = t ?? "";
      break e;
    } catch {
    }
    typeof t == "function" || (t == null || t === !1 && e.indexOf("-") == -1 ? n.removeAttribute(e) : n.setAttribute(e, t));
  }
}
function Nx(n) {
  Ya = !0;
  try {
    return this.l[n.type + !1](_e.event ? _e.event(n) : n);
  } finally {
    Ya = !1;
  }
}
function Px(n) {
  Ya = !0;
  try {
    return this.l[n.type + !0](_e.event ? _e.event(n) : n);
  } finally {
    Ya = !1;
  }
}
function Rr(n, e) {
  this.props = n, this.context = e;
}
function hc(n, e) {
  if (e == null) return n.__ ? hc(n.__, n.__.__k.indexOf(n) + 1) : null;
  for (var t; e < n.__k.length; e++) if ((t = n.__k[e]) != null && t.__e != null) return t.__e;
  return typeof n.type == "function" ? hc(n) : null;
}
function _1(n) {
  var e, t;
  if ((n = n.__) != null && n.__c != null) {
    for (n.__e = n.__c.base = null, e = 0; e < n.__k.length; e++) if ((t = n.__k[e]) != null && t.__e != null) {
      n.__e = n.__c.base = t.__e;
      break;
    }
    return _1(n);
  }
}
function vB(n) {
  Ya ? setTimeout(n) : D1(n);
}
function qm(n) {
  (!n.__d && (n.__d = !0) && Co.push(n) && !_d.__r++ || Ox !== _e.debounceRendering) && ((Ox = _e.debounceRendering) || vB)(_d);
}
function _d() {
  var n, e, t, r, i, s, o, a;
  for (Co.sort(function(c, u) {
    return c.__v.__b - u.__v.__b;
  }); n = Co.shift(); ) n.__d && (e = Co.length, r = void 0, i = void 0, o = (s = (t = n).__v).__e, (a = t.__P) && (r = [], (i = Bs({}, s)).__v = s.__v + 1, vy(a, s, i, t.__n, a.ownerSVGElement !== void 0, s.__h != null ? [o] : null, r, o ?? hc(s), s.__h), L1(r, s), s.__e != o && _1(s)), Co.length > e && Co.sort(function(c, u) {
    return c.__v.__b - u.__v.__b;
  }));
  _d.__r = 0;
}
function O1(n, e, t, r, i, s, o, a, c, u) {
  var d, h, p, g, y, b, S, w = r && r.__k || k1, T = w.length;
  for (t.__k = [], d = 0; d < e.length; d++) if ((g = t.__k[d] = (g = e[d]) == null || typeof g == "boolean" ? null : typeof g == "string" || typeof g == "number" || typeof g == "bigint" ? hd(null, g, null, null, g) : Array.isArray(g) ? hd(Dt, { children: g }, null, null, null) : g.__b > 0 ? hd(g.type, g.props, g.key, g.ref ? g.ref : null, g.__v) : g) != null) {
    if (g.__ = t, g.__b = t.__b + 1, (p = w[d]) === null || p && g.key == p.key && g.type === p.type) w[d] = void 0;
    else for (h = 0; h < T; h++) {
      if ((p = w[h]) && g.key == p.key && g.type === p.type) {
        w[h] = void 0;
        break;
      }
      p = null;
    }
    vy(n, g, p = p || kd, i, s, o, a, c, u), y = g.__e, (h = g.ref) && p.ref != h && (S || (S = []), p.ref && S.push(p.ref, null, g), S.push(h, g.__c || y, g)), y != null ? (b == null && (b = y), typeof g.type == "function" && g.__k === p.__k ? g.__d = c = I1(g, c, n) : c = N1(n, g, p, w, y, c), typeof t.type == "function" && (t.__d = c)) : c && p.__e == c && c.parentNode != n && (c = hc(p));
  }
  for (t.__e = b, d = T; d--; ) w[d] != null && (typeof t.type == "function" && w[d].__e != null && w[d].__e == t.__d && (t.__d = P1(r).nextSibling), j1(w[d], w[d]));
  if (S) for (d = 0; d < S.length; d++) B1(S[d], S[++d], S[++d]);
}
function I1(n, e, t) {
  for (var r, i = n.__k, s = 0; i && s < i.length; s++) (r = i[s]) && (r.__ = n, e = typeof r.type == "function" ? I1(r, e, t) : N1(t, r, r, i, r.__e, e));
  return e;
}
function Od(n, e) {
  return e = e || [], n == null || typeof n == "boolean" || (Array.isArray(n) ? n.some(function(t) {
    Od(t, e);
  }) : e.push(n)), e;
}
function N1(n, e, t, r, i, s) {
  var o, a, c;
  if (e.__d !== void 0) o = e.__d, e.__d = void 0;
  else if (t == null || i != s || i.parentNode == null) e: if (s == null || s.parentNode !== n) n.appendChild(i), o = null;
  else {
    for (a = s, c = 0; (a = a.nextSibling) && c < r.length; c += 1) if (a == i) break e;
    n.insertBefore(i, s), o = s;
  }
  return o !== void 0 ? o : i.nextSibling;
}
function P1(n) {
  var e, t, r;
  if (n.type == null || typeof n.type == "string") return n.__e;
  if (n.__k) {
    for (e = n.__k.length - 1; e >= 0; e--) if ((t = n.__k[e]) && (r = P1(t))) return r;
  }
  return null;
}
function vy(n, e, t, r, i, s, o, a, c) {
  var u, d, h, p, g, y, b, S, w, T, C, k, R, N, L, j = e.type;
  if (e.constructor !== void 0) return null;
  t.__h != null && (c = t.__h, a = e.__e = t.__e, e.__h = null, s = [a]), (u = _e.__b) && u(e);
  try {
    e: if (typeof j == "function") {
      if (S = e.props, w = (u = j.contextType) && r[u.__c], T = u ? w ? w.props.value : u.__ : r, t.__c ? b = (d = e.__c = t.__c).__ = d.__E : ("prototype" in j && j.prototype.render ? e.__c = d = new j(S, T) : (e.__c = d = new Rr(S, T), d.constructor = j, d.render = xB), w && w.sub(d), d.props = S, d.state || (d.state = {}), d.context = T, d.__n = r, h = d.__d = !0, d.__h = [], d._sb = []), d.__s == null && (d.__s = d.state), j.getDerivedStateFromProps != null && (d.__s == d.state && (d.__s = Bs({}, d.__s)), Bs(d.__s, j.getDerivedStateFromProps(S, d.__s))), p = d.props, g = d.state, d.__v = e, h) j.getDerivedStateFromProps == null && d.componentWillMount != null && d.componentWillMount(), d.componentDidMount != null && d.__h.push(d.componentDidMount);
      else {
        if (j.getDerivedStateFromProps == null && S !== p && d.componentWillReceiveProps != null && d.componentWillReceiveProps(S, T), !d.__e && d.shouldComponentUpdate != null && d.shouldComponentUpdate(S, d.__s, T) === !1 || e.__v === t.__v) {
          for (e.__v !== t.__v && (d.props = S, d.state = d.__s, d.__d = !1), e.__e = t.__e, e.__k = t.__k, e.__k.forEach(function(W) {
            W && (W.__ = e);
          }), C = 0; C < d._sb.length; C++) d.__h.push(d._sb[C]);
          d._sb = [], d.__h.length && o.push(d);
          break e;
        }
        d.componentWillUpdate != null && d.componentWillUpdate(S, d.__s, T), d.componentDidUpdate != null && d.__h.push(function() {
          d.componentDidUpdate(p, g, y);
        });
      }
      if (d.context = T, d.props = S, d.__P = n, k = _e.__r, R = 0, "prototype" in j && j.prototype.render) {
        for (d.state = d.__s, d.__d = !1, k && k(e), u = d.render(d.props, d.state, d.context), N = 0; N < d._sb.length; N++) d.__h.push(d._sb[N]);
        d._sb = [];
      } else do
        d.__d = !1, k && k(e), u = d.render(d.props, d.state, d.context), d.state = d.__s;
      while (d.__d && ++R < 25);
      d.state = d.__s, d.getChildContext != null && (r = Bs(Bs({}, r), d.getChildContext())), h || d.getSnapshotBeforeUpdate == null || (y = d.getSnapshotBeforeUpdate(p, g)), L = u != null && u.type === Dt && u.key == null ? u.props.children : u, O1(n, Array.isArray(L) ? L : [L], e, t, r, i, s, o, a, c), d.base = e.__e, e.__h = null, d.__h.length && o.push(d), b && (d.__E = d.__ = null), d.__e = !1;
    } else s == null && e.__v === t.__v ? (e.__k = t.__k, e.__e = t.__e) : e.__e = bB(t.__e, e, t, r, i, s, o, c);
    (u = _e.diffed) && u(e);
  } catch (W) {
    e.__v = null, (c || s != null) && (e.__e = a, e.__h = !!c, s[s.indexOf(a)] = null), _e.__e(W, e, t);
  }
}
function L1(n, e) {
  _e.__c && _e.__c(e, n), n.some(function(t) {
    try {
      n = t.__h, t.__h = [], n.some(function(r) {
        r.call(t);
      });
    } catch (r) {
      _e.__e(r, t.__v);
    }
  });
}
function bB(n, e, t, r, i, s, o, a) {
  var c, u, d, h = t.props, p = e.props, g = e.type, y = 0;
  if (g === "svg" && (i = !0), s != null) {
    for (; y < s.length; y++) if ((c = s[y]) && "setAttribute" in c == !!g && (g ? c.localName === g : c.nodeType === 3)) {
      n = c, s[y] = null;
      break;
    }
  }
  if (n == null) {
    if (g === null) return document.createTextNode(p);
    n = i ? document.createElementNS("http://www.w3.org/2000/svg", g) : document.createElement(g, p.is && p), s = null, a = !1;
  }
  if (g === null) h === p || a && n.data === p || (n.data = p);
  else {
    if (s = s && $f.call(n.childNodes), u = (h = t.props || kd).dangerouslySetInnerHTML, d = p.dangerouslySetInnerHTML, !a) {
      if (s != null) for (h = {}, y = 0; y < n.attributes.length; y++) h[n.attributes[y].name] = n.attributes[y].value;
      (d || u) && (d && (u && d.__html == u.__html || d.__html === n.innerHTML) || (n.innerHTML = d && d.__html || ""));
    }
    if (yB(n, p, h, i, a), d) e.__k = [];
    else if (y = e.props.children, O1(n, Array.isArray(y) ? y : [y], e, t, r, i && g !== "foreignObject", s, o, s ? s[0] : t.__k && hc(t, 0), a), s != null) for (y = s.length; y--; ) s[y] != null && M1(s[y]);
    a || ("value" in p && (y = p.value) !== void 0 && (y !== n.value || g === "progress" && !y || g === "option" && y !== h.value) && Md(n, "value", y, h.value, !1), "checked" in p && (y = p.checked) !== void 0 && y !== n.checked && Md(n, "checked", y, h.checked, !1));
  }
  return n;
}
function B1(n, e, t) {
  try {
    typeof n == "function" ? n(e) : n.current = e;
  } catch (r) {
    _e.__e(r, t);
  }
}
function j1(n, e, t) {
  var r, i;
  if (_e.unmount && _e.unmount(n), (r = n.ref) && (r.current && r.current !== n.__e || B1(r, null, e)), (r = n.__c) != null) {
    if (r.componentWillUnmount) try {
      r.componentWillUnmount();
    } catch (s) {
      _e.__e(s, e);
    }
    r.base = r.__P = null, n.__c = void 0;
  }
  if (r = n.__k) for (i = 0; i < r.length; i++) r[i] && j1(r[i], e, t || typeof n.type != "function");
  t || n.__e == null || M1(n.__e), n.__ = n.__e = n.__d = void 0;
}
function xB(n, e, t) {
  return this.constructor(n, t);
}
function pc(n, e, t) {
  var r, i, s;
  _e.__ && _e.__(n, e), i = (r = !1) ? null : e.__k, s = [], vy(e, n = e.__k = I(Dt, null, [n]), i || kd, kd, e.ownerSVGElement !== void 0, i ? null : e.firstChild ? $f.call(e.childNodes) : null, s, i ? i.__e : e.firstChild, r), L1(s, n);
}
function SB(n, e) {
  var t = { __c: e = "__cC" + R1++, __: n, Consumer: function(r, i) {
    return r.children(i);
  }, Provider: function(r) {
    var i, s;
    return this.getChildContext || (i = [], (s = {})[e] = this, this.getChildContext = function() {
      return s;
    }, this.shouldComponentUpdate = function(o) {
      this.props.value !== o.value && i.some(function(a) {
        a.__e = !0, qm(a);
      });
    }, this.sub = function(o) {
      i.push(o);
      var a = o.componentWillUnmount;
      o.componentWillUnmount = function() {
        i.splice(i.indexOf(o), 1), a && a.call(o);
      };
    }), r.children;
  } };
  return t.Provider.__ = t.Consumer.contextType = t;
}
$f = k1.slice, _e = { __e: function(n, e, t, r) {
  for (var i, s, o; e = e.__; ) if ((i = e.__c) && !i.__) try {
    if ((s = i.constructor) && s.getDerivedStateFromError != null && (i.setState(s.getDerivedStateFromError(n)), o = i.__d), i.componentDidCatch != null && (i.componentDidCatch(n, r || {}), o = i.__d), o) return i.__E = i;
  } catch (a) {
    n = a;
  }
  throw n;
} }, T1 = 0, C1 = function(n) {
  return n != null && n.constructor === void 0;
}, Ya = !1, Rr.prototype.setState = function(n, e) {
  var t;
  t = this.__s != null && this.__s !== this.state ? this.__s : this.__s = Bs({}, this.state), typeof n == "function" && (n = n(Bs({}, t), this.props)), n && Bs(t, n), n != null && this.__v && (e && this._sb.push(e), qm(this));
}, Rr.prototype.forceUpdate = function(n) {
  this.__v && (this.__e = !0, n && this.__h.push(n), qm(this));
}, Rr.prototype.render = Dt, Co = [], D1 = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, _d.__r = 0, R1 = 0;
var Di, Tp, Lx, F1 = [], Cp = [], Bx = _e.__b, jx = _e.__r, Fx = _e.diffed, zx = _e.__c, Vx = _e.unmount;
function wB() {
  for (var n; n = F1.shift(); ) if (n.__P && n.__H) try {
    n.__H.__h.forEach(pd), n.__H.__h.forEach(Km), n.__H.__h = [];
  } catch (e) {
    n.__H.__h = [], _e.__e(e, n.__v);
  }
}
_e.__b = function(n) {
  Di = null, Bx && Bx(n);
}, _e.__r = function(n) {
  jx && jx(n);
  var e = (Di = n.__c).__H;
  e && (Tp === Di ? (e.__h = [], Di.__h = [], e.__.forEach(function(t) {
    t.__N && (t.__ = t.__N), t.__V = Cp, t.__N = t.i = void 0;
  })) : (e.__h.forEach(pd), e.__h.forEach(Km), e.__h = [])), Tp = Di;
}, _e.diffed = function(n) {
  Fx && Fx(n);
  var e = n.__c;
  e && e.__H && (e.__H.__h.length && (F1.push(e) !== 1 && Lx === _e.requestAnimationFrame || ((Lx = _e.requestAnimationFrame) || EB)(wB)), e.__H.__.forEach(function(t) {
    t.i && (t.__H = t.i), t.__V !== Cp && (t.__ = t.__V), t.i = void 0, t.__V = Cp;
  })), Tp = Di = null;
}, _e.__c = function(n, e) {
  e.some(function(t) {
    try {
      t.__h.forEach(pd), t.__h = t.__h.filter(function(r) {
        return !r.__ || Km(r);
      });
    } catch (r) {
      e.some(function(i) {
        i.__h && (i.__h = []);
      }), e = [], _e.__e(r, t.__v);
    }
  }), zx && zx(n, e);
}, _e.unmount = function(n) {
  Vx && Vx(n);
  var e, t = n.__c;
  t && t.__H && (t.__H.__.forEach(function(r) {
    try {
      pd(r);
    } catch (i) {
      e = i;
    }
  }), t.__H = void 0, e && _e.__e(e, t.__v));
};
var Hx = typeof requestAnimationFrame == "function";
function EB(n) {
  var e, t = function() {
    clearTimeout(r), Hx && cancelAnimationFrame(e), setTimeout(n);
  }, r = setTimeout(t, 100);
  Hx && (e = requestAnimationFrame(t));
}
function pd(n) {
  var e = Di, t = n.__c;
  typeof t == "function" && (n.__c = void 0, t()), Di = e;
}
function Km(n) {
  var e = Di;
  n.__c = n.__(), Di = e;
}
function AB(n, e) {
  for (var t in e) n[t] = e[t];
  return n;
}
function Ux(n, e) {
  for (var t in n) if (t !== "__source" && !(t in e)) return !0;
  for (var r in e) if (r !== "__source" && n[r] !== e[r]) return !0;
  return !1;
}
function Wx(n) {
  this.props = n;
}
(Wx.prototype = new Rr()).isPureReactComponent = !0, Wx.prototype.shouldComponentUpdate = function(n, e) {
  return Ux(this.props, n) || Ux(this.state, e);
};
var $x = _e.__b;
_e.__b = function(n) {
  n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $x && $x(n);
};
var TB = _e.__e;
_e.__e = function(n, e, t, r) {
  if (n.then) {
    for (var i, s = e; s = s.__; ) if ((i = s.__c) && i.__c) return e.__e == null && (e.__e = t.__e, e.__k = t.__k), i.__c(n, e);
  }
  TB(n, e, t, r);
};
var Gx = _e.unmount;
function z1(n, e, t) {
  return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(r) {
    typeof r.__c == "function" && r.__c();
  }), n.__c.__H = null), (n = AB({}, n)).__c != null && (n.__c.__P === t && (n.__c.__P = e), n.__c = null), n.__k = n.__k && n.__k.map(function(r) {
    return z1(r, e, t);
  })), n;
}
function V1(n, e, t) {
  return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(r) {
    return V1(r, e, t);
  }), n.__c && n.__c.__P === e && (n.__e && t.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = t)), n;
}
function Dp() {
  this.__u = 0, this.t = null, this.__b = null;
}
function H1(n) {
  var e = n.__.__c;
  return e && e.__a && e.__a(n);
}
function Lu() {
  this.u = null, this.o = null;
}
_e.unmount = function(n) {
  var e = n.__c;
  e && e.__R && e.__R(), e && n.__h === !0 && (n.type = null), Gx && Gx(n);
}, (Dp.prototype = new Rr()).__c = function(n, e) {
  var t = e.__c, r = this;
  r.t == null && (r.t = []), r.t.push(t);
  var i = H1(r.__v), s = !1, o = function() {
    s || (s = !0, t.__R = null, i ? i(a) : a());
  };
  t.__R = o;
  var a = function() {
    if (!--r.__u) {
      if (r.state.__a) {
        var u = r.state.__a;
        r.__v.__k[0] = V1(u, u.__c.__P, u.__c.__O);
      }
      var d;
      for (r.setState({ __a: r.__b = null }); d = r.t.pop(); ) d.forceUpdate();
    }
  }, c = e.__h === !0;
  r.__u++ || c || r.setState({ __a: r.__b = r.__v.__k[0] }), n.then(o, o);
}, Dp.prototype.componentWillUnmount = function() {
  this.t = [];
}, Dp.prototype.render = function(n, e) {
  if (this.__b) {
    if (this.__v.__k) {
      var t = document.createElement("div"), r = this.__v.__k[0].__c;
      this.__v.__k[0] = z1(this.__b, t, r.__O = r.__P);
    }
    this.__b = null;
  }
  var i = e.__a && I(Dt, null, n.fallback);
  return i && (i.__h = null), [I(Dt, null, e.__a ? null : n.children), i];
};
var Yx = function(n, e, t) {
  if (++t[1] === t[0] && n.o.delete(e), n.props.revealOrder && (n.props.revealOrder[0] !== "t" || !n.o.size)) for (t = n.u; t; ) {
    for (; t.length > 3; ) t.pop()();
    if (t[1] < t[0]) break;
    n.u = t = t[2];
  }
};
function CB(n) {
  return this.getChildContext = function() {
    return n.context;
  }, n.children;
}
function DB(n) {
  var e = this, t = n.i;
  e.componentWillUnmount = function() {
    pc(null, e.l), e.l = null, e.i = null;
  }, e.i && e.i !== t && e.componentWillUnmount(), n.__v ? (e.l || (e.i = t, e.l = { nodeType: 1, parentNode: t, childNodes: [], appendChild: function(r) {
    this.childNodes.push(r), e.i.appendChild(r);
  }, insertBefore: function(r, i) {
    this.childNodes.push(r), e.i.appendChild(r);
  }, removeChild: function(r) {
    this.childNodes.splice(this.childNodes.indexOf(r) >>> 1, 1), e.i.removeChild(r);
  } }), pc(I(CB, { context: e.context }, n.__v), e.l)) : e.l && e.componentWillUnmount();
}
function RB(n, e) {
  var t = I(DB, { __v: n, i: e });
  return t.containerInfo = e, t;
}
(Lu.prototype = new Rr()).__a = function(n) {
  var e = this, t = H1(e.__v), r = e.o.get(n);
  return r[0]++, function(i) {
    var s = function() {
      e.props.revealOrder ? (r.push(i), Yx(e, n, r)) : i();
    };
    t ? t(s) : s();
  };
}, Lu.prototype.render = function(n) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var e = Od(n.children);
  n.revealOrder && n.revealOrder[0] === "b" && e.reverse();
  for (var t = e.length; t--; ) this.o.set(e[t], this.u = [1, 0, this.u]);
  return n.children;
}, Lu.prototype.componentDidUpdate = Lu.prototype.componentDidMount = function() {
  var n = this;
  this.o.forEach(function(e, t) {
    Yx(n, t, e);
  });
};
var kB = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, MB = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, _B = typeof document < "u", OB = function(n) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
Rr.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(n) {
  Object.defineProperty(Rr.prototype, n, { configurable: !0, get: function() {
    return this["UNSAFE_" + n];
  }, set: function(e) {
    Object.defineProperty(this, n, { configurable: !0, writable: !0, value: e });
  } });
});
var qx = _e.event;
function IB() {
}
function NB() {
  return this.cancelBubble;
}
function PB() {
  return this.defaultPrevented;
}
_e.event = function(n) {
  return qx && (n = qx(n)), n.persist = IB, n.isPropagationStopped = NB, n.isDefaultPrevented = PB, n.nativeEvent = n;
};
var Kx = { configurable: !0, get: function() {
  return this.class;
} }, Jx = _e.vnode;
_e.vnode = function(n) {
  var e = n.type, t = n.props, r = t;
  if (typeof e == "string") {
    var i = e.indexOf("-") === -1;
    for (var s in r = {}, t) {
      var o = t[s];
      _B && s === "children" && e === "noscript" || s === "value" && "defaultValue" in t && o == null || (s === "defaultValue" && "value" in t && t.value == null ? s = "value" : s === "download" && o === !0 ? o = "" : /ondoubleclick/i.test(s) ? s = "ondblclick" : /^onchange(textarea|input)/i.test(s + e) && !OB(t.type) ? s = "oninput" : /^onfocus$/i.test(s) ? s = "onfocusin" : /^onblur$/i.test(s) ? s = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(s) ? s = s.toLowerCase() : i && MB.test(s) ? s = s.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : o === null && (o = void 0), /^oninput$/i.test(s) && (s = s.toLowerCase(), r[s] && (s = "oninputCapture")), r[s] = o);
    }
    e == "select" && r.multiple && Array.isArray(r.value) && (r.value = Od(t.children).forEach(function(a) {
      a.props.selected = r.value.indexOf(a.props.value) != -1;
    })), e == "select" && r.defaultValue != null && (r.value = Od(t.children).forEach(function(a) {
      a.props.selected = r.multiple ? r.defaultValue.indexOf(a.props.value) != -1 : r.defaultValue == a.props.value;
    })), n.props = r, t.class != t.className && (Kx.enumerable = "className" in t, t.className != null && (r.class = t.className), Object.defineProperty(r, "className", Kx));
  }
  n.$$typeof = kB, Jx && Jx(n);
};
var Qx = _e.__r;
_e.__r = function(n) {
  Qx && Qx(n), n.__c;
};
const U1 = [], Jm = /* @__PURE__ */ new Map();
function by(n) {
  U1.push(n), Jm.forEach((e) => {
    $1(e, n);
  });
}
function LB(n) {
  n.isConnected && // sometimes true if SSR system simulates DOM
  n.getRootNode && W1(n.getRootNode());
}
function W1(n) {
  let e = Jm.get(n);
  if (!e || !e.isConnected) {
    if (e = n.querySelector("style[data-fullcalendar]"), !e) {
      e = document.createElement("style"), e.setAttribute("data-fullcalendar", "");
      const t = jB();
      t && (e.nonce = t);
      const r = n === document ? document.head : n, i = n === document ? r.querySelector("script,link[rel=stylesheet],link[as=style],style") : r.firstChild;
      r.insertBefore(e, i);
    }
    Jm.set(n, e), BB(e);
  }
}
function BB(n) {
  for (const e of U1)
    $1(n, e);
}
function $1(n, e) {
  const { sheet: t } = n, r = t.cssRules.length;
  e.split("}").forEach((i, s) => {
    i = i.trim(), i && t.insertRule(i + "}", r + s);
  });
}
let Rp;
function jB() {
  return Rp === void 0 && (Rp = FB()), Rp;
}
function FB() {
  const n = document.querySelector('meta[name="csp-nonce"]');
  if (n && n.hasAttribute("content"))
    return n.getAttribute("content");
  const e = document.querySelector("script[nonce]");
  return e && e.nonce || "";
}
typeof document < "u" && W1(document);
var zB = ':root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url("data:application/x-font-ttf;charset=utf-8;base64,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") format("truetype")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:"\\e900"}.fc-icon-chevron-right:before{content:"\\e901"}.fc-icon-chevrons-left:before{content:"\\e902"}.fc-icon-chevrons-right:before{content:"\\e903"}.fc-icon-minus-square:before{content:"\\e904"}.fc-icon-plus-square:before{content:"\\e905"}.fc-icon-x:before{content:"\\e906"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:"";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:"";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:"";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}';
by(zB);
class xy {
  constructor(e) {
    this.drainedOption = e, this.isRunning = !1, this.isDirty = !1, this.pauseDepths = {}, this.timeoutId = 0;
  }
  request(e) {
    this.isDirty = !0, this.isPaused() || (this.clearTimeout(), e == null ? this.tryDrain() : this.timeoutId = setTimeout(
      // NOT OPTIMAL! TODO: look at debounce
      this.tryDrain.bind(this),
      e
    ));
  }
  pause(e = "") {
    let { pauseDepths: t } = this;
    t[e] = (t[e] || 0) + 1, this.clearTimeout();
  }
  resume(e = "", t) {
    let { pauseDepths: r } = this;
    e in r && (t ? delete r[e] : (r[e] -= 1, r[e] <= 0 && delete r[e]), this.tryDrain());
  }
  isPaused() {
    return Object.keys(this.pauseDepths).length;
  }
  tryDrain() {
    if (!this.isRunning && !this.isPaused()) {
      for (this.isRunning = !0; this.isDirty; )
        this.isDirty = !1, this.drained();
      this.isRunning = !1;
    }
  }
  clear() {
    this.clearTimeout(), this.isDirty = !1, this.pauseDepths = {};
  }
  clearTimeout() {
    this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = 0);
  }
  drained() {
    this.drainedOption && this.drainedOption();
  }
}
function VB(n) {
  n.parentNode && n.parentNode.removeChild(n);
}
function Xi(n, e) {
  if (n.closest)
    return n.closest(e);
  if (!document.documentElement.contains(n))
    return null;
  do {
    if (HB(n, e))
      return n;
    n = n.parentElement || n.parentNode;
  } while (n !== null && n.nodeType === 1);
  return null;
}
function HB(n, e) {
  return (n.matches || n.matchesSelector || n.msMatchesSelector).call(n, e);
}
function UB(n, e) {
  let t = n instanceof HTMLElement ? [n] : n, r = [];
  for (let i = 0; i < t.length; i += 1) {
    let s = t[i].querySelectorAll(e);
    for (let o = 0; o < s.length; o += 1)
      r.push(s[o]);
  }
  return r;
}
const WB = /(top|left|right|bottom|width|height)$/i;
function $B(n, e) {
  for (let t in e)
    G1(n, t, e[t]);
}
function G1(n, e, t) {
  t == null ? n.style[e] = "" : typeof t == "number" && WB.test(e) ? n.style[e] = `${t}px` : n.style[e] = t;
}
function GB(n) {
  var e, t;
  return (t = (e = n.composedPath) === null || e === void 0 ? void 0 : e.call(n)[0]) !== null && t !== void 0 ? t : n.target;
}
let Zx = 0;
function Gf() {
  return Zx += 1, "fc-dom-" + Zx;
}
function YB(n, e) {
  return (t) => {
    let r = Xi(t.target, n);
    r && e.call(r, t, r);
  };
}
function Y1(n, e, t, r) {
  let i = YB(t, r);
  return n.addEventListener(e, i), () => {
    n.removeEventListener(e, i);
  };
}
function qB(n, e, t, r) {
  let i;
  return Y1(n, "mouseover", e, (s, o) => {
    if (o !== i) {
      i = o, t(s, o);
      let a = (c) => {
        i = null, r(c, o), o.removeEventListener("mouseleave", a);
      };
      o.addEventListener("mouseleave", a);
    }
  });
}
function q1(n) {
  return Object.assign({ onClick: n }, K1(n));
}
function K1(n) {
  return {
    tabIndex: 0,
    onKeyDown(e) {
      (e.key === "Enter" || e.key === " ") && (n(e), e.preventDefault());
    }
  };
}
let Xx = 0;
function Jo() {
  return Xx += 1, String(Xx);
}
function KB(n) {
  let e = [], t = [], r, i;
  for (typeof n == "string" ? t = n.split(/\s*,\s*/) : typeof n == "function" ? t = [n] : Array.isArray(n) && (t = n), r = 0; r < t.length; r += 1)
    i = t[r], typeof i == "string" ? e.push(i.charAt(0) === "-" ? { field: i.substring(1), order: -1 } : { field: i, order: 1 }) : typeof i == "function" && e.push({ func: i });
  return e;
}
function JB(n, e, t) {
  let r, i;
  for (r = 0; r < t.length; r += 1)
    if (i = QB(n, e, t[r]), i)
      return i;
  return 0;
}
function QB(n, e, t) {
  return t.func ? t.func(n, e) : ZB(n[t.field], e[t.field]) * (t.order || 1);
}
function ZB(n, e) {
  return !n && !e ? 0 : e == null ? -1 : n == null ? 1 : typeof n == "string" || typeof e == "string" ? String(n).localeCompare(String(e)) : n - e;
}
function za(n, e) {
  let t = String(n);
  return "000".substr(0, e - t.length) + t;
}
function Yl(n, e, t) {
  return typeof n == "function" ? n(...e) : typeof n == "string" ? e.reduce((r, i, s) => r.replace("$" + s, i || ""), n) : t;
}
function md(n) {
  return n % 1 === 0;
}
function XB(n) {
  let e = n.querySelector(".fc-scrollgrid-shrink-frame"), t = n.querySelector(".fc-scrollgrid-shrink-cushion");
  if (!e)
    throw new Error("needs fc-scrollgrid-shrink-frame className");
  if (!t)
    throw new Error("needs fc-scrollgrid-shrink-cushion className");
  return n.getBoundingClientRect().width - e.getBoundingClientRect().width + // the cell padding+border
  t.getBoundingClientRect().width;
}
const eS = ["years", "months", "days", "milliseconds"], ej = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
function lt(n, e) {
  return typeof n == "string" ? tj(n) : typeof n == "object" && n ? tS(n) : typeof n == "number" ? tS({ [e || "milliseconds"]: n }) : null;
}
function tj(n) {
  let e = ej.exec(n);
  if (e) {
    let t = e[1] ? -1 : 1;
    return {
      years: 0,
      months: 0,
      days: t * (e[2] ? parseInt(e[2], 10) : 0),
      milliseconds: t * ((e[3] ? parseInt(e[3], 10) : 0) * 60 * 60 * 1e3 + // hours
      (e[4] ? parseInt(e[4], 10) : 0) * 60 * 1e3 + // minutes
      (e[5] ? parseInt(e[5], 10) : 0) * 1e3 + // seconds
      (e[6] ? parseInt(e[6], 10) : 0))
    };
  }
  return null;
}
function tS(n) {
  let e = {
    years: n.years || n.year || 0,
    months: n.months || n.month || 0,
    days: n.days || n.day || 0,
    milliseconds: (n.hours || n.hour || 0) * 60 * 60 * 1e3 + // hours
    (n.minutes || n.minute || 0) * 60 * 1e3 + // minutes
    (n.seconds || n.second || 0) * 1e3 + // seconds
    (n.milliseconds || n.millisecond || n.ms || 0)
    // ms
  }, t = n.weeks || n.week;
  return t && (e.days += t * 7, e.specifiedWeeks = !0), e;
}
function nj(n, e) {
  return n.years === e.years && n.months === e.months && n.days === e.days && n.milliseconds === e.milliseconds;
}
function Qm(n, e) {
  return {
    years: n.years + e.years,
    months: n.months + e.months,
    days: n.days + e.days,
    milliseconds: n.milliseconds + e.milliseconds
  };
}
function rj(n, e) {
  return {
    years: n.years - e.years,
    months: n.months - e.months,
    days: n.days - e.days,
    milliseconds: n.milliseconds - e.milliseconds
  };
}
function ij(n, e) {
  return {
    years: n.years * e,
    months: n.months * e,
    days: n.days * e,
    milliseconds: n.milliseconds * e
  };
}
function sj(n) {
  return Va(n) / 365;
}
function oj(n) {
  return Va(n) / 30;
}
function Va(n) {
  return di(n) / 864e5;
}
function di(n) {
  return n.years * (365 * 864e5) + n.months * (30 * 864e5) + n.days * 864e5 + n.milliseconds;
}
function Sy(n, e) {
  let t = null;
  for (let r = 0; r < eS.length; r += 1) {
    let i = eS[r];
    if (e[i]) {
      let s = n[i] / e[i];
      if (!md(s) || t !== null && t !== s)
        return null;
      t = s;
    } else if (n[i])
      return null;
  }
  return t;
}
function Zm(n) {
  let e = n.milliseconds;
  if (e) {
    if (e % 1e3 !== 0)
      return { unit: "millisecond", value: e };
    if (e % (1e3 * 60) !== 0)
      return { unit: "second", value: e / 1e3 };
    if (e % (1e3 * 60 * 60) !== 0)
      return { unit: "minute", value: e / (1e3 * 60) };
    if (e)
      return { unit: "hour", value: e / (1e3 * 60 * 60) };
  }
  return n.days ? n.specifiedWeeks && n.days % 7 === 0 ? { unit: "week", value: n.days / 7 } : { unit: "day", value: n.days } : n.months ? { unit: "month", value: n.months } : n.years ? { unit: "year", value: n.years } : { unit: "millisecond", value: 0 };
}
function Js(n, e, t) {
  if (n === e)
    return !0;
  let r = n.length, i;
  if (r !== e.length)
    return !1;
  for (i = 0; i < r; i += 1)
    if (!(t ? t(n[i], e[i]) : n[i] === e[i]))
      return !1;
  return !0;
}
const aj = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
function nS(n, e) {
  let t = js(n);
  return t[2] += e * 7, pr(t);
}
function bn(n, e) {
  let t = js(n);
  return t[2] += e, pr(t);
}
function Qs(n, e) {
  let t = js(n);
  return t[6] += e, pr(t);
}
function lj(n, e) {
  return Qo(n, e) / 7;
}
function Qo(n, e) {
  return (e.valueOf() - n.valueOf()) / (1e3 * 60 * 60 * 24);
}
function cj(n, e) {
  return (e.valueOf() - n.valueOf()) / (1e3 * 60 * 60);
}
function uj(n, e) {
  return (e.valueOf() - n.valueOf()) / (1e3 * 60);
}
function dj(n, e) {
  return (e.valueOf() - n.valueOf()) / 1e3;
}
function fj(n, e) {
  let t = Ot(n), r = Ot(e);
  return {
    years: 0,
    months: 0,
    days: Math.round(Qo(t, r)),
    milliseconds: e.valueOf() - r.valueOf() - (n.valueOf() - t.valueOf())
  };
}
function hj(n, e) {
  let t = Id(n, e);
  return t !== null && t % 7 === 0 ? t / 7 : null;
}
function Id(n, e) {
  return Fs(n) === Fs(e) ? Math.round(Qo(n, e)) : null;
}
function Ot(n) {
  return pr([
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate()
  ]);
}
function pj(n) {
  return pr([
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate(),
    n.getUTCHours()
  ]);
}
function mj(n) {
  return pr([
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate(),
    n.getUTCHours(),
    n.getUTCMinutes()
  ]);
}
function gj(n) {
  return pr([
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate(),
    n.getUTCHours(),
    n.getUTCMinutes(),
    n.getUTCSeconds()
  ]);
}
function yj(n, e, t) {
  let r = n.getUTCFullYear(), i = kp(n, r, e, t);
  if (i < 1)
    return kp(n, r - 1, e, t);
  let s = kp(n, r + 1, e, t);
  return s >= 1 ? Math.min(i, s) : i;
}
function kp(n, e, t, r) {
  let i = pr([e, 0, 1 + vj(e, t, r)]), s = Ot(n), o = Math.round(Qo(i, s));
  return Math.floor(o / 7) + 1;
}
function vj(n, e, t) {
  let r = 7 + e - t;
  return -((7 + pr([n, 0, r]).getUTCDay() - e) % 7) + r - 1;
}
function rS(n) {
  return [
    n.getFullYear(),
    n.getMonth(),
    n.getDate(),
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ];
}
function iS(n) {
  return new Date(
    n[0],
    n[1] || 0,
    n[2] == null ? 1 : n[2],
    // day of month
    n[3] || 0,
    n[4] || 0,
    n[5] || 0
  );
}
function js(n) {
  return [
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate(),
    n.getUTCHours(),
    n.getUTCMinutes(),
    n.getUTCSeconds(),
    n.getUTCMilliseconds()
  ];
}
function pr(n) {
  return n.length === 1 && (n = n.concat([0])), new Date(Date.UTC(...n));
}
function J1(n) {
  return !isNaN(n.valueOf());
}
function Fs(n) {
  return n.getUTCHours() * 1e3 * 60 * 60 + n.getUTCMinutes() * 1e3 * 60 + n.getUTCSeconds() * 1e3 + n.getUTCMilliseconds();
}
function Q1(n, e, t = !1) {
  let r = n.toISOString();
  return r = r.replace(".000", ""), t && (r = r.replace("T00:00:00Z", "")), r.length > 10 && (e == null ? r = r.replace("Z", "") : e !== 0 && (r = r.replace("Z", Ey(e, !0)))), r;
}
function wy(n) {
  return n.toISOString().replace(/T.*$/, "");
}
function bj(n) {
  return n.toISOString().match(/^\d{4}-\d{2}/)[0];
}
function xj(n) {
  return za(n.getUTCHours(), 2) + ":" + za(n.getUTCMinutes(), 2) + ":" + za(n.getUTCSeconds(), 2);
}
function Ey(n, e = !1) {
  let t = n < 0 ? "-" : "+", r = Math.abs(n), i = Math.floor(r / 60), s = Math.round(r % 60);
  return e ? `${t + za(i, 2)}:${za(s, 2)}` : `GMT${t}${i}${s ? `:${za(s, 2)}` : ""}`;
}
function Pe(n, e, t) {
  let r, i;
  return function(...s) {
    if (!r)
      i = n.apply(this, s);
    else if (!Js(r, s)) {
      let o = n.apply(this, s);
      (!e || !e(o, i)) && (i = o);
    }
    return r = s, i;
  };
}
function gd(n, e, t) {
  let r, i;
  return (s) => (r ? pi(r, s) || (i = n.call(this, s)) : i = n.call(this, s), r = s, i);
}
const Mp = {
  week: 3,
  separator: 9,
  omitZeroMinute: 9,
  meridiem: 9,
  omitCommas: 9
}, Nd = {
  timeZoneName: 7,
  era: 6,
  year: 5,
  month: 4,
  day: 2,
  weekday: 2,
  hour: 1,
  minute: 1,
  second: 1
}, Bu = /\s*([ap])\.?m\.?/i, Sj = /,/g, wj = /\s+/g, Ej = /\u200e/g, Aj = /UTC|GMT/;
class Tj {
  constructor(e) {
    let t = {}, r = {}, i = 9;
    for (let s in e)
      s in Mp ? (r[s] = e[s], Mp[s] < 9 && (i = Math.min(Mp[s], i))) : (t[s] = e[s], s in Nd && (i = Math.min(Nd[s], i)));
    this.standardDateProps = t, this.extendedSettings = r, this.smallestUnitNum = i, this.buildFormattingFunc = Pe(sS);
  }
  format(e, t) {
    return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, t)(e);
  }
  formatRange(e, t, r, i) {
    let { standardDateProps: s, extendedSettings: o } = this, a = _j(e.marker, t.marker, r.calendarSystem);
    if (!a)
      return this.format(e, r);
    let c = a;
    c > 1 && // the two dates are different in a way that's larger scale than time
    (s.year === "numeric" || s.year === "2-digit") && (s.month === "numeric" || s.month === "2-digit") && (s.day === "numeric" || s.day === "2-digit") && (c = 1);
    let u = this.format(e, r), d = this.format(t, r);
    if (u === d)
      return u;
    let h = Oj(s, c), p = sS(h, o, r), g = p(e), y = p(t), b = Ij(u, g, d, y), S = o.separator || i || r.defaultSeparator || "";
    return b ? b.before + g + S + y + b.after : u + S + d;
  }
  getSmallestUnit() {
    switch (this.smallestUnitNum) {
      case 7:
      case 6:
      case 5:
        return "year";
      case 4:
        return "month";
      case 3:
        return "week";
      case 2:
        return "day";
      default:
        return "time";
    }
  }
}
function sS(n, e, t) {
  let r = Object.keys(n).length;
  return r === 1 && n.timeZoneName === "short" ? (i) => Ey(i.timeZoneOffset) : r === 0 && e.week ? (i) => Mj(t.computeWeekNumber(i.marker), t.weekText, t.weekTextLong, t.locale, e.week) : Cj(n, e, t);
}
function Cj(n, e, t) {
  n = Object.assign({}, n), e = Object.assign({}, e), Dj(n, e), n.timeZone = "UTC";
  let r = new Intl.DateTimeFormat(t.locale.codes, n), i;
  if (e.omitZeroMinute) {
    let s = Object.assign({}, n);
    delete s.minute, i = new Intl.DateTimeFormat(t.locale.codes, s);
  }
  return (s) => {
    let { marker: o } = s, a;
    i && !o.getUTCMinutes() ? a = i : a = r;
    let c = a.format(o);
    return Rj(c, s, n, e, t);
  };
}
function Dj(n, e) {
  n.timeZoneName && (n.hour || (n.hour = "2-digit"), n.minute || (n.minute = "2-digit")), n.timeZoneName === "long" && (n.timeZoneName = "short"), e.omitZeroMinute && (n.second || n.millisecond) && delete e.omitZeroMinute;
}
function Rj(n, e, t, r, i) {
  return n = n.replace(Ej, ""), t.timeZoneName === "short" && (n = kj(n, i.timeZone === "UTC" || e.timeZoneOffset == null ? "UTC" : (
    // important to normalize for IE, which does "GMT"
    Ey(e.timeZoneOffset)
  ))), r.omitCommas && (n = n.replace(Sj, "").trim()), r.omitZeroMinute && (n = n.replace(":00", "")), r.meridiem === !1 ? n = n.replace(Bu, "").trim() : r.meridiem === "narrow" ? n = n.replace(Bu, (s, o) => o.toLocaleLowerCase()) : r.meridiem === "short" ? n = n.replace(Bu, (s, o) => `${o.toLocaleLowerCase()}m`) : r.meridiem === "lowercase" && (n = n.replace(Bu, (s) => s.toLocaleLowerCase())), n = n.replace(wj, " "), n = n.trim(), n;
}
function kj(n, e) {
  let t = !1;
  return n = n.replace(Aj, () => (t = !0, e)), t || (n += ` ${e}`), n;
}
function Mj(n, e, t, r, i) {
  let s = [];
  return i === "long" ? s.push(t) : (i === "short" || i === "narrow") && s.push(e), (i === "long" || i === "short") && s.push(" "), s.push(r.simpleNumberFormat.format(n)), r.options.direction === "rtl" && s.reverse(), s.join("");
}
function _j(n, e, t) {
  return t.getMarkerYear(n) !== t.getMarkerYear(e) ? 5 : t.getMarkerMonth(n) !== t.getMarkerMonth(e) ? 4 : t.getMarkerDay(n) !== t.getMarkerDay(e) ? 2 : Fs(n) !== Fs(e) ? 1 : 0;
}
function Oj(n, e) {
  let t = {};
  for (let r in n)
    (!(r in Nd) || // not a date part prop (like timeZone)
    Nd[r] <= e) && (t[r] = n[r]);
  return t;
}
function Ij(n, e, t, r) {
  let i = 0;
  for (; i < n.length; ) {
    let s = n.indexOf(e, i);
    if (s === -1)
      break;
    let o = n.substr(0, s);
    i = s + e.length;
    let a = n.substr(i), c = 0;
    for (; c < t.length; ) {
      let u = t.indexOf(r, c);
      if (u === -1)
        break;
      let d = t.substr(0, u);
      c = u + r.length;
      let h = t.substr(c);
      if (o === d && a === h)
        return {
          before: o,
          after: a
        };
    }
  }
  return null;
}
function oS(n, e) {
  let t = e.markerToArray(n.marker);
  return {
    marker: n.marker,
    timeZoneOffset: n.timeZoneOffset,
    array: t,
    year: t[0],
    month: t[1],
    day: t[2],
    hour: t[3],
    minute: t[4],
    second: t[5],
    millisecond: t[6]
  };
}
function Pd(n, e, t, r) {
  let i = oS(n, t.calendarSystem), s = e ? oS(e, t.calendarSystem) : null;
  return {
    date: i,
    start: i,
    end: s,
    timeZone: t.timeZone,
    localeCodes: t.locale.codes,
    defaultSeparator: r || t.defaultSeparator
  };
}
class Nj {
  constructor(e) {
    this.cmdStr = e;
  }
  format(e, t, r) {
    return t.cmdFormatter(this.cmdStr, Pd(e, null, t, r));
  }
  formatRange(e, t, r, i) {
    return r.cmdFormatter(this.cmdStr, Pd(e, t, r, i));
  }
}
class Pj {
  constructor(e) {
    this.func = e;
  }
  format(e, t, r) {
    return this.func(Pd(e, null, t, r));
  }
  formatRange(e, t, r, i) {
    return this.func(Pd(e, t, r, i));
  }
}
function $t(n) {
  return typeof n == "object" && n ? new Tj(n) : typeof n == "string" ? new Nj(n) : typeof n == "function" ? new Pj(n) : null;
}
const aS = {
  navLinkDayClick: $,
  navLinkWeekClick: $,
  duration: lt,
  bootstrapFontAwesome: $,
  buttonIcons: $,
  customButtons: $,
  defaultAllDayEventDuration: lt,
  defaultTimedEventDuration: lt,
  nextDayThreshold: lt,
  scrollTime: lt,
  scrollTimeReset: Boolean,
  slotMinTime: lt,
  slotMaxTime: lt,
  dayPopoverFormat: $t,
  slotDuration: lt,
  snapDuration: lt,
  headerToolbar: $,
  footerToolbar: $,
  defaultRangeSeparator: String,
  titleRangeSeparator: String,
  forceEventDuration: Boolean,
  dayHeaders: Boolean,
  dayHeaderFormat: $t,
  dayHeaderClassNames: $,
  dayHeaderContent: $,
  dayHeaderDidMount: $,
  dayHeaderWillUnmount: $,
  dayCellClassNames: $,
  dayCellContent: $,
  dayCellDidMount: $,
  dayCellWillUnmount: $,
  initialView: String,
  aspectRatio: Number,
  weekends: Boolean,
  weekNumberCalculation: $,
  weekNumbers: Boolean,
  weekNumberClassNames: $,
  weekNumberContent: $,
  weekNumberDidMount: $,
  weekNumberWillUnmount: $,
  editable: Boolean,
  viewClassNames: $,
  viewDidMount: $,
  viewWillUnmount: $,
  nowIndicator: Boolean,
  nowIndicatorSnap: $,
  nowIndicatorClassNames: $,
  nowIndicatorContent: $,
  nowIndicatorDidMount: $,
  nowIndicatorWillUnmount: $,
  showNonCurrentDates: Boolean,
  lazyFetching: Boolean,
  startParam: String,
  endParam: String,
  timeZoneParam: String,
  timeZone: String,
  locales: $,
  locale: $,
  themeSystem: String,
  dragRevertDuration: Number,
  dragScroll: Boolean,
  allDayMaintainDuration: Boolean,
  unselectAuto: Boolean,
  dropAccept: $,
  eventOrder: KB,
  eventOrderStrict: Boolean,
  handleWindowResize: Boolean,
  windowResizeDelay: Number,
  longPressDelay: Number,
  eventDragMinDistance: Number,
  expandRows: Boolean,
  height: $,
  contentHeight: $,
  direction: String,
  weekNumberFormat: $t,
  eventResizableFromStart: Boolean,
  displayEventTime: Boolean,
  displayEventEnd: Boolean,
  weekText: String,
  weekTextLong: String,
  progressiveEventRendering: Boolean,
  businessHours: $,
  initialDate: $,
  now: $,
  eventDataTransform: $,
  stickyHeaderDates: $,
  stickyFooterScrollbar: $,
  viewHeight: $,
  defaultAllDay: Boolean,
  eventSourceFailure: $,
  eventSourceSuccess: $,
  eventDisplay: String,
  eventStartEditable: Boolean,
  eventDurationEditable: Boolean,
  eventOverlap: $,
  eventConstraint: $,
  eventAllow: $,
  eventBackgroundColor: String,
  eventBorderColor: String,
  eventTextColor: String,
  eventColor: String,
  eventClassNames: $,
  eventContent: $,
  eventDidMount: $,
  eventWillUnmount: $,
  selectConstraint: $,
  selectOverlap: $,
  selectAllow: $,
  droppable: Boolean,
  unselectCancel: String,
  slotLabelFormat: $,
  slotLaneClassNames: $,
  slotLaneContent: $,
  slotLaneDidMount: $,
  slotLaneWillUnmount: $,
  slotLabelClassNames: $,
  slotLabelContent: $,
  slotLabelDidMount: $,
  slotLabelWillUnmount: $,
  dayMaxEvents: $,
  dayMaxEventRows: $,
  dayMinWidth: Number,
  slotLabelInterval: lt,
  allDayText: String,
  allDayClassNames: $,
  allDayContent: $,
  allDayDidMount: $,
  allDayWillUnmount: $,
  slotMinWidth: Number,
  navLinks: Boolean,
  eventTimeFormat: $t,
  rerenderDelay: Number,
  moreLinkText: $,
  moreLinkHint: $,
  selectMinDistance: Number,
  selectable: Boolean,
  selectLongPressDelay: Number,
  eventLongPressDelay: Number,
  selectMirror: Boolean,
  eventMaxStack: Number,
  eventMinHeight: Number,
  eventMinWidth: Number,
  eventShortHeight: Number,
  slotEventOverlap: Boolean,
  plugins: $,
  firstDay: Number,
  dayCount: Number,
  dateAlignment: String,
  dateIncrement: lt,
  hiddenDays: $,
  fixedWeekCount: Boolean,
  validRange: $,
  visibleRange: $,
  titleFormat: $,
  eventInteractive: Boolean,
  // only used by list-view, but languages define the value, so we need it in base options
  noEventsText: String,
  viewHint: $,
  navLinkHint: $,
  closeHint: String,
  timeHint: String,
  eventHint: String,
  moreLinkClick: $,
  moreLinkClassNames: $,
  moreLinkContent: $,
  moreLinkDidMount: $,
  moreLinkWillUnmount: $,
  monthStartFormat: $t,
  // for connectors
  // (can't be part of plugin system b/c must be provided at runtime)
  handleCustomRendering: $,
  customRenderingMetaMap: $,
  customRenderingReplaces: Boolean
}, ql = {
  eventDisplay: "auto",
  defaultRangeSeparator: " - ",
  titleRangeSeparator: " – ",
  defaultTimedEventDuration: "01:00:00",
  defaultAllDayEventDuration: { day: 1 },
  forceEventDuration: !1,
  nextDayThreshold: "00:00:00",
  dayHeaders: !0,
  initialView: "",
  aspectRatio: 1.35,
  headerToolbar: {
    start: "title",
    center: "",
    end: "today prev,next"
  },
  weekends: !0,
  weekNumbers: !1,
  weekNumberCalculation: "local",
  editable: !1,
  nowIndicator: !1,
  scrollTime: "06:00:00",
  scrollTimeReset: !0,
  slotMinTime: "00:00:00",
  slotMaxTime: "24:00:00",
  showNonCurrentDates: !0,
  lazyFetching: !0,
  startParam: "start",
  endParam: "end",
  timeZoneParam: "timeZone",
  timeZone: "local",
  locales: [],
  locale: "",
  themeSystem: "standard",
  dragRevertDuration: 500,
  dragScroll: !0,
  allDayMaintainDuration: !1,
  unselectAuto: !0,
  dropAccept: "*",
  eventOrder: "start,-duration,allDay,title",
  dayPopoverFormat: { month: "long", day: "numeric", year: "numeric" },
  handleWindowResize: !0,
  windowResizeDelay: 100,
  longPressDelay: 1e3,
  eventDragMinDistance: 5,
  expandRows: !1,
  navLinks: !1,
  selectable: !1,
  eventMinHeight: 15,
  eventMinWidth: 30,
  eventShortHeight: 30,
  monthStartFormat: { month: "long", day: "numeric" },
  nowIndicatorSnap: "auto"
}, lS = {
  datesSet: $,
  eventsSet: $,
  eventAdd: $,
  eventChange: $,
  eventRemove: $,
  windowResize: $,
  eventClick: $,
  eventMouseEnter: $,
  eventMouseLeave: $,
  select: $,
  unselect: $,
  loading: $,
  // internal
  _unmount: $,
  _beforeprint: $,
  _afterprint: $,
  _noEventDrop: $,
  _noEventResize: $,
  _resize: $,
  _scrollRequest: $
}, cS = {
  buttonText: $,
  buttonHints: $,
  views: $,
  plugins: $,
  initialEvents: $,
  events: $,
  eventSources: $
}, wo = {
  headerToolbar: Eo,
  footerToolbar: Eo,
  buttonText: Eo,
  buttonHints: Eo,
  buttonIcons: Eo,
  dateIncrement: Eo,
  plugins: ju,
  events: ju,
  eventSources: ju,
  resources: ju
};
function Eo(n, e) {
  return typeof n == "object" && typeof e == "object" && n && e ? pi(n, e) : n === e;
}
function ju(n, e) {
  return Array.isArray(n) && Array.isArray(e) ? Js(n, e) : n === e;
}
const Lj = {
  type: String,
  component: $,
  buttonText: String,
  buttonTextKey: String,
  dateProfileGeneratorClass: $,
  usesMinMaxTime: Boolean,
  classNames: $,
  content: $,
  didMount: $,
  willUnmount: $
};
function _p(n) {
  return Ty(n, wo);
}
function Ay(n, e) {
  let t = {}, r = {};
  for (let i in e)
    i in n && (t[i] = e[i](n[i]));
  for (let i in n)
    i in e || (r[i] = n[i]);
  return { refined: t, extra: r };
}
function $(n) {
  return n;
}
const { hasOwnProperty: Ld } = Object.prototype;
function Ty(n, e) {
  let t = {};
  if (e) {
    for (let r in e)
      if (e[r] === Eo) {
        let i = [];
        for (let s = n.length - 1; s >= 0; s -= 1) {
          let o = n[s][r];
          if (typeof o == "object" && o)
            i.unshift(o);
          else if (o !== void 0) {
            t[r] = o;
            break;
          }
        }
        i.length && (t[r] = Ty(i));
      }
  }
  for (let r = n.length - 1; r >= 0; r -= 1) {
    let i = n[r];
    for (let s in i)
      s in t || (t[s] = i[s]);
  }
  return t;
}
function qa(n, e) {
  let t = {};
  for (let r in n)
    e(n[r], r) && (t[r] = n[r]);
  return t;
}
function Ho(n, e) {
  let t = {};
  for (let r in n)
    t[r] = e(n[r], r);
  return t;
}
function Z1(n) {
  let e = {};
  for (let t of n)
    e[t] = !0;
  return e;
}
function Cy(n) {
  let e = [];
  for (let t in n)
    e.push(n[t]);
  return e;
}
function pi(n, e) {
  if (n === e)
    return !0;
  for (let t in n)
    if (Ld.call(n, t) && !(t in e))
      return !1;
  for (let t in e)
    if (Ld.call(e, t) && n[t] !== e[t])
      return !1;
  return !0;
}
const Bj = /^on[A-Z]/;
function jj(n, e) {
  const t = Fj(n, e);
  for (let r of t)
    if (!Bj.test(r))
      return !1;
  return !0;
}
function Fj(n, e) {
  let t = [];
  for (let r in n)
    Ld.call(n, r) && (r in e || t.push(r));
  for (let r in e)
    Ld.call(e, r) && n[r] !== e[r] && t.push(r);
  return t;
}
function Op(n, e, t = {}) {
  if (n === e)
    return !0;
  for (let r in e)
    if (!(r in n && zj(n[r], e[r], t[r]))) return !1;
  for (let r in n)
    if (!(r in e))
      return !1;
  return !0;
}
function zj(n, e, t) {
  return n === e || t === !0 ? !0 : t ? t(n, e) : !1;
}
function Vj(n, e = 0, t, r = 1) {
  let i = [];
  t == null && (t = Object.keys(n).length);
  for (let s = e; s < t; s += r) {
    let o = n[s];
    o !== void 0 && i.push(o);
  }
  return i;
}
let X1 = {};
function Hj(n, e) {
  X1[n] = e;
}
function Uj(n) {
  return new X1[n]();
}
class Wj {
  getMarkerYear(e) {
    return e.getUTCFullYear();
  }
  getMarkerMonth(e) {
    return e.getUTCMonth();
  }
  getMarkerDay(e) {
    return e.getUTCDate();
  }
  arrayToMarker(e) {
    return pr(e);
  }
  markerToArray(e) {
    return js(e);
  }
}
Hj("gregory", Wj);
const $j = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function Gj(n) {
  let e = $j.exec(n);
  if (e) {
    let t = new Date(Date.UTC(Number(e[1]), e[3] ? Number(e[3]) - 1 : 0, Number(e[5] || 1), Number(e[7] || 0), Number(e[8] || 0), Number(e[10] || 0), e[12] ? +`0.${e[12]}` * 1e3 : 0));
    if (J1(t)) {
      let r = null;
      return e[13] && (r = (e[15] === "-" ? -1 : 1) * (Number(e[16] || 0) * 60 + Number(e[18] || 0))), {
        marker: t,
        isTimeUnspecified: !e[6],
        timeZoneOffset: r
      };
    }
  }
  return null;
}
class Yj {
  constructor(e) {
    let t = this.timeZone = e.timeZone, r = t !== "local" && t !== "UTC";
    e.namedTimeZoneImpl && r && (this.namedTimeZoneImpl = new e.namedTimeZoneImpl(t)), this.canComputeOffset = !!(!r || this.namedTimeZoneImpl), this.calendarSystem = Uj(e.calendarSystem), this.locale = e.locale, this.weekDow = e.locale.week.dow, this.weekDoy = e.locale.week.doy, e.weekNumberCalculation === "ISO" && (this.weekDow = 1, this.weekDoy = 4), typeof e.firstDay == "number" && (this.weekDow = e.firstDay), typeof e.weekNumberCalculation == "function" && (this.weekNumberFunc = e.weekNumberCalculation), this.weekText = e.weekText != null ? e.weekText : e.locale.options.weekText, this.weekTextLong = (e.weekTextLong != null ? e.weekTextLong : e.locale.options.weekTextLong) || this.weekText, this.cmdFormatter = e.cmdFormatter, this.defaultSeparator = e.defaultSeparator;
  }
  // Creating / Parsing
  createMarker(e) {
    let t = this.createMarkerMeta(e);
    return t === null ? null : t.marker;
  }
  createNowMarker() {
    return this.canComputeOffset ? this.timestampToMarker((/* @__PURE__ */ new Date()).valueOf()) : pr(rS(/* @__PURE__ */ new Date()));
  }
  createMarkerMeta(e) {
    if (typeof e == "string")
      return this.parse(e);
    let t = null;
    return typeof e == "number" ? t = this.timestampToMarker(e) : e instanceof Date ? (e = e.valueOf(), isNaN(e) || (t = this.timestampToMarker(e))) : Array.isArray(e) && (t = pr(e)), t === null || !J1(t) ? null : { marker: t, isTimeUnspecified: !1, forcedTzo: null };
  }
  parse(e) {
    let t = Gj(e);
    if (t === null)
      return null;
    let { marker: r } = t, i = null;
    return t.timeZoneOffset !== null && (this.canComputeOffset ? r = this.timestampToMarker(r.valueOf() - t.timeZoneOffset * 60 * 1e3) : i = t.timeZoneOffset), { marker: r, isTimeUnspecified: t.isTimeUnspecified, forcedTzo: i };
  }
  // Accessors
  getYear(e) {
    return this.calendarSystem.getMarkerYear(e);
  }
  getMonth(e) {
    return this.calendarSystem.getMarkerMonth(e);
  }
  getDay(e) {
    return this.calendarSystem.getMarkerDay(e);
  }
  // Adding / Subtracting
  add(e, t) {
    let r = this.calendarSystem.markerToArray(e);
    return r[0] += t.years, r[1] += t.months, r[2] += t.days, r[6] += t.milliseconds, this.calendarSystem.arrayToMarker(r);
  }
  subtract(e, t) {
    let r = this.calendarSystem.markerToArray(e);
    return r[0] -= t.years, r[1] -= t.months, r[2] -= t.days, r[6] -= t.milliseconds, this.calendarSystem.arrayToMarker(r);
  }
  addYears(e, t) {
    let r = this.calendarSystem.markerToArray(e);
    return r[0] += t, this.calendarSystem.arrayToMarker(r);
  }
  addMonths(e, t) {
    let r = this.calendarSystem.markerToArray(e);
    return r[1] += t, this.calendarSystem.arrayToMarker(r);
  }
  // Diffing Whole Units
  diffWholeYears(e, t) {
    let { calendarSystem: r } = this;
    return Fs(e) === Fs(t) && r.getMarkerDay(e) === r.getMarkerDay(t) && r.getMarkerMonth(e) === r.getMarkerMonth(t) ? r.getMarkerYear(t) - r.getMarkerYear(e) : null;
  }
  diffWholeMonths(e, t) {
    let { calendarSystem: r } = this;
    return Fs(e) === Fs(t) && r.getMarkerDay(e) === r.getMarkerDay(t) ? r.getMarkerMonth(t) - r.getMarkerMonth(e) + (r.getMarkerYear(t) - r.getMarkerYear(e)) * 12 : null;
  }
  // Range / Duration
  greatestWholeUnit(e, t) {
    let r = this.diffWholeYears(e, t);
    return r !== null ? { unit: "year", value: r } : (r = this.diffWholeMonths(e, t), r !== null ? { unit: "month", value: r } : (r = hj(e, t), r !== null ? { unit: "week", value: r } : (r = Id(e, t), r !== null ? { unit: "day", value: r } : (r = cj(e, t), md(r) ? { unit: "hour", value: r } : (r = uj(e, t), md(r) ? { unit: "minute", value: r } : (r = dj(e, t), md(r) ? { unit: "second", value: r } : { unit: "millisecond", value: t.valueOf() - e.valueOf() }))))));
  }
  countDurationsBetween(e, t, r) {
    let i;
    return r.years && (i = this.diffWholeYears(e, t), i !== null) ? i / sj(r) : r.months && (i = this.diffWholeMonths(e, t), i !== null) ? i / oj(r) : r.days && (i = Id(e, t), i !== null) ? i / Va(r) : (t.valueOf() - e.valueOf()) / di(r);
  }
  // Start-Of
  // these DON'T return zoned-dates. only UTC start-of dates
  startOf(e, t) {
    return t === "year" ? this.startOfYear(e) : t === "month" ? this.startOfMonth(e) : t === "week" ? this.startOfWeek(e) : t === "day" ? Ot(e) : t === "hour" ? pj(e) : t === "minute" ? mj(e) : t === "second" ? gj(e) : null;
  }
  startOfYear(e) {
    return this.calendarSystem.arrayToMarker([
      this.calendarSystem.getMarkerYear(e)
    ]);
  }
  startOfMonth(e) {
    return this.calendarSystem.arrayToMarker([
      this.calendarSystem.getMarkerYear(e),
      this.calendarSystem.getMarkerMonth(e)
    ]);
  }
  startOfWeek(e) {
    return this.calendarSystem.arrayToMarker([
      this.calendarSystem.getMarkerYear(e),
      this.calendarSystem.getMarkerMonth(e),
      e.getUTCDate() - (e.getUTCDay() - this.weekDow + 7) % 7
    ]);
  }
  // Week Number
  computeWeekNumber(e) {
    return this.weekNumberFunc ? this.weekNumberFunc(this.toDate(e)) : yj(e, this.weekDow, this.weekDoy);
  }
  // TODO: choke on timeZoneName: long
  format(e, t, r = {}) {
    return t.format({
      marker: e,
      timeZoneOffset: r.forcedTzo != null ? r.forcedTzo : this.offsetForMarker(e)
    }, this);
  }
  formatRange(e, t, r, i = {}) {
    return i.isEndExclusive && (t = Qs(t, -1)), r.formatRange({
      marker: e,
      timeZoneOffset: i.forcedStartTzo != null ? i.forcedStartTzo : this.offsetForMarker(e)
    }, {
      marker: t,
      timeZoneOffset: i.forcedEndTzo != null ? i.forcedEndTzo : this.offsetForMarker(t)
    }, this, i.defaultSeparator);
  }
  /*
  DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
  might as well use buildIsoString or some other util directly
  */
  formatIso(e, t = {}) {
    let r = null;
    return t.omitTimeZoneOffset || (t.forcedTzo != null ? r = t.forcedTzo : r = this.offsetForMarker(e)), Q1(e, r, t.omitTime);
  }
  // TimeZone
  timestampToMarker(e) {
    return this.timeZone === "local" ? pr(rS(new Date(e))) : this.timeZone === "UTC" || !this.namedTimeZoneImpl ? new Date(e) : pr(this.namedTimeZoneImpl.timestampToArray(e));
  }
  offsetForMarker(e) {
    return this.timeZone === "local" ? -iS(js(e)).getTimezoneOffset() : this.timeZone === "UTC" ? 0 : this.namedTimeZoneImpl ? this.namedTimeZoneImpl.offsetForArray(js(e)) : null;
  }
  // Conversion
  toDate(e, t) {
    return this.timeZone === "local" ? iS(js(e)) : this.timeZone === "UTC" ? new Date(e.valueOf()) : this.namedTimeZoneImpl ? new Date(e.valueOf() - this.namedTimeZoneImpl.offsetForArray(js(e)) * 1e3 * 60) : new Date(e.valueOf() - (t || 0));
  }
}
class Fc {
  constructor(e) {
    this.iconOverrideOption && this.setIconOverride(e[this.iconOverrideOption]);
  }
  setIconOverride(e) {
    let t, r;
    if (typeof e == "object" && e) {
      t = Object.assign({}, this.iconClasses);
      for (r in e)
        t[r] = this.applyIconOverridePrefix(e[r]);
      this.iconClasses = t;
    } else e === !1 && (this.iconClasses = {});
  }
  applyIconOverridePrefix(e) {
    let t = this.iconOverridePrefix;
    return t && e.indexOf(t) !== 0 && (e = t + e), e;
  }
  getClass(e) {
    return this.classes[e] || "";
  }
  getIconClass(e, t) {
    let r;
    return t && this.rtlIconClasses ? r = this.rtlIconClasses[e] || this.iconClasses[e] : r = this.iconClasses[e], r ? `${this.baseIconClass} ${r}` : "";
  }
  getCustomButtonIconClass(e) {
    let t;
    return this.iconOverrideCustomButtonOption && (t = e[this.iconOverrideCustomButtonOption], t) ? `${this.baseIconClass} ${this.applyIconOverridePrefix(t)}` : "";
  }
}
Fc.prototype.classes = {};
Fc.prototype.iconClasses = {};
Fc.prototype.baseIconClass = "";
Fc.prototype.iconOverridePrefix = "";
function Bd(n) {
  n();
  let e = _e.debounceRendering, t = [];
  function r(i) {
    t.push(i);
  }
  for (_e.debounceRendering = r, pc(I(qj, {}), document.createElement("div")); t.length; )
    t.shift()();
  _e.debounceRendering = e;
}
class qj extends Rr {
  render() {
    return I("div", {});
  }
  componentDidMount() {
    this.setState({});
  }
}
function eT(n) {
  let e = SB(n), t = e.Provider;
  return e.Provider = function() {
    let r = !this.getChildContext, i = t.apply(this, arguments);
    if (r) {
      let s = [];
      this.shouldComponentUpdate = (o) => {
        this.props.value !== o.value && s.forEach((a) => {
          a.context = o.value, a.forceUpdate();
        });
      }, this.sub = (o) => {
        s.push(o);
        let a = o.componentWillUnmount;
        o.componentWillUnmount = () => {
          s.splice(s.indexOf(o), 1), a && a.call(o);
        };
      };
    }
    return i;
  }, e;
}
class Kj {
  constructor(e, t, r, i) {
    this.execFunc = e, this.emitter = t, this.scrollTime = r, this.scrollTimeReset = i, this.handleScrollRequest = (s) => {
      this.queuedRequest = Object.assign({}, this.queuedRequest || {}, s), this.drain();
    }, t.on("_scrollRequest", this.handleScrollRequest), this.fireInitialScroll();
  }
  detach() {
    this.emitter.off("_scrollRequest", this.handleScrollRequest);
  }
  update(e) {
    e && this.scrollTimeReset ? this.fireInitialScroll() : this.drain();
  }
  fireInitialScroll() {
    this.handleScrollRequest({
      time: this.scrollTime
    });
  }
  drain() {
    this.queuedRequest && this.execFunc(this.queuedRequest) && (this.queuedRequest = null);
  }
}
const ms = eT({});
function Jj(n, e, t, r, i, s, o, a, c, u, d, h, p, g) {
  return {
    dateEnv: i,
    nowManager: s,
    options: t,
    pluginHooks: a,
    emitter: d,
    dispatch: c,
    getCurrentData: u,
    calendarApi: h,
    viewSpec: n,
    viewApi: e,
    dateProfileGenerator: r,
    theme: o,
    isRtl: t.direction === "rtl",
    addResizeHandler(y) {
      d.on("_resize", y);
    },
    removeResizeHandler(y) {
      d.off("_resize", y);
    },
    createScrollResponder(y) {
      return new Kj(y, d, lt(t.scrollTime), t.scrollTimeReset);
    },
    registerInteractiveComponent: p,
    unregisterInteractiveComponent: g
  };
}
class Zo extends Rr {
  // debug: boolean
  shouldComponentUpdate(e, t) {
    return !Op(
      this.props,
      e,
      this.propEquality
      /*, this.debug */
    ) || !Op(
      this.state,
      t,
      this.stateEquality
      /*, this.debug */
    );
  }
  // HACK for freakin' React StrictMode
  safeSetState(e) {
    Op(this.state, Object.assign(Object.assign({}, this.state), e), this.stateEquality) || this.setState(e);
  }
}
Zo.addPropsEquality = Qj;
Zo.addStateEquality = Zj;
Zo.contextType = ms;
Zo.prototype.propEquality = {};
Zo.prototype.stateEquality = {};
class gt extends Zo {
}
gt.contextType = ms;
function Qj(n) {
  let e = Object.create(this.prototype.propEquality);
  Object.assign(e, n), this.prototype.propEquality = e;
}
function Zj(n) {
  let e = Object.create(this.prototype.stateEquality);
  Object.assign(e, n), this.prototype.stateEquality = e;
}
function _i(n, e) {
  typeof n == "function" ? n(e) : n && (n.current = e);
}
class Dy extends gt {
  constructor() {
    super(...arguments), this.id = Jo(), this.queuedDomNodes = [], this.currentDomNodes = [], this.handleEl = (e) => {
      const { options: t } = this.context, { generatorName: r } = this.props;
      (!t.customRenderingReplaces || !Xm(r, t)) && this.updateElRef(e);
    }, this.updateElRef = (e) => {
      this.props.elRef && _i(this.props.elRef, e);
    };
  }
  render() {
    const { props: e, context: t } = this, { options: r } = t, { customGenerator: i, defaultGenerator: s, renderProps: o } = e, a = tT(e, [], this.handleEl);
    let c = !1, u, d = [], h;
    if (i != null) {
      const p = typeof i == "function" ? i(o, I) : i;
      if (p === !0)
        c = !0;
      else {
        const g = p && typeof p == "object";
        g && "html" in p ? a.dangerouslySetInnerHTML = { __html: p.html } : g && "domNodes" in p ? d = Array.prototype.slice.call(p.domNodes) : (g ? C1(p) : typeof p != "function") ? u = p : h = p;
      }
    } else
      c = !Xm(e.generatorName, r);
    return c && s && (u = s(o)), this.queuedDomNodes = d, this.currentGeneratorMeta = h, I(e.elTag, a, u);
  }
  componentDidMount() {
    this.applyQueueudDomNodes(), this.triggerCustomRendering(!0);
  }
  componentDidUpdate() {
    this.applyQueueudDomNodes(), this.triggerCustomRendering(!0);
  }
  componentWillUnmount() {
    this.triggerCustomRendering(!1);
  }
  triggerCustomRendering(e) {
    var t;
    const { props: r, context: i } = this, { handleCustomRendering: s, customRenderingMetaMap: o } = i.options;
    if (s) {
      const a = (t = this.currentGeneratorMeta) !== null && t !== void 0 ? t : o == null ? void 0 : o[r.generatorName];
      a && s(Object.assign(Object.assign({
        id: this.id,
        isActive: e,
        containerEl: this.base,
        reportNewContainerEl: this.updateElRef,
        // front-end framework tells us about new container els
        generatorMeta: a
      }, r), { elClasses: (r.elClasses || []).filter(Xj) }));
    }
  }
  applyQueueudDomNodes() {
    const { queuedDomNodes: e, currentDomNodes: t } = this, r = this.base;
    if (!Js(e, t)) {
      t.forEach(VB);
      for (let i of e)
        r.appendChild(i);
      this.currentDomNodes = e;
    }
  }
}
Dy.addPropsEquality({
  elClasses: Js,
  elStyle: pi,
  elAttrs: jj,
  renderProps: pi
});
function Xm(n, e) {
  var t;
  return !!(e.handleCustomRendering && n && (!((t = e.customRenderingMetaMap) === null || t === void 0) && t[n]));
}
function tT(n, e, t) {
  const r = Object.assign(Object.assign({}, n.elAttrs), { ref: t });
  return (n.elClasses || e) && (r.className = (n.elClasses || []).concat(e || []).concat(r.className || []).filter(Boolean).join(" ")), n.elStyle && (r.style = n.elStyle), r;
}
function Xj(n) {
  return !!n;
}
const nT = eT(0);
class Mr extends Rr {
  constructor() {
    super(...arguments), this.InnerContent = eF.bind(void 0, this), this.handleEl = (e) => {
      this.el = e, this.props.elRef && (_i(this.props.elRef, e), e && this.didMountMisfire && this.componentDidMount());
    };
  }
  render() {
    const { props: e } = this, t = tF(e.classNameGenerator, e.renderProps);
    if (e.children) {
      const r = tT(e, t, this.handleEl), i = e.children(this.InnerContent, e.renderProps, r);
      return e.elTag ? I(e.elTag, r, i) : i;
    } else
      return I(Dy, Object.assign(Object.assign({}, e), { elRef: this.handleEl, elTag: e.elTag || "div", elClasses: (e.elClasses || []).concat(t), renderId: this.context }));
  }
  componentDidMount() {
    var e, t;
    this.el ? (t = (e = this.props).didMount) === null || t === void 0 || t.call(e, Object.assign(Object.assign({}, this.props.renderProps), { el: this.el })) : this.didMountMisfire = !0;
  }
  componentWillUnmount() {
    var e, t;
    (t = (e = this.props).willUnmount) === null || t === void 0 || t.call(e, Object.assign(Object.assign({}, this.props.renderProps), { el: this.el }));
  }
}
Mr.contextType = nT;
function eF(n, e) {
  const t = n.props;
  return I(Dy, Object.assign({ renderProps: t.renderProps, generatorName: t.generatorName, customGenerator: t.customGenerator, defaultGenerator: t.defaultGenerator, renderId: n.context }, e));
}
function tF(n, e) {
  const t = typeof n == "function" ? n(e) : n || [];
  return typeof t == "string" ? [t] : t;
}
class jd extends gt {
  render() {
    let { props: e, context: t } = this, { options: r } = t, i = { view: t.viewApi };
    return I(Mr, { elRef: e.elRef, elTag: e.elTag || "div", elAttrs: e.elAttrs, elClasses: [
      ...rT(e.viewSpec),
      ...e.elClasses || []
    ], elStyle: e.elStyle, renderProps: i, classNameGenerator: r.viewClassNames, generatorName: void 0, didMount: r.viewDidMount, willUnmount: r.viewWillUnmount }, () => e.children);
  }
}
function rT(n) {
  return [
    `fc-${n.type}-view`,
    "fc-view"
  ];
}
function nF(n, e) {
  let t = null, r = null;
  return n.start && (t = e.createMarker(n.start)), n.end && (r = e.createMarker(n.end)), !t && !r || t && r && r < t ? null : { start: t, end: r };
}
function uS(n, e) {
  let t = [], { start: r } = e, i, s;
  for (n.sort(rF), i = 0; i < n.length; i += 1)
    s = n[i], s.start > r && t.push({ start: r, end: s.start }), s.end > r && (r = s.end);
  return r < e.end && t.push({ start: r, end: e.end }), t;
}
function rF(n, e) {
  return n.start.valueOf() - e.start.valueOf();
}
function Uo(n, e) {
  let { start: t, end: r } = n, i = null;
  return e.start !== null && (t === null ? t = e.start : t = new Date(Math.max(t.valueOf(), e.start.valueOf()))), e.end != null && (r === null ? r = e.end : r = new Date(Math.min(r.valueOf(), e.end.valueOf()))), (t === null || r === null || t < r) && (i = { start: t, end: r }), i;
}
function iF(n, e) {
  return (n.end === null || e.start === null || n.end > e.start) && (n.start === null || e.end === null || n.start < e.end);
}
function ns(n, e) {
  return (n.start === null || e >= n.start) && (n.end === null || e < n.end);
}
function sF(n, e) {
  return e.start != null && n < e.start ? e.start : e.end != null && n >= e.end ? new Date(e.end.valueOf() - 1) : n;
}
function iT(n) {
  let e = Math.floor(Qo(n.start, n.end)) || 1, t = Ot(n.start), r = bn(t, e);
  return { start: t, end: r };
}
function sT(n, e = lt(0)) {
  let t = null, r = null;
  if (n.end) {
    r = Ot(n.end);
    let i = n.end.valueOf() - r.valueOf();
    i && i >= di(e) && (r = bn(r, 1));
  }
  return n.start && (t = Ot(n.start), r && r <= t && (r = bn(t, 1))), { start: t, end: r };
}
function Fu(n, e, t, r) {
  return r === "year" ? lt(t.diffWholeYears(n, e), "year") : r === "month" ? lt(t.diffWholeMonths(n, e), "month") : fj(n, e);
}
class oT {
  constructor(e) {
    this.props = e, this.initHiddenDays();
  }
  /* Date Range Computation
  ------------------------------------------------------------------------------------------------------------------*/
  // Builds a structure with info about what the dates/ranges will be for the "prev" view.
  buildPrev(e, t, r) {
    let { dateEnv: i } = this.props, s = i.subtract(
      i.startOf(t, e.currentRangeUnit),
      // important for start-of-month
      e.dateIncrement
    );
    return this.build(s, -1, r);
  }
  // Builds a structure with info about what the dates/ranges will be for the "next" view.
  buildNext(e, t, r) {
    let { dateEnv: i } = this.props, s = i.add(
      i.startOf(t, e.currentRangeUnit),
      // important for start-of-month
      e.dateIncrement
    );
    return this.build(s, 1, r);
  }
  // Builds a structure holding dates/ranges for rendering around the given date.
  // Optional direction param indicates whether the date is being incremented/decremented
  // from its previous value. decremented = -1, incremented = 1 (default).
  build(e, t, r = !0) {
    let { props: i } = this, s, o, a, c, u, d;
    return s = this.buildValidRange(), s = this.trimHiddenDays(s), r && (e = sF(e, s)), o = this.buildCurrentRangeInfo(e, t), a = /^(year|month|week|day)$/.test(o.unit), c = this.buildRenderRange(this.trimHiddenDays(o.range), o.unit, a), c = this.trimHiddenDays(c), u = c, i.showNonCurrentDates || (u = Uo(u, o.range)), u = this.adjustActiveRange(u), u = Uo(u, s), d = iF(o.range, s), ns(c, e) || (e = c.start), {
      currentDate: e,
      // constraint for where prev/next operations can go and where events can be dragged/resized to.
      // an object with optional start and end properties.
      validRange: s,
      // range the view is formally responsible for.
      // for example, a month view might have 1st-31st, excluding padded dates
      currentRange: o.range,
      // name of largest unit being displayed, like "month" or "week"
      currentRangeUnit: o.unit,
      isRangeAllDay: a,
      // dates that display events and accept drag-n-drop
      // will be `null` if no dates accept events
      activeRange: u,
      // date range with a rendered skeleton
      // includes not-active days that need some sort of DOM
      renderRange: c,
      // Duration object that denotes the first visible time of any given day
      slotMinTime: i.slotMinTime,
      // Duration object that denotes the exclusive visible end time of any given day
      slotMaxTime: i.slotMaxTime,
      isValid: d,
      // how far the current date will move for a prev/next operation
      dateIncrement: this.buildDateIncrement(o.duration)
      // pass a fallback (might be null) ^
    };
  }
  // Builds an object with optional start/end properties.
  // Indicates the minimum/maximum dates to display.
  // not responsible for trimming hidden days.
  buildValidRange() {
    let e = this.props.validRangeInput, t = typeof e == "function" ? e.call(this.props.calendarApi, this.props.dateEnv.toDate(this.props.nowManager.getDateMarker())) : e;
    return this.refineRange(t) || { start: null, end: null };
  }
  // Builds a structure with info about the "current" range, the range that is
  // highlighted as being the current month for example.
  // See build() for a description of `direction`.
  // Guaranteed to have `range` and `unit` properties. `duration` is optional.
  buildCurrentRangeInfo(e, t) {
    let { props: r } = this, i = null, s = null, o = null, a;
    return r.duration ? (i = r.duration, s = r.durationUnit, o = this.buildRangeFromDuration(e, t, i, s)) : (a = this.props.dayCount) ? (s = "day", o = this.buildRangeFromDayCount(e, t, a)) : (o = this.buildCustomVisibleRange(e)) ? s = r.dateEnv.greatestWholeUnit(o.start, o.end).unit : (i = this.getFallbackDuration(), s = Zm(i).unit, o = this.buildRangeFromDuration(e, t, i, s)), { duration: i, unit: s, range: o };
  }
  getFallbackDuration() {
    return lt({ day: 1 });
  }
  // Returns a new activeRange to have time values (un-ambiguate)
  // slotMinTime or slotMaxTime causes the range to expand.
  adjustActiveRange(e) {
    let { dateEnv: t, usesMinMaxTime: r, slotMinTime: i, slotMaxTime: s } = this.props, { start: o, end: a } = e;
    return r && (Va(i) < 0 && (o = Ot(o), o = t.add(o, i)), Va(s) > 1 && (a = Ot(a), a = bn(a, -1), a = t.add(a, s))), { start: o, end: a };
  }
  // Builds the "current" range when it is specified as an explicit duration.
  // `unit` is the already-computed greatestDurationDenominator unit of duration.
  buildRangeFromDuration(e, t, r, i) {
    let { dateEnv: s, dateAlignment: o } = this.props, a, c, u;
    if (!o) {
      let { dateIncrement: h } = this.props;
      h && di(h) < di(r) ? o = Zm(h).unit : o = i;
    }
    Va(r) <= 1 && this.isHiddenDay(a) && (a = this.skipHiddenDays(a, t), a = Ot(a));
    function d() {
      a = s.startOf(e, o), c = s.add(a, r), u = { start: a, end: c };
    }
    return d(), this.trimHiddenDays(u) || (e = this.skipHiddenDays(e, t), d()), u;
  }
  // Builds the "current" range when a dayCount is specified.
  buildRangeFromDayCount(e, t, r) {
    let { dateEnv: i, dateAlignment: s } = this.props, o = 0, a = e, c;
    s && (a = i.startOf(a, s)), a = Ot(a), a = this.skipHiddenDays(a, t), c = a;
    do
      c = bn(c, 1), this.isHiddenDay(c) || (o += 1);
    while (o < r);
    return { start: a, end: c };
  }
  // Builds a normalized range object for the "visible" range,
  // which is a way to define the currentRange and activeRange at the same time.
  buildCustomVisibleRange(e) {
    let { props: t } = this, r = t.visibleRangeInput, i = typeof r == "function" ? r.call(t.calendarApi, t.dateEnv.toDate(e)) : r, s = this.refineRange(i);
    return s && (s.start == null || s.end == null) ? null : s;
  }
  // Computes the range that will represent the element/cells for *rendering*,
  // but which may have voided days/times.
  // not responsible for trimming hidden days.
  buildRenderRange(e, t, r) {
    return e;
  }
  // Compute the duration value that should be added/substracted to the current date
  // when a prev/next operation happens.
  buildDateIncrement(e) {
    let { dateIncrement: t } = this.props, r;
    return t || ((r = this.props.dateAlignment) ? lt(1, r) : e || lt({ days: 1 }));
  }
  refineRange(e) {
    if (e) {
      let t = nF(e, this.props.dateEnv);
      return t && (t = sT(t)), t;
    }
    return null;
  }
  /* Hidden Days
  ------------------------------------------------------------------------------------------------------------------*/
  // Initializes internal variables related to calculating hidden days-of-week
  initHiddenDays() {
    let e = this.props.hiddenDays || [], t = [], r = 0, i;
    for (this.props.weekends === !1 && e.push(0, 6), i = 0; i < 7; i += 1)
      (t[i] = e.indexOf(i) !== -1) || (r += 1);
    if (!r)
      throw new Error("invalid hiddenDays");
    this.isHiddenDayHash = t;
  }
  // Remove days from the beginning and end of the range that are computed as hidden.
  // If the whole range is trimmed off, returns null
  trimHiddenDays(e) {
    let { start: t, end: r } = e;
    return t && (t = this.skipHiddenDays(t)), r && (r = this.skipHiddenDays(r, -1, !0)), t == null || r == null || t < r ? { start: t, end: r } : null;
  }
  // Is the current day hidden?
  // `day` is a day-of-week index (0-6), or a Date (used for UTC)
  isHiddenDay(e) {
    return e instanceof Date && (e = e.getUTCDay()), this.isHiddenDayHash[e];
  }
  // Incrementing the current day until it is no longer a hidden day, returning a copy.
  // DOES NOT CONSIDER validRange!
  // If the initial value of `date` is not a hidden day, don't do anything.
  // Pass `isExclusive` as `true` if you are dealing with an end date.
  // `inc` defaults to `1` (increment one day forward each time)
  skipHiddenDays(e, t = 1, r = !1) {
    for (; this.isHiddenDayHash[(e.getUTCDay() + (r ? t : 0) + 7) % 7]; )
      e = bn(e, t);
    return e;
  }
}
function Ry(n, e, t, r) {
  return {
    instanceId: Jo(),
    defId: n,
    range: e,
    forcedStartTzo: t ?? null,
    forcedEndTzo: r ?? null
  };
}
function oF(n, e, t, r) {
  for (let i = 0; i < r.length; i += 1) {
    let s = r[i].parse(n, t);
    if (s) {
      let { allDay: o } = n;
      return o == null && (o = e, o == null && (o = s.allDayGuess, o == null && (o = !1))), {
        allDay: o,
        duration: s.duration,
        typeData: s.typeData,
        typeId: i
      };
    }
  }
  return null;
}
function zc(n, e, t) {
  let { dateEnv: r, pluginHooks: i, options: s } = t, { defs: o, instances: a } = n;
  a = qa(a, (c) => !o[c.defId].recurringDef);
  for (let c in o) {
    let u = o[c];
    if (u.recurringDef) {
      let { duration: d } = u.recurringDef;
      d || (d = u.allDay ? s.defaultAllDayEventDuration : s.defaultTimedEventDuration);
      let h = aF(u, d, e, r, i.recurringTypes);
      for (let p of h) {
        let g = Ry(c, {
          start: p,
          end: r.add(p, d)
        });
        a[g.instanceId] = g;
      }
    }
  }
  return { defs: o, instances: a };
}
function aF(n, e, t, r, i) {
  let o = i[n.recurringDef.typeId].expand(n.recurringDef.typeData, {
    start: r.subtract(t.start, e),
    end: t.end
  }, r);
  return n.allDay && (o = o.map(Ot)), o;
}
const yd = {
  id: String,
  groupId: String,
  title: String,
  url: String,
  interactive: Boolean
}, aT = {
  start: $,
  end: $,
  date: $,
  allDay: Boolean
}, lF = Object.assign(Object.assign(Object.assign({}, yd), aT), { extendedProps: $ });
function lT(n, e, t, r, i = ky(t), s, o) {
  let { refined: a, extra: c } = cT(n, t, i), u = uF(e, t), d = oF(a, u, t.dateEnv, t.pluginHooks.recurringTypes);
  if (d) {
    let p = eg(a, c, e ? e.sourceId : "", d.allDay, !!d.duration, t, s);
    return p.recurringDef = {
      typeId: d.typeId,
      typeData: d.typeData,
      duration: d.duration
    }, { def: p, instance: null };
  }
  let h = cF(a, u, t, r);
  if (h) {
    let p = eg(a, c, e ? e.sourceId : "", h.allDay, h.hasEnd, t, s), g = Ry(p.defId, h.range, h.forcedStartTzo, h.forcedEndTzo);
    return o && p.publicId && o[p.publicId] && (g.instanceId = o[p.publicId]), { def: p, instance: g };
  }
  return null;
}
function cT(n, e, t = ky(e)) {
  return Ay(n, t);
}
function ky(n) {
  return Object.assign(Object.assign(Object.assign({}, Fd), lF), n.pluginHooks.eventRefiners);
}
function eg(n, e, t, r, i, s, o) {
  let a = {
    title: n.title || "",
    groupId: n.groupId || "",
    publicId: n.id || "",
    url: n.url || "",
    recurringDef: null,
    defId: (o && n.id ? o[n.id] : "") || Jo(),
    sourceId: t,
    allDay: r,
    hasEnd: i,
    interactive: n.interactive,
    ui: zd(n, s),
    extendedProps: Object.assign(Object.assign({}, n.extendedProps || {}), e)
  };
  for (let c of s.pluginHooks.eventDefMemberAdders)
    Object.assign(a, c(n));
  return Object.freeze(a.ui.classNames), Object.freeze(a.extendedProps), a;
}
function cF(n, e, t, r) {
  let { allDay: i } = n, s, o = null, a = !1, c, u = null, d = n.start != null ? n.start : n.date;
  if (s = t.dateEnv.createMarkerMeta(d), s)
    o = s.marker;
  else if (!r)
    return null;
  return n.end != null && (c = t.dateEnv.createMarkerMeta(n.end)), i == null && (e != null ? i = e : i = (!s || s.isTimeUnspecified) && (!c || c.isTimeUnspecified)), i && o && (o = Ot(o)), c && (u = c.marker, i && (u = Ot(u)), o && u <= o && (u = null)), u ? a = !0 : r || (a = t.options.forceEventDuration || !1, u = t.dateEnv.add(o, i ? t.options.defaultAllDayEventDuration : t.options.defaultTimedEventDuration)), {
    allDay: i,
    hasEnd: a,
    range: { start: o, end: u },
    forcedStartTzo: s ? s.forcedTzo : null,
    forcedEndTzo: c ? c.forcedTzo : null
  };
}
function uF(n, e) {
  let t = null;
  return n && (t = n.defaultAllDay), t == null && (t = e.options.defaultAllDay), t;
}
function mc(n, e, t, r, i, s) {
  let o = as(), a = ky(t);
  for (let c of n) {
    let u = lT(c, e, t, r, a, i, s);
    u && tg(u, o);
  }
  return o;
}
function tg(n, e = as()) {
  return e.defs[n.def.defId] = n.def, n.instance && (e.instances[n.instance.instanceId] = n.instance), e;
}
function dF(n, e) {
  let t = n.instances[e];
  if (t) {
    let r = n.defs[t.defId], i = _y(n, (s) => fF(r, s));
    return i.defs[r.defId] = r, i.instances[t.instanceId] = t, i;
  }
  return as();
}
function fF(n, e) {
  return !!(n.groupId && n.groupId === e.groupId);
}
function as() {
  return { defs: {}, instances: {} };
}
function My(n, e) {
  return {
    defs: Object.assign(Object.assign({}, n.defs), e.defs),
    instances: Object.assign(Object.assign({}, n.instances), e.instances)
  };
}
function _y(n, e) {
  let t = qa(n.defs, e), r = qa(n.instances, (i) => t[i.defId]);
  return { defs: t, instances: r };
}
function hF(n, e) {
  let { defs: t, instances: r } = n, i = {}, s = {};
  for (let o in t)
    e.defs[o] || (i[o] = t[o]);
  for (let o in r)
    !e.instances[o] && // not explicitly excluded
    i[r[o].defId] && (s[o] = r[o]);
  return {
    defs: i,
    instances: s
  };
}
function pF(n, e) {
  return Array.isArray(n) ? mc(n, null, e, !0) : typeof n == "object" && n ? mc([n], null, e, !0) : n != null ? String(n) : null;
}
function dS(n) {
  return Array.isArray(n) ? n : typeof n == "string" ? n.split(/\s+/) : [];
}
const Fd = {
  display: String,
  editable: Boolean,
  startEditable: Boolean,
  durationEditable: Boolean,
  constraint: $,
  overlap: $,
  allow: $,
  className: dS,
  classNames: dS,
  color: String,
  backgroundColor: String,
  borderColor: String,
  textColor: String
}, mF = {
  display: null,
  startEditable: null,
  durationEditable: null,
  constraints: [],
  overlap: null,
  allows: [],
  backgroundColor: "",
  borderColor: "",
  textColor: "",
  classNames: []
};
function zd(n, e) {
  let t = pF(n.constraint, e);
  return {
    display: n.display || null,
    startEditable: n.startEditable != null ? n.startEditable : n.editable,
    durationEditable: n.durationEditable != null ? n.durationEditable : n.editable,
    constraints: t != null ? [t] : [],
    overlap: n.overlap != null ? n.overlap : null,
    allows: n.allow != null ? [n.allow] : [],
    backgroundColor: n.backgroundColor || n.color || "",
    borderColor: n.borderColor || n.color || "",
    textColor: n.textColor || "",
    classNames: (n.className || []).concat(n.classNames || [])
    // join singular and plural
  };
}
function uT(n) {
  return n.reduce(gF, mF);
}
function gF(n, e) {
  return {
    display: e.display != null ? e.display : n.display,
    startEditable: e.startEditable != null ? e.startEditable : n.startEditable,
    durationEditable: e.durationEditable != null ? e.durationEditable : n.durationEditable,
    constraints: n.constraints.concat(e.constraints),
    overlap: typeof e.overlap == "boolean" ? e.overlap : n.overlap,
    allows: n.allows.concat(e.allows),
    backgroundColor: e.backgroundColor || n.backgroundColor,
    borderColor: e.borderColor || n.borderColor,
    textColor: e.textColor || n.textColor,
    classNames: n.classNames.concat(e.classNames)
  };
}
const yF = {
  id: String,
  defaultAllDay: Boolean,
  url: String,
  format: String,
  events: $,
  eventDataTransform: $,
  // for any network-related sources
  success: $,
  failure: $
};
function dT(n, e, t = fT(e)) {
  let r;
  if (typeof n == "string" ? r = { url: n } : typeof n == "function" || Array.isArray(n) ? r = { events: n } : typeof n == "object" && n && (r = n), r) {
    let { refined: i, extra: s } = Ay(r, t), o = vF(i, e);
    if (o)
      return {
        _raw: n,
        isFetching: !1,
        latestFetchId: "",
        fetchRange: null,
        defaultAllDay: i.defaultAllDay,
        eventDataTransform: i.eventDataTransform,
        success: i.success,
        failure: i.failure,
        publicId: i.id || "",
        sourceId: Jo(),
        sourceDefId: o.sourceDefId,
        meta: o.meta,
        ui: zd(i, e),
        extendedProps: s
      };
  }
  return null;
}
function fT(n) {
  return Object.assign(Object.assign(Object.assign({}, Fd), yF), n.pluginHooks.eventSourceRefiners);
}
function vF(n, e) {
  let t = e.pluginHooks.eventSourceDefs;
  for (let r = t.length - 1; r >= 0; r -= 1) {
    let s = t[r].parseMeta(n);
    if (s)
      return { sourceDefId: r, meta: s };
  }
  return null;
}
function bF(n, e, t, r, i) {
  switch (e.type) {
    case "RECEIVE_EVENTS":
      return xF(n, t[e.sourceId], e.fetchId, e.fetchRange, e.rawEvents, i);
    case "RESET_RAW_EVENTS":
      return SF(n, t[e.sourceId], e.rawEvents, r.activeRange, i);
    case "ADD_EVENTS":
      return wF(
        n,
        e.eventStore,
        // new ones
        r ? r.activeRange : null,
        i
      );
    case "RESET_EVENTS":
      return e.eventStore;
    case "MERGE_EVENTS":
      return My(n, e.eventStore);
    case "PREV":
    case "NEXT":
    case "CHANGE_DATE":
    case "CHANGE_VIEW_TYPE":
      return r ? zc(n, r.activeRange, i) : n;
    case "REMOVE_EVENTS":
      return hF(n, e.eventStore);
    case "REMOVE_EVENT_SOURCE":
      return pT(n, e.sourceId);
    case "REMOVE_ALL_EVENT_SOURCES":
      return _y(n, (s) => !s.sourceId);
    case "REMOVE_ALL_EVENTS":
      return as();
    default:
      return n;
  }
}
function xF(n, e, t, r, i, s) {
  if (e && // not already removed
  t === e.latestFetchId) {
    let o = mc(hT(i, e, s), e, s);
    return r && (o = zc(o, r, s)), My(pT(n, e.sourceId), o);
  }
  return n;
}
function SF(n, e, t, r, i) {
  const { defIdMap: s, instanceIdMap: o } = EF(n);
  let a = mc(hT(t, e, i), e, i, !1, s, o);
  return zc(a, r, i);
}
function hT(n, e, t) {
  let r = t.options.eventDataTransform, i = e ? e.eventDataTransform : null;
  return i && (n = fS(n, i)), r && (n = fS(n, r)), n;
}
function fS(n, e) {
  let t;
  if (!e)
    t = n;
  else {
    t = [];
    for (let r of n) {
      let i = e(r);
      i ? t.push(i) : i == null && t.push(r);
    }
  }
  return t;
}
function wF(n, e, t, r) {
  return t && (e = zc(e, t, r)), My(n, e);
}
function hS(n, e, t) {
  let { defs: r } = n, i = Ho(n.instances, (s) => r[s.defId].allDay ? s : Object.assign(Object.assign({}, s), { range: {
    start: t.createMarker(e.toDate(s.range.start, s.forcedStartTzo)),
    end: t.createMarker(e.toDate(s.range.end, s.forcedEndTzo))
  }, forcedStartTzo: t.canComputeOffset ? null : s.forcedStartTzo, forcedEndTzo: t.canComputeOffset ? null : s.forcedEndTzo }));
  return { defs: r, instances: i };
}
function pT(n, e) {
  return _y(n, (t) => t.sourceId !== e);
}
function EF(n) {
  const { defs: e, instances: t } = n, r = {}, i = {};
  for (let s in e) {
    const o = e[s], { publicId: a } = o;
    a && (r[a] = s);
  }
  for (let s in t) {
    const o = t[s], a = e[o.defId], { publicId: c } = a;
    c && (i[c] = s);
  }
  return { defIdMap: r, instanceIdMap: i };
}
class AF {
  constructor() {
    this.handlers = {}, this.thisContext = null;
  }
  setThisContext(e) {
    this.thisContext = e;
  }
  setOptions(e) {
    this.options = e;
  }
  on(e, t) {
    TF(this.handlers, e, t);
  }
  off(e, t) {
    CF(this.handlers, e, t);
  }
  trigger(e, ...t) {
    let r = this.handlers[e] || [], i = this.options && this.options[e], s = [].concat(i || [], r);
    for (let o of s)
      o.apply(this.thisContext, t);
  }
  hasHandlers(e) {
    return !!(this.handlers[e] && this.handlers[e].length || this.options && this.options[e]);
  }
}
function TF(n, e, t) {
  (n[e] || (n[e] = [])).push(t);
}
function CF(n, e, t) {
  t ? n[e] && (n[e] = n[e].filter((r) => r !== t)) : delete n[e];
}
const DF = {
  startTime: "09:00",
  endTime: "17:00",
  daysOfWeek: [1, 2, 3, 4, 5],
  display: "inverse-background",
  classNames: "fc-non-business",
  groupId: "_businessHours"
  // so multiple defs get grouped
};
function RF(n, e) {
  return mc(kF(n), null, e);
}
function kF(n) {
  let e;
  return n === !0 ? e = [{}] : Array.isArray(n) ? e = n.filter((t) => t.daysOfWeek) : typeof n == "object" && n ? e = [n] : e = [], e = e.map((t) => Object.assign(Object.assign({}, DF), t)), e;
}
function MF(n, e, t) {
  t.emitter.trigger("select", Object.assign(Object.assign({}, OF(n, t)), { jsEvent: null, view: t.viewApi || t.calendarApi.view }));
}
function _F(n, e) {
  e.emitter.trigger("unselect", {
    jsEvent: n ? n.origEvent : null,
    view: e.viewApi || e.calendarApi.view
  });
}
function OF(n, e) {
  let t = {};
  for (let r of e.pluginHooks.dateSpanTransforms)
    Object.assign(t, r(n, e));
  return Object.assign(t, $F(n, e.dateEnv)), t;
}
function pS(n, e, t) {
  let { dateEnv: r, options: i } = t, s = e;
  return n ? (s = Ot(s), s = r.add(s, i.defaultAllDayEventDuration)) : s = r.add(s, i.defaultTimedEventDuration), s;
}
function IF(n, e, t, r) {
  let i = gT(n.defs, e), s = as();
  for (let o in n.defs) {
    let a = n.defs[o];
    s.defs[o] = NF(a, i[o], t, r);
  }
  for (let o in n.instances) {
    let a = n.instances[o], c = s.defs[a.defId];
    s.instances[o] = PF(a, c, i[a.defId], t, r);
  }
  return s;
}
function NF(n, e, t, r) {
  let i = t.standardProps || {};
  i.hasEnd == null && e.durationEditable && (t.startDelta || t.endDelta) && (i.hasEnd = !0);
  let s = Object.assign(Object.assign(Object.assign({}, n), i), { ui: Object.assign(Object.assign({}, n.ui), i.ui) });
  t.extendedProps && (s.extendedProps = Object.assign(Object.assign({}, s.extendedProps), t.extendedProps));
  for (let o of r.pluginHooks.eventDefMutationAppliers)
    o(s, t, r);
  return !s.hasEnd && r.options.forceEventDuration && (s.hasEnd = !0), s;
}
function PF(n, e, t, r, i) {
  let { dateEnv: s } = i, o = r.standardProps && r.standardProps.allDay === !0, a = r.standardProps && r.standardProps.hasEnd === !1, c = Object.assign({}, n);
  return o && (c.range = iT(c.range)), r.datesDelta && t.startEditable && (c.range = {
    start: s.add(c.range.start, r.datesDelta),
    end: s.add(c.range.end, r.datesDelta)
  }), r.startDelta && t.durationEditable && (c.range = {
    start: s.add(c.range.start, r.startDelta),
    end: c.range.end
  }), r.endDelta && t.durationEditable && (c.range = {
    start: c.range.start,
    end: s.add(c.range.end, r.endDelta)
  }), a && (c.range = {
    start: c.range.start,
    end: pS(e.allDay, c.range.start, i)
  }), e.allDay && (c.range = {
    start: Ot(c.range.start),
    end: Ot(c.range.end)
  }), c.range.end < c.range.start && (c.range.end = pS(e.allDay, c.range.start, i)), c;
}
class Ra {
  constructor(e, t) {
    this.context = e, this.internalEventSource = t;
  }
  remove() {
    this.context.dispatch({
      type: "REMOVE_EVENT_SOURCE",
      sourceId: this.internalEventSource.sourceId
    });
  }
  refetch() {
    this.context.dispatch({
      type: "FETCH_EVENT_SOURCES",
      sourceIds: [this.internalEventSource.sourceId],
      isRefetch: !0
    });
  }
  get id() {
    return this.internalEventSource.publicId;
  }
  get url() {
    return this.internalEventSource.meta.url;
  }
  get format() {
    return this.internalEventSource.meta.format;
  }
}
class qr {
  // instance will be null if expressing a recurring event that has no current instances,
  // OR if trying to validate an incoming external event that has no dates assigned
  constructor(e, t, r) {
    this._context = e, this._def = t, this._instance = r || null;
  }
  /*
  TODO: make event struct more responsible for this
  */
  setProp(e, t) {
    if (e in aT)
      console.warn("Could not set date-related prop 'name'. Use one of the date-related methods instead.");
    else if (e === "id")
      t = yd[e](t), this.mutate({
        standardProps: { publicId: t }
        // hardcoded internal name
      });
    else if (e in yd)
      t = yd[e](t), this.mutate({
        standardProps: { [e]: t }
      });
    else if (e in Fd) {
      let r = Fd[e](t);
      e === "color" ? r = { backgroundColor: t, borderColor: t } : e === "editable" ? r = { startEditable: t, durationEditable: t } : r = { [e]: t }, this.mutate({
        standardProps: { ui: r }
      });
    } else
      console.warn(`Could not set prop '${e}'. Use setExtendedProp instead.`);
  }
  setExtendedProp(e, t) {
    this.mutate({
      extendedProps: { [e]: t }
    });
  }
  setStart(e, t = {}) {
    let { dateEnv: r } = this._context, i = r.createMarker(e);
    if (i && this._instance) {
      let s = this._instance.range, o = Fu(s.start, i, r, t.granularity);
      t.maintainDuration ? this.mutate({ datesDelta: o }) : this.mutate({ startDelta: o });
    }
  }
  setEnd(e, t = {}) {
    let { dateEnv: r } = this._context, i;
    if (!(e != null && (i = r.createMarker(e), !i)) && this._instance)
      if (i) {
        let s = Fu(this._instance.range.end, i, r, t.granularity);
        this.mutate({ endDelta: s });
      } else
        this.mutate({ standardProps: { hasEnd: !1 } });
  }
  setDates(e, t, r = {}) {
    let { dateEnv: i } = this._context, s = { allDay: r.allDay }, o = i.createMarker(e), a;
    if (o && !(t != null && (a = i.createMarker(t), !a)) && this._instance) {
      let c = this._instance.range;
      r.allDay === !0 && (c = iT(c));
      let u = Fu(c.start, o, i, r.granularity);
      if (a) {
        let d = Fu(c.end, a, i, r.granularity);
        nj(u, d) ? this.mutate({ datesDelta: u, standardProps: s }) : this.mutate({ startDelta: u, endDelta: d, standardProps: s });
      } else
        s.hasEnd = !1, this.mutate({ datesDelta: u, standardProps: s });
    }
  }
  moveStart(e) {
    let t = lt(e);
    t && this.mutate({ startDelta: t });
  }
  moveEnd(e) {
    let t = lt(e);
    t && this.mutate({ endDelta: t });
  }
  moveDates(e) {
    let t = lt(e);
    t && this.mutate({ datesDelta: t });
  }
  setAllDay(e, t = {}) {
    let r = { allDay: e }, { maintainDuration: i } = t;
    i == null && (i = this._context.options.allDayMaintainDuration), this._def.allDay !== e && (r.hasEnd = i), this.mutate({ standardProps: r });
  }
  formatRange(e) {
    let { dateEnv: t } = this._context, r = this._instance, i = $t(e);
    return this._def.hasEnd ? t.formatRange(r.range.start, r.range.end, i, {
      forcedStartTzo: r.forcedStartTzo,
      forcedEndTzo: r.forcedEndTzo
    }) : t.format(r.range.start, i, {
      forcedTzo: r.forcedStartTzo
    });
  }
  mutate(e) {
    let t = this._instance;
    if (t) {
      let r = this._def, i = this._context, { eventStore: s } = i.getCurrentData(), o = dF(s, t.instanceId);
      o = IF(o, {
        "": {
          display: "",
          startEditable: !0,
          durationEditable: !0,
          constraints: [],
          overlap: null,
          allows: [],
          backgroundColor: "",
          borderColor: "",
          textColor: "",
          classNames: []
        }
      }, e, i);
      let c = new qr(i, r, t);
      this._def = o.defs[r.defId], this._instance = o.instances[t.instanceId], i.dispatch({
        type: "MERGE_EVENTS",
        eventStore: o
      }), i.emitter.trigger("eventChange", {
        oldEvent: c,
        event: this,
        relatedEvents: Oy(o, i, t),
        revert() {
          i.dispatch({
            type: "RESET_EVENTS",
            eventStore: s
            // the ORIGINAL store
          });
        }
      });
    }
  }
  remove() {
    let e = this._context, t = mT(this);
    e.dispatch({
      type: "REMOVE_EVENTS",
      eventStore: t
    }), e.emitter.trigger("eventRemove", {
      event: this,
      relatedEvents: [],
      revert() {
        e.dispatch({
          type: "MERGE_EVENTS",
          eventStore: t
        });
      }
    });
  }
  get source() {
    let { sourceId: e } = this._def;
    return e ? new Ra(this._context, this._context.getCurrentData().eventSources[e]) : null;
  }
  get start() {
    return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
  }
  get end() {
    return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
  }
  get startStr() {
    let e = this._instance;
    return e ? this._context.dateEnv.formatIso(e.range.start, {
      omitTime: this._def.allDay,
      forcedTzo: e.forcedStartTzo
    }) : "";
  }
  get endStr() {
    let e = this._instance;
    return e && this._def.hasEnd ? this._context.dateEnv.formatIso(e.range.end, {
      omitTime: this._def.allDay,
      forcedTzo: e.forcedEndTzo
    }) : "";
  }
  // computable props that all access the def
  // TODO: find a TypeScript-compatible way to do this at scale
  get id() {
    return this._def.publicId;
  }
  get groupId() {
    return this._def.groupId;
  }
  get allDay() {
    return this._def.allDay;
  }
  get title() {
    return this._def.title;
  }
  get url() {
    return this._def.url;
  }
  get display() {
    return this._def.ui.display || "auto";
  }
  // bad. just normalize the type earlier
  get startEditable() {
    return this._def.ui.startEditable;
  }
  get durationEditable() {
    return this._def.ui.durationEditable;
  }
  get constraint() {
    return this._def.ui.constraints[0] || null;
  }
  get overlap() {
    return this._def.ui.overlap;
  }
  get allow() {
    return this._def.ui.allows[0] || null;
  }
  get backgroundColor() {
    return this._def.ui.backgroundColor;
  }
  get borderColor() {
    return this._def.ui.borderColor;
  }
  get textColor() {
    return this._def.ui.textColor;
  }
  // NOTE: user can't modify these because Object.freeze was called in event-def parsing
  get classNames() {
    return this._def.ui.classNames;
  }
  get extendedProps() {
    return this._def.extendedProps;
  }
  toPlainObject(e = {}) {
    let t = this._def, { ui: r } = t, { startStr: i, endStr: s } = this, o = {
      allDay: t.allDay
    };
    return t.title && (o.title = t.title), i && (o.start = i), s && (o.end = s), t.publicId && (o.id = t.publicId), t.groupId && (o.groupId = t.groupId), t.url && (o.url = t.url), r.display && r.display !== "auto" && (o.display = r.display), e.collapseColor && r.backgroundColor && r.backgroundColor === r.borderColor ? o.color = r.backgroundColor : (r.backgroundColor && (o.backgroundColor = r.backgroundColor), r.borderColor && (o.borderColor = r.borderColor)), r.textColor && (o.textColor = r.textColor), r.classNames.length && (o.classNames = r.classNames), Object.keys(t.extendedProps).length && (e.collapseExtendedProps ? Object.assign(o, t.extendedProps) : o.extendedProps = t.extendedProps), o;
  }
  toJSON() {
    return this.toPlainObject();
  }
}
function mT(n) {
  let e = n._def, t = n._instance;
  return {
    defs: { [e.defId]: e },
    instances: t ? { [t.instanceId]: t } : {}
  };
}
function Oy(n, e, t) {
  let { defs: r, instances: i } = n, s = [], o = t ? t.instanceId : "";
  for (let a in i) {
    let c = i[a], u = r[c.defId];
    c.instanceId !== o && s.push(new qr(e, u, c));
  }
  return s;
}
function mS(n, e, t, r) {
  let i = {}, s = {}, o = {}, a = [], c = [], u = gT(n.defs, e);
  for (let d in n.defs) {
    let h = n.defs[d];
    u[h.defId].display === "inverse-background" && (h.groupId ? (i[h.groupId] = [], o[h.groupId] || (o[h.groupId] = h)) : s[d] = []);
  }
  for (let d in n.instances) {
    let h = n.instances[d], p = n.defs[h.defId], g = u[p.defId], y = h.range, b = !p.allDay && r ? sT(y, r) : y, S = Uo(b, t);
    S && (g.display === "inverse-background" ? p.groupId ? i[p.groupId].push(S) : s[h.defId].push(S) : g.display !== "none" && (g.display === "background" ? a : c).push({
      def: p,
      ui: g,
      instance: h,
      range: S,
      isStart: b.start && b.start.valueOf() === S.start.valueOf(),
      isEnd: b.end && b.end.valueOf() === S.end.valueOf()
    }));
  }
  for (let d in i) {
    let h = i[d], p = uS(h, t);
    for (let g of p) {
      let y = o[d], b = u[y.defId];
      a.push({
        def: y,
        ui: b,
        instance: null,
        range: g,
        isStart: !1,
        isEnd: !1
      });
    }
  }
  for (let d in s) {
    let h = s[d], p = uS(h, t);
    for (let g of p)
      a.push({
        def: n.defs[d],
        ui: u[d],
        instance: null,
        range: g,
        isStart: !1,
        isEnd: !1
      });
  }
  return { bg: a, fg: c };
}
function LF(n) {
  return n.ui.display === "background" || n.ui.display === "inverse-background";
}
function gS(n, e) {
  n.fcSeg = e;
}
function ng(n) {
  return n.fcSeg || n.parentNode.fcSeg || // for the harness
  null;
}
function gT(n, e) {
  return Ho(n, (t) => yT(t, e));
}
function yT(n, e) {
  let t = [];
  return e[""] && t.push(e[""]), e[n.defId] && t.push(e[n.defId]), t.push(n.ui), uT(t);
}
function vT(n, e) {
  let t = n.map(BF);
  return t.sort((r, i) => JB(r, i, e)), t.map((r) => r._seg);
}
function BF(n) {
  let { eventRange: e } = n, t = e.def, r = e.instance ? e.instance.range : e.range, i = r.start ? r.start.valueOf() : 0, s = r.end ? r.end.valueOf() : 0;
  return Object.assign(Object.assign(Object.assign({}, t.extendedProps), t), {
    id: t.publicId,
    start: i,
    end: s,
    duration: s - i,
    allDay: Number(t.allDay),
    _seg: n
  });
}
function jF(n, e) {
  let { pluginHooks: t } = e, r = t.isDraggableTransformers, { def: i, ui: s } = n.eventRange, o = s.startEditable;
  for (let a of r)
    o = a(o, i, s, e);
  return o;
}
function FF(n, e) {
  return n.isStart && n.eventRange.ui.durationEditable && e.options.eventResizableFromStart;
}
function zF(n, e) {
  return n.isEnd && n.eventRange.ui.durationEditable;
}
function bT(n, e, t, r, i, s, o) {
  let { dateEnv: a, options: c } = t, { displayEventTime: u, displayEventEnd: d } = c, h = n.eventRange.def, p = n.eventRange.instance;
  u == null && (u = r !== !1), d == null && (d = i !== !1);
  let g = p.range.start, y = p.range.end, b = n.start || n.eventRange.range.start, S = n.end || n.eventRange.range.end, w = Ot(g).valueOf() === Ot(b).valueOf(), T = Ot(Qs(y, -1)).valueOf() === Ot(Qs(S, -1)).valueOf();
  return u && !h.allDay && (w || T) ? (b = w ? g : b, S = T ? y : S, d && h.hasEnd ? a.formatRange(b, S, e, {
    forcedStartTzo: p.forcedStartTzo,
    forcedEndTzo: p.forcedEndTzo
  }) : a.format(b, e, {
    forcedTzo: p.forcedStartTzo
    // nooooo, same
  })) : "";
}
function $s(n, e, t) {
  let r = n.eventRange.range;
  return {
    isPast: r.end <= (t || e.start),
    isFuture: r.start >= (t || e.end),
    isToday: e && ns(e, r.start)
  };
}
function VF(n) {
  let e = ["fc-event"];
  return n.isMirror && e.push("fc-event-mirror"), n.isDraggable && e.push("fc-event-draggable"), (n.isStartResizable || n.isEndResizable) && e.push("fc-event-resizable"), n.isDragging && e.push("fc-event-dragging"), n.isResizing && e.push("fc-event-resizing"), n.isSelected && e.push("fc-event-selected"), n.isStart && e.push("fc-event-start"), n.isEnd && e.push("fc-event-end"), n.isPast && e.push("fc-event-past"), n.isToday && e.push("fc-event-today"), n.isFuture && e.push("fc-event-future"), e;
}
function xT(n) {
  return n.instance ? n.instance.instanceId : `${n.def.defId}:${n.range.start.toISOString()}`;
}
function ST(n, e) {
  let { def: t, instance: r } = n.eventRange, { url: i } = t;
  if (i)
    return { href: i };
  let { emitter: s, options: o } = e, { eventInteractive: a } = o;
  return a == null && (a = t.interactive, a == null && (a = !!s.hasHandlers("eventClick"))), a ? K1((c) => {
    s.trigger("eventClick", {
      el: c.target,
      event: new qr(e, t, r),
      jsEvent: c,
      view: e.viewApi
    });
  }) : {};
}
const HF = {
  start: $,
  end: $,
  allDay: Boolean
};
function UF(n, e, t) {
  let r = WF(n, e), { range: i } = r;
  if (!i.start)
    return null;
  if (!i.end) {
    if (t == null)
      return null;
    i.end = e.add(i.start, t);
  }
  return r;
}
function WF(n, e) {
  let { refined: t, extra: r } = Ay(n, HF), i = t.start ? e.createMarkerMeta(t.start) : null, s = t.end ? e.createMarkerMeta(t.end) : null, { allDay: o } = t;
  return o == null && (o = i && i.isTimeUnspecified && (!s || s.isTimeUnspecified)), Object.assign({ range: {
    start: i ? i.marker : null,
    end: s ? s.marker : null
  }, allDay: o }, r);
}
function $F(n, e) {
  return Object.assign(Object.assign({}, ET(n.range, e, n.allDay)), { allDay: n.allDay });
}
function wT(n, e, t) {
  return Object.assign(Object.assign({}, ET(n, e, t)), { timeZone: e.timeZone });
}
function ET(n, e, t) {
  return {
    start: e.toDate(n.start),
    end: e.toDate(n.end),
    startStr: e.formatIso(n.start, { omitTime: t }),
    endStr: e.formatIso(n.end, { omitTime: t })
  };
}
function GF(n, e, t) {
  let r = cT({ editable: !1 }, t), i = eg(
    r.refined,
    r.extra,
    "",
    // sourceId
    n.allDay,
    !0,
    // hasEnd
    t
  );
  return {
    def: i,
    ui: yT(i, e),
    instance: Ry(i.defId, n.range),
    range: n.range,
    isStart: !0,
    isEnd: !0
  };
}
function YF(n, e, t) {
  let r = !1, i = function(a) {
    r || (r = !0, e(a));
  }, s = function(a) {
    r || (r = !0, t(a));
  }, o = n(i, s);
  o && typeof o.then == "function" && o.then(i, s);
}
class yS extends Error {
  constructor(e, t) {
    super(e), this.response = t;
  }
}
function qF(n, e, t) {
  n = n.toUpperCase();
  const r = {
    method: n
  };
  return n === "GET" ? e += (e.indexOf("?") === -1 ? "?" : "&") + new URLSearchParams(t) : (r.body = new URLSearchParams(t), r.headers = {
    "Content-Type": "application/x-www-form-urlencoded"
  }), fetch(e, r).then((i) => {
    if (i.ok)
      return i.json().then((s) => [s, i], () => {
        throw new yS("Failure parsing JSON", i);
      });
    throw new yS("Request failed", i);
  });
}
let Ip;
function AT() {
  return Ip == null && (Ip = KF()), Ip;
}
function KF() {
  if (typeof document > "u")
    return !0;
  let n = document.createElement("div");
  n.style.position = "absolute", n.style.top = "0px", n.style.left = "0px", n.innerHTML = "<table><tr><td><div></div></td></tr></table>", n.querySelector("table").style.height = "100px", n.querySelector("div").style.height = "100%", document.body.appendChild(n);
  let t = n.querySelector("div").offsetHeight > 0;
  return document.body.removeChild(n), t;
}
class JF extends gt {
  constructor() {
    super(...arguments), this.state = {
      forPrint: !1
    }, this.handleBeforePrint = () => {
      Bd(() => {
        this.setState({ forPrint: !0 });
      });
    }, this.handleAfterPrint = () => {
      Bd(() => {
        this.setState({ forPrint: !1 });
      });
    };
  }
  render() {
    let { props: e } = this, { options: t } = e, { forPrint: r } = this.state, i = r || t.height === "auto" || t.contentHeight === "auto", s = !i && t.height != null ? t.height : "", o = [
      "fc",
      r ? "fc-media-print" : "fc-media-screen",
      `fc-direction-${t.direction}`,
      e.theme.getClass("root")
    ];
    return AT() || o.push("fc-liquid-hack"), e.children(o, s, i, r);
  }
  componentDidMount() {
    let { emitter: e } = this.props;
    e.on("_beforeprint", this.handleBeforePrint), e.on("_afterprint", this.handleAfterPrint);
  }
  componentWillUnmount() {
    let { emitter: e } = this.props;
    e.off("_beforeprint", this.handleBeforePrint), e.off("_afterprint", this.handleAfterPrint);
  }
}
class TT {
  constructor(e) {
    this.component = e.component, this.isHitComboAllowed = e.isHitComboAllowed || null;
  }
  destroy() {
  }
}
function QF(n, e) {
  return {
    component: n,
    el: e.el,
    useEventCenter: e.useEventCenter != null ? e.useEventCenter : !0,
    isHitComboAllowed: e.isHitComboAllowed || null
  };
}
const vS = {};
class nl extends Rr {
  constructor(e, t) {
    super(e, t), this.handleRefresh = () => {
      let r = this.computeTiming();
      r.state.nowDate.valueOf() !== this.state.nowDate.valueOf() && this.setState(r.state), this.clearTimeout(), this.setTimeout(r.waitMs);
    }, this.handleVisibilityChange = () => {
      document.hidden || this.handleRefresh();
    }, this.state = this.computeTiming().state;
  }
  render() {
    let { props: e, state: t } = this;
    return e.children(t.nowDate, t.todayRange);
  }
  componentDidMount() {
    this.setTimeout(), this.context.nowManager.addResetListener(this.handleRefresh), document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }
  componentDidUpdate(e) {
    e.unit !== this.props.unit && (this.clearTimeout(), this.setTimeout());
  }
  componentWillUnmount() {
    this.clearTimeout(), this.context.nowManager.removeResetListener(this.handleRefresh), document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }
  computeTiming() {
    let { props: e, context: t } = this, r = t.nowManager.getDateMarker(), { nowIndicatorSnap: i } = t.options;
    i === "auto" && (i = // large unit?
    /year|month|week|day/.test(e.unit) || // if slotDuration 30 mins for example, would NOT appear to snap (legacy behavior)
    (e.unitValue || 1) === 1);
    let s, o;
    return i ? (s = t.dateEnv.startOf(r, e.unit), o = t.dateEnv.add(s, lt(1, e.unit)).valueOf() - r.valueOf()) : (s = r, o = 1e3 * 60), o = Math.min(1e3 * 60 * 60 * 24, o), {
      state: { nowDate: s, todayRange: ZF(s) },
      waitMs: o
    };
  }
  setTimeout(e = this.computeTiming().waitMs) {
    this.timeoutId = setTimeout(() => {
      const t = this.computeTiming();
      this.setState(t.state, () => {
        this.setTimeout(t.waitMs);
      });
    }, e);
  }
  clearTimeout() {
    this.timeoutId && clearTimeout(this.timeoutId);
  }
}
nl.contextType = ms;
function ZF(n) {
  let e = Ot(n), t = bn(e, 1);
  return { start: e, end: t };
}
class XF {
  getCurrentData() {
    return this.currentDataManager.getCurrentData();
  }
  dispatch(e) {
    this.currentDataManager.dispatch(e);
  }
  get view() {
    return this.getCurrentData().viewApi;
  }
  batchRendering(e) {
    e();
  }
  updateSize() {
    this.trigger("_resize", !0);
  }
  // Options
  // -----------------------------------------------------------------------------------------------------------------
  setOption(e, t) {
    this.dispatch({
      type: "SET_OPTION",
      optionName: e,
      rawOptionValue: t
    });
  }
  getOption(e) {
    return this.currentDataManager.currentCalendarOptionsInput[e];
  }
  getAvailableLocaleCodes() {
    return Object.keys(this.getCurrentData().availableRawLocales);
  }
  // Trigger
  // -----------------------------------------------------------------------------------------------------------------
  on(e, t) {
    let { currentDataManager: r } = this;
    r.currentCalendarOptionsRefiners[e] ? r.emitter.on(e, t) : console.warn(`Unknown listener name '${e}'`);
  }
  off(e, t) {
    this.currentDataManager.emitter.off(e, t);
  }
  // not meant for public use
  trigger(e, ...t) {
    this.currentDataManager.emitter.trigger(e, ...t);
  }
  // View
  // -----------------------------------------------------------------------------------------------------------------
  changeView(e, t) {
    this.batchRendering(() => {
      if (this.unselect(), t)
        if (t.start && t.end)
          this.dispatch({
            type: "CHANGE_VIEW_TYPE",
            viewType: e
          }), this.dispatch({
            type: "SET_OPTION",
            optionName: "visibleRange",
            rawOptionValue: t
          });
        else {
          let { dateEnv: r } = this.getCurrentData();
          this.dispatch({
            type: "CHANGE_VIEW_TYPE",
            viewType: e,
            dateMarker: r.createMarker(t)
          });
        }
      else
        this.dispatch({
          type: "CHANGE_VIEW_TYPE",
          viewType: e
        });
    });
  }
  // Forces navigation to a view for the given date.
  // `viewType` can be a specific view name or a generic one like "week" or "day".
  // needs to change
  zoomTo(e, t) {
    let r = this.getCurrentData(), i;
    t = t || "day", i = r.viewSpecs[t] || this.getUnitViewSpec(t), this.unselect(), i ? this.dispatch({
      type: "CHANGE_VIEW_TYPE",
      viewType: i.type,
      dateMarker: e
    }) : this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: e
    });
  }
  // Given a duration singular unit, like "week" or "day", finds a matching view spec.
  // Preference is given to views that have corresponding buttons.
  getUnitViewSpec(e) {
    let { viewSpecs: t, toolbarConfig: r } = this.getCurrentData(), i = [].concat(r.header ? r.header.viewsWithButtons : [], r.footer ? r.footer.viewsWithButtons : []), s, o;
    for (let a in t)
      i.push(a);
    for (s = 0; s < i.length; s += 1)
      if (o = t[i[s]], o && o.singleUnit === e)
        return o;
    return null;
  }
  // Current Date
  // -----------------------------------------------------------------------------------------------------------------
  prev() {
    this.unselect(), this.dispatch({ type: "PREV" });
  }
  next() {
    this.unselect(), this.dispatch({ type: "NEXT" });
  }
  prevYear() {
    let e = this.getCurrentData();
    this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: e.dateEnv.addYears(e.currentDate, -1)
    });
  }
  nextYear() {
    let e = this.getCurrentData();
    this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: e.dateEnv.addYears(e.currentDate, 1)
    });
  }
  today() {
    let e = this.getCurrentData();
    this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: e.nowManager.getDateMarker()
    });
  }
  gotoDate(e) {
    let t = this.getCurrentData();
    this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: t.dateEnv.createMarker(e)
    });
  }
  incrementDate(e) {
    let t = this.getCurrentData(), r = lt(e);
    r && (this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: t.dateEnv.add(t.currentDate, r)
    }));
  }
  getDate() {
    let e = this.getCurrentData();
    return e.dateEnv.toDate(e.currentDate);
  }
  // Date Formatting Utils
  // -----------------------------------------------------------------------------------------------------------------
  formatDate(e, t) {
    let { dateEnv: r } = this.getCurrentData();
    return r.format(r.createMarker(e), $t(t));
  }
  // `settings` is for formatter AND isEndExclusive
  formatRange(e, t, r) {
    let { dateEnv: i } = this.getCurrentData();
    return i.formatRange(i.createMarker(e), i.createMarker(t), $t(r), r);
  }
  formatIso(e, t) {
    let { dateEnv: r } = this.getCurrentData();
    return r.formatIso(r.createMarker(e), { omitTime: t });
  }
  // Date Selection / Event Selection / DayClick
  // -----------------------------------------------------------------------------------------------------------------
  select(e, t) {
    let r;
    t == null ? e.start != null ? r = e : r = {
      start: e,
      end: null
    } : r = {
      start: e,
      end: t
    };
    let i = this.getCurrentData(), s = UF(r, i.dateEnv, lt({ days: 1 }));
    s && (this.dispatch({ type: "SELECT_DATES", selection: s }), MF(s, null, i));
  }
  unselect(e) {
    let t = this.getCurrentData();
    t.dateSelection && (this.dispatch({ type: "UNSELECT_DATES" }), _F(e, t));
  }
  // Public Events API
  // -----------------------------------------------------------------------------------------------------------------
  addEvent(e, t) {
    if (e instanceof qr) {
      let o = e._def, a = e._instance;
      return this.getCurrentData().eventStore.defs[o.defId] || (this.dispatch({
        type: "ADD_EVENTS",
        eventStore: tg({ def: o, instance: a })
        // TODO: better util for two args?
      }), this.triggerEventAdd(e)), e;
    }
    let r = this.getCurrentData(), i;
    if (t instanceof Ra)
      i = t.internalEventSource;
    else if (typeof t == "boolean")
      t && ([i] = Cy(r.eventSources));
    else if (t != null) {
      let o = this.getEventSourceById(t);
      if (!o)
        return console.warn(`Could not find an event source with ID "${t}"`), null;
      i = o.internalEventSource;
    }
    let s = lT(e, i, r, !1);
    if (s) {
      let o = new qr(r, s.def, s.def.recurringDef ? null : s.instance);
      return this.dispatch({
        type: "ADD_EVENTS",
        eventStore: tg(s)
      }), this.triggerEventAdd(o), o;
    }
    return null;
  }
  triggerEventAdd(e) {
    let { emitter: t } = this.getCurrentData();
    t.trigger("eventAdd", {
      event: e,
      relatedEvents: [],
      revert: () => {
        this.dispatch({
          type: "REMOVE_EVENTS",
          eventStore: mT(e)
        });
      }
    });
  }
  // TODO: optimize
  getEventById(e) {
    let t = this.getCurrentData(), { defs: r, instances: i } = t.eventStore;
    e = String(e);
    for (let s in r) {
      let o = r[s];
      if (o.publicId === e) {
        if (o.recurringDef)
          return new qr(t, o, null);
        for (let a in i) {
          let c = i[a];
          if (c.defId === o.defId)
            return new qr(t, o, c);
        }
      }
    }
    return null;
  }
  getEvents() {
    let e = this.getCurrentData();
    return Oy(e.eventStore, e);
  }
  removeAllEvents() {
    this.dispatch({ type: "REMOVE_ALL_EVENTS" });
  }
  // Public Event Sources API
  // -----------------------------------------------------------------------------------------------------------------
  getEventSources() {
    let e = this.getCurrentData(), t = e.eventSources, r = [];
    for (let i in t)
      r.push(new Ra(e, t[i]));
    return r;
  }
  getEventSourceById(e) {
    let t = this.getCurrentData(), r = t.eventSources;
    e = String(e);
    for (let i in r)
      if (r[i].publicId === e)
        return new Ra(t, r[i]);
    return null;
  }
  addEventSource(e) {
    let t = this.getCurrentData();
    if (e instanceof Ra)
      return t.eventSources[e.internalEventSource.sourceId] || this.dispatch({
        type: "ADD_EVENT_SOURCES",
        sources: [e.internalEventSource]
      }), e;
    let r = dT(e, t);
    return r ? (this.dispatch({ type: "ADD_EVENT_SOURCES", sources: [r] }), new Ra(t, r)) : null;
  }
  removeAllEventSources() {
    this.dispatch({ type: "REMOVE_ALL_EVENT_SOURCES" });
  }
  refetchEvents() {
    this.dispatch({ type: "FETCH_EVENT_SOURCES", isRefetch: !0 });
  }
  // Scroll
  // -----------------------------------------------------------------------------------------------------------------
  scrollToTime(e) {
    let t = lt(e);
    t && this.trigger("_scrollRequest", { time: t });
  }
}
function ez(n, e) {
  let t = {
    left: Math.max(n.left, e.left),
    right: Math.min(n.right, e.right),
    top: Math.max(n.top, e.top),
    bottom: Math.min(n.bottom, e.bottom)
  };
  return t.left < t.right && t.top < t.bottom ? t : !1;
}
const Np = as();
class tz {
  constructor() {
    this.getKeysForEventDefs = Pe(this._getKeysForEventDefs), this.splitDateSelection = Pe(this._splitDateSpan), this.splitEventStore = Pe(this._splitEventStore), this.splitIndividualUi = Pe(this._splitIndividualUi), this.splitEventDrag = Pe(this._splitInteraction), this.splitEventResize = Pe(this._splitInteraction), this.eventUiBuilders = {};
  }
  splitProps(e) {
    let t = this.getKeyInfo(e), r = this.getKeysForEventDefs(e.eventStore), i = this.splitDateSelection(e.dateSelection), s = this.splitIndividualUi(e.eventUiBases, r), o = this.splitEventStore(e.eventStore, r), a = this.splitEventDrag(e.eventDrag), c = this.splitEventResize(e.eventResize), u = {};
    this.eventUiBuilders = Ho(t, (d, h) => this.eventUiBuilders[h] || Pe(nz));
    for (let d in t) {
      let h = t[d], p = o[d] || Np, g = this.eventUiBuilders[d];
      u[d] = {
        businessHours: h.businessHours || e.businessHours,
        dateSelection: i[d] || null,
        eventStore: p,
        eventUiBases: g(e.eventUiBases[""], h.ui, s[d]),
        eventSelection: p.instances[e.eventSelection] ? e.eventSelection : "",
        eventDrag: a[d] || null,
        eventResize: c[d] || null
      };
    }
    return u;
  }
  _splitDateSpan(e) {
    let t = {};
    if (e) {
      let r = this.getKeysForDateSpan(e);
      for (let i of r)
        t[i] = e;
    }
    return t;
  }
  _getKeysForEventDefs(e) {
    return Ho(e.defs, (t) => this.getKeysForEventDef(t));
  }
  _splitEventStore(e, t) {
    let { defs: r, instances: i } = e, s = {};
    for (let o in r)
      for (let a of t[o])
        s[a] || (s[a] = as()), s[a].defs[o] = r[o];
    for (let o in i) {
      let a = i[o];
      for (let c of t[a.defId])
        s[c] && (s[c].instances[o] = a);
    }
    return s;
  }
  _splitIndividualUi(e, t) {
    let r = {};
    for (let i in e)
      if (i)
        for (let s of t[i])
          r[s] || (r[s] = {}), r[s][i] = e[i];
    return r;
  }
  _splitInteraction(e) {
    let t = {};
    if (e) {
      let r = this._splitEventStore(e.affectedEvents, this._getKeysForEventDefs(e.affectedEvents)), i = this._getKeysForEventDefs(e.mutatedEvents), s = this._splitEventStore(e.mutatedEvents, i), o = (a) => {
        t[a] || (t[a] = {
          affectedEvents: r[a] || Np,
          mutatedEvents: s[a] || Np,
          isEvent: e.isEvent
        });
      };
      for (let a in r)
        o(a);
      for (let a in s)
        o(a);
    }
    return t;
  }
}
function nz(n, e, t) {
  let r = [];
  n && r.push(n), e && r.push(e);
  let i = {
    "": uT(r)
  };
  return t && Object.assign(i, t), i;
}
function CT(n, e, t, r) {
  return {
    dow: n.getUTCDay(),
    isDisabled: !!(r && (!r.activeRange || !ns(r.activeRange, n))),
    isOther: !!(r && !ns(r.currentRange, n)),
    isToday: !!(e && ns(e, n)),
    isPast: !!(e && n < e.start),
    isFuture: !!(e && n >= e.end)
  };
}
function Iy(n, e) {
  let t = [
    "fc-day",
    `fc-day-${aj[n.dow]}`
  ];
  return n.isDisabled ? t.push("fc-day-disabled") : (n.isToday && (t.push("fc-day-today"), t.push(e.getClass("today"))), n.isPast && t.push("fc-day-past"), n.isFuture && t.push("fc-day-future"), n.isOther && t.push("fc-day-other")), t;
}
const rz = $t({ year: "numeric", month: "long", day: "numeric" }), iz = $t({ week: "long" });
function Vd(n, e, t = "day", r = !0) {
  const { dateEnv: i, options: s, calendarApi: o } = n;
  let a = i.format(e, t === "week" ? iz : rz);
  if (s.navLinks) {
    let c = i.toDate(e);
    const u = (d) => {
      let h = t === "day" ? s.navLinkDayClick : t === "week" ? s.navLinkWeekClick : null;
      typeof h == "function" ? h.call(o, i.toDate(e), d) : (typeof h == "string" && (t = h), o.zoomTo(e, t));
    };
    return Object.assign({ title: Yl(s.navLinkHint, [a, c], a), "data-navlink": "" }, r ? q1(u) : { onClick: u });
  }
  return { "aria-label": a };
}
let Pp;
function sz() {
  return Pp || (Pp = oz()), Pp;
}
function oz() {
  let n = document.createElement("div");
  n.style.overflow = "scroll", n.style.position = "absolute", n.style.top = "-9999px", n.style.left = "-9999px", document.body.appendChild(n);
  let e = az(n);
  return document.body.removeChild(n), e;
}
function az(n) {
  return {
    x: n.offsetHeight - n.clientHeight,
    y: n.offsetWidth - n.clientWidth
  };
}
function lz(n) {
  let e = cz(n), t = n.getBoundingClientRect();
  for (let r of e) {
    let i = ez(t, r.getBoundingClientRect());
    if (i)
      t = i;
    else
      return null;
  }
  return t;
}
function cz(n) {
  let e = [];
  for (; n instanceof HTMLElement; ) {
    let t = window.getComputedStyle(n);
    if (t.position === "fixed")
      break;
    /(auto|scroll)/.test(t.overflow + t.overflowY + t.overflowX) && e.push(n), n = n.parentNode;
  }
  return e;
}
class Ka {
  constructor(e, t, r, i) {
    this.els = t;
    let s = this.originClientRect = e.getBoundingClientRect();
    r && this.buildElHorizontals(s.left), i && this.buildElVerticals(s.top);
  }
  // Populates the left/right internal coordinate arrays
  buildElHorizontals(e) {
    let t = [], r = [];
    for (let i of this.els) {
      let s = i.getBoundingClientRect();
      t.push(s.left - e), r.push(s.right - e);
    }
    this.lefts = t, this.rights = r;
  }
  // Populates the top/bottom internal coordinate arrays
  buildElVerticals(e) {
    let t = [], r = [];
    for (let i of this.els) {
      let s = i.getBoundingClientRect();
      t.push(s.top - e), r.push(s.bottom - e);
    }
    this.tops = t, this.bottoms = r;
  }
  // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
  // If no intersection is made, returns undefined.
  leftToIndex(e) {
    let { lefts: t, rights: r } = this, i = t.length, s;
    for (s = 0; s < i; s += 1)
      if (e >= t[s] && e < r[s])
        return s;
  }
  // Given a top offset (from document top), returns the index of the el that it vertically intersects.
  // If no intersection is made, returns undefined.
  topToIndex(e) {
    let { tops: t, bottoms: r } = this, i = t.length, s;
    for (s = 0; s < i; s += 1)
      if (e >= t[s] && e < r[s])
        return s;
  }
  // Gets the width of the element at the given index
  getWidth(e) {
    return this.rights[e] - this.lefts[e];
  }
  // Gets the height of the element at the given index
  getHeight(e) {
    return this.bottoms[e] - this.tops[e];
  }
  similarTo(e) {
    return zu(this.tops || [], e.tops || []) && zu(this.bottoms || [], e.bottoms || []) && zu(this.lefts || [], e.lefts || []) && zu(this.rights || [], e.rights || []);
  }
}
function zu(n, e) {
  const t = n.length;
  if (t !== e.length)
    return !1;
  for (let r = 0; r < t; r++)
    if (Math.round(n[r]) !== Math.round(e[r]))
      return !1;
  return !0;
}
class Li extends gt {
  constructor() {
    super(...arguments), this.uid = Jo();
  }
  // Hit System
  // -----------------------------------------------------------------------------------------------------------------
  prepareHits() {
  }
  queryHit(e, t, r, i) {
    return null;
  }
  // Pointer Interaction Utils
  // -----------------------------------------------------------------------------------------------------------------
  isValidSegDownEl(e) {
    return !this.props.eventDrag && // HACK
    !this.props.eventResize && // HACK
    !Xi(e, ".fc-event-mirror");
  }
  isValidDateDownEl(e) {
    return !Xi(e, ".fc-event:not(.fc-bg-event)") && !Xi(e, ".fc-more-link") && // a "more.." link
    !Xi(e, "a[data-navlink]") && // a clickable nav link
    !Xi(e, ".fc-popover");
  }
}
class DT {
  constructor(e = (t) => t.thickness || 1) {
    this.getEntryThickness = e, this.strictOrder = !1, this.allowReslicing = !1, this.maxCoord = -1, this.maxStackCnt = -1, this.levelCoords = [], this.entriesByLevel = [], this.stackCnts = {};
  }
  addSegs(e) {
    let t = [];
    for (let r of e)
      this.insertEntry(r, t);
    return t;
  }
  insertEntry(e, t) {
    let r = this.findInsertion(e);
    this.isInsertionValid(r, e) ? this.insertEntryAt(e, r) : this.handleInvalidInsertion(r, e, t);
  }
  isInsertionValid(e, t) {
    return (this.maxCoord === -1 || e.levelCoord + this.getEntryThickness(t) <= this.maxCoord) && (this.maxStackCnt === -1 || e.stackCnt < this.maxStackCnt);
  }
  handleInvalidInsertion(e, t, r) {
    if (this.allowReslicing && e.touchingEntry) {
      const i = Object.assign(Object.assign({}, t), { span: Ny(t.span, e.touchingEntry.span) });
      r.push(i), this.splitEntry(t, e.touchingEntry, r);
    } else
      r.push(t);
  }
  /*
  Does NOT add what hit the `barrier` into hiddenEntries. Should already be done.
  */
  splitEntry(e, t, r) {
    let i = e.span, s = t.span;
    i.start < s.start && this.insertEntry({
      index: e.index,
      thickness: e.thickness,
      span: { start: i.start, end: s.start }
    }, r), i.end > s.end && this.insertEntry({
      index: e.index,
      thickness: e.thickness,
      span: { start: s.end, end: i.end }
    }, r);
  }
  insertEntryAt(e, t) {
    let { entriesByLevel: r, levelCoords: i } = this;
    t.lateral === -1 ? (Lp(i, t.level, t.levelCoord), Lp(r, t.level, [e])) : Lp(r[t.level], t.lateral, e), this.stackCnts[Po(e)] = t.stackCnt;
  }
  /*
  does not care about limits
  */
  findInsertion(e) {
    let { levelCoords: t, entriesByLevel: r, strictOrder: i, stackCnts: s } = this, o = t.length, a = 0, c = -1, u = -1, d = null, h = 0;
    for (let y = 0; y < o; y += 1) {
      const b = t[y];
      if (!i && b >= a + this.getEntryThickness(e))
        break;
      let S = r[y], w, T = ig(S, e.span.start, rg), C = T[0] + T[1];
      for (
        ;
        // loop through entries that horizontally intersect
        (w = S[C]) && // but not past the whole entry list
        w.span.start < e.span.end;
      ) {
        let k = b + this.getEntryThickness(w);
        k > a && (a = k, d = w, c = y, u = C), k === a && (h = Math.max(h, s[Po(w)] + 1)), C += 1;
      }
    }
    let p = 0;
    if (d)
      for (p = c + 1; p < o && t[p] < a; )
        p += 1;
    let g = -1;
    return p < o && t[p] === a && (g = ig(r[p], e.span.end, rg)[0]), {
      touchingLevel: c,
      touchingLateral: u,
      touchingEntry: d,
      stackCnt: h,
      levelCoord: a,
      level: p,
      lateral: g
    };
  }
  // sorted by levelCoord (lowest to highest)
  toRects() {
    let { entriesByLevel: e, levelCoords: t } = this, r = e.length, i = [];
    for (let s = 0; s < r; s += 1) {
      let o = e[s], a = t[s];
      for (let c of o)
        i.push(Object.assign(Object.assign({}, c), { thickness: this.getEntryThickness(c), levelCoord: a }));
    }
    return i;
  }
}
function rg(n) {
  return n.span.end;
}
function Po(n) {
  return n.index + ":" + n.span.start;
}
function uz(n) {
  let e = [];
  for (let t of n) {
    let r = [], i = {
      span: t.span,
      entries: [t]
    };
    for (let s of e)
      Ny(s.span, i.span) ? i = {
        entries: s.entries.concat(i.entries),
        span: dz(s.span, i.span)
      } : r.push(s);
    r.push(i), e = r;
  }
  return e;
}
function dz(n, e) {
  return {
    start: Math.min(n.start, e.start),
    end: Math.max(n.end, e.end)
  };
}
function Ny(n, e) {
  let t = Math.max(n.start, e.start), r = Math.min(n.end, e.end);
  return t < r ? { start: t, end: r } : null;
}
function Lp(n, e, t) {
  n.splice(e, 0, t);
}
function ig(n, e, t) {
  let r = 0, i = n.length;
  if (!i || e < t(n[r]))
    return [0, 0];
  if (e > t(n[i - 1]))
    return [i, 0];
  for (; r < i; ) {
    let s = Math.floor(r + (i - r) / 2), o = t(n[s]);
    if (e < o)
      i = s;
    else if (e > o)
      r = s + 1;
    else
      return [s, 1];
  }
  return [r, 0];
}
function fz(n, e) {
  return !n || e > 10 ? $t({ weekday: "short" }) : e > 1 ? $t({ weekday: "short", month: "numeric", day: "numeric", omitCommas: !0 }) : $t({ weekday: "long" });
}
const RT = "fc-col-header-cell";
function kT(n) {
  return n.text;
}
class hz extends gt {
  render() {
    let { dateEnv: e, options: t, theme: r, viewApi: i } = this.context, { props: s } = this, { date: o, dateProfile: a } = s, c = CT(o, s.todayRange, null, a), u = [RT].concat(Iy(c, r)), d = e.format(o, s.dayHeaderFormat), h = !c.isDisabled && s.colCnt > 1 ? Vd(this.context, o) : {}, p = e.toDate(o);
    e.namedTimeZoneImpl && (p = Qs(p, 36e5));
    let g = Object.assign(Object.assign(Object.assign({ date: p, view: i }, s.extraRenderProps), { text: d }), c);
    return I(Mr, { elTag: "th", elClasses: u, elAttrs: Object.assign({ role: "columnheader", colSpan: s.colSpan, "data-date": c.isDisabled ? void 0 : wy(o) }, s.extraDataAttrs), renderProps: g, generatorName: "dayHeaderContent", customGenerator: t.dayHeaderContent, defaultGenerator: kT, classNameGenerator: t.dayHeaderClassNames, didMount: t.dayHeaderDidMount, willUnmount: t.dayHeaderWillUnmount }, (y) => I("div", { className: "fc-scrollgrid-sync-inner" }, !c.isDisabled && I(y, { elTag: "a", elAttrs: h, elClasses: [
      "fc-col-header-cell-cushion",
      s.isSticky && "fc-sticky"
    ] })));
  }
}
const pz = $t({ weekday: "long" });
class mz extends gt {
  render() {
    let { props: e } = this, { dateEnv: t, theme: r, viewApi: i, options: s } = this.context, o = bn(/* @__PURE__ */ new Date(2592e5), e.dow), a = {
      dow: e.dow,
      isDisabled: !1,
      isFuture: !1,
      isPast: !1,
      isToday: !1,
      isOther: !1
    }, c = t.format(o, e.dayHeaderFormat), u = Object.assign(Object.assign(Object.assign(Object.assign({
      // TODO: make this public?
      date: o
    }, a), { view: i }), e.extraRenderProps), { text: c });
    return I(Mr, { elTag: "th", elClasses: [
      RT,
      ...Iy(a, r),
      ...e.extraClassNames || []
    ], elAttrs: Object.assign({ role: "columnheader", colSpan: e.colSpan }, e.extraDataAttrs), renderProps: u, generatorName: "dayHeaderContent", customGenerator: s.dayHeaderContent, defaultGenerator: kT, classNameGenerator: s.dayHeaderClassNames, didMount: s.dayHeaderDidMount, willUnmount: s.dayHeaderWillUnmount }, (d) => I(
      "div",
      { className: "fc-scrollgrid-sync-inner" },
      I(d, { elTag: "a", elClasses: [
        "fc-col-header-cell-cushion",
        e.isSticky && "fc-sticky"
      ], elAttrs: {
        "aria-label": t.format(o, pz)
      } })
    ));
  }
}
class MT extends gt {
  constructor() {
    super(...arguments), this.createDayHeaderFormatter = Pe(gz);
  }
  render() {
    let { context: e } = this, { dates: t, dateProfile: r, datesRepDistinctDays: i, renderIntro: s } = this.props, o = this.createDayHeaderFormatter(e.options.dayHeaderFormat, i, t.length);
    return I(nl, { unit: "day" }, (a, c) => I(
      "tr",
      { role: "row" },
      s && s("day"),
      t.map((u) => i ? I(hz, { key: u.toISOString(), date: u, dateProfile: r, todayRange: c, colCnt: t.length, dayHeaderFormat: o }) : I(mz, { key: u.getUTCDay(), dow: u.getUTCDay(), dayHeaderFormat: o }))
    ));
  }
}
function gz(n, e, t) {
  return n || fz(e, t);
}
class _T {
  constructor(e, t) {
    let r = e.start, { end: i } = e, s = [], o = [], a = -1;
    for (; r < i; )
      t.isHiddenDay(r) ? s.push(a + 0.5) : (a += 1, s.push(a), o.push(r)), r = bn(r, 1);
    this.dates = o, this.indices = s, this.cnt = o.length;
  }
  sliceRange(e) {
    let t = this.getDateDayIndex(e.start), r = this.getDateDayIndex(bn(e.end, -1)), i = Math.max(0, t), s = Math.min(this.cnt - 1, r);
    return i = Math.ceil(i), s = Math.floor(s), i <= s ? {
      firstIndex: i,
      lastIndex: s,
      isStart: t === i,
      isEnd: r === s
    } : null;
  }
  // Given a date, returns its chronolocial cell-index from the first cell of the grid.
  // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
  // If before the first offset, returns a negative number.
  // If after the last offset, returns an offset past the last cell offset.
  // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
  getDateDayIndex(e) {
    let { indices: t } = this, r = Math.floor(Qo(this.dates[0], e));
    return r < 0 ? t[0] - 1 : r >= t.length ? t[t.length - 1] + 1 : t[r];
  }
}
class OT {
  constructor(e, t) {
    let { dates: r } = e, i, s, o;
    if (t) {
      for (s = r[0].getUTCDay(), i = 1; i < r.length && r[i].getUTCDay() !== s; i += 1)
        ;
      o = Math.ceil(r.length / i);
    } else
      o = 1, i = r.length;
    this.rowCnt = o, this.colCnt = i, this.daySeries = e, this.cells = this.buildCells(), this.headerDates = this.buildHeaderDates();
  }
  buildCells() {
    let e = [];
    for (let t = 0; t < this.rowCnt; t += 1) {
      let r = [];
      for (let i = 0; i < this.colCnt; i += 1)
        r.push(this.buildCell(t, i));
      e.push(r);
    }
    return e;
  }
  buildCell(e, t) {
    let r = this.daySeries.dates[e * this.colCnt + t];
    return {
      key: r.toISOString(),
      date: r
    };
  }
  buildHeaderDates() {
    let e = [];
    for (let t = 0; t < this.colCnt; t += 1)
      e.push(this.cells[0][t].date);
    return e;
  }
  sliceRange(e) {
    let { colCnt: t } = this, r = this.daySeries.sliceRange(e), i = [];
    if (r) {
      let { firstIndex: s, lastIndex: o } = r, a = s;
      for (; a <= o; ) {
        let c = Math.floor(a / t), u = Math.min((c + 1) * t, o + 1);
        i.push({
          row: c,
          firstCol: a % t,
          lastCol: (u - 1) % t,
          isStart: r.isStart && a === s,
          isEnd: r.isEnd && u - 1 === o
        }), a = u;
      }
    }
    return i;
  }
}
class IT {
  constructor() {
    this.sliceBusinessHours = Pe(this._sliceBusinessHours), this.sliceDateSelection = Pe(this._sliceDateSpan), this.sliceEventStore = Pe(this._sliceEventStore), this.sliceEventDrag = Pe(this._sliceInteraction), this.sliceEventResize = Pe(this._sliceInteraction), this.forceDayIfListItem = !1;
  }
  sliceProps(e, t, r, i, ...s) {
    let { eventUiBases: o } = e, a = this.sliceEventStore(e.eventStore, o, t, r, ...s);
    return {
      dateSelectionSegs: this.sliceDateSelection(e.dateSelection, t, r, o, i, ...s),
      businessHourSegs: this.sliceBusinessHours(e.businessHours, t, r, i, ...s),
      fgEventSegs: a.fg,
      bgEventSegs: a.bg,
      eventDrag: this.sliceEventDrag(e.eventDrag, o, t, r, ...s),
      eventResize: this.sliceEventResize(e.eventResize, o, t, r, ...s),
      eventSelection: e.eventSelection
    };
  }
  sliceNowDate(e, t, r, i, ...s) {
    return this._sliceDateSpan(
      { range: { start: e, end: Qs(e, 1) }, allDay: !1 },
      // add 1 ms, protect against null range
      t,
      r,
      {},
      i,
      ...s
    );
  }
  _sliceBusinessHours(e, t, r, i, ...s) {
    return e ? this._sliceEventStore(zc(e, Vu(t, !!r), i), {}, t, r, ...s).bg : [];
  }
  _sliceEventStore(e, t, r, i, ...s) {
    if (e) {
      let o = mS(e, t, Vu(r, !!i), i);
      return {
        bg: this.sliceEventRanges(o.bg, s),
        fg: this.sliceEventRanges(o.fg, s)
      };
    }
    return { bg: [], fg: [] };
  }
  _sliceInteraction(e, t, r, i, ...s) {
    if (!e)
      return null;
    let o = mS(e.mutatedEvents, t, Vu(r, !!i), i);
    return {
      segs: this.sliceEventRanges(o.fg, s),
      affectedInstances: e.affectedEvents.instances,
      isEvent: e.isEvent
    };
  }
  _sliceDateSpan(e, t, r, i, s, ...o) {
    if (!e)
      return [];
    let a = Vu(t, !!r), c = Uo(e.range, a);
    if (c) {
      e = Object.assign(Object.assign({}, e), { range: c });
      let u = GF(e, i, s), d = this.sliceRange(e.range, ...o);
      for (let h of d)
        h.eventRange = u;
      return d;
    }
    return [];
  }
  /*
  "complete" seg means it has component and eventRange
  */
  sliceEventRanges(e, t) {
    let r = [];
    for (let i of e)
      r.push(...this.sliceEventRange(i, t));
    return r;
  }
  /*
  "complete" seg means it has component and eventRange
  */
  sliceEventRange(e, t) {
    let r = e.range;
    this.forceDayIfListItem && e.ui.display === "list-item" && (r = {
      start: r.start,
      end: bn(r.start, 1)
    });
    let i = this.sliceRange(r, ...t);
    for (let s of i)
      s.eventRange = e, s.isStart = e.isStart && s.isStart, s.isEnd = e.isEnd && s.isEnd;
    return i;
  }
}
function Vu(n, e) {
  let t = n.activeRange;
  return e ? t : {
    start: Qs(t.start, n.slotMinTime.milliseconds),
    end: Qs(t.end, n.slotMaxTime.milliseconds - 864e5)
    // 864e5 = ms in a day
  };
}
const Hu = /^(visible|hidden)$/;
class yz extends gt {
  constructor() {
    super(...arguments), this.handleEl = (e) => {
      this.el = e, _i(this.props.elRef, e);
    };
  }
  render() {
    let { props: e } = this, { liquid: t, liquidIsAbsolute: r } = e, i = t && r, s = ["fc-scroller"];
    return t && (r ? s.push("fc-scroller-liquid-absolute") : s.push("fc-scroller-liquid")), I("div", { ref: this.handleEl, className: s.join(" "), style: {
      overflowX: e.overflowX,
      overflowY: e.overflowY,
      left: i && -(e.overcomeLeft || 0) || "",
      right: i && -(e.overcomeRight || 0) || "",
      bottom: i && -(e.overcomeBottom || 0) || "",
      marginLeft: !i && -(e.overcomeLeft || 0) || "",
      marginRight: !i && -(e.overcomeRight || 0) || "",
      marginBottom: !i && -(e.overcomeBottom || 0) || "",
      maxHeight: e.maxHeight || ""
    } }, e.children);
  }
  needsXScrolling() {
    if (Hu.test(this.props.overflowX))
      return !1;
    let { el: e } = this, t = this.el.getBoundingClientRect().width - this.getYScrollbarWidth(), { children: r } = e;
    for (let i = 0; i < r.length; i += 1)
      if (r[i].getBoundingClientRect().width > t)
        return !0;
    return !1;
  }
  needsYScrolling() {
    if (Hu.test(this.props.overflowY))
      return !1;
    let { el: e } = this, t = this.el.getBoundingClientRect().height - this.getXScrollbarWidth(), { children: r } = e;
    for (let i = 0; i < r.length; i += 1)
      if (r[i].getBoundingClientRect().height > t)
        return !0;
    return !1;
  }
  getXScrollbarWidth() {
    return Hu.test(this.props.overflowX) ? 0 : this.el.offsetHeight - this.el.clientHeight;
  }
  getYScrollbarWidth() {
    return Hu.test(this.props.overflowY) ? 0 : this.el.offsetWidth - this.el.clientWidth;
  }
}
class es {
  constructor(e) {
    this.masterCallback = e, this.currentMap = {}, this.depths = {}, this.callbackMap = {}, this.handleValue = (t, r) => {
      let { depths: i, currentMap: s } = this, o = !1, a = !1;
      t !== null ? (o = r in s, s[r] = t, i[r] = (i[r] || 0) + 1, a = !0) : (i[r] -= 1, i[r] || (delete s[r], delete this.callbackMap[r], o = !0)), this.masterCallback && (o && this.masterCallback(null, String(r)), a && this.masterCallback(t, String(r)));
    };
  }
  createRef(e) {
    let t = this.callbackMap[e];
    return t || (t = this.callbackMap[e] = (r) => {
      this.handleValue(r, String(e));
    }), t;
  }
  // TODO: check callers that don't care about order. should use getAll instead
  // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
  // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
  collect(e, t, r) {
    return Vj(this.currentMap, e, t, r);
  }
  getAll() {
    return Cy(this.currentMap);
  }
}
function vz(n) {
  let e = UB(n, ".fc-scrollgrid-shrink"), t = 0;
  for (let r of e)
    t = Math.max(t, XB(r));
  return Math.ceil(t);
}
function NT(n, e) {
  return n.liquid && e.liquid;
}
function bz(n, e) {
  return e.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
  NT(n, e);
}
function xz(n, e, t, r) {
  let { expandRows: i } = t;
  return typeof e.content == "function" ? e.content(t) : I("table", {
    role: "presentation",
    className: [
      e.tableClassName,
      n.syncRowHeights ? "fc-scrollgrid-sync-table" : ""
    ].join(" "),
    style: {
      minWidth: t.tableMinWidth,
      width: t.clientWidth,
      height: i ? t.clientHeight : ""
      // css `height` on a <table> serves as a min-height
    }
  }, t.tableColGroupNode, I(r ? "thead" : "tbody", {
    role: "presentation"
  }, typeof e.rowContent == "function" ? e.rowContent(t) : e.rowContent));
}
function Sz(n, e) {
  return Js(n, e, pi);
}
function wz(n, e) {
  let t = [];
  for (let r of n) {
    let i = r.span || 1;
    for (let s = 0; s < i; s += 1)
      t.push(I("col", { style: {
        width: r.width === "shrink" ? Ez(e) : r.width || "",
        minWidth: r.minWidth || ""
      } }));
  }
  return I("colgroup", {}, ...t);
}
function Ez(n) {
  return n ?? 4;
}
function Az(n) {
  for (let e of n)
    if (e.width === "shrink")
      return !0;
  return !1;
}
function Tz(n, e) {
  let t = [
    "fc-scrollgrid",
    e.theme.getClass("table")
  ];
  return n && t.push("fc-scrollgrid-liquid"), t;
}
function Cz(n, e) {
  let t = [
    "fc-scrollgrid-section",
    `fc-scrollgrid-section-${n.type}`,
    n.className
    // used?
  ];
  return e && n.liquid && n.maxHeight == null && t.push("fc-scrollgrid-section-liquid"), n.isSticky && t.push("fc-scrollgrid-section-sticky"), t;
}
function sg(n) {
  return I("div", { className: "fc-scrollgrid-sticky-shim", style: {
    width: n.clientWidth,
    minWidth: n.tableMinWidth
  } });
}
function Hd(n) {
  let { stickyHeaderDates: e } = n;
  return (e == null || e === "auto") && (e = n.height === "auto" || n.viewHeight === "auto"), e;
}
function PT(n) {
  let { stickyFooterScrollbar: e } = n;
  return (e == null || e === "auto") && (e = n.height === "auto" || n.viewHeight === "auto"), e;
}
class Py extends gt {
  constructor() {
    super(...arguments), this.processCols = Pe((e) => e, Sz), this.renderMicroColGroup = Pe(wz), this.scrollerRefs = new es(), this.scrollerElRefs = new es(this._handleScrollerEl.bind(this)), this.state = {
      shrinkWidth: null,
      forceYScrollbars: !1,
      scrollerClientWidths: {},
      scrollerClientHeights: {}
    }, this.handleSizing = () => {
      this.safeSetState(Object.assign({ shrinkWidth: this.computeShrinkWidth() }, this.computeScrollerDims()));
    };
  }
  render() {
    let { props: e, state: t, context: r } = this, i = e.sections || [], s = this.processCols(e.cols), o = this.renderMicroColGroup(s, t.shrinkWidth), a = Tz(e.liquid, r);
    e.collapsibleWidth && a.push("fc-scrollgrid-collapsible");
    let c = i.length, u = 0, d, h = [], p = [], g = [];
    for (; u < c && (d = i[u]).type === "header"; )
      h.push(this.renderSection(d, o, !0)), u += 1;
    for (; u < c && (d = i[u]).type === "body"; )
      p.push(this.renderSection(d, o, !1)), u += 1;
    for (; u < c && (d = i[u]).type === "footer"; )
      g.push(this.renderSection(d, o, !0)), u += 1;
    let y = !AT();
    const b = { role: "rowgroup" };
    return I("table", {
      role: "grid",
      className: a.join(" "),
      style: { height: e.height }
    }, !!(!y && h.length) && I("thead", b, ...h), !!(!y && p.length) && I("tbody", b, ...p), !!(!y && g.length) && I("tfoot", b, ...g), y && I("tbody", b, ...h, ...p, ...g));
  }
  renderSection(e, t, r) {
    return "outerContent" in e ? I(Dt, { key: e.key }, e.outerContent) : I("tr", { key: e.key, role: "presentation", className: Cz(e, this.props.liquid).join(" ") }, this.renderChunkTd(e, t, e.chunk, r));
  }
  renderChunkTd(e, t, r, i) {
    if ("outerContent" in r)
      return r.outerContent;
    let { props: s } = this, { forceYScrollbars: o, scrollerClientWidths: a, scrollerClientHeights: c } = this.state, u = bz(s, e), d = NT(s, e), h = s.liquid ? o ? "scroll" : u ? "auto" : "hidden" : "visible", p = e.key, g = xz(e, r, {
      tableColGroupNode: t,
      tableMinWidth: "",
      clientWidth: !s.collapsibleWidth && a[p] !== void 0 ? a[p] : null,
      clientHeight: c[p] !== void 0 ? c[p] : null,
      expandRows: e.expandRows,
      syncRowHeights: !1,
      rowSyncHeights: [],
      reportRowHeightChange: () => {
      }
    }, i);
    return I(i ? "th" : "td", {
      ref: r.elRef,
      role: "presentation"
    }, I(
      "div",
      { className: `fc-scroller-harness${d ? " fc-scroller-harness-liquid" : ""}` },
      I(yz, { ref: this.scrollerRefs.createRef(p), elRef: this.scrollerElRefs.createRef(p), overflowY: h, overflowX: s.liquid ? "hidden" : "visible", maxHeight: e.maxHeight, liquid: d, liquidIsAbsolute: !0 }, g)
    ));
  }
  _handleScrollerEl(e, t) {
    let r = Dz(this.props.sections, t);
    r && _i(r.chunk.scrollerElRef, e);
  }
  componentDidMount() {
    this.handleSizing(), this.context.addResizeHandler(this.handleSizing);
  }
  componentDidUpdate() {
    this.handleSizing();
  }
  componentWillUnmount() {
    this.context.removeResizeHandler(this.handleSizing);
  }
  computeShrinkWidth() {
    return Az(this.props.cols) ? vz(this.scrollerElRefs.getAll()) : 0;
  }
  computeScrollerDims() {
    let e = sz(), { scrollerRefs: t, scrollerElRefs: r } = this, i = !1, s = {}, o = {};
    for (let a in t.currentMap) {
      let c = t.currentMap[a];
      if (c && c.needsYScrolling()) {
        i = !0;
        break;
      }
    }
    for (let a of this.props.sections) {
      let c = a.key, u = r.currentMap[c];
      if (u) {
        let d = u.parentNode;
        s[c] = Math.floor(d.getBoundingClientRect().width - (i ? e.y : 0)), o[c] = Math.floor(d.getBoundingClientRect().height);
      }
    }
    return { forceYScrollbars: i, scrollerClientWidths: s, scrollerClientHeights: o };
  }
}
Py.addStateEquality({
  scrollerClientWidths: pi,
  scrollerClientHeights: pi
});
function Dz(n, e) {
  for (let t of n)
    if (t.key === e)
      return t;
  return null;
}
class Ly extends gt {
  constructor() {
    super(...arguments), this.buildPublicEvent = Pe((e, t, r) => new qr(e, t, r)), this.handleEl = (e) => {
      this.el = e, _i(this.props.elRef, e), e && gS(e, this.props.seg);
    };
  }
  render() {
    const { props: e, context: t } = this, { options: r } = t, { seg: i } = e, { eventRange: s } = i, { ui: o } = s, a = {
      event: this.buildPublicEvent(t, s.def, s.instance),
      view: t.viewApi,
      timeText: e.timeText,
      textColor: o.textColor,
      backgroundColor: o.backgroundColor,
      borderColor: o.borderColor,
      isDraggable: !e.disableDragging && jF(i, t),
      isStartResizable: !e.disableResizing && FF(i, t),
      isEndResizable: !e.disableResizing && zF(i),
      isMirror: !!(e.isDragging || e.isResizing || e.isDateSelecting),
      isStart: !!i.isStart,
      isEnd: !!i.isEnd,
      isPast: !!e.isPast,
      isFuture: !!e.isFuture,
      isToday: !!e.isToday,
      isSelected: !!e.isSelected,
      isDragging: !!e.isDragging,
      isResizing: !!e.isResizing
    };
    return I(Mr, { elRef: this.handleEl, elTag: e.elTag, elAttrs: e.elAttrs, elClasses: [
      ...VF(a),
      ...i.eventRange.ui.classNames,
      ...e.elClasses || []
    ], elStyle: e.elStyle, renderProps: a, generatorName: "eventContent", customGenerator: r.eventContent, defaultGenerator: e.defaultGenerator, classNameGenerator: r.eventClassNames, didMount: r.eventDidMount, willUnmount: r.eventWillUnmount }, e.children);
  }
  componentDidUpdate(e) {
    this.el && this.props.seg !== e.seg && gS(this.el, this.props.seg);
  }
}
class By extends gt {
  render() {
    let { props: e, context: t } = this, { options: r } = t, { seg: i } = e, { ui: s } = i.eventRange, o = r.eventTimeFormat || e.defaultTimeFormat, a = bT(i, o, t, e.defaultDisplayEventTime, e.defaultDisplayEventEnd);
    return I(Ly, Object.assign({}, e, { elTag: "a", elStyle: {
      borderColor: s.borderColor,
      backgroundColor: s.backgroundColor
    }, elAttrs: ST(i, t), defaultGenerator: Rz, timeText: a }), (c, u) => I(
      Dt,
      null,
      I(c, { elTag: "div", elClasses: ["fc-event-main"], elStyle: { color: u.textColor } }),
      !!u.isStartResizable && I("div", { className: "fc-event-resizer fc-event-resizer-start" }),
      !!u.isEndResizable && I("div", { className: "fc-event-resizer fc-event-resizer-end" })
    ));
  }
}
By.addPropsEquality({
  seg: pi
});
function Rz(n) {
  return I(
    "div",
    { className: "fc-event-main-frame" },
    n.timeText && I("div", { className: "fc-event-time" }, n.timeText),
    I(
      "div",
      { className: "fc-event-title-container" },
      I("div", { className: "fc-event-title fc-sticky" }, n.event.title || I(Dt, null, " "))
    )
  );
}
const jy = (n) => I(ms.Consumer, null, (e) => {
  let { options: t } = e, r = {
    isAxis: n.isAxis,
    date: e.dateEnv.toDate(n.date),
    view: e.viewApi
  };
  return I(Mr, { elRef: n.elRef, elTag: n.elTag || "div", elAttrs: n.elAttrs, elClasses: n.elClasses, elStyle: n.elStyle, renderProps: r, generatorName: "nowIndicatorContent", customGenerator: t.nowIndicatorContent, classNameGenerator: t.nowIndicatorClassNames, didMount: t.nowIndicatorDidMount, willUnmount: t.nowIndicatorWillUnmount }, n.children);
}), kz = $t({ day: "numeric" });
class Fy extends gt {
  constructor() {
    super(...arguments), this.refineRenderProps = gd(Mz);
  }
  render() {
    let { props: e, context: t } = this, { options: r } = t, i = this.refineRenderProps({
      date: e.date,
      dateProfile: e.dateProfile,
      todayRange: e.todayRange,
      isMonthStart: e.isMonthStart || !1,
      showDayNumber: e.showDayNumber,
      extraRenderProps: e.extraRenderProps,
      viewApi: t.viewApi,
      dateEnv: t.dateEnv,
      monthStartFormat: r.monthStartFormat
    });
    return I(Mr, { elRef: e.elRef, elTag: e.elTag, elAttrs: Object.assign(Object.assign({}, e.elAttrs), i.isDisabled ? {} : { "data-date": wy(e.date) }), elClasses: [
      ...Iy(i, t.theme),
      ...e.elClasses || []
    ], elStyle: e.elStyle, renderProps: i, generatorName: "dayCellContent", customGenerator: r.dayCellContent, defaultGenerator: e.defaultGenerator, classNameGenerator: (
      // don't use custom classNames if disabled
      i.isDisabled ? void 0 : r.dayCellClassNames
    ), didMount: r.dayCellDidMount, willUnmount: r.dayCellWillUnmount }, e.children);
  }
}
function zy(n) {
  return !!(n.dayCellContent || Xm("dayCellContent", n));
}
function Mz(n) {
  let { date: e, dateEnv: t, dateProfile: r, isMonthStart: i } = n, s = CT(e, n.todayRange, null, r), o = n.showDayNumber ? t.format(e, i ? n.monthStartFormat : kz) : "";
  return Object.assign(Object.assign(Object.assign({ date: t.toDate(e), view: n.viewApi }, s), {
    isMonthStart: i,
    dayNumberText: o
  }), n.extraRenderProps);
}
class LT extends gt {
  render() {
    let { props: e } = this, { seg: t } = e;
    return I(Ly, { elTag: "div", elClasses: ["fc-bg-event"], elStyle: { backgroundColor: t.eventRange.ui.backgroundColor }, defaultGenerator: _z, seg: t, timeText: "", isDragging: !1, isResizing: !1, isDateSelecting: !1, isSelected: !1, isPast: e.isPast, isFuture: e.isFuture, isToday: e.isToday, disableDragging: !0, disableResizing: !0 });
  }
}
function _z(n) {
  let { title: e } = n.event;
  return e && I("div", { className: "fc-event-title" }, n.event.title);
}
function BT(n) {
  return I("div", { className: `fc-${n}` });
}
const jT = (n) => I(ms.Consumer, null, (e) => {
  let { dateEnv: t, options: r } = e, { date: i } = n, s = r.weekNumberFormat || n.defaultFormat, o = t.computeWeekNumber(i), a = t.format(i, s), c = { num: o, text: a, date: i };
  return I(
    Mr,
    { elRef: n.elRef, elTag: n.elTag, elAttrs: n.elAttrs, elClasses: n.elClasses, elStyle: n.elStyle, renderProps: c, generatorName: "weekNumberContent", customGenerator: r.weekNumberContent, defaultGenerator: Oz, classNameGenerator: r.weekNumberClassNames, didMount: r.weekNumberDidMount, willUnmount: r.weekNumberWillUnmount },
    n.children
  );
});
function Oz(n) {
  return n.text;
}
const Bp = 10;
class Iz extends gt {
  constructor() {
    super(...arguments), this.state = {
      titleId: Gf()
    }, this.handleRootEl = (e) => {
      this.rootEl = e, this.props.elRef && _i(this.props.elRef, e);
    }, this.handleDocumentMouseDown = (e) => {
      const t = GB(e);
      this.rootEl.contains(t) || this.handleCloseClick();
    }, this.handleDocumentKeyDown = (e) => {
      e.key === "Escape" && this.handleCloseClick();
    }, this.handleCloseClick = () => {
      let { onClose: e } = this.props;
      e && e();
    };
  }
  render() {
    let { theme: e, options: t } = this.context, { props: r, state: i } = this, s = [
      "fc-popover",
      e.getClass("popover")
    ].concat(r.extraClassNames || []);
    return RB(I(
      "div",
      Object.assign({}, r.extraAttrs, { id: r.id, className: s.join(" "), "aria-labelledby": i.titleId, ref: this.handleRootEl }),
      I(
        "div",
        { className: "fc-popover-header " + e.getClass("popoverHeader") },
        I("span", { className: "fc-popover-title", id: i.titleId }, r.title),
        I("span", { className: "fc-popover-close " + e.getIconClass("close"), title: t.closeHint, onClick: this.handleCloseClick })
      ),
      I("div", { className: "fc-popover-body " + e.getClass("popoverContent") }, r.children)
    ), r.parentEl);
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.handleDocumentMouseDown), document.addEventListener("keydown", this.handleDocumentKeyDown), this.updateSize();
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleDocumentMouseDown), document.removeEventListener("keydown", this.handleDocumentKeyDown);
  }
  updateSize() {
    let { isRtl: e } = this.context, { alignmentEl: t, alignGridTop: r } = this.props, { rootEl: i } = this, s = lz(t);
    if (s) {
      let o = i.getBoundingClientRect(), a = r ? Xi(t, ".fc-scrollgrid").getBoundingClientRect().top : s.top, c = e ? s.right - o.width : s.left;
      a = Math.max(a, Bp), c = Math.min(c, document.documentElement.clientWidth - Bp - o.width), c = Math.max(c, Bp);
      let u = i.offsetParent.getBoundingClientRect();
      $B(i, {
        top: a - u.top,
        left: c - u.left
      });
    }
  }
}
class Nz extends Li {
  constructor() {
    super(...arguments), this.handleRootEl = (e) => {
      this.rootEl = e, e ? this.context.registerInteractiveComponent(this, {
        el: e,
        useEventCenter: !1
      }) : this.context.unregisterInteractiveComponent(this);
    };
  }
  render() {
    let { options: e, dateEnv: t } = this.context, { props: r } = this, { startDate: i, todayRange: s, dateProfile: o } = r, a = t.format(i, e.dayPopoverFormat);
    return I(Fy, { elRef: this.handleRootEl, date: i, dateProfile: o, todayRange: s }, (c, u, d) => I(
      Iz,
      { elRef: d.ref, id: r.id, title: a, extraClassNames: ["fc-more-popover"].concat(d.className || []), extraAttrs: d, parentEl: r.parentEl, alignmentEl: r.alignmentEl, alignGridTop: r.alignGridTop, onClose: r.onClose },
      zy(e) && I(c, { elTag: "div", elClasses: ["fc-more-popover-misc"] }),
      r.children
    ));
  }
  queryHit(e, t, r, i) {
    let { rootEl: s, props: o } = this;
    return e >= 0 && e < r && t >= 0 && t < i ? {
      dateProfile: o.dateProfile,
      dateSpan: Object.assign({ allDay: !o.forceTimed, range: {
        start: o.startDate,
        end: o.endDate
      } }, o.extraDateSpan),
      dayEl: s,
      rect: {
        left: 0,
        top: 0,
        right: r,
        bottom: i
      },
      layer: 1
      // important when comparing with hits from other components
    } : null;
  }
}
class FT extends gt {
  constructor() {
    super(...arguments), this.state = {
      isPopoverOpen: !1,
      popoverId: Gf()
    }, this.handleLinkEl = (e) => {
      this.linkEl = e, this.props.elRef && _i(this.props.elRef, e);
    }, this.handleClick = (e) => {
      let { props: t, context: r } = this, { moreLinkClick: i } = r.options, s = bS(t).start;
      function o(a) {
        let { def: c, instance: u, range: d } = a.eventRange;
        return {
          event: new qr(r, c, u),
          start: r.dateEnv.toDate(d.start),
          end: r.dateEnv.toDate(d.end),
          isStart: a.isStart,
          isEnd: a.isEnd
        };
      }
      typeof i == "function" && (i = i({
        date: s,
        allDay: !!t.allDayDate,
        allSegs: t.allSegs.map(o),
        hiddenSegs: t.hiddenSegs.map(o),
        jsEvent: e,
        view: r.viewApi
      })), !i || i === "popover" ? this.setState({ isPopoverOpen: !0 }) : typeof i == "string" && r.calendarApi.zoomTo(s, i);
    }, this.handlePopoverClose = () => {
      this.setState({ isPopoverOpen: !1 });
    };
  }
  render() {
    let { props: e, state: t } = this;
    return I(ms.Consumer, null, (r) => {
      let { viewApi: i, options: s, calendarApi: o } = r, { moreLinkText: a } = s, { moreCnt: c } = e, u = bS(e), d = typeof a == "function" ? a.call(o, c) : `+${c} ${a}`, h = Yl(s.moreLinkHint, [c], d), p = {
        num: c,
        shortText: `+${c}`,
        text: d,
        view: i
      };
      return I(
        Dt,
        null,
        !!e.moreCnt && I(Mr, { elTag: e.elTag || "a", elRef: this.handleLinkEl, elClasses: [
          ...e.elClasses || [],
          "fc-more-link"
        ], elStyle: e.elStyle, elAttrs: Object.assign(Object.assign(Object.assign({}, e.elAttrs), q1(this.handleClick)), { title: h, "aria-expanded": t.isPopoverOpen, "aria-controls": t.isPopoverOpen ? t.popoverId : "" }), renderProps: p, generatorName: "moreLinkContent", customGenerator: s.moreLinkContent, defaultGenerator: e.defaultGenerator || Pz, classNameGenerator: s.moreLinkClassNames, didMount: s.moreLinkDidMount, willUnmount: s.moreLinkWillUnmount }, e.children),
        t.isPopoverOpen && I(Nz, { id: t.popoverId, startDate: u.start, endDate: u.end, dateProfile: e.dateProfile, todayRange: e.todayRange, extraDateSpan: e.extraDateSpan, parentEl: this.parentEl, alignmentEl: e.alignmentElRef ? e.alignmentElRef.current : this.linkEl, alignGridTop: e.alignGridTop, forceTimed: e.forceTimed, onClose: this.handlePopoverClose }, e.popoverContent())
      );
    });
  }
  componentDidMount() {
    this.updateParentEl();
  }
  componentDidUpdate() {
    this.updateParentEl();
  }
  updateParentEl() {
    this.linkEl && (this.parentEl = Xi(this.linkEl, ".fc-view-harness"));
  }
}
function Pz(n) {
  return n.text;
}
function bS(n) {
  if (n.allDayDate)
    return {
      start: n.allDayDate,
      end: bn(n.allDayDate, 1)
    };
  let { hiddenSegs: e } = n;
  return {
    start: zT(e),
    end: Bz(e)
  };
}
function zT(n) {
  return n.reduce(Lz).eventRange.range.start;
}
function Lz(n, e) {
  return n.eventRange.range.start < e.eventRange.range.start ? n : e;
}
function Bz(n) {
  return n.reduce(jz).eventRange.range.end;
}
function jz(n, e) {
  return n.eventRange.range.end > e.eventRange.range.end ? n : e;
}
class Fz {
  constructor() {
    this.handlers = [];
  }
  set(e) {
    this.currentValue = e;
    for (let t of this.handlers)
      t(e);
  }
  subscribe(e) {
    this.handlers.push(e), this.currentValue !== void 0 && e(this.currentValue);
  }
}
class zz extends Fz {
  constructor() {
    super(...arguments), this.map = /* @__PURE__ */ new Map();
  }
  // for consistent order
  handle(e) {
    const { map: t } = this;
    let r = !1;
    e.isActive ? (t.set(e.id, e), r = !0) : t.has(e.id) && (t.delete(e.id), r = !0), r && this.set(t);
  }
}
const Vz = [], VT = {
  code: "en",
  week: {
    dow: 0,
    doy: 4
    // 4 days need to be within the year to be considered the first week
  },
  direction: "ltr",
  buttonText: {
    prev: "prev",
    next: "next",
    prevYear: "prev year",
    nextYear: "next year",
    year: "year",
    today: "today",
    month: "month",
    week: "week",
    day: "day",
    list: "list"
  },
  weekText: "W",
  weekTextLong: "Week",
  closeHint: "Close",
  timeHint: "Time",
  eventHint: "Event",
  allDayText: "all-day",
  moreLinkText: "more",
  noEventsText: "No events to display"
}, HT = Object.assign(Object.assign({}, VT), {
  // Includes things we don't want other locales to inherit,
  // things that derive from other translatable strings.
  buttonHints: {
    prev: "Previous $0",
    next: "Next $0",
    today(n, e) {
      return e === "day" ? "Today" : `This ${n}`;
    }
  },
  viewHint: "$0 view",
  navLinkHint: "Go to $0",
  moreLinkHint(n) {
    return `Show ${n} more event${n === 1 ? "" : "s"}`;
  }
});
function Hz(n) {
  let e = n.length > 0 ? n[0].code : "en", t = Vz.concat(n), r = {
    en: HT
  };
  for (let i of t)
    r[i.code] = i;
  return {
    map: r,
    defaultCode: e
  };
}
function UT(n, e) {
  return typeof n == "object" && !Array.isArray(n) ? WT(n.code, [n.code], n) : Uz(n, e);
}
function Uz(n, e) {
  let t = [].concat(n || []), r = Wz(t, e) || HT;
  return WT(n, t, r);
}
function Wz(n, e) {
  for (let t = 0; t < n.length; t += 1) {
    let r = n[t].toLocaleLowerCase().split("-");
    for (let i = r.length; i > 0; i -= 1) {
      let s = r.slice(0, i).join("-");
      if (e[s])
        return e[s];
    }
  }
  return null;
}
function WT(n, e, t) {
  let r = Ty([VT, t], ["buttonText"]);
  delete r.code;
  let { week: i } = r;
  return delete r.week, {
    codeArg: n,
    codes: e,
    week: i,
    simpleNumberFormat: new Intl.NumberFormat(n),
    options: r
  };
}
function eo(n) {
  return {
    id: Jo(),
    name: n.name,
    premiumReleaseDate: n.premiumReleaseDate ? new Date(n.premiumReleaseDate) : void 0,
    deps: n.deps || [],
    reducers: n.reducers || [],
    isLoadingFuncs: n.isLoadingFuncs || [],
    contextInit: [].concat(n.contextInit || []),
    eventRefiners: n.eventRefiners || {},
    eventDefMemberAdders: n.eventDefMemberAdders || [],
    eventSourceRefiners: n.eventSourceRefiners || {},
    isDraggableTransformers: n.isDraggableTransformers || [],
    eventDragMutationMassagers: n.eventDragMutationMassagers || [],
    eventDefMutationAppliers: n.eventDefMutationAppliers || [],
    dateSelectionTransformers: n.dateSelectionTransformers || [],
    datePointTransforms: n.datePointTransforms || [],
    dateSpanTransforms: n.dateSpanTransforms || [],
    views: n.views || {},
    viewPropsTransformers: n.viewPropsTransformers || [],
    isPropsValid: n.isPropsValid || null,
    externalDefTransforms: n.externalDefTransforms || [],
    viewContainerAppends: n.viewContainerAppends || [],
    eventDropTransformers: n.eventDropTransformers || [],
    componentInteractions: n.componentInteractions || [],
    calendarInteractions: n.calendarInteractions || [],
    themeClasses: n.themeClasses || {},
    eventSourceDefs: n.eventSourceDefs || [],
    cmdFormatter: n.cmdFormatter,
    recurringTypes: n.recurringTypes || [],
    namedTimeZonedImpl: n.namedTimeZonedImpl,
    initialView: n.initialView || "",
    elementDraggingImpl: n.elementDraggingImpl,
    optionChangeHandlers: n.optionChangeHandlers || {},
    scrollGridImpl: n.scrollGridImpl || null,
    listenerRefiners: n.listenerRefiners || {},
    optionRefiners: n.optionRefiners || {},
    propSetHandlers: n.propSetHandlers || {}
  };
}
function $z(n, e) {
  let t = {}, r = {
    premiumReleaseDate: void 0,
    reducers: [],
    isLoadingFuncs: [],
    contextInit: [],
    eventRefiners: {},
    eventDefMemberAdders: [],
    eventSourceRefiners: {},
    isDraggableTransformers: [],
    eventDragMutationMassagers: [],
    eventDefMutationAppliers: [],
    dateSelectionTransformers: [],
    datePointTransforms: [],
    dateSpanTransforms: [],
    views: {},
    viewPropsTransformers: [],
    isPropsValid: null,
    externalDefTransforms: [],
    viewContainerAppends: [],
    eventDropTransformers: [],
    componentInteractions: [],
    calendarInteractions: [],
    themeClasses: {},
    eventSourceDefs: [],
    cmdFormatter: null,
    recurringTypes: [],
    namedTimeZonedImpl: null,
    initialView: "",
    elementDraggingImpl: null,
    optionChangeHandlers: {},
    scrollGridImpl: null,
    listenerRefiners: {},
    optionRefiners: {},
    propSetHandlers: {}
  };
  function i(s) {
    for (let o of s) {
      const a = o.name, c = t[a];
      c === void 0 ? (t[a] = o.id, i(o.deps), r = Yz(r, o)) : c !== o.id && console.warn(`Duplicate plugin '${a}'`);
    }
  }
  return n && i(n), i(e), r;
}
function Gz() {
  let n = [], e = [], t;
  return (r, i) => ((!t || !Js(r, n) || !Js(i, e)) && (t = $z(r, i)), n = r, e = i, t);
}
function Yz(n, e) {
  return {
    premiumReleaseDate: qz(n.premiumReleaseDate, e.premiumReleaseDate),
    reducers: n.reducers.concat(e.reducers),
    isLoadingFuncs: n.isLoadingFuncs.concat(e.isLoadingFuncs),
    contextInit: n.contextInit.concat(e.contextInit),
    eventRefiners: Object.assign(Object.assign({}, n.eventRefiners), e.eventRefiners),
    eventDefMemberAdders: n.eventDefMemberAdders.concat(e.eventDefMemberAdders),
    eventSourceRefiners: Object.assign(Object.assign({}, n.eventSourceRefiners), e.eventSourceRefiners),
    isDraggableTransformers: n.isDraggableTransformers.concat(e.isDraggableTransformers),
    eventDragMutationMassagers: n.eventDragMutationMassagers.concat(e.eventDragMutationMassagers),
    eventDefMutationAppliers: n.eventDefMutationAppliers.concat(e.eventDefMutationAppliers),
    dateSelectionTransformers: n.dateSelectionTransformers.concat(e.dateSelectionTransformers),
    datePointTransforms: n.datePointTransforms.concat(e.datePointTransforms),
    dateSpanTransforms: n.dateSpanTransforms.concat(e.dateSpanTransforms),
    views: Object.assign(Object.assign({}, n.views), e.views),
    viewPropsTransformers: n.viewPropsTransformers.concat(e.viewPropsTransformers),
    isPropsValid: e.isPropsValid || n.isPropsValid,
    externalDefTransforms: n.externalDefTransforms.concat(e.externalDefTransforms),
    viewContainerAppends: n.viewContainerAppends.concat(e.viewContainerAppends),
    eventDropTransformers: n.eventDropTransformers.concat(e.eventDropTransformers),
    calendarInteractions: n.calendarInteractions.concat(e.calendarInteractions),
    componentInteractions: n.componentInteractions.concat(e.componentInteractions),
    themeClasses: Object.assign(Object.assign({}, n.themeClasses), e.themeClasses),
    eventSourceDefs: n.eventSourceDefs.concat(e.eventSourceDefs),
    cmdFormatter: e.cmdFormatter || n.cmdFormatter,
    recurringTypes: n.recurringTypes.concat(e.recurringTypes),
    namedTimeZonedImpl: e.namedTimeZonedImpl || n.namedTimeZonedImpl,
    initialView: n.initialView || e.initialView,
    elementDraggingImpl: n.elementDraggingImpl || e.elementDraggingImpl,
    optionChangeHandlers: Object.assign(Object.assign({}, n.optionChangeHandlers), e.optionChangeHandlers),
    scrollGridImpl: e.scrollGridImpl || n.scrollGridImpl,
    listenerRefiners: Object.assign(Object.assign({}, n.listenerRefiners), e.listenerRefiners),
    optionRefiners: Object.assign(Object.assign({}, n.optionRefiners), e.optionRefiners),
    propSetHandlers: Object.assign(Object.assign({}, n.propSetHandlers), e.propSetHandlers)
  };
}
function qz(n, e) {
  return n === void 0 ? e : e === void 0 ? n : new Date(Math.max(n.valueOf(), e.valueOf()));
}
class to extends Fc {
}
to.prototype.classes = {
  root: "fc-theme-standard",
  tableCellShaded: "fc-cell-shaded",
  buttonGroup: "fc-button-group",
  button: "fc-button fc-button-primary",
  buttonActive: "fc-button-active"
};
to.prototype.baseIconClass = "fc-icon";
to.prototype.iconClasses = {
  close: "fc-icon-x",
  prev: "fc-icon-chevron-left",
  next: "fc-icon-chevron-right",
  prevYear: "fc-icon-chevrons-left",
  nextYear: "fc-icon-chevrons-right"
};
to.prototype.rtlIconClasses = {
  prev: "fc-icon-chevron-right",
  next: "fc-icon-chevron-left",
  prevYear: "fc-icon-chevrons-right",
  nextYear: "fc-icon-chevrons-left"
};
to.prototype.iconOverrideOption = "buttonIcons";
to.prototype.iconOverrideCustomButtonOption = "icon";
to.prototype.iconOverridePrefix = "fc-icon-";
function Kz(n, e) {
  let t = {}, r;
  for (r in n)
    og(r, t, n, e);
  for (r in e)
    og(r, t, n, e);
  return t;
}
function og(n, e, t, r) {
  if (e[n])
    return e[n];
  let i = Jz(n, e, t, r);
  return i && (e[n] = i), i;
}
function Jz(n, e, t, r) {
  let i = t[n], s = r[n], o = (d) => i && i[d] !== null ? i[d] : s && s[d] !== null ? s[d] : null, a = o("component"), c = o("superType"), u = null;
  if (c) {
    if (c === n)
      throw new Error("Can't have a custom view type that references itself");
    u = og(c, e, t, r);
  }
  return !a && u && (a = u.component), a ? {
    type: n,
    component: a,
    defaults: Object.assign(Object.assign({}, u ? u.defaults : {}), i ? i.rawOptions : {}),
    overrides: Object.assign(Object.assign({}, u ? u.overrides : {}), s ? s.rawOptions : {})
  } : null;
}
function xS(n) {
  return Ho(n, Qz);
}
function Qz(n) {
  let e = typeof n == "function" ? { component: n } : n, { component: t } = e;
  return e.content ? t = SS(e) : t && !(t.prototype instanceof gt) && (t = SS(Object.assign(Object.assign({}, e), { content: t }))), {
    superType: e.type,
    component: t,
    rawOptions: e
    // includes type and component too :(
  };
}
function SS(n) {
  return (e) => I(ms.Consumer, null, (t) => I(Mr, { elTag: "div", elClasses: rT(t.viewSpec), renderProps: Object.assign(Object.assign({}, e), { nextDayThreshold: t.options.nextDayThreshold }), generatorName: void 0, customGenerator: n.content, classNameGenerator: n.classNames, didMount: n.didMount, willUnmount: n.willUnmount }));
}
function Zz(n, e, t, r) {
  let i = xS(n), s = xS(e.views), o = Kz(i, s);
  return Ho(o, (a) => Xz(a, s, e, t, r));
}
function Xz(n, e, t, r, i) {
  let s = n.overrides.duration || n.defaults.duration || r.duration || t.duration, o = null, a = "", c = "", u = {};
  if (s && (o = eV(s), o)) {
    let p = Zm(o);
    a = p.unit, p.value === 1 && (c = a, u = e[a] ? e[a].rawOptions : {});
  }
  let d = (p) => {
    let g = p.buttonText || {}, y = n.defaults.buttonTextKey;
    return y != null && g[y] != null ? g[y] : g[n.type] != null ? g[n.type] : g[c] != null ? g[c] : null;
  }, h = (p) => {
    let g = p.buttonHints || {}, y = n.defaults.buttonTextKey;
    return y != null && g[y] != null ? g[y] : g[n.type] != null ? g[n.type] : g[c] != null ? g[c] : null;
  };
  return {
    type: n.type,
    component: n.component,
    duration: o,
    durationUnit: a,
    singleUnit: c,
    optionDefaults: n.defaults,
    optionOverrides: Object.assign(Object.assign({}, u), n.overrides),
    buttonTextOverride: d(r) || d(t) || // constructor-specified buttonText lookup hash takes precedence
    n.overrides.buttonText,
    buttonTextDefault: d(i) || n.defaults.buttonText || d(ql) || n.type,
    // not DRY
    buttonTitleOverride: h(r) || h(t) || n.overrides.buttonHint,
    buttonTitleDefault: h(i) || n.defaults.buttonHint || h(ql)
    // will eventually fall back to buttonText
  };
}
let wS = {};
function eV(n) {
  let e = JSON.stringify(n), t = wS[e];
  return t === void 0 && (t = lt(n), wS[e] = t), t;
}
function tV(n, e) {
  switch (e.type) {
    case "CHANGE_VIEW_TYPE":
      n = e.viewType;
  }
  return n;
}
function nV(n, e) {
  switch (e.type) {
    case "CHANGE_DATE":
      return e.dateMarker;
    default:
      return n;
  }
}
function rV(n, e, t) {
  let r = n.initialDate;
  return r != null ? e.createMarker(r) : t.getDateMarker();
}
function iV(n, e) {
  switch (e.type) {
    case "SET_OPTION":
      return Object.assign(Object.assign({}, n), { [e.optionName]: e.rawOptionValue });
    default:
      return n;
  }
}
function sV(n, e, t, r) {
  let i;
  switch (e.type) {
    case "CHANGE_VIEW_TYPE":
      return r.build(e.dateMarker || t);
    case "CHANGE_DATE":
      return r.build(e.dateMarker);
    case "PREV":
      if (i = r.buildPrev(n, t), i.isValid)
        return i;
      break;
    case "NEXT":
      if (i = r.buildNext(n, t), i.isValid)
        return i;
      break;
  }
  return n;
}
function oV(n, e, t) {
  let r = e ? e.activeRange : null;
  return GT({}, hV(n, t), r, t);
}
function aV(n, e, t, r) {
  let i = t ? t.activeRange : null;
  switch (e.type) {
    case "ADD_EVENT_SOURCES":
      return GT(n, e.sources, i, r);
    case "REMOVE_EVENT_SOURCE":
      return cV(n, e.sourceId);
    case "PREV":
    case "NEXT":
    case "CHANGE_DATE":
    case "CHANGE_VIEW_TYPE":
      return t ? YT(n, i, r) : n;
    case "FETCH_EVENT_SOURCES":
      return Vy(n, e.sourceIds ? (
        // why no type?
        Z1(e.sourceIds)
      ) : qT(n, r), i, e.isRefetch || !1, r);
    case "RECEIVE_EVENTS":
    case "RECEIVE_EVENT_ERROR":
      return fV(n, e.sourceId, e.fetchId, e.fetchRange);
    case "REMOVE_ALL_EVENT_SOURCES":
      return {};
    default:
      return n;
  }
}
function lV(n, e, t) {
  let r = e ? e.activeRange : null;
  return Vy(n, qT(n, t), r, !0, t);
}
function $T(n) {
  for (let e in n)
    if (n[e].isFetching)
      return !0;
  return !1;
}
function GT(n, e, t, r) {
  let i = {};
  for (let s of e)
    i[s.sourceId] = s;
  return t && (i = YT(i, t, r)), Object.assign(Object.assign({}, n), i);
}
function cV(n, e) {
  return qa(n, (t) => t.sourceId !== e);
}
function YT(n, e, t) {
  return Vy(n, qa(n, (r) => uV(r, e, t)), e, !1, t);
}
function uV(n, e, t) {
  return KT(n, t) ? !t.options.lazyFetching || !n.fetchRange || n.isFetching || // always cancel outdated in-progress fetches
  e.start < n.fetchRange.start || e.end > n.fetchRange.end : !n.latestFetchId;
}
function Vy(n, e, t, r, i) {
  let s = {};
  for (let o in n) {
    let a = n[o];
    e[o] ? s[o] = dV(a, t, r, i) : s[o] = a;
  }
  return s;
}
function dV(n, e, t, r) {
  let { options: i, calendarApi: s } = r, o = r.pluginHooks.eventSourceDefs[n.sourceDefId], a = Jo();
  return o.fetch({
    eventSource: n,
    range: e,
    isRefetch: t,
    context: r
  }, (c) => {
    let { rawEvents: u } = c;
    i.eventSourceSuccess && (u = i.eventSourceSuccess.call(s, u, c.response) || u), n.success && (u = n.success.call(s, u, c.response) || u), r.dispatch({
      type: "RECEIVE_EVENTS",
      sourceId: n.sourceId,
      fetchId: a,
      fetchRange: e,
      rawEvents: u
    });
  }, (c) => {
    let u = !1;
    i.eventSourceFailure && (i.eventSourceFailure.call(s, c), u = !0), n.failure && (n.failure(c), u = !0), u || console.warn(c.message, c), r.dispatch({
      type: "RECEIVE_EVENT_ERROR",
      sourceId: n.sourceId,
      fetchId: a,
      fetchRange: e,
      error: c
    });
  }), Object.assign(Object.assign({}, n), { isFetching: !0, latestFetchId: a });
}
function fV(n, e, t, r) {
  let i = n[e];
  return i && // not already removed
  t === i.latestFetchId ? Object.assign(Object.assign({}, n), { [e]: Object.assign(Object.assign({}, i), { isFetching: !1, fetchRange: r }) }) : n;
}
function qT(n, e) {
  return qa(n, (t) => KT(t, e));
}
function hV(n, e) {
  let t = fT(e), r = [].concat(n.eventSources || []), i = [];
  n.initialEvents && r.unshift(n.initialEvents), n.events && r.unshift(n.events);
  for (let s of r) {
    let o = dT(s, e, t);
    o && i.push(o);
  }
  return i;
}
function KT(n, e) {
  return !e.pluginHooks.eventSourceDefs[n.sourceDefId].ignoreRange;
}
function pV(n, e) {
  switch (e.type) {
    case "UNSELECT_DATES":
      return null;
    case "SELECT_DATES":
      return e.selection;
    default:
      return n;
  }
}
function mV(n, e) {
  switch (e.type) {
    case "UNSELECT_EVENT":
      return "";
    case "SELECT_EVENT":
      return e.eventInstanceId;
    default:
      return n;
  }
}
function gV(n, e) {
  let t;
  switch (e.type) {
    case "UNSET_EVENT_DRAG":
      return null;
    case "SET_EVENT_DRAG":
      return t = e.state, {
        affectedEvents: t.affectedEvents,
        mutatedEvents: t.mutatedEvents,
        isEvent: t.isEvent
      };
    default:
      return n;
  }
}
function yV(n, e) {
  let t;
  switch (e.type) {
    case "UNSET_EVENT_RESIZE":
      return null;
    case "SET_EVENT_RESIZE":
      return t = e.state, {
        affectedEvents: t.affectedEvents,
        mutatedEvents: t.mutatedEvents,
        isEvent: t.isEvent
      };
    default:
      return n;
  }
}
function vV(n, e, t, r, i) {
  let s = n.headerToolbar ? ES(n.headerToolbar, n, e, t, r, i) : null, o = n.footerToolbar ? ES(n.footerToolbar, n, e, t, r, i) : null;
  return { header: s, footer: o };
}
function ES(n, e, t, r, i, s) {
  let o = {}, a = [], c = !1;
  for (let u in n) {
    let d = n[u], h = bV(d, e, t, r, i, s);
    o[u] = h.widgets, a.push(...h.viewsWithButtons), c = c || h.hasTitle;
  }
  return { sectionWidgets: o, viewsWithButtons: a, hasTitle: c };
}
function bV(n, e, t, r, i, s) {
  let o = e.direction === "rtl", a = e.customButtons || {}, c = t.buttonText || {}, u = e.buttonText || {}, d = t.buttonHints || {}, h = e.buttonHints || {}, p = n ? n.split(" ") : [], g = [], y = !1;
  return { widgets: p.map((S) => S.split(",").map((w) => {
    if (w === "title")
      return y = !0, { buttonName: w };
    let T, C, k, R, N, L;
    if (T = a[w])
      k = (j) => {
        T.click && T.click.call(j.target, j, j.target);
      }, (R = r.getCustomButtonIconClass(T)) || (R = r.getIconClass(w, o)) || (N = T.text), L = T.hint || T.text;
    else if (C = i[w]) {
      g.push(w), k = () => {
        s.changeView(w);
      }, (N = C.buttonTextOverride) || (R = r.getIconClass(w, o)) || (N = C.buttonTextDefault);
      let j = C.buttonTextOverride || C.buttonTextDefault;
      L = Yl(
        C.buttonTitleOverride || C.buttonTitleDefault || e.viewHint,
        [j, w],
        // view-name = buttonName
        j
      );
    } else if (s[w])
      if (k = () => {
        s[w]();
      }, (N = c[w]) || (R = r.getIconClass(w, o)) || (N = u[w]), w === "prevYear" || w === "nextYear") {
        let j = w === "prevYear" ? "prev" : "next";
        L = Yl(d[j] || h[j], [
          u.year || "year",
          "year"
        ], u[w]);
      } else
        L = (j) => Yl(d[w] || h[w], [
          u[j] || j,
          j
        ], u[w]);
    return { buttonName: w, buttonClick: k, buttonIcon: R, buttonText: N, buttonHint: L };
  })), viewsWithButtons: g, hasTitle: y };
}
class xV {
  constructor(e, t, r) {
    this.type = e, this.getCurrentData = t, this.dateEnv = r;
  }
  get calendar() {
    return this.getCurrentData().calendarApi;
  }
  get title() {
    return this.getCurrentData().viewTitle;
  }
  get activeStart() {
    return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
  }
  get activeEnd() {
    return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
  }
  get currentStart() {
    return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
  }
  get currentEnd() {
    return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
  }
  getOption(e) {
    return this.getCurrentData().options[e];
  }
}
let SV = {
  ignoreRange: !0,
  parseMeta(n) {
    return Array.isArray(n.events) ? n.events : null;
  },
  fetch(n, e) {
    e({
      rawEvents: n.eventSource.meta
    });
  }
};
const wV = eo({
  name: "array-event-source",
  eventSourceDefs: [SV]
});
let EV = {
  parseMeta(n) {
    return typeof n.events == "function" ? n.events : null;
  },
  fetch(n, e, t) {
    const { dateEnv: r } = n.context, i = n.eventSource.meta;
    YF(i.bind(null, wT(n.range, r)), (s) => e({ rawEvents: s }), t);
  }
};
const AV = eo({
  name: "func-event-source",
  eventSourceDefs: [EV]
}), TV = {
  method: String,
  extraParams: $,
  startParam: String,
  endParam: String,
  timeZoneParam: String
};
let CV = {
  parseMeta(n) {
    return n.url && (n.format === "json" || !n.format) ? {
      url: n.url,
      format: "json",
      method: (n.method || "GET").toUpperCase(),
      extraParams: n.extraParams,
      startParam: n.startParam,
      endParam: n.endParam,
      timeZoneParam: n.timeZoneParam
    } : null;
  },
  fetch(n, e, t) {
    const { meta: r } = n.eventSource, i = RV(r, n.range, n.context);
    qF(r.method, r.url, i).then(([s, o]) => {
      e({ rawEvents: s, response: o });
    }, t);
  }
};
const DV = eo({
  name: "json-event-source",
  eventSourceRefiners: TV,
  eventSourceDefs: [CV]
});
function RV(n, e, t) {
  let { dateEnv: r, options: i } = t, s, o, a, c, u = {};
  return s = n.startParam, s == null && (s = i.startParam), o = n.endParam, o == null && (o = i.endParam), a = n.timeZoneParam, a == null && (a = i.timeZoneParam), typeof n.extraParams == "function" ? c = n.extraParams() : c = n.extraParams || {}, Object.assign(u, c), u[s] = r.formatIso(e.start), u[o] = r.formatIso(e.end), r.timeZone !== "local" && (u[a] = r.timeZone), u;
}
const kV = {
  daysOfWeek: $,
  startTime: lt,
  endTime: lt,
  duration: lt,
  startRecur: $,
  endRecur: $
};
let MV = {
  parse(n, e) {
    if (n.daysOfWeek || n.startTime || n.endTime || n.startRecur || n.endRecur) {
      let t = {
        daysOfWeek: n.daysOfWeek || null,
        startTime: n.startTime || null,
        endTime: n.endTime || null,
        startRecur: n.startRecur ? e.createMarker(n.startRecur) : null,
        endRecur: n.endRecur ? e.createMarker(n.endRecur) : null,
        dateEnv: e
      }, r;
      return n.duration && (r = n.duration), !r && n.startTime && n.endTime && (r = rj(n.endTime, n.startTime)), {
        allDayGuess: !n.startTime && !n.endTime,
        duration: r,
        typeData: t
        // doesn't need endTime anymore but oh well
      };
    }
    return null;
  },
  expand(n, e, t) {
    let r = Uo(e, { start: n.startRecur, end: n.endRecur });
    return r ? OV(n.daysOfWeek, n.startTime, n.dateEnv, t, r) : [];
  }
};
const _V = eo({
  name: "simple-recurring-event",
  recurringTypes: [MV],
  eventRefiners: kV
});
function OV(n, e, t, r, i) {
  let s = n ? Z1(n) : null, o = Ot(i.start), a = i.end, c = [];
  for (e && (e.milliseconds < 0 ? a = bn(a, 1) : e.milliseconds >= 1e3 * 60 * 60 * 24 && (o = bn(o, -1))); o < a; ) {
    let u;
    (!s || s[o.getUTCDay()]) && (e ? u = r.add(o, e) : u = o, c.push(r.createMarker(t.toDate(u)))), o = bn(o, 1);
  }
  return c;
}
const IV = eo({
  name: "change-handler",
  optionChangeHandlers: {
    events(n, e) {
      AS([n], e);
    },
    eventSources: AS
  }
});
function AS(n, e) {
  let t = Cy(e.getCurrentData().eventSources);
  if (t.length === 1 && n.length === 1 && Array.isArray(t[0]._raw) && Array.isArray(n[0])) {
    e.dispatch({
      type: "RESET_RAW_EVENTS",
      sourceId: t[0].sourceId,
      rawEvents: n[0]
    });
    return;
  }
  let r = [];
  for (let i of n) {
    let s = !1;
    for (let o = 0; o < t.length; o += 1)
      if (t[o]._raw === i) {
        t.splice(o, 1), s = !0;
        break;
      }
    s || r.push(i);
  }
  for (let i of t)
    e.dispatch({
      type: "REMOVE_EVENT_SOURCE",
      sourceId: i.sourceId
    });
  for (let i of r)
    e.calendarApi.addEventSource(i);
}
function NV(n, e) {
  e.emitter.trigger("datesSet", Object.assign(Object.assign({}, wT(n.activeRange, e.dateEnv)), { view: e.viewApi }));
}
function PV(n, e) {
  let { emitter: t } = e;
  t.hasHandlers("eventsSet") && t.trigger("eventsSet", Oy(n, e));
}
const LV = [
  wV,
  AV,
  DV,
  _V,
  IV,
  eo({
    name: "misc",
    isLoadingFuncs: [
      (n) => $T(n.eventSources)
    ],
    propSetHandlers: {
      dateProfile: NV,
      eventStore: PV
    }
  })
];
class BV {
  constructor(e, t) {
    this.runTaskOption = e, this.drainedOption = t, this.queue = [], this.delayedRunner = new xy(this.drain.bind(this));
  }
  request(e, t) {
    this.queue.push(e), this.delayedRunner.request(t);
  }
  pause(e) {
    this.delayedRunner.pause(e);
  }
  resume(e, t) {
    this.delayedRunner.resume(e, t);
  }
  drain() {
    let { queue: e } = this;
    for (; e.length; ) {
      let t = [], r;
      for (; r = e.shift(); )
        this.runTask(r), t.push(r);
      this.drained(t);
    }
  }
  runTask(e) {
    this.runTaskOption && this.runTaskOption(e);
  }
  drained(e) {
    this.drainedOption && this.drainedOption(e);
  }
}
function jV(n, e, t) {
  let r;
  return /^(year|month)$/.test(n.currentRangeUnit) ? r = n.currentRange : r = n.activeRange, t.formatRange(r.start, r.end, $t(e.titleFormat || FV(n)), {
    isEndExclusive: n.isRangeAllDay,
    defaultSeparator: e.titleRangeSeparator
  });
}
function FV(n) {
  let { currentRangeUnit: e } = n;
  if (e === "year")
    return { year: "numeric" };
  if (e === "month")
    return { year: "numeric", month: "long" };
  let t = Id(n.currentRange.start, n.currentRange.end);
  return t !== null && t > 1 ? { year: "numeric", month: "short", day: "numeric" } : { year: "numeric", month: "long", day: "numeric" };
}
class TS {
  constructor() {
    this.resetListeners = /* @__PURE__ */ new Set();
  }
  handleInput(e, t) {
    const r = this.dateEnv;
    if (e !== r && (typeof t == "function" ? this.nowFn = t : r || (this.nowAnchorDate = e.toDate(t ? e.createMarker(t) : e.createNowMarker()), this.nowAnchorQueried = Date.now()), this.dateEnv = e, r))
      for (const i of this.resetListeners.values())
        i();
  }
  getDateMarker() {
    return this.nowAnchorDate ? this.dateEnv.timestampToMarker(this.nowAnchorDate.valueOf() + (Date.now() - this.nowAnchorQueried)) : this.dateEnv.createMarker(this.nowFn());
  }
  addResetListener(e) {
    this.resetListeners.add(e);
  }
  removeResetListener(e) {
    this.resetListeners.delete(e);
  }
}
class zV {
  constructor(e) {
    this.computeCurrentViewData = Pe(this._computeCurrentViewData), this.organizeRawLocales = Pe(Hz), this.buildLocale = Pe(UT), this.buildPluginHooks = Gz(), this.buildDateEnv = Pe(VV), this.buildTheme = Pe(HV), this.parseToolbars = Pe(vV), this.buildViewSpecs = Pe(Zz), this.buildDateProfileGenerator = gd(UV), this.buildViewApi = Pe(WV), this.buildViewUiProps = gd(YV), this.buildEventUiBySource = Pe($V, pi), this.buildEventUiBases = Pe(GV), this.parseContextBusinessHours = gd(qV), this.buildTitle = Pe(jV), this.nowManager = new TS(), this.emitter = new AF(), this.actionRunner = new BV(this._handleAction.bind(this), this.updateData.bind(this)), this.currentCalendarOptionsInput = {}, this.currentCalendarOptionsRefined = {}, this.currentViewOptionsInput = {}, this.currentViewOptionsRefined = {}, this.currentCalendarOptionsRefiners = {}, this.optionsForRefining = [], this.optionsForHandling = [], this.getCurrentData = () => this.data, this.dispatch = (p) => {
      this.actionRunner.request(p);
    }, this.props = e, this.actionRunner.pause(), this.nowManager = new TS();
    let t = {}, r = this.computeOptionsData(e.optionOverrides, t, e.calendarApi), i = r.calendarOptions.initialView || r.pluginHooks.initialView, s = this.computeCurrentViewData(i, r, e.optionOverrides, t);
    e.calendarApi.currentDataManager = this, this.emitter.setThisContext(e.calendarApi), this.emitter.setOptions(s.options);
    let o = {
      nowManager: this.nowManager,
      dateEnv: r.dateEnv,
      options: r.calendarOptions,
      pluginHooks: r.pluginHooks,
      calendarApi: e.calendarApi,
      dispatch: this.dispatch,
      emitter: this.emitter,
      getCurrentData: this.getCurrentData
    }, a = rV(r.calendarOptions, r.dateEnv, this.nowManager), c = s.dateProfileGenerator.build(a);
    ns(c.activeRange, a) || (a = c.currentRange.start);
    for (let p of r.pluginHooks.contextInit)
      p(o);
    let u = oV(r.calendarOptions, c, o), d = {
      dynamicOptionOverrides: t,
      currentViewType: i,
      currentDate: a,
      dateProfile: c,
      businessHours: this.parseContextBusinessHours(o),
      eventSources: u,
      eventUiBases: {},
      eventStore: as(),
      renderableEventStore: as(),
      dateSelection: null,
      eventSelection: "",
      eventDrag: null,
      eventResize: null,
      selectionConfig: this.buildViewUiProps(o).selectionConfig
    }, h = Object.assign(Object.assign({}, o), d);
    for (let p of r.pluginHooks.reducers)
      Object.assign(d, p(null, null, h));
    jp(d, o) && this.emitter.trigger("loading", !0), this.state = d, this.updateData(), this.actionRunner.resume();
  }
  resetOptions(e, t) {
    let { props: r } = this;
    t === void 0 ? r.optionOverrides = e : (r.optionOverrides = Object.assign(Object.assign({}, r.optionOverrides || {}), e), this.optionsForRefining.push(...t)), (t === void 0 || t.length) && this.actionRunner.request({
      type: "NOTHING"
    });
  }
  _handleAction(e) {
    let { props: t, state: r, emitter: i } = this, s = iV(r.dynamicOptionOverrides, e), o = this.computeOptionsData(t.optionOverrides, s, t.calendarApi), a = tV(r.currentViewType, e), c = this.computeCurrentViewData(a, o, t.optionOverrides, s);
    t.calendarApi.currentDataManager = this, i.setThisContext(t.calendarApi), i.setOptions(c.options);
    let u = {
      nowManager: this.nowManager,
      dateEnv: o.dateEnv,
      options: o.calendarOptions,
      pluginHooks: o.pluginHooks,
      calendarApi: t.calendarApi,
      dispatch: this.dispatch,
      emitter: i,
      getCurrentData: this.getCurrentData
    }, { currentDate: d, dateProfile: h } = r;
    this.data && this.data.dateProfileGenerator !== c.dateProfileGenerator && (h = c.dateProfileGenerator.build(d)), d = nV(d, e), h = sV(h, e, d, c.dateProfileGenerator), (e.type === "PREV" || // TODO: move this logic into DateProfileGenerator
    e.type === "NEXT" || // "
    !ns(h.currentRange, d)) && (d = h.currentRange.start);
    let p = aV(r.eventSources, e, h, u), g = bF(r.eventStore, e, p, h, u), b = $T(p) && !c.options.progressiveEventRendering && r.renderableEventStore || g, { eventUiSingleBase: S, selectionConfig: w } = this.buildViewUiProps(u), T = this.buildEventUiBySource(p), C = this.buildEventUiBases(b.defs, S, T), k = {
      dynamicOptionOverrides: s,
      currentViewType: a,
      currentDate: d,
      dateProfile: h,
      eventSources: p,
      eventStore: g,
      renderableEventStore: b,
      selectionConfig: w,
      eventUiBases: C,
      businessHours: this.parseContextBusinessHours(u),
      dateSelection: pV(r.dateSelection, e),
      eventSelection: mV(r.eventSelection, e),
      eventDrag: gV(r.eventDrag, e),
      eventResize: yV(r.eventResize, e)
    }, R = Object.assign(Object.assign({}, u), k);
    for (let j of o.pluginHooks.reducers)
      Object.assign(k, j(r, e, R));
    let N = jp(r, u), L = jp(k, u);
    !N && L ? i.trigger("loading", !0) : N && !L && i.trigger("loading", !1), this.state = k, t.onAction && t.onAction(e);
  }
  updateData() {
    let { props: e, state: t } = this, r = this.data, i = this.computeOptionsData(e.optionOverrides, t.dynamicOptionOverrides, e.calendarApi), s = this.computeCurrentViewData(t.currentViewType, i, e.optionOverrides, t.dynamicOptionOverrides), o = this.data = Object.assign(Object.assign(Object.assign({ nowManager: this.nowManager, viewTitle: this.buildTitle(t.dateProfile, s.options, i.dateEnv), calendarApi: e.calendarApi, dispatch: this.dispatch, emitter: this.emitter, getCurrentData: this.getCurrentData }, i), s), t), a = i.pluginHooks.optionChangeHandlers, c = r && r.calendarOptions, u = i.calendarOptions;
    if (c && c !== u) {
      c.timeZone !== u.timeZone && (t.eventSources = o.eventSources = lV(o.eventSources, t.dateProfile, o), t.eventStore = o.eventStore = hS(o.eventStore, r.dateEnv, o.dateEnv), t.renderableEventStore = o.renderableEventStore = hS(o.renderableEventStore, r.dateEnv, o.dateEnv));
      for (let d in a)
        (this.optionsForHandling.indexOf(d) !== -1 || c[d] !== u[d]) && a[d](u[d], o);
    }
    this.optionsForHandling = [], e.onData && e.onData(o);
  }
  computeOptionsData(e, t, r) {
    if (!this.optionsForRefining.length && e === this.stableOptionOverrides && t === this.stableDynamicOptionOverrides)
      return this.stableCalendarOptionsData;
    let { refinedOptions: i, pluginHooks: s, localeDefaults: o, availableLocaleData: a, extra: c } = this.processRawCalendarOptions(e, t);
    CS(c);
    let u = this.buildDateEnv(i.timeZone, i.locale, i.weekNumberCalculation, i.firstDay, i.weekText, s, a, i.defaultRangeSeparator), d = this.buildViewSpecs(s.views, this.stableOptionOverrides, this.stableDynamicOptionOverrides, o), h = this.buildTheme(i, s), p = this.parseToolbars(i, this.stableOptionOverrides, h, d, r);
    return this.stableCalendarOptionsData = {
      calendarOptions: i,
      pluginHooks: s,
      dateEnv: u,
      viewSpecs: d,
      theme: h,
      toolbarConfig: p,
      localeDefaults: o,
      availableRawLocales: a.map
    };
  }
  // always called from behind a memoizer
  processRawCalendarOptions(e, t) {
    let { locales: r, locale: i } = _p([
      ql,
      e,
      t
    ]), s = this.organizeRawLocales(r), o = s.map, a = this.buildLocale(i || s.defaultCode, o).options, c = this.buildPluginHooks(e.plugins || [], LV), u = this.currentCalendarOptionsRefiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, aS), lS), cS), c.listenerRefiners), c.optionRefiners), d = {}, h = _p([
      ql,
      a,
      e,
      t
    ]), p = {}, g = this.currentCalendarOptionsInput, y = this.currentCalendarOptionsRefined, b = !1;
    for (let S in h)
      this.optionsForRefining.indexOf(S) === -1 && (h[S] === g[S] || wo[S] && S in g && wo[S](g[S], h[S])) ? p[S] = y[S] : u[S] ? (p[S] = u[S](h[S]), b = !0) : d[S] = g[S];
    return b && (this.currentCalendarOptionsInput = h, this.currentCalendarOptionsRefined = p, this.stableOptionOverrides = e, this.stableDynamicOptionOverrides = t), this.optionsForHandling.push(...this.optionsForRefining), this.optionsForRefining = [], {
      rawOptions: this.currentCalendarOptionsInput,
      refinedOptions: this.currentCalendarOptionsRefined,
      pluginHooks: c,
      availableLocaleData: s,
      localeDefaults: a,
      extra: d
    };
  }
  _computeCurrentViewData(e, t, r, i) {
    let s = t.viewSpecs[e];
    if (!s)
      throw new Error(`viewType "${e}" is not available. Please make sure you've loaded all neccessary plugins`);
    let { refinedOptions: o, extra: a } = this.processRawViewOptions(s, t.pluginHooks, t.localeDefaults, r, i);
    CS(a), this.nowManager.handleInput(t.dateEnv, o.now);
    let c = this.buildDateProfileGenerator({
      dateProfileGeneratorClass: s.optionDefaults.dateProfileGeneratorClass,
      nowManager: this.nowManager,
      duration: s.duration,
      durationUnit: s.durationUnit,
      usesMinMaxTime: s.optionDefaults.usesMinMaxTime,
      dateEnv: t.dateEnv,
      calendarApi: this.props.calendarApi,
      slotMinTime: o.slotMinTime,
      slotMaxTime: o.slotMaxTime,
      showNonCurrentDates: o.showNonCurrentDates,
      dayCount: o.dayCount,
      dateAlignment: o.dateAlignment,
      dateIncrement: o.dateIncrement,
      hiddenDays: o.hiddenDays,
      weekends: o.weekends,
      validRangeInput: o.validRange,
      visibleRangeInput: o.visibleRange,
      fixedWeekCount: o.fixedWeekCount
    }), u = this.buildViewApi(e, this.getCurrentData, t.dateEnv);
    return { viewSpec: s, options: o, dateProfileGenerator: c, viewApi: u };
  }
  processRawViewOptions(e, t, r, i, s) {
    let o = _p([
      ql,
      e.optionDefaults,
      r,
      i,
      e.optionOverrides,
      s
    ]), a = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, aS), lS), cS), Lj), t.listenerRefiners), t.optionRefiners), c = {}, u = this.currentViewOptionsInput, d = this.currentViewOptionsRefined, h = !1, p = {};
    for (let g in o)
      o[g] === u[g] || wo[g] && wo[g](o[g], u[g]) ? c[g] = d[g] : (o[g] === this.currentCalendarOptionsInput[g] || wo[g] && wo[g](o[g], this.currentCalendarOptionsInput[g]) ? g in this.currentCalendarOptionsRefined && (c[g] = this.currentCalendarOptionsRefined[g]) : a[g] ? c[g] = a[g](o[g]) : p[g] = o[g], h = !0);
    return h && (this.currentViewOptionsInput = o, this.currentViewOptionsRefined = c), {
      rawOptions: this.currentViewOptionsInput,
      refinedOptions: this.currentViewOptionsRefined,
      extra: p
    };
  }
}
function VV(n, e, t, r, i, s, o, a) {
  let c = UT(e || o.defaultCode, o.map);
  return new Yj({
    calendarSystem: "gregory",
    timeZone: n,
    namedTimeZoneImpl: s.namedTimeZonedImpl,
    locale: c,
    weekNumberCalculation: t,
    firstDay: r,
    weekText: i,
    cmdFormatter: s.cmdFormatter,
    defaultSeparator: a
  });
}
function HV(n, e) {
  let t = e.themeClasses[n.themeSystem] || to;
  return new t(n);
}
function UV(n) {
  let e = n.dateProfileGeneratorClass || oT;
  return new e(n);
}
function WV(n, e, t) {
  return new xV(n, e, t);
}
function $V(n) {
  return Ho(n, (e) => e.ui);
}
function GV(n, e, t) {
  let r = { "": e };
  for (let i in n) {
    let s = n[i];
    s.sourceId && t[s.sourceId] && (r[i] = t[s.sourceId]);
  }
  return r;
}
function YV(n) {
  let { options: e } = n;
  return {
    eventUiSingleBase: zd({
      display: e.eventDisplay,
      editable: e.editable,
      startEditable: e.eventStartEditable,
      durationEditable: e.eventDurationEditable,
      constraint: e.eventConstraint,
      overlap: typeof e.eventOverlap == "boolean" ? e.eventOverlap : void 0,
      allow: e.eventAllow,
      backgroundColor: e.eventBackgroundColor,
      borderColor: e.eventBorderColor,
      textColor: e.eventTextColor,
      color: e.eventColor
      // classNames: options.eventClassNames // render hook will handle this
    }, n),
    selectionConfig: zd({
      constraint: e.selectConstraint,
      overlap: typeof e.selectOverlap == "boolean" ? e.selectOverlap : void 0,
      allow: e.selectAllow
    }, n)
  };
}
function jp(n, e) {
  for (let t of e.pluginHooks.isLoadingFuncs)
    if (t(n))
      return !0;
  return !1;
}
function qV(n) {
  return RF(n.options.businessHours, n);
}
function CS(n, e) {
  for (let t in n)
    console.warn(`Unknown option '${t}'`);
}
class KV extends gt {
  render() {
    let e = this.props.widgetGroups.map((t) => this.renderWidgetGroup(t));
    return I("div", { className: "fc-toolbar-chunk" }, ...e);
  }
  renderWidgetGroup(e) {
    let { props: t } = this, { theme: r } = this.context, i = [], s = !0;
    for (let o of e) {
      let { buttonName: a, buttonClick: c, buttonText: u, buttonIcon: d, buttonHint: h } = o;
      if (a === "title")
        s = !1, i.push(I("h2", { className: "fc-toolbar-title", id: t.titleId }, t.title));
      else {
        let p = a === t.activeButton, g = !t.isTodayEnabled && a === "today" || !t.isPrevEnabled && a === "prev" || !t.isNextEnabled && a === "next", y = [`fc-${a}-button`, r.getClass("button")];
        p && y.push(r.getClass("buttonActive")), i.push(I("button", { type: "button", title: typeof h == "function" ? h(t.navUnit) : h, disabled: g, "aria-pressed": p, className: y.join(" "), onClick: c }, u || (d ? I("span", { className: d, role: "img" }) : "")));
      }
    }
    if (i.length > 1) {
      let o = s && r.getClass("buttonGroup") || "";
      return I("div", { className: o }, ...i);
    }
    return i[0];
  }
}
class DS extends gt {
  render() {
    let { model: e, extraClassName: t } = this.props, r = !1, i, s, o = e.sectionWidgets, a = o.center;
    return o.left ? (r = !0, i = o.left) : i = o.start, o.right ? (r = !0, s = o.right) : s = o.end, I(
      "div",
      { className: [
        t || "",
        "fc-toolbar",
        r ? "fc-toolbar-ltr" : ""
      ].join(" ") },
      this.renderSection("start", i || []),
      this.renderSection("center", a || []),
      this.renderSection("end", s || [])
    );
  }
  renderSection(e, t) {
    let { props: r } = this;
    return I(KV, { key: e, widgetGroups: t, title: r.title, navUnit: r.navUnit, activeButton: r.activeButton, isTodayEnabled: r.isTodayEnabled, isPrevEnabled: r.isPrevEnabled, isNextEnabled: r.isNextEnabled, titleId: r.titleId });
  }
}
class JV extends gt {
  constructor() {
    super(...arguments), this.state = {
      availableWidth: null
    }, this.handleEl = (e) => {
      this.el = e, _i(this.props.elRef, e), this.updateAvailableWidth();
    }, this.handleResize = () => {
      this.updateAvailableWidth();
    };
  }
  render() {
    let { props: e, state: t } = this, { aspectRatio: r } = e, i = [
      "fc-view-harness",
      r || e.liquid || e.height ? "fc-view-harness-active" : "fc-view-harness-passive"
      // let the view do the height
    ], s = "", o = "";
    return r ? t.availableWidth !== null ? s = t.availableWidth / r : o = `${1 / r * 100}%` : s = e.height || "", I("div", { "aria-labelledby": e.labeledById, ref: this.handleEl, className: i.join(" "), style: { height: s, paddingBottom: o } }, e.children);
  }
  componentDidMount() {
    this.context.addResizeHandler(this.handleResize);
  }
  componentWillUnmount() {
    this.context.removeResizeHandler(this.handleResize);
  }
  updateAvailableWidth() {
    this.el && // needed. but why?
    this.props.aspectRatio && this.setState({ availableWidth: this.el.offsetWidth });
  }
}
class QV extends TT {
  constructor(e) {
    super(e), this.handleSegClick = (t, r) => {
      let { component: i } = this, { context: s } = i, o = ng(r);
      if (o && // might be the <div> surrounding the more link
      i.isValidSegDownEl(t.target)) {
        let a = Xi(t.target, ".fc-event-forced-url"), c = a ? a.querySelector("a[href]").href : "";
        s.emitter.trigger("eventClick", {
          el: r,
          event: new qr(i.context, o.eventRange.def, o.eventRange.instance),
          jsEvent: t,
          view: s.viewApi
        }), c && !t.defaultPrevented && (window.location.href = c);
      }
    }, this.destroy = Y1(
      e.el,
      "click",
      ".fc-event",
      // on both fg and bg events
      this.handleSegClick
    );
  }
}
class ZV extends TT {
  constructor(e) {
    super(e), this.handleEventElRemove = (t) => {
      t === this.currentSegEl && this.handleSegLeave(null, this.currentSegEl);
    }, this.handleSegEnter = (t, r) => {
      ng(r) && (this.currentSegEl = r, this.triggerEvent("eventMouseEnter", t, r));
    }, this.handleSegLeave = (t, r) => {
      this.currentSegEl && (this.currentSegEl = null, this.triggerEvent("eventMouseLeave", t, r));
    }, this.removeHoverListeners = qB(
      e.el,
      ".fc-event",
      // on both fg and bg events
      this.handleSegEnter,
      this.handleSegLeave
    );
  }
  destroy() {
    this.removeHoverListeners();
  }
  triggerEvent(e, t, r) {
    let { component: i } = this, { context: s } = i, o = ng(r);
    (!t || i.isValidSegDownEl(t.target)) && s.emitter.trigger(e, {
      el: r,
      event: new qr(s, o.eventRange.def, o.eventRange.instance),
      jsEvent: t,
      view: s.viewApi
    });
  }
}
class XV extends Zo {
  constructor() {
    super(...arguments), this.buildViewContext = Pe(Jj), this.buildViewPropTransformers = Pe(tH), this.buildToolbarProps = Pe(eH), this.headerRef = Xn(), this.footerRef = Xn(), this.interactionsStore = {}, this.state = {
      viewLabelId: Gf()
    }, this.registerInteractiveComponent = (e, t) => {
      let r = QF(e, t), o = [
        QV,
        ZV
      ].concat(this.props.pluginHooks.componentInteractions).map((a) => new a(r));
      this.interactionsStore[e.uid] = o, vS[e.uid] = r;
    }, this.unregisterInteractiveComponent = (e) => {
      let t = this.interactionsStore[e.uid];
      if (t) {
        for (let r of t)
          r.destroy();
        delete this.interactionsStore[e.uid];
      }
      delete vS[e.uid];
    }, this.resizeRunner = new xy(() => {
      this.props.emitter.trigger("_resize", !0), this.props.emitter.trigger("windowResize", { view: this.props.viewApi });
    }), this.handleWindowResize = (e) => {
      let { options: t } = this.props;
      t.handleWindowResize && e.target === window && this.resizeRunner.request(t.windowResizeDelay);
    };
  }
  /*
  renders INSIDE of an outer div
  */
  render() {
    let { props: e } = this, { toolbarConfig: t, options: r } = e, i = !1, s = "", o;
    e.isHeightAuto || e.forPrint ? s = "" : r.height != null ? i = !0 : r.contentHeight != null ? s = r.contentHeight : o = Math.max(r.aspectRatio, 0.5);
    let a = this.buildViewContext(e.viewSpec, e.viewApi, e.options, e.dateProfileGenerator, e.dateEnv, e.nowManager, e.theme, e.pluginHooks, e.dispatch, e.getCurrentData, e.emitter, e.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent), c = t.header && t.header.hasTitle ? this.state.viewLabelId : void 0;
    return I(
      ms.Provider,
      { value: a },
      I(nl, { unit: "day" }, (u) => {
        let d = this.buildToolbarProps(e.viewSpec, e.dateProfile, e.dateProfileGenerator, e.currentDate, u, e.viewTitle);
        return I(
          Dt,
          null,
          t.header && I(DS, Object.assign({ ref: this.headerRef, extraClassName: "fc-header-toolbar", model: t.header, titleId: c }, d)),
          I(
            JV,
            { liquid: i, height: s, aspectRatio: o, labeledById: c },
            this.renderView(e),
            this.buildAppendContent()
          ),
          t.footer && I(DS, Object.assign({ ref: this.footerRef, extraClassName: "fc-footer-toolbar", model: t.footer, titleId: "" }, d))
        );
      })
    );
  }
  componentDidMount() {
    let { props: e } = this;
    this.calendarInteractions = e.pluginHooks.calendarInteractions.map((r) => new r(e)), window.addEventListener("resize", this.handleWindowResize);
    let { propSetHandlers: t } = e.pluginHooks;
    for (let r in t)
      t[r](e[r], e);
  }
  componentDidUpdate(e) {
    let { props: t } = this, { propSetHandlers: r } = t.pluginHooks;
    for (let i in r)
      t[i] !== e[i] && r[i](t[i], t);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowResize), this.resizeRunner.clear();
    for (let e of this.calendarInteractions)
      e.destroy();
    this.props.emitter.trigger("_unmount");
  }
  buildAppendContent() {
    let { props: e } = this, t = e.pluginHooks.viewContainerAppends.map((r) => r(e));
    return I(Dt, {}, ...t);
  }
  renderView(e) {
    let { pluginHooks: t } = e, { viewSpec: r } = e, i = {
      dateProfile: e.dateProfile,
      businessHours: e.businessHours,
      eventStore: e.renderableEventStore,
      eventUiBases: e.eventUiBases,
      dateSelection: e.dateSelection,
      eventSelection: e.eventSelection,
      eventDrag: e.eventDrag,
      eventResize: e.eventResize,
      isHeightAuto: e.isHeightAuto,
      forPrint: e.forPrint
    }, s = this.buildViewPropTransformers(t.viewPropsTransformers);
    for (let a of s)
      Object.assign(i, a.transform(i, e));
    let o = r.component;
    return I(o, Object.assign({}, i));
  }
}
function eH(n, e, t, r, i, s) {
  let o = t.build(i, void 0, !1), a = t.buildPrev(e, r, !1), c = t.buildNext(e, r, !1);
  return {
    title: s,
    activeButton: n.type,
    navUnit: n.singleUnit,
    isTodayEnabled: o.isValid && !ns(e.currentRange, i),
    isPrevEnabled: a.isValid,
    isNextEnabled: c.isValid
  };
}
function tH(n) {
  return n.map((e) => new e());
}
class nH extends XF {
  constructor(e, t = {}) {
    super(), this.isRendering = !1, this.isRendered = !1, this.currentClassNames = [], this.customContentRenderId = 0, this.handleAction = (r) => {
      switch (r.type) {
        case "SET_EVENT_DRAG":
        case "SET_EVENT_RESIZE":
          this.renderRunner.tryDrain();
      }
    }, this.handleData = (r) => {
      this.currentData = r, this.renderRunner.request(r.calendarOptions.rerenderDelay);
    }, this.handleRenderRequest = () => {
      if (this.isRendering) {
        this.isRendered = !0;
        let { currentData: r } = this;
        Bd(() => {
          pc(I(JF, { options: r.calendarOptions, theme: r.theme, emitter: r.emitter }, (i, s, o, a) => (this.setClassNames(i), this.setHeight(s), I(
            nT.Provider,
            { value: this.customContentRenderId },
            I(XV, Object.assign({ isHeightAuto: o, forPrint: a }, r))
          ))), this.el);
        });
      } else this.isRendered && (this.isRendered = !1, pc(null, this.el), this.setClassNames([]), this.setHeight(""));
    }, LB(e), this.el = e, this.renderRunner = new xy(this.handleRenderRequest), new zV({
      optionOverrides: t,
      calendarApi: this,
      onAction: this.handleAction,
      onData: this.handleData
    });
  }
  render() {
    let e = this.isRendering;
    e ? this.customContentRenderId += 1 : this.isRendering = !0, this.renderRunner.request(), e && this.updateSize();
  }
  destroy() {
    this.isRendering && (this.isRendering = !1, this.renderRunner.request());
  }
  updateSize() {
    Bd(() => {
      super.updateSize();
    });
  }
  batchRendering(e) {
    this.renderRunner.pause("batchRendering"), e(), this.renderRunner.resume("batchRendering");
  }
  pauseRendering() {
    this.renderRunner.pause("pauseRendering");
  }
  resumeRendering() {
    this.renderRunner.resume("pauseRendering", !0);
  }
  resetOptions(e, t) {
    this.currentDataManager.resetOptions(e, t);
  }
  setClassNames(e) {
    if (!Js(e, this.currentClassNames)) {
      let { classList: t } = this.el;
      for (let r of this.currentClassNames)
        t.remove(r);
      for (let r of e)
        t.add(r);
      this.currentClassNames = e;
    }
  }
  setHeight(e) {
    G1(this.el, "height", e);
  }
}
class rH extends Li {
  constructor() {
    super(...arguments), this.headerElRef = Xn();
  }
  renderSimpleLayout(e, t) {
    let { props: r, context: i } = this, s = [], o = Hd(i.options);
    return e && s.push({
      type: "header",
      key: "header",
      isSticky: o,
      chunk: {
        elRef: this.headerElRef,
        tableClassName: "fc-col-header",
        rowContent: e
      }
    }), s.push({
      type: "body",
      key: "body",
      liquid: !0,
      chunk: { content: t }
    }), I(
      jd,
      { elClasses: ["fc-daygrid"], viewSpec: i.viewSpec },
      I(Py, { liquid: !r.isHeightAuto && !r.forPrint, collapsibleWidth: r.forPrint, cols: [], sections: s })
    );
  }
  renderHScrollLayout(e, t, r, i) {
    let s = this.context.pluginHooks.scrollGridImpl;
    if (!s)
      throw new Error("No ScrollGrid implementation");
    let { props: o, context: a } = this, c = !o.forPrint && Hd(a.options), u = !o.forPrint && PT(a.options), d = [];
    return e && d.push({
      type: "header",
      key: "header",
      isSticky: c,
      chunks: [{
        key: "main",
        elRef: this.headerElRef,
        tableClassName: "fc-col-header",
        rowContent: e
      }]
    }), d.push({
      type: "body",
      key: "body",
      liquid: !0,
      chunks: [{
        key: "main",
        content: t
      }]
    }), u && d.push({
      type: "footer",
      key: "footer",
      isSticky: !0,
      chunks: [{
        key: "main",
        content: sg
      }]
    }), I(
      jd,
      { elClasses: ["fc-daygrid"], viewSpec: a.viewSpec },
      I(s, { liquid: !o.isHeightAuto && !o.forPrint, forPrint: o.forPrint, collapsibleWidth: o.forPrint, colGroups: [{ cols: [{ span: r, minWidth: i }] }], sections: d })
    );
  }
}
function vd(n, e) {
  let t = [];
  for (let r = 0; r < e; r += 1)
    t[r] = [];
  for (let r of n)
    t[r.row].push(r);
  return t;
}
function Uu(n, e) {
  let t = [];
  for (let r = 0; r < e; r += 1)
    t[r] = [];
  for (let r of n)
    t[r.firstCol].push(r);
  return t;
}
function RS(n, e) {
  let t = [];
  if (n) {
    for (let r = 0; r < e; r += 1)
      t[r] = {
        affectedInstances: n.affectedInstances,
        isEvent: n.isEvent,
        segs: []
      };
    for (let r of n.segs)
      t[r.row].segs.push(r);
  } else
    for (let r = 0; r < e; r += 1)
      t[r] = null;
  return t;
}
const JT = $t({
  hour: "numeric",
  minute: "2-digit",
  omitZeroMinute: !0,
  meridiem: "narrow"
});
function QT(n) {
  let { display: e } = n.eventRange.ui;
  return e === "list-item" || e === "auto" && !n.eventRange.def.allDay && n.firstCol === n.lastCol && // can't be multi-day
  n.isStart && // "
  n.isEnd;
}
class ZT extends gt {
  render() {
    let { props: e } = this;
    return I(By, Object.assign({}, e, { elClasses: ["fc-daygrid-event", "fc-daygrid-block-event", "fc-h-event"], defaultTimeFormat: JT, defaultDisplayEventEnd: e.defaultDisplayEventEnd, disableResizing: !e.seg.eventRange.def.allDay }));
  }
}
class XT extends gt {
  render() {
    let { props: e, context: t } = this, { options: r } = t, { seg: i } = e, s = r.eventTimeFormat || JT, o = bT(i, s, t, !0, e.defaultDisplayEventEnd);
    return I(Ly, Object.assign({}, e, { elTag: "a", elClasses: ["fc-daygrid-event", "fc-daygrid-dot-event"], elAttrs: ST(e.seg, t), defaultGenerator: iH, timeText: o, isResizing: !1, isDateSelecting: !1 }));
  }
}
function iH(n) {
  return I(
    Dt,
    null,
    I("div", { className: "fc-daygrid-event-dot", style: { borderColor: n.borderColor || n.backgroundColor } }),
    n.timeText && I("div", { className: "fc-event-time" }, n.timeText),
    I("div", { className: "fc-event-title" }, n.event.title || I(Dt, null, " "))
  );
}
class sH extends gt {
  constructor() {
    super(...arguments), this.compileSegs = Pe(oH);
  }
  render() {
    let { props: e } = this, { allSegs: t, invisibleSegs: r } = this.compileSegs(e.singlePlacements);
    return I(FT, { elClasses: ["fc-daygrid-more-link"], dateProfile: e.dateProfile, todayRange: e.todayRange, allDayDate: e.allDayDate, moreCnt: e.moreCnt, allSegs: t, hiddenSegs: r, alignmentElRef: e.alignmentElRef, alignGridTop: e.alignGridTop, extraDateSpan: e.extraDateSpan, popoverContent: () => {
      let i = (e.eventDrag ? e.eventDrag.affectedInstances : null) || (e.eventResize ? e.eventResize.affectedInstances : null) || {};
      return I(Dt, null, t.map((s) => {
        let o = s.eventRange.instance.instanceId;
        return I("div", { className: "fc-daygrid-event-harness", key: o, style: {
          visibility: i[o] ? "hidden" : ""
        } }, QT(s) ? I(XT, Object.assign({ seg: s, isDragging: !1, isSelected: o === e.eventSelection, defaultDisplayEventEnd: !1 }, $s(s, e.todayRange))) : I(ZT, Object.assign({ seg: s, isDragging: !1, isResizing: !1, isDateSelecting: !1, isSelected: o === e.eventSelection, defaultDisplayEventEnd: !1 }, $s(s, e.todayRange))));
      }));
    } });
  }
}
function oH(n) {
  let e = [], t = [];
  for (let r of n)
    e.push(r.seg), r.isVisible || t.push(r.seg);
  return { allSegs: e, invisibleSegs: t };
}
const aH = $t({ week: "narrow" });
class lH extends Li {
  constructor() {
    super(...arguments), this.rootElRef = Xn(), this.state = {
      dayNumberId: Gf()
    }, this.handleRootEl = (e) => {
      _i(this.rootElRef, e), _i(this.props.elRef, e);
    };
  }
  render() {
    let { context: e, props: t, state: r, rootElRef: i } = this, { options: s, dateEnv: o } = e, { date: a, dateProfile: c } = t;
    const u = t.showDayNumber && uH(a, c.currentRange, o);
    return I(Fy, { elTag: "td", elRef: this.handleRootEl, elClasses: [
      "fc-daygrid-day",
      ...t.extraClassNames || []
    ], elAttrs: Object.assign(Object.assign(Object.assign({}, t.extraDataAttrs), t.showDayNumber ? { "aria-labelledby": r.dayNumberId } : {}), { role: "gridcell" }), defaultGenerator: cH, date: a, dateProfile: c, todayRange: t.todayRange, showDayNumber: t.showDayNumber, isMonthStart: u, extraRenderProps: t.extraRenderProps }, (d, h) => I(
      "div",
      { ref: t.innerElRef, className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner", style: { minHeight: t.minHeight } },
      t.showWeekNumber && I(jT, { elTag: "a", elClasses: ["fc-daygrid-week-number"], elAttrs: Vd(e, a, "week"), date: a, defaultFormat: aH }),
      !h.isDisabled && (t.showDayNumber || zy(s) || t.forceDayTop) ? I(
        "div",
        { className: "fc-daygrid-day-top" },
        I(d, { elTag: "a", elClasses: [
          "fc-daygrid-day-number",
          u && "fc-daygrid-month-start"
        ], elAttrs: Object.assign(Object.assign({}, Vd(e, a)), { id: r.dayNumberId }) })
      ) : t.showDayNumber ? (
        // for creating correct amount of space (see issue #7162)
        I(
          "div",
          { className: "fc-daygrid-day-top", style: { visibility: "hidden" } },
          I("a", { className: "fc-daygrid-day-number" }, " ")
        )
      ) : void 0,
      I(
        "div",
        { className: "fc-daygrid-day-events", ref: t.fgContentElRef },
        t.fgContent,
        I(
          "div",
          { className: "fc-daygrid-day-bottom", style: { marginTop: t.moreMarginTop } },
          I(sH, { allDayDate: a, singlePlacements: t.singlePlacements, moreCnt: t.moreCnt, alignmentElRef: i, alignGridTop: !t.showDayNumber, extraDateSpan: t.extraDateSpan, dateProfile: t.dateProfile, eventSelection: t.eventSelection, eventDrag: t.eventDrag, eventResize: t.eventResize, todayRange: t.todayRange })
        )
      ),
      I("div", { className: "fc-daygrid-day-bg" }, t.bgContent)
    ));
  }
}
function cH(n) {
  return n.dayNumberText || I(Dt, null, " ");
}
function uH(n, e, t) {
  const { start: r, end: i } = e, s = Qs(i, -1), o = t.getYear(r), a = t.getMonth(r), c = t.getYear(s), u = t.getMonth(s);
  return !(o === c && a === u) && // first date in current view?
  (n.valueOf() === r.valueOf() || // a month-start that's within the current range?
  t.getDay(n) === 1 && n.valueOf() < i.valueOf());
}
function eC(n) {
  return n.eventRange.instance.instanceId + ":" + n.firstCol;
}
function tC(n) {
  return eC(n) + ":" + n.lastCol;
}
function dH(n, e, t, r, i, s, o) {
  let a = new pH((w) => {
    let T = n[w.index].eventRange.instance.instanceId + ":" + w.span.start + ":" + (w.span.end - 1);
    return i[T] || 1;
  });
  a.allowReslicing = !0, a.strictOrder = r, e === !0 || t === !0 ? (a.maxCoord = s, a.hiddenConsumes = !0) : typeof e == "number" ? a.maxStackCnt = e : typeof t == "number" && (a.maxStackCnt = t, a.hiddenConsumes = !0);
  let c = [], u = [];
  for (let w = 0; w < n.length; w += 1) {
    let T = n[w], C = tC(T);
    i[C] != null ? c.push({
      index: w,
      span: {
        start: T.firstCol,
        end: T.lastCol + 1
      }
    }) : u.push(T);
  }
  let d = a.addSegs(c), h = a.toRects(), { singleColPlacements: p, multiColPlacements: g, leftoverMargins: y } = fH(h, n, o), b = [], S = [];
  for (let w of u) {
    g[w.firstCol].push({
      seg: w,
      isVisible: !1,
      isAbsolute: !0,
      absoluteTop: 0,
      marginTop: 0
    });
    for (let T = w.firstCol; T <= w.lastCol; T += 1)
      p[T].push({
        seg: Ha(w, T, T + 1, o),
        isVisible: !1,
        isAbsolute: !1,
        absoluteTop: 0,
        marginTop: 0
      });
  }
  for (let w = 0; w < o.length; w += 1)
    b.push(0);
  for (let w of d) {
    let T = n[w.index], C = w.span;
    g[C.start].push({
      seg: Ha(T, C.start, C.end, o),
      isVisible: !1,
      isAbsolute: !0,
      absoluteTop: 0,
      marginTop: 0
    });
    for (let k = C.start; k < C.end; k += 1)
      b[k] += 1, p[k].push({
        seg: Ha(T, k, k + 1, o),
        isVisible: !1,
        isAbsolute: !1,
        absoluteTop: 0,
        marginTop: 0
      });
  }
  for (let w = 0; w < o.length; w += 1)
    S.push(y[w]);
  return { singleColPlacements: p, multiColPlacements: g, moreCnts: b, moreMarginTops: S };
}
function fH(n, e, t) {
  let r = hH(n, t.length), i = [], s = [], o = [];
  for (let a = 0; a < t.length; a += 1) {
    let c = r[a], u = [], d = 0, h = 0;
    for (let g of c) {
      let y = e[g.index];
      u.push({
        seg: Ha(y, a, a + 1, t),
        isVisible: !0,
        isAbsolute: !1,
        absoluteTop: g.levelCoord,
        marginTop: g.levelCoord - d
      }), d = g.levelCoord + g.thickness;
    }
    let p = [];
    d = 0, h = 0;
    for (let g of c) {
      let y = e[g.index], b = g.span.end - g.span.start > 1, S = g.span.start === a;
      h += g.levelCoord - d, d = g.levelCoord + g.thickness, b ? (h += g.thickness, S && p.push({
        seg: Ha(y, g.span.start, g.span.end, t),
        isVisible: !0,
        isAbsolute: !0,
        absoluteTop: g.levelCoord,
        marginTop: 0
      })) : S && (p.push({
        seg: Ha(y, g.span.start, g.span.end, t),
        isVisible: !0,
        isAbsolute: !1,
        absoluteTop: g.levelCoord,
        marginTop: h
        // claim the margin
      }), h = 0);
    }
    i.push(u), s.push(p), o.push(h);
  }
  return { singleColPlacements: i, multiColPlacements: s, leftoverMargins: o };
}
function hH(n, e) {
  let t = [];
  for (let r = 0; r < e; r += 1)
    t.push([]);
  for (let r of n)
    for (let i = r.span.start; i < r.span.end; i += 1)
      t[i].push(r);
  return t;
}
function Ha(n, e, t, r) {
  if (n.firstCol === e && n.lastCol === t - 1)
    return n;
  let i = n.eventRange, s = i.range, o = Uo(s, {
    start: r[e].date,
    end: bn(r[t - 1].date, 1)
  });
  return Object.assign(Object.assign({}, n), { firstCol: e, lastCol: t - 1, eventRange: {
    def: i.def,
    ui: Object.assign(Object.assign({}, i.ui), { durationEditable: !1 }),
    instance: i.instance,
    range: o
  }, isStart: n.isStart && o.start.valueOf() === s.start.valueOf(), isEnd: n.isEnd && o.end.valueOf() === s.end.valueOf() });
}
class pH extends DT {
  constructor() {
    super(...arguments), this.hiddenConsumes = !1, this.forceHidden = {};
  }
  addSegs(e) {
    const t = super.addSegs(e), { entriesByLevel: r } = this, i = (s) => !this.forceHidden[Po(s)];
    for (let s = 0; s < r.length; s += 1)
      r[s] = r[s].filter(i);
    return t;
  }
  handleInvalidInsertion(e, t, r) {
    const { entriesByLevel: i, forceHidden: s } = this, { touchingEntry: o, touchingLevel: a, touchingLateral: c } = e;
    if (this.hiddenConsumes && o) {
      const u = Po(o);
      if (!s[u])
        if (this.allowReslicing) {
          const d = Object.assign(Object.assign({}, o), { span: Ny(o.span, t.span) }), h = Po(d);
          s[h] = !0, i[a][c] = d, r.push(d), this.splitEntry(o, t, r);
        } else
          s[u] = !0, r.push(o);
    }
    super.handleInvalidInsertion(e, t, r);
  }
}
class nC extends Li {
  constructor() {
    super(...arguments), this.cellElRefs = new es(), this.frameElRefs = new es(), this.fgElRefs = new es(), this.segHarnessRefs = new es(), this.rootElRef = Xn(), this.state = {
      framePositions: null,
      maxContentHeight: null,
      segHeights: {}
    }, this.handleResize = (e) => {
      e && this.updateSizing(!0);
    };
  }
  render() {
    let { props: e, state: t, context: r } = this, { options: i } = r, s = e.cells.length, o = Uu(e.businessHourSegs, s), a = Uu(e.bgEventSegs, s), c = Uu(this.getHighlightSegs(), s), u = Uu(this.getMirrorSegs(), s), { singleColPlacements: d, multiColPlacements: h, moreCnts: p, moreMarginTops: g } = dH(vT(e.fgEventSegs, i.eventOrder), e.dayMaxEvents, e.dayMaxEventRows, i.eventOrderStrict, t.segHeights, t.maxContentHeight, e.cells), y = (
      // TODO: messy way to compute this
      e.eventDrag && e.eventDrag.affectedInstances || e.eventResize && e.eventResize.affectedInstances || {}
    );
    return I(
      "tr",
      { ref: this.rootElRef, role: "row" },
      e.renderIntro && e.renderIntro(),
      e.cells.map((b, S) => {
        let w = this.renderFgSegs(S, e.forPrint ? d[S] : h[S], e.todayRange, y), T = this.renderFgSegs(S, mH(u[S], h), e.todayRange, {}, !!e.eventDrag, !!e.eventResize, !1);
        return I(lH, { key: b.key, elRef: this.cellElRefs.createRef(b.key), innerElRef: this.frameElRefs.createRef(b.key), dateProfile: e.dateProfile, date: b.date, showDayNumber: e.showDayNumbers, showWeekNumber: e.showWeekNumbers && S === 0, forceDayTop: e.showWeekNumbers, todayRange: e.todayRange, eventSelection: e.eventSelection, eventDrag: e.eventDrag, eventResize: e.eventResize, extraRenderProps: b.extraRenderProps, extraDataAttrs: b.extraDataAttrs, extraClassNames: b.extraClassNames, extraDateSpan: b.extraDateSpan, moreCnt: p[S], moreMarginTop: g[S], singlePlacements: d[S], fgContentElRef: this.fgElRefs.createRef(b.key), fgContent: (
          // Fragment scopes the keys
          I(
            Dt,
            null,
            I(Dt, null, w),
            I(Dt, null, T)
          )
        ), bgContent: (
          // Fragment scopes the keys
          I(
            Dt,
            null,
            this.renderFillSegs(c[S], "highlight"),
            this.renderFillSegs(o[S], "non-business"),
            this.renderFillSegs(a[S], "bg-event")
          )
        ), minHeight: e.cellMinHeight });
      })
    );
  }
  componentDidMount() {
    this.updateSizing(!0), this.context.addResizeHandler(this.handleResize);
  }
  componentDidUpdate(e, t) {
    let r = this.props;
    this.updateSizing(!pi(e, r));
  }
  componentWillUnmount() {
    this.context.removeResizeHandler(this.handleResize);
  }
  getHighlightSegs() {
    let { props: e } = this;
    return e.eventDrag && e.eventDrag.segs.length ? e.eventDrag.segs : e.eventResize && e.eventResize.segs.length ? e.eventResize.segs : e.dateSelectionSegs;
  }
  getMirrorSegs() {
    let { props: e } = this;
    return e.eventResize && e.eventResize.segs.length ? e.eventResize.segs : [];
  }
  renderFgSegs(e, t, r, i, s, o, a) {
    let { context: c } = this, { eventSelection: u } = this.props, { framePositions: d } = this.state, h = this.props.cells.length === 1, p = s || o || a, g = [];
    if (d)
      for (let y of t) {
        let { seg: b } = y, { instanceId: S } = b.eventRange.instance, w = y.isVisible && !i[S], T = y.isAbsolute, C = "", k = "";
        T && (c.isRtl ? (k = 0, C = d.lefts[b.lastCol] - d.lefts[b.firstCol]) : (C = 0, k = d.rights[b.firstCol] - d.rights[b.lastCol])), g.push(I("div", { className: "fc-daygrid-event-harness" + (T ? " fc-daygrid-event-harness-abs" : ""), key: eC(b), ref: p ? null : this.segHarnessRefs.createRef(tC(b)), style: {
          visibility: w ? "" : "hidden",
          marginTop: T ? "" : y.marginTop,
          top: T ? y.absoluteTop : "",
          left: C,
          right: k
        } }, QT(b) ? I(XT, Object.assign({ seg: b, isDragging: s, isSelected: S === u, defaultDisplayEventEnd: h }, $s(b, r))) : I(ZT, Object.assign({ seg: b, isDragging: s, isResizing: o, isDateSelecting: a, isSelected: S === u, defaultDisplayEventEnd: h }, $s(b, r)))));
      }
    return g;
  }
  renderFillSegs(e, t) {
    let { isRtl: r } = this.context, { todayRange: i } = this.props, { framePositions: s } = this.state, o = [];
    if (s)
      for (let a of e) {
        let c = r ? {
          right: 0,
          left: s.lefts[a.lastCol] - s.lefts[a.firstCol]
        } : {
          left: 0,
          right: s.rights[a.firstCol] - s.rights[a.lastCol]
        };
        o.push(I("div", { key: xT(a.eventRange), className: "fc-daygrid-bg-harness", style: c }, t === "bg-event" ? I(LT, Object.assign({ seg: a }, $s(a, i))) : BT(t)));
      }
    return I(Dt, {}, ...o);
  }
  updateSizing(e) {
    let { props: t, state: r, frameElRefs: i } = this;
    if (!t.forPrint && t.clientWidth !== null) {
      if (e) {
        let c = t.cells.map((u) => i.currentMap[u.key]);
        if (c.length) {
          let u = this.rootElRef.current, d = new Ka(
            u,
            c,
            !0,
            // isHorizontal
            !1
          );
          (!r.framePositions || !r.framePositions.similarTo(d)) && this.setState({
            framePositions: new Ka(
              u,
              c,
              !0,
              // isHorizontal
              !1
            )
          });
        }
      }
      const s = this.state.segHeights, o = this.querySegHeights(), a = t.dayMaxEvents === !0 || t.dayMaxEventRows === !0;
      this.safeSetState({
        // HACK to prevent oscillations of events being shown/hidden from max-event-rows
        // Essentially, once you compute an element's height, never null-out.
        // TODO: always display all events, as visibility:hidden?
        segHeights: Object.assign(Object.assign({}, s), o),
        maxContentHeight: a ? this.computeMaxContentHeight() : null
      });
    }
  }
  querySegHeights() {
    let e = this.segHarnessRefs.currentMap, t = {};
    for (let r in e) {
      let i = Math.round(e[r].getBoundingClientRect().height);
      t[r] = Math.max(t[r] || 0, i);
    }
    return t;
  }
  computeMaxContentHeight() {
    let e = this.props.cells[0].key, t = this.cellElRefs.currentMap[e], r = this.fgElRefs.currentMap[e];
    return t.getBoundingClientRect().bottom - r.getBoundingClientRect().top;
  }
  getCellEls() {
    let e = this.cellElRefs.currentMap;
    return this.props.cells.map((t) => e[t.key]);
  }
}
nC.addStateEquality({
  segHeights: pi
});
function mH(n, e) {
  if (!n.length)
    return [];
  let t = gH(e);
  return n.map((r) => ({
    seg: r,
    isVisible: !0,
    isAbsolute: !0,
    absoluteTop: t[r.eventRange.instance.instanceId],
    marginTop: 0
  }));
}
function gH(n) {
  let e = {};
  for (let t of n)
    for (let r of t)
      e[r.seg.eventRange.instance.instanceId] = r.absoluteTop;
  return e;
}
class yH extends Li {
  constructor() {
    super(...arguments), this.splitBusinessHourSegs = Pe(vd), this.splitBgEventSegs = Pe(vH), this.splitFgEventSegs = Pe(vd), this.splitDateSelectionSegs = Pe(vd), this.splitEventDrag = Pe(RS), this.splitEventResize = Pe(RS), this.rowRefs = new es();
  }
  render() {
    let { props: e, context: t } = this, r = e.cells.length, i = this.splitBusinessHourSegs(e.businessHourSegs, r), s = this.splitBgEventSegs(e.bgEventSegs, r), o = this.splitFgEventSegs(e.fgEventSegs, r), a = this.splitDateSelectionSegs(e.dateSelectionSegs, r), c = this.splitEventDrag(e.eventDrag, r), u = this.splitEventResize(e.eventResize, r), d = r >= 7 && e.clientWidth ? e.clientWidth / t.options.aspectRatio / 6 : null;
    return I(nl, { unit: "day" }, (h, p) => I(Dt, null, e.cells.map((g, y) => I(nC, {
      ref: this.rowRefs.createRef(y),
      key: g.length ? g[0].date.toISOString() : y,
      showDayNumbers: r > 1,
      showWeekNumbers: e.showWeekNumbers,
      todayRange: p,
      dateProfile: e.dateProfile,
      cells: g,
      renderIntro: e.renderRowIntro,
      businessHourSegs: i[y],
      eventSelection: e.eventSelection,
      bgEventSegs: s[y],
      fgEventSegs: o[y],
      dateSelectionSegs: a[y],
      eventDrag: c[y],
      eventResize: u[y],
      dayMaxEvents: e.dayMaxEvents,
      dayMaxEventRows: e.dayMaxEventRows,
      clientWidth: e.clientWidth,
      clientHeight: e.clientHeight,
      cellMinHeight: d,
      forPrint: e.forPrint
    }))));
  }
  componentDidMount() {
    this.registerInteractiveComponent();
  }
  componentDidUpdate() {
    this.registerInteractiveComponent();
  }
  registerInteractiveComponent() {
    if (!this.rootEl) {
      const e = this.rowRefs.currentMap[0].getCellEls()[0], t = e ? e.closest(".fc-daygrid-body") : null;
      t && (this.rootEl = t, this.context.registerInteractiveComponent(this, {
        el: t,
        isHitComboAllowed: this.props.isHitComboAllowed
      }));
    }
  }
  componentWillUnmount() {
    this.rootEl && (this.context.unregisterInteractiveComponent(this), this.rootEl = null);
  }
  // Hit System
  // ----------------------------------------------------------------------------------------------------
  prepareHits() {
    this.rowPositions = new Ka(
      this.rootEl,
      this.rowRefs.collect().map((e) => e.getCellEls()[0]),
      // first cell el in each row. TODO: not optimal
      !1,
      !0
    ), this.colPositions = new Ka(
      this.rootEl,
      this.rowRefs.currentMap[0].getCellEls(),
      // cell els in first row
      !0,
      // horizontal
      !1
    );
  }
  queryHit(e, t) {
    let { colPositions: r, rowPositions: i } = this, s = r.leftToIndex(e), o = i.topToIndex(t);
    if (o != null && s != null) {
      let a = this.props.cells[o][s];
      return {
        dateProfile: this.props.dateProfile,
        dateSpan: Object.assign({ range: this.getCellRange(o, s), allDay: !0 }, a.extraDateSpan),
        dayEl: this.getCellEl(o, s),
        rect: {
          left: r.lefts[s],
          right: r.rights[s],
          top: i.tops[o],
          bottom: i.bottoms[o]
        },
        layer: 0
      };
    }
    return null;
  }
  getCellEl(e, t) {
    return this.rowRefs.currentMap[e].getCellEls()[t];
  }
  getCellRange(e, t) {
    let r = this.props.cells[e][t].date, i = bn(r, 1);
    return { start: r, end: i };
  }
}
function vH(n, e) {
  return vd(n.filter(bH), e);
}
function bH(n) {
  return n.eventRange.def.allDay;
}
class xH extends Li {
  constructor() {
    super(...arguments), this.elRef = Xn(), this.needsScrollReset = !1;
  }
  render() {
    let { props: e } = this, { dayMaxEventRows: t, dayMaxEvents: r, expandRows: i } = e, s = r === !0 || t === !0;
    s && !i && (s = !1, t = null, r = null);
    let o = [
      "fc-daygrid-body",
      s ? "fc-daygrid-body-balanced" : "fc-daygrid-body-unbalanced",
      i ? "" : "fc-daygrid-body-natural"
      // will height of one row depend on the others?
    ];
    return I(
      "div",
      { ref: this.elRef, className: o.join(" "), style: {
        // these props are important to give this wrapper correct dimensions for interactions
        // TODO: if we set it here, can we avoid giving to inner tables?
        width: e.clientWidth,
        minWidth: e.tableMinWidth
      } },
      I(
        "table",
        { role: "presentation", className: "fc-scrollgrid-sync-table", style: {
          width: e.clientWidth,
          minWidth: e.tableMinWidth,
          height: i ? e.clientHeight : ""
        } },
        e.colGroupNode,
        I(
          "tbody",
          { role: "presentation" },
          I(yH, { dateProfile: e.dateProfile, cells: e.cells, renderRowIntro: e.renderRowIntro, showWeekNumbers: e.showWeekNumbers, clientWidth: e.clientWidth, clientHeight: e.clientHeight, businessHourSegs: e.businessHourSegs, bgEventSegs: e.bgEventSegs, fgEventSegs: e.fgEventSegs, dateSelectionSegs: e.dateSelectionSegs, eventSelection: e.eventSelection, eventDrag: e.eventDrag, eventResize: e.eventResize, dayMaxEvents: r, dayMaxEventRows: t, forPrint: e.forPrint, isHitComboAllowed: e.isHitComboAllowed })
        )
      )
    );
  }
  componentDidMount() {
    this.requestScrollReset();
  }
  componentDidUpdate(e) {
    e.dateProfile !== this.props.dateProfile ? this.requestScrollReset() : this.flushScrollReset();
  }
  requestScrollReset() {
    this.needsScrollReset = !0, this.flushScrollReset();
  }
  flushScrollReset() {
    if (this.needsScrollReset && this.props.clientWidth) {
      const e = SH(this.elRef.current, this.props.dateProfile);
      if (e) {
        const t = e.closest(".fc-daygrid-body"), r = t.closest(".fc-scroller"), i = e.getBoundingClientRect().top - t.getBoundingClientRect().top;
        r.scrollTop = i ? i + 1 : 0;
      }
      this.needsScrollReset = !1;
    }
  }
}
function SH(n, e) {
  let t;
  return e.currentRangeUnit.match(/year|month/) && (t = n.querySelector(`[data-date="${bj(e.currentDate)}-01"]`)), t || (t = n.querySelector(`[data-date="${wy(e.currentDate)}"]`)), t;
}
class wH extends IT {
  constructor() {
    super(...arguments), this.forceDayIfListItem = !0;
  }
  sliceRange(e, t) {
    return t.sliceRange(e);
  }
}
class rC extends Li {
  constructor() {
    super(...arguments), this.slicer = new wH(), this.tableRef = Xn();
  }
  render() {
    let { props: e, context: t } = this;
    return I(xH, Object.assign({ ref: this.tableRef }, this.slicer.sliceProps(e, e.dateProfile, e.nextDayThreshold, t, e.dayTableModel), { dateProfile: e.dateProfile, cells: e.dayTableModel.cells, colGroupNode: e.colGroupNode, tableMinWidth: e.tableMinWidth, renderRowIntro: e.renderRowIntro, dayMaxEvents: e.dayMaxEvents, dayMaxEventRows: e.dayMaxEventRows, showWeekNumbers: e.showWeekNumbers, expandRows: e.expandRows, headerAlignElRef: e.headerAlignElRef, clientWidth: e.clientWidth, clientHeight: e.clientHeight, forPrint: e.forPrint }));
  }
}
class EH extends rH {
  constructor() {
    super(...arguments), this.buildDayTableModel = Pe(AH), this.headerRef = Xn(), this.tableRef = Xn();
  }
  render() {
    let { options: e, dateProfileGenerator: t } = this.context, { props: r } = this, i = this.buildDayTableModel(r.dateProfile, t), s = e.dayHeaders && I(MT, { ref: this.headerRef, dateProfile: r.dateProfile, dates: i.headerDates, datesRepDistinctDays: i.rowCnt === 1 }), o = (a) => I(rC, { ref: this.tableRef, dateProfile: r.dateProfile, dayTableModel: i, businessHours: r.businessHours, dateSelection: r.dateSelection, eventStore: r.eventStore, eventUiBases: r.eventUiBases, eventSelection: r.eventSelection, eventDrag: r.eventDrag, eventResize: r.eventResize, nextDayThreshold: e.nextDayThreshold, colGroupNode: a.tableColGroupNode, tableMinWidth: a.tableMinWidth, dayMaxEvents: e.dayMaxEvents, dayMaxEventRows: e.dayMaxEventRows, showWeekNumbers: e.weekNumbers, expandRows: !r.isHeightAuto, headerAlignElRef: this.headerElRef, clientWidth: a.clientWidth, clientHeight: a.clientHeight, forPrint: r.forPrint });
    return e.dayMinWidth ? this.renderHScrollLayout(s, o, i.colCnt, e.dayMinWidth) : this.renderSimpleLayout(s, o);
  }
}
function AH(n, e) {
  let t = new _T(n.renderRange, e);
  return new OT(t, /year|month|week/.test(n.currentRangeUnit));
}
class TH extends oT {
  // Computes the date range that will be rendered
  buildRenderRange(e, t, r) {
    let i = super.buildRenderRange(e, t, r), { props: s } = this;
    return CH({
      currentRange: i,
      snapToWeek: /^(year|month)$/.test(t),
      fixedWeekCount: s.fixedWeekCount,
      dateEnv: s.dateEnv
    });
  }
}
function CH(n) {
  let { dateEnv: e, currentRange: t } = n, { start: r, end: i } = t, s;
  if (n.snapToWeek && (r = e.startOfWeek(r), s = e.startOfWeek(i), s.valueOf() !== i.valueOf() && (i = nS(s, 1))), n.fixedWeekCount) {
    let o = e.startOfWeek(e.startOfMonth(bn(t.end, -1))), a = Math.ceil(
      // could be partial weeks due to hiddenDays
      lj(o, i)
    );
    i = nS(i, 6 - a);
  }
  return { start: r, end: i };
}
var DH = ':root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{clear:both;content:"";display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-daygrid-day-frame{min-height:100%;position:relative}.fc .fc-daygrid-day-top{display:flex;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{padding:4px;position:relative;z-index:4}.fc .fc-daygrid-month-start{font-size:1.1em;font-weight:700}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{left:0;position:absolute;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:2em;position:relative}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{left:0;position:absolute;right:0;top:0}.fc .fc-daygrid-bg-harness{bottom:0;position:absolute;top:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{margin-top:1px;z-index:6}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;margin:0 2px}.fc .fc-daygrid-day-bottom:after,.fc .fc-daygrid-day-bottom:before{clear:both;content:"";display:table}.fc .fc-daygrid-more-link{border-radius:3px;cursor:pointer;line-height:1;margin-top:1px;max-width:100%;overflow:hidden;padding:2px;position:relative;white-space:nowrap;z-index:4}.fc .fc-daygrid-more-link:hover{background-color:rgba(0,0,0,.1)}.fc .fc-daygrid-week-number{background-color:var(--fc-neutral-bg-color);color:var(--fc-neutral-text-color);min-width:1.5em;padding:2px;position:absolute;text-align:center;top:0;z-index:5}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-more-link{float:left}.fc-direction-ltr .fc-daygrid-week-number{border-radius:0 0 3px 0;left:0}.fc-direction-rtl .fc-daygrid-more-link{float:right}.fc-direction-rtl .fc-daygrid-week-number{border-radius:0 0 0 3px;right:0}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{border-radius:3px;font-size:var(--fc-small-font-size);position:relative;white-space:nowrap}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{align-items:center;display:flex;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{flex-grow:1;flex-shrink:1;font-weight:700;min-width:0;overflow:hidden}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-daygrid-event-dot{border:calc(var(--fc-daygrid-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-daygrid-event-dot-width)/2);box-sizing:content-box;height:0;margin:0 4px;width:0}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}';
by(DH);
var RH = eo({
  name: "@fullcalendar/daygrid",
  initialView: "dayGridMonth",
  views: {
    dayGrid: {
      component: EH,
      dateProfileGeneratorClass: TH
    },
    dayGridDay: {
      type: "dayGrid",
      duration: { days: 1 }
    },
    dayGridWeek: {
      type: "dayGrid",
      duration: { weeks: 1 }
    },
    dayGridMonth: {
      type: "dayGrid",
      duration: { months: 1 },
      fixedWeekCount: !0
    },
    dayGridYear: {
      type: "dayGrid",
      duration: { years: 1 }
    }
  }
});
const kH = parseInt(String(ze.version).split(".")[0]), MH = kH < 18;
class iC extends my {
  constructor() {
    super(...arguments), this.elRef = G2(), this.isUpdating = !1, this.isUnmounting = !1, this.state = {
      customRenderingMap: /* @__PURE__ */ new Map()
    }, this.requestResize = () => {
      this.isUnmounting || (this.cancelResize(), this.resizeId = requestAnimationFrame(() => {
        this.doResize();
      }));
    };
  }
  render() {
    const e = [];
    for (const t of this.state.customRenderingMap.values())
      e.push(ze.createElement(_H, { key: t.id, customRendering: t }));
    return ze.createElement("div", { ref: this.elRef }, e);
  }
  componentDidMount() {
    this.isUnmounting = !1;
    const e = new zz();
    this.handleCustomRendering = e.handle.bind(e), this.calendar = new nH(this.elRef.current, Object.assign(Object.assign({}, this.props), { handleCustomRendering: this.handleCustomRendering })), this.calendar.render(), this.calendar.on("_beforeprint", () => {
      kx(() => {
      });
    });
    let t;
    e.subscribe((r) => {
      const i = Date.now(), s = !t;
      // don't call flushSync if React version already does sync rendering by default
      // guards against fatal errors:
      // https://github.com/fullcalendar/fullcalendar/issues/7448
      (MH || //
      s || this.isUpdating || this.isUnmounting || i - t < 100 ? sC : kx)(() => {
        this.setState({ customRenderingMap: r }, () => {
          t = i, s ? this.doResize() : this.requestResize();
        });
      });
    });
  }
  componentDidUpdate() {
    this.isUpdating = !0, this.calendar.resetOptions(Object.assign(Object.assign({}, this.props), { handleCustomRendering: this.handleCustomRendering })), this.isUpdating = !1;
  }
  componentWillUnmount() {
    this.isUnmounting = !0, this.cancelResize(), this.calendar.destroy();
  }
  doResize() {
    this.calendar.updateSize();
  }
  cancelResize() {
    this.resizeId !== void 0 && (cancelAnimationFrame(this.resizeId), this.resizeId = void 0);
  }
  getApi() {
    return this.calendar;
  }
}
iC.act = sC;
class _H extends Y2 {
  render() {
    const { customRendering: e } = this.props, { generatorMeta: t } = e, r = typeof t == "function" ? t(e.renderProps) : t;
    return w1(r, e.containerEl);
  }
}
function sC(n) {
  n();
}
class OH extends tz {
  getKeyInfo() {
    return {
      allDay: {},
      timed: {}
    };
  }
  getKeysForDateSpan(e) {
    return e.allDay ? ["allDay"] : ["timed"];
  }
  getKeysForEventDef(e) {
    return e.allDay ? LF(e) ? ["timed", "allDay"] : ["allDay"] : ["timed"];
  }
}
const IH = $t({
  hour: "numeric",
  minute: "2-digit",
  omitZeroMinute: !0,
  meridiem: "short"
});
function oC(n) {
  let e = [
    "fc-timegrid-slot",
    "fc-timegrid-slot-label",
    n.isLabeled ? "fc-scrollgrid-shrink" : "fc-timegrid-slot-minor"
  ];
  return I(ms.Consumer, null, (t) => {
    if (!n.isLabeled)
      return I("td", { className: e.join(" "), "data-time": n.isoTimeStr });
    let { dateEnv: r, options: i, viewApi: s } = t, o = (
      // TODO: fully pre-parse
      i.slotLabelFormat == null ? IH : Array.isArray(i.slotLabelFormat) ? $t(i.slotLabelFormat[0]) : $t(i.slotLabelFormat)
    ), a = {
      level: 0,
      time: n.time,
      date: r.toDate(n.date),
      view: s,
      text: r.format(n.date, o)
    };
    return I(Mr, { elTag: "td", elClasses: e, elAttrs: {
      "data-time": n.isoTimeStr
    }, renderProps: a, generatorName: "slotLabelContent", customGenerator: i.slotLabelContent, defaultGenerator: NH, classNameGenerator: i.slotLabelClassNames, didMount: i.slotLabelDidMount, willUnmount: i.slotLabelWillUnmount }, (c) => I(
      "div",
      { className: "fc-timegrid-slot-label-frame fc-scrollgrid-shrink-frame" },
      I(c, { elTag: "div", elClasses: [
        "fc-timegrid-slot-label-cushion",
        "fc-scrollgrid-shrink-cushion"
      ] })
    ));
  });
}
function NH(n) {
  return n.text;
}
class PH extends gt {
  render() {
    return this.props.slatMetas.map((e) => I(
      "tr",
      { key: e.key },
      I(oC, Object.assign({}, e))
    ));
  }
}
const LH = $t({ week: "short" }), BH = 5;
class jH extends Li {
  constructor() {
    super(...arguments), this.allDaySplitter = new OH(), this.headerElRef = Xn(), this.rootElRef = Xn(), this.scrollerElRef = Xn(), this.state = {
      slatCoords: null
    }, this.handleScrollTopRequest = (e) => {
      let t = this.scrollerElRef.current;
      t && (t.scrollTop = e);
    }, this.renderHeadAxis = (e, t = "") => {
      let { options: r } = this.context, { dateProfile: i } = this.props, s = i.renderRange, a = Qo(s.start, s.end) === 1 ? Vd(this.context, s.start, "week") : {};
      return r.weekNumbers && e === "day" ? I(jT, { elTag: "th", elClasses: [
        "fc-timegrid-axis",
        "fc-scrollgrid-shrink"
      ], elAttrs: {
        "aria-hidden": !0
      }, date: s.start, defaultFormat: LH }, (c) => I(
        "div",
        { className: [
          "fc-timegrid-axis-frame",
          "fc-scrollgrid-shrink-frame",
          "fc-timegrid-axis-frame-liquid"
        ].join(" "), style: { height: t } },
        I(c, { elTag: "a", elClasses: [
          "fc-timegrid-axis-cushion",
          "fc-scrollgrid-shrink-cushion",
          "fc-scrollgrid-sync-inner"
        ], elAttrs: a })
      )) : I(
        "th",
        { "aria-hidden": !0, className: "fc-timegrid-axis" },
        I("div", { className: "fc-timegrid-axis-frame", style: { height: t } })
      );
    }, this.renderTableRowAxis = (e) => {
      let { options: t, viewApi: r } = this.context, i = {
        text: t.allDayText,
        view: r
      };
      return (
        // TODO: make reusable hook. used in list view too
        I(Mr, { elTag: "td", elClasses: [
          "fc-timegrid-axis",
          "fc-scrollgrid-shrink"
        ], elAttrs: {
          "aria-hidden": !0
        }, renderProps: i, generatorName: "allDayContent", customGenerator: t.allDayContent, defaultGenerator: FH, classNameGenerator: t.allDayClassNames, didMount: t.allDayDidMount, willUnmount: t.allDayWillUnmount }, (s) => I(
          "div",
          { className: [
            "fc-timegrid-axis-frame",
            "fc-scrollgrid-shrink-frame",
            e == null ? " fc-timegrid-axis-frame-liquid" : ""
          ].join(" "), style: { height: e } },
          I(s, { elTag: "span", elClasses: [
            "fc-timegrid-axis-cushion",
            "fc-scrollgrid-shrink-cushion",
            "fc-scrollgrid-sync-inner"
          ] })
        ))
      );
    }, this.handleSlatCoords = (e) => {
      this.setState({ slatCoords: e });
    };
  }
  // rendering
  // ----------------------------------------------------------------------------------------------------
  renderSimpleLayout(e, t, r) {
    let { context: i, props: s } = this, o = [], a = Hd(i.options);
    return e && o.push({
      type: "header",
      key: "header",
      isSticky: a,
      chunk: {
        elRef: this.headerElRef,
        tableClassName: "fc-col-header",
        rowContent: e
      }
    }), t && (o.push({
      type: "body",
      key: "all-day",
      chunk: { content: t }
    }), o.push({
      type: "body",
      key: "all-day-divider",
      outerContent: (
        // TODO: rename to cellContent so don't need to define <tr>?
        I(
          "tr",
          { role: "presentation", className: "fc-scrollgrid-section" },
          I("td", { className: "fc-timegrid-divider " + i.theme.getClass("tableCellShaded") })
        )
      )
    })), o.push({
      type: "body",
      key: "body",
      liquid: !0,
      expandRows: !!i.options.expandRows,
      chunk: {
        scrollerElRef: this.scrollerElRef,
        content: r
      }
    }), I(
      jd,
      { elRef: this.rootElRef, elClasses: ["fc-timegrid"], viewSpec: i.viewSpec },
      I(Py, { liquid: !s.isHeightAuto && !s.forPrint, collapsibleWidth: s.forPrint, cols: [{ width: "shrink" }], sections: o })
    );
  }
  renderHScrollLayout(e, t, r, i, s, o, a) {
    let c = this.context.pluginHooks.scrollGridImpl;
    if (!c)
      throw new Error("No ScrollGrid implementation");
    let { context: u, props: d } = this, h = !d.forPrint && Hd(u.options), p = !d.forPrint && PT(u.options), g = [];
    e && g.push({
      type: "header",
      key: "header",
      isSticky: h,
      syncRowHeights: !0,
      chunks: [
        {
          key: "axis",
          rowContent: (b) => I("tr", { role: "presentation" }, this.renderHeadAxis("day", b.rowSyncHeights[0]))
        },
        {
          key: "cols",
          elRef: this.headerElRef,
          tableClassName: "fc-col-header",
          rowContent: e
        }
      ]
    }), t && (g.push({
      type: "body",
      key: "all-day",
      syncRowHeights: !0,
      chunks: [
        {
          key: "axis",
          rowContent: (b) => I("tr", { role: "presentation" }, this.renderTableRowAxis(b.rowSyncHeights[0]))
        },
        {
          key: "cols",
          content: t
        }
      ]
    }), g.push({
      key: "all-day-divider",
      type: "body",
      outerContent: (
        // TODO: rename to cellContent so don't need to define <tr>?
        I(
          "tr",
          { role: "presentation", className: "fc-scrollgrid-section" },
          I("td", { colSpan: 2, className: "fc-timegrid-divider " + u.theme.getClass("tableCellShaded") })
        )
      )
    }));
    let y = u.options.nowIndicator;
    return g.push({
      type: "body",
      key: "body",
      liquid: !0,
      expandRows: !!u.options.expandRows,
      chunks: [
        {
          key: "axis",
          content: (b) => (
            // TODO: make this now-indicator arrow more DRY with TimeColsContent
            I(
              "div",
              { className: "fc-timegrid-axis-chunk" },
              I(
                "table",
                { "aria-hidden": !0, style: { height: b.expandRows ? b.clientHeight : "" } },
                b.tableColGroupNode,
                I(
                  "tbody",
                  null,
                  I(PH, { slatMetas: o })
                )
              ),
              I(
                "div",
                { className: "fc-timegrid-now-indicator-container" },
                I(nl, {
                  unit: y ? "minute" : "day"
                  /* hacky */
                }, (S) => {
                  let w = y && a && a.safeComputeTop(S);
                  return typeof w == "number" ? I(jy, { elClasses: ["fc-timegrid-now-indicator-arrow"], elStyle: { top: w }, isAxis: !0, date: S }) : null;
                })
              )
            )
          )
        },
        {
          key: "cols",
          scrollerElRef: this.scrollerElRef,
          content: r
        }
      ]
    }), p && g.push({
      key: "footer",
      type: "footer",
      isSticky: !0,
      chunks: [
        {
          key: "axis",
          content: sg
        },
        {
          key: "cols",
          content: sg
        }
      ]
    }), I(
      jd,
      { elRef: this.rootElRef, elClasses: ["fc-timegrid"], viewSpec: u.viewSpec },
      I(c, { liquid: !d.isHeightAuto && !d.forPrint, forPrint: d.forPrint, collapsibleWidth: !1, colGroups: [
        { width: "shrink", cols: [{ width: "shrink" }] },
        { cols: [{ span: i, minWidth: s }] }
      ], sections: g })
    );
  }
  /* Dimensions
  ------------------------------------------------------------------------------------------------------------------*/
  getAllDayMaxEventProps() {
    let { dayMaxEvents: e, dayMaxEventRows: t } = this.context.options;
    return (e === !0 || t === !0) && (e = void 0, t = BH), { dayMaxEvents: e, dayMaxEventRows: t };
  }
}
function FH(n) {
  return n.text;
}
class zH {
  constructor(e, t, r) {
    this.positions = e, this.dateProfile = t, this.slotDuration = r;
  }
  safeComputeTop(e) {
    let { dateProfile: t } = this;
    if (ns(t.currentRange, e)) {
      let r = Ot(e), i = e.valueOf() - r.valueOf();
      if (i >= di(t.slotMinTime) && i < di(t.slotMaxTime))
        return this.computeTimeTop(lt(i));
    }
    return null;
  }
  // Computes the top coordinate, relative to the bounds of the grid, of the given date.
  // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
  computeDateTop(e, t) {
    return t || (t = Ot(e)), this.computeTimeTop(lt(e.valueOf() - t.valueOf()));
  }
  // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
  // This is a makeshify way to compute the time-top. Assumes all slatMetas dates are uniform.
  // Eventually allow computation with arbirary slat dates.
  computeTimeTop(e) {
    let { positions: t, dateProfile: r } = this, i = t.els.length, s = (e.milliseconds - di(r.slotMinTime)) / di(this.slotDuration), o, a;
    return s = Math.max(0, s), s = Math.min(i, s), o = Math.floor(s), o = Math.min(o, i - 1), a = s - o, t.tops[o] + t.getHeight(o) * a;
  }
}
class VH extends gt {
  render() {
    let { props: e, context: t } = this, { options: r } = t, { slatElRefs: i } = e;
    return I("tbody", null, e.slatMetas.map((s, o) => {
      let a = {
        time: s.time,
        date: t.dateEnv.toDate(s.date),
        view: t.viewApi
      };
      return I(
        "tr",
        { key: s.key, ref: i.createRef(s.key) },
        e.axis && I(oC, Object.assign({}, s)),
        I(Mr, { elTag: "td", elClasses: [
          "fc-timegrid-slot",
          "fc-timegrid-slot-lane",
          !s.isLabeled && "fc-timegrid-slot-minor"
        ], elAttrs: {
          "data-time": s.isoTimeStr
        }, renderProps: a, generatorName: "slotLaneContent", customGenerator: r.slotLaneContent, classNameGenerator: r.slotLaneClassNames, didMount: r.slotLaneDidMount, willUnmount: r.slotLaneWillUnmount })
      );
    }));
  }
}
class HH extends gt {
  constructor() {
    super(...arguments), this.rootElRef = Xn(), this.slatElRefs = new es();
  }
  render() {
    let { props: e, context: t } = this;
    return I(
      "div",
      { ref: this.rootElRef, className: "fc-timegrid-slots" },
      I(
        "table",
        { "aria-hidden": !0, className: t.theme.getClass("table"), style: {
          minWidth: e.tableMinWidth,
          width: e.clientWidth,
          height: e.minHeight
        } },
        e.tableColGroupNode,
        I(VH, { slatElRefs: this.slatElRefs, axis: e.axis, slatMetas: e.slatMetas })
      )
    );
  }
  componentDidMount() {
    this.updateSizing();
  }
  componentDidUpdate() {
    this.updateSizing();
  }
  componentWillUnmount() {
    this.props.onCoords && this.props.onCoords(null);
  }
  updateSizing() {
    let { context: e, props: t } = this;
    t.onCoords && t.clientWidth !== null && this.rootElRef.current.offsetHeight && t.onCoords(new zH(new Ka(this.rootElRef.current, UH(this.slatElRefs.currentMap, t.slatMetas), !1, !0), this.props.dateProfile, e.options.slotDuration));
  }
}
function UH(n, e) {
  return e.map((t) => n[t.key]);
}
function kl(n, e) {
  let t = [], r;
  for (r = 0; r < e; r += 1)
    t.push([]);
  if (n)
    for (r = 0; r < n.length; r += 1)
      t[n[r].col].push(n[r]);
  return t;
}
function kS(n, e) {
  let t = [];
  if (n) {
    for (let r = 0; r < e; r += 1)
      t[r] = {
        affectedInstances: n.affectedInstances,
        isEvent: n.isEvent,
        segs: []
      };
    for (let r of n.segs)
      t[r.col].segs.push(r);
  } else
    for (let r = 0; r < e; r += 1)
      t[r] = null;
  return t;
}
class WH extends gt {
  render() {
    let { props: e } = this;
    return I(FT, { elClasses: ["fc-timegrid-more-link"], elStyle: {
      top: e.top,
      bottom: e.bottom
    }, allDayDate: null, moreCnt: e.hiddenSegs.length, allSegs: e.hiddenSegs, hiddenSegs: e.hiddenSegs, extraDateSpan: e.extraDateSpan, dateProfile: e.dateProfile, todayRange: e.todayRange, popoverContent: () => lC(e.hiddenSegs, e), defaultGenerator: $H, forceTimed: !0 }, (t) => I(t, { elTag: "div", elClasses: ["fc-timegrid-more-link-inner", "fc-sticky"] }));
  }
}
function $H(n) {
  return n.shortText;
}
function GH(n, e, t) {
  let r = new DT();
  e != null && (r.strictOrder = e), t != null && (r.maxStackCnt = t);
  let i = r.addSegs(n), s = uz(i), o = YH(r);
  return o = QH(o, 1), { segRects: ZH(o), hiddenGroups: s };
}
function YH(n) {
  const { entriesByLevel: e } = n, t = Hy((r, i) => r + ":" + i, (r, i) => {
    let s = JH(n, r, i), o = MS(s, t), a = e[r][i];
    return [
      Object.assign(Object.assign({}, a), { nextLevelNodes: o[0] }),
      a.thickness + o[1]
      // the pressure builds
    ];
  });
  return MS(e.length ? { level: 0, lateralStart: 0, lateralEnd: e[0].length } : null, t)[0];
}
function MS(n, e) {
  if (!n)
    return [[], 0];
  let { level: t, lateralStart: r, lateralEnd: i } = n, s = r, o = [];
  for (; s < i; )
    o.push(e(t, s)), s += 1;
  return o.sort(qH), [
    o.map(KH),
    o[0][1]
    // first item's pressure
  ];
}
function qH(n, e) {
  return e[1] - n[1];
}
function KH(n) {
  return n[0];
}
function JH(n, e, t) {
  let { levelCoords: r, entriesByLevel: i } = n, s = i[e][t], o = r[e] + s.thickness, a = r.length, c = e;
  for (; c < a && r[c] < o; c += 1)
    ;
  for (; c < a; c += 1) {
    let u = i[c], d, h = ig(u, s.span.start, rg), p = h[0] + h[1], g = p;
    for (
      ;
      // loop through entries that horizontally intersect
      (d = u[g]) && // but not past the whole seg list
      d.span.start < s.span.end;
    )
      g += 1;
    if (p < g)
      return { level: c, lateralStart: p, lateralEnd: g };
  }
  return null;
}
function QH(n, e) {
  const t = Hy((r, i, s) => Po(r), (r, i, s) => {
    let { nextLevelNodes: o, thickness: a } = r, c = a + s, u = a / c, d, h = [];
    if (!o.length)
      d = e;
    else
      for (let g of o)
        if (d === void 0) {
          let y = t(g, i, c);
          d = y[0], h.push(y[1]);
        } else {
          let y = t(g, d, 0);
          h.push(y[1]);
        }
    let p = (d - i) * u;
    return [d - p, Object.assign(Object.assign({}, r), { thickness: p, nextLevelNodes: h })];
  });
  return n.map((r) => t(r, 0, 0)[1]);
}
function ZH(n) {
  let e = [];
  const t = Hy((i, s, o) => Po(i), (i, s, o) => {
    let a = Object.assign(Object.assign({}, i), {
      levelCoord: s,
      stackDepth: o,
      stackForward: 0
    });
    return e.push(a), a.stackForward = r(i.nextLevelNodes, s + i.thickness, o + 1) + 1;
  });
  function r(i, s, o) {
    let a = 0;
    for (let c of i)
      a = Math.max(t(c, s, o), a);
    return a;
  }
  return r(n, 0, 0), e;
}
function Hy(n, e) {
  const t = {};
  return (...r) => {
    let i = n(...r);
    return i in t ? t[i] : t[i] = e(...r);
  };
}
function _S(n, e, t = null, r = 0) {
  let i = [];
  if (t)
    for (let s = 0; s < n.length; s += 1) {
      let o = n[s], a = t.computeDateTop(o.start, e), c = Math.max(
        a + (r || 0),
        // :(
        t.computeDateTop(o.end, e)
      );
      i.push({
        start: Math.round(a),
        end: Math.round(c)
        //
      });
    }
  return i;
}
function XH(n, e, t, r) {
  let i = [], s = [];
  for (let u = 0; u < n.length; u += 1) {
    let d = e[u];
    d ? i.push({
      index: u,
      thickness: 1,
      span: d
    }) : s.push(n[u]);
  }
  let { segRects: o, hiddenGroups: a } = GH(i, t, r), c = [];
  for (let u of o)
    c.push({
      seg: n[u.index],
      rect: u
    });
  for (let u of s)
    c.push({ seg: u, rect: null });
  return { segPlacements: c, hiddenGroups: a };
}
const eU = $t({
  hour: "numeric",
  minute: "2-digit",
  meridiem: !1
});
class aC extends gt {
  render() {
    return I(By, Object.assign({}, this.props, { elClasses: [
      "fc-timegrid-event",
      "fc-v-event",
      this.props.isShort && "fc-timegrid-event-short"
    ], defaultTimeFormat: eU }));
  }
}
class tU extends gt {
  constructor() {
    super(...arguments), this.sortEventSegs = Pe(vT);
  }
  // TODO: memoize event-placement?
  render() {
    let { props: e, context: t } = this, { options: r } = t, i = r.selectMirror, s = (
      // yuck
      e.eventDrag && e.eventDrag.segs || e.eventResize && e.eventResize.segs || i && e.dateSelectionSegs || []
    ), o = (
      // TODO: messy way to compute this
      e.eventDrag && e.eventDrag.affectedInstances || e.eventResize && e.eventResize.affectedInstances || {}
    ), a = this.sortEventSegs(e.fgEventSegs, r.eventOrder);
    return I(Fy, { elTag: "td", elRef: e.elRef, elClasses: [
      "fc-timegrid-col",
      ...e.extraClassNames || []
    ], elAttrs: Object.assign({ role: "gridcell" }, e.extraDataAttrs), date: e.date, dateProfile: e.dateProfile, todayRange: e.todayRange, extraRenderProps: e.extraRenderProps }, (c) => I(
      "div",
      { className: "fc-timegrid-col-frame" },
      I(
        "div",
        { className: "fc-timegrid-col-bg" },
        this.renderFillSegs(e.businessHourSegs, "non-business"),
        this.renderFillSegs(e.bgEventSegs, "bg-event"),
        this.renderFillSegs(e.dateSelectionSegs, "highlight")
      ),
      I("div", { className: "fc-timegrid-col-events" }, this.renderFgSegs(a, o, !1, !1, !1)),
      I("div", { className: "fc-timegrid-col-events" }, this.renderFgSegs(s, {}, !!e.eventDrag, !!e.eventResize, !!i, "mirror")),
      I("div", { className: "fc-timegrid-now-indicator-container" }, this.renderNowIndicator(e.nowIndicatorSegs)),
      zy(r) && I(c, { elTag: "div", elClasses: ["fc-timegrid-col-misc"] })
    ));
  }
  renderFgSegs(e, t, r, i, s, o) {
    let { props: a } = this;
    return a.forPrint ? lC(e, a) : this.renderPositionedFgSegs(e, t, r, i, s, o);
  }
  renderPositionedFgSegs(e, t, r, i, s, o) {
    let { eventMaxStack: a, eventShortHeight: c, eventOrderStrict: u, eventMinHeight: d } = this.context.options, { date: h, slatCoords: p, eventSelection: g, todayRange: y, nowDate: b } = this.props, S = r || i || s, w = _S(e, h, p, d), { segPlacements: T, hiddenGroups: C } = XH(e, w, u, a);
    return I(
      Dt,
      null,
      this.renderHiddenGroups(C, e),
      T.map((k) => {
        let { seg: R, rect: N } = k, L = R.eventRange.instance.instanceId, j = S || !!(!t[L] && N), W = Fp(N && N.span), Z = !S && N ? this.computeSegHStyle(N) : { left: 0, right: 0 }, fe = !!N && N.stackForward > 0, Oe = !!N && N.span.end - N.span.start < c;
        return I(
          "div",
          { className: "fc-timegrid-event-harness" + (fe ? " fc-timegrid-event-harness-inset" : ""), key: o || L, style: Object.assign(Object.assign({ visibility: j ? "" : "hidden" }, W), Z) },
          I(aC, Object.assign({ seg: R, isDragging: r, isResizing: i, isDateSelecting: s, isSelected: L === g, isShort: Oe }, $s(R, y, b)))
        );
      })
    );
  }
  // will already have eventMinHeight applied because segInputs already had it
  renderHiddenGroups(e, t) {
    let { extraDateSpan: r, dateProfile: i, todayRange: s, nowDate: o, eventSelection: a, eventDrag: c, eventResize: u } = this.props;
    return I(Dt, null, e.map((d) => {
      let h = Fp(d.span), p = nU(d.entries, t);
      return I(WH, { key: Q1(zT(p)), hiddenSegs: p, top: h.top, bottom: h.bottom, extraDateSpan: r, dateProfile: i, todayRange: s, nowDate: o, eventSelection: a, eventDrag: c, eventResize: u });
    }));
  }
  renderFillSegs(e, t) {
    let { props: r, context: i } = this, o = _S(e, r.date, r.slatCoords, i.options.eventMinHeight).map((a, c) => {
      let u = e[c];
      return I("div", { key: xT(u.eventRange), className: "fc-timegrid-bg-harness", style: Fp(a) }, t === "bg-event" ? I(LT, Object.assign({ seg: u }, $s(u, r.todayRange, r.nowDate))) : BT(t));
    });
    return I(Dt, null, o);
  }
  renderNowIndicator(e) {
    let { slatCoords: t, date: r } = this.props;
    return t ? e.map((i, s) => I(
      jy,
      {
        // key doesn't matter. will only ever be one
        key: s,
        elClasses: ["fc-timegrid-now-indicator-line"],
        elStyle: {
          top: t.computeDateTop(i.start, r)
        },
        isAxis: !1,
        date: r
      }
    )) : null;
  }
  computeSegHStyle(e) {
    let { isRtl: t, options: r } = this.context, i = r.slotEventOverlap, s = e.levelCoord, o = e.levelCoord + e.thickness, a, c;
    i && (o = Math.min(1, s + (o - s) * 2)), t ? (a = 1 - o, c = s) : (a = s, c = 1 - o);
    let u = {
      zIndex: e.stackDepth + 1,
      left: a * 100 + "%",
      right: c * 100 + "%"
    };
    return i && !e.stackForward && (u[t ? "marginLeft" : "marginRight"] = 10 * 2), u;
  }
}
function lC(n, { todayRange: e, nowDate: t, eventSelection: r, eventDrag: i, eventResize: s }) {
  let o = (i ? i.affectedInstances : null) || (s ? s.affectedInstances : null) || {};
  return I(Dt, null, n.map((a) => {
    let c = a.eventRange.instance.instanceId;
    return I(
      "div",
      { key: c, style: { visibility: o[c] ? "hidden" : "" } },
      I(aC, Object.assign({ seg: a, isDragging: !1, isResizing: !1, isDateSelecting: !1, isSelected: c === r, isShort: !1 }, $s(a, e, t)))
    );
  }));
}
function Fp(n) {
  return n ? {
    top: n.start,
    bottom: -n.end
  } : { top: "", bottom: "" };
}
function nU(n, e) {
  return n.map((t) => e[t.index]);
}
class rU extends gt {
  constructor() {
    super(...arguments), this.splitFgEventSegs = Pe(kl), this.splitBgEventSegs = Pe(kl), this.splitBusinessHourSegs = Pe(kl), this.splitNowIndicatorSegs = Pe(kl), this.splitDateSelectionSegs = Pe(kl), this.splitEventDrag = Pe(kS), this.splitEventResize = Pe(kS), this.rootElRef = Xn(), this.cellElRefs = new es();
  }
  render() {
    let { props: e, context: t } = this, r = t.options.nowIndicator && e.slatCoords && e.slatCoords.safeComputeTop(e.nowDate), i = e.cells.length, s = this.splitFgEventSegs(e.fgEventSegs, i), o = this.splitBgEventSegs(e.bgEventSegs, i), a = this.splitBusinessHourSegs(e.businessHourSegs, i), c = this.splitNowIndicatorSegs(e.nowIndicatorSegs, i), u = this.splitDateSelectionSegs(e.dateSelectionSegs, i), d = this.splitEventDrag(e.eventDrag, i), h = this.splitEventResize(e.eventResize, i);
    return I(
      "div",
      { className: "fc-timegrid-cols", ref: this.rootElRef },
      I(
        "table",
        { role: "presentation", style: {
          minWidth: e.tableMinWidth,
          width: e.clientWidth
        } },
        e.tableColGroupNode,
        I(
          "tbody",
          { role: "presentation" },
          I(
            "tr",
            { role: "row" },
            e.axis && I(
              "td",
              { "aria-hidden": !0, className: "fc-timegrid-col fc-timegrid-axis" },
              I(
                "div",
                { className: "fc-timegrid-col-frame" },
                I("div", { className: "fc-timegrid-now-indicator-container" }, typeof r == "number" && I(jy, { elClasses: ["fc-timegrid-now-indicator-arrow"], elStyle: { top: r }, isAxis: !0, date: e.nowDate }))
              )
            ),
            e.cells.map((p, g) => I(tU, { key: p.key, elRef: this.cellElRefs.createRef(p.key), dateProfile: e.dateProfile, date: p.date, nowDate: e.nowDate, todayRange: e.todayRange, extraRenderProps: p.extraRenderProps, extraDataAttrs: p.extraDataAttrs, extraClassNames: p.extraClassNames, extraDateSpan: p.extraDateSpan, fgEventSegs: s[g], bgEventSegs: o[g], businessHourSegs: a[g], nowIndicatorSegs: c[g], dateSelectionSegs: u[g], eventDrag: d[g], eventResize: h[g], slatCoords: e.slatCoords, eventSelection: e.eventSelection, forPrint: e.forPrint }))
          )
        )
      )
    );
  }
  componentDidMount() {
    this.updateCoords();
  }
  componentDidUpdate() {
    this.updateCoords();
  }
  updateCoords() {
    let { props: e } = this;
    e.onColCoords && e.clientWidth !== null && e.onColCoords(new Ka(
      this.rootElRef.current,
      iU(this.cellElRefs.currentMap, e.cells),
      !0,
      // horizontal
      !1
    ));
  }
}
function iU(n, e) {
  return e.map((t) => n[t.key]);
}
class sU extends Li {
  constructor() {
    super(...arguments), this.processSlotOptions = Pe(oU), this.state = {
      slatCoords: null
    }, this.handleRootEl = (e) => {
      e ? this.context.registerInteractiveComponent(this, {
        el: e,
        isHitComboAllowed: this.props.isHitComboAllowed
      }) : this.context.unregisterInteractiveComponent(this);
    }, this.handleScrollRequest = (e) => {
      let { onScrollTopRequest: t } = this.props, { slatCoords: r } = this.state;
      if (t && r) {
        if (e.time) {
          let i = r.computeTimeTop(e.time);
          i = Math.ceil(i), i && (i += 1), t(i);
        }
        return !0;
      }
      return !1;
    }, this.handleColCoords = (e) => {
      this.colCoords = e;
    }, this.handleSlatCoords = (e) => {
      this.setState({ slatCoords: e }), this.props.onSlatCoords && this.props.onSlatCoords(e);
    };
  }
  render() {
    let { props: e, state: t } = this;
    return I(
      "div",
      { className: "fc-timegrid-body", ref: this.handleRootEl, style: {
        // these props are important to give this wrapper correct dimensions for interactions
        // TODO: if we set it here, can we avoid giving to inner tables?
        width: e.clientWidth,
        minWidth: e.tableMinWidth
      } },
      I(HH, { axis: e.axis, dateProfile: e.dateProfile, slatMetas: e.slatMetas, clientWidth: e.clientWidth, minHeight: e.expandRows ? e.clientHeight : "", tableMinWidth: e.tableMinWidth, tableColGroupNode: e.axis ? e.tableColGroupNode : null, onCoords: this.handleSlatCoords }),
      I(rU, { cells: e.cells, axis: e.axis, dateProfile: e.dateProfile, businessHourSegs: e.businessHourSegs, bgEventSegs: e.bgEventSegs, fgEventSegs: e.fgEventSegs, dateSelectionSegs: e.dateSelectionSegs, eventSelection: e.eventSelection, eventDrag: e.eventDrag, eventResize: e.eventResize, todayRange: e.todayRange, nowDate: e.nowDate, nowIndicatorSegs: e.nowIndicatorSegs, clientWidth: e.clientWidth, tableMinWidth: e.tableMinWidth, tableColGroupNode: e.tableColGroupNode, slatCoords: t.slatCoords, onColCoords: this.handleColCoords, forPrint: e.forPrint })
    );
  }
  componentDidMount() {
    this.scrollResponder = this.context.createScrollResponder(this.handleScrollRequest);
  }
  componentDidUpdate(e) {
    this.scrollResponder.update(e.dateProfile !== this.props.dateProfile);
  }
  componentWillUnmount() {
    this.scrollResponder.detach();
  }
  queryHit(e, t) {
    let { dateEnv: r, options: i } = this.context, { colCoords: s } = this, { dateProfile: o } = this.props, { slatCoords: a } = this.state, { snapDuration: c, snapsPerSlot: u } = this.processSlotOptions(this.props.slotDuration, i.snapDuration), d = s.leftToIndex(e), h = a.positions.topToIndex(t);
    if (d != null && h != null) {
      let p = this.props.cells[d], g = a.positions.tops[h], y = a.positions.getHeight(h), b = (t - g) / y, S = Math.floor(b * u), w = h * u + S, T = this.props.cells[d].date, C = Qm(o.slotMinTime, ij(c, w)), k = r.add(T, C), R = r.add(k, c);
      return {
        dateProfile: o,
        dateSpan: Object.assign({ range: { start: k, end: R }, allDay: !1 }, p.extraDateSpan),
        dayEl: s.els[d],
        rect: {
          left: s.lefts[d],
          right: s.rights[d],
          top: g,
          bottom: g + y
        },
        layer: 0
      };
    }
    return null;
  }
}
function oU(n, e) {
  let t = e || n, r = Sy(n, t);
  return r === null && (t = n, r = 1), { snapDuration: t, snapsPerSlot: r };
}
class aU extends IT {
  sliceRange(e, t) {
    let r = [];
    for (let i = 0; i < t.length; i += 1) {
      let s = Uo(e, t[i]);
      s && r.push({
        start: s.start,
        end: s.end,
        isStart: s.start.valueOf() === e.start.valueOf(),
        isEnd: s.end.valueOf() === e.end.valueOf(),
        col: i
      });
    }
    return r;
  }
}
class lU extends Li {
  constructor() {
    super(...arguments), this.buildDayRanges = Pe(cU), this.slicer = new aU(), this.timeColsRef = Xn();
  }
  render() {
    let { props: e, context: t } = this, { dateProfile: r, dayTableModel: i } = e, { nowIndicator: s, nextDayThreshold: o } = t.options, a = this.buildDayRanges(i, r, t.dateEnv);
    return I(nl, { unit: s ? "minute" : "day" }, (c, u) => I(sU, Object.assign({ ref: this.timeColsRef }, this.slicer.sliceProps(e, r, null, t, a), { forPrint: e.forPrint, axis: e.axis, dateProfile: r, slatMetas: e.slatMetas, slotDuration: e.slotDuration, cells: i.cells[0], tableColGroupNode: e.tableColGroupNode, tableMinWidth: e.tableMinWidth, clientWidth: e.clientWidth, clientHeight: e.clientHeight, expandRows: e.expandRows, nowDate: c, nowIndicatorSegs: s && this.slicer.sliceNowDate(c, r, o, t, a), todayRange: u, onScrollTopRequest: e.onScrollTopRequest, onSlatCoords: e.onSlatCoords })));
  }
}
function cU(n, e, t) {
  let r = [];
  for (let i of n.headerDates)
    r.push({
      start: t.add(i, e.slotMinTime),
      end: t.add(i, e.slotMaxTime)
    });
  return r;
}
const OS = [
  { hours: 1 },
  { minutes: 30 },
  { minutes: 15 },
  { seconds: 30 },
  { seconds: 15 }
];
function uU(n, e, t, r, i) {
  let s = /* @__PURE__ */ new Date(0), o = n, a = lt(0), c = t || dU(r), u = [];
  for (; di(o) < di(e); ) {
    let d = i.add(s, o), h = Sy(a, c) !== null;
    u.push({
      date: d,
      time: o,
      key: d.toISOString(),
      isoTimeStr: xj(d),
      isLabeled: h
    }), o = Qm(o, r), a = Qm(a, r);
  }
  return u;
}
function dU(n) {
  let e, t, r;
  for (e = OS.length - 1; e >= 0; e -= 1)
    if (t = lt(OS[e]), r = Sy(t, n), r !== null && r > 1)
      return t;
  return n;
}
class fU extends jH {
  constructor() {
    super(...arguments), this.buildTimeColsModel = Pe(hU), this.buildSlatMetas = Pe(uU);
  }
  render() {
    let { options: e, dateEnv: t, dateProfileGenerator: r } = this.context, { props: i } = this, { dateProfile: s } = i, o = this.buildTimeColsModel(s, r), a = this.allDaySplitter.splitProps(i), c = this.buildSlatMetas(s.slotMinTime, s.slotMaxTime, e.slotLabelInterval, e.slotDuration, t), { dayMinWidth: u } = e, d = !u, h = u, p = e.dayHeaders && I(MT, { dates: o.headerDates, dateProfile: s, datesRepDistinctDays: !0, renderIntro: d ? this.renderHeadAxis : null }), g = e.allDaySlot !== !1 && ((b) => I(rC, Object.assign({}, a.allDay, { dateProfile: s, dayTableModel: o, nextDayThreshold: e.nextDayThreshold, tableMinWidth: b.tableMinWidth, colGroupNode: b.tableColGroupNode, renderRowIntro: d ? this.renderTableRowAxis : null, showWeekNumbers: !1, expandRows: !1, headerAlignElRef: this.headerElRef, clientWidth: b.clientWidth, clientHeight: b.clientHeight, forPrint: i.forPrint }, this.getAllDayMaxEventProps()))), y = (b) => I(lU, Object.assign({}, a.timed, { dayTableModel: o, dateProfile: s, axis: d, slotDuration: e.slotDuration, slatMetas: c, forPrint: i.forPrint, tableColGroupNode: b.tableColGroupNode, tableMinWidth: b.tableMinWidth, clientWidth: b.clientWidth, clientHeight: b.clientHeight, onSlatCoords: this.handleSlatCoords, expandRows: b.expandRows, onScrollTopRequest: this.handleScrollTopRequest }));
    return h ? this.renderHScrollLayout(p, g, y, o.colCnt, u, c, this.state.slatCoords) : this.renderSimpleLayout(p, g, y);
  }
}
function hU(n, e) {
  let t = new _T(n.renderRange, e);
  return new OT(t, !1);
}
var pU = '.fc-v-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-v-event .fc-event-main{color:var(--fc-event-text-color);height:100%}.fc-v-event .fc-event-main-frame{display:flex;flex-direction:column;height:100%}.fc-v-event .fc-event-time{flex-grow:0;flex-shrink:0;max-height:100%;overflow:hidden}.fc-v-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-height:0}.fc-v-event .fc-event-title{bottom:0;max-height:100%;overflow:hidden;top:0}.fc-v-event:not(.fc-event-start){border-top-left-radius:0;border-top-right-radius:0;border-top-width:0}.fc-v-event:not(.fc-event-end){border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-width:0}.fc-v-event.fc-event-selected:before{left:-10px;right:-10px}.fc-v-event .fc-event-resizer-start{cursor:n-resize}.fc-v-event .fc-event-resizer-end{cursor:s-resize}.fc-v-event:not(.fc-event-selected) .fc-event-resizer{height:var(--fc-event-resizer-thickness);left:0;right:0}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start{top:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer{left:50%;margin-left:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-start{top:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc .fc-timegrid .fc-daygrid-body{z-index:2}.fc .fc-timegrid-divider{padding:0 0 2px}.fc .fc-timegrid-body{min-height:100%;position:relative;z-index:1}.fc .fc-timegrid-axis-chunk{position:relative}.fc .fc-timegrid-axis-chunk>table,.fc .fc-timegrid-slots{position:relative;z-index:1}.fc .fc-timegrid-slot{border-bottom:0;height:1.5em}.fc .fc-timegrid-slot:empty:before{content:"\\00a0"}.fc .fc-timegrid-slot-minor{border-top-style:dotted}.fc .fc-timegrid-slot-label-cushion{display:inline-block;white-space:nowrap}.fc .fc-timegrid-slot-label{vertical-align:middle}.fc .fc-timegrid-axis-cushion,.fc .fc-timegrid-slot-label-cushion{padding:0 4px}.fc .fc-timegrid-axis-frame-liquid{height:100%}.fc .fc-timegrid-axis-frame{align-items:center;display:flex;justify-content:flex-end;overflow:hidden}.fc .fc-timegrid-axis-cushion{flex-shrink:0;max-width:60px}.fc-direction-ltr .fc-timegrid-slot-label-frame{text-align:right}.fc-direction-rtl .fc-timegrid-slot-label-frame{text-align:left}.fc-liquid-hack .fc-timegrid-axis-frame-liquid{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-timegrid-col-frame{min-height:100%;position:relative}.fc-media-screen.fc-liquid-hack .fc-timegrid-col-frame{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols{bottom:0;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols>table{height:100%}.fc-media-screen .fc-timegrid-col-bg,.fc-media-screen .fc-timegrid-col-events,.fc-media-screen .fc-timegrid-now-indicator-container{left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col-bg{z-index:2}.fc .fc-timegrid-col-bg .fc-non-business{z-index:1}.fc .fc-timegrid-col-bg .fc-bg-event{z-index:2}.fc .fc-timegrid-col-bg .fc-highlight{z-index:3}.fc .fc-timegrid-bg-harness{left:0;position:absolute;right:0}.fc .fc-timegrid-col-events{z-index:3}.fc .fc-timegrid-now-indicator-container{bottom:0;overflow:hidden}.fc-direction-ltr .fc-timegrid-col-events{margin:0 2.5% 0 2px}.fc-direction-rtl .fc-timegrid-col-events{margin:0 2px 0 2.5%}.fc-timegrid-event-harness{position:absolute}.fc-timegrid-event-harness>.fc-timegrid-event{bottom:0;left:0;position:absolute;right:0;top:0}.fc-timegrid-event-harness-inset .fc-timegrid-event,.fc-timegrid-event.fc-event-mirror,.fc-timegrid-more-link{box-shadow:0 0 0 1px var(--fc-page-bg-color)}.fc-timegrid-event,.fc-timegrid-more-link{border-radius:3px;font-size:var(--fc-small-font-size)}.fc-timegrid-event{margin-bottom:1px}.fc-timegrid-event .fc-event-main{padding:1px 1px 0}.fc-timegrid-event .fc-event-time{font-size:var(--fc-small-font-size);margin-bottom:1px;white-space:nowrap}.fc-timegrid-event-short .fc-event-main-frame{flex-direction:row;overflow:hidden}.fc-timegrid-event-short .fc-event-time:after{content:"\\00a0-\\00a0"}.fc-timegrid-event-short .fc-event-title{font-size:var(--fc-small-font-size)}.fc-timegrid-more-link{background:var(--fc-more-link-bg-color);color:var(--fc-more-link-text-color);cursor:pointer;margin-bottom:1px;position:absolute;z-index:9999}.fc-timegrid-more-link-inner{padding:3px 2px;top:0}.fc-direction-ltr .fc-timegrid-more-link{right:0}.fc-direction-rtl .fc-timegrid-more-link{left:0}.fc .fc-timegrid-now-indicator-arrow,.fc .fc-timegrid-now-indicator-line{pointer-events:none}.fc .fc-timegrid-now-indicator-line{border-color:var(--fc-now-indicator-color);border-style:solid;border-width:1px 0 0;left:0;position:absolute;right:0;z-index:4}.fc .fc-timegrid-now-indicator-arrow{border-color:var(--fc-now-indicator-color);border-style:solid;margin-top:-5px;position:absolute;z-index:4}.fc-direction-ltr .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 0 5px 6px;left:0}.fc-direction-rtl .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 6px 5px 0;right:0}';
by(pU);
const mU = {
  allDaySlot: Boolean
};
var gU = eo({
  name: "@fullcalendar/timegrid",
  initialView: "timeGridWeek",
  optionRefiners: mU,
  views: {
    timeGrid: {
      component: fU,
      usesMinMaxTime: !0,
      allDaySlot: !0,
      slotDuration: "00:30:00",
      slotEventOverlap: !0
      // a bad name. confused with overlap/constraint system
    },
    timeGridDay: {
      type: "timeGrid",
      duration: { days: 1 }
    },
    timeGridWeek: {
      type: "timeGrid",
      duration: { weeks: 1 }
    }
  }
}), ag = { exports: {} }, Wu = { exports: {} }, pt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var IS;
function yU() {
  if (IS) return pt;
  IS = 1;
  var n = typeof Symbol == "function" && Symbol.for, e = n ? Symbol.for("react.element") : 60103, t = n ? Symbol.for("react.portal") : 60106, r = n ? Symbol.for("react.fragment") : 60107, i = n ? Symbol.for("react.strict_mode") : 60108, s = n ? Symbol.for("react.profiler") : 60114, o = n ? Symbol.for("react.provider") : 60109, a = n ? Symbol.for("react.context") : 60110, c = n ? Symbol.for("react.async_mode") : 60111, u = n ? Symbol.for("react.concurrent_mode") : 60111, d = n ? Symbol.for("react.forward_ref") : 60112, h = n ? Symbol.for("react.suspense") : 60113, p = n ? Symbol.for("react.suspense_list") : 60120, g = n ? Symbol.for("react.memo") : 60115, y = n ? Symbol.for("react.lazy") : 60116, b = n ? Symbol.for("react.block") : 60121, S = n ? Symbol.for("react.fundamental") : 60117, w = n ? Symbol.for("react.responder") : 60118, T = n ? Symbol.for("react.scope") : 60119;
  function C(R) {
    if (typeof R == "object" && R !== null) {
      var N = R.$$typeof;
      switch (N) {
        case e:
          switch (R = R.type, R) {
            case c:
            case u:
            case r:
            case s:
            case i:
            case h:
              return R;
            default:
              switch (R = R && R.$$typeof, R) {
                case a:
                case d:
                case y:
                case g:
                case o:
                  return R;
                default:
                  return N;
              }
          }
        case t:
          return N;
      }
    }
  }
  function k(R) {
    return C(R) === u;
  }
  return pt.AsyncMode = c, pt.ConcurrentMode = u, pt.ContextConsumer = a, pt.ContextProvider = o, pt.Element = e, pt.ForwardRef = d, pt.Fragment = r, pt.Lazy = y, pt.Memo = g, pt.Portal = t, pt.Profiler = s, pt.StrictMode = i, pt.Suspense = h, pt.isAsyncMode = function(R) {
    return k(R) || C(R) === c;
  }, pt.isConcurrentMode = k, pt.isContextConsumer = function(R) {
    return C(R) === a;
  }, pt.isContextProvider = function(R) {
    return C(R) === o;
  }, pt.isElement = function(R) {
    return typeof R == "object" && R !== null && R.$$typeof === e;
  }, pt.isForwardRef = function(R) {
    return C(R) === d;
  }, pt.isFragment = function(R) {
    return C(R) === r;
  }, pt.isLazy = function(R) {
    return C(R) === y;
  }, pt.isMemo = function(R) {
    return C(R) === g;
  }, pt.isPortal = function(R) {
    return C(R) === t;
  }, pt.isProfiler = function(R) {
    return C(R) === s;
  }, pt.isStrictMode = function(R) {
    return C(R) === i;
  }, pt.isSuspense = function(R) {
    return C(R) === h;
  }, pt.isValidElementType = function(R) {
    return typeof R == "string" || typeof R == "function" || R === r || R === u || R === s || R === i || R === h || R === p || typeof R == "object" && R !== null && (R.$$typeof === y || R.$$typeof === g || R.$$typeof === o || R.$$typeof === a || R.$$typeof === d || R.$$typeof === S || R.$$typeof === w || R.$$typeof === T || R.$$typeof === b);
  }, pt.typeOf = C, pt;
}
var mt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var NS;
function vU() {
  return NS || (NS = 1, process.env.NODE_ENV !== "production" && function() {
    var n = typeof Symbol == "function" && Symbol.for, e = n ? Symbol.for("react.element") : 60103, t = n ? Symbol.for("react.portal") : 60106, r = n ? Symbol.for("react.fragment") : 60107, i = n ? Symbol.for("react.strict_mode") : 60108, s = n ? Symbol.for("react.profiler") : 60114, o = n ? Symbol.for("react.provider") : 60109, a = n ? Symbol.for("react.context") : 60110, c = n ? Symbol.for("react.async_mode") : 60111, u = n ? Symbol.for("react.concurrent_mode") : 60111, d = n ? Symbol.for("react.forward_ref") : 60112, h = n ? Symbol.for("react.suspense") : 60113, p = n ? Symbol.for("react.suspense_list") : 60120, g = n ? Symbol.for("react.memo") : 60115, y = n ? Symbol.for("react.lazy") : 60116, b = n ? Symbol.for("react.block") : 60121, S = n ? Symbol.for("react.fundamental") : 60117, w = n ? Symbol.for("react.responder") : 60118, T = n ? Symbol.for("react.scope") : 60119;
    function C(Q) {
      return typeof Q == "string" || typeof Q == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Q === r || Q === u || Q === s || Q === i || Q === h || Q === p || typeof Q == "object" && Q !== null && (Q.$$typeof === y || Q.$$typeof === g || Q.$$typeof === o || Q.$$typeof === a || Q.$$typeof === d || Q.$$typeof === S || Q.$$typeof === w || Q.$$typeof === T || Q.$$typeof === b);
    }
    function k(Q) {
      if (typeof Q == "object" && Q !== null) {
        var ke = Q.$$typeof;
        switch (ke) {
          case e:
            var Ye = Q.type;
            switch (Ye) {
              case c:
              case u:
              case r:
              case s:
              case i:
              case h:
                return Ye;
              default:
                var it = Ye && Ye.$$typeof;
                switch (it) {
                  case a:
                  case d:
                  case y:
                  case g:
                  case o:
                    return it;
                  default:
                    return ke;
                }
            }
          case t:
            return ke;
        }
      }
    }
    var R = c, N = u, L = a, j = o, W = e, Z = d, fe = r, Oe = y, Ae = g, Y = t, re = s, q = i, U = h, J = !1;
    function we(Q) {
      return J || (J = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), z(Q) || k(Q) === c;
    }
    function z(Q) {
      return k(Q) === u;
    }
    function X(Q) {
      return k(Q) === a;
    }
    function me(Q) {
      return k(Q) === o;
    }
    function pe(Q) {
      return typeof Q == "object" && Q !== null && Q.$$typeof === e;
    }
    function he(Q) {
      return k(Q) === d;
    }
    function xe(Q) {
      return k(Q) === r;
    }
    function H(Q) {
      return k(Q) === y;
    }
    function le(Q) {
      return k(Q) === g;
    }
    function G(Q) {
      return k(Q) === t;
    }
    function oe(Q) {
      return k(Q) === s;
    }
    function ue(Q) {
      return k(Q) === i;
    }
    function ge(Q) {
      return k(Q) === h;
    }
    mt.AsyncMode = R, mt.ConcurrentMode = N, mt.ContextConsumer = L, mt.ContextProvider = j, mt.Element = W, mt.ForwardRef = Z, mt.Fragment = fe, mt.Lazy = Oe, mt.Memo = Ae, mt.Portal = Y, mt.Profiler = re, mt.StrictMode = q, mt.Suspense = U, mt.isAsyncMode = we, mt.isConcurrentMode = z, mt.isContextConsumer = X, mt.isContextProvider = me, mt.isElement = pe, mt.isForwardRef = he, mt.isFragment = xe, mt.isLazy = H, mt.isMemo = le, mt.isPortal = G, mt.isProfiler = oe, mt.isStrictMode = ue, mt.isSuspense = ge, mt.isValidElementType = C, mt.typeOf = k;
  }()), mt;
}
var PS;
function cC() {
  return PS || (PS = 1, process.env.NODE_ENV === "production" ? Wu.exports = yU() : Wu.exports = vU()), Wu.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var zp, LS;
function bU() {
  if (LS) return zp;
  LS = 1;
  var n = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var o = {}, a = 0; a < 10; a++)
        o["_" + String.fromCharCode(a)] = a;
      var c = Object.getOwnPropertyNames(o).map(function(d) {
        return o[d];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        u[d] = d;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return zp = i() ? Object.assign : function(s, o) {
    for (var a, c = r(s), u, d = 1; d < arguments.length; d++) {
      a = Object(arguments[d]);
      for (var h in a)
        e.call(a, h) && (c[h] = a[h]);
      if (n) {
        u = n(a);
        for (var p = 0; p < u.length; p++)
          t.call(a, u[p]) && (c[u[p]] = a[u[p]]);
      }
    }
    return c;
  }, zp;
}
var Vp, BS;
function Uy() {
  if (BS) return Vp;
  BS = 1;
  var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Vp = n, Vp;
}
var Hp, jS;
function uC() {
  return jS || (jS = 1, Hp = Function.call.bind(Object.prototype.hasOwnProperty)), Hp;
}
var Up, FS;
function xU() {
  if (FS) return Up;
  FS = 1;
  var n = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = Uy(), t = {}, r = uC();
    n = function(s) {
      var o = "Warning: " + s;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(s, o, a, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in s)
        if (r(s, d)) {
          var h;
          try {
            if (typeof s[d] != "function") {
              var p = Error(
                (c || "React class") + ": " + a + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            h = s[d](o, d, c, a, null, e);
          } catch (y) {
            h = y;
          }
          if (h && !(h instanceof Error) && n(
            (c || "React class") + ": type specification of " + a + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in t)) {
            t[h.message] = !0;
            var g = u ? u() : "";
            n(
              "Failed " + a + " type: " + h.message + (g ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, Up = i, Up;
}
var Wp, zS;
function SU() {
  if (zS) return Wp;
  zS = 1;
  var n = cC(), e = bU(), t = Uy(), r = uC(), i = xU(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(a) {
    var c = "Warning: " + a;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Wp = function(a, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function h(z) {
      var X = z && (u && z[u] || z[d]);
      if (typeof X == "function")
        return X;
    }
    var p = "<<anonymous>>", g = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: T(),
      arrayOf: C,
      element: k(),
      elementType: R(),
      instanceOf: N,
      node: Z(),
      objectOf: j,
      oneOf: L,
      oneOfType: W,
      shape: Oe,
      exact: Ae
    };
    function y(z, X) {
      return z === X ? z !== 0 || 1 / z === 1 / X : z !== z && X !== X;
    }
    function b(z, X) {
      this.message = z, this.data = X && typeof X == "object" ? X : {}, this.stack = "";
    }
    b.prototype = Error.prototype;
    function S(z) {
      if (process.env.NODE_ENV !== "production")
        var X = {}, me = 0;
      function pe(xe, H, le, G, oe, ue, ge) {
        if (G = G || p, ue = ue || le, ge !== t) {
          if (c) {
            var Q = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Q.name = "Invariant Violation", Q;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ke = G + ":" + le;
            !X[ke] && // Avoid spamming the console because they are often not actionable except for lib authors
            me < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + ue + "` prop on `" + G + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), X[ke] = !0, me++);
          }
        }
        return H[le] == null ? xe ? H[le] === null ? new b("The " + oe + " `" + ue + "` is marked as required " + ("in `" + G + "`, but its value is `null`.")) : new b("The " + oe + " `" + ue + "` is marked as required in " + ("`" + G + "`, but its value is `undefined`.")) : null : z(H, le, G, oe, ue);
      }
      var he = pe.bind(null, !1);
      return he.isRequired = pe.bind(null, !0), he;
    }
    function w(z) {
      function X(me, pe, he, xe, H, le) {
        var G = me[pe], oe = q(G);
        if (oe !== z) {
          var ue = U(G);
          return new b(
            "Invalid " + xe + " `" + H + "` of type " + ("`" + ue + "` supplied to `" + he + "`, expected ") + ("`" + z + "`."),
            { expectedType: z }
          );
        }
        return null;
      }
      return S(X);
    }
    function T() {
      return S(o);
    }
    function C(z) {
      function X(me, pe, he, xe, H) {
        if (typeof z != "function")
          return new b("Property `" + H + "` of component `" + he + "` has invalid PropType notation inside arrayOf.");
        var le = me[pe];
        if (!Array.isArray(le)) {
          var G = q(le);
          return new b("Invalid " + xe + " `" + H + "` of type " + ("`" + G + "` supplied to `" + he + "`, expected an array."));
        }
        for (var oe = 0; oe < le.length; oe++) {
          var ue = z(le, oe, he, xe, H + "[" + oe + "]", t);
          if (ue instanceof Error)
            return ue;
        }
        return null;
      }
      return S(X);
    }
    function k() {
      function z(X, me, pe, he, xe) {
        var H = X[me];
        if (!a(H)) {
          var le = q(H);
          return new b("Invalid " + he + " `" + xe + "` of type " + ("`" + le + "` supplied to `" + pe + "`, expected a single ReactElement."));
        }
        return null;
      }
      return S(z);
    }
    function R() {
      function z(X, me, pe, he, xe) {
        var H = X[me];
        if (!n.isValidElementType(H)) {
          var le = q(H);
          return new b("Invalid " + he + " `" + xe + "` of type " + ("`" + le + "` supplied to `" + pe + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return S(z);
    }
    function N(z) {
      function X(me, pe, he, xe, H) {
        if (!(me[pe] instanceof z)) {
          var le = z.name || p, G = we(me[pe]);
          return new b("Invalid " + xe + " `" + H + "` of type " + ("`" + G + "` supplied to `" + he + "`, expected ") + ("instance of `" + le + "`."));
        }
        return null;
      }
      return S(X);
    }
    function L(z) {
      if (!Array.isArray(z))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), o;
      function X(me, pe, he, xe, H) {
        for (var le = me[pe], G = 0; G < z.length; G++)
          if (y(le, z[G]))
            return null;
        var oe = JSON.stringify(z, function(ge, Q) {
          var ke = U(Q);
          return ke === "symbol" ? String(Q) : Q;
        });
        return new b("Invalid " + xe + " `" + H + "` of value `" + String(le) + "` " + ("supplied to `" + he + "`, expected one of " + oe + "."));
      }
      return S(X);
    }
    function j(z) {
      function X(me, pe, he, xe, H) {
        if (typeof z != "function")
          return new b("Property `" + H + "` of component `" + he + "` has invalid PropType notation inside objectOf.");
        var le = me[pe], G = q(le);
        if (G !== "object")
          return new b("Invalid " + xe + " `" + H + "` of type " + ("`" + G + "` supplied to `" + he + "`, expected an object."));
        for (var oe in le)
          if (r(le, oe)) {
            var ue = z(le, oe, he, xe, H + "." + oe, t);
            if (ue instanceof Error)
              return ue;
          }
        return null;
      }
      return S(X);
    }
    function W(z) {
      if (!Array.isArray(z))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var X = 0; X < z.length; X++) {
        var me = z[X];
        if (typeof me != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + J(me) + " at index " + X + "."
          ), o;
      }
      function pe(he, xe, H, le, G) {
        for (var oe = [], ue = 0; ue < z.length; ue++) {
          var ge = z[ue], Q = ge(he, xe, H, le, G, t);
          if (Q == null)
            return null;
          Q.data && r(Q.data, "expectedType") && oe.push(Q.data.expectedType);
        }
        var ke = oe.length > 0 ? ", expected one of type [" + oe.join(", ") + "]" : "";
        return new b("Invalid " + le + " `" + G + "` supplied to " + ("`" + H + "`" + ke + "."));
      }
      return S(pe);
    }
    function Z() {
      function z(X, me, pe, he, xe) {
        return Y(X[me]) ? null : new b("Invalid " + he + " `" + xe + "` supplied to " + ("`" + pe + "`, expected a ReactNode."));
      }
      return S(z);
    }
    function fe(z, X, me, pe, he) {
      return new b(
        (z || "React class") + ": " + X + " type `" + me + "." + pe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + he + "`."
      );
    }
    function Oe(z) {
      function X(me, pe, he, xe, H) {
        var le = me[pe], G = q(le);
        if (G !== "object")
          return new b("Invalid " + xe + " `" + H + "` of type `" + G + "` " + ("supplied to `" + he + "`, expected `object`."));
        for (var oe in z) {
          var ue = z[oe];
          if (typeof ue != "function")
            return fe(he, xe, H, oe, U(ue));
          var ge = ue(le, oe, he, xe, H + "." + oe, t);
          if (ge)
            return ge;
        }
        return null;
      }
      return S(X);
    }
    function Ae(z) {
      function X(me, pe, he, xe, H) {
        var le = me[pe], G = q(le);
        if (G !== "object")
          return new b("Invalid " + xe + " `" + H + "` of type `" + G + "` " + ("supplied to `" + he + "`, expected `object`."));
        var oe = e({}, me[pe], z);
        for (var ue in oe) {
          var ge = z[ue];
          if (r(z, ue) && typeof ge != "function")
            return fe(he, xe, H, ue, U(ge));
          if (!ge)
            return new b(
              "Invalid " + xe + " `" + H + "` key `" + ue + "` supplied to `" + he + "`.\nBad object: " + JSON.stringify(me[pe], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(z), null, "  ")
            );
          var Q = ge(le, ue, he, xe, H + "." + ue, t);
          if (Q)
            return Q;
        }
        return null;
      }
      return S(X);
    }
    function Y(z) {
      switch (typeof z) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !z;
        case "object":
          if (Array.isArray(z))
            return z.every(Y);
          if (z === null || a(z))
            return !0;
          var X = h(z);
          if (X) {
            var me = X.call(z), pe;
            if (X !== z.entries) {
              for (; !(pe = me.next()).done; )
                if (!Y(pe.value))
                  return !1;
            } else
              for (; !(pe = me.next()).done; ) {
                var he = pe.value;
                if (he && !Y(he[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function re(z, X) {
      return z === "symbol" ? !0 : X ? X["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && X instanceof Symbol : !1;
    }
    function q(z) {
      var X = typeof z;
      return Array.isArray(z) ? "array" : z instanceof RegExp ? "object" : re(X, z) ? "symbol" : X;
    }
    function U(z) {
      if (typeof z > "u" || z === null)
        return "" + z;
      var X = q(z);
      if (X === "object") {
        if (z instanceof Date)
          return "date";
        if (z instanceof RegExp)
          return "regexp";
      }
      return X;
    }
    function J(z) {
      var X = U(z);
      switch (X) {
        case "array":
        case "object":
          return "an " + X;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + X;
        default:
          return X;
      }
    }
    function we(z) {
      return !z.constructor || !z.constructor.name ? p : z.constructor.name;
    }
    return g.checkPropTypes = i, g.resetWarningCache = i.resetWarningCache, g.PropTypes = g, g;
  }, Wp;
}
var $p, VS;
function wU() {
  if (VS) return $p;
  VS = 1;
  var n = Uy();
  function e() {
  }
  function t() {
  }
  return t.resetWarningCache = e, $p = function() {
    function r(o, a, c, u, d, h) {
      if (h !== n) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: t,
      resetWarningCache: e
    };
    return s.PropTypes = s, s;
  }, $p;
}
if (process.env.NODE_ENV !== "production") {
  var EU = cC(), AU = !0;
  ag.exports = SU()(EU.isElement, AU);
} else
  ag.exports = wU()();
var TU = ag.exports;
const bo = /* @__PURE__ */ A1(TU);
var CU = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, DU = Object.defineProperty, RU = Object.defineProperties, kU = Object.getOwnPropertyDescriptors, Ud = Object.getOwnPropertySymbols, dC = Object.prototype.hasOwnProperty, fC = Object.prototype.propertyIsEnumerable, HS = (n, e, t) => e in n ? DU(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, US = (n, e) => {
  for (var t in e || (e = {}))
    dC.call(e, t) && HS(n, t, e[t]);
  if (Ud)
    for (var t of Ud(e))
      fC.call(e, t) && HS(n, t, e[t]);
  return n;
}, MU = (n, e) => RU(n, kU(e)), _U = (n, e) => {
  var t = {};
  for (var r in n)
    dC.call(n, r) && e.indexOf(r) < 0 && (t[r] = n[r]);
  if (n != null && Ud)
    for (var r of Ud(n))
      e.indexOf(r) < 0 && fC.call(n, r) && (t[r] = n[r]);
  return t;
}, Wn = (n, e, t) => {
  const r = hs(
    (i, s) => {
      var o = i, { color: a = "currentColor", size: c = 24, stroke: u = 2, children: d } = o, h = _U(o, ["color", "size", "stroke", "children"]);
      return Gm(
        "svg",
        US(MU(US({
          ref: s
        }, CU), {
          width: c,
          height: c,
          stroke: a,
          strokeWidth: u,
          className: `tabler-icon tabler-icon-${n}`
        }), h),
        [...t.map(([p, g]) => Gm(p, g)), ...d || []]
      );
    }
  );
  return r.propTypes = {
    color: bo.string,
    size: bo.oneOfType([bo.string, bo.number]),
    stroke: bo.oneOfType([bo.string, bo.number])
  }, r.displayName = `${e}`, r;
}, OU = Wn("alert-circle", "IconAlertCircle", [
  ["path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 8v4", key: "svg-1" }],
  ["path", { d: "M12 16h.01", key: "svg-2" }]
]), IU = Wn("alert-triangle", "IconAlertTriangle", [
  ["path", { d: "M12 9v4", key: "svg-0" }],
  [
    "path",
    {
      d: "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z",
      key: "svg-1"
    }
  ],
  ["path", { d: "M12 16h.01", key: "svg-2" }]
]), NU = Wn("arrow-left", "IconArrowLeft", [
  ["path", { d: "M5 12l14 0", key: "svg-0" }],
  ["path", { d: "M5 12l6 6", key: "svg-1" }],
  ["path", { d: "M5 12l6 -6", key: "svg-2" }]
]), WS = Wn("arrow-right", "IconArrowRight", [
  ["path", { d: "M5 12l14 0", key: "svg-0" }],
  ["path", { d: "M13 18l6 -6", key: "svg-1" }],
  ["path", { d: "M13 6l6 6", key: "svg-2" }]
]), Wy = Wn("check", "IconCheck", [
  ["path", { d: "M5 12l5 5l10 -10", key: "svg-0" }]
]), $y = Wn("chevron-down", "IconChevronDown", [
  ["path", { d: "M6 9l6 6l6 -6", key: "svg-0" }]
]), PU = Wn("chevron-left", "IconChevronLeft", [
  ["path", { d: "M15 6l-6 6l6 6", key: "svg-0" }]
]), LU = Wn("chevron-right", "IconChevronRight", [
  ["path", { d: "M9 6l6 6l-6 6", key: "svg-0" }]
]), hC = Wn("chevron-up", "IconChevronUp", [
  ["path", { d: "M6 15l6 -6l6 6", key: "svg-0" }]
]), pC = Wn("copy", "IconCopy", [
  [
    "path",
    {
      d: "M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1",
      key: "svg-1"
    }
  ]
]), BU = Wn("dots-vertical", "IconDotsVertical", [
  ["path", { d: "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-0" }],
  ["path", { d: "M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-1" }],
  ["path", { d: "M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-2" }]
]), jU = Wn("home", "IconHome", [
  ["path", { d: "M5 12l-2 0l9 -9l9 9l-2 0", key: "svg-0" }],
  ["path", { d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7", key: "svg-1" }],
  ["path", { d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6", key: "svg-2" }]
]), FU = Wn("pencil", "IconPencil", [
  [
    "path",
    {
      d: "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4",
      key: "svg-0"
    }
  ],
  ["path", { d: "M13.5 6.5l4 4", key: "svg-1" }]
]), zU = Wn("refresh", "IconRefresh", [
  ["path", { d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4", key: "svg-0" }],
  ["path", { d: "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4", key: "svg-1" }]
]), VU = Wn("shield-check", "IconShieldCheck", [
  [
    "path",
    {
      d: "M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06",
      key: "svg-0"
    }
  ],
  ["path", { d: "M15 19l2 2l4 -4", key: "svg-1" }]
]), HU = Wn("trash", "IconTrash", [
  ["path", { d: "M4 7l16 0", key: "svg-0" }],
  ["path", { d: "M10 11l0 6", key: "svg-1" }],
  ["path", { d: "M14 11l0 6", key: "svg-2" }],
  [
    "path",
    { d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12", key: "svg-3" }
  ],
  ["path", { d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3", key: "svg-4" }]
]), mC = { exports: {} };
(function(n, e) {
  (function(t, r) {
    n.exports = r();
  })(Da, function() {
    var t = 1e3, r = 6e4, i = 36e5, s = "millisecond", o = "second", a = "minute", c = "hour", u = "day", d = "week", h = "month", p = "quarter", g = "year", y = "date", b = "Invalid Date", S = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, w = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, T = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(Y) {
      var re = ["th", "st", "nd", "rd"], q = Y % 100;
      return "[" + Y + (re[(q - 20) % 10] || re[q] || re[0]) + "]";
    } }, C = function(Y, re, q) {
      var U = String(Y);
      return !U || U.length >= re ? Y : "" + Array(re + 1 - U.length).join(q) + Y;
    }, k = { s: C, z: function(Y) {
      var re = -Y.utcOffset(), q = Math.abs(re), U = Math.floor(q / 60), J = q % 60;
      return (re <= 0 ? "+" : "-") + C(U, 2, "0") + ":" + C(J, 2, "0");
    }, m: function Y(re, q) {
      if (re.date() < q.date()) return -Y(q, re);
      var U = 12 * (q.year() - re.year()) + (q.month() - re.month()), J = re.clone().add(U, h), we = q - J < 0, z = re.clone().add(U + (we ? -1 : 1), h);
      return +(-(U + (q - J) / (we ? J - z : z - J)) || 0);
    }, a: function(Y) {
      return Y < 0 ? Math.ceil(Y) || 0 : Math.floor(Y);
    }, p: function(Y) {
      return { M: h, y: g, w: d, d: u, D: y, h: c, m: a, s: o, ms: s, Q: p }[Y] || String(Y || "").toLowerCase().replace(/s$/, "");
    }, u: function(Y) {
      return Y === void 0;
    } }, R = "en", N = {};
    N[R] = T;
    var L = "$isDayjsObject", j = function(Y) {
      return Y instanceof Oe || !(!Y || !Y[L]);
    }, W = function Y(re, q, U) {
      var J;
      if (!re) return R;
      if (typeof re == "string") {
        var we = re.toLowerCase();
        N[we] && (J = we), q && (N[we] = q, J = we);
        var z = re.split("-");
        if (!J && z.length > 1) return Y(z[0]);
      } else {
        var X = re.name;
        N[X] = re, J = X;
      }
      return !U && J && (R = J), J || !U && R;
    }, Z = function(Y, re) {
      if (j(Y)) return Y.clone();
      var q = typeof re == "object" ? re : {};
      return q.date = Y, q.args = arguments, new Oe(q);
    }, fe = k;
    fe.l = W, fe.i = j, fe.w = function(Y, re) {
      return Z(Y, { locale: re.$L, utc: re.$u, x: re.$x, $offset: re.$offset });
    };
    var Oe = function() {
      function Y(q) {
        this.$L = W(q.locale, null, !0), this.parse(q), this.$x = this.$x || q.x || {}, this[L] = !0;
      }
      var re = Y.prototype;
      return re.parse = function(q) {
        this.$d = function(U) {
          var J = U.date, we = U.utc;
          if (J === null) return /* @__PURE__ */ new Date(NaN);
          if (fe.u(J)) return /* @__PURE__ */ new Date();
          if (J instanceof Date) return new Date(J);
          if (typeof J == "string" && !/Z$/i.test(J)) {
            var z = J.match(S);
            if (z) {
              var X = z[2] - 1 || 0, me = (z[7] || "0").substring(0, 3);
              return we ? new Date(Date.UTC(z[1], X, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, me)) : new Date(z[1], X, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, me);
            }
          }
          return new Date(J);
        }(q), this.init();
      }, re.init = function() {
        var q = this.$d;
        this.$y = q.getFullYear(), this.$M = q.getMonth(), this.$D = q.getDate(), this.$W = q.getDay(), this.$H = q.getHours(), this.$m = q.getMinutes(), this.$s = q.getSeconds(), this.$ms = q.getMilliseconds();
      }, re.$utils = function() {
        return fe;
      }, re.isValid = function() {
        return this.$d.toString() !== b;
      }, re.isSame = function(q, U) {
        var J = Z(q);
        return this.startOf(U) <= J && J <= this.endOf(U);
      }, re.isAfter = function(q, U) {
        return Z(q) < this.startOf(U);
      }, re.isBefore = function(q, U) {
        return this.endOf(U) < Z(q);
      }, re.$g = function(q, U, J) {
        return fe.u(q) ? this[U] : this.set(J, q);
      }, re.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, re.valueOf = function() {
        return this.$d.getTime();
      }, re.startOf = function(q, U) {
        var J = this, we = !!fe.u(U) || U, z = fe.p(q), X = function(oe, ue) {
          var ge = fe.w(J.$u ? Date.UTC(J.$y, ue, oe) : new Date(J.$y, ue, oe), J);
          return we ? ge : ge.endOf(u);
        }, me = function(oe, ue) {
          return fe.w(J.toDate()[oe].apply(J.toDate("s"), (we ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ue)), J);
        }, pe = this.$W, he = this.$M, xe = this.$D, H = "set" + (this.$u ? "UTC" : "");
        switch (z) {
          case g:
            return we ? X(1, 0) : X(31, 11);
          case h:
            return we ? X(1, he) : X(0, he + 1);
          case d:
            var le = this.$locale().weekStart || 0, G = (pe < le ? pe + 7 : pe) - le;
            return X(we ? xe - G : xe + (6 - G), he);
          case u:
          case y:
            return me(H + "Hours", 0);
          case c:
            return me(H + "Minutes", 1);
          case a:
            return me(H + "Seconds", 2);
          case o:
            return me(H + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, re.endOf = function(q) {
        return this.startOf(q, !1);
      }, re.$set = function(q, U) {
        var J, we = fe.p(q), z = "set" + (this.$u ? "UTC" : ""), X = (J = {}, J[u] = z + "Date", J[y] = z + "Date", J[h] = z + "Month", J[g] = z + "FullYear", J[c] = z + "Hours", J[a] = z + "Minutes", J[o] = z + "Seconds", J[s] = z + "Milliseconds", J)[we], me = we === u ? this.$D + (U - this.$W) : U;
        if (we === h || we === g) {
          var pe = this.clone().set(y, 1);
          pe.$d[X](me), pe.init(), this.$d = pe.set(y, Math.min(this.$D, pe.daysInMonth())).$d;
        } else X && this.$d[X](me);
        return this.init(), this;
      }, re.set = function(q, U) {
        return this.clone().$set(q, U);
      }, re.get = function(q) {
        return this[fe.p(q)]();
      }, re.add = function(q, U) {
        var J, we = this;
        q = Number(q);
        var z = fe.p(U), X = function(he) {
          var xe = Z(we);
          return fe.w(xe.date(xe.date() + Math.round(he * q)), we);
        };
        if (z === h) return this.set(h, this.$M + q);
        if (z === g) return this.set(g, this.$y + q);
        if (z === u) return X(1);
        if (z === d) return X(7);
        var me = (J = {}, J[a] = r, J[c] = i, J[o] = t, J)[z] || 1, pe = this.$d.getTime() + q * me;
        return fe.w(pe, this);
      }, re.subtract = function(q, U) {
        return this.add(-1 * q, U);
      }, re.format = function(q) {
        var U = this, J = this.$locale();
        if (!this.isValid()) return J.invalidDate || b;
        var we = q || "YYYY-MM-DDTHH:mm:ssZ", z = fe.z(this), X = this.$H, me = this.$m, pe = this.$M, he = J.weekdays, xe = J.months, H = J.meridiem, le = function(ue, ge, Q, ke) {
          return ue && (ue[ge] || ue(U, we)) || Q[ge].slice(0, ke);
        }, G = function(ue) {
          return fe.s(X % 12 || 12, ue, "0");
        }, oe = H || function(ue, ge, Q) {
          var ke = ue < 12 ? "AM" : "PM";
          return Q ? ke.toLowerCase() : ke;
        };
        return we.replace(w, function(ue, ge) {
          return ge || function(Q) {
            switch (Q) {
              case "YY":
                return String(U.$y).slice(-2);
              case "YYYY":
                return fe.s(U.$y, 4, "0");
              case "M":
                return pe + 1;
              case "MM":
                return fe.s(pe + 1, 2, "0");
              case "MMM":
                return le(J.monthsShort, pe, xe, 3);
              case "MMMM":
                return le(xe, pe);
              case "D":
                return U.$D;
              case "DD":
                return fe.s(U.$D, 2, "0");
              case "d":
                return String(U.$W);
              case "dd":
                return le(J.weekdaysMin, U.$W, he, 2);
              case "ddd":
                return le(J.weekdaysShort, U.$W, he, 3);
              case "dddd":
                return he[U.$W];
              case "H":
                return String(X);
              case "HH":
                return fe.s(X, 2, "0");
              case "h":
                return G(1);
              case "hh":
                return G(2);
              case "a":
                return oe(X, me, !0);
              case "A":
                return oe(X, me, !1);
              case "m":
                return String(me);
              case "mm":
                return fe.s(me, 2, "0");
              case "s":
                return String(U.$s);
              case "ss":
                return fe.s(U.$s, 2, "0");
              case "SSS":
                return fe.s(U.$ms, 3, "0");
              case "Z":
                return z;
            }
            return null;
          }(ue) || z.replace(":", "");
        });
      }, re.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, re.diff = function(q, U, J) {
        var we, z = this, X = fe.p(U), me = Z(q), pe = (me.utcOffset() - this.utcOffset()) * r, he = this - me, xe = function() {
          return fe.m(z, me);
        };
        switch (X) {
          case g:
            we = xe() / 12;
            break;
          case h:
            we = xe();
            break;
          case p:
            we = xe() / 3;
            break;
          case d:
            we = (he - pe) / 6048e5;
            break;
          case u:
            we = (he - pe) / 864e5;
            break;
          case c:
            we = he / i;
            break;
          case a:
            we = he / r;
            break;
          case o:
            we = he / t;
            break;
          default:
            we = he;
        }
        return J ? we : fe.a(we);
      }, re.daysInMonth = function() {
        return this.endOf(h).$D;
      }, re.$locale = function() {
        return N[this.$L];
      }, re.locale = function(q, U) {
        if (!q) return this.$L;
        var J = this.clone(), we = W(q, U, !0);
        return we && (J.$L = we), J;
      }, re.clone = function() {
        return fe.w(this.$d, this);
      }, re.toDate = function() {
        return new Date(this.valueOf());
      }, re.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, re.toISOString = function() {
        return this.$d.toISOString();
      }, re.toString = function() {
        return this.$d.toUTCString();
      }, Y;
    }(), Ae = Oe.prototype;
    return Z.prototype = Ae, [["$ms", s], ["$s", o], ["$m", a], ["$H", c], ["$W", u], ["$M", h], ["$y", g], ["$D", y]].forEach(function(Y) {
      Ae[Y[1]] = function(re) {
        return this.$g(re, Y[0], Y[1]);
      };
    }), Z.extend = function(Y, re) {
      return Y.$i || (Y(re, Oe, Z), Y.$i = !0), Z;
    }, Z.locale = W, Z.isDayjs = j, Z.unix = function(Y) {
      return Z(1e3 * Y);
    }, Z.en = N[R], Z.Ls = N, Z.p = {}, Z;
  });
})(mC);
var UU = mC.exports;
const xt = /* @__PURE__ */ A1(UU), WU = "_calendarWrapper_vg3lz_1", $U = "_eventContent_vg3lz_53", $S = {
  calendarWrapper: WU,
  eventContent: $U
};
function rQ({
  events: n,
  currentDate: e,
  onPrev: t,
  onNext: r,
  onToday: i,
  onTitleClick: s,
  onDatesSet: o,
  onDateClick: a
}) {
  const c = bt(null);
  wt(() => {
    if (c.current && e) {
      const d = c.current.getApi();
      xt(d.getDate()).format("YYYY-MM") !== xt(e).format("YYYY-MM") && d.gotoDate(e);
    }
  }, [e]);
  const u = (d) => /* @__PURE__ */ x.jsx(
    "div",
    {
      className: $S.eventContent,
      style: {
        backgroundColor: d.event.backgroundColor,
        color: d.event.textColor
      },
      children: d.event.title
    }
  );
  return /* @__PURE__ */ x.jsxs("div", { className: $S.calendarWrapper, children: [
    /* @__PURE__ */ x.jsxs(Fe, { justify: "center", align: "center", mb: "md", gap: "xs", children: [
      /* @__PURE__ */ x.jsx(
        hi,
        {
          variant: "subtle",
          color: "gray",
          "aria-label": "이전 달",
          onClick: t,
          disabled: !t,
          children: /* @__PURE__ */ x.jsx(PU, { size: 20 })
        }
      ),
      /* @__PURE__ */ x.jsx(
        Lc,
        {
          "aria-label": "표시 월 선택",
          disabled: !s,
          style: {
            minWidth: 80,
            textAlign: "center"
          },
          onClick: s,
          children: /* @__PURE__ */ x.jsx(ae, { fw: 500, size: "lg", children: xt(e || /* @__PURE__ */ new Date()).format("YYYY. MM") })
        }
      ),
      /* @__PURE__ */ x.jsx(
        hi,
        {
          variant: "subtle",
          color: "gray",
          "aria-label": "다음 달",
          onClick: r,
          disabled: !r,
          children: /* @__PURE__ */ x.jsx(LU, { size: 20 })
        }
      ),
      i && /* @__PURE__ */ x.jsx(
        hn,
        {
          size: "xs",
          variant: "light",
          color: "blue",
          onClick: i,
          ml: "xs",
          children: "오늘"
        }
      )
    ] }),
    /* @__PURE__ */ x.jsx(
      iC,
      {
        ref: c,
        plugins: [RH, gU],
        initialView: "dayGridMonth",
        locale: mB,
        events: n,
        height: "auto",
        headerToolbar: !1,
        initialDate: e,
        datesSet: o,
        dayCellContent: (d) => d.date.getDate().toString(),
        dayHeaderDidMount: (d) => {
          const h = d.date.getDay(), p = d.el.querySelector(".fc-col-header-cell-cushion");
          p && (h === 0 ? p.style.color = "var(--mantine-color-red-6)" : h === 6 && (p.style.color = "var(--mantine-color-blue-6)"));
        },
        dayCellDidMount: (d) => {
          const h = d.date.getDay(), p = d.el.querySelector(".fc-daygrid-day-number");
          p && (h === 0 ? p.style.color = "var(--mantine-color-red-6)" : h === 6 && (p.style.color = "var(--mantine-color-blue-6)")), a && (d.el.style.cursor = "pointer", d.el.addEventListener("click", () => {
            a(d.date);
          }));
        },
        eventContent: u
      }
    )
  ] });
}
const Yf = typeof window < "u", iQ = (n) => {
  if (!Yf) return;
  if (!n) {
    console.warn("[분석 로깅] 측정 ID가 없어 기존 GA 수집을 시작하지 않았습니다.");
    return;
  }
  const e = "google-analytics-script";
  if (!document.getElementById(e)) {
    const t = document.createElement("script");
    t.id = e, t.async = !0, t.src = `https://www.googletagmanager.com/gtag/js?id=${n}`, document.head.appendChild(t);
  }
  window.dataLayer = window.dataLayer || [], window.gtag || (window.gtag = (...t) => {
    var r;
    (r = window.dataLayer) == null || r.push(t);
  }), window.gtag("js", /* @__PURE__ */ new Date()), window.gtag("config", n, {
    ...yy(window.location.pathname, window.location.origin, "DutyOn"),
    send_page_view: !1
  }), console.info("[분석 로깅] 기존 GA 수집을 시작했습니다.");
}, GU = (n, e) => {
  if (!Yf) return;
  const t = J2(n, e);
  t && window.gtag && window.gtag("event", t.name, {
    ...t.params,
    ...yy(window.location.pathname, window.location.origin, "DutyOn")
  });
}, YU = (n, e) => {
  if (!Yf) return;
  const t = Q2(n);
  !!window.dispatchEvent(
    new CustomEvent("dutyon:page-view", {
      cancelable: !0,
      detail: { path: t }
    })
  ) && window.gtag && window.gtag("event", "page_view", {
    ...yy(t, window.location.origin, "DutyOn")
  });
}, sQ = (n) => {
  Yf && GU("duty_auto_generated", {
    duty_count: n.dutyCount,
    mode: n.mode,
    source: n.source
  });
};
function oQ() {
  const n = oB();
  return wt(() => {
    YU(n.pathname);
  }, [n.pathname]), /* @__PURE__ */ x.jsx(S1, {});
}
function aQ({
  allowedRoles: n,
  fallbackPath: e = "/login",
  onUnauthorized: t,
  fallbackElement: r = null
}) {
  const { token: i, clearToken: s, logout: o } = Z2(), [a, c] = Et(null);
  return wt(() => {
    if (!i) {
      o({ reason: "session-expired" }), c(!1);
      return;
    }
    const u = X2(i), d = u != null && u.exp ? u.exp * 1e3 <= Date.now() : !0;
    if (!u || d || u.tokenType !== "access") {
      o({ reason: "session-expired" }), c(!1);
      return;
    }
    if (!n || n.length === 0) {
      c(!0);
      return;
    }
    const h = u == null ? void 0 : u.role;
    u && h && n.includes(h) ? c(!0) : t ? t(u, {
      clearToken: s,
      reject: () => {
        c(!1);
      }
    }) : c(!1);
  }, [i, n, s, o, t]), a === null ? r : a ? /* @__PURE__ */ x.jsx(S1, {}) : /* @__PURE__ */ x.jsx(aB, { to: e, replace: !0 });
}
const gC = ps({});
function Gy(n) {
  const e = bt(null);
  return e.current === null && (e.current = n()), e.current;
}
const yC = typeof window < "u", vC = yC ? gy : wt, Yy = /* @__PURE__ */ ps(null);
function qy(n, e) {
  n.indexOf(e) === -1 && n.push(e);
}
function Vc(n, e) {
  const t = n.indexOf(e);
  t > -1 && n.splice(t, 1);
}
const Oi = (n, e, t) => t > e ? e : t < n ? n : t;
function lg(n, e) {
  return e ? `${n}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${e}` : n;
}
let rl = () => {
}, mi = () => {
};
var h1;
typeof process < "u" && ((h1 = process.env) == null ? void 0 : h1.NODE_ENV) !== "production" && (rl = (n, e, t) => {
  !n && typeof console < "u" && console.warn(lg(e, t));
}, mi = (n, e, t) => {
  if (!n)
    throw new Error(lg(e, t));
});
const ls = {}, bC = (n) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(n);
function xC(n) {
  return typeof n == "object" && n !== null;
}
const SC = (n) => /^0[^.\s]+$/u.test(n);
// @__NO_SIDE_EFFECTS__
function Ky(n) {
  let e;
  return () => (e === void 0 && (e = n()), e);
}
const Jr = /* @__NO_SIDE_EFFECTS__ */ (n) => n, qU = (n, e) => (t) => e(n(t)), Hc = (...n) => n.reduce(qU), Ja = /* @__NO_SIDE_EFFECTS__ */ (n, e, t) => {
  const r = e - n;
  return r === 0 ? 1 : (t - n) / r;
};
class Jy {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return qy(this.subscriptions, e), () => Vc(this.subscriptions, e);
  }
  notify(e, t, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](e, t, r);
      else
        for (let s = 0; s < i; s++) {
          const o = this.subscriptions[s];
          o && o(e, t, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const fi = /* @__NO_SIDE_EFFECTS__ */ (n) => n * 1e3, Kr = /* @__NO_SIDE_EFFECTS__ */ (n) => n / 1e3;
function wC(n, e) {
  return e ? n * (1e3 / e) : 0;
}
const GS = /* @__PURE__ */ new Set();
function qf(n, e, t) {
  n || GS.has(e) || (console.warn(lg(e, t)), GS.add(e));
}
const KU = (n, e, t) => {
  const r = e - n;
  return ((t - n) % r + r) % r + n;
}, EC = (n, e, t) => (((1 - 3 * t + 3 * e) * n + (3 * t - 6 * e)) * n + 3 * e) * n, JU = 1e-7, QU = 12;
function ZU(n, e, t, r, i) {
  let s, o, a = 0;
  do
    o = e + (t - e) / 2, s = EC(o, r, i) - n, s > 0 ? t = o : e = o;
  while (Math.abs(s) > JU && ++a < QU);
  return o;
}
function Uc(n, e, t, r) {
  if (n === e && t === r)
    return Jr;
  const i = (s) => ZU(s, 0, 1, n, t);
  return (s) => s === 0 || s === 1 ? s : EC(i(s), e, r);
}
const AC = (n) => (e) => e <= 0.5 ? n(2 * e) / 2 : (2 - n(2 * (1 - e))) / 2, TC = (n) => (e) => 1 - n(1 - e), CC = /* @__PURE__ */ Uc(0.33, 1.53, 0.69, 0.99), Qy = /* @__PURE__ */ TC(CC), DC = /* @__PURE__ */ AC(Qy), RC = (n) => (n *= 2) < 1 ? 0.5 * Qy(n) : 0.5 * (2 - Math.pow(2, -10 * (n - 1))), Zy = (n) => 1 - Math.sin(Math.acos(n)), kC = TC(Zy), MC = AC(Zy), XU = /* @__PURE__ */ Uc(0.42, 0, 1, 1), eW = /* @__PURE__ */ Uc(0, 0, 0.58, 1), _C = /* @__PURE__ */ Uc(0.42, 0, 0.58, 1), OC = (n) => Array.isArray(n) && typeof n[0] != "number";
function IC(n, e) {
  return OC(n) ? n[KU(0, n.length, e)] : n;
}
const NC = (n) => Array.isArray(n) && typeof n[0] == "number", YS = {
  linear: Jr,
  easeIn: XU,
  easeInOut: _C,
  easeOut: eW,
  circIn: Zy,
  circInOut: MC,
  circOut: kC,
  backIn: Qy,
  backInOut: DC,
  backOut: CC,
  anticipate: RC
}, tW = (n) => typeof n == "string", qS = (n) => {
  if (NC(n)) {
    mi(n.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [e, t, r, i] = n;
    return Uc(e, t, r, i);
  } else if (tW(n))
    return mi(YS[n] !== void 0, `Invalid easing type '${n}'`, "invalid-easing-type"), YS[n];
  return n;
}, $u = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function nW(n, e) {
  let t = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), i = !1, s = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function c(d) {
    o.has(d) && (u.schedule(d), n()), d(a);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (d, h = !1, p = !1) => {
      const y = p && i ? t : r;
      return h && o.add(d), y.has(d) || y.add(d), d;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (d) => {
      r.delete(d), o.delete(d);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (d) => {
      if (a = d, i) {
        s = !0;
        return;
      }
      i = !0, [t, r] = [r, t], t.forEach(c), t.clear(), i = !1, s && (s = !1, u.process(d));
    }
  };
  return u;
}
const rW = 40;
function PC(n, e) {
  let t = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, s = () => t = !0, o = $u.reduce((C, k) => (C[k] = nW(s), C), {}), { setup: a, read: c, resolveKeyframes: u, preUpdate: d, update: h, preRender: p, render: g, postRender: y } = o, b = () => {
    const C = ls.useManualTiming ? i.timestamp : performance.now();
    t = !1, ls.useManualTiming || (i.delta = r ? 1e3 / 60 : Math.max(Math.min(C - i.timestamp, rW), 1)), i.timestamp = C, i.isProcessing = !0, a.process(i), c.process(i), u.process(i), d.process(i), h.process(i), p.process(i), g.process(i), y.process(i), i.isProcessing = !1, t && e && (r = !1, n(b));
  }, S = () => {
    t = !0, r = !0, i.isProcessing || n(b);
  };
  return { schedule: $u.reduce((C, k) => {
    const R = o[k];
    return C[k] = (N, L = !1, j = !1) => (t || S(), R.schedule(N, L, j)), C;
  }, {}), cancel: (C) => {
    for (let k = 0; k < $u.length; k++)
      o[$u[k]].cancel(C);
  }, state: i, steps: o };
}
const { schedule: Rt, cancel: cs, state: _n, steps: Gp } = /* @__PURE__ */ PC(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Jr, !0);
let bd;
function iW() {
  bd = void 0;
}
const Qn = {
  now: () => (bd === void 0 && Qn.set(_n.isProcessing || ls.useManualTiming ? _n.timestamp : performance.now()), bd),
  set: (n) => {
    bd = n, queueMicrotask(iW);
  }
}, LC = (n) => (e) => typeof e == "string" && e.startsWith(n), BC = /* @__PURE__ */ LC("--"), sW = /* @__PURE__ */ LC("var(--"), Xy = (n) => sW(n) ? oW.test(n.split("/*")[0].trim()) : !1, oW = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function KS(n) {
  return typeof n != "string" ? !1 : n.split("/*")[0].includes("var(--");
}
const il = {
  test: (n) => typeof n == "number",
  parse: parseFloat,
  transform: (n) => n
}, gc = {
  ...il,
  transform: (n) => Oi(0, 1, n)
}, Gu = {
  ...il,
  default: 1
}, Kl = (n) => Math.round(n * 1e5) / 1e5, ev = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function aW(n) {
  return n == null;
}
const lW = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, tv = (n, e) => (t) => !!(typeof t == "string" && lW.test(t) && t.startsWith(n) || e && !aW(t) && Object.prototype.hasOwnProperty.call(t, e)), jC = (n, e, t) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, s, o, a] = r.match(ev);
  return {
    [n]: parseFloat(i),
    [e]: parseFloat(s),
    [t]: parseFloat(o),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, cW = (n) => Oi(0, 255, n), Yp = {
  ...il,
  transform: (n) => Math.round(cW(n))
}, ko = {
  test: /* @__PURE__ */ tv("rgb", "red"),
  parse: /* @__PURE__ */ jC("red", "green", "blue"),
  transform: ({ red: n, green: e, blue: t, alpha: r = 1 }) => "rgba(" + Yp.transform(n) + ", " + Yp.transform(e) + ", " + Yp.transform(t) + ", " + Kl(gc.transform(r)) + ")"
};
function uW(n) {
  let e = "", t = "", r = "", i = "";
  return n.length > 5 ? (e = n.substring(1, 3), t = n.substring(3, 5), r = n.substring(5, 7), i = n.substring(7, 9)) : (e = n.substring(1, 2), t = n.substring(2, 3), r = n.substring(3, 4), i = n.substring(4, 5), e += e, t += t, r += r, i += i), {
    red: parseInt(e, 16),
    green: parseInt(t, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const cg = {
  test: /* @__PURE__ */ tv("#"),
  parse: uW,
  transform: ko.transform
}, Wc = /* @__NO_SIDE_EFFECTS__ */ (n) => ({
  test: (e) => typeof e == "string" && e.endsWith(n) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${n}`
}), Ms = /* @__PURE__ */ Wc("deg"), Mi = /* @__PURE__ */ Wc("%"), Te = /* @__PURE__ */ Wc("px"), dW = /* @__PURE__ */ Wc("vh"), fW = /* @__PURE__ */ Wc("vw"), JS = {
  ...Mi,
  parse: (n) => Mi.parse(n) / 100,
  transform: (n) => Mi.transform(n * 100)
}, Ia = {
  test: /* @__PURE__ */ tv("hsl", "hue"),
  parse: /* @__PURE__ */ jC("hue", "saturation", "lightness"),
  transform: ({ hue: n, saturation: e, lightness: t, alpha: r = 1 }) => "hsla(" + Math.round(n) + ", " + Mi.transform(Kl(e)) + ", " + Mi.transform(Kl(t)) + ", " + Kl(gc.transform(r)) + ")"
}, rn = {
  test: (n) => ko.test(n) || cg.test(n) || Ia.test(n),
  parse: (n) => ko.test(n) ? ko.parse(n) : Ia.test(n) ? Ia.parse(n) : cg.parse(n),
  transform: (n) => typeof n == "string" ? n : n.hasOwnProperty("red") ? ko.transform(n) : Ia.transform(n),
  getAnimatableNone: (n) => {
    const e = rn.parse(n);
    return e.alpha = 0, rn.transform(e);
  }
}, hW = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function pW(n) {
  var e, t;
  return isNaN(n) && typeof n == "string" && (((e = n.match(ev)) == null ? void 0 : e.length) || 0) + (((t = n.match(hW)) == null ? void 0 : t.length) || 0) > 0;
}
const FC = "number", zC = "color", mW = "var", gW = "var(", QS = "${}", yW = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function yc(n) {
  const e = n.toString(), t = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let s = 0;
  const a = e.replace(yW, (c) => (rn.test(c) ? (r.color.push(s), i.push(zC), t.push(rn.parse(c))) : c.startsWith(gW) ? (r.var.push(s), i.push(mW), t.push(c)) : (r.number.push(s), i.push(FC), t.push(parseFloat(c))), ++s, QS)).split(QS);
  return { values: t, split: a, indexes: r, types: i };
}
function VC(n) {
  return yc(n).values;
}
function HC(n) {
  const { split: e, types: t } = yc(n), r = e.length;
  return (i) => {
    let s = "";
    for (let o = 0; o < r; o++)
      if (s += e[o], i[o] !== void 0) {
        const a = t[o];
        a === FC ? s += Kl(i[o]) : a === zC ? s += rn.transform(i[o]) : s += i[o];
      }
    return s;
  };
}
const vW = (n) => typeof n == "number" ? 0 : rn.test(n) ? rn.getAnimatableNone(n) : n;
function bW(n) {
  const e = VC(n);
  return HC(n)(e.map(vW));
}
const Zs = {
  test: pW,
  parse: VC,
  createTransformer: HC,
  getAnimatableNone: bW
};
function qp(n, e, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? n + (e - n) * 6 * t : t < 1 / 2 ? e : t < 2 / 3 ? n + (e - n) * (2 / 3 - t) * 6 : n;
}
function xW({ hue: n, saturation: e, lightness: t, alpha: r }) {
  n /= 360, e /= 100, t /= 100;
  let i = 0, s = 0, o = 0;
  if (!e)
    i = s = o = t;
  else {
    const a = t < 0.5 ? t * (1 + e) : t + e - t * e, c = 2 * t - a;
    i = qp(c, a, n + 1 / 3), s = qp(c, a, n), o = qp(c, a, n - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(s * 255),
    blue: Math.round(o * 255),
    alpha: r
  };
}
function Wd(n, e) {
  return (t) => t > 0 ? e : n;
}
const Ft = (n, e, t) => n + (e - n) * t, Kp = (n, e, t) => {
  const r = n * n, i = t * (e * e - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, SW = [cg, ko, Ia], wW = (n) => SW.find((e) => e.test(n));
function ZS(n) {
  const e = wW(n);
  if (rl(!!e, `'${n}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !e)
    return !1;
  let t = e.parse(n);
  return e === Ia && (t = xW(t)), t;
}
const XS = (n, e) => {
  const t = ZS(n), r = ZS(e);
  if (!t || !r)
    return Wd(n, e);
  const i = { ...t };
  return (s) => (i.red = Kp(t.red, r.red, s), i.green = Kp(t.green, r.green, s), i.blue = Kp(t.blue, r.blue, s), i.alpha = Ft(t.alpha, r.alpha, s), ko.transform(i));
}, ug = /* @__PURE__ */ new Set(["none", "hidden"]);
function EW(n, e) {
  return ug.has(n) ? (t) => t <= 0 ? n : e : (t) => t >= 1 ? e : n;
}
function AW(n, e) {
  return (t) => Ft(n, e, t);
}
function nv(n) {
  return typeof n == "number" ? AW : typeof n == "string" ? Xy(n) ? Wd : rn.test(n) ? XS : DW : Array.isArray(n) ? UC : typeof n == "object" ? rn.test(n) ? XS : TW : Wd;
}
function UC(n, e) {
  const t = [...n], r = t.length, i = n.map((s, o) => nv(s)(s, e[o]));
  return (s) => {
    for (let o = 0; o < r; o++)
      t[o] = i[o](s);
    return t;
  };
}
function TW(n, e) {
  const t = { ...n, ...e }, r = {};
  for (const i in t)
    n[i] !== void 0 && e[i] !== void 0 && (r[i] = nv(n[i])(n[i], e[i]));
  return (i) => {
    for (const s in r)
      t[s] = r[s](i);
    return t;
  };
}
function CW(n, e) {
  const t = [], r = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < e.values.length; i++) {
    const s = e.types[i], o = n.indexes[s][r[s]], a = n.values[o] ?? 0;
    t[i] = a, r[s]++;
  }
  return t;
}
const DW = (n, e) => {
  const t = Zs.createTransformer(e), r = yc(n), i = yc(e);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? ug.has(n) && !i.values.length || ug.has(e) && !r.values.length ? EW(n, e) : Hc(UC(CW(r, i), i.values), t) : (rl(!0, `Complex values '${n}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Wd(n, e));
};
function WC(n, e, t) {
  return typeof n == "number" && typeof e == "number" && typeof t == "number" ? Ft(n, e, t) : nv(n)(n, e);
}
const RW = (n) => {
  const e = ({ timestamp: t }) => n(t);
  return {
    start: (t = !0) => Rt.update(e, t),
    stop: () => cs(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => _n.isProcessing ? _n.timestamp : Qn.now()
  };
}, $C = (n, e, t = 10) => {
  let r = "";
  const i = Math.max(Math.round(e / t), 2);
  for (let s = 0; s < i; s++)
    r += Math.round(n(s / (i - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, $d = 2e4;
function rv(n) {
  let e = 0;
  const t = 50;
  let r = n.next(e);
  for (; !r.done && e < $d; )
    e += t, r = n.next(e);
  return e >= $d ? 1 / 0 : e;
}
function GC(n, e = 100, t) {
  const r = t({ ...n, keyframes: [0, e] }), i = Math.min(rv(r), $d);
  return {
    type: "keyframes",
    ease: (s) => r.next(i * s).value / e,
    duration: /* @__PURE__ */ Kr(i)
  };
}
const kW = 5;
function YC(n, e, t) {
  const r = Math.max(e - kW, 0);
  return wC(t - n(r), e - r);
}
const Ut = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, Jp = 1e-3;
function MW({ duration: n = Ut.duration, bounce: e = Ut.bounce, velocity: t = Ut.velocity, mass: r = Ut.mass }) {
  let i, s;
  rl(n <= /* @__PURE__ */ fi(Ut.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let o = 1 - e;
  o = Oi(Ut.minDamping, Ut.maxDamping, o), n = Oi(Ut.minDuration, Ut.maxDuration, /* @__PURE__ */ Kr(n)), o < 1 ? (i = (u) => {
    const d = u * o, h = d * n, p = d - t, g = dg(u, o), y = Math.exp(-h);
    return Jp - p / g * y;
  }, s = (u) => {
    const h = u * o * n, p = h * t + t, g = Math.pow(o, 2) * Math.pow(u, 2) * n, y = Math.exp(-h), b = dg(Math.pow(u, 2), o);
    return (-i(u) + Jp > 0 ? -1 : 1) * ((p - g) * y) / b;
  }) : (i = (u) => {
    const d = Math.exp(-u * n), h = (u - t) * n + 1;
    return -Jp + d * h;
  }, s = (u) => {
    const d = Math.exp(-u * n), h = (t - u) * (n * n);
    return d * h;
  });
  const a = 5 / n, c = OW(i, s, a);
  if (n = /* @__PURE__ */ fi(n), isNaN(c))
    return {
      stiffness: Ut.stiffness,
      damping: Ut.damping,
      duration: n
    };
  {
    const u = Math.pow(c, 2) * r;
    return {
      stiffness: u,
      damping: o * 2 * Math.sqrt(r * u),
      duration: n
    };
  }
}
const _W = 12;
function OW(n, e, t) {
  let r = t;
  for (let i = 1; i < _W; i++)
    r = r - n(r) / e(r);
  return r;
}
function dg(n, e) {
  return n * Math.sqrt(1 - e * e);
}
const IW = ["duration", "bounce"], NW = ["stiffness", "damping", "mass"];
function ew(n, e) {
  return e.some((t) => n[t] !== void 0);
}
function PW(n) {
  let e = {
    velocity: Ut.velocity,
    stiffness: Ut.stiffness,
    damping: Ut.damping,
    mass: Ut.mass,
    isResolvedFromDuration: !1,
    ...n
  };
  if (!ew(n, NW) && ew(n, IW))
    if (n.visualDuration) {
      const t = n.visualDuration, r = 2 * Math.PI / (t * 1.2), i = r * r, s = 2 * Oi(0.05, 1, 1 - (n.bounce || 0)) * Math.sqrt(i);
      e = {
        ...e,
        mass: Ut.mass,
        stiffness: i,
        damping: s
      };
    } else {
      const t = MW(n);
      e = {
        ...e,
        ...t,
        mass: Ut.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function vc(n = Ut.visualDuration, e = Ut.bounce) {
  const t = typeof n != "object" ? {
    visualDuration: n,
    keyframes: [0, 1],
    bounce: e
  } : n;
  let { restSpeed: r, restDelta: i } = t;
  const s = t.keyframes[0], o = t.keyframes[t.keyframes.length - 1], a = { done: !1, value: s }, { stiffness: c, damping: u, mass: d, duration: h, velocity: p, isResolvedFromDuration: g } = PW({
    ...t,
    velocity: -/* @__PURE__ */ Kr(t.velocity || 0)
  }), y = p || 0, b = u / (2 * Math.sqrt(c * d)), S = o - s, w = /* @__PURE__ */ Kr(Math.sqrt(c / d)), T = Math.abs(S) < 5;
  r || (r = T ? Ut.restSpeed.granular : Ut.restSpeed.default), i || (i = T ? Ut.restDelta.granular : Ut.restDelta.default);
  let C;
  if (b < 1) {
    const R = dg(w, b);
    C = (N) => {
      const L = Math.exp(-b * w * N);
      return o - L * ((y + b * w * S) / R * Math.sin(R * N) + S * Math.cos(R * N));
    };
  } else if (b === 1)
    C = (R) => o - Math.exp(-w * R) * (S + (y + w * S) * R);
  else {
    const R = w * Math.sqrt(b * b - 1);
    C = (N) => {
      const L = Math.exp(-b * w * N), j = Math.min(R * N, 300);
      return o - L * ((y + b * w * S) * Math.sinh(j) + R * S * Math.cosh(j)) / R;
    };
  }
  const k = {
    calculatedDuration: g && h || null,
    next: (R) => {
      const N = C(R);
      if (g)
        a.done = R >= h;
      else {
        let L = R === 0 ? y : 0;
        b < 1 && (L = R === 0 ? /* @__PURE__ */ fi(y) : YC(C, R, N));
        const j = Math.abs(L) <= r, W = Math.abs(o - N) <= i;
        a.done = j && W;
      }
      return a.value = a.done ? o : N, a;
    },
    toString: () => {
      const R = Math.min(rv(k), $d), N = $C((L) => k.next(R * L).value, R, 30);
      return R + "ms " + N;
    },
    toTransition: () => {
    }
  };
  return k;
}
vc.applyToOptions = (n) => {
  const e = GC(n, 100, vc);
  return n.ease = e.ease, n.duration = /* @__PURE__ */ fi(e.duration), n.type = "keyframes", n;
};
function fg({ keyframes: n, velocity: e = 0, power: t = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: s = 500, modifyTarget: o, min: a, max: c, restDelta: u = 0.5, restSpeed: d }) {
  const h = n[0], p = {
    done: !1,
    value: h
  }, g = (j) => a !== void 0 && j < a || c !== void 0 && j > c, y = (j) => a === void 0 ? c : c === void 0 || Math.abs(a - j) < Math.abs(c - j) ? a : c;
  let b = t * e;
  const S = h + b, w = o === void 0 ? S : o(S);
  w !== S && (b = w - h);
  const T = (j) => -b * Math.exp(-j / r), C = (j) => w + T(j), k = (j) => {
    const W = T(j), Z = C(j);
    p.done = Math.abs(W) <= u, p.value = p.done ? w : Z;
  };
  let R, N;
  const L = (j) => {
    g(p.value) && (R = j, N = vc({
      keyframes: [p.value, y(p.value)],
      velocity: YC(C, j, p.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: s,
      restDelta: u,
      restSpeed: d
    }));
  };
  return L(0), {
    calculatedDuration: null,
    next: (j) => {
      let W = !1;
      return !N && R === void 0 && (W = !0, k(j), L(j)), R !== void 0 && j >= R ? N.next(j - R) : (!W && k(j), p);
    }
  };
}
function LW(n, e, t) {
  const r = [], i = t || ls.mix || WC, s = n.length - 1;
  for (let o = 0; o < s; o++) {
    let a = i(n[o], n[o + 1]);
    if (e) {
      const c = Array.isArray(e) ? e[o] || Jr : e;
      a = Hc(c, a);
    }
    r.push(a);
  }
  return r;
}
function qC(n, e, { clamp: t = !0, ease: r, mixer: i } = {}) {
  const s = n.length;
  if (mi(s === e.length, "Both input and output ranges must be the same length", "range-length"), s === 1)
    return () => e[0];
  if (s === 2 && e[0] === e[1])
    return () => e[1];
  const o = n[0] === n[1];
  n[0] > n[s - 1] && (n = [...n].reverse(), e = [...e].reverse());
  const a = LW(e, r, i), c = a.length, u = (d) => {
    if (o && d < n[0])
      return e[0];
    let h = 0;
    if (c > 1)
      for (; h < n.length - 2 && !(d < n[h + 1]); h++)
        ;
    const p = /* @__PURE__ */ Ja(n[h], n[h + 1], d);
    return a[h](p);
  };
  return t ? (d) => u(Oi(n[0], n[s - 1], d)) : u;
}
function KC(n, e) {
  const t = n[n.length - 1];
  for (let r = 1; r <= e; r++) {
    const i = /* @__PURE__ */ Ja(0, e, r);
    n.push(Ft(t, 1, i));
  }
}
function JC(n) {
  const e = [0];
  return KC(e, n.length - 1), e;
}
function BW(n, e) {
  return n.map((t) => t * e);
}
function jW(n, e) {
  return n.map(() => e || _C).splice(0, n.length - 1);
}
function Na({ duration: n = 300, keyframes: e, times: t, ease: r = "easeInOut" }) {
  const i = OC(r) ? r.map(qS) : qS(r), s = {
    done: !1,
    value: e[0]
  }, o = BW(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    t && t.length === e.length ? t : JC(e),
    n
  ), a = qC(o, e, {
    ease: Array.isArray(i) ? i : jW(e, i)
  });
  return {
    calculatedDuration: n,
    next: (c) => (s.value = a(c), s.done = c >= n, s)
  };
}
const FW = (n) => n !== null;
function iv(n, { repeat: e, repeatType: t = "loop" }, r, i = 1) {
  const s = n.filter(FW), a = i < 0 || e && t !== "loop" && e % 2 === 1 ? 0 : s.length - 1;
  return !a || r === void 0 ? s[a] : r;
}
const zW = {
  decay: fg,
  inertia: fg,
  tween: Na,
  keyframes: Na,
  spring: vc
};
function QC(n) {
  typeof n.type == "string" && (n.type = zW[n.type]);
}
class sv {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((e) => {
      this.resolve = e;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(e, t) {
    return this.finished.then(e, t);
  }
}
const VW = (n) => n / 100;
class ov extends sv {
  constructor(e) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var r, i;
      const { motionValue: t } = this.options;
      t && t.updatedAt !== Qn.now() && this.tick(Qn.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (i = (r = this.options).onStop) == null || i.call(r));
    }, this.options = e, this.initAnimation(), this.play(), e.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: e } = this;
    QC(e);
    const { type: t = Na, repeat: r = 0, repeatDelay: i = 0, repeatType: s, velocity: o = 0 } = e;
    let { keyframes: a } = e;
    const c = t || Na;
    process.env.NODE_ENV !== "production" && c !== Na && mi(a.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${a}`, "spring-two-frames"), c !== Na && typeof a[0] != "number" && (this.mixKeyframes = Hc(VW, WC(a[0], a[1])), a = [0, 100]);
    const u = c({ ...e, keyframes: a });
    s === "mirror" && (this.mirroredGenerator = c({
      ...e,
      keyframes: [...a].reverse(),
      velocity: -o
    })), u.calculatedDuration === null && (u.calculatedDuration = rv(u));
    const { calculatedDuration: d } = u;
    this.calculatedDuration = d, this.resolvedDuration = d + i, this.totalDuration = this.resolvedDuration * (r + 1) - i, this.generator = u;
  }
  updateTime(e) {
    const t = Math.round(e - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = t;
  }
  tick(e, t = !1) {
    const { generator: r, totalDuration: i, mixKeyframes: s, mirroredGenerator: o, resolvedDuration: a, calculatedDuration: c } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: u = 0, keyframes: d, repeat: h, repeatType: p, repeatDelay: g, type: y, onUpdate: b, finalKeyframe: S } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - i / this.speed, this.startTime)), t ? this.currentTime = e : this.updateTime(e);
    const w = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1), T = this.playbackSpeed >= 0 ? w < 0 : w > i;
    this.currentTime = Math.max(w, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = i);
    let C = this.currentTime, k = r;
    if (h) {
      const j = Math.min(this.currentTime, i) / a;
      let W = Math.floor(j), Z = j % 1;
      !Z && j >= 1 && (Z = 1), Z === 1 && W--, W = Math.min(W, h + 1), !!(W % 2) && (p === "reverse" ? (Z = 1 - Z, g && (Z -= g / a)) : p === "mirror" && (k = o)), C = Oi(0, 1, Z) * a;
    }
    const R = T ? { done: !1, value: d[0] } : k.next(C);
    s && (R.value = s(R.value));
    let { done: N } = R;
    !T && c !== null && (N = this.playbackSpeed >= 0 ? this.currentTime >= i : this.currentTime <= 0);
    const L = this.holdTime === null && (this.state === "finished" || this.state === "running" && N);
    return L && y !== fg && (R.value = iv(d, this.options, S, this.speed)), b && b(R.value), L && this.finish(), R;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, t) {
    return this.finished.then(e, t);
  }
  get duration() {
    return /* @__PURE__ */ Kr(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: e = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ Kr(e);
  }
  get time() {
    return /* @__PURE__ */ Kr(this.currentTime);
  }
  set time(e) {
    var t;
    e = /* @__PURE__ */ fi(e), this.currentTime = e, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed), (t = this.driver) == null || t.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    this.updateTime(Qn.now());
    const t = this.playbackSpeed !== e;
    this.playbackSpeed = e, t && (this.time = /* @__PURE__ */ Kr(this.currentTime));
  }
  play() {
    var i, s;
    if (this.isStopped)
      return;
    const { driver: e = RW, startTime: t } = this.options;
    this.driver || (this.driver = e((o) => this.tick(o))), (s = (i = this.options).onPlay) == null || s.call(i);
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = t ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(Qn.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var e, t;
    this.notifyFinished(), this.teardown(), this.state = "finished", (t = (e = this.options).onComplete) == null || t.call(e);
  }
  cancel() {
    var e, t;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (t = (e = this.options).onCancel) == null || t.call(e);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
  attachTimeline(e) {
    var t;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (t = this.driver) == null || t.stop(), e.observe(this);
  }
}
function HW(n) {
  for (let e = 1; e < n.length; e++)
    n[e] ?? (n[e] = n[e - 1]);
}
const Mo = (n) => n * 180 / Math.PI, hg = (n) => {
  const e = Mo(Math.atan2(n[1], n[0]));
  return pg(e);
}, UW = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (n) => (Math.abs(n[0]) + Math.abs(n[3])) / 2,
  rotate: hg,
  rotateZ: hg,
  skewX: (n) => Mo(Math.atan(n[1])),
  skewY: (n) => Mo(Math.atan(n[2])),
  skew: (n) => (Math.abs(n[1]) + Math.abs(n[2])) / 2
}, pg = (n) => (n = n % 360, n < 0 && (n += 360), n), tw = hg, nw = (n) => Math.sqrt(n[0] * n[0] + n[1] * n[1]), rw = (n) => Math.sqrt(n[4] * n[4] + n[5] * n[5]), WW = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: nw,
  scaleY: rw,
  scale: (n) => (nw(n) + rw(n)) / 2,
  rotateX: (n) => pg(Mo(Math.atan2(n[6], n[5]))),
  rotateY: (n) => pg(Mo(Math.atan2(-n[2], n[0]))),
  rotateZ: tw,
  rotate: tw,
  skewX: (n) => Mo(Math.atan(n[4])),
  skewY: (n) => Mo(Math.atan(n[1])),
  skew: (n) => (Math.abs(n[1]) + Math.abs(n[4])) / 2
};
function mg(n) {
  return n.includes("scale") ? 1 : 0;
}
function gg(n, e) {
  if (!n || n === "none")
    return mg(e);
  const t = n.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, i;
  if (t)
    r = WW, i = t;
  else {
    const a = n.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = UW, i = a;
  }
  if (!i)
    return mg(e);
  const s = r[e], o = i[1].split(",").map(GW);
  return typeof s == "function" ? s(o) : o[s];
}
const $W = (n, e) => {
  const { transform: t = "none" } = getComputedStyle(n);
  return gg(t, e);
};
function GW(n) {
  return parseFloat(n.trim());
}
const sl = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], ol = new Set(sl), iw = (n) => n === il || n === Te, YW = /* @__PURE__ */ new Set(["x", "y", "z"]), qW = sl.filter((n) => !YW.has(n));
function KW(n) {
  const e = [];
  return qW.forEach((t) => {
    const r = n.getValue(t);
    r !== void 0 && (e.push([t, r.get()]), r.set(t.startsWith("scale") ? 1 : 0));
  }), e;
}
const zs = {
  // Dimensions
  width: ({ x: n }, { paddingLeft: e = "0", paddingRight: t = "0" }) => n.max - n.min - parseFloat(e) - parseFloat(t),
  height: ({ y: n }, { paddingTop: e = "0", paddingBottom: t = "0" }) => n.max - n.min - parseFloat(e) - parseFloat(t),
  top: (n, { top: e }) => parseFloat(e),
  left: (n, { left: e }) => parseFloat(e),
  bottom: ({ y: n }, { top: e }) => parseFloat(e) + (n.max - n.min),
  right: ({ x: n }, { left: e }) => parseFloat(e) + (n.max - n.min),
  // Transform
  x: (n, { transform: e }) => gg(e, "x"),
  y: (n, { transform: e }) => gg(e, "y")
};
zs.translateX = zs.x;
zs.translateY = zs.y;
const Lo = /* @__PURE__ */ new Set();
let yg = !1, vg = !1, bg = !1;
function ZC() {
  if (vg) {
    const n = Array.from(Lo).filter((r) => r.needsMeasurement), e = new Set(n.map((r) => r.element)), t = /* @__PURE__ */ new Map();
    e.forEach((r) => {
      const i = KW(r);
      i.length && (t.set(r, i), r.render());
    }), n.forEach((r) => r.measureInitialState()), e.forEach((r) => {
      r.render();
      const i = t.get(r);
      i && i.forEach(([s, o]) => {
        var a;
        (a = r.getValue(s)) == null || a.set(o);
      });
    }), n.forEach((r) => r.measureEndState()), n.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  vg = !1, yg = !1, Lo.forEach((n) => n.complete(bg)), Lo.clear();
}
function XC() {
  Lo.forEach((n) => {
    n.readKeyframes(), n.needsMeasurement && (vg = !0);
  });
}
function JW() {
  bg = !0, XC(), ZC(), bg = !1;
}
class av {
  constructor(e, t, r, i, s, o = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...e], this.onComplete = t, this.name = r, this.motionValue = i, this.element = s, this.isAsync = o;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (Lo.add(this), yg || (yg = !0, Rt.read(XC), Rt.resolveKeyframes(ZC))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: t, element: r, motionValue: i } = this;
    if (e[0] === null) {
      const s = i == null ? void 0 : i.get(), o = e[e.length - 1];
      if (s !== void 0)
        e[0] = s;
      else if (r && t) {
        const a = r.readValue(t, o);
        a != null && (e[0] = a);
      }
      e[0] === void 0 && (e[0] = o), i && s === void 0 && i.set(e[0]);
    }
    HW(e);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(e = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e), Lo.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Lo.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const QW = (n) => n.startsWith("--");
function ZW(n, e, t) {
  QW(e) ? n.style.setProperty(e, t) : n.style[e] = t;
}
const XW = /* @__PURE__ */ Ky(() => window.ScrollTimeline !== void 0), e3 = {};
function t3(n, e) {
  const t = /* @__PURE__ */ Ky(n);
  return () => e3[e] ?? t();
}
const eD = /* @__PURE__ */ t3(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Fl = ([n, e, t, r]) => `cubic-bezier(${n}, ${e}, ${t}, ${r})`, sw = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Fl([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Fl([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Fl([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Fl([0.33, 1.53, 0.69, 0.99])
};
function tD(n, e) {
  if (n)
    return typeof n == "function" ? eD() ? $C(n, e) : "ease-out" : NC(n) ? Fl(n) : Array.isArray(n) ? n.map((t) => tD(t, e) || sw.easeOut) : sw[n];
}
function n3(n, e, t, { delay: r = 0, duration: i = 300, repeat: s = 0, repeatType: o = "loop", ease: a = "easeOut", times: c } = {}, u = void 0) {
  const d = {
    [e]: t
  };
  c && (d.offset = c);
  const h = tD(a, i);
  Array.isArray(h) && (d.easing = h);
  const p = {
    delay: r,
    duration: i,
    easing: Array.isArray(h) ? "linear" : h,
    fill: "both",
    iterations: s + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  };
  return u && (p.pseudoElement = u), n.animate(d, p);
}
function lv(n) {
  return typeof n == "function" && "applyToOptions" in n;
}
function r3({ type: n, ...e }) {
  return lv(n) && eD() ? n.applyToOptions(e) : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
}
class i3 extends sv {
  constructor(e) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !e)
      return;
    const { element: t, name: r, keyframes: i, pseudoElement: s, allowFlatten: o = !1, finalKeyframe: a, onComplete: c } = e;
    this.isPseudoElement = !!s, this.allowFlatten = o, this.options = e, mi(typeof e.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const u = r3(e);
    this.animation = n3(t, r, i, u, s), u.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !s) {
        const d = iv(i, this.options, a, this.speed);
        this.updateMotionValue ? this.updateMotionValue(d) : ZW(t, r, d), this.animation.cancel();
      }
      c == null || c(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var e, t;
    (t = (e = this.animation).finish) == null || t.call(e);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: e } = this;
    e === "idle" || e === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var e, t;
    this.isPseudoElement || (t = (e = this.animation).commitStyles) == null || t.call(e);
  }
  get duration() {
    var t, r;
    const e = ((r = (t = this.animation.effect) == null ? void 0 : t.getComputedTiming) == null ? void 0 : r.call(t).duration) || 0;
    return /* @__PURE__ */ Kr(Number(e));
  }
  get iterationDuration() {
    const { delay: e = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ Kr(e);
  }
  get time() {
    return /* @__PURE__ */ Kr(Number(this.animation.currentTime) || 0);
  }
  set time(e) {
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ fi(e);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(e) {
    e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(e) {
    this.manualStartTime = this.animation.startTime = e;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: e, observe: t }) {
    var r;
    return this.allowFlatten && ((r = this.animation.effect) == null || r.updateTiming({ easing: "linear" })), this.animation.onfinish = null, e && XW() ? (this.animation.timeline = e, Jr) : t(this);
  }
}
const nD = {
  anticipate: RC,
  backInOut: DC,
  circInOut: MC
};
function s3(n) {
  return n in nD;
}
function o3(n) {
  typeof n.ease == "string" && s3(n.ease) && (n.ease = nD[n.ease]);
}
const Qp = 10;
class a3 extends i3 {
  constructor(e) {
    o3(e), QC(e), super(e), e.startTime !== void 0 && (this.startTime = e.startTime), this.options = e;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read committed styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(e) {
    const { motionValue: t, onUpdate: r, onComplete: i, element: s, ...o } = this.options;
    if (!t)
      return;
    if (e !== void 0) {
      t.set(e);
      return;
    }
    const a = new ov({
      ...o,
      autoplay: !1
    }), c = Math.max(Qp, Qn.now() - this.startTime), u = Oi(0, Qp, c - Qp);
    t.setWithVelocity(a.sample(Math.max(0, c - u)).value, a.sample(c).value, u), a.stop();
  }
}
const ow = (n, e) => e === "zIndex" ? !1 : !!(typeof n == "number" || Array.isArray(n) || typeof n == "string" && // It's animatable if we have a string
(Zs.test(n) || n === "0") && // And it contains numbers and/or colors
!n.startsWith("url("));
function l3(n) {
  const e = n[0];
  if (n.length === 1)
    return !0;
  for (let t = 0; t < n.length; t++)
    if (n[t] !== e)
      return !0;
}
function c3(n, e, t, r) {
  const i = n[0];
  if (i === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const s = n[n.length - 1], o = ow(i, e), a = ow(s, e);
  return rl(o === a, `You are trying to animate ${e} from "${i}" to "${s}". "${o ? s : i}" is not an animatable value.`, "value-not-animatable"), !o || !a ? !1 : l3(n) || (t === "spring" || lv(t)) && r;
}
function xg(n) {
  n.duration = 0, n.type = "keyframes";
}
const u3 = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), d3 = /* @__PURE__ */ Ky(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function f3(n) {
  var d;
  const { motionValue: e, name: t, repeatDelay: r, repeatType: i, damping: s, type: o } = n;
  if (!(((d = e == null ? void 0 : e.owner) == null ? void 0 : d.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: c, transformTemplate: u } = e.owner.getProps();
  return d3() && t && u3.has(t) && (t !== "transform" || !u) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !c && !r && i !== "mirror" && s !== 0 && o !== "inertia";
}
const h3 = 40;
class p3 extends sv {
  constructor({ autoplay: e = !0, delay: t = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: s = 0, repeatType: o = "loop", keyframes: a, name: c, motionValue: u, element: d, ...h }) {
    var y;
    super(), this.stop = () => {
      var b, S;
      this._animation && (this._animation.stop(), (b = this.stopTimeline) == null || b.call(this)), (S = this.keyframeResolver) == null || S.cancel();
    }, this.createdAt = Qn.now();
    const p = {
      autoplay: e,
      delay: t,
      type: r,
      repeat: i,
      repeatDelay: s,
      repeatType: o,
      name: c,
      motionValue: u,
      element: d,
      ...h
    }, g = (d == null ? void 0 : d.KeyframeResolver) || av;
    this.keyframeResolver = new g(a, (b, S, w) => this.onKeyframesResolved(b, S, p, !w), c, u, d), (y = this.keyframeResolver) == null || y.scheduleResolve();
  }
  onKeyframesResolved(e, t, r, i) {
    var S, w;
    this.keyframeResolver = void 0;
    const { name: s, type: o, velocity: a, delay: c, isHandoff: u, onUpdate: d } = r;
    this.resolvedAt = Qn.now(), c3(e, s, o, a) || ((ls.instantAnimations || !c) && (d == null || d(iv(e, r, t))), e[0] = e[e.length - 1], xg(r), r.repeat = 0);
    const p = {
      startTime: i ? this.resolvedAt ? this.resolvedAt - this.createdAt > h3 ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: t,
      ...r,
      keyframes: e
    }, g = !u && f3(p), y = (w = (S = p.motionValue) == null ? void 0 : S.owner) == null ? void 0 : w.current, b = g ? new a3({
      ...p,
      element: y
    }) : new ov(p);
    b.finished.then(() => {
      this.notifyFinished();
    }).catch(Jr), this.pendingTimeline && (this.stopTimeline = b.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = b;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(e, t) {
    return this.finished.finally(e).then(() => {
    });
  }
  get animation() {
    var e;
    return this._animation || ((e = this.keyframeResolver) == null || e.resume(), JW()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(e) {
    this.animation.time = e;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(e) {
    this.animation.speed = e;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(e) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(e) : this.pendingTimeline = e, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var e;
    this._animation && this.animation.cancel(), (e = this.keyframeResolver) == null || e.cancel();
  }
}
class m3 {
  constructor(e) {
    this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((e) => e.finished));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, t) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][e] = t;
  }
  attachTimeline(e) {
    const t = this.animations.map((r) => r.attachTimeline(e));
    return () => {
      t.forEach((r, i) => {
        r && r(), this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get state() {
    return this.getAll("state");
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    return aw(this.animations, "duration");
  }
  get iterationDuration() {
    return aw(this.animations, "iterationDuration");
  }
  runAll(e) {
    this.animations.forEach((t) => t[e]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function aw(n, e) {
  let t = 0;
  for (let r = 0; r < n.length; r++) {
    const i = n[r][e];
    i !== null && i > t && (t = i);
  }
  return t;
}
class g3 extends m3 {
  then(e, t) {
    return this.finished.finally(e).then(() => {
    });
  }
}
function rD(n, e, t, r = 0, i = 1) {
  const s = Array.from(n).sort((u, d) => u.sortNodePosition(d)).indexOf(e), o = n.size, a = (o - 1) * r;
  return typeof t == "function" ? t(s, o) : i === 1 ? s * r : a - s * r;
}
const y3 = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function v3(n) {
  const e = y3.exec(n);
  if (!e)
    return [,];
  const [, t, r, i] = e;
  return [`--${t ?? r}`, i];
}
const b3 = 4;
function iD(n, e, t = 1) {
  mi(t <= b3, `Max CSS variable fallback depth detected in property "${n}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [r, i] = v3(n);
  if (!r)
    return;
  const s = window.getComputedStyle(e).getPropertyValue(r);
  if (s) {
    const o = s.trim();
    return bC(o) ? parseFloat(o) : o;
  }
  return Xy(i) ? iD(i, e, t + 1) : i;
}
const x3 = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, S3 = (n) => ({
  type: "spring",
  stiffness: 550,
  damping: n === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), w3 = {
  type: "keyframes",
  duration: 0.8
}, E3 = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, A3 = (n, { keyframes: e }) => e.length > 2 ? w3 : ol.has(n) ? n.startsWith("scale") ? S3(e[1]) : x3 : E3, T3 = (n) => n !== null;
function C3(n, { repeat: e, repeatType: t = "loop" }, r) {
  const i = n.filter(T3), s = e && t !== "loop" && e % 2 === 1 ? 0 : i.length - 1;
  return i[s];
}
function cv(n, e) {
  return (n == null ? void 0 : n[e]) ?? (n == null ? void 0 : n.default) ?? n;
}
function D3({ when: n, delay: e, delayChildren: t, staggerChildren: r, staggerDirection: i, repeat: s, repeatType: o, repeatDelay: a, from: c, elapsed: u, ...d }) {
  return !!Object.keys(d).length;
}
const uv = (n, e, t, r = {}, i, s) => (o) => {
  const a = cv(r, n) || {}, c = a.delay || r.delay || 0;
  let { elapsed: u = 0 } = r;
  u = u - /* @__PURE__ */ fi(c);
  const d = {
    keyframes: Array.isArray(t) ? t : [null, t],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...a,
    delay: -u,
    onUpdate: (p) => {
      e.set(p), a.onUpdate && a.onUpdate(p);
    },
    onComplete: () => {
      o(), a.onComplete && a.onComplete();
    },
    name: n,
    motionValue: e,
    element: s ? void 0 : i
  };
  D3(a) || Object.assign(d, A3(n, d)), d.duration && (d.duration = /* @__PURE__ */ fi(d.duration)), d.repeatDelay && (d.repeatDelay = /* @__PURE__ */ fi(d.repeatDelay)), d.from !== void 0 && (d.keyframes[0] = d.from);
  let h = !1;
  if ((d.type === !1 || d.duration === 0 && !d.repeatDelay) && (xg(d), d.delay === 0 && (h = !0)), (ls.instantAnimations || ls.skipAnimations) && (h = !0, xg(d), d.delay = 0), d.allowFlatten = !a.type && !a.ease, h && !s && e.get() !== void 0) {
    const p = C3(d.keyframes, a);
    if (p !== void 0) {
      Rt.update(() => {
        d.onUpdate(p), d.onComplete();
      });
      return;
    }
  }
  return a.isSync ? new ov(d) : new p3(d);
};
function lw(n) {
  const e = [{}, {}];
  return n == null || n.values.forEach((t, r) => {
    e[0][r] = t.get(), e[1][r] = t.getVelocity();
  }), e;
}
function dv(n, e, t, r) {
  if (typeof e == "function") {
    const [i, s] = lw(r);
    e = e(t !== void 0 ? t : n.custom, i, s);
  }
  if (typeof e == "string" && (e = n.variants && n.variants[e]), typeof e == "function") {
    const [i, s] = lw(r);
    e = e(t !== void 0 ? t : n.custom, i, s);
  }
  return e;
}
function Ua(n, e, t) {
  const r = n.getProps();
  return dv(r, e, t !== void 0 ? t : r.custom, n);
}
const sD = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...sl
]), cw = 30, R3 = (n) => !isNaN(parseFloat(n)), Jl = {
  current: void 0
};
class k3 {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(e, t = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r) => {
      var s;
      const i = Qn.now();
      if (this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && ((s = this.events.change) == null || s.notify(this.current), this.dependents))
        for (const o of this.dependents)
          o.dirty();
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = t.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = Qn.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = R3(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && qf(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, t) {
    this.events[e] || (this.events[e] = new Jy());
    const r = this.events[e].add(t);
    return e === "change" ? () => {
      r(), Rt.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(e, t) {
    this.passiveEffect = e, this.stopPassiveEffect = t;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e) {
    this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e);
  }
  setWithVelocity(e, t, r) {
    this.set(t), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, t = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, t && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var e;
    (e = this.events.change) == null || e.notify(this.current);
  }
  addDependent(e) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(e);
  }
  removeDependent(e) {
    this.dependents && this.dependents.delete(e);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return Jl.current && Jl.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = Qn.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > cw)
      return 0;
    const t = Math.min(this.updatedAt - this.prevUpdatedAt, cw);
    return wC(parseFloat(this.current) - parseFloat(this.prevFrameValue), t);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(e) {
    return this.stop(), new Promise((t) => {
      this.hasAnimated = !0, this.animation = e(t), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var e, t;
    (e = this.dependents) == null || e.clear(), (t = this.events.destroy) == null || t.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Wo(n, e) {
  return new k3(n, e);
}
const Sg = (n) => Array.isArray(n);
function M3(n, e, t) {
  n.hasValue(e) ? n.getValue(e).set(t) : n.addValue(e, Wo(t));
}
function _3(n) {
  return Sg(n) ? n[n.length - 1] || 0 : n;
}
function O3(n, e) {
  const t = Ua(n, e);
  let { transitionEnd: r = {}, transition: i = {}, ...s } = t || {};
  s = { ...s, ...r };
  for (const o in s) {
    const a = _3(s[o]);
    M3(n, o, a);
  }
}
const yn = (n) => !!(n && n.getVelocity);
function I3(n) {
  return !!(yn(n) && n.add);
}
function wg(n, e) {
  const t = n.getValue("willChange");
  if (I3(t))
    return t.add(e);
  if (!t && ls.WillChange) {
    const r = new ls.WillChange("auto");
    n.addValue("willChange", r), r.add(e);
  }
}
function fv(n) {
  return n.replace(/([A-Z])/g, (e) => `-${e.toLowerCase()}`);
}
const N3 = "framerAppearId", oD = "data-" + fv(N3);
function aD(n) {
  return n.props[oD];
}
function P3({ protectedKeys: n, needsAnimating: e }, t) {
  const r = n.hasOwnProperty(t) && e[t] !== !0;
  return e[t] = !1, r;
}
function hv(n, e, { delay: t = 0, transitionOverride: r, type: i } = {}) {
  let { transition: s = n.getDefaultTransition(), transitionEnd: o, ...a } = e;
  const c = s == null ? void 0 : s.reduceMotion;
  r && (s = r);
  const u = [], d = i && n.animationState && n.animationState.getState()[i];
  for (const h in a) {
    const p = n.getValue(h, n.latestValues[h] ?? null), g = a[h];
    if (g === void 0 || d && P3(d, h))
      continue;
    const y = {
      delay: t,
      ...cv(s || {}, h)
    }, b = p.get();
    if (b !== void 0 && !p.isAnimating && !Array.isArray(g) && g === b && !y.velocity)
      continue;
    let S = !1;
    if (window.MotionHandoffAnimation) {
      const C = aD(n);
      if (C) {
        const k = window.MotionHandoffAnimation(C, h, Rt);
        k !== null && (y.startTime = k, S = !0);
      }
    }
    wg(n, h);
    const w = c ?? n.shouldReduceMotion;
    p.start(uv(h, p, g, w && sD.has(h) ? { type: !1 } : y, n, S));
    const T = p.animation;
    T && u.push(T);
  }
  return o && Promise.all(u).then(() => {
    Rt.update(() => {
      o && O3(n, o);
    });
  }), u;
}
function Eg(n, e, t = {}) {
  var c;
  const r = Ua(n, e, t.type === "exit" ? (c = n.presenceContext) == null ? void 0 : c.custom : void 0);
  let { transition: i = n.getDefaultTransition() || {} } = r || {};
  t.transitionOverride && (i = t.transitionOverride);
  const s = r ? () => Promise.all(hv(n, r, t)) : () => Promise.resolve(), o = n.variantChildren && n.variantChildren.size ? (u = 0) => {
    const { delayChildren: d = 0, staggerChildren: h, staggerDirection: p } = i;
    return L3(n, e, u, d, h, p, t);
  } : () => Promise.resolve(), { when: a } = i;
  if (a) {
    const [u, d] = a === "beforeChildren" ? [s, o] : [o, s];
    return u().then(() => d());
  } else
    return Promise.all([s(), o(t.delay)]);
}
function L3(n, e, t = 0, r = 0, i = 0, s = 1, o) {
  const a = [];
  for (const c of n.variantChildren)
    c.notify("AnimationStart", e), a.push(Eg(c, e, {
      ...o,
      delay: t + (typeof r == "function" ? 0 : r) + rD(n.variantChildren, c, r, i, s)
    }).then(() => c.notify("AnimationComplete", e)));
  return Promise.all(a);
}
function B3(n, e, t = {}) {
  n.notify("AnimationStart", e);
  let r;
  if (Array.isArray(e)) {
    const i = e.map((s) => Eg(n, s, t));
    r = Promise.all(i);
  } else if (typeof e == "string")
    r = Eg(n, e, t);
  else {
    const i = typeof e == "function" ? Ua(n, e, t.custom) : e;
    r = Promise.all(hv(n, i, t));
  }
  return r.then(() => {
    n.notify("AnimationComplete", e);
  });
}
const j3 = {
  test: (n) => n === "auto",
  parse: (n) => n
}, lD = (n) => (e) => e.test(n), cD = [il, Te, Mi, Ms, fW, dW, j3], uw = (n) => cD.find(lD(n));
function F3(n) {
  return typeof n == "number" ? n === 0 : n !== null ? n === "none" || n === "0" || SC(n) : !0;
}
const z3 = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function V3(n) {
  const [e, t] = n.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return n;
  const [r] = t.match(ev) || [];
  if (!r)
    return n;
  const i = t.replace(r, "");
  let s = z3.has(e) ? 1 : 0;
  return r !== t && (s *= 100), e + "(" + s + i + ")";
}
const H3 = /\b([a-z-]*)\(.*?\)/gu, Ag = {
  ...Zs,
  getAnimatableNone: (n) => {
    const e = n.match(H3);
    return e ? e.map(V3).join(" ") : n;
  }
}, dw = {
  ...il,
  transform: Math.round
}, U3 = {
  rotate: Ms,
  rotateX: Ms,
  rotateY: Ms,
  rotateZ: Ms,
  scale: Gu,
  scaleX: Gu,
  scaleY: Gu,
  scaleZ: Gu,
  skew: Ms,
  skewX: Ms,
  skewY: Ms,
  distance: Te,
  translateX: Te,
  translateY: Te,
  translateZ: Te,
  x: Te,
  y: Te,
  z: Te,
  perspective: Te,
  transformPerspective: Te,
  opacity: gc,
  originX: JS,
  originY: JS,
  originZ: Te
}, pv = {
  // Border props
  borderWidth: Te,
  borderTopWidth: Te,
  borderRightWidth: Te,
  borderBottomWidth: Te,
  borderLeftWidth: Te,
  borderRadius: Te,
  borderTopLeftRadius: Te,
  borderTopRightRadius: Te,
  borderBottomRightRadius: Te,
  borderBottomLeftRadius: Te,
  // Positioning props
  width: Te,
  maxWidth: Te,
  height: Te,
  maxHeight: Te,
  top: Te,
  right: Te,
  bottom: Te,
  left: Te,
  inset: Te,
  insetBlock: Te,
  insetBlockStart: Te,
  insetBlockEnd: Te,
  insetInline: Te,
  insetInlineStart: Te,
  insetInlineEnd: Te,
  // Spacing props
  padding: Te,
  paddingTop: Te,
  paddingRight: Te,
  paddingBottom: Te,
  paddingLeft: Te,
  paddingBlock: Te,
  paddingBlockStart: Te,
  paddingBlockEnd: Te,
  paddingInline: Te,
  paddingInlineStart: Te,
  paddingInlineEnd: Te,
  margin: Te,
  marginTop: Te,
  marginRight: Te,
  marginBottom: Te,
  marginLeft: Te,
  marginBlock: Te,
  marginBlockStart: Te,
  marginBlockEnd: Te,
  marginInline: Te,
  marginInlineStart: Te,
  marginInlineEnd: Te,
  // Typography
  fontSize: Te,
  // Misc
  backgroundPositionX: Te,
  backgroundPositionY: Te,
  ...U3,
  zIndex: dw,
  // SVG
  fillOpacity: gc,
  strokeOpacity: gc,
  numOctaves: dw
}, W3 = {
  ...pv,
  // Color props
  color: rn,
  backgroundColor: rn,
  outlineColor: rn,
  fill: rn,
  stroke: rn,
  // Border props
  borderColor: rn,
  borderTopColor: rn,
  borderRightColor: rn,
  borderBottomColor: rn,
  borderLeftColor: rn,
  filter: Ag,
  WebkitFilter: Ag
}, uD = (n) => W3[n];
function dD(n, e) {
  let t = uD(n);
  return t !== Ag && (t = Zs), t.getAnimatableNone ? t.getAnimatableNone(e) : void 0;
}
const $3 = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function G3(n, e, t) {
  let r = 0, i;
  for (; r < n.length && !i; ) {
    const s = n[r];
    typeof s == "string" && !$3.has(s) && yc(s).values.length && (i = n[r]), r++;
  }
  if (i && t)
    for (const s of e)
      n[s] = dD(t, i);
}
class Y3 extends av {
  constructor(e, t, r, i, s) {
    super(e, t, r, i, s, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: t, name: r } = this;
    if (!t || !t.current)
      return;
    super.readKeyframes();
    for (let d = 0; d < e.length; d++) {
      let h = e[d];
      if (typeof h == "string" && (h = h.trim(), Xy(h))) {
        const p = iD(h, t.current);
        p !== void 0 && (e[d] = p), d === e.length - 1 && (this.finalKeyframe = h);
      }
    }
    if (this.resolveNoneKeyframes(), !sD.has(r) || e.length !== 2)
      return;
    const [i, s] = e, o = uw(i), a = uw(s), c = KS(i), u = KS(s);
    if (c !== u && zs[r]) {
      this.needsMeasurement = !0;
      return;
    }
    if (o !== a)
      if (iw(o) && iw(a))
        for (let d = 0; d < e.length; d++) {
          const h = e[d];
          typeof h == "string" && (e[d] = parseFloat(h));
        }
      else zs[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: t } = this, r = [];
    for (let i = 0; i < e.length; i++)
      (e[i] === null || F3(e[i])) && r.push(i);
    r.length && G3(e, r, t);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: t, name: r } = this;
    if (!e || !e.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = zs[r](e.measureViewportBox(), window.getComputedStyle(e.current)), t[0] = this.measuredOrigin;
    const i = t[t.length - 1];
    i !== void 0 && e.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    var a;
    const { element: e, name: t, unresolvedKeyframes: r } = this;
    if (!e || !e.current)
      return;
    const i = e.getValue(t);
    i && i.jump(this.measuredOrigin, !1);
    const s = r.length - 1, o = r[s];
    r[s] = zs[t](e.measureViewportBox(), window.getComputedStyle(e.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), (a = this.removedTransforms) != null && a.length && this.removedTransforms.forEach(([c, u]) => {
      e.getValue(c).set(u);
    }), this.resolveNoneKeyframes();
  }
}
function fD(n, e, t) {
  if (n == null)
    return [];
  if (n instanceof EventTarget)
    return [n];
  if (typeof n == "string") {
    let r = document;
    e && (r = e.current);
    const i = (t == null ? void 0 : t[n]) ?? r.querySelectorAll(n);
    return i ? Array.from(i) : [];
  }
  return Array.from(n).filter((r) => r != null);
}
const hD = (n, e) => e && typeof n == "number" ? e.transform(n) : n;
function q3(n) {
  return xC(n) && "offsetHeight" in n;
}
const { schedule: mv } = /* @__PURE__ */ PC(queueMicrotask, !1), ci = {
  x: !1,
  y: !1
};
function pD() {
  return ci.x || ci.y;
}
function K3(n) {
  return n === "x" || n === "y" ? ci[n] ? null : (ci[n] = !0, () => {
    ci[n] = !1;
  }) : ci.x || ci.y ? null : (ci.x = ci.y = !0, () => {
    ci.x = ci.y = !1;
  });
}
function mD(n, e) {
  const t = fD(n), r = new AbortController(), i = {
    passive: !0,
    ...e,
    signal: r.signal
  };
  return [t, i, () => r.abort()];
}
function fw(n) {
  return !(n.pointerType === "touch" || pD());
}
function J3(n, e, t = {}) {
  const [r, i, s] = mD(n, t), o = (a) => {
    if (!fw(a))
      return;
    const { target: c } = a, u = e(c, a);
    if (typeof u != "function" || !c)
      return;
    const d = (h) => {
      fw(h) && (u(h), c.removeEventListener("pointerleave", d));
    };
    c.addEventListener("pointerleave", d, i);
  };
  return r.forEach((a) => {
    a.addEventListener("pointerenter", o, i);
  }), s;
}
const gD = (n, e) => e ? n === e ? !0 : gD(n, e.parentElement) : !1, gv = (n) => n.pointerType === "mouse" ? typeof n.button != "number" || n.button <= 0 : n.isPrimary !== !1, Q3 = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function yD(n) {
  return Q3.has(n.tagName) || n.isContentEditable === !0;
}
const xd = /* @__PURE__ */ new WeakSet();
function hw(n) {
  return (e) => {
    e.key === "Enter" && n(e);
  };
}
function Zp(n, e) {
  n.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }));
}
const Z3 = (n, e) => {
  const t = n.currentTarget;
  if (!t)
    return;
  const r = hw(() => {
    if (xd.has(t))
      return;
    Zp(t, "down");
    const i = hw(() => {
      Zp(t, "up");
    }), s = () => Zp(t, "cancel");
    t.addEventListener("keyup", i, e), t.addEventListener("blur", s, e);
  });
  t.addEventListener("keydown", r, e), t.addEventListener("blur", () => t.removeEventListener("keydown", r), e);
};
function pw(n) {
  return gv(n) && !pD();
}
function X3(n, e, t = {}) {
  const [r, i, s] = mD(n, t), o = (a) => {
    const c = a.currentTarget;
    if (!pw(a))
      return;
    xd.add(c);
    const u = e(c, a), d = (g, y) => {
      window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", p), xd.has(c) && xd.delete(c), pw(g) && typeof u == "function" && u(g, { success: y });
    }, h = (g) => {
      d(g, c === window || c === document || t.useGlobalTarget || gD(c, g.target));
    }, p = (g) => {
      d(g, !1);
    };
    window.addEventListener("pointerup", h, i), window.addEventListener("pointercancel", p, i);
  };
  return r.forEach((a) => {
    (t.useGlobalTarget ? window : a).addEventListener("pointerdown", o, i), q3(a) && (a.addEventListener("focus", (u) => Z3(u, i)), !yD(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), s;
}
function yv(n) {
  return xC(n) && "ownerSVGElement" in n;
}
function vD(n) {
  return yv(n) && n.tagName === "svg";
}
function Sd(...n) {
  const e = !Array.isArray(n[0]), t = e ? 0 : -1, r = n[0 + t], i = n[1 + t], s = n[2 + t], o = n[3 + t], a = qC(i, s, o);
  return e ? a(r) : a;
}
const e$ = [...cD, rn, Zs], t$ = (n) => e$.find(lD(n)), mw = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Pa = () => ({
  x: mw(),
  y: mw()
}), gw = () => ({ min: 0, max: 0 }), nn = () => ({
  x: gw(),
  y: gw()
}), Gd = { current: null }, vv = { current: !1 }, n$ = typeof window < "u";
function bD() {
  if (vv.current = !0, !!n$)
    if (window.matchMedia) {
      const n = window.matchMedia("(prefers-reduced-motion)"), e = () => Gd.current = n.matches;
      n.addEventListener("change", e), e();
    } else
      Gd.current = !1;
}
const bc = /* @__PURE__ */ new WeakMap();
function Kf(n) {
  return n !== null && typeof n == "object" && typeof n.start == "function";
}
function xc(n) {
  return typeof n == "string" || Array.isArray(n);
}
const bv = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], xv = ["initial", ...bv];
function Jf(n) {
  return Kf(n.animate) || xv.some((e) => xc(n[e]));
}
function xD(n) {
  return !!(Jf(n) || n.variants);
}
function r$(n, e, t) {
  for (const r in e) {
    const i = e[r], s = t[r];
    if (yn(i))
      n.addValue(r, i);
    else if (yn(s))
      n.addValue(r, Wo(i, { owner: n }));
    else if (s !== i)
      if (n.hasValue(r)) {
        const o = n.getValue(r);
        o.liveStyle === !0 ? o.jump(i) : o.hasAnimated || o.set(i);
      } else {
        const o = n.getStaticValue(r);
        n.addValue(r, Wo(o !== void 0 ? o : i, { owner: n }));
      }
  }
  for (const r in t)
    e[r] === void 0 && n.removeValue(r);
  return e;
}
const yw = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
let Yd = {};
function SD(n) {
  Yd = n;
}
function i$() {
  return Yd;
}
class wD {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, t, r) {
    return {};
  }
  constructor({ parent: e, props: t, presenceContext: r, reducedMotionConfig: i, blockInitialAnimation: s, visualState: o }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = av, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = Qn.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, Rt.render(this.render, !1, !0));
    };
    const { latestValues: c, renderState: u } = o;
    this.latestValues = c, this.baseTarget = { ...c }, this.initialValues = t.initial ? { ...c } : {}, this.renderState = u, this.parent = e, this.props = t, this.presenceContext = r, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = i, this.options = a, this.blockInitialAnimation = !!s, this.isControllingVariants = Jf(t), this.isVariantNode = xD(t), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: d, ...h } = this.scrapeMotionValuesFromProps(t, {}, this);
    for (const p in h) {
      const g = h[p];
      c[p] !== void 0 && yn(g) && g.set(c[p]);
    }
  }
  mount(e) {
    var t;
    this.current = e, bc.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((r, i) => this.bindToMotionValue(i, r)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : (vv.current || bD(), this.shouldReduceMotion = Gd.current), process.env.NODE_ENV !== "production" && qf(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), (t = this.parent) == null || t.addChild(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    var e;
    this.projection && this.projection.unmount(), cs(this.notifyUpdate), cs(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (e = this.parent) == null || e.removeChild(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const r = this.features[t];
      r && (r.unmount(), r.isMounted = !1);
    }
    this.current = null;
  }
  addChild(e) {
    this.children.add(e), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(e);
  }
  removeChild(e) {
    this.children.delete(e), this.enteringChildren && this.enteringChildren.delete(e);
  }
  bindToMotionValue(e, t) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const r = ol.has(e);
    r && this.onBindTransform && this.onBindTransform();
    const i = t.on("change", (o) => {
      this.latestValues[e] = o, this.props.onUpdate && Rt.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let s;
    typeof window < "u" && window.MotionCheckAppearSync && (s = window.MotionCheckAppearSync(this, e, t)), this.valueSubscriptions.set(e, () => {
      i(), s && s(), t.owner && t.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in Yd) {
      const t = Yd[e];
      if (!t)
        continue;
      const { isEnabled: r, Feature: i } = t;
      if (!this.features[e] && i && r(this.props) && (this.features[e] = new i(this)), this.features[e]) {
        const s = this.features[e];
        s.isMounted ? s.update() : (s.mount(), s.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : nn();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, t) {
    this.latestValues[e] = t;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, t) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = t;
    for (let r = 0; r < yw.length; r++) {
      const i = yw[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const s = "on" + i, o = e[s];
      o && (this.propEventSubscriptions[i] = this.on(i, o));
    }
    this.prevMotionValues = r$(this, this.scrapeMotionValuesFromProps(e, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const t = this.getClosestVariantNode();
    if (t)
      return t.variantChildren && t.variantChildren.add(e), () => t.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, t) {
    const r = this.values.get(e);
    t !== r && (r && this.removeValue(e), this.bindToMotionValue(e, t), this.values.set(e, t), this.latestValues[e] = t.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const t = this.valueSubscriptions.get(e);
    t && (t(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, t) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let r = this.values.get(e);
    return r === void 0 && t !== void 0 && (r = Wo(t === null ? void 0 : t, { owner: this }), this.addValue(e, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, t) {
    let r = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : this.getBaseTargetFromProps(this.props, e) ?? this.readValueFromInstance(this.current, e, this.options);
    return r != null && (typeof r == "string" && (bC(r) || SC(r)) ? r = parseFloat(r) : !t$(r) && Zs.test(t) && (r = dD(e, t)), this.setBaseTarget(e, yn(r) ? r.get() : r)), yn(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, t) {
    this.baseTarget[e] = t;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var s;
    const { initial: t } = this.props;
    let r;
    if (typeof t == "string" || typeof t == "object") {
      const o = dv(this.props, t, (s = this.presenceContext) == null ? void 0 : s.custom);
      o && (r = o[e]);
    }
    if (t && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, e);
    return i !== void 0 && !yn(i) ? i : this.initialValues[e] !== void 0 && r === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, t) {
    return this.events[e] || (this.events[e] = new Jy()), this.events[e].add(t);
  }
  notify(e, ...t) {
    this.events[e] && this.events[e].notify(...t);
  }
  scheduleRenderMicrotask() {
    mv.render(this.render);
  }
}
class ED extends wD {
  constructor() {
    super(...arguments), this.KeyframeResolver = Y3;
  }
  sortInstanceNodePosition(e, t) {
    return e.compareDocumentPosition(t) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, t) {
    const r = e.style;
    return r ? r[t] : void 0;
  }
  removeValueFromRenderState(e, { vars: t, style: r }) {
    delete t[e], delete r[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    yn(e) && (this.childSubscription = e.on("change", (t) => {
      this.current && (this.current.textContent = `${t}`);
    }));
  }
}
class no {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
function AD({ top: n, left: e, right: t, bottom: r }) {
  return {
    x: { min: e, max: t },
    y: { min: n, max: r }
  };
}
function s$({ x: n, y: e }) {
  return { top: e.min, right: n.max, bottom: e.max, left: n.min };
}
function o$(n, e) {
  if (!e)
    return n;
  const t = e({ x: n.left, y: n.top }), r = e({ x: n.right, y: n.bottom });
  return {
    top: t.y,
    left: t.x,
    bottom: r.y,
    right: r.x
  };
}
function Xp(n) {
  return n === void 0 || n === 1;
}
function Tg({ scale: n, scaleX: e, scaleY: t }) {
  return !Xp(n) || !Xp(e) || !Xp(t);
}
function Ao(n) {
  return Tg(n) || TD(n) || n.z || n.rotate || n.rotateX || n.rotateY || n.skewX || n.skewY;
}
function TD(n) {
  return vw(n.x) || vw(n.y);
}
function vw(n) {
  return n && n !== "0%";
}
function qd(n, e, t) {
  const r = n - t, i = e * r;
  return t + i;
}
function bw(n, e, t, r, i) {
  return i !== void 0 && (n = qd(n, i, r)), qd(n, t, r) + e;
}
function Cg(n, e = 0, t = 1, r, i) {
  n.min = bw(n.min, e, t, r, i), n.max = bw(n.max, e, t, r, i);
}
function CD(n, { x: e, y: t }) {
  Cg(n.x, e.translate, e.scale, e.originPoint), Cg(n.y, t.translate, t.scale, t.originPoint);
}
const xw = 0.999999999999, Sw = 1.0000000000001;
function a$(n, e, t, r = !1) {
  const i = t.length;
  if (!i)
    return;
  e.x = e.y = 1;
  let s, o;
  for (let a = 0; a < i; a++) {
    s = t[a], o = s.projectionDelta;
    const { visualElement: c } = s.options;
    c && c.props.style && c.props.style.display === "contents" || (r && s.options.layoutScroll && s.scroll && s !== s.root && Ba(n, {
      x: -s.scroll.offset.x,
      y: -s.scroll.offset.y
    }), o && (e.x *= o.x.scale, e.y *= o.y.scale, CD(n, o)), r && Ao(s.latestValues) && Ba(n, s.latestValues));
  }
  e.x < Sw && e.x > xw && (e.x = 1), e.y < Sw && e.y > xw && (e.y = 1);
}
function La(n, e) {
  n.min = n.min + e, n.max = n.max + e;
}
function ww(n, e, t, r, i = 0.5) {
  const s = Ft(n.min, n.max, i);
  Cg(n, e, t, s, r);
}
function Ba(n, e) {
  ww(n.x, e.x, e.scaleX, e.scale, e.originX), ww(n.y, e.y, e.scaleY, e.scale, e.originY);
}
function DD(n, e) {
  return AD(o$(n.getBoundingClientRect(), e));
}
function l$(n, e, t) {
  const r = DD(n, t), { scroll: i } = e;
  return i && (La(r.x, i.offset.x), La(r.y, i.offset.y)), r;
}
const c$ = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, u$ = sl.length;
function d$(n, e, t) {
  let r = "", i = !0;
  for (let s = 0; s < u$; s++) {
    const o = sl[s], a = n[o];
    if (a === void 0)
      continue;
    let c = !0;
    if (typeof a == "number")
      c = a === (o.startsWith("scale") ? 1 : 0);
    else {
      const u = parseFloat(a);
      c = o.startsWith("scale") ? u === 1 : u === 0;
    }
    if (!c || t) {
      const u = hD(a, pv[o]);
      if (!c) {
        i = !1;
        const d = c$[o] || o;
        r += `${d}(${u}) `;
      }
      t && (e[o] = u);
    }
  }
  return r = r.trim(), t ? r = t(e, i ? "" : r) : i && (r = "none"), r;
}
function Sv(n, e, t) {
  const { style: r, vars: i, transformOrigin: s } = n;
  let o = !1, a = !1;
  for (const c in e) {
    const u = e[c];
    if (ol.has(c)) {
      o = !0;
      continue;
    } else if (BC(c)) {
      i[c] = u;
      continue;
    } else {
      const d = hD(u, pv[c]);
      c.startsWith("origin") ? (a = !0, s[c] = d) : r[c] = d;
    }
  }
  if (e.transform || (o || t ? r.transform = d$(e, n.transform, t) : r.transform && (r.transform = "none")), a) {
    const { originX: c = "50%", originY: u = "50%", originZ: d = 0 } = s;
    r.transformOrigin = `${c} ${u} ${d}`;
  }
}
function RD(n, { style: e, vars: t }, r, i) {
  const s = n.style;
  let o;
  for (o in e)
    s[o] = e[o];
  i == null || i.applyProjectionStyles(s, r);
  for (o in t)
    s.setProperty(o, t[o]);
}
function Ew(n, e) {
  return e.max === e.min ? 0 : n / (e.max - e.min) * 100;
}
const Ml = {
  correct: (n, e) => {
    if (!e.target)
      return n;
    if (typeof n == "string")
      if (Te.test(n))
        n = parseFloat(n);
      else
        return n;
    const t = Ew(n, e.target.x), r = Ew(n, e.target.y);
    return `${t}% ${r}%`;
  }
}, f$ = {
  correct: (n, { treeScale: e, projectionDelta: t }) => {
    const r = n, i = Zs.parse(n);
    if (i.length > 5)
      return r;
    const s = Zs.createTransformer(n), o = typeof i[0] != "number" ? 1 : 0, a = t.x.scale * e.x, c = t.y.scale * e.y;
    i[0 + o] /= a, i[1 + o] /= c;
    const u = Ft(a, c, 0.5);
    return typeof i[2 + o] == "number" && (i[2 + o] /= u), typeof i[3 + o] == "number" && (i[3 + o] /= u), s(i);
  }
}, Dg = {
  borderRadius: {
    ...Ml,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Ml,
  borderTopRightRadius: Ml,
  borderBottomLeftRadius: Ml,
  borderBottomRightRadius: Ml,
  boxShadow: f$
};
function kD(n, { layout: e, layoutId: t }) {
  return ol.has(n) || n.startsWith("origin") || (e || t !== void 0) && (!!Dg[n] || n === "opacity");
}
function wv(n, e, t) {
  var o;
  const r = n.style, i = e == null ? void 0 : e.style, s = {};
  if (!r)
    return s;
  for (const a in r)
    (yn(r[a]) || i && yn(i[a]) || kD(a, n) || ((o = t == null ? void 0 : t.getValue(a)) == null ? void 0 : o.liveStyle) !== void 0) && (s[a] = r[a]);
  return s;
}
function h$(n) {
  return window.getComputedStyle(n);
}
class MD extends ED {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = RD;
  }
  readValueFromInstance(e, t) {
    var r;
    if (ol.has(t))
      return (r = this.projection) != null && r.isProjecting ? mg(t) : $W(e, t);
    {
      const i = h$(e), s = (BC(t) ? i.getPropertyValue(t) : i[t]) || 0;
      return typeof s == "string" ? s.trim() : s;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: t }) {
    return DD(e, t);
  }
  build(e, t, r) {
    Sv(e, t, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, t, r) {
    return wv(e, t, r);
  }
}
function p$(n, e) {
  return n in e;
}
class m$ extends wD {
  constructor() {
    super(...arguments), this.type = "object";
  }
  readValueFromInstance(e, t) {
    if (p$(t, e)) {
      const r = e[t];
      if (typeof r == "string" || typeof r == "number")
        return r;
    }
  }
  getBaseTargetFromProps() {
  }
  removeValueFromRenderState(e, t) {
    delete t.output[e];
  }
  measureInstanceViewportBox() {
    return nn();
  }
  build(e, t) {
    Object.assign(e.output, t);
  }
  renderInstance(e, { output: t }) {
    Object.assign(e, t);
  }
  sortInstanceNodePosition() {
    return 0;
  }
}
const g$ = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, y$ = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function v$(n, e, t = 1, r = 0, i = !0) {
  n.pathLength = 1;
  const s = i ? g$ : y$;
  n[s.offset] = `${-r}`, n[s.array] = `${e} ${t}`;
}
const b$ = [
  "offsetDistance",
  "offsetPath",
  "offsetRotate",
  "offsetAnchor"
];
function _D(n, {
  attrX: e,
  attrY: t,
  attrScale: r,
  pathLength: i,
  pathSpacing: s = 1,
  pathOffset: o = 0,
  // This is object creation, which we try to avoid per-frame.
  ...a
}, c, u, d) {
  if (Sv(n, a, u), c) {
    n.style.viewBox && (n.attrs.viewBox = n.style.viewBox);
    return;
  }
  n.attrs = n.style, n.style = {};
  const { attrs: h, style: p } = n;
  h.transform && (p.transform = h.transform, delete h.transform), (p.transform || h.transformOrigin) && (p.transformOrigin = h.transformOrigin ?? "50% 50%", delete h.transformOrigin), p.transform && (p.transformBox = (d == null ? void 0 : d.transformBox) ?? "fill-box", delete h.transformBox);
  for (const g of b$)
    h[g] !== void 0 && (p[g] = h[g], delete h[g]);
  e !== void 0 && (h.x = e), t !== void 0 && (h.y = t), r !== void 0 && (h.scale = r), i !== void 0 && v$(h, i, s, o, !1);
}
const OD = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]), ID = (n) => typeof n == "string" && n.toLowerCase() === "svg";
function x$(n, e, t, r) {
  RD(n, e, void 0, r);
  for (const i in e.attrs)
    n.setAttribute(OD.has(i) ? i : fv(i), e.attrs[i]);
}
function ND(n, e, t) {
  const r = wv(n, e, t);
  for (const i in n)
    if (yn(n[i]) || yn(e[i])) {
      const s = sl.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[s] = n[i];
    }
  return r;
}
class PD extends ED {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = nn;
  }
  getBaseTargetFromProps(e, t) {
    return e[t];
  }
  readValueFromInstance(e, t) {
    if (ol.has(t)) {
      const r = uD(t);
      return r && r.default || 0;
    }
    return t = OD.has(t) ? t : fv(t), e.getAttribute(t);
  }
  scrapeMotionValuesFromProps(e, t, r) {
    return ND(e, t, r);
  }
  build(e, t, r) {
    _D(e, t, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(e, t, r, i) {
    x$(e, t, r, i);
  }
  mount(e) {
    this.isSVGTag = ID(e.tagName), super.mount(e);
  }
}
const S$ = xv.length;
function LD(n) {
  if (!n)
    return;
  if (!n.isControllingVariants) {
    const t = n.parent ? LD(n.parent) || {} : {};
    return n.props.initial !== void 0 && (t.initial = n.props.initial), t;
  }
  const e = {};
  for (let t = 0; t < S$; t++) {
    const r = xv[t], i = n.props[r];
    (xc(i) || i === !1) && (e[r] = i);
  }
  return e;
}
function BD(n, e) {
  if (!Array.isArray(e))
    return !1;
  const t = e.length;
  if (t !== n.length)
    return !1;
  for (let r = 0; r < t; r++)
    if (e[r] !== n[r])
      return !1;
  return !0;
}
const w$ = [...bv].reverse(), E$ = bv.length;
function A$(n) {
  return (e) => Promise.all(e.map(({ animation: t, options: r }) => B3(n, t, r)));
}
function T$(n) {
  let e = A$(n), t = Aw(), r = !0;
  const i = (c) => (u, d) => {
    var p;
    const h = Ua(n, d, c === "exit" ? (p = n.presenceContext) == null ? void 0 : p.custom : void 0);
    if (h) {
      const { transition: g, transitionEnd: y, ...b } = h;
      u = { ...u, ...b, ...y };
    }
    return u;
  };
  function s(c) {
    e = c(n);
  }
  function o(c) {
    const { props: u } = n, d = LD(n.parent) || {}, h = [], p = /* @__PURE__ */ new Set();
    let g = {}, y = 1 / 0;
    for (let S = 0; S < E$; S++) {
      const w = w$[S], T = t[w], C = u[w] !== void 0 ? u[w] : d[w], k = xc(C), R = w === c ? T.isActive : null;
      R === !1 && (y = S);
      let N = C === d[w] && C !== u[w] && k;
      if (N && r && n.manuallyAnimateOnMount && (N = !1), T.protectedKeys = { ...g }, // If it isn't active and hasn't *just* been set as inactive
      !T.isActive && R === null || // If we didn't and don't have any defined prop for this animation type
      !C && !T.prevProp || // Or if the prop doesn't define an animation
      Kf(C) || typeof C == "boolean")
        continue;
      const L = C$(T.prevProp, C);
      let j = L || // If we're making this variant active, we want to always make it active
      w === c && T.isActive && !N && k || // If we removed a higher-priority variant (i is in reverse order)
      S > y && k, W = !1;
      const Z = Array.isArray(C) ? C : [C];
      let fe = Z.reduce(i(w), {});
      R === !1 && (fe = {});
      const { prevResolvedValues: Oe = {} } = T, Ae = {
        ...Oe,
        ...fe
      }, Y = (U) => {
        j = !0, p.has(U) && (W = !0, p.delete(U)), T.needsAnimating[U] = !0;
        const J = n.getValue(U);
        J && (J.liveStyle = !1);
      };
      for (const U in Ae) {
        const J = fe[U], we = Oe[U];
        if (g.hasOwnProperty(U))
          continue;
        let z = !1;
        Sg(J) && Sg(we) ? z = !BD(J, we) : z = J !== we, z ? J != null ? Y(U) : p.add(U) : J !== void 0 && p.has(U) ? Y(U) : T.protectedKeys[U] = !0;
      }
      T.prevProp = C, T.prevResolvedValues = fe, T.isActive && (g = { ...g, ...fe }), r && n.blockInitialAnimation && (j = !1);
      const re = N && L;
      j && (!re || W) && h.push(...Z.map((U) => {
        const J = { type: w };
        if (typeof U == "string" && r && !re && n.manuallyAnimateOnMount && n.parent) {
          const { parent: we } = n, z = Ua(we, U);
          if (we.enteringChildren && z) {
            const { delayChildren: X } = z.transition || {};
            J.delay = rD(we.enteringChildren, n, X);
          }
        }
        return {
          animation: U,
          options: J
        };
      }));
    }
    if (p.size) {
      const S = {};
      if (typeof u.initial != "boolean") {
        const w = Ua(n, Array.isArray(u.initial) ? u.initial[0] : u.initial);
        w && w.transition && (S.transition = w.transition);
      }
      p.forEach((w) => {
        const T = n.getBaseTarget(w), C = n.getValue(w);
        C && (C.liveStyle = !0), S[w] = T ?? null;
      }), h.push({ animation: S });
    }
    let b = !!h.length;
    return r && (u.initial === !1 || u.initial === u.animate) && !n.manuallyAnimateOnMount && (b = !1), r = !1, b ? e(h) : Promise.resolve();
  }
  function a(c, u) {
    var h;
    if (t[c].isActive === u)
      return Promise.resolve();
    (h = n.variantChildren) == null || h.forEach((p) => {
      var g;
      return (g = p.animationState) == null ? void 0 : g.setActive(c, u);
    }), t[c].isActive = u;
    const d = o(c);
    for (const p in t)
      t[p].protectedKeys = {};
    return d;
  }
  return {
    animateChanges: o,
    setActive: a,
    setAnimateFunction: s,
    getState: () => t,
    reset: () => {
      t = Aw();
    }
  };
}
function C$(n, e) {
  return typeof e == "string" ? e !== n : Array.isArray(e) ? !BD(e, n) : !1;
}
function xo(n = !1) {
  return {
    isActive: n,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Aw() {
  return {
    animate: xo(!0),
    whileInView: xo(),
    whileHover: xo(),
    whileTap: xo(),
    whileDrag: xo(),
    whileFocus: xo(),
    exit: xo()
  };
}
function Tw(n, e) {
  n.min = e.min, n.max = e.max;
}
function li(n, e) {
  Tw(n.x, e.x), Tw(n.y, e.y);
}
function Cw(n, e) {
  n.translate = e.translate, n.scale = e.scale, n.originPoint = e.originPoint, n.origin = e.origin;
}
const jD = 1e-4, D$ = 1 - jD, R$ = 1 + jD, FD = 0.01, k$ = 0 - FD, M$ = 0 + FD;
function Zn(n) {
  return n.max - n.min;
}
function _$(n, e, t) {
  return Math.abs(n - e) <= t;
}
function Dw(n, e, t, r = 0.5) {
  n.origin = r, n.originPoint = Ft(e.min, e.max, n.origin), n.scale = Zn(t) / Zn(e), n.translate = Ft(t.min, t.max, n.origin) - n.originPoint, (n.scale >= D$ && n.scale <= R$ || isNaN(n.scale)) && (n.scale = 1), (n.translate >= k$ && n.translate <= M$ || isNaN(n.translate)) && (n.translate = 0);
}
function Ql(n, e, t, r) {
  Dw(n.x, e.x, t.x, r ? r.originX : void 0), Dw(n.y, e.y, t.y, r ? r.originY : void 0);
}
function Rw(n, e, t) {
  n.min = t.min + e.min, n.max = n.min + Zn(e);
}
function O$(n, e, t) {
  Rw(n.x, e.x, t.x), Rw(n.y, e.y, t.y);
}
function kw(n, e, t) {
  n.min = e.min - t.min, n.max = n.min + Zn(e);
}
function Kd(n, e, t) {
  kw(n.x, e.x, t.x), kw(n.y, e.y, t.y);
}
function Mw(n, e, t, r, i) {
  return n -= e, n = qd(n, 1 / t, r), i !== void 0 && (n = qd(n, 1 / i, r)), n;
}
function I$(n, e = 0, t = 1, r = 0.5, i, s = n, o = n) {
  if (Mi.test(e) && (e = parseFloat(e), e = Ft(o.min, o.max, e / 100) - o.min), typeof e != "number")
    return;
  let a = Ft(s.min, s.max, r);
  n === s && (a -= e), n.min = Mw(n.min, e, t, a, i), n.max = Mw(n.max, e, t, a, i);
}
function _w(n, e, [t, r, i], s, o) {
  I$(n, e[t], e[r], e[i], e.scale, s, o);
}
const N$ = ["x", "scaleX", "originX"], P$ = ["y", "scaleY", "originY"];
function Ow(n, e, t, r) {
  _w(n.x, e, N$, t ? t.x : void 0, r ? r.x : void 0), _w(n.y, e, P$, t ? t.y : void 0, r ? r.y : void 0);
}
function Iw(n) {
  return n.translate === 0 && n.scale === 1;
}
function zD(n) {
  return Iw(n.x) && Iw(n.y);
}
function Nw(n, e) {
  return n.min === e.min && n.max === e.max;
}
function L$(n, e) {
  return Nw(n.x, e.x) && Nw(n.y, e.y);
}
function Pw(n, e) {
  return Math.round(n.min) === Math.round(e.min) && Math.round(n.max) === Math.round(e.max);
}
function VD(n, e) {
  return Pw(n.x, e.x) && Pw(n.y, e.y);
}
function Lw(n) {
  return Zn(n.x) / Zn(n.y);
}
function Bw(n, e) {
  return n.translate === e.translate && n.scale === e.scale && n.originPoint === e.originPoint;
}
function Ur(n) {
  return [n("x"), n("y")];
}
function B$(n, e, t) {
  let r = "";
  const i = n.x.translate / e.x, s = n.y.translate / e.y, o = (t == null ? void 0 : t.z) || 0;
  if ((i || s || o) && (r = `translate3d(${i}px, ${s}px, ${o}px) `), (e.x !== 1 || e.y !== 1) && (r += `scale(${1 / e.x}, ${1 / e.y}) `), t) {
    const { transformPerspective: u, rotate: d, rotateX: h, rotateY: p, skewX: g, skewY: y } = t;
    u && (r = `perspective(${u}px) ${r}`), d && (r += `rotate(${d}deg) `), h && (r += `rotateX(${h}deg) `), p && (r += `rotateY(${p}deg) `), g && (r += `skewX(${g}deg) `), y && (r += `skewY(${y}deg) `);
  }
  const a = n.x.scale * e.x, c = n.y.scale * e.y;
  return (a !== 1 || c !== 1) && (r += `scale(${a}, ${c})`), r || "none";
}
const HD = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], j$ = HD.length, jw = (n) => typeof n == "string" ? parseFloat(n) : n, Fw = (n) => typeof n == "number" || Te.test(n);
function F$(n, e, t, r, i, s) {
  i ? (n.opacity = Ft(0, t.opacity ?? 1, z$(r)), n.opacityExit = Ft(e.opacity ?? 1, 0, V$(r))) : s && (n.opacity = Ft(e.opacity ?? 1, t.opacity ?? 1, r));
  for (let o = 0; o < j$; o++) {
    const a = `border${HD[o]}Radius`;
    let c = zw(e, a), u = zw(t, a);
    if (c === void 0 && u === void 0)
      continue;
    c || (c = 0), u || (u = 0), c === 0 || u === 0 || Fw(c) === Fw(u) ? (n[a] = Math.max(Ft(jw(c), jw(u), r), 0), (Mi.test(u) || Mi.test(c)) && (n[a] += "%")) : n[a] = u;
  }
  (e.rotate || t.rotate) && (n.rotate = Ft(e.rotate || 0, t.rotate || 0, r));
}
function zw(n, e) {
  return n[e] !== void 0 ? n[e] : n.borderRadius;
}
const z$ = /* @__PURE__ */ UD(0, 0.5, kC), V$ = /* @__PURE__ */ UD(0.5, 0.95, Jr);
function UD(n, e, t) {
  return (r) => r < n ? 0 : r > e ? 1 : t(/* @__PURE__ */ Ja(n, e, r));
}
function WD(n, e, t) {
  const r = yn(n) ? n : Wo(n);
  return r.start(uv("", r, e, t)), r.animation;
}
function Sc(n, e, t, r = { passive: !0 }) {
  return n.addEventListener(e, t, r), () => n.removeEventListener(e, t);
}
const H$ = (n, e) => n.depth - e.depth;
class U$ {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    qy(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    Vc(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(H$), this.isDirty = !1, this.children.forEach(e);
  }
}
function W$(n, e) {
  const t = Qn.now(), r = ({ timestamp: i }) => {
    const s = i - t;
    s >= e && (cs(r), n(s - e));
  };
  return Rt.setup(r, !0), () => cs(r);
}
function wd(n) {
  return yn(n) ? n.get() : n;
}
class $$ {
  constructor() {
    this.members = [];
  }
  add(e) {
    qy(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (Vc(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const t = this.members[this.members.length - 1];
      t && this.promote(t);
    }
  }
  relegate(e) {
    const t = this.members.findIndex((i) => e === i);
    if (t === 0)
      return !1;
    let r;
    for (let i = t; i >= 0; i--) {
      const s = this.members[i];
      if (s.isPresent !== !1) {
        r = s;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(e, t) {
    const r = this.lead;
    if (e !== r && (this.prevLead = r, this.lead = e, e.show(), r)) {
      r.instance && r.scheduleRender(), e.scheduleRender();
      const i = r.options.layoutDependency, s = e.options.layoutDependency;
      i !== void 0 && s !== void 0 && i === s || (e.resumeFrom = r, t && (e.resumeFrom.preserveOpacity = !0), r.snapshot && (e.snapshot = r.snapshot, e.snapshot.latestValues = r.animationValues || r.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0));
      const { crossfade: a } = e.options;
      a === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: t, resumingFrom: r } = e;
      t.onExitComplete && t.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
const Ed = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, em = ["", "X", "Y", "Z"], G$ = 1e3;
let Y$ = 0;
function tm(n, e, t, r) {
  const { latestValues: i } = e;
  i[n] && (t[n] = i[n], e.setStaticValue(n, 0), r && (r[n] = 0));
}
function $D(n) {
  if (n.hasCheckedOptimisedAppear = !0, n.root === n)
    return;
  const { visualElement: e } = n.options;
  if (!e)
    return;
  const t = aD(e);
  if (window.MotionHasOptimisedAnimation(t, "transform")) {
    const { layout: i, layoutId: s } = n.options;
    window.MotionCancelOptimisedAnimation(t, "transform", Rt, !(i || s));
  }
  const { parent: r } = n;
  r && !r.hasCheckedOptimisedAppear && $D(r);
}
function GD({ attachResizeListener: n, defaultParent: e, measureScroll: t, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(o = {}, a = e == null ? void 0 : e()) {
      this.id = Y$++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(J$), this.nodes.forEach(e5), this.nodes.forEach(t5), this.nodes.forEach(Q$);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let c = 0; c < this.path.length; c++)
        this.path[c].shouldResetTransform = !0;
      this.root === this && (this.nodes = new U$());
    }
    addEventListener(o, a) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new Jy()), this.eventHandlers.get(o).add(a);
    }
    notifyListeners(o, ...a) {
      const c = this.eventHandlers.get(o);
      c && c.notify(...a);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o) {
      if (this.instance)
        return;
      this.isSVG = yv(o) && !vD(o), this.instance = o;
      const { layoutId: a, layout: c, visualElement: u } = this.options;
      if (u && !u.current && u.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (c || a) && (this.isLayoutDirty = !0), n) {
        let d, h = 0;
        const p = () => this.root.updateBlockedByResize = !1;
        Rt.read(() => {
          h = window.innerWidth;
        }), n(o, () => {
          const g = window.innerWidth;
          g !== h && (h = g, this.root.updateBlockedByResize = !0, d && d(), d = W$(p, 250), Ed.hasAnimatedSinceResize && (Ed.hasAnimatedSinceResize = !1, this.nodes.forEach(Uw)));
        });
      }
      a && this.root.registerSharedNode(a, this), this.options.animate !== !1 && u && (a || c) && this.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: h, hasRelativeLayoutChanged: p, layout: g }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const y = this.options.transition || u.getDefaultTransition() || o5, { onLayoutAnimationStart: b, onLayoutAnimationComplete: S } = u.getProps(), w = !this.targetLayout || !VD(this.targetLayout, g), T = !h && p;
        if (this.options.layoutRoot || this.resumeFrom || T || h && (w || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const C = {
            ...cv(y, "layout"),
            onPlay: b,
            onComplete: S
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (C.delay = 0, C.type = !1), this.startAnimation(C), this.setAnimationOrigin(d, T);
        } else
          h || Uw(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = g;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), cs(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(n5), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && $D(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let d = 0; d < this.path.length; d++) {
        const h = this.path[d];
        h.shouldResetTransform = !0, h.updateScroll("snapshot"), h.options.layoutRoot && h.willUpdate(!1);
      }
      const { layoutId: a, layout: c } = this.options;
      if (a === void 0 && !c)
        return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Vw);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(Hw);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(X$), this.nodes.forEach(q$), this.nodes.forEach(K$)) : this.nodes.forEach(Hw), this.clearAllSnapshots();
      const a = Qn.now();
      _n.delta = Oi(0, 1e3 / 60, a - _n.timestamp), _n.timestamp = a, _n.isProcessing = !0, Gp.update.process(_n), Gp.preRender.process(_n), Gp.render.process(_n), _n.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, mv.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(Z$), this.sharedNodes.forEach(r5);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Rt.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Rt.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Zn(this.snapshot.measuredBox.x) && !Zn(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let c = 0; c < this.path.length; c++)
          this.path[c].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected = nn(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (a = !1), a && this.instance) {
        const c = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: c,
          offset: t(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : c
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !zD(this.projectionDelta), c = this.getTransformTemplate(), u = c ? c(this.latestValues, "") : void 0, d = u !== this.prevTransformTemplateValue;
      o && this.instance && (a || Ao(this.latestValues) || d) && (i(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const a = this.measurePageBox();
      let c = this.removeElementScroll(a);
      return o && (c = this.removeTransform(c)), a5(c), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: c,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var u;
      const { visualElement: o } = this.options;
      if (!o)
        return nn();
      const a = o.measureViewportBox();
      if (!(((u = this.scroll) == null ? void 0 : u.wasRoot) || this.path.some(l5))) {
        const { scroll: d } = this.root;
        d && (La(a.x, d.offset.x), La(a.y, d.offset.y));
      }
      return a;
    }
    removeElementScroll(o) {
      var c;
      const a = nn();
      if (li(a, o), (c = this.scroll) != null && c.wasRoot)
        return a;
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u], { scroll: h, options: p } = d;
        d !== this.root && h && p.layoutScroll && (h.wasRoot && li(a, o), La(a.x, h.offset.x), La(a.y, h.offset.y));
      }
      return a;
    }
    applyTransform(o, a = !1) {
      const c = nn();
      li(c, o);
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u];
        !a && d.options.layoutScroll && d.scroll && d !== d.root && Ba(c, {
          x: -d.scroll.offset.x,
          y: -d.scroll.offset.y
        }), Ao(d.latestValues) && Ba(c, d.latestValues);
      }
      return Ao(this.latestValues) && Ba(c, this.latestValues), c;
    }
    removeTransform(o) {
      const a = nn();
      li(a, o);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        if (!u.instance || !Ao(u.latestValues))
          continue;
        Tg(u.latestValues) && u.updateSnapshot();
        const d = nn(), h = u.measurePageBox();
        li(d, h), Ow(a, u.latestValues, u.snapshot ? u.snapshot.layoutBox : void 0, d);
      }
      return Ao(this.latestValues) && Ow(a, this.latestValues), a;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== _n.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var g;
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== a;
      if (!(o || c && this.isSharedProjectionDirty || this.isProjectionDirty || (g = this.parent) != null && g.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: d, layoutId: h } = this.options;
      if (!this.layout || !(d || h))
        return;
      this.resolvedRelativeTargetAt = _n.timestamp;
      const p = this.getClosestProjectingParent();
      p && this.linkedParentVersion !== p.layoutVersion && !p.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (p && p.layout ? this.createRelativeTarget(p, this.layout.layoutBox, p.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = nn(), this.targetWithTransforms = nn()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), O$(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : li(this.target, this.layout.layoutBox), CD(this.target, this.targetDelta)) : li(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, p && !!p.resumingFrom == !!this.resumingFrom && !p.options.layoutScroll && p.target && this.animationProgress !== 1 ? this.createRelativeTarget(p, this.target, p.target) : this.relativeParent = this.relativeTarget = void 0));
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Tg(this.parent.latestValues) || TD(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(o, a, c) {
      this.relativeParent = o, this.linkedParentVersion = o.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = nn(), this.relativeTargetOrigin = nn(), Kd(this.relativeTargetOrigin, a, c), li(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      var y;
      const o = this.getLead(), a = !!this.resumingFrom || this !== o;
      let c = !0;
      if ((this.isProjectionDirty || (y = this.parent) != null && y.isProjectionDirty) && (c = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === _n.timestamp && (c = !1), c)
        return;
      const { layout: u, layoutId: d } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || d))
        return;
      li(this.layoutCorrected, this.layout.layoutBox);
      const h = this.treeScale.x, p = this.treeScale.y;
      a$(this.layoutCorrected, this.treeScale, this.path, a), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = nn());
      const { target: g } = o;
      if (!g) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (Cw(this.prevProjectionDelta.x, this.projectionDelta.x), Cw(this.prevProjectionDelta.y, this.projectionDelta.y)), Ql(this.projectionDelta, this.layoutCorrected, g, this.latestValues), (this.treeScale.x !== h || this.treeScale.y !== p || !Bw(this.projectionDelta.x, this.prevProjectionDelta.x) || !Bw(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", g));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      var a;
      if ((a = this.options.visualElement) == null || a.scheduleRender(), o) {
        const c = this.getStack();
        c && c.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = Pa(), this.projectionDelta = Pa(), this.projectionDeltaWithTransform = Pa();
    }
    setAnimationOrigin(o, a = !1) {
      const c = this.snapshot, u = c ? c.latestValues : {}, d = { ...this.latestValues }, h = Pa();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const p = nn(), g = c ? c.source : void 0, y = this.layout ? this.layout.source : void 0, b = g !== y, S = this.getStack(), w = !S || S.members.length <= 1, T = !!(b && !w && this.options.crossfade === !0 && !this.path.some(s5));
      this.animationProgress = 0;
      let C;
      this.mixTargetDelta = (k) => {
        const R = k / 1e3;
        Ww(h.x, o.x, R), Ww(h.y, o.y, R), this.setTargetDelta(h), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Kd(p, this.layout.layoutBox, this.relativeParent.layout.layoutBox), i5(this.relativeTarget, this.relativeTargetOrigin, p, R), C && L$(this.relativeTarget, C) && (this.isProjectionDirty = !1), C || (C = nn()), li(C, this.relativeTarget)), b && (this.animationValues = d, F$(d, u, this.latestValues, R, T, w)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = R;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      var a, c, u;
      this.notifyListeners("animationStart"), (a = this.currentAnimation) == null || a.stop(), (u = (c = this.resumingFrom) == null ? void 0 : c.currentAnimation) == null || u.stop(), this.pendingAnimation && (cs(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Rt.update(() => {
        Ed.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Wo(0)), this.currentAnimation = WD(this.motionValue, [0, 1e3], {
          ...o,
          velocity: 0,
          isSync: !0,
          onUpdate: (d) => {
            this.mixTargetDelta(d), o.onUpdate && o.onUpdate(d);
          },
          onStop: () => {
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(G$), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: a, target: c, layout: u, latestValues: d } = o;
      if (!(!a || !c || !u)) {
        if (this !== o && this.layout && u && YD(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          c = this.target || nn();
          const h = Zn(this.layout.layoutBox.x);
          c.x.min = o.target.x.min, c.x.max = c.x.min + h;
          const p = Zn(this.layout.layoutBox.y);
          c.y.min = o.target.y.min, c.y.max = c.y.min + p;
        }
        li(a, c), Ba(a, d), Ql(this.projectionDeltaWithTransform, this.layoutCorrected, a, d);
      }
    }
    registerSharedNode(o, a) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new $$()), this.sharedNodes.get(o).add(a);
      const u = a.options.initialPromotionConfig;
      a.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? ((a = this.getStack()) == null ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? (a = this.getStack()) == null ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: a, preserveFollowOpacity: c } = {}) {
      const u = this.getStack();
      u && u.promote(this, c), o && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let a = !1;
      const { latestValues: c } = o;
      if ((c.z || c.rotate || c.rotateX || c.rotateY || c.rotateZ || c.skewX || c.skewY) && (a = !0), !a)
        return;
      const u = {};
      c.z && tm("z", o, u, this.animationValues);
      for (let d = 0; d < em.length; d++)
        tm(`rotate${em[d]}`, o, u, this.animationValues), tm(`skew${em[d]}`, o, u, this.animationValues);
      o.render();
      for (const d in u)
        o.setStaticValue(d, u[d]), this.animationValues && (this.animationValues[d] = u[d]);
      o.scheduleRender();
    }
    applyProjectionStyles(o, a) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        o.visibility = "hidden";
        return;
      }
      const c = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, o.visibility = "", o.opacity = "", o.pointerEvents = wd(a == null ? void 0 : a.pointerEvents) || "", o.transform = c ? c(this.latestValues, "") : "none";
        return;
      }
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        this.options.layoutId && (o.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, o.pointerEvents = wd(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !Ao(this.latestValues) && (o.transform = c ? c({}, "") : "none", this.hasProjected = !1);
        return;
      }
      o.visibility = "";
      const d = u.animationValues || u.latestValues;
      this.applyTransformsToTarget();
      let h = B$(this.projectionDeltaWithTransform, this.treeScale, d);
      c && (h = c(d, h)), o.transform = h;
      const { x: p, y: g } = this.projectionDelta;
      o.transformOrigin = `${p.origin * 100}% ${g.origin * 100}% 0`, u.animationValues ? o.opacity = u === this ? d.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : d.opacityExit : o.opacity = u === this ? d.opacity !== void 0 ? d.opacity : "" : d.opacityExit !== void 0 ? d.opacityExit : 0;
      for (const y in Dg) {
        if (d[y] === void 0)
          continue;
        const { correct: b, applyTo: S, isCSSVariable: w } = Dg[y], T = h === "none" ? d[y] : b(d[y], u);
        if (S) {
          const C = S.length;
          for (let k = 0; k < C; k++)
            o[S[k]] = T;
        } else
          w ? this.options.visualElement.renderState.vars[y] = T : o[y] = T;
      }
      this.options.layoutId && (o.pointerEvents = u === this ? wd(a == null ? void 0 : a.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var a;
        return (a = o.currentAnimation) == null ? void 0 : a.stop();
      }), this.root.nodes.forEach(Vw), this.root.sharedNodes.clear();
    }
  };
}
function q$(n) {
  n.updateLayout();
}
function K$(n) {
  var t;
  const e = ((t = n.resumeFrom) == null ? void 0 : t.snapshot) || n.snapshot;
  if (n.isLead() && n.layout && e && n.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: i } = n.layout, { animationType: s } = n.options, o = e.source !== n.layout.source;
    s === "size" ? Ur((h) => {
      const p = o ? e.measuredBox[h] : e.layoutBox[h], g = Zn(p);
      p.min = r[h].min, p.max = p.min + g;
    }) : YD(s, e.layoutBox, r) && Ur((h) => {
      const p = o ? e.measuredBox[h] : e.layoutBox[h], g = Zn(r[h]);
      p.max = p.min + g, n.relativeTarget && !n.currentAnimation && (n.isProjectionDirty = !0, n.relativeTarget[h].max = n.relativeTarget[h].min + g);
    });
    const a = Pa();
    Ql(a, r, e.layoutBox);
    const c = Pa();
    o ? Ql(c, n.applyTransform(i, !0), e.measuredBox) : Ql(c, r, e.layoutBox);
    const u = !zD(a);
    let d = !1;
    if (!n.resumeFrom) {
      const h = n.getClosestProjectingParent();
      if (h && !h.resumeFrom) {
        const { snapshot: p, layout: g } = h;
        if (p && g) {
          const y = nn();
          Kd(y, e.layoutBox, p.layoutBox);
          const b = nn();
          Kd(b, r, g.layoutBox), VD(y, b) || (d = !0), h.options.layoutRoot && (n.relativeTarget = b, n.relativeTargetOrigin = y, n.relativeParent = h);
        }
      }
    }
    n.notifyListeners("didUpdate", {
      layout: r,
      snapshot: e,
      delta: c,
      layoutDelta: a,
      hasLayoutChanged: u,
      hasRelativeLayoutChanged: d
    });
  } else if (n.isLead()) {
    const { onExitComplete: r } = n.options;
    r && r();
  }
  n.options.transition = void 0;
}
function J$(n) {
  n.parent && (n.isProjecting() || (n.isProjectionDirty = n.parent.isProjectionDirty), n.isSharedProjectionDirty || (n.isSharedProjectionDirty = !!(n.isProjectionDirty || n.parent.isProjectionDirty || n.parent.isSharedProjectionDirty)), n.isTransformDirty || (n.isTransformDirty = n.parent.isTransformDirty));
}
function Q$(n) {
  n.isProjectionDirty = n.isSharedProjectionDirty = n.isTransformDirty = !1;
}
function Z$(n) {
  n.clearSnapshot();
}
function Vw(n) {
  n.clearMeasurements();
}
function Hw(n) {
  n.isLayoutDirty = !1;
}
function X$(n) {
  const { visualElement: e } = n.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), n.resetTransform();
}
function Uw(n) {
  n.finishAnimation(), n.targetDelta = n.relativeTarget = n.target = void 0, n.isProjectionDirty = !0;
}
function e5(n) {
  n.resolveTargetDelta();
}
function t5(n) {
  n.calcProjection();
}
function n5(n) {
  n.resetSkewAndRotation();
}
function r5(n) {
  n.removeLeadSnapshot();
}
function Ww(n, e, t) {
  n.translate = Ft(e.translate, 0, t), n.scale = Ft(e.scale, 1, t), n.origin = e.origin, n.originPoint = e.originPoint;
}
function $w(n, e, t, r) {
  n.min = Ft(e.min, t.min, r), n.max = Ft(e.max, t.max, r);
}
function i5(n, e, t, r) {
  $w(n.x, e.x, t.x, r), $w(n.y, e.y, t.y, r);
}
function s5(n) {
  return n.animationValues && n.animationValues.opacityExit !== void 0;
}
const o5 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Gw = (n) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(n), Yw = Gw("applewebkit/") && !Gw("chrome/") ? Math.round : Jr;
function qw(n) {
  n.min = Yw(n.min), n.max = Yw(n.max);
}
function a5(n) {
  qw(n.x), qw(n.y);
}
function YD(n, e, t) {
  return n === "position" || n === "preserve-aspect" && !_$(Lw(e), Lw(t), 0.2);
}
function l5(n) {
  var e;
  return n !== n.root && ((e = n.scroll) == null ? void 0 : e.wasRoot);
}
const c5 = GD({
  attachResizeListener: (n, e) => Sc(n, "resize", e),
  measureScroll: () => {
    var n, e;
    return {
      x: document.documentElement.scrollLeft || ((n = document.body) == null ? void 0 : n.scrollLeft) || 0,
      y: document.documentElement.scrollTop || ((e = document.body) == null ? void 0 : e.scrollTop) || 0
    };
  },
  checkIsScrollRoot: () => !0
}), nm = {
  current: void 0
}, qD = GD({
  measureScroll: (n) => ({
    x: n.scrollLeft,
    y: n.scrollTop
  }),
  defaultParent: () => {
    if (!nm.current) {
      const n = new c5({});
      n.mount(window), n.setOptions({ layoutScroll: !0 }), nm.current = n;
    }
    return nm.current;
  },
  resetTransform: (n, e) => {
    n.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (n) => window.getComputedStyle(n).position === "fixed"
}), Ev = ps({
  transformPagePoint: (n) => n,
  isStatic: !1,
  reducedMotion: "never"
});
function u5(n = !0) {
  const e = Nn(Yy);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: r, register: i } = e, s = q2();
  wt(() => {
    if (n)
      return i(s);
  }, [n]);
  const o = fn(() => n && r && r(s), [s, r, n]);
  return !t && r ? [!1, o] : [!0];
}
const KD = ps({ strict: !1 }), Kw = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
let Jw = !1;
function d5() {
  if (Jw)
    return;
  const n = {};
  for (const e in Kw)
    n[e] = {
      isEnabled: (t) => Kw[e].some((r) => !!t[r])
    };
  SD(n), Jw = !0;
}
function JD() {
  return d5(), i$();
}
function f5(n) {
  const e = JD();
  for (const t in n)
    e[t] = {
      ...e[t],
      ...n[t]
    };
  SD(e);
}
const h5 = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Jd(n) {
  return n.startsWith("while") || n.startsWith("drag") && n !== "draggable" || n.startsWith("layout") || n.startsWith("onTap") || n.startsWith("onPan") || n.startsWith("onLayout") || h5.has(n);
}
let QD = (n) => !Jd(n);
function p5(n) {
  typeof n == "function" && (QD = (e) => e.startsWith("on") ? !Jd(e) : n(e));
}
try {
  p5(require("@emotion/is-prop-valid").default);
} catch {
}
function m5(n, e, t) {
  const r = {};
  for (const i in n)
    i === "values" && typeof n.values == "object" || (QD(i) || t === !0 && Jd(i) || !e && !Jd(i) || // If trying to use native HTML drag events, forward drag listeners
    n.draggable && i.startsWith("onDrag")) && (r[i] = n[i]);
  return r;
}
const Qf = /* @__PURE__ */ ps({});
function g5(n, e) {
  if (Jf(n)) {
    const { initial: t, animate: r } = n;
    return {
      initial: t === !1 || xc(t) ? t : void 0,
      animate: xc(r) ? r : void 0
    };
  }
  return n.inherit !== !1 ? e : {};
}
function y5(n) {
  const { initial: e, animate: t } = g5(n, Nn(Qf));
  return Wt(() => ({ initial: e, animate: t }), [Qw(e), Qw(t)]);
}
function Qw(n) {
  return Array.isArray(n) ? n.join(" ") : n;
}
const Av = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function ZD(n, e, t) {
  for (const r in e)
    !yn(e[r]) && !kD(r, t) && (n[r] = e[r]);
}
function v5({ transformTemplate: n }, e) {
  return Wt(() => {
    const t = Av();
    return Sv(t, e, n), Object.assign({}, t.vars, t.style);
  }, [e]);
}
function b5(n, e) {
  const t = n.style || {}, r = {};
  return ZD(r, t, n), Object.assign(r, v5(n, e)), r;
}
function x5(n, e) {
  const t = {}, r = b5(n, e);
  return n.drag && n.dragListener !== !1 && (t.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = n.drag === !0 ? "none" : `pan-${n.drag === "x" ? "y" : "x"}`), n.tabIndex === void 0 && (n.onTap || n.onTapStart || n.whileTap) && (t.tabIndex = 0), t.style = r, t;
}
const XD = () => ({
  ...Av(),
  attrs: {}
});
function S5(n, e, t, r) {
  const i = Wt(() => {
    const s = XD();
    return _D(s, e, ID(r), n.transformTemplate, n.style), {
      ...s.attrs,
      style: { ...s.style }
    };
  }, [e]);
  if (n.style) {
    const s = {};
    ZD(s, n.style, n), i.style = { ...s, ...i.style };
  }
  return i;
}
const w5 = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Tv(n) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof n != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    n.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(w5.indexOf(n) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(n))
    )
  );
}
function E5(n, e, t, { latestValues: r }, i, s = !1, o) {
  const c = (o ?? Tv(n) ? S5 : x5)(e, r, i, n), u = m5(e, typeof n == "string", s), d = n !== v1 ? { ...u, ...c, ref: t } : {}, { children: h } = e, p = Wt(() => yn(h) ? h.get() : h, [h]);
  return Gm(n, {
    ...d,
    children: p
  });
}
function A5({ scrapeMotionValuesFromProps: n, createRenderState: e }, t, r, i) {
  return {
    latestValues: T5(t, r, i, n),
    renderState: e()
  };
}
function T5(n, e, t, r) {
  const i = {}, s = r(n, {});
  for (const p in s)
    i[p] = wd(s[p]);
  let { initial: o, animate: a } = n;
  const c = Jf(n), u = xD(n);
  e && u && !c && n.inherit !== !1 && (o === void 0 && (o = e.initial), a === void 0 && (a = e.animate));
  let d = t ? t.initial === !1 : !1;
  d = d || o === !1;
  const h = d ? a : o;
  if (h && typeof h != "boolean" && !Kf(h)) {
    const p = Array.isArray(h) ? h : [h];
    for (let g = 0; g < p.length; g++) {
      const y = dv(n, p[g]);
      if (y) {
        const { transitionEnd: b, transition: S, ...w } = y;
        for (const T in w) {
          let C = w[T];
          if (Array.isArray(C)) {
            const k = d ? C.length - 1 : 0;
            C = C[k];
          }
          C !== null && (i[T] = C);
        }
        for (const T in b)
          i[T] = b[T];
      }
    }
  }
  return i;
}
const eR = (n) => (e, t) => {
  const r = Nn(Qf), i = Nn(Yy), s = () => A5(n, e, r, i);
  return t ? s() : Gy(s);
}, C5 = /* @__PURE__ */ eR({
  scrapeMotionValuesFromProps: wv,
  createRenderState: Av
}), D5 = /* @__PURE__ */ eR({
  scrapeMotionValuesFromProps: ND,
  createRenderState: XD
}), R5 = Symbol.for("motionComponentSymbol");
function k5(n, e, t) {
  const r = bt(t);
  b1(() => {
    r.current = t;
  });
  const i = bt(null);
  return fn((s) => {
    var a;
    s && ((a = n.onMount) == null || a.call(n, s)), e && (s ? e.mount(s) : e.unmount());
    const o = r.current;
    if (typeof o == "function")
      if (s) {
        const c = o(s);
        typeof c == "function" && (i.current = c);
      } else i.current ? (i.current(), i.current = null) : o(s);
    else o && (o.current = s);
  }, [e]);
}
const tR = ps({});
function zl(n) {
  return n && typeof n == "object" && Object.prototype.hasOwnProperty.call(n, "current");
}
function M5(n, e, t, r, i, s) {
  var w, T;
  const { visualElement: o } = Nn(Qf), a = Nn(KD), c = Nn(Yy), u = Nn(Ev).reducedMotion, d = bt(null), h = bt(!1);
  r = r || a.renderer, !d.current && r && (d.current = r(n, {
    visualState: e,
    parent: o,
    props: t,
    presenceContext: c,
    blockInitialAnimation: c ? c.initial === !1 : !1,
    reducedMotionConfig: u,
    isSVG: s
  }), h.current && d.current && (d.current.manuallyAnimateOnMount = !0));
  const p = d.current, g = Nn(tR);
  p && !p.projection && i && (p.type === "html" || p.type === "svg") && _5(d.current, t, i, g);
  const y = bt(!1);
  b1(() => {
    p && y.current && p.update(t, c);
  });
  const b = t[oD], S = bt(!!b && !((w = window.MotionHandoffIsComplete) != null && w.call(window, b)) && ((T = window.MotionHasOptimisedAnimation) == null ? void 0 : T.call(window, b)));
  return vC(() => {
    h.current = !0, p && (y.current = !0, window.MotionIsMounted = !0, p.updateFeatures(), p.scheduleRenderMicrotask(), S.current && p.animationState && p.animationState.animateChanges());
  }), wt(() => {
    p && (!S.current && p.animationState && p.animationState.animateChanges(), S.current && (queueMicrotask(() => {
      var C;
      (C = window.MotionHandoffMarkAsComplete) == null || C.call(window, b);
    }), S.current = !1), p.enteringChildren = void 0);
  }), p;
}
function _5(n, e, t, r) {
  const { layoutId: i, layout: s, drag: o, dragConstraints: a, layoutScroll: c, layoutRoot: u, layoutCrossfade: d } = e;
  n.projection = new t(n.latestValues, e["data-framer-portal-id"] ? void 0 : nR(n.parent)), n.projection.setOptions({
    layoutId: i,
    layout: s,
    alwaysMeasureLayout: !!o || a && zl(a),
    visualElement: n,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof s == "string" ? s : "both",
    initialPromotionConfig: r,
    crossfade: d,
    layoutScroll: c,
    layoutRoot: u
  });
}
function nR(n) {
  if (n)
    return n.options.allowProjection !== !1 ? n.projection : nR(n.parent);
}
function rm(n, { forwardMotionProps: e = !1, type: t } = {}, r, i) {
  r && f5(r);
  const s = t ? t === "svg" : Tv(n), o = s ? D5 : C5;
  function a(u, d) {
    let h;
    const p = {
      ...Nn(Ev),
      ...u,
      layoutId: O5(u)
    }, { isStatic: g } = p, y = y5(u), b = o(u, g);
    if (!g && yC) {
      I5(p, r);
      const S = N5(p);
      h = S.MeasureLayout, y.visualElement = M5(n, b, p, i, S.ProjectionNode, s);
    }
    return x.jsxs(Qf.Provider, { value: y, children: [h && y.visualElement ? x.jsx(h, { visualElement: y.visualElement, ...p }) : null, E5(n, u, k5(b, y.visualElement, d), b, g, e, s)] });
  }
  a.displayName = `motion.${typeof n == "string" ? n : `create(${n.displayName ?? n.name ?? ""})`}`;
  const c = hs(a);
  return c[R5] = n, c;
}
function O5({ layoutId: n }) {
  const e = Nn(gC).id;
  return e && n !== void 0 ? e + "-" + n : n;
}
function I5(n, e) {
  const t = Nn(KD).strict;
  if (process.env.NODE_ENV !== "production" && e && t) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    n.ignoreStrict ? rl(!1, r, "lazy-strict-mode") : mi(!1, r, "lazy-strict-mode");
  }
}
function N5(n) {
  const e = JD(), { drag: t, layout: r } = e;
  if (!t && !r)
    return {};
  const i = { ...t, ...r };
  return {
    MeasureLayout: t != null && t.isEnabled(n) || r != null && r.isEnabled(n) ? i.MeasureLayout : void 0,
    ProjectionNode: i.ProjectionNode
  };
}
function P5(n, e) {
  if (typeof Proxy > "u")
    return rm;
  const t = /* @__PURE__ */ new Map(), r = (s, o) => rm(s, o, n, e), i = (s, o) => (process.env.NODE_ENV !== "production" && qf(!1, "motion() is deprecated. Use motion.create() instead."), r(s, o));
  return new Proxy(i, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (s, o) => o === "create" ? r : (t.has(o) || t.set(o, rm(o, void 0, n, e)), t.get(o))
  });
}
const L5 = (n, e) => e.isSVG ?? Tv(n) ? new PD(e) : new MD(e, {
  allowProjection: n !== v1
});
class B5 extends no {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = T$(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    Kf(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: t } = this.node.prevProps || {};
    e !== t && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) == null || e.call(this);
  }
}
let j5 = 0;
class F5 extends no {
  constructor() {
    super(...arguments), this.id = j5++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: t } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === r)
      return;
    const i = this.node.animationState.setActive("exit", !e);
    t && !e && i.then(() => {
      t(this.id);
    });
  }
  mount() {
    const { register: e, onExitComplete: t } = this.node.presenceContext || {};
    t && t(this.id), e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const z5 = {
  animation: {
    Feature: B5
  },
  exit: {
    Feature: F5
  }
};
function $c(n) {
  return {
    point: {
      x: n.pageX,
      y: n.pageY
    }
  };
}
const V5 = (n) => (e) => gv(e) && n(e, $c(e));
function Zl(n, e, t, r) {
  return Sc(n, e, V5(t), r);
}
const rR = ({ current: n }) => n ? n.ownerDocument.defaultView : null, Zw = (n, e) => Math.abs(n - e);
function H5(n, e) {
  const t = Zw(n.x, e.x), r = Zw(n.y, e.y);
  return Math.sqrt(t ** 2 + r ** 2);
}
const Xw = /* @__PURE__ */ new Set(["auto", "scroll"]);
class iR {
  constructor(e, t, { transformPagePoint: r, contextWindow: i = window, dragSnapToOrigin: s = !1, distanceThreshold: o = 3, element: a } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = /* @__PURE__ */ new Map(), this.removeScrollListeners = null, this.onElementScroll = (g) => {
      this.handleScroll(g.target);
    }, this.onWindowScroll = () => {
      this.handleScroll(window);
    }, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const g = sm(this.lastMoveEventInfo, this.history), y = this.startEvent !== null, b = H5(g.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!y && !b)
        return;
      const { point: S } = g, { timestamp: w } = _n;
      this.history.push({ ...S, timestamp: w });
      const { onStart: T, onMove: C } = this.handlers;
      y || (T && T(this.lastMoveEvent, g), this.startEvent = this.lastMoveEvent), C && C(this.lastMoveEvent, g);
    }, this.handlePointerMove = (g, y) => {
      this.lastMoveEvent = g, this.lastMoveEventInfo = im(y, this.transformPagePoint), Rt.update(this.updatePoint, !0);
    }, this.handlePointerUp = (g, y) => {
      this.end();
      const { onEnd: b, onSessionEnd: S, resumeAnimation: w } = this.handlers;
      if ((this.dragSnapToOrigin || !this.startEvent) && w && w(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const T = sm(g.type === "pointercancel" ? this.lastMoveEventInfo : im(y, this.transformPagePoint), this.history);
      this.startEvent && b && b(g, T), S && S(g, T);
    }, !gv(e))
      return;
    this.dragSnapToOrigin = s, this.handlers = t, this.transformPagePoint = r, this.distanceThreshold = o, this.contextWindow = i || window;
    const c = $c(e), u = im(c, this.transformPagePoint), { point: d } = u, { timestamp: h } = _n;
    this.history = [{ ...d, timestamp: h }];
    const { onSessionStart: p } = t;
    p && p(e, sm(u, this.history)), this.removeListeners = Hc(Zl(this.contextWindow, "pointermove", this.handlePointerMove), Zl(this.contextWindow, "pointerup", this.handlePointerUp), Zl(this.contextWindow, "pointercancel", this.handlePointerUp)), a && this.startScrollTracking(a);
  }
  /**
   * Start tracking scroll on ancestors and window.
   */
  startScrollTracking(e) {
    let t = e.parentElement;
    for (; t; ) {
      const r = getComputedStyle(t);
      (Xw.has(r.overflowX) || Xw.has(r.overflowY)) && this.scrollPositions.set(t, {
        x: t.scrollLeft,
        y: t.scrollTop
      }), t = t.parentElement;
    }
    this.scrollPositions.set(window, {
      x: window.scrollX,
      y: window.scrollY
    }), window.addEventListener("scroll", this.onElementScroll, {
      capture: !0,
      passive: !0
    }), window.addEventListener("scroll", this.onWindowScroll, {
      passive: !0
    }), this.removeScrollListeners = () => {
      window.removeEventListener("scroll", this.onElementScroll, {
        capture: !0
      }), window.removeEventListener("scroll", this.onWindowScroll);
    };
  }
  /**
   * Handle scroll compensation during drag.
   *
   * For element scroll: adjusts history origin since pageX/pageY doesn't change.
   * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
   */
  handleScroll(e) {
    const t = this.scrollPositions.get(e);
    if (!t)
      return;
    const r = e === window, i = r ? { x: window.scrollX, y: window.scrollY } : {
      x: e.scrollLeft,
      y: e.scrollTop
    }, s = { x: i.x - t.x, y: i.y - t.y };
    s.x === 0 && s.y === 0 || (r ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += s.x, this.lastMoveEventInfo.point.y += s.y) : this.history.length > 0 && (this.history[0].x -= s.x, this.history[0].y -= s.y), this.scrollPositions.set(e, i), Rt.update(this.updatePoint, !0));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), cs(this.updatePoint);
  }
}
function im(n, e) {
  return e ? { point: e(n.point) } : n;
}
function eE(n, e) {
  return { x: n.x - e.x, y: n.y - e.y };
}
function sm({ point: n }, e) {
  return {
    point: n,
    delta: eE(n, sR(e)),
    offset: eE(n, U5(e)),
    velocity: W5(e, 0.1)
  };
}
function U5(n) {
  return n[0];
}
function sR(n) {
  return n[n.length - 1];
}
function W5(n, e) {
  if (n.length < 2)
    return { x: 0, y: 0 };
  let t = n.length - 1, r = null;
  const i = sR(n);
  for (; t >= 0 && (r = n[t], !(i.timestamp - r.timestamp > /* @__PURE__ */ fi(e))); )
    t--;
  if (!r)
    return { x: 0, y: 0 };
  const s = /* @__PURE__ */ Kr(i.timestamp - r.timestamp);
  if (s === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (i.x - r.x) / s,
    y: (i.y - r.y) / s
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function $5(n, { min: e, max: t }, r) {
  return e !== void 0 && n < e ? n = r ? Ft(e, n, r.min) : Math.max(n, e) : t !== void 0 && n > t && (n = r ? Ft(t, n, r.max) : Math.min(n, t)), n;
}
function tE(n, e, t) {
  return {
    min: e !== void 0 ? n.min + e : void 0,
    max: t !== void 0 ? n.max + t - (n.max - n.min) : void 0
  };
}
function G5(n, { top: e, left: t, bottom: r, right: i }) {
  return {
    x: tE(n.x, t, i),
    y: tE(n.y, e, r)
  };
}
function nE(n, e) {
  let t = e.min - n.min, r = e.max - n.max;
  return e.max - e.min < n.max - n.min && ([t, r] = [r, t]), { min: t, max: r };
}
function Y5(n, e) {
  return {
    x: nE(n.x, e.x),
    y: nE(n.y, e.y)
  };
}
function q5(n, e) {
  let t = 0.5;
  const r = Zn(n), i = Zn(e);
  return i > r ? t = /* @__PURE__ */ Ja(e.min, e.max - r, n.min) : r > i && (t = /* @__PURE__ */ Ja(n.min, n.max - i, e.min)), Oi(0, 1, t);
}
function K5(n, e) {
  const t = {};
  return e.min !== void 0 && (t.min = e.min - n.min), e.max !== void 0 && (t.max = e.max - n.min), t;
}
const Rg = 0.35;
function J5(n = Rg) {
  return n === !1 ? n = 0 : n === !0 && (n = Rg), {
    x: rE(n, "left", "right"),
    y: rE(n, "top", "bottom")
  };
}
function rE(n, e, t) {
  return {
    min: iE(n, e),
    max: iE(n, t)
  };
}
function iE(n, e) {
  return typeof n == "number" ? n : n[e] || 0;
}
const Q5 = /* @__PURE__ */ new WeakMap();
class Z5 {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = nn(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = e;
  }
  start(e, { snapToCursor: t = !1, distanceThreshold: r } = {}) {
    const { presenceContext: i } = this.visualElement;
    if (i && i.isPresent === !1)
      return;
    const s = (h) => {
      t ? (this.stopAnimation(), this.snapToCursor($c(h).point)) : this.pauseAnimation();
    }, o = (h, p) => {
      this.stopAnimation();
      const { drag: g, dragPropagation: y, onDragStart: b } = this.getProps();
      if (g && !y && (this.openDragLock && this.openDragLock(), this.openDragLock = K3(g), !this.openDragLock))
        return;
      this.latestPointerEvent = h, this.latestPanInfo = p, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Ur((w) => {
        let T = this.getAxisMotionValue(w).get() || 0;
        if (Mi.test(T)) {
          const { projection: C } = this.visualElement;
          if (C && C.layout) {
            const k = C.layout.layoutBox[w];
            k && (T = Zn(k) * (parseFloat(T) / 100));
          }
        }
        this.originPoint[w] = T;
      }), b && Rt.postRender(() => b(h, p)), wg(this.visualElement, "transform");
      const { animationState: S } = this.visualElement;
      S && S.setActive("whileDrag", !0);
    }, a = (h, p) => {
      this.latestPointerEvent = h, this.latestPanInfo = p;
      const { dragPropagation: g, dragDirectionLock: y, onDirectionLock: b, onDrag: S } = this.getProps();
      if (!g && !this.openDragLock)
        return;
      const { offset: w } = p;
      if (y && this.currentDirection === null) {
        this.currentDirection = X5(w), this.currentDirection !== null && b && b(this.currentDirection);
        return;
      }
      this.updateAxis("x", p.point, w), this.updateAxis("y", p.point, w), this.visualElement.render(), S && S(h, p);
    }, c = (h, p) => {
      this.latestPointerEvent = h, this.latestPanInfo = p, this.stop(h, p), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, u = () => Ur((h) => {
      var p;
      return this.getAnimationState(h) === "paused" && ((p = this.getAxisMotionValue(h).animation) == null ? void 0 : p.play());
    }), { dragSnapToOrigin: d } = this.getProps();
    this.panSession = new iR(e, {
      onSessionStart: s,
      onStart: o,
      onMove: a,
      onSessionEnd: c,
      resumeAnimation: u
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: d,
      distanceThreshold: r,
      contextWindow: rR(this.visualElement),
      element: this.visualElement.current
    });
  }
  /**
   * @internal
   */
  stop(e, t) {
    const r = e || this.latestPointerEvent, i = t || this.latestPanInfo, s = this.isDragging;
    if (this.cancel(), !s || !i || !r)
      return;
    const { velocity: o } = i;
    this.startAnimation(o);
    const { onDragEnd: a } = this.getProps();
    a && Rt.postRender(() => a(r, i));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: t } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.endPanSession();
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), t && t.setActive("whileDrag", !1);
  }
  /**
   * Clean up the pan session without modifying other drag state.
   * This is used during unmount to ensure event listeners are removed
   * without affecting projection animations or drag locks.
   * @internal
   */
  endPanSession() {
    this.panSession && this.panSession.end(), this.panSession = void 0;
  }
  updateAxis(e, t, r) {
    const { drag: i } = this.getProps();
    if (!r || !Yu(e, i, this.currentDirection))
      return;
    const s = this.getAxisMotionValue(e);
    let o = this.originPoint[e] + r[e];
    this.constraints && this.constraints[e] && (o = $5(o, this.constraints[e], this.elastic[e])), s.set(o);
  }
  resolveConstraints() {
    var s;
    const { dragConstraints: e, dragElastic: t } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (s = this.visualElement.projection) == null ? void 0 : s.layout, i = this.constraints;
    e && zl(e) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : e && r ? this.constraints = G5(r.layoutBox, e) : this.constraints = !1, this.elastic = J5(t), i !== this.constraints && r && this.constraints && !this.hasMutatedConstraints && Ur((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = K5(r.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: t } = this.getProps();
    if (!e || !zl(e))
      return !1;
    const r = e.current;
    mi(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const s = l$(r, i.root, this.visualElement.getTransformPagePoint());
    let o = Y5(i.layout.layoutBox, s);
    if (t) {
      const a = t(s$(o));
      this.hasMutatedConstraints = !!a, a && (o = AD(a));
    }
    return o;
  }
  startAnimation(e) {
    const { drag: t, dragMomentum: r, dragElastic: i, dragTransition: s, dragSnapToOrigin: o, onDragTransitionEnd: a } = this.getProps(), c = this.constraints || {}, u = Ur((d) => {
      if (!Yu(d, t, this.currentDirection))
        return;
      let h = c && c[d] || {};
      o && (h = { min: 0, max: 0 });
      const p = i ? 200 : 1e6, g = i ? 40 : 1e7, y = {
        type: "inertia",
        velocity: r ? e[d] : 0,
        bounceStiffness: p,
        bounceDamping: g,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...s,
        ...h
      };
      return this.startAxisValueAnimation(d, y);
    });
    return Promise.all(u).then(a);
  }
  startAxisValueAnimation(e, t) {
    const r = this.getAxisMotionValue(e);
    return wg(this.visualElement, e), r.start(uv(e, r, 0, t, this.visualElement, !1));
  }
  stopAnimation() {
    Ur((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    Ur((e) => {
      var t;
      return (t = this.getAxisMotionValue(e).animation) == null ? void 0 : t.pause();
    });
  }
  getAnimationState(e) {
    var t;
    return (t = this.getAxisMotionValue(e).animation) == null ? void 0 : t.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const t = `_drag${e.toUpperCase()}`, r = this.visualElement.getProps(), i = r[t];
    return i || this.visualElement.getValue(e, (r.initial ? r.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    Ur((t) => {
      const { drag: r } = this.getProps();
      if (!Yu(t, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, s = this.getAxisMotionValue(t);
      if (i && i.layout) {
        const { min: o, max: a } = i.layout.layoutBox[t], c = s.get() || 0;
        s.set(e[t] - Ft(o, a, 0.5) + c);
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: t } = this.getProps(), { projection: r } = this.visualElement;
    if (!zl(t) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    Ur((o) => {
      const a = this.getAxisMotionValue(o);
      if (a && this.constraints !== !1) {
        const c = a.get();
        i[o] = q5({ min: c, max: c }, this.constraints[o]);
      }
    });
    const { transformTemplate: s } = this.visualElement.getProps();
    this.visualElement.current.style.transform = s ? s({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), Ur((o) => {
      if (!Yu(o, e, null))
        return;
      const a = this.getAxisMotionValue(o), { min: c, max: u } = this.constraints[o];
      a.set(Ft(c, u, i[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    Q5.set(this.visualElement, this);
    const e = this.visualElement.current, t = Zl(e, "pointerdown", (c) => {
      const { drag: u, dragListener: d = !0 } = this.getProps(), h = c.target, p = h !== e && yD(h);
      u && d && !p && this.start(c);
    }), r = () => {
      const { dragConstraints: c } = this.getProps();
      zl(c) && c.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, s = i.addEventListener("measure", r);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), Rt.read(r);
    const o = Sc(window, "resize", () => this.scalePositionWithinConstraints()), a = i.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: u }) => {
      this.isDragging && u && (Ur((d) => {
        const h = this.getAxisMotionValue(d);
        h && (this.originPoint[d] += c[d].translate, h.set(h.get() + c[d].translate));
      }), this.visualElement.render());
    });
    return () => {
      o(), t(), s(), a && a();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: t = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: s = !1, dragElastic: o = Rg, dragMomentum: a = !0 } = e;
    return {
      ...e,
      drag: t,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: s,
      dragElastic: o,
      dragMomentum: a
    };
  }
}
function Yu(n, e, t) {
  return (e === !0 || e === n) && (t === null || t === n);
}
function X5(n, e = 10) {
  let t = null;
  return Math.abs(n.y) > e ? t = "y" : Math.abs(n.x) > e && (t = "x"), t;
}
class e4 extends no {
  constructor(e) {
    super(e), this.removeGroupControls = Jr, this.removeListeners = Jr, this.controls = new Z5(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Jr;
  }
  update() {
    const { dragControls: e } = this.node.getProps(), { dragControls: t } = this.node.prevProps || {};
    e !== t && (this.removeGroupControls(), e && (this.removeGroupControls = e.subscribe(this.controls)));
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
  }
}
const sE = (n) => (e, t) => {
  n && Rt.postRender(() => n(e, t));
};
class t4 extends no {
  constructor() {
    super(...arguments), this.removePointerDownListener = Jr;
  }
  onPointerDown(e) {
    this.session = new iR(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: rR(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: t, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: sE(e),
      onStart: sE(t),
      onMove: r,
      onEnd: (s, o) => {
        delete this.session, i && Rt.postRender(() => i(s, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Zl(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
let om = !1;
class n4 extends my {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: t, switchLayoutGroup: r, layoutId: i } = this.props, { projection: s } = e;
    s && (t.group && t.group.add(s), r && r.register && i && r.register(s), om && s.root.didUpdate(), s.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), s.setOptions({
      ...s.options,
      layoutDependency: this.props.layoutDependency,
      onExitComplete: () => this.safeToRemove()
    })), Ed.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: t, visualElement: r, drag: i, isPresent: s } = this.props, { projection: o } = r;
    return o && (o.isPresent = s, e.layoutDependency !== t && o.setOptions({
      ...o.options,
      layoutDependency: t
    }), om = !0, i || e.layoutDependency !== t || t === void 0 || e.isPresent !== s ? o.willUpdate() : this.safeToRemove(), e.isPresent !== s && (s ? o.promote() : o.relegate() || Rt.postRender(() => {
      const a = o.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), mv.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: t, switchLayoutGroup: r } = this.props, { projection: i } = e;
    om = !0, i && (i.scheduleCheckAfterUnmount(), t && t.group && t.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function oR(n) {
  const [e, t] = u5(), r = Nn(gC);
  return x.jsx(n4, { ...n, layoutGroup: r, switchLayoutGroup: Nn(tR), isPresent: e, safeToRemove: t });
}
const r4 = {
  pan: {
    Feature: t4
  },
  drag: {
    Feature: e4,
    ProjectionNode: qD,
    MeasureLayout: oR
  }
};
function oE(n, e, t) {
  const { props: r } = n;
  n.animationState && r.whileHover && n.animationState.setActive("whileHover", t === "Start");
  const i = "onHover" + t, s = r[i];
  s && Rt.postRender(() => s(e, $c(e)));
}
class i4 extends no {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = J3(e, (t, r) => (oE(this.node, r, "Start"), (i) => oE(this.node, i, "End"))));
  }
  unmount() {
  }
}
class s4 extends no {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Hc(Sc(this.node.current, "focus", () => this.onFocus()), Sc(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function aE(n, e, t) {
  const { props: r } = n;
  if (n.current instanceof HTMLButtonElement && n.current.disabled)
    return;
  n.animationState && r.whileTap && n.animationState.setActive("whileTap", t === "Start");
  const i = "onTap" + (t === "End" ? "" : t), s = r[i];
  s && Rt.postRender(() => s(e, $c(e)));
}
class o4 extends no {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = X3(e, (t, r) => (aE(this.node, r, "Start"), (i, { success: s }) => aE(this.node, i, s ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const kg = /* @__PURE__ */ new WeakMap(), am = /* @__PURE__ */ new WeakMap(), a4 = (n) => {
  const e = kg.get(n.target);
  e && e(n);
}, l4 = (n) => {
  n.forEach(a4);
};
function c4({ root: n, ...e }) {
  const t = n || document;
  am.has(t) || am.set(t, {});
  const r = am.get(t), i = JSON.stringify(e);
  return r[i] || (r[i] = new IntersectionObserver(l4, { root: n, ...e })), r[i];
}
function u4(n, e, t) {
  const r = c4(e);
  return kg.set(n, t), r.observe(n), () => {
    kg.delete(n), r.unobserve(n);
  };
}
const d4 = {
  some: 0,
  all: 1
};
class f4 extends no {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: t, margin: r, amount: i = "some", once: s } = e, o = {
      root: t ? t.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : d4[i]
    }, a = (c) => {
      const { isIntersecting: u } = c;
      if (this.isInView === u || (this.isInView = u, s && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: d, onViewportLeave: h } = this.node.getProps(), p = u ? d : h;
      p && p(c);
    };
    return u4(this.node.current, o, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: t } = this.node;
    ["amount", "margin", "root"].some(h4(e, t)) && this.startObserver();
  }
  unmount() {
  }
}
function h4({ viewport: n = {} }, { viewport: e = {} } = {}) {
  return (t) => n[t] !== e[t];
}
const p4 = {
  inView: {
    Feature: f4
  },
  tap: {
    Feature: o4
  },
  focus: {
    Feature: s4
  },
  hover: {
    Feature: i4
  }
}, m4 = {
  layout: {
    ProjectionNode: qD,
    MeasureLayout: oR
  }
}, g4 = {
  ...z5,
  ...p4,
  ...r4,
  ...m4
}, us = /* @__PURE__ */ P5(g4, L5);
function Mg(n) {
  const e = Gy(() => Wo(n)), { isStatic: t } = Nn(Ev);
  if (t) {
    const [, r] = Et(n);
    wt(() => e.on("change", r), []);
  }
  return e;
}
function aR(n, e) {
  const t = Mg(e()), r = () => t.set(e());
  return r(), vC(() => {
    const i = () => Rt.preRender(r, !1, !0), s = n.map((o) => o.on("change", i));
    return () => {
      s.forEach((o) => o()), cs(r);
    };
  }), t;
}
function y4(n) {
  Jl.current = [], n();
  const e = aR(Jl.current, n);
  return Jl.current = void 0, e;
}
function Xl(n, e, t, r) {
  if (typeof n == "function")
    return y4(n);
  const s = typeof e == "function" ? e : Sd(e, t, r);
  return Array.isArray(n) ? lE(n, s) : lE([n], ([o]) => s(o));
}
function lE(n, e) {
  const t = Gy(() => []);
  return aR(n, () => {
    t.length = 0;
    const r = n.length;
    for (let i = 0; i < r; i++)
      t[i] = n[i].get();
    return e(t);
  });
}
function v4() {
  !vv.current && bD();
  const [n] = Et(Gd.current);
  return process.env.NODE_ENV !== "production" && qf(n !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), n;
}
function Cv(n) {
  return typeof n == "object" && !Array.isArray(n);
}
function lR(n, e, t, r) {
  return n == null ? [] : typeof n == "string" && Cv(e) ? fD(n, t, r) : n instanceof NodeList ? Array.from(n) : Array.isArray(n) ? n.filter((i) => i != null) : [n];
}
function b4(n, e, t) {
  return n * (e + 1);
}
function cE(n, e, t, r) {
  return typeof e == "number" ? e : e.startsWith("-") || e.startsWith("+") ? Math.max(0, n + parseFloat(e)) : e === "<" ? t : e.startsWith("<") ? Math.max(0, t + parseFloat(e.slice(1))) : r.get(e) ?? n;
}
function x4(n, e, t) {
  for (let r = 0; r < n.length; r++) {
    const i = n[r];
    i.at > e && i.at < t && (Vc(n, i), r--);
  }
}
function S4(n, e, t, r, i, s) {
  x4(n, i, s);
  for (let o = 0; o < e.length; o++)
    n.push({
      value: e[o],
      at: Ft(i, s, r[o]),
      easing: IC(t, o)
    });
}
function w4(n, e) {
  for (let t = 0; t < n.length; t++)
    n[t] = n[t] / (e + 1);
}
function E4(n, e) {
  return n.at === e.at ? n.value === null ? 1 : e.value === null ? -1 : 0 : n.at - e.at;
}
const A4 = "easeInOut", T4 = 20;
function C4(n, { defaultTransition: e = {}, ...t } = {}, r, i) {
  const s = e.duration || 0.3, o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), c = {}, u = /* @__PURE__ */ new Map();
  let d = 0, h = 0, p = 0;
  for (let g = 0; g < n.length; g++) {
    const y = n[g];
    if (typeof y == "string") {
      u.set(y, h);
      continue;
    } else if (!Array.isArray(y)) {
      u.set(y.name, cE(h, y.at, d, u));
      continue;
    }
    let [b, S, w = {}] = y;
    w.at !== void 0 && (h = cE(h, w.at, d, u));
    let T = 0;
    const C = (k, R, N, L = 0, j = 0) => {
      const W = D4(k), { delay: Z = 0, times: fe = JC(W), type: Oe = e.type || "keyframes", repeat: Ae, repeatType: Y, repeatDelay: re = 0, ...q } = R;
      let { ease: U = e.ease || "easeOut", duration: J } = R;
      const we = typeof Z == "function" ? Z(L, j) : Z, z = W.length, X = lv(Oe) ? Oe : i == null ? void 0 : i[Oe || "keyframes"];
      if (z <= 2 && X) {
        let xe = 100;
        if (z === 2 && M4(W)) {
          const G = W[1] - W[0];
          xe = Math.abs(G);
        }
        const H = {
          ...e,
          ...q
        };
        J !== void 0 && (H.duration = /* @__PURE__ */ fi(J));
        const le = GC(H, xe, X);
        U = le.ease, J = le.duration;
      }
      J ?? (J = s);
      const me = h + we;
      fe.length === 1 && fe[0] === 0 && (fe[1] = 1);
      const pe = fe.length - W.length;
      if (pe > 0 && KC(fe, pe), W.length === 1 && W.unshift(null), Ae) {
        mi(Ae < T4, "Repeat count too high, must be less than 20", "repeat-count-high"), J = b4(J, Ae);
        const xe = [...W], H = [...fe];
        U = Array.isArray(U) ? [...U] : [U];
        const le = [...U];
        for (let G = 0; G < Ae; G++) {
          W.push(...xe);
          for (let oe = 0; oe < xe.length; oe++)
            fe.push(H[oe] + (G + 1)), U.push(oe === 0 ? "linear" : IC(le, oe - 1));
        }
        w4(fe, Ae);
      }
      const he = me + J;
      S4(N, W, U, fe, me, he), T = Math.max(we + J, T), p = Math.max(he, p);
    };
    if (yn(b)) {
      const k = uE(b, a);
      C(S, w, dE("default", k));
    } else {
      const k = lR(b, S, r, c), R = k.length;
      for (let N = 0; N < R; N++) {
        S = S, w = w;
        const L = k[N], j = uE(L, a);
        for (const W in S)
          C(S[W], R4(w, W), dE(W, j), N, R);
      }
    }
    d = h, h += T;
  }
  return a.forEach((g, y) => {
    for (const b in g) {
      const S = g[b];
      S.sort(E4);
      const w = [], T = [], C = [];
      for (let L = 0; L < S.length; L++) {
        const { at: j, value: W, easing: Z } = S[L];
        w.push(W), T.push(/* @__PURE__ */ Ja(0, p, j)), C.push(Z || "easeOut");
      }
      T[0] !== 0 && (T.unshift(0), w.unshift(w[0]), C.unshift(A4)), T[T.length - 1] !== 1 && (T.push(1), w.push(null)), o.has(y) || o.set(y, {
        keyframes: {},
        transition: {}
      });
      const k = o.get(y);
      k.keyframes[b] = w;
      const { type: R, ...N } = e;
      k.transition[b] = {
        ...N,
        duration: p,
        ease: C,
        times: T,
        ...t
      };
    }
  }), o;
}
function uE(n, e) {
  return !e.has(n) && e.set(n, {}), e.get(n);
}
function dE(n, e) {
  return e[n] || (e[n] = []), e[n];
}
function D4(n) {
  return Array.isArray(n) ? n : [n];
}
function R4(n, e) {
  return n && n[e] ? {
    ...n,
    ...n[e]
  } : { ...n };
}
const k4 = (n) => typeof n == "number", M4 = (n) => n.every(k4);
function _4(n) {
  const e = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, t = yv(n) && !vD(n) ? new PD(e) : new MD(e);
  t.mount(n), bc.set(n, t);
}
function O4(n) {
  const e = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        output: {}
      },
      latestValues: {}
    }
  }, t = new m$(e);
  t.mount(n), bc.set(n, t);
}
function I4(n, e) {
  return yn(n) || typeof n == "number" || typeof n == "string" && !Cv(e);
}
function cR(n, e, t, r) {
  const i = [];
  if (I4(n, e))
    i.push(WD(n, Cv(e) && e.default || e, t && (t.default || t)));
  else {
    if (n == null)
      return i;
    const s = lR(n, e, r), o = s.length;
    mi(!!o, "No valid elements provided.", "no-valid-elements");
    for (let a = 0; a < o; a++) {
      const c = s[a], u = c instanceof Element ? _4 : O4;
      bc.has(c) || u(c);
      const d = bc.get(c), h = { ...t };
      "delay" in h && typeof h.delay == "function" && (h.delay = h.delay(a, o)), i.push(...hv(d, { ...e, transition: h }, {}));
    }
  }
  return i;
}
function N4(n, e, t) {
  const r = [];
  return C4(n, e, t, { spring: vc }).forEach(({ keyframes: s, transition: o }, a) => {
    r.push(...cR(a, s, o));
  }), r;
}
function P4(n) {
  return Array.isArray(n) && n.some(Array.isArray);
}
function L4(n = {}) {
  const { scope: e, reduceMotion: t } = n;
  function r(i, s, o) {
    let a = [], c;
    if (P4(i))
      a = N4(i, t !== void 0 ? { reduceMotion: t, ...s } : s, e);
    else {
      const { onComplete: d, ...h } = o || {};
      typeof d == "function" && (c = d), a = cR(i, s, t !== void 0 ? { reduceMotion: t, ...h } : h, e);
    }
    const u = new g3(a);
    return c && u.finished.then(c), e && (e.animations.push(u), u.finished.then(() => {
      Vc(e.animations, u);
    })), u;
  }
  return r;
}
const qu = L4();
function fE(n, e) {
  let t;
  return (...r) => {
    window.clearTimeout(t), t = window.setTimeout(() => n(...r), e);
  };
}
function B4({ debounce: n, scroll: e, polyfill: t, offsetSize: r } = { debounce: 0, scroll: !1, offsetSize: !1 }) {
  const i = t || (typeof window > "u" ? class {
  } : window.ResizeObserver);
  if (!i) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
  const [s, o] = Et({ left: 0, top: 0, width: 0, height: 0, bottom: 0, right: 0, x: 0, y: 0 }), a = bt({ element: null, scrollContainers: null, resizeObserver: null, lastBounds: s, orientationHandler: null }), c = n ? typeof n == "number" ? n : n.scroll : null, u = n ? typeof n == "number" ? n : n.resize : null, d = bt(!1);
  wt(() => (d.current = !0, () => void (d.current = !1)));
  const [h, p, g] = Wt(() => {
    const w = () => {
      if (!a.current.element) return;
      const { left: T, top: C, width: k, height: R, bottom: N, right: L, x: j, y: W } = a.current.element.getBoundingClientRect(), Z = { left: T, top: C, width: k, height: R, bottom: N, right: L, x: j, y: W };
      a.current.element instanceof HTMLElement && r && (Z.height = a.current.element.offsetHeight, Z.width = a.current.element.offsetWidth), Object.freeze(Z), d.current && !V4(a.current.lastBounds, Z) && o(a.current.lastBounds = Z);
    };
    return [w, u ? fE(w, u) : w, c ? fE(w, c) : w];
  }, [o, r, c, u]);
  function y() {
    a.current.scrollContainers && (a.current.scrollContainers.forEach((w) => w.removeEventListener("scroll", g, !0)), a.current.scrollContainers = null), a.current.resizeObserver && (a.current.resizeObserver.disconnect(), a.current.resizeObserver = null), a.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", a.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", a.current.orientationHandler));
  }
  function b() {
    a.current.element && (a.current.resizeObserver = new i(g), a.current.resizeObserver.observe(a.current.element), e && a.current.scrollContainers && a.current.scrollContainers.forEach((w) => w.addEventListener("scroll", g, { capture: !0, passive: !0 })), a.current.orientationHandler = () => {
      g();
    }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", a.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", a.current.orientationHandler));
  }
  const S = (w) => {
    !w || w === a.current.element || (y(), a.current.element = w, a.current.scrollContainers = uR(w), b());
  };
  return F4(g, !!e), j4(p), wt(() => {
    y(), b();
  }, [e, g, p]), wt(() => y, []), [S, s, h];
}
function j4(n) {
  wt(() => {
    const e = n;
    return window.addEventListener("resize", e), () => void window.removeEventListener("resize", e);
  }, [n]);
}
function F4(n, e) {
  wt(() => {
    if (e) {
      const t = n;
      return window.addEventListener("scroll", t, { capture: !0, passive: !0 }), () => void window.removeEventListener("scroll", t, !0);
    }
  }, [n, e]);
}
function uR(n) {
  const e = [];
  if (!n || n === document.body) return e;
  const { overflow: t, overflowX: r, overflowY: i } = window.getComputedStyle(n);
  return [t, r, i].some((s) => s === "auto" || s === "scroll") && e.push(n), [...e, ...uR(n.parentElement)];
}
const z4 = ["x", "y", "top", "bottom", "left", "right", "width", "height"], V4 = (n, e) => z4.every((t) => n[t] === e[t]);
var dR = ps(
  void 0
);
function Gc() {
  const n = Nn(dR);
  if (!n) throw new Error("Sheet context error");
  return n;
}
var ds = {
  root: {
    base: {
      position: "fixed",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      overflow: "hidden",
      pointerEvents: "none"
    },
    decorative: {}
  },
  backdrop: {
    base: {
      zIndex: 1,
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      touchAction: "none",
      userSelect: "none"
    },
    decorative: {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      border: "none",
      WebkitTapHighlightColor: "transparent"
    }
  },
  container: {
    base: {
      zIndex: 2,
      position: "absolute",
      left: 0,
      bottom: 0,
      width: "100%",
      pointerEvents: "auto",
      display: "flex",
      flexDirection: "column"
    },
    decorative: {
      backgroundColor: "#fff",
      borderTopRightRadius: "8px",
      borderTopLeftRadius: "8px",
      boxShadow: "0px -2px 16px rgba(0, 0, 0, 0.3)"
    }
  },
  headerWrapper: {
    base: {
      width: "100%"
    },
    decorative: {}
  },
  header: {
    base: {
      width: "100%",
      position: "relative"
    },
    decorative: {
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  },
  indicatorWrapper: {
    base: {
      display: "flex"
    },
    decorative: {}
  },
  indicator: {
    base: {
      display: "inline-block"
    },
    decorative: {
      width: "18px",
      height: "4px",
      borderRadius: "99px",
      backgroundColor: "#ddd"
    }
  },
  content: {
    base: {
      minHeight: "0px",
      position: "relative",
      flexGrow: 1,
      display: "flex",
      flexDirection: "column"
    },
    decorative: {}
  },
  scroller: {
    base: {
      height: "100%",
      overflowY: "auto",
      overscrollBehaviorY: "none"
    },
    decorative: {}
  }
}, hE = "calc(100% - env(safe-area-inset-top) - 34px)", wc = typeof window > "u", H4 = {
  ease: "easeOut",
  duration: 0.2
}, U4 = {
  ease: "linear",
  duration: 0.01
}, W4 = 0.6, $4 = 500;
function fs(n, e) {
  return e ? n.base : { ...n.base, ...n.decorative };
}
function G4(n) {
  for (let e = 0; e < n.length; e++)
    if (n[e + 1] < n[e]) return !1;
  return !0;
}
function Qd(n) {
  return (e) => {
    n.forEach((t) => {
      typeof t == "function" ? t(e) : t && (t.current = e);
    });
  };
}
function Dv(n) {
  var e;
  return typeof window < "u" && window.navigator != null ? n.test(
    // @ts-expect-error
    ((e = window.navigator.userAgentData) == null ? void 0 : e.platform) || window.navigator.platform
  ) : !1;
}
function Zf(n) {
  let e = null;
  return () => (e == null && (e = n()), e);
}
var Y4 = Zf(function() {
  return Dv(/^Mac/i);
}), q4 = Zf(function() {
  return Dv(/^iPhone/i);
}), K4 = Zf(function() {
  return Dv(/^iPad/i) || Y4() && navigator.maxTouchPoints > 1;
}), J4 = Zf(function() {
  return q4() || K4();
});
function Q4(n, e = 50, t = 20) {
  return new Promise((r) => {
    let i = 0;
    const s = setInterval(() => {
      const o = document.getElementsByClassName(
        n
      )[0];
      i++, (o || i >= t) && (clearInterval(s), r(o));
    }, e);
  });
}
var Z4 = (n) => !!n.onClick || !!n.onTap, fR = hs(
  ({ style: n, className: e = "", unstyled: t, ...r }, i) => {
    const s = Gc(), o = Z4(r), a = o ? us.button : us.div, c = o ? "auto" : "none", u = t ?? s.unstyled, d = {
      ...fs(ds.backdrop, u),
      ...n,
      pointerEvents: c
    };
    return /* @__PURE__ */ ze.createElement(
      a,
      {
        ...r,
        ref: i,
        className: `react-modal-sheet-backdrop ${e}`,
        style: d,
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 1 }
      }
    );
  }
);
fR.displayName = "SheetBackdrop";
var hR = hs(
  ({ children: n, style: e, className: t = "", unstyled: r, ...i }, s) => {
    const o = Gc(), a = r ?? o.unstyled, c = {
      ...fs(ds.container, a),
      ...e,
      y: o.y
    };
    return o.detent === "default" && (c.height = hE), o.detent === "full" && (c.height = "100%", c.maxHeight = "100%"), o.detent === "content" && (c.height = "auto", c.maxHeight = hE), /* @__PURE__ */ ze.createElement(
      us.div,
      {
        ...i,
        ref: Qd([
          s,
          o.sheetRef,
          o.sheetBoundsRef
        ]),
        className: `react-modal-sheet-container ${t}`,
        style: c
      },
      n
    );
  }
);
hR.displayName = "SheetContainer";
var X4 = { bottom: 0, top: 0, left: 0, right: 0 };
function pR() {
  const n = bt(null), e = fn(() => X4, []);
  return { ref: n, onMeasure: e };
}
function e6(n = {}) {
  const { debounceDelay: e = 32, isEnabled: t = !0 } = n, [r, i] = Et(null), [s, o] = Et(void 0);
  return wt(() => {
    if (!r || !t) return;
    let a = null;
    function c(h) {
      const { scrollTop: p, scrollHeight: g, clientHeight: y } = h;
      if (!(g > y)) {
        s && o(void 0);
        return;
      }
      const S = p <= 0, w = Math.ceil(g) - Math.ceil(p) === Math.ceil(y);
      let T;
      S ? T = "top" : w ? T = "bottom" : T = "middle", T !== s && o(T);
    }
    function u(h) {
      if (h.currentTarget instanceof HTMLElement) {
        const p = h.currentTarget;
        a && clearTimeout(a), e === 0 ? c(p) : a = setTimeout(
          () => c(p),
          e
        );
      }
    }
    function d(h) {
      h.currentTarget instanceof HTMLElement && c(h.currentTarget);
    }
    return c(r), r.addEventListener("scroll", u), r.addEventListener("touchstart", d), () => {
      a && clearTimeout(a), r.removeEventListener("scroll", u), r.removeEventListener("touchstart", d);
    };
  }, [r, t]), {
    scrollRef: (a) => i(a),
    scrollPosition: s
  };
}
var mR = hs(
  ({
    disableScroll: n,
    disableDrag: e,
    children: t,
    style: r,
    className: i = "",
    scrollClassName: s = "",
    scrollStyle: o,
    scrollRef: a = null,
    unstyled: c,
    ...u
  }, d) => {
    const h = Gc(), p = pR(), g = e6(), y = typeof n == "function" ? n({
      scrollPosition: g.scrollPosition,
      currentSnap: h.currentSnap
    }) : !!n, b = !y && g.scrollPosition && g.scrollPosition !== "top", T = (typeof e == "function" ? e({
      scrollPosition: g.scrollPosition,
      currentSnap: h.currentSnap
    }) : !!e) || b || h.disableDrag || h.disableDrag ? void 0 : h.dragProps, C = c ?? h.unstyled, k = {
      ...fs(ds.content, C),
      ...r
    }, R = fs(ds.scroller, C);
    return h.avoidKeyboard && (R.paddingBottom = "env(keyboard-inset-height, var(--keyboard-inset-height, 0px))"), y && (R.overflowY = "hidden"), /* @__PURE__ */ ze.createElement(
      us.div,
      {
        ...u,
        ref: Qd([d, p.ref]),
        className: `react-modal-sheet-content ${i}`,
        style: k,
        ...T,
        dragConstraints: p.ref,
        onMeasureDragConstraints: p.onMeasure
      },
      /* @__PURE__ */ ze.createElement(
        us.div,
        {
          ref: Qd([g.scrollRef, a]),
          style: { ...R, ...o },
          className: `react-modal-sheet-content-scroller ${s}`
        },
        t
      )
    );
  }
);
mR.displayName = "SheetContent";
function gR({
  style: n,
  className: e = "",
  unstyled: t,
  ...r
}) {
  const i = Gc(), s = Xl(
    i.indicatorRotation,
    (d) => `translateX(2px) rotate(${d}deg)`
  ), o = Xl(
    i.indicatorRotation,
    (d) => `translateX(-2px) rotate(${-1 * d}deg)`
  ), a = t ?? i.unstyled, c = {
    ...fs(ds.indicatorWrapper, a),
    ...n
  }, u = fs(ds.indicator, a);
  return /* @__PURE__ */ ze.createElement(
    "div",
    {
      className: `react-modal-sheet-drag-indicator-container ${e}`,
      style: c,
      ...r
    },
    /* @__PURE__ */ ze.createElement(
      us.span,
      {
        className: "react-modal-sheet-drag-indicator",
        style: { ...u, transform: s }
      }
    ),
    /* @__PURE__ */ ze.createElement(
      us.span,
      {
        className: "react-modal-sheet-drag-indicator",
        style: { ...u, transform: o }
      }
    )
  );
}
var yR = hs(
  ({ children: n, style: e, disableDrag: t, unstyled: r, className: i = "", ...s }, o) => {
    const a = Gc(), c = pR(), u = t || a.disableDrag ? void 0 : a.dragProps, d = r ?? a.unstyled, h = {
      ...fs(ds.headerWrapper, d),
      ...e
    }, p = fs(ds.header, d);
    return /* @__PURE__ */ ze.createElement(
      us.div,
      {
        ...s,
        ref: Qd([o, c.ref]),
        style: h,
        className: `react-modal-sheet-header-container ${i}`,
        ...u,
        dragConstraints: c.ref,
        onMeasureDragConstraints: c.onMeasure
      },
      n || /* @__PURE__ */ ze.createElement("div", { className: "react-modal-sheet-header", style: p }, /* @__PURE__ */ ze.createElement(gR, null))
    );
  }
);
yR.displayName = "SheetHeader";
var Ec = wc ? wt : gy;
function t6() {
  const [n, e] = Et(() => ({
    windowHeight: wc ? 0 : window.innerHeight,
    windowWidth: wc ? 0 : window.innerWidth
  }));
  return Ec(() => {
    function t() {
      e({
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth
      });
    }
    return t(), window.addEventListener("resize", t), () => {
      window.removeEventListener("resize", t);
    };
  }, []), n;
}
function n6() {
  const [n] = Et(() => {
    const e = { top: 0, left: 0, right: 0, bottom: 0 };
    if (wc) return e;
    const t = document.querySelector(":root");
    if (!t) return e;
    t.style.setProperty("--rms-sat", "env(safe-area-inset-top)"), t.style.setProperty("--rms-sal", "env(safe-area-inset-left)"), t.style.setProperty("--rms-sar", "env(safe-area-inset-right)"), t.style.setProperty("--rms-sab", "env(safe-area-inset-bottom)");
    const r = getComputedStyle(t), i = Ku(r, "--rms-sat"), s = Ku(r, "--rms-sal"), o = Ku(r, "--rms-sar"), a = Ku(r, "--rms-sab");
    return t.style.removeProperty("--rms-sat"), t.style.removeProperty("--rms-sal"), t.style.removeProperty("--rms-sar"), t.style.removeProperty("--rms-sab"), { top: i, left: s, right: o, bottom: a };
  });
  return n;
}
function Ku(n, e) {
  const t = n.getPropertyValue(e).replace("px", "").trim();
  return parseInt(t, 10) || 0;
}
function r6({
  y: n,
  detent: e,
  rootId: t,
  sheetHeight: r,
  snapPoints: i,
  startThreshold: s
}) {
  const o = n6().top;
  let a = t;
  a && e === "full" && (console.warn('Using "full" detent with modal effect is not supported.'), a = void 0), Ec(() => () => {
    a && pE(a);
  }, []), Ec(() => {
    if (!a) return;
    const c = document.querySelector(`#${a}`);
    if (!c) return;
    const u = n.on("animationStart", () => {
      i6(a);
    }), d = n.on("change", (y) => {
      if (!c) return;
      let b = Math.max(0, 1 - y / r);
      const S = i.length > 1 ? i[i.length - 2] : void 0;
      if (S !== void 0) {
        const R = S.snapValueY;
        y <= R ? b = (R - y) / R : b = 0;
      }
      if (s !== void 0) {
        const R = r - Math.min(Math.floor(s * r), r);
        y <= R ? b = (R - y) / R : b = 0;
      }
      b = Math.max(0, Math.min(1, b));
      const w = window.innerWidth, T = Sd(b, [0, 1], [0, 24 + o]), C = Sd(b, [0, 1], [1, (w - 16) / w]), k = Sd(b, [0, 1], [0, 10]);
      c.style.transform = `scale(${C}) translate3d(0, ${T}px, 0)`, c.style.borderTopRightRadius = `${k}px`, c.style.borderTopLeftRadius = `${k}px`;
    });
    function h() {
      n.get() - 5 >= r && pE(a);
    }
    const p = n.on("animationComplete", h), g = n.on("animationCancel", h);
    return () => {
      u(), d(), p(), g();
    };
  }, [n, a, o, s, r]);
}
function i6(n) {
  const e = document.querySelector(`#${n}`), t = document.querySelector("body");
  e && (t.style.backgroundColor = "#000", e.style.overflow = "hidden", e.style.transitionTimingFunction = "cubic-bezier(0.32, 0.72, 0, 1)", e.style.transitionProperty = "transform, border-radius", e.style.transitionDuration = "0.5s", e.style.transformOrigin = "center top");
}
function pE(n) {
  const e = document.querySelector(`#${n}`), t = document.querySelector("body");
  e && (t.style.removeProperty("background-color"), e.style.removeProperty("overflow"), e.style.removeProperty("transition-timing-function"), e.style.removeProperty("transition-property"), e.style.removeProperty("transition-duration"), e.style.removeProperty("transform-origin"), e.style.removeProperty("transform"), e.style.removeProperty("border-top-right-radius"), e.style.removeProperty("border-top-left-radius"));
}
var s6 = 24;
function _g(...n) {
  return (...e) => {
    for (const t of n)
      typeof t == "function" && t(...e);
  };
}
var lm = typeof document < "u" && window.visualViewport;
function mE(n, e) {
  if (!n)
    return !1;
  const t = window.getComputedStyle(n);
  let r = /(auto|scroll)/.test(
    t.overflow + t.overflowX + t.overflowY
  );
  return r && e && (r = n.scrollHeight !== n.clientHeight || n.scrollWidth !== n.clientWidth), r;
}
function vR(n, e) {
  let t = n;
  for (mE(t, e) && (t = t.parentElement); t && !mE(t, e); )
    t = t.parentElement;
  return t || document.scrollingElement || document.documentElement;
}
var o6 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]), Ju = 0, Qu;
function a6(n = {}) {
  const { isDisabled: e } = n;
  Ec(() => {
    if (!e)
      return Ju++, Ju === 1 && (J4() ? Qu = c6() : Qu = l6()), () => {
        Ju--, Ju === 0 && (Qu == null || Qu());
      };
  }, [e]);
}
function l6() {
  return _g(
    ec(
      document.documentElement,
      "paddingRight",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    ),
    ec(document.documentElement, "overflow", "hidden")
  );
}
function c6() {
  let n, e = 0;
  const t = (h) => {
    var p;
    const g = (p = h.composedPath()) == null ? void 0 : p[0];
    n = vR(g, !0), !(n === document.documentElement && n === document.body) && (e = h.changedTouches[0].pageY);
  }, r = (h) => {
    if (n === void 0)
      return;
    if (!n || n === document.documentElement || n === document.body) {
      h.preventDefault();
      return;
    }
    const p = h.changedTouches[0].pageY, g = n.scrollTop, y = n.scrollHeight - n.clientHeight;
    y !== 0 && ((g <= 0 && p > e || g >= y && p < e) && h.preventDefault(), e = p);
  }, i = (h) => {
    var p;
    const g = (p = h.composedPath()) == null ? void 0 : p[0];
    yE(g) && g !== document.activeElement && (h.preventDefault(), g.style.transform = "translateY(-2000px)", g.focus(), requestAnimationFrame(() => {
      g.style.transform = "";
    }));
  }, s = (h) => {
    var p;
    const g = (p = h.composedPath()) == null ? void 0 : p[0];
    yE(g) && (g.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      g.style.transform = "", lm && (lm.height < window.innerHeight ? requestAnimationFrame(() => {
        gE(g);
      }) : lm.addEventListener(
        "resize",
        () => gE(g),
        { once: !0 }
      ));
    }));
  }, o = () => {
    window.scrollTo(0, 0);
  }, a = window.pageXOffset, c = window.pageYOffset, u = _g(
    ec(
      document.documentElement,
      "paddingRight",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    ),
    ec(document.documentElement, "overflow", "hidden"),
    ec(document.body, "marginTop", `-${c}px`)
  );
  window.scrollTo(0, 0);
  const d = _g(
    _l(document, "touchstart", t, {
      passive: !1,
      capture: !0
    }),
    _l(document, "touchmove", r, {
      passive: !1,
      capture: !0
    }),
    _l(document, "touchend", i, {
      passive: !1,
      capture: !0
    }),
    _l(document, "focus", s, !0),
    _l(window, "scroll", o)
  );
  return () => {
    u(), d(), window.scrollTo(a, c);
  };
}
function ec(n, e, t) {
  const r = n.style[e];
  return n.style[e] = t, () => {
    n.style[e] = r;
  };
}
function _l(n, e, t, r) {
  return n.addEventListener(e, t, r), () => {
    n.removeEventListener(e, t, r);
  };
}
function gE(n) {
  const e = document.scrollingElement || document.documentElement;
  for (; n && n !== e; ) {
    const t = vR(n);
    if (t !== document.documentElement && t !== document.body && t !== n) {
      const r = t.getBoundingClientRect().top, i = n.getBoundingClientRect().top, s = n.getBoundingClientRect().bottom, o = t.getBoundingClientRect().bottom + s6;
      s > o && (t.scrollTop += i - r);
    }
    n = t.parentElement;
  }
}
function yE(n) {
  return n instanceof HTMLInputElement && !o6.has(n.type) || n instanceof HTMLTextAreaElement || n instanceof HTMLElement && n.isContentEditable;
}
function $r(n) {
  const e = bt(void 0);
  return Ec(() => {
    e.current = n;
  }), fn((...t) => {
    const r = e.current;
    return r == null ? void 0 : r(...t);
  }, []);
}
function u6({
  isOpen: n,
  onClosed: e,
  onOpening: t,
  onOpen: r,
  onClosing: i
}) {
  const [s, o] = Et(n ? "opening" : "closed"), a = $r(() => e == null ? void 0 : e()), c = $r(() => t == null ? void 0 : t()), u = $r(() => r == null ? void 0 : r()), d = $r(() => i == null ? void 0 : i());
  return wt(() => {
    n && s === "closed" ? o("opening") : !n && (s === "open" || s === "opening") && o("closing");
  }, [n, s]), wt(() => {
    async function h() {
      switch (s) {
        case "closed":
          await (a == null ? void 0 : a());
          break;
        case "opening":
          await (c == null ? void 0 : c()), o("open");
          break;
        case "open":
          await (u == null ? void 0 : u());
          break;
        case "closing":
          await (d == null ? void 0 : d()), o("closed");
          break;
      }
    }
    h().catch((p) => {
      console.error("Internal sheet state error:", p);
    });
  }, [s]), s;
}
function d6(n = {}) {
  const {
    containerRef: e,
    isEnabled: t = !0,
    debounceDelay: r = 100,
    includeContentEditable: i = !0,
    visualViewportThreshold: s = 100
  } = n, [o, a] = Et({
    isVisible: !1,
    height: 0
  }), c = bt(null), u = bt(null), d = $r((h) => (h == null ? void 0 : h.tagName) === "INPUT" || (h == null ? void 0 : h.tagName) === "TEXTAREA" || i && h instanceof HTMLElement && h.isContentEditable);
  return wt(() => {
    if (!t) return;
    const h = window.visualViewport, p = navigator.virtualKeyboard;
    function g(T) {
      const C = (e == null ? void 0 : e.current) || document.documentElement;
      window.isSecureContext ? C.style.setProperty(
        "--keyboard-inset-height",
        `env(keyboard-inset-height, ${T}px)`
      ) : C.style.setProperty("--keyboard-inset-height", `${T}px`);
    }
    function y(T) {
      T.target instanceof HTMLElement && d(T.target) && (c.current = T.target, S());
    }
    function b() {
      c.current = null, S();
    }
    function S() {
      u.current && clearTimeout(u.current), u.current = setTimeout(() => {
        const T = c.current;
        if (!d(T)) {
          g(0), a({ isVisible: !1, height: 0 });
          return;
        }
        if (h) {
          const k = window.innerHeight - h.height;
          k > s ? (g(k), a({ isVisible: !0, height: k })) : (g(0), a({ isVisible: !1, height: 0 }));
        }
      }, r);
    }
    window.addEventListener("focusin", y), window.addEventListener("focusout", b), h && (h.addEventListener("resize", S), h.addEventListener("scroll", S));
    let w = !1;
    return p && (w = p.overlaysContent, p.overlaysContent = !0), () => {
      window.removeEventListener("focusin", y), window.removeEventListener("focusout", b), h && (h.removeEventListener("resize", S), h.removeEventListener("scroll", S)), p && (p.overlaysContent = w), u.current && clearTimeout(u.current);
    };
  }, [
    r,
    i,
    t,
    s
  ]), {
    keyboardHeight: o.height,
    isKeyboardOpen: o.isVisible
  };
}
function f6({
  snapPointsProp: n,
  sheetHeight: e
}) {
  if (n[0] !== 0 && (console.error(
    `First snap point should be 0 to ensure the sheet can be fully closed. Got: [${n.join(", ")}]`
  ), n.unshift(0)), n[n.length - 1] !== 1 && (console.error(
    `Last snap point should be 1 to ensure the sheet can be fully opened. Got: [${n.join(", ")}]`
  ), n.push(1)), e <= 0)
    return console.error(
      `Sheet height is ${e}, cannot compute snap points. Make sure the sheet is mounted and has a valid height.`
    ), [];
  const t = n.map((r) => r > 0 && r <= 1 ? Math.round(r * e) : r < 0 ? e + r : r);
  return console.assert(
    G4(t),
    `Snap points need to be in ascending order got: [${n.join(", ")}]`
  ), t.forEach((r) => {
    (r < 0 || r > e) && console.warn(
      `Snap point ${r} is outside of the sheet height ${e}. This can cause unexpected behavior. Consider adjusting your snap points.`
    );
  }), t.includes(e) || (console.warn(
    "Snap points do not include the sheet height.Please include `1` as the last snap point or it will be included automatically.This is to ensure the sheet can be fully opened."
  ), t.push(e)), t.map((r, i) => ({
    snapIndex: i,
    snapValue: r,
    // Absolute value from the bottom of the sheet
    snapValueY: e - r
    // Y value is inverted as `y = 0` means sheet is at the top
  }));
}
function h6({
  snapPoints: n,
  currentY: e
}) {
  return n.reduce(
    (t, r) => Math.abs(r.snapValueY - e) < Math.abs(t.snapValueY - e) ? r : t
  );
}
function p6({
  y: n,
  snapPoints: e,
  dragDirection: t
}) {
  return t === "down" ? e.slice().reverse().find((r) => r.snapValueY > n) : e.find((r) => r.snapValueY < n);
}
function m6({
  dragDirection: n,
  snapPoints: e
}) {
  const t = e[0], r = e[e.length - 1];
  return n === "down" ? {
    yTo: t.snapValueY,
    snapIndex: t.snapIndex
  } : {
    yTo: r.snapValueY,
    snapIndex: r.snapIndex
  };
}
function g6({
  currentSnapPoint: n,
  currentY: e,
  dragDirection: t,
  snapPoints: r,
  velocity: i
}) {
  const s = h6({
    snapPoints: r,
    currentY: e
  });
  if (Math.abs(i) < 20)
    return {
      yTo: s.snapValueY,
      snapIndex: s.snapIndex
    };
  const o = p6({
    y: e,
    snapPoints: r,
    dragDirection: t
  });
  return o ? {
    yTo: o.snapValueY,
    snapIndex: o.snapIndex
  } : {
    yTo: n.snapValueY,
    snapIndex: n.snapIndex
  };
}
var bR = hs(
  ({
    avoidKeyboard: n = !0,
    children: e,
    className: t = "",
    detent: r = "default",
    disableDismiss: i = !1,
    disableDrag: s = !1,
    disableScrollLocking: o = !1,
    dragCloseThreshold: a = W4,
    dragVelocityThreshold: c = $4,
    initialSnap: u,
    isOpen: d,
    modalEffectRootId: h,
    modalEffectThreshold: p,
    mountPoint: g,
    prefersReducedMotion: y = !1,
    snapPoints: b,
    style: S,
    tweenConfig: w = H4,
    unstyled: T = !1,
    onOpenStart: C,
    onOpenEnd: k,
    onClose: R,
    onCloseStart: N,
    onCloseEnd: L,
    onSnap: j,
    onDrag: W,
    onDragStart: Z,
    onDragEnd: fe,
    ...Oe
  }, Ae) => {
    const [Y, re] = B4(), q = bt(null), U = Math.round(re.height), [J, we] = Et(u), z = b && U > 0 ? f6({ sheetHeight: U, snapPointsProp: b }) : [], { windowHeight: X } = t6(), me = U > 0 ? U : X, pe = Mg(me), he = Xl(pe, (qe) => Math.max(U - qe, 0)), xe = Mg(0), H = v4(), G = {
      type: "tween",
      ...!!(y || H) ? U4 : w
    }, ue = d6({
      isEnabled: d && n,
      containerRef: q
    }).isKeyboardOpen || s, ge = Xl(
      pe,
      (qe) => qe + 2 >= me ? -1 : (S == null ? void 0 : S.zIndex) ?? 9999
    ), Q = Xl(
      pe,
      (qe) => qe + 2 >= me ? "hidden" : "visible"
    ), ke = $r((qe) => {
      we(qe), j == null || j(qe);
    }), Ye = $r((qe) => b && z ? qe < 0 || qe >= z.length ? (console.warn(
      `Invalid snap index ${qe}. Snap points are: [${b.join(", ")}] and their computed values are: [${z.map((ut) => ut.snapValue).join(", ")}]`
    ), null) : z[qe] : null), it = $r(async (qe) => {
      if (!b) {
        console.warn("Snapping is not possible without `snapPoints` prop.");
        return;
      }
      const ut = Ye(qe);
      if (ut === null) {
        console.warn(`Invalid snap index ${qe}.`);
        return;
      }
      if (qe === 0) {
        R();
        return;
      }
      await qu(pe, ut.snapValueY, {
        ...G,
        onComplete: () => ke(qe)
      });
    }), It = $r(() => {
      const qe = document.activeElement;
      if (!qe || !q.current) return;
      (qe.tagName === "INPUT" || qe.tagName === "TEXTAREA") && q.current.contains(qe) && qe.blur();
    }), kt = $r((qe, ut) => {
      W == null || W(qe, ut);
      const vr = pe.get(), Nt = pe.getVelocity();
      Nt > 0 && xe.set(10), Nt < 0 && xe.set(-10), pe.set(Math.max(vr + ut.delta.y, 0));
    }), pn = $r((qe, ut) => {
      It(), Z == null || Z(qe, ut);
    }), _r = $r((qe, ut) => {
      It(), fe == null || fe(qe, ut);
      const vr = pe.get();
      let Nt = 0;
      const Tn = J !== void 0 ? Ye(J) : null;
      if (Tn) {
        const Gn = ut.offset.y > 0 ? "down" : "up", cn = ut.velocity.y > 0 ? "down" : "up", ei = Math.abs(ut.velocity.y) > c;
        let or;
        if (ei ? or = m6({
          snapPoints: z,
          dragDirection: cn
        }) : or = g6({
          currentSnapPoint: Tn,
          currentY: vr,
          dragDirection: Gn,
          snapPoints: z,
          velocity: ut.velocity.y
        }), Nt = or.yTo, i && Nt + 1 >= U) {
          const Or = z.find((ti) => ti.snapValue > 0);
          Or ? (Nt = Or.snapValueY, ke(Or.snapIndex)) : Nt = vr;
        } else or.snapIndex !== void 0 && ke(or.snapIndex);
      } else (ut.velocity.y > c || vr > U * a) && (i ? Nt = 0 : Nt = me);
      qu(pe, Nt, G), Nt + 1 >= U && !i && R(), xe.set(0);
    });
    K2(Ae, () => ({
      y: pe,
      yInverted: he,
      height: U,
      snapTo: it
    })), r6({
      y: pe,
      detent: r,
      sheetHeight: U,
      snapPoints: z,
      rootId: h,
      startThreshold: p
    }), a6({
      isDisabled: o || !d
    });
    const ir = u6({
      isOpen: d,
      onOpen: async () => {
        C == null || C(), await Q4("react-modal-sheet-container");
        const qe = u !== void 0 ? Ye(u) : null, ut = (qe == null ? void 0 : qe.snapValueY) ?? 0;
        await qu(pe, ut, G), u !== void 0 && ke(u), k == null || k();
      },
      onClosing: async () => {
        N == null || N(), await qu(pe, me, G), L == null || L();
      }
    }), Ln = {
      currentSnap: J,
      detent: r,
      disableDrag: ue,
      dragProps: {
        drag: "y",
        dragElastic: 0,
        dragMomentum: !1,
        dragPropagation: !1,
        onDrag: kt,
        onDragStart: pn,
        onDragEnd: _r
      },
      indicatorRotation: xe,
      avoidKeyboard: n,
      sheetBoundsRef: Y,
      sheetRef: q,
      unstyled: T,
      y: pe
    }, sr = /* @__PURE__ */ ze.createElement(dR.Provider, { value: Ln }, /* @__PURE__ */ ze.createElement(
      us.div,
      {
        ...Oe,
        ref: Ae,
        "data-sheet-state": ir,
        className: `react-modal-sheet-root ${t}`,
        style: {
          ...fs(ds.root, T),
          zIndex: ge,
          visibility: Q,
          ...S
        }
      },
      ir !== "closed" ? e : null
    ));
    return wc ? sr : w1(sr, g ?? document.body);
  }
);
bR.displayName = "Sheet";
var Ol = Object.assign(bR, {
  Container: hR,
  Header: yR,
  DragIndicator: gR,
  Content: mR,
  Backdrop: fR
});
const y6 = "_option_1n7so_1", v6 = "_sheetContainer_1n7so_21", b6 = "_sheetHeader_1n7so_31", x6 = "_sheetBody_1n7so_39", Zu = {
  option: y6,
  sheetContainer: v6,
  sheetHeader: b6,
  sheetBody: x6
}, S6 = hs(
  ({
    label: n,
    description: e,
    error: t,
    required: r,
    withAsterisk: i,
    data: s,
    value: o,
    onChange: a,
    placeholder: c,
    disabled: u,
    renderItem: d,
    ...h
  }, p) => {
    const [g, { open: y, close: b }] = y1(!1), S = s.map(
      (C) => typeof C == "string" ? { value: C, label: C } : C
    ), w = S.find((C) => C.value === o), T = (C) => {
      a == null || a(C), b();
    };
    return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(
        fc.Wrapper,
        {
          label: n,
          description: e,
          error: t,
          required: r,
          withAsterisk: i,
          ...h,
          children: /* @__PURE__ */ x.jsx(
            fc,
            {
              component: "button",
              type: "button",
              pointer: !0,
              rightSection: /* @__PURE__ */ x.jsx($y, { size: 16 }),
              onClick: () => !u && y(),
              disabled: u,
              ref: p,
              multiline: !0,
              children: w ? /* @__PURE__ */ x.jsx(ae, { size: "sm", children: w.label }) : /* @__PURE__ */ x.jsx(ae, { size: "sm", c: "dimmed", children: c })
            }
          )
        }
      ),
      /* @__PURE__ */ x.jsxs(Ol, { isOpen: g, onClose: b, detent: "content", className: Zu.sheetContainer, children: [
        /* @__PURE__ */ x.jsxs(Ol.Container, { children: [
          /* @__PURE__ */ x.jsx(Ol.Header, {}),
          /* @__PURE__ */ x.jsxs(Ol.Content, { children: [
            /* @__PURE__ */ x.jsx(yt, { className: Zu.sheetHeader, px: 16, children: /* @__PURE__ */ x.jsx(ae, { fw: 600, size: "lg", children: n || "Select Option" }) }),
            /* @__PURE__ */ x.jsx(yt, { className: Zu.sheetBody, my: 16, px: 16, children: /* @__PURE__ */ x.jsx(ct, { gap: 4, children: S.map((C) => /* @__PURE__ */ x.jsx(
              Lc,
              {
                className: Zu.option,
                py: 8,
                "data-selected": C.value === o || void 0,
                onClick: () => T(C.value),
                children: d ? d(C, C.value === o) : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
                  /* @__PURE__ */ x.jsx(ae, { size: "md", fw: C.value === o ? 600 : 400, children: C.label }),
                  C.value === o && /* @__PURE__ */ x.jsx(Wy, { size: 18, style: { color: "var(--mantine-color-blue-7)" } })
                ] })
              },
              C.value
            )) }) })
          ] })
        ] }),
        /* @__PURE__ */ x.jsx(Ol.Backdrop, { onTap: b })
      ] })
    ] });
  }
);
S6.displayName = "DtSelect";
function xR({
  title: n = "서비스 이용에 불편을 드려 죄송합니다",
  message: e = `예기치 못한 문제가 발생하여 페이지를 표시할 수 없습니다.
잠시 후 다시 시도해 주시거나 아래 버튼을 통해 이동해 주세요.`,
  error: t,
  onReload: r,
  onGoHome: i,
  onGoBack: s,
  homePath: o = "/",
  showDetails: a = !0,
  serviceName: c = "DutyOn",
  logoSrc: u,
  homeLabel: d = "홈으로 이동"
}) {
  const [h, { toggle: p }] = y1(!1), [g, y] = Et(!1), b = () => {
    r ? r() : window.location.reload();
  }, S = () => {
    i ? i() : window.location.href = o;
  }, w = () => {
    s ? s() : typeof window < "u" && window.history.length > 1 ? window.history.back() : S();
  }, T = t instanceof Error ? t.message : typeof t == "string" ? t : "Unknown error", C = t instanceof Error ? t.stack : null, k = () => {
    var N;
    const R = `Error: ${T}

Stack:
${C || "No stack trace available"}`;
    (N = navigator == null ? void 0 : navigator.clipboard) != null && N.writeText && (navigator.clipboard.writeText(R), y(!0), setTimeout(() => y(!1), 2e3));
  };
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      style: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #f8fafc 0%, #f3f6fb 100%)",
        padding: "clamp(1rem, 4vw, 3rem)"
      },
      children: /* @__PURE__ */ x.jsx(fy, { size: "sm", px: 0, style: { width: "100%" }, children: /* @__PURE__ */ x.jsx(
        er,
        {
          p: { base: "xl", sm: 40 },
          radius: "xl",
          style: {
            width: "100%",
            background: "rgba(255, 255, 255, 0.96)",
            borderColor: "rgba(226, 232, 240, 0.95)",
            boxShadow: "0 24px 70px rgba(15, 23, 42, 0.1)"
          },
          children: /* @__PURE__ */ x.jsxs(ct, { align: "center", gap: "xl", children: [
            /* @__PURE__ */ x.jsxs(Fe, { gap: "sm", wrap: "nowrap", children: [
              u && /* @__PURE__ */ x.jsx(
                "img",
                {
                  src: u,
                  alt: "",
                  "aria-hidden": "true",
                  width: 40,
                  height: 40,
                  style: { display: "block", objectFit: "contain" }
                }
              ),
              /* @__PURE__ */ x.jsx(ae, { fw: 900, size: "lg", c: "blue", children: c })
            ] }),
            /* @__PURE__ */ x.jsx(
              p1,
              {
                size: 76,
                radius: "xl",
                variant: "light",
                color: "blue",
                style: { boxShadow: "0 12px 28px rgba(34, 139, 230, 0.16)" },
                children: /* @__PURE__ */ x.jsx(IU, { size: 38, stroke: 1.8 })
              }
            ),
            /* @__PURE__ */ x.jsxs(ct, { align: "center", gap: "xs", style: { textAlign: "center" }, children: [
              /* @__PURE__ */ x.jsx(
                Ga,
                {
                  order: 2,
                  style: { fontSize: "clamp(1.45rem, 4vw, 1.85rem)", wordBreak: "keep-all" },
                  children: n
                }
              ),
              /* @__PURE__ */ x.jsx(
                ae,
                {
                  c: "dimmed",
                  size: "md",
                  maw: 480,
                  style: { whiteSpace: "pre-line", wordBreak: "keep-all", lineHeight: 1.7 },
                  children: e
                }
              )
            ] }),
            /* @__PURE__ */ x.jsxs(Fe, { justify: "center", gap: "sm", wrap: "wrap", style: { width: "100%" }, children: [
              /* @__PURE__ */ x.jsx(
                hn,
                {
                  size: "md",
                  color: "blue",
                  leftSection: /* @__PURE__ */ x.jsx(zU, { size: 18 }),
                  onClick: b,
                  style: { boxShadow: "0 10px 22px rgba(34, 139, 230, 0.2)" },
                  children: "다시 불러오기"
                }
              ),
              /* @__PURE__ */ x.jsx(
                hn,
                {
                  size: "md",
                  variant: "default",
                  leftSection: /* @__PURE__ */ x.jsx(jU, { size: 18 }),
                  onClick: S,
                  children: d
                }
              ),
              s !== null && /* @__PURE__ */ x.jsx(
                hn,
                {
                  size: "md",
                  variant: "subtle",
                  color: "gray",
                  leftSection: /* @__PURE__ */ x.jsx(NU, { size: 18 }),
                  onClick: w,
                  children: "이전 페이지"
                }
              )
            ] }),
            a && !!t && /* @__PURE__ */ x.jsx(
              er,
              {
                withBorder: !0,
                radius: "lg",
                p: "sm",
                style: { width: "100%", boxShadow: "none" },
                bg: "var(--mantine-color-gray-0)",
                children: /* @__PURE__ */ x.jsxs(ct, { gap: "xs", children: [
                  /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", wrap: "nowrap", children: [
                    /* @__PURE__ */ x.jsxs(
                      Fe,
                      {
                        gap: "xs",
                        wrap: "nowrap",
                        style: { cursor: "pointer", minWidth: 0, flex: 1 },
                        onClick: p,
                        children: [
                          /* @__PURE__ */ x.jsx(ae, { size: "xs", fw: 700, c: "dimmed", style: { whiteSpace: "nowrap" }, children: "오류 세부 정보" }),
                          /* @__PURE__ */ x.jsx(ae, { size: "xs", c: "gray", fw: 500, style: { minWidth: 0 }, truncate: !0, children: T })
                        ]
                      }
                    ),
                    /* @__PURE__ */ x.jsx(
                      hi,
                      {
                        variant: "subtle",
                        color: "gray",
                        size: "sm",
                        "aria-label": h ? "오류 세부 정보 닫기" : "오류 세부 정보 열기",
                        onClick: p,
                        children: h ? /* @__PURE__ */ x.jsx(hC, { size: 16 }) : /* @__PURE__ */ x.jsx($y, { size: 16 })
                      }
                    )
                  ] }),
                  /* @__PURE__ */ x.jsx(I2, { in: h, children: /* @__PURE__ */ x.jsxs(ct, { gap: "xs", mt: "xs", children: [
                    /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", align: "center", wrap: "nowrap", children: [
                      /* @__PURE__ */ x.jsx(ae, { size: "xs", c: "dimmed", children: "문제가 지속되면 아래 내용을 복사하여 기술 지원팀에 문의해 주세요." }),
                      /* @__PURE__ */ x.jsx(ss, { label: g ? "복사되었습니다!" : "오류 내용 복사", children: /* @__PURE__ */ x.jsx(
                        hi,
                        {
                          variant: "light",
                          color: g ? "teal" : "blue",
                          size: "sm",
                          onClick: k,
                          children: g ? /* @__PURE__ */ x.jsx(Wy, { size: 14 }) : /* @__PURE__ */ x.jsx(pC, { size: 14 })
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ x.jsx(
                      N2,
                      {
                        block: !0,
                        style: {
                          maxHeight: 180,
                          overflowY: "auto",
                          fontSize: "0.75rem",
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-all"
                        },
                        children: C || T
                      }
                    )
                  ] }) })
                ] })
              }
            )
          ] })
        }
      ) })
    }
  );
}
class cQ extends my {
  constructor(t) {
    super(t);
    Dx(this, "reset", () => {
      this.setState({ hasError: !1, error: null });
    });
    this.state = { hasError: !1, error: null };
  }
  static getDerivedStateFromError(t) {
    return { hasError: !0, error: t };
  }
  componentDidCatch(t, r) {
    this.props.onError && this.props.onError(t, r);
  }
  render() {
    return this.state.hasError && this.state.error ? typeof this.props.fallback == "function" ? this.props.fallback(this.state.error, this.reset) : this.props.fallback ? this.props.fallback : /* @__PURE__ */ x.jsx(
      xR,
      {
        error: this.state.error,
        homePath: this.props.homePath || "/",
        serviceName: this.props.serviceName,
        logoSrc: this.props.logoSrc,
        homeLabel: this.props.homeLabel,
        onReload: () => window.location.reload()
      }
    ) : this.props.children;
  }
}
function uQ({
  homePath: n = "/",
  title: e,
  message: t,
  serviceName: r,
  logoSrc: i,
  homeLabel: s
}) {
  const o = lB(), a = cB();
  return /* @__PURE__ */ x.jsx(
    xR,
    {
      title: e,
      message: t,
      error: o,
      homePath: n,
      serviceName: r,
      logoSrc: i,
      homeLabel: s,
      onGoHome: () => a(n),
      onGoBack: () => {
        window.history.length > 1 ? a(-1) : a(n);
      }
    }
  );
}
function dQ({
  src: n,
  alt: e,
  size: t = 100,
  onChange: r,
  accept: i = "image/png,image/jpeg,image/webp,image/gif",
  disabled: s = !1,
  style: o
}) {
  const [a, c] = Et(!1), u = bt(null), d = fn(
    async (y) => {
      if (!(/* @__PURE__ */ new Set(["image/png", "image/jpeg", "image/webp", "image/gif"])).has(y.type)) {
        Cl.show({
          title: "지원하지 않는 이미지",
          message: "JPEG, PNG, WebP, GIF 이미지만 선택할 수 있습니다.",
          color: "red"
        });
        return;
      }
      if (y.size <= 0 || y.size > 5 * 1024 * 1024) {
        Cl.show({
          title: "이미지 크기 초과",
          message: "5MB 이하의 이미지를 선택해 주세요.",
          color: "red"
        });
        return;
      }
      c(!0);
      try {
        const S = await eB(y);
        r(S.url), Cl.show({
          title: "성공",
          message: "프로필 이미지가 업로드되었습니다.",
          color: "green"
        });
      } catch (S) {
        const w = tB(S, {
          fallback: "이미지 업로드 중 오류가 발생했습니다."
        });
        nB("프로필 이미지를 업로드하지 못했습니다.", {
          action: "프로필 이미지 업로드",
          errorCode: w.errorCode
        }), Cl.show({
          title: "오류",
          message: w.message,
          color: "red"
        });
      } finally {
        c(!1);
      }
    },
    [r]
  ), h = fn(
    (y) => {
      var S;
      const b = (S = y.target.files) == null ? void 0 : S[0];
      b && d(b), y.target.value = "";
    },
    [d]
  ), p = fn(() => {
    var y;
    s || a || (y = u.current) == null || y.click();
  }, [s, a]), g = fn(() => {
    s || a || !n || U2({
      title: "프로필 이미지 초기화",
      centered: !0,
      children: /* @__PURE__ */ x.jsx(ae, { size: "sm", children: "현재 프로필 이미지를 초기화하시겠습니까?" }),
      labels: { confirm: "초기화", cancel: "취소" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        r(null), Cl.show({
          title: "초기화 완료",
          message: "프로필 이미지가 초기화되었습니다.",
          color: "blue"
        });
      }
    });
  }, [s, a, r, n]);
  return /* @__PURE__ */ x.jsxs(
    ct,
    {
      align: "center",
      gap: "md",
      style: {
        position: "relative",
        width: "100%",
        ...o
      },
      children: [
        /* @__PURE__ */ x.jsx(
          "input",
          {
            ref: u,
            type: "file",
            accept: i,
            onChange: h,
            style: { display: "none" }
          }
        ),
        /* @__PURE__ */ x.jsxs(
          Lc,
          {
            type: "button",
            "aria-label": "프로필 이미지 변경",
            disabled: s || a,
            onClick: p,
            style: {
              position: "relative",
              cursor: s || a ? "not-allowed" : "pointer",
              display: "inline-block"
            },
            children: [
              /* @__PURE__ */ x.jsx(
                Wf,
                {
                  visible: a,
                  overlayProps: { radius: "100%", blur: 2 },
                  loaderProps: { size: "sm" }
                }
              ),
              /* @__PURE__ */ x.jsx(
                hy,
                {
                  src: n,
                  alt: e,
                  size: "xl",
                  style: {
                    width: t,
                    height: t,
                    borderRadius: "100%"
                  }
                }
              ),
              /* @__PURE__ */ x.jsx(
                hi,
                {
                  component: "span",
                  "aria-hidden": "true",
                  variant: "filled",
                  size: "sm",
                  radius: "xl",
                  color: "blue",
                  style: {
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    pointerEvents: "none"
                  },
                  children: /* @__PURE__ */ x.jsx(FU, { size: 12, "aria-hidden": "true" })
                }
              )
            ]
          }
        ),
        n && /* @__PURE__ */ x.jsx(
          hn,
          {
            type: "button",
            size: "xs",
            variant: "subtle",
            color: "red",
            leftSection: /* @__PURE__ */ x.jsx(HU, { size: 14, "aria-hidden": "true" }),
            disabled: s || a,
            onClick: g,
            children: "이미지 초기화"
          }
        )
      ]
    }
  );
}
function Mn(n) {
  this.content = n;
}
Mn.prototype = {
  constructor: Mn,
  find: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === n) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(n) {
    var e = this.find(n);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(n, e, t) {
    var r = t && t != n ? this.remove(t) : this, i = r.find(n), s = r.content.slice();
    return i == -1 ? s.push(t || n, e) : (s[i + 1] = e, t && (s[i] = t)), new Mn(s);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(n) {
    var e = this.find(n);
    if (e == -1) return this;
    var t = this.content.slice();
    return t.splice(e, 2), new Mn(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(n, e) {
    return new Mn([n, e].concat(this.remove(n).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(n, e) {
    var t = this.remove(n).content.slice();
    return t.push(n, e), new Mn(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(n, e, t) {
    var r = this.remove(e), i = r.content.slice(), s = r.find(n);
    return i.splice(s == -1 ? i.length : s, 0, e, t), new Mn(i);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      n(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(n) {
    return n = Mn.from(n), n.size ? new Mn(n.content.concat(this.subtract(n).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(n) {
    return n = Mn.from(n), n.size ? new Mn(this.subtract(n).content.concat(n.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(n) {
    var e = this;
    n = Mn.from(n);
    for (var t = 0; t < n.content.length; t += 2)
      e = e.remove(n.content[t]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var n = {};
    return this.forEach(function(e, t) {
      n[e] = t;
    }), n;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Mn.from = function(n) {
  if (n instanceof Mn) return n;
  var e = [];
  if (n) for (var t in n) e.push(t, n[t]);
  return new Mn(e);
};
function SR(n, e, t) {
  for (let r = 0; ; r++) {
    if (r == n.childCount || r == e.childCount)
      return n.childCount == e.childCount ? null : t;
    let i = n.child(r), s = e.child(r);
    if (i == s) {
      t += i.nodeSize;
      continue;
    }
    if (!i.sameMarkup(s))
      return t;
    if (i.isText && i.text != s.text) {
      for (let o = 0; i.text[o] == s.text[o]; o++)
        t++;
      return t;
    }
    if (i.content.size || s.content.size) {
      let o = SR(i.content, s.content, t + 1);
      if (o != null)
        return o;
    }
    t += i.nodeSize;
  }
}
function wR(n, e, t, r) {
  for (let i = n.childCount, s = e.childCount; ; ) {
    if (i == 0 || s == 0)
      return i == s ? null : { a: t, b: r };
    let o = n.child(--i), a = e.child(--s), c = o.nodeSize;
    if (o == a) {
      t -= c, r -= c;
      continue;
    }
    if (!o.sameMarkup(a))
      return { a: t, b: r };
    if (o.isText && o.text != a.text) {
      let u = 0, d = Math.min(o.text.length, a.text.length);
      for (; u < d && o.text[o.text.length - u - 1] == a.text[a.text.length - u - 1]; )
        u++, t--, r--;
      return { a: t, b: r };
    }
    if (o.content.size || a.content.size) {
      let u = wR(o.content, a.content, t - 1, r - 1);
      if (u)
        return u;
    }
    t -= c, r -= c;
  }
}
class ce {
  /**
  @internal
  */
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, t, r, i = 0, s) {
    for (let o = 0, a = 0; a < t; o++) {
      let c = this.content[o], u = a + c.nodeSize;
      if (u > e && r(c, i + a, s || null, o) !== !1 && c.content.size) {
        let d = a + 1;
        c.nodesBetween(Math.max(0, e - d), Math.min(c.content.size, t - d), r, i + d);
      }
      a = u;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, t, r, i) {
    let s = "", o = !0;
    return this.nodesBetween(e, t, (a, c) => {
      let u = a.isText ? a.text.slice(Math.max(e, c) - c, t - c) : a.isLeaf ? i ? typeof i == "function" ? i(a) : i : a.type.spec.leafText ? a.type.spec.leafText(a) : "" : "";
      a.isBlock && (a.isLeaf && u || a.isTextblock) && r && (o ? o = !1 : s += r), s += u;
    }, 0), s;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, r = e.firstChild, i = this.content.slice(), s = 0;
    for (t.isText && t.sameMarkup(r) && (i[i.length - 1] = t.withText(t.text + r.text), s = 1); s < e.content.length; s++)
      i.push(e.content[s]);
    return new ce(i, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let r = [], i = 0;
    if (t > e)
      for (let s = 0, o = 0; o < t; s++) {
        let a = this.content[s], c = o + a.nodeSize;
        c > e && ((o < e || c > t) && (a.isText ? a = a.cut(Math.max(0, e - o), Math.min(a.text.length, t - o)) : a = a.cut(Math.max(0, e - o - 1), Math.min(a.content.size, t - o - 1))), r.push(a), i += a.nodeSize), o = c;
      }
    return new ce(r, i);
  }
  /**
  @internal
  */
  cutByIndex(e, t) {
    return e == t ? ce.empty : e == 0 && t == this.content.length ? this : new ce(this.content.slice(e, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, t) {
    let r = this.content[e];
    if (r == t)
      return this;
    let i = this.content.slice(), s = this.size + t.nodeSize - r.nodeSize;
    return i[e] = t, new ce(i, s);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new ce([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new ce(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let t = 0, r = 0; t < this.content.length; t++) {
      let i = this.content[t];
      e(i, r, t), r += i.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, t = 0) {
    return SR(this, e, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, t = this.size, r = e.size) {
    return wR(this, e, t, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e) {
    if (e == 0)
      return Xu(0, e);
    if (e == this.size)
      return Xu(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let t = 0, r = 0; ; t++) {
      let i = this.child(t), s = r + i.nodeSize;
      if (s >= e)
        return s == e ? Xu(t + 1, s) : Xu(t, r);
      r = s;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return ce.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new ce(t.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return ce.empty;
    let t, r = 0;
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      r += s.nodeSize, i && s.isText && e[i - 1].sameMarkup(s) ? (t || (t = e.slice(0, i)), t[t.length - 1] = s.withText(t[t.length - 1].text + s.text)) : t && t.push(s);
    }
    return new ce(t || e, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return ce.empty;
    if (e instanceof ce)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new ce([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
ce.empty = new ce([], 0);
const cm = { index: 0, offset: 0 };
function Xu(n, e) {
  return cm.index = n, cm.offset = e, cm;
}
function Zd(n, e) {
  if (n === e)
    return !0;
  if (!(n && typeof n == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(n);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (n.length != e.length)
      return !1;
    for (let r = 0; r < n.length; r++)
      if (!Zd(n[r], e[r]))
        return !1;
  } else {
    for (let r in n)
      if (!(r in e) || !Zd(n[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in n))
        return !1;
  }
  return !0;
}
let St = class Og {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let t, r = !1;
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      if (this.eq(s))
        return e;
      if (this.type.excludes(s.type))
        t || (t = e.slice(0, i));
      else {
        if (s.type.excludes(this.type))
          return e;
        !r && s.type.rank > this.type.rank && (t || (t = e.slice(0, i)), t.push(this), r = !0), t && t.push(s);
      }
    }
    return t || (t = e.slice()), r || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && Zd(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[t.type];
    if (!r)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let i = r.create(t.attrs);
    return r.checkAttrs(i.attrs), i;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(t[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return Og.none;
    if (e instanceof Og)
      return [e];
    let t = e.slice();
    return t.sort((r, i) => r.type.rank - i.type.rank), t;
  }
};
St.none = [];
class Xd extends Error {
}
class Se {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, t, r) {
    this.content = e, this.openStart = t, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, t) {
    let r = AR(this.content, e + this.openStart, t);
    return r && new Se(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, t) {
    return new Se(ER(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return Se.empty;
    let r = t.openStart || 0, i = t.openEnd || 0;
    if (typeof r != "number" || typeof i != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Se(ce.fromJSON(e, t.content), r, i);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, t = !0) {
    let r = 0, i = 0;
    for (let s = e.firstChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.firstChild)
      r++;
    for (let s = e.lastChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.lastChild)
      i++;
    return new Se(e, r, i);
  }
}
Se.empty = new Se(ce.empty, 0, 0);
function ER(n, e, t) {
  let { index: r, offset: i } = n.findIndex(e), s = n.maybeChild(r), { index: o, offset: a } = n.findIndex(t);
  if (i == e || s.isText) {
    if (a != t && !n.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return n.cut(0, e).append(n.cut(t));
  }
  if (r != o)
    throw new RangeError("Removing non-flat range");
  return n.replaceChild(r, s.copy(ER(s.content, e - i - 1, t - i - 1)));
}
function AR(n, e, t, r) {
  let { index: i, offset: s } = n.findIndex(e), o = n.maybeChild(i);
  if (s == e || o.isText)
    return r && !r.canReplace(i, i, t) ? null : n.cut(0, e).append(t).append(n.cut(e));
  let a = AR(o.content, e - s - 1, t, o);
  return a && n.replaceChild(i, o.copy(a));
}
function w6(n, e, t) {
  if (t.openStart > n.depth)
    throw new Xd("Inserted content deeper than insertion position");
  if (n.depth - t.openStart != e.depth - t.openEnd)
    throw new Xd("Inconsistent open depths");
  return TR(n, e, t, 0);
}
function TR(n, e, t, r) {
  let i = n.index(r), s = n.node(r);
  if (i == e.index(r) && r < n.depth - t.openStart) {
    let o = TR(n, e, t, r + 1);
    return s.copy(s.content.replaceChild(i, o));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && n.depth == r && e.depth == r) {
      let o = n.parent, a = o.content;
      return jo(o, a.cut(0, n.parentOffset).append(t.content).append(a.cut(e.parentOffset)));
    } else {
      let { start: o, end: a } = E6(t, n);
      return jo(s, DR(n, o, a, e, r));
    }
  else return jo(s, ef(n, e, r));
}
function CR(n, e) {
  if (!e.type.compatibleContent(n.type))
    throw new Xd("Cannot join " + e.type.name + " onto " + n.type.name);
}
function Ig(n, e, t) {
  let r = n.node(t);
  return CR(r, e.node(t)), r;
}
function Bo(n, e) {
  let t = e.length - 1;
  t >= 0 && n.isText && n.sameMarkup(e[t]) ? e[t] = n.withText(e[t].text + n.text) : e.push(n);
}
function tc(n, e, t, r) {
  let i = (e || n).node(t), s = 0, o = e ? e.index(t) : i.childCount;
  n && (s = n.index(t), n.depth > t ? s++ : n.textOffset && (Bo(n.nodeAfter, r), s++));
  for (let a = s; a < o; a++)
    Bo(i.child(a), r);
  e && e.depth == t && e.textOffset && Bo(e.nodeBefore, r);
}
function jo(n, e) {
  return n.type.checkContent(e), n.copy(e);
}
function DR(n, e, t, r, i) {
  let s = n.depth > i && Ig(n, e, i + 1), o = r.depth > i && Ig(t, r, i + 1), a = [];
  return tc(null, n, i, a), s && o && e.index(i) == t.index(i) ? (CR(s, o), Bo(jo(s, DR(n, e, t, r, i + 1)), a)) : (s && Bo(jo(s, ef(n, e, i + 1)), a), tc(e, t, i, a), o && Bo(jo(o, ef(t, r, i + 1)), a)), tc(r, null, i, a), new ce(a);
}
function ef(n, e, t) {
  let r = [];
  if (tc(null, n, t, r), n.depth > t) {
    let i = Ig(n, e, t + 1);
    Bo(jo(i, ef(n, e, t + 1)), r);
  }
  return tc(e, null, t, r), new ce(r);
}
function E6(n, e) {
  let t = e.depth - n.openStart, i = e.node(t).copy(n.content);
  for (let s = t - 1; s >= 0; s--)
    i = e.node(s).copy(ce.from(i));
  return {
    start: i.resolveNoCache(n.openStart + t),
    end: i.resolveNoCache(i.content.size - n.openEnd - t)
  };
}
class Ac {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.path = t, this.parentOffset = r, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, t = this.index(this.depth);
    if (t == e.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], i = e.child(t);
    return r ? e.child(t).cut(r) : i;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(e).cut(0, t) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, t) {
    t = this.resolveDepth(t);
    let r = this.path[t * 3], i = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let s = 0; s < e; s++)
      i += r.child(s).nodeSize;
    return i;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, t = this.index();
    if (e.content.size == 0)
      return St.none;
    if (this.textOffset)
      return e.child(t).marks;
    let r = e.maybeChild(t - 1), i = e.maybeChild(t);
    if (!r) {
      let a = r;
      r = i, i = a;
    }
    let s = r.marks;
    for (var o = 0; o < s.length; o++)
      s[o].type.spec.inclusive === !1 && (!i || !s[o].isInSet(i.marks)) && (s = s[o--].removeFromSet(s));
    return s;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let r = t.marks, i = e.parent.maybeChild(e.index());
    for (var s = 0; s < r.length; s++)
      r[s].type.spec.inclusive === !1 && (!i || !r[s].isInSet(i.marks)) && (r = r[s--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= e && this.end(t) >= e)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, t) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
      if (e.pos <= this.end(r) && (!t || t(this.node(r))))
        return new tf(this, e, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let t = 1; t <= this.depth; t++)
      e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, t) {
    if (!(t >= 0 && t <= e.content.size))
      throw new RangeError("Position " + t + " out of range");
    let r = [], i = 0, s = t;
    for (let o = e; ; ) {
      let { index: a, offset: c } = o.content.findIndex(s), u = s - c;
      if (r.push(o, a, i + c), !u || (o = o.child(a), o.isText))
        break;
      s = u - 1, i += c + 1;
    }
    return new Ac(t, r, s);
  }
  /**
  @internal
  */
  static resolveCached(e, t) {
    let r = vE.get(e);
    if (r)
      for (let s = 0; s < r.elts.length; s++) {
        let o = r.elts[s];
        if (o.pos == t)
          return o;
      }
    else
      vE.set(e, r = new A6());
    let i = r.elts[r.i] = Ac.resolve(e, t);
    return r.i = (r.i + 1) % T6, i;
  }
}
class A6 {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const T6 = 12, vE = /* @__PURE__ */ new WeakMap();
class tf {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const C6 = /* @__PURE__ */ Object.create(null);
let Gs = class Ng {
  /**
  @internal
  */
  constructor(e, t, r, i = St.none) {
    this.type = e, this.attrs = t, this.marks = i, this.content = r || ce.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, t, r, i = 0) {
    this.content.nodesBetween(e, t, r, i, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(e, t, r, i) {
    return this.content.textBetween(e, t, r, i);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, t, r) {
    return this.type == e && Zd(this.attrs, t || e.defaultAttrs || C6) && St.sameSet(this.marks, r || St.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new Ng(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new Ng(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, t = this.content.size) {
    return e == 0 && t == this.content.size ? this : this.copy(this.content.cut(e, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, t = this.content.size, r = !1) {
    if (e == t)
      return Se.empty;
    let i = this.resolve(e), s = this.resolve(t), o = r ? 0 : i.sharedDepth(t), a = i.start(o), u = i.node(o).content.cut(i.pos - a, s.pos - a);
    return new Se(u, i.depth - o, s.depth - o);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, t, r) {
    return w6(this.resolve(e), this.resolve(t), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let t = this; ; ) {
      let { index: r, offset: i } = t.content.findIndex(e);
      if (t = t.maybeChild(r), !t)
        return null;
      if (i == e || t.isText)
        return t;
      e -= i + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: t, offset: r } = this.content.findIndex(e);
    return { node: this.content.maybeChild(t), index: t, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: r } = this.content.findIndex(e);
    if (r < e)
      return { node: this.content.child(t), index: t, offset: r };
    let i = this.content.child(t - 1);
    return { node: i, index: t - 1, offset: r - i.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return Ac.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return Ac.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, t, r) {
    let i = !1;
    return t > e && this.nodesBetween(e, t, (s) => (r.isInSet(s.marks) && (i = !0), !i)), i;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), RR(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, t, r = ce.empty, i = 0, s = r.childCount) {
    let o = this.contentMatchAt(e).matchFragment(r, i, s), a = o && o.matchFragment(this.content, t);
    if (!a || !a.validEnd)
      return !1;
    for (let c = i; c < s; c++)
      if (!this.type.allowsMarks(r.child(c).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, t, r, i) {
    if (i && !this.type.allowsMarks(i))
      return !1;
    let s = this.contentMatchAt(e).matchType(r), o = s && s.matchFragment(this.content, t);
    return o ? o.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = St.none;
    for (let t = 0; t < this.marks.length; t++) {
      let r = this.marks[t];
      r.type.checkAttrs(r.attrs), e = r.addToSet(e);
    }
    if (!St.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((t) => t.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = t.marks.map(e.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(t.text, r);
    }
    let i = ce.fromJSON(e, t.content), s = e.nodeType(t.type).create(t.attrs, i, r);
    return s.type.checkAttrs(s.attrs), s;
  }
};
Gs.prototype.text = void 0;
class nf extends Gs {
  /**
  @internal
  */
  constructor(e, t, r, i) {
    if (super(e, t, null, i), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : RR(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, t) {
    return this.text.slice(e, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new nf(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new nf(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, t = this.text.length) {
    return e == 0 && t == this.text.length ? this : this.withText(this.text.slice(e, t));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function RR(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    e = n[t].type.name + "(" + e + ")";
  return e;
}
class $o {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, t) {
    let r = new D6(e, t);
    if (r.next == null)
      return $o.empty;
    let i = kR(r);
    r.next && r.err("Unexpected trailing text");
    let s = N6(I6(i));
    return P6(s, r), s;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == e)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, t = 0, r = e.childCount) {
    let i = this;
    for (let s = t; i && s < r; s++)
      i = i.matchType(e.child(s).type);
    return i;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: t } = this.next[e];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let t = 0; t < this.next.length; t++)
      for (let r = 0; r < e.next.length; r++)
        if (this.next[t].type == e.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, t = !1, r = 0) {
    let i = [this];
    function s(o, a) {
      let c = o.matchFragment(e, r);
      if (c && (!t || c.validEnd))
        return ce.from(a.map((u) => u.createAndFill()));
      for (let u = 0; u < o.next.length; u++) {
        let { type: d, next: h } = o.next[u];
        if (!(d.isText || d.hasRequiredAttrs()) && i.indexOf(h) == -1) {
          i.push(h);
          let p = s(h, a.concat(d));
          if (p)
            return p;
        }
      }
      return null;
    }
    return s(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == e)
        return this.wrapCache[r + 1];
    let t = this.computeWrapping(e);
    return this.wrapCache.push(e, t), t;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let t = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let i = r.shift(), s = i.match;
      if (s.matchType(e)) {
        let o = [];
        for (let a = i; a.type; a = a.via)
          o.push(a.type);
        return o.reverse();
      }
      for (let o = 0; o < s.next.length; o++) {
        let { type: a, next: c } = s.next[o];
        !a.isLeaf && !a.hasRequiredAttrs() && !(a.name in t) && (!i.type || c.validEnd) && (r.push({ match: a.contentMatch, type: a, via: i }), t[a.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function t(r) {
      e.push(r);
      for (let i = 0; i < r.next.length; i++)
        e.indexOf(r.next[i].next) == -1 && t(r.next[i].next);
    }
    return t(this), e.map((r, i) => {
      let s = i + (r.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < r.next.length; o++)
        s += (o ? ", " : "") + r.next[o].type.name + "->" + e.indexOf(r.next[o].next);
      return s;
    }).join(`
`);
  }
}
$o.empty = new $o(!0);
class D6 {
  constructor(e, t) {
    this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function kR(n) {
  let e = [];
  do
    e.push(R6(n));
  while (n.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function R6(n) {
  let e = [];
  do
    e.push(k6(n));
  while (n.next && n.next != ")" && n.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function k6(n) {
  let e = O6(n);
  for (; ; )
    if (n.eat("+"))
      e = { type: "plus", expr: e };
    else if (n.eat("*"))
      e = { type: "star", expr: e };
    else if (n.eat("?"))
      e = { type: "opt", expr: e };
    else if (n.eat("{"))
      e = M6(n, e);
    else
      break;
  return e;
}
function bE(n) {
  /\D/.test(n.next) && n.err("Expected number, got '" + n.next + "'");
  let e = Number(n.next);
  return n.pos++, e;
}
function M6(n, e) {
  let t = bE(n), r = t;
  return n.eat(",") && (n.next != "}" ? r = bE(n) : r = -1), n.eat("}") || n.err("Unclosed braced range"), { type: "range", min: t, max: r, expr: e };
}
function _6(n, e) {
  let t = n.nodeTypes, r = t[e];
  if (r)
    return [r];
  let i = [];
  for (let s in t) {
    let o = t[s];
    o.isInGroup(e) && i.push(o);
  }
  return i.length == 0 && n.err("No node type or group '" + e + "' found"), i;
}
function O6(n) {
  if (n.eat("(")) {
    let e = kR(n);
    return n.eat(")") || n.err("Missing closing paren"), e;
  } else if (/\W/.test(n.next))
    n.err("Unexpected token '" + n.next + "'");
  else {
    let e = _6(n, n.next).map((t) => (n.inline == null ? n.inline = t.isInline : n.inline != t.isInline && n.err("Mixing inline and block content"), { type: "name", value: t }));
    return n.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function I6(n) {
  let e = [[]];
  return i(s(n, 0), t()), e;
  function t() {
    return e.push([]) - 1;
  }
  function r(o, a, c) {
    let u = { term: c, to: a };
    return e[o].push(u), u;
  }
  function i(o, a) {
    o.forEach((c) => c.to = a);
  }
  function s(o, a) {
    if (o.type == "choice")
      return o.exprs.reduce((c, u) => c.concat(s(u, a)), []);
    if (o.type == "seq")
      for (let c = 0; ; c++) {
        let u = s(o.exprs[c], a);
        if (c == o.exprs.length - 1)
          return u;
        i(u, a = t());
      }
    else if (o.type == "star") {
      let c = t();
      return r(a, c), i(s(o.expr, c), c), [r(c)];
    } else if (o.type == "plus") {
      let c = t();
      return i(s(o.expr, a), c), i(s(o.expr, c), c), [r(c)];
    } else {
      if (o.type == "opt")
        return [r(a)].concat(s(o.expr, a));
      if (o.type == "range") {
        let c = a;
        for (let u = 0; u < o.min; u++) {
          let d = t();
          i(s(o.expr, c), d), c = d;
        }
        if (o.max == -1)
          i(s(o.expr, c), c);
        else
          for (let u = o.min; u < o.max; u++) {
            let d = t();
            r(c, d), i(s(o.expr, c), d), c = d;
          }
        return [r(c)];
      } else {
        if (o.type == "name")
          return [r(a, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function MR(n, e) {
  return e - n;
}
function xE(n, e) {
  let t = [];
  return r(e), t.sort(MR);
  function r(i) {
    let s = n[i];
    if (s.length == 1 && !s[0].term)
      return r(s[0].to);
    t.push(i);
    for (let o = 0; o < s.length; o++) {
      let { term: a, to: c } = s[o];
      !a && t.indexOf(c) == -1 && r(c);
    }
  }
}
function N6(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return t(xE(n, 0));
  function t(r) {
    let i = [];
    r.forEach((o) => {
      n[o].forEach(({ term: a, to: c }) => {
        if (!a)
          return;
        let u;
        for (let d = 0; d < i.length; d++)
          i[d][0] == a && (u = i[d][1]);
        xE(n, c).forEach((d) => {
          u || i.push([a, u = []]), u.indexOf(d) == -1 && u.push(d);
        });
      });
    });
    let s = e[r.join(",")] = new $o(r.indexOf(n.length - 1) > -1);
    for (let o = 0; o < i.length; o++) {
      let a = i[o][1].sort(MR);
      s.next.push({ type: i[o][0], next: e[a.join(",")] || t(a) });
    }
    return s;
  }
}
function P6(n, e) {
  for (let t = 0, r = [n]; t < r.length; t++) {
    let i = r[t], s = !i.validEnd, o = [];
    for (let a = 0; a < i.next.length; a++) {
      let { type: c, next: u } = i.next[a];
      o.push(c.name), s && !(c.isText || c.hasRequiredAttrs()) && (s = !1), r.indexOf(u) == -1 && r.push(u);
    }
    s && e.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function _R(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n) {
    let r = n[t];
    if (!r.hasDefault)
      return null;
    e[t] = r.default;
  }
  return e;
}
function OR(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let r in n) {
    let i = e && e[r];
    if (i === void 0) {
      let s = n[r];
      if (s.hasDefault)
        i = s.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    t[r] = i;
  }
  return t;
}
function IR(n, e, t, r) {
  for (let i in e)
    if (!(i in n))
      throw new RangeError(`Unsupported attribute ${i} for ${t} of type ${i}`);
  for (let i in n) {
    let s = n[i];
    s.validate && s.validate(e[i]);
  }
}
function NR(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let r in e)
      t[r] = new B6(n, r, e[r]);
  return t;
}
let SE = class PR {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.name = e, this.schema = t, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = NR(e, r.attrs), this.defaultAttrs = _R(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == $o.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : OR(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, t, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Gs(this, this.computeAttrs(e), ce.from(t), St.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, t, r) {
    return t = ce.from(t), this.checkContent(t), new Gs(this, this.computeAttrs(e), t, St.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, t, r) {
    if (e = this.computeAttrs(e), t = ce.from(t), t.size) {
      let o = this.contentMatch.fillBefore(t);
      if (!o)
        return null;
      t = o.append(t);
    }
    let i = this.contentMatch.matchFragment(t), s = i && i.fillBefore(ce.empty, !0);
    return s ? new Gs(this, e, t.append(s), St.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let t = this.contentMatch.matchFragment(e);
    if (!t || !t.validEnd)
      return !1;
    for (let r = 0; r < e.childCount; r++)
      if (!this.allowsMarks(e.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    IR(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < e.length; t++)
      if (!this.allowsMarkType(e[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let t;
    for (let r = 0; r < e.length; r++)
      this.allowsMarkType(e[r].type) ? t && t.push(e[r]) : t || (t = e.slice(0, r));
    return t ? t.length ? t : St.none : e;
  }
  /**
  @internal
  */
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null);
    e.forEach((s, o) => r[s] = new PR(s, t, o));
    let i = t.spec.topNode || "doc";
    if (!r[i])
      throw new RangeError("Schema is missing its top node type ('" + i + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let s in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function L6(n, e, t) {
  let r = t.split("|");
  return (i) => {
    let s = i === null ? "null" : typeof i;
    if (r.indexOf(s) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${e} on type ${n}, got ${s}`);
  };
}
class B6 {
  constructor(e, t, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? L6(e, t, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Xf {
  /**
  @internal
  */
  constructor(e, t, r, i) {
    this.name = e, this.rank = t, this.schema = r, this.spec = i, this.attrs = NR(e, i.attrs), this.excluded = null;
    let s = _R(this.attrs);
    this.instance = s ? new St(this, s) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new St(this, OR(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null), i = 0;
    return e.forEach((s, o) => r[s] = new Xf(s, i++, t, o)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var t = 0; t < e.length; t++)
      e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].type == this)
        return e[t];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    IR(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class LR {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let i in e)
      t[i] = e[i];
    t.nodes = Mn.from(e.nodes), t.marks = Mn.from(e.marks || {}), this.nodes = SE.compile(this.spec.nodes, this), this.marks = Xf.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in this.nodes) {
      if (i in this.marks)
        throw new RangeError(i + " can not be both a node and a mark");
      let s = this.nodes[i], o = s.spec.content || "", a = s.spec.marks;
      if (s.contentMatch = r[o] || (r[o] = $o.parse(o, this.nodes)), s.inlineContent = s.contentMatch.inlineContent, s.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!s.isInline || !s.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = s;
      }
      s.markSet = a == "_" ? null : a ? wE(this, a.split(" ")) : a == "" || !s.inlineContent ? [] : null;
    }
    for (let i in this.marks) {
      let s = this.marks[i], o = s.spec.excludes;
      s.excluded = o == null ? [s] : o == "" ? [] : wE(this, o.split(" "));
    }
    this.nodeFromJSON = (i) => Gs.fromJSON(this, i), this.markFromJSON = (i) => St.fromJSON(this, i), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, t = null, r, i) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof SE) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(t, r, i);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, t) {
    let r = this.nodes.text;
    return new nf(r, r.defaultAttrs, e, St.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, t) {
    return typeof e == "string" && (e = this.marks[e]), e.create(t);
  }
  /**
  @internal
  */
  nodeType(e) {
    let t = this.nodes[e];
    if (!t)
      throw new RangeError("Unknown node type: " + e);
    return t;
  }
}
function wE(n, e) {
  let t = [];
  for (let r = 0; r < e.length; r++) {
    let i = e[r], s = n.marks[i], o = s;
    if (s)
      t.push(s);
    else
      for (let a in n.marks) {
        let c = n.marks[a];
        (i == "_" || c.spec.group && c.spec.group.split(" ").indexOf(i) > -1) && t.push(o = c);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return t;
}
function j6(n) {
  return n.tag != null;
}
function F6(n) {
  return n.style != null;
}
let nc = class Pg {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    t.forEach((i) => {
      if (j6(i))
        this.tags.push(i);
      else if (F6(i)) {
        let s = /[^=]*/.exec(i.style)[0];
        r.indexOf(s) < 0 && r.push(s), this.styles.push(i);
      }
    }), this.normalizeLists = !this.tags.some((i) => {
      if (!/^(ul|ol)\b/.test(i.tag) || !i.node)
        return !1;
      let s = e.nodes[i.node];
      return s.contentMatch.matchType(s);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, t = {}) {
    let r = new AE(this, t, !1);
    return r.addAll(e, St.none, t.from, t.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, t = {}) {
    let r = new AE(this, t, !0);
    return r.addAll(e, St.none, t.from, t.to), Se.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(e, t, r) {
    for (let i = r ? this.tags.indexOf(r) + 1 : 0; i < this.tags.length; i++) {
      let s = this.tags[i];
      if (H6(e, s.tag) && (s.namespace === void 0 || e.namespaceURI == s.namespace) && (!s.context || t.matchesContext(s.context))) {
        if (s.getAttrs) {
          let o = s.getAttrs(e);
          if (o === !1)
            continue;
          s.attrs = o || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, t, r, i) {
    for (let s = i ? this.styles.indexOf(i) + 1 : 0; s < this.styles.length; s++) {
      let o = this.styles[s], a = o.style;
      if (!(a.indexOf(e) != 0 || o.context && !r.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      a.length > e.length && (a.charCodeAt(e.length) != 61 || a.slice(e.length + 1) != t))) {
        if (o.getAttrs) {
          let c = o.getAttrs(t);
          if (c === !1)
            continue;
          o.attrs = c || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let t = [];
    function r(i) {
      let s = i.priority == null ? 50 : i.priority, o = 0;
      for (; o < t.length; o++) {
        let a = t[o];
        if ((a.priority == null ? 50 : a.priority) < s)
          break;
      }
      t.splice(o, 0, i);
    }
    for (let i in e.marks) {
      let s = e.marks[i].spec.parseDOM;
      s && s.forEach((o) => {
        r(o = TE(o)), o.mark || o.ignore || o.clearMark || (o.mark = i);
      });
    }
    for (let i in e.nodes) {
      let s = e.nodes[i].spec.parseDOM;
      s && s.forEach((o) => {
        r(o = TE(o)), o.node || o.ignore || o.mark || (o.node = i);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new Pg(e, Pg.schemaRules(e)));
  }
};
const BR = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, z6 = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, jR = { ol: !0, ul: !0 }, Tc = 1, Lg = 2, rc = 4;
function EE(n, e, t) {
  return e != null ? (e ? Tc : 0) | (e === "full" ? Lg : 0) : n && n.whitespace == "pre" ? Tc | Lg : t & ~rc;
}
class ed {
  constructor(e, t, r, i, s, o) {
    this.type = e, this.attrs = t, this.marks = r, this.solid = i, this.options = o, this.content = [], this.activeMarks = St.none, this.match = s || (o & rc ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(ce.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let r = this.type.contentMatch, i;
        return (i = r.findWrapping(e.type)) ? (this.match = r, i) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & Tc)) {
      let r = this.content[this.content.length - 1], i;
      if (r && r.isText && (i = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let s = r;
        r.text.length == i[0].length ? this.content.pop() : this.content[this.content.length - 1] = s.withText(s.text.slice(0, s.text.length - i[0].length));
      }
    }
    let t = ce.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(ce.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !BR.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class AE {
  constructor(e, t, r) {
    this.parser = e, this.options = t, this.isOpen = r, this.open = 0, this.localPreserveWS = !1;
    let i = t.topNode, s, o = EE(null, t.preserveWhitespace, 0) | (r ? rc : 0);
    i ? s = new ed(i.type, i.attrs, St.none, !0, t.topMatch || i.type.contentMatch, o) : r ? s = new ed(null, null, St.none, !0, null, o) : s = new ed(e.schema.topNodeType, null, St.none, !0, null, o), this.nodes = [s], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, t) {
    e.nodeType == 3 ? this.addTextNode(e, t) : e.nodeType == 1 && this.addElement(e, t);
  }
  addTextNode(e, t) {
    let r = e.nodeValue, i = this.top, s = i.options & Lg ? "full" : this.localPreserveWS || (i.options & Tc) > 0, { schema: o } = this.parser;
    if (s === "full" || i.inlineContext(e) || /[^ \t\r\n\u000c]/.test(r)) {
      if (s)
        if (s === "full")
          r = r.replace(/\r\n?/g, `
`);
        else if (o.linebreakReplacement && /[\r\n]/.test(r) && this.top.findWrapping(o.linebreakReplacement.create())) {
          let a = r.split(/\r?\n|\r/);
          for (let c = 0; c < a.length; c++)
            c && this.insertNode(o.linebreakReplacement.create(), t, !0), a[c] && this.insertNode(o.text(a[c]), t, !/\S/.test(a[c]));
          r = "";
        } else
          r = r.replace(/\r?\n|\r/g, " ");
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let a = i.content[i.content.length - 1], c = e.previousSibling;
        (!a || c && c.nodeName == "BR" || a.isText && /[ \t\r\n\u000c]$/.test(a.text)) && (r = r.slice(1));
      }
      r && this.insertNode(o.text(r), t, !/\S/.test(r)), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, t, r) {
    let i = this.localPreserveWS, s = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let o = e.nodeName.toLowerCase(), a;
    jR.hasOwnProperty(o) && this.parser.normalizeLists && V6(e);
    let c = this.options.ruleFromNode && this.options.ruleFromNode(e) || (a = this.parser.matchTag(e, this, r));
    e: if (c ? c.ignore : z6.hasOwnProperty(o))
      this.findInside(e), this.ignoreFallback(e, t);
    else if (!c || c.skip || c.closeParent) {
      c && c.closeParent ? this.open = Math.max(0, this.open - 1) : c && c.skip.nodeType && (e = c.skip);
      let u, d = this.needsBlock;
      if (BR.hasOwnProperty(o))
        s.content.length && s.content[0].isInline && this.open && (this.open--, s = this.top), u = !0, s.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, t);
        break e;
      }
      let h = c && c.skip ? t : this.readStyles(e, t);
      h && this.addAll(e, h), u && this.sync(s), this.needsBlock = d;
    } else {
      let u = this.readStyles(e, t);
      u && this.addElementByRule(e, c, u, c.consuming === !1 ? a : void 0);
    }
    this.localPreserveWS = i;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, t) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(e, t) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, t) {
    let r = e.style;
    if (r && r.length)
      for (let i = 0; i < this.parser.matchedStyles.length; i++) {
        let s = this.parser.matchedStyles[i], o = r.getPropertyValue(s);
        if (o)
          for (let a = void 0; ; ) {
            let c = this.parser.matchStyle(s, o, this, a);
            if (!c)
              break;
            if (c.ignore)
              return null;
            if (c.clearMark ? t = t.filter((u) => !c.clearMark(u)) : t = t.concat(this.parser.schema.marks[c.mark].create(c.attrs)), c.consuming === !1)
              a = c;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, t, r, i) {
    let s, o;
    if (t.node)
      if (o = this.parser.schema.nodes[t.node], o.isLeaf)
        this.insertNode(o.create(t.attrs), r, e.nodeName == "BR") || this.leafFallback(e, r);
      else {
        let c = this.enter(o, t.attrs || null, r, t.preserveWhitespace);
        c && (s = !0, r = c);
      }
    else {
      let c = this.parser.schema.marks[t.mark];
      r = r.concat(c.create(t.attrs));
    }
    let a = this.top;
    if (o && o.isLeaf)
      this.findInside(e);
    else if (i)
      this.addElement(e, r, i);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((c) => this.insertNode(c, r, !1));
    else {
      let c = e;
      typeof t.contentElement == "string" ? c = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? c = t.contentElement(e) : t.contentElement && (c = t.contentElement), this.findAround(e, c, !0), this.addAll(c, r), this.findAround(e, c, !1);
    }
    s && this.sync(a) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, t, r, i) {
    let s = r || 0;
    for (let o = r ? e.childNodes[r] : e.firstChild, a = i == null ? null : e.childNodes[i]; o != a; o = o.nextSibling, ++s)
      this.findAtPoint(e, s), this.addDOM(o, t);
    this.findAtPoint(e, s);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, t, r) {
    let i, s;
    for (let o = this.open, a = 0; o >= 0; o--) {
      let c = this.nodes[o], u = c.findWrapping(e);
      if (u && (!i || i.length > u.length + a) && (i = u, s = c, !u.length))
        break;
      if (c.solid) {
        if (r)
          break;
        a += 2;
      }
    }
    if (!i)
      return null;
    this.sync(s);
    for (let o = 0; o < i.length; o++)
      t = this.enterInner(i[o], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, t, r) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let s = this.textblockFromContext();
      s && (t = this.enterInner(s, null, t));
    }
    let i = this.findPlace(e, t, r);
    if (i) {
      this.closeExtra();
      let s = this.top;
      s.match && (s.match = s.match.matchType(e.type));
      let o = St.none;
      for (let a of i.concat(e.marks))
        (s.type ? s.type.allowsMarkType(a.type) : CE(a.type, e.type)) && (o = a.addToSet(o));
      return s.content.push(e.mark(o)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, t, r, i) {
    let s = this.findPlace(e.create(t), r, !1);
    return s && (s = this.enterInner(e, t, r, !0, i)), s;
  }
  // Open a node of the given type
  enterInner(e, t, r, i = !1, s) {
    this.closeExtra();
    let o = this.top;
    o.match = o.match && o.match.matchType(e);
    let a = EE(e, s, o.options);
    o.options & rc && o.content.length == 0 && (a |= rc);
    let c = St.none;
    return r = r.filter((u) => (o.type ? o.type.allowsMarkType(u.type) : CE(u.type, e)) ? (c = u.addToSet(c), !1) : !0), this.nodes.push(new ed(e, t, c, i, null, a)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--) {
      if (this.nodes[t] == e)
        return this.open = t, !0;
      this.localPreserveWS && (this.nodes[t].options |= Tc);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let r = this.nodes[t].content;
      for (let i = r.length - 1; i >= 0; i--)
        e += r[i].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == t && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, r) {
    if (e != t && this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].pos == null && e.nodeType == 1 && e.contains(this.find[i].node) && t.compareDocumentPosition(this.find[i].node) & (r ? 2 : 4) && (this.find[i].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), r = this.options.context, i = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), s = -(r ? r.depth + 1 : 0) + (i ? 0 : 1), o = (a, c) => {
      for (; a >= 0; a--) {
        let u = t[a];
        if (u == "") {
          if (a == t.length - 1 || a == 0)
            continue;
          for (; c >= s; c--)
            if (o(a - 1, c))
              return !0;
          return !1;
        } else {
          let d = c > 0 || c == 0 && i ? this.nodes[c].type : r && c >= s ? r.node(c - s).type : null;
          if (!d || d.name != u && !d.isInGroup(u))
            return !1;
          c--;
        }
      }
      return !0;
    };
    return o(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let r = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let t in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[t];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
}
function V6(n) {
  for (let e = n.firstChild, t = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && jR.hasOwnProperty(r) && t ? (t.appendChild(e), e = t) : r == "li" ? t = e : r && (t = null);
  }
}
function H6(n, e) {
  return (n.matches || n.msMatchesSelector || n.webkitMatchesSelector || n.mozMatchesSelector).call(n, e);
}
function TE(n) {
  let e = {};
  for (let t in n)
    e[t] = n[t];
  return e;
}
function CE(n, e) {
  let t = e.schema.nodes;
  for (let r in t) {
    let i = t[r];
    if (!i.allowsMarkType(n))
      continue;
    let s = [], o = (a) => {
      s.push(a);
      for (let c = 0; c < a.edgeCount; c++) {
        let { type: u, next: d } = a.edge(c);
        if (u == e || s.indexOf(d) < 0 && o(d))
          return !0;
      }
    };
    if (o(i.contentMatch))
      return !0;
  }
}
class Xo {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, t = {}, r) {
    r || (r = um(t).createDocumentFragment());
    let i = r, s = [];
    return e.forEach((o) => {
      if (s.length || o.marks.length) {
        let a = 0, c = 0;
        for (; a < s.length && c < o.marks.length; ) {
          let u = o.marks[c];
          if (!this.marks[u.type.name]) {
            c++;
            continue;
          }
          if (!u.eq(s[a][0]) || u.type.spec.spanning === !1)
            break;
          a++, c++;
        }
        for (; a < s.length; )
          i = s.pop()[1];
        for (; c < o.marks.length; ) {
          let u = o.marks[c++], d = this.serializeMark(u, o.isInline, t);
          d && (s.push([u, i]), i.appendChild(d.dom), i = d.contentDOM || d.dom);
        }
      }
      i.appendChild(this.serializeNodeInner(o, t));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(e, t) {
    let { dom: r, contentDOM: i } = Ad(um(t), this.nodes[e.type.name](e), null, e.attrs);
    if (i) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, i);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, t = {}) {
    let r = this.serializeNodeInner(e, t);
    for (let i = e.marks.length - 1; i >= 0; i--) {
      let s = this.serializeMark(e.marks[i], e.isInline, t);
      s && ((s.contentDOM || s.dom).appendChild(r), r = s.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(e, t, r = {}) {
    let i = this.marks[e.type.name];
    return i && Ad(um(r), i(e, t), null, e.attrs);
  }
  static renderSpec(e, t, r = null, i) {
    return Ad(e, t, r, i);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new Xo(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let t = DE(e.nodes);
    return t.text || (t.text = (r) => r.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return DE(e.marks);
  }
}
function DE(n) {
  let e = {};
  for (let t in n) {
    let r = n[t].spec.toDOM;
    r && (e[t] = r);
  }
  return e;
}
function um(n) {
  return n.document || window.document;
}
const RE = /* @__PURE__ */ new WeakMap();
function U6(n) {
  let e = RE.get(n);
  return e === void 0 && RE.set(n, e = W6(n)), e;
}
function W6(n) {
  let e = null;
  function t(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          e || (e = []), e.push(r);
        else
          for (let i = 0; i < r.length; i++)
            t(r[i]);
      else
        for (let i in r)
          t(r[i]);
  }
  return t(n), e;
}
function Ad(n, e, t, r) {
  if (typeof e == "string")
    return { dom: n.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let i = e[0], s;
  if (typeof i != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (s = U6(r)) && s.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let o = i.indexOf(" ");
  o > 0 && (t = i.slice(0, o), i = i.slice(o + 1));
  let a, c = t ? n.createElementNS(t, i) : n.createElement(i), u = e[1], d = 1;
  if (u && typeof u == "object" && u.nodeType == null && !Array.isArray(u)) {
    d = 2;
    for (let h in u)
      if (u[h] != null) {
        let p = h.indexOf(" ");
        p > 0 ? c.setAttributeNS(h.slice(0, p), h.slice(p + 1), u[h]) : h == "style" && c.style ? c.style.cssText = u[h] : c.setAttribute(h, u[h]);
      }
  }
  for (let h = d; h < e.length; h++) {
    let p = e[h];
    if (p === 0) {
      if (h < e.length - 1 || h > d)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: c, contentDOM: c };
    } else {
      let { dom: g, contentDOM: y } = Ad(n, p, t, r);
      if (c.appendChild(g), y) {
        if (a)
          throw new RangeError("Multiple content holes");
        a = y;
      }
    }
  }
  return { dom: c, contentDOM: a };
}
const FR = 65535, zR = Math.pow(2, 16);
function $6(n, e) {
  return n + e * zR;
}
function kE(n) {
  return n & FR;
}
function G6(n) {
  return (n - (n & FR)) / zR;
}
const VR = 1, HR = 2, Td = 4, UR = 8;
class Bg {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.delInfo = t, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & UR) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (VR | Td)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (HR | Td)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & Td) > 0;
  }
}
class Cr {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && Cr.empty)
      return Cr.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let t = 0, r = kE(e);
    if (!this.inverted)
      for (let i = 0; i < r; i++)
        t += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[r * 3] + t + G6(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let i = 0, s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let c = this.ranges[a] - (this.inverted ? i : 0);
      if (c > e)
        break;
      let u = this.ranges[a + s], d = this.ranges[a + o], h = c + u;
      if (e <= h) {
        let p = u ? e == c ? -1 : e == h ? 1 : t : t, g = c + i + (p < 0 ? 0 : d);
        if (r)
          return g;
        let y = e == (t < 0 ? c : h) ? null : $6(a / 3, e - c), b = e == c ? HR : e == h ? VR : Td;
        return (t < 0 ? e != c : e != h) && (b |= UR), new Bg(g, b, y);
      }
      i += d - u;
    }
    return r ? e + i : new Bg(e + i, 0, null);
  }
  /**
  @internal
  */
  touches(e, t) {
    let r = 0, i = kE(t), s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let c = this.ranges[a] - (this.inverted ? r : 0);
      if (c > e)
        break;
      let u = this.ranges[a + s], d = c + u;
      if (e <= d && a == i * 3)
        return !0;
      r += this.ranges[a + o] - u;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let t = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let i = 0, s = 0; i < this.ranges.length; i += 3) {
      let o = this.ranges[i], a = o - (this.inverted ? s : 0), c = o + (this.inverted ? 0 : s), u = this.ranges[i + t], d = this.ranges[i + r];
      e(a, a + u, c, c + d), s += d - u;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new Cr(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? Cr.empty : new Cr(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
Cr.empty = new Cr([]);
class Cc {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, t, r = 0, i = e ? e.length : 0) {
    this.mirror = t, this.from = r, this.to = i, this._maps = e || [], this.ownData = !(e || t);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, t = this.maps.length) {
    return new Cc(this._maps, this.mirror, e, t);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, t) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), t != null && this.setMirror(this._maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let t = 0, r = this._maps.length; t < e._maps.length; t++) {
      let i = e.getMirror(t);
      this.appendMap(e._maps[t], i != null && i < t ? r + i : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == e)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, r = this._maps.length + e._maps.length; t >= 0; t--) {
      let i = e.getMirror(t);
      this.appendMap(e._maps[t].invert(), i != null && i > t ? r - i - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new Cc();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, t = 1) {
    if (this.mirror)
      return this._map(e, t, !0);
    for (let r = this.from; r < this.to; r++)
      e = this._maps[r].map(e, t);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let i = 0;
    for (let s = this.from; s < this.to; s++) {
      let o = this._maps[s], a = o.mapResult(e, t);
      if (a.recover != null) {
        let c = this.getMirror(s);
        if (c != null && c > s && c < this.to) {
          s = c, e = this._maps[c].recover(a.recover);
          continue;
        }
      }
      i |= a.delInfo, e = a.pos;
    }
    return r ? e : new Bg(e, i, null);
  }
}
const dm = /* @__PURE__ */ Object.create(null);
class $n {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return Cr.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = dm[t.stepType];
    if (!r)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, t) {
    if (e in dm)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return dm[e] = t, t.prototype.jsonID = e, t;
  }
}
class an {
  /**
  @internal
  */
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new an(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new an(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, t, r, i) {
    try {
      return an.ok(e.replace(t, r, i));
    } catch (s) {
      if (s instanceof Xd)
        return an.fail(s.message);
      throw s;
    }
  }
}
function Rv(n, e, t) {
  let r = [];
  for (let i = 0; i < n.childCount; i++) {
    let s = n.child(i);
    s.content.size && (s = s.copy(Rv(s.content, e, s))), s.isInline && (s = e(s, t, i)), r.push(s);
  }
  return ce.fromArray(r);
}
class Vs extends $n {
  /**
  Create a mark step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = e.resolve(this.from), i = r.node(r.sharedDepth(this.to)), s = new Se(Rv(t.content, (o, a) => !o.isAtom || !a.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), i), t.openStart, t.openEnd);
    return an.fromReplace(e, this.from, this.to, s);
  }
  invert() {
    return new ki(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new Vs(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof Vs && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Vs(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Vs(t.from, t.to, e.markFromJSON(t.mark));
  }
}
$n.jsonID("addMark", Vs);
class ki extends $n {
  /**
  Create a mark-removing step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = new Se(Rv(t.content, (i) => i.mark(this.mark.removeFromSet(i.marks)), e), t.openStart, t.openEnd);
    return an.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new Vs(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new ki(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof ki && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new ki(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new ki(t.from, t.to, e.markFromJSON(t.mark));
  }
}
$n.jsonID("removeMark", ki);
class Hs extends $n {
  /**
  Create a node mark step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return an.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return an.fromReplace(e, this.pos, this.pos + 1, new Se(ce.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let r = this.mark.addToSet(t.marks);
      if (r.length == t.marks.length) {
        for (let i = 0; i < t.marks.length; i++)
          if (!t.marks[i].isInSet(r))
            return new Hs(this.pos, t.marks[i]);
        return new Hs(this.pos, this.mark);
      }
    }
    return new Go(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Hs(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Hs(t.pos, e.markFromJSON(t.mark));
  }
}
$n.jsonID("addNodeMark", Hs);
class Go extends $n {
  /**
  Create a mark-removing step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return an.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return an.fromReplace(e, this.pos, this.pos + 1, new Se(ce.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new Hs(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Go(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Go(t.pos, e.markFromJSON(t.mark));
  }
}
$n.jsonID("removeNodeMark", Go);
class gn extends $n {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, t, r, i = !1) {
    super(), this.from = e, this.to = t, this.slice = r, this.structure = i;
  }
  apply(e) {
    return this.structure && jg(e, this.from, this.to) ? an.fail("Structure replace would overwrite content") : an.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new Cr([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new gn(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deletedAcross && r.deletedAcross ? null : new gn(t.pos, Math.max(t.pos, r.pos), this.slice, this.structure);
  }
  merge(e) {
    if (!(e instanceof gn) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? Se.empty : new Se(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new gn(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? Se.empty : new Se(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new gn(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new gn(t.from, t.to, Se.fromJSON(e, t.slice), !!t.structure);
  }
}
$n.jsonID("replace", gn);
class xn extends $n {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, t, r, i, s, o, a = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = r, this.gapTo = i, this.slice = s, this.insert = o, this.structure = a;
  }
  apply(e) {
    if (this.structure && (jg(e, this.from, this.gapFrom) || jg(e, this.gapTo, this.to)))
      return an.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return an.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, t.content);
    return r ? an.fromReplace(e, this.from, this.to, r) : an.fail("Content does not fit in gap");
  }
  getMap() {
    return new Cr([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new xn(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), i = this.from == this.gapFrom ? t.pos : e.map(this.gapFrom, -1), s = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return t.deletedAcross && r.deletedAcross || i < t.pos || s > r.pos ? null : new xn(t.pos, r.pos, i, s, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new xn(t.from, t.to, t.gapFrom, t.gapTo, Se.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
$n.jsonID("replaceAround", xn);
function jg(n, e, t) {
  let r = n.resolve(e), i = t - e, s = r.depth;
  for (; i > 0 && s > 0 && r.indexAfter(s) == r.node(s).childCount; )
    s--, i--;
  if (i > 0) {
    let o = r.node(s).maybeChild(r.indexAfter(s));
    for (; i > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, i--;
    }
  }
  return !1;
}
function Y6(n, e, t, r) {
  let i = [], s = [], o, a;
  n.doc.nodesBetween(e, t, (c, u, d) => {
    if (!c.isInline)
      return;
    let h = c.marks;
    if (!r.isInSet(h) && d.type.allowsMarkType(r.type)) {
      let p = Math.max(u, e), g = Math.min(u + c.nodeSize, t), y = r.addToSet(h);
      for (let b = 0; b < h.length; b++)
        h[b].isInSet(y) || (o && o.to == p && o.mark.eq(h[b]) ? o.to = g : i.push(o = new ki(p, g, h[b])));
      a && a.to == p ? a.to = g : s.push(a = new Vs(p, g, r));
    }
  }), i.forEach((c) => n.step(c)), s.forEach((c) => n.step(c));
}
function q6(n, e, t, r) {
  let i = [], s = 0;
  n.doc.nodesBetween(e, t, (o, a) => {
    if (!o.isInline)
      return;
    s++;
    let c = null;
    if (r instanceof Xf) {
      let u = o.marks, d;
      for (; d = r.isInSet(u); )
        (c || (c = [])).push(d), u = d.removeFromSet(u);
    } else r ? r.isInSet(o.marks) && (c = [r]) : c = o.marks;
    if (c && c.length) {
      let u = Math.min(a + o.nodeSize, t);
      for (let d = 0; d < c.length; d++) {
        let h = c[d], p;
        for (let g = 0; g < i.length; g++) {
          let y = i[g];
          y.step == s - 1 && h.eq(i[g].style) && (p = y);
        }
        p ? (p.to = u, p.step = s) : i.push({ style: h, from: Math.max(a, e), to: u, step: s });
      }
    }
  }), i.forEach((o) => n.step(new ki(o.from, o.to, o.style)));
}
function kv(n, e, t, r = t.contentMatch, i = !0) {
  let s = n.doc.nodeAt(e), o = [], a = e + 1;
  for (let c = 0; c < s.childCount; c++) {
    let u = s.child(c), d = a + u.nodeSize, h = r.matchType(u.type);
    if (!h)
      o.push(new gn(a, d, Se.empty));
    else {
      r = h;
      for (let p = 0; p < u.marks.length; p++)
        t.allowsMarkType(u.marks[p].type) || n.step(new ki(a, d, u.marks[p]));
      if (i && u.isText && t.whitespace != "pre") {
        let p, g = /\r?\n|\r/g, y;
        for (; p = g.exec(u.text); )
          y || (y = new Se(ce.from(t.schema.text(" ", t.allowedMarks(u.marks))), 0, 0)), o.push(new gn(a + p.index, a + p.index + p[0].length, y));
      }
    }
    a = d;
  }
  if (!r.validEnd) {
    let c = r.fillBefore(ce.empty, !0);
    n.replace(a, a, new Se(c, 0, 0));
  }
  for (let c = o.length - 1; c >= 0; c--)
    n.step(o[c]);
}
function K6(n, e, t) {
  return (e == 0 || n.canReplace(e, n.childCount)) && (t == n.childCount || n.canReplace(0, t));
}
function al(n) {
  let t = n.parent.content.cutByIndex(n.startIndex, n.endIndex);
  for (let r = n.depth, i = 0, s = 0; ; --r) {
    let o = n.$from.node(r), a = n.$from.index(r) + i, c = n.$to.indexAfter(r) - s;
    if (r < n.depth && o.canReplace(a, c, t))
      return r;
    if (r == 0 || o.type.spec.isolating || !K6(o, a, c))
      break;
    a && (i = 1), c < o.childCount && (s = 1);
  }
  return null;
}
function J6(n, e, t) {
  let { $from: r, $to: i, depth: s } = e, o = r.before(s + 1), a = i.after(s + 1), c = o, u = a, d = ce.empty, h = 0;
  for (let y = s, b = !1; y > t; y--)
    b || r.index(y) > 0 ? (b = !0, d = ce.from(r.node(y).copy(d)), h++) : c--;
  let p = ce.empty, g = 0;
  for (let y = s, b = !1; y > t; y--)
    b || i.after(y + 1) < i.end(y) ? (b = !0, p = ce.from(i.node(y).copy(p)), g++) : u++;
  n.step(new xn(c, u, o, a, new Se(d.append(p), h, g), d.size - h, !0));
}
function Mv(n, e, t = null, r = n) {
  let i = Q6(n, e), s = i && Z6(r, e);
  return s ? i.map(ME).concat({ type: e, attrs: t }).concat(s.map(ME)) : null;
}
function ME(n) {
  return { type: n, attrs: null };
}
function Q6(n, e) {
  let { parent: t, startIndex: r, endIndex: i } = n, s = t.contentMatchAt(r).findWrapping(e);
  if (!s)
    return null;
  let o = s.length ? s[0] : e;
  return t.canReplaceWith(r, i, o) ? s : null;
}
function Z6(n, e) {
  let { parent: t, startIndex: r, endIndex: i } = n, s = t.child(r), o = e.contentMatch.findWrapping(s.type);
  if (!o)
    return null;
  let c = (o.length ? o[o.length - 1] : e).contentMatch;
  for (let u = r; c && u < i; u++)
    c = c.matchType(t.child(u).type);
  return !c || !c.validEnd ? null : o;
}
function X6(n, e, t) {
  let r = ce.empty;
  for (let o = t.length - 1; o >= 0; o--) {
    if (r.size) {
      let a = t[o].type.contentMatch.matchFragment(r);
      if (!a || !a.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = ce.from(t[o].type.create(t[o].attrs, r));
  }
  let i = e.start, s = e.end;
  n.step(new xn(i, s, i, s, new Se(r, 0, 0), t.length, !0));
}
function eG(n, e, t, r, i) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let s = n.steps.length;
  n.doc.nodesBetween(e, t, (o, a) => {
    let c = typeof i == "function" ? i(o) : i;
    if (o.isTextblock && !o.hasMarkup(r, c) && tG(n.doc, n.mapping.slice(s).map(a), r)) {
      let u = null;
      if (r.schema.linebreakReplacement) {
        let g = r.whitespace == "pre", y = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        g && !y ? u = !1 : !g && y && (u = !0);
      }
      u === !1 && $R(n, o, a, s), kv(n, n.mapping.slice(s).map(a, 1), r, void 0, u === null);
      let d = n.mapping.slice(s), h = d.map(a, 1), p = d.map(a + o.nodeSize, 1);
      return n.step(new xn(h, p, h + 1, p - 1, new Se(ce.from(r.create(c, null, o.marks)), 0, 0), 1, !0)), u === !0 && WR(n, o, a, s), !1;
    }
  });
}
function WR(n, e, t, r) {
  e.forEach((i, s) => {
    if (i.isText) {
      let o, a = /\r?\n|\r/g;
      for (; o = a.exec(i.text); ) {
        let c = n.mapping.slice(r).map(t + 1 + s + o.index);
        n.replaceWith(c, c + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function $R(n, e, t, r) {
  e.forEach((i, s) => {
    if (i.type == i.type.schema.linebreakReplacement) {
      let o = n.mapping.slice(r).map(t + 1 + s);
      n.replaceWith(o, o + 1, e.type.schema.text(`
`));
    }
  });
}
function tG(n, e, t) {
  let r = n.resolve(e), i = r.index();
  return r.parent.canReplaceWith(i, i + 1, t);
}
function nG(n, e, t, r, i) {
  let s = n.doc.nodeAt(e);
  if (!s)
    throw new RangeError("No node at given position");
  t || (t = s.type);
  let o = t.create(r, null, i || s.marks);
  if (s.isLeaf)
    return n.replaceWith(e, e + s.nodeSize, o);
  if (!t.validContent(s.content))
    throw new RangeError("Invalid content for node type " + t.name);
  n.step(new xn(e, e + s.nodeSize, e + 1, e + s.nodeSize - 1, new Se(ce.from(o), 0, 0), 1, !0));
}
function rs(n, e, t = 1, r) {
  let i = n.resolve(e), s = i.depth - t, o = r && r[r.length - 1] || i.parent;
  if (s < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !o.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount)))
    return !1;
  for (let u = i.depth - 1, d = t - 2; u > s; u--, d--) {
    let h = i.node(u), p = i.index(u);
    if (h.type.spec.isolating)
      return !1;
    let g = h.content.cutByIndex(p, h.childCount), y = r && r[d + 1];
    y && (g = g.replaceChild(0, y.type.create(y.attrs)));
    let b = r && r[d] || h;
    if (!h.canReplace(p + 1, h.childCount) || !b.type.validContent(g))
      return !1;
  }
  let a = i.indexAfter(s), c = r && r[0];
  return i.node(s).canReplaceWith(a, a, c ? c.type : i.node(s + 1).type);
}
function rG(n, e, t = 1, r) {
  let i = n.doc.resolve(e), s = ce.empty, o = ce.empty;
  for (let a = i.depth, c = i.depth - t, u = t - 1; a > c; a--, u--) {
    s = ce.from(i.node(a).copy(s));
    let d = r && r[u];
    o = ce.from(d ? d.type.create(d.attrs, o) : i.node(a).copy(o));
  }
  n.step(new gn(e, e, new Se(s.append(o), t, t), !0));
}
function ro(n, e) {
  let t = n.resolve(e), r = t.index();
  return GR(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(r, r + 1);
}
function iG(n, e) {
  e.content.size || n.type.compatibleContent(e.type);
  let t = n.contentMatchAt(n.childCount), { linebreakReplacement: r } = n.type.schema;
  for (let i = 0; i < e.childCount; i++) {
    let s = e.child(i), o = s.type == r ? n.type.schema.nodes.text : s.type;
    if (t = t.matchType(o), !t || !n.type.allowsMarks(s.marks))
      return !1;
  }
  return t.validEnd;
}
function GR(n, e) {
  return !!(n && e && !n.isLeaf && iG(n, e));
}
function eh(n, e, t = -1) {
  let r = n.resolve(e);
  for (let i = r.depth; ; i--) {
    let s, o, a = r.index(i);
    if (i == r.depth ? (s = r.nodeBefore, o = r.nodeAfter) : t > 0 ? (s = r.node(i + 1), a++, o = r.node(i).maybeChild(a)) : (s = r.node(i).maybeChild(a - 1), o = r.node(i + 1)), s && !s.isTextblock && GR(s, o) && r.node(i).canReplace(a, a + 1))
      return e;
    if (i == 0)
      break;
    e = t < 0 ? r.before(i) : r.after(i);
  }
}
function sG(n, e, t) {
  let r = null, { linebreakReplacement: i } = n.doc.type.schema, s = n.doc.resolve(e - t), o = s.node().type;
  if (i && o.inlineContent) {
    let d = o.whitespace == "pre", h = !!o.contentMatch.matchType(i);
    d && !h ? r = !1 : !d && h && (r = !0);
  }
  let a = n.steps.length;
  if (r === !1) {
    let d = n.doc.resolve(e + t);
    $R(n, d.node(), d.before(), a);
  }
  o.inlineContent && kv(n, e + t - 1, o, s.node().contentMatchAt(s.index()), r == null);
  let c = n.mapping.slice(a), u = c.map(e - t);
  if (n.step(new gn(u, c.map(e + t, -1), Se.empty, !0)), r === !0) {
    let d = n.doc.resolve(u);
    WR(n, d.node(), d.before(), n.steps.length);
  }
  return n;
}
function oG(n, e, t) {
  let r = n.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), t))
    return e;
  if (r.parentOffset == 0)
    for (let i = r.depth - 1; i >= 0; i--) {
      let s = r.index(i);
      if (r.node(i).canReplaceWith(s, s, t))
        return r.before(i + 1);
      if (s > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let i = r.depth - 1; i >= 0; i--) {
      let s = r.indexAfter(i);
      if (r.node(i).canReplaceWith(s, s, t))
        return r.after(i + 1);
      if (s < r.node(i).childCount)
        return null;
    }
  return null;
}
function YR(n, e, t) {
  let r = n.resolve(e);
  if (!t.content.size)
    return e;
  let i = t.content;
  for (let s = 0; s < t.openStart; s++)
    i = i.firstChild.content;
  for (let s = 1; s <= (t.openStart == 0 && t.size ? 2 : 1); s++)
    for (let o = r.depth; o >= 0; o--) {
      let a = o == r.depth ? 0 : r.pos <= (r.start(o + 1) + r.end(o + 1)) / 2 ? -1 : 1, c = r.index(o) + (a > 0 ? 1 : 0), u = r.node(o), d = !1;
      if (s == 1)
        d = u.canReplace(c, c, i);
      else {
        let h = u.contentMatchAt(c).findWrapping(i.firstChild.type);
        d = h && u.canReplaceWith(c, c, h[0]);
      }
      if (d)
        return a == 0 ? r.pos : a < 0 ? r.before(o + 1) : r.after(o + 1);
    }
  return null;
}
function th(n, e, t = e, r = Se.empty) {
  if (e == t && !r.size)
    return null;
  let i = n.resolve(e), s = n.resolve(t);
  return qR(i, s, r) ? new gn(e, t, r) : new aG(i, s, r).fit();
}
function qR(n, e, t) {
  return !t.openStart && !t.openEnd && n.start() == e.start() && n.parent.canReplace(n.index(), e.index(), t.content);
}
class aG {
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.unplaced = r, this.frontier = [], this.placed = ce.empty;
    for (let i = 0; i <= e.depth; i++) {
      let s = e.node(i);
      this.frontier.push({
        type: s.type,
        match: s.contentMatchAt(e.indexAfter(i))
      });
    }
    for (let i = e.depth; i > 0; i--)
      this.placed = ce.from(e.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let u = this.findFittable();
      u ? this.placeNodes(u) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, r = this.$from, i = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!i)
      return null;
    let s = this.placed, o = r.depth, a = i.depth;
    for (; o && a && s.childCount == 1; )
      s = s.firstChild.content, o--, a--;
    let c = new Se(s, o, a);
    return e > -1 ? new xn(r.pos, e, this.$to.pos, this.$to.end(), c, t) : c.size || r.pos != this.$to.pos ? new gn(r.pos, i.pos, c) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, r = 0, i = this.unplaced.openEnd; r < e; r++) {
      let s = t.firstChild;
      if (t.childCount > 1 && (i = 0), s.type.spec.isolating && i <= r) {
        e = r;
        break;
      }
      t = s.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let r = t == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let i, s = null;
        r ? (s = fm(this.unplaced.content, r - 1).firstChild, i = s.content) : i = this.unplaced.content;
        let o = i.firstChild;
        for (let a = this.depth; a >= 0; a--) {
          let { type: c, match: u } = this.frontier[a], d, h = null;
          if (t == 1 && (o ? u.matchType(o.type) || (h = u.fillBefore(ce.from(o), !1)) : s && c.compatibleContent(s.type)))
            return { sliceDepth: r, frontierDepth: a, parent: s, inject: h };
          if (t == 2 && o && (d = u.findWrapping(o.type)))
            return { sliceDepth: r, frontierDepth: a, parent: s, wrap: d };
          if (s && u.matchType(s.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, i = fm(e, t);
    return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new Se(e, t + 1, Math.max(r, i.size + t >= e.size - r ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, i = fm(e, t);
    if (i.childCount <= 1 && t > 0) {
      let s = e.size - t <= t + i.size;
      this.unplaced = new Se(Vl(e, t - 1, 1), t - 1, s ? t - 1 : r);
    } else
      this.unplaced = new Se(Vl(e, t, 1), t, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: r, inject: i, wrap: s }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (s)
      for (let b = 0; b < s.length; b++)
        this.openFrontierNode(s[b]);
    let o = this.unplaced, a = r ? r.content : o.content, c = o.openStart - e, u = 0, d = [], { match: h, type: p } = this.frontier[t];
    if (i) {
      for (let b = 0; b < i.childCount; b++)
        d.push(i.child(b));
      h = h.matchFragment(i);
    }
    let g = a.size + e - (o.content.size - o.openEnd);
    for (; u < a.childCount; ) {
      let b = a.child(u), S = h.matchType(b.type);
      if (!S)
        break;
      u++, (u > 1 || c == 0 || b.content.size) && (h = S, d.push(KR(b.mark(p.allowedMarks(b.marks)), u == 1 ? c : 0, u == a.childCount ? g : -1)));
    }
    let y = u == a.childCount;
    y || (g = -1), this.placed = Hl(this.placed, t, ce.from(d)), this.frontier[t].match = h, y && g < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let b = 0, S = a; b < g; b++) {
      let w = S.lastChild;
      this.frontier.push({ type: w.type, match: w.contentMatchAt(w.childCount) }), S = w.content;
    }
    this.unplaced = y ? e == 0 ? Se.empty : new Se(Vl(o.content, e - 1, 1), e - 1, g < 0 ? o.openEnd : e - 1) : new Se(Vl(o.content, e, u), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !hm(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, i = this.$to.after(r);
    for (; r > 1 && i == this.$to.end(--r); )
      ++i;
    return i;
  }
  findCloseLevel(e) {
    e: for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
      let { match: r, type: i } = this.frontier[t], s = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), o = hm(e, t, i, r, s);
      if (o) {
        for (let a = t - 1; a >= 0; a--) {
          let { match: c, type: u } = this.frontier[a], d = hm(e, a, u, c, !0);
          if (!d || d.childCount)
            continue e;
        }
        return { depth: t, fit: o, move: s ? e.doc.resolve(e.after(t + 1)) : e };
      }
    }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = Hl(this.placed, t.depth, t.fit)), e = t.move;
    for (let r = t.depth + 1; r <= e.depth; r++) {
      let i = e.node(r), s = i.type.contentMatch.fillBefore(i.content, !0, e.index(r));
      this.openFrontierNode(i.type, i.attrs, s);
    }
    return e;
  }
  openFrontierNode(e, t = null, r) {
    let i = this.frontier[this.depth];
    i.match = i.match.matchType(e), this.placed = Hl(this.placed, this.depth, ce.from(e.create(t, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(ce.empty, !0);
    t.childCount && (this.placed = Hl(this.placed, this.frontier.length, t));
  }
}
function Vl(n, e, t) {
  return e == 0 ? n.cutByIndex(t, n.childCount) : n.replaceChild(0, n.firstChild.copy(Vl(n.firstChild.content, e - 1, t)));
}
function Hl(n, e, t) {
  return e == 0 ? n.append(t) : n.replaceChild(n.childCount - 1, n.lastChild.copy(Hl(n.lastChild.content, e - 1, t)));
}
function fm(n, e) {
  for (let t = 0; t < e; t++)
    n = n.firstChild.content;
  return n;
}
function KR(n, e, t) {
  if (e <= 0)
    return n;
  let r = n.content;
  return e > 1 && (r = r.replaceChild(0, KR(r.firstChild, e - 1, r.childCount == 1 ? t - 1 : 0))), e > 0 && (r = n.type.contentMatch.fillBefore(r).append(r), t <= 0 && (r = r.append(n.type.contentMatch.matchFragment(r).fillBefore(ce.empty, !0)))), n.copy(r);
}
function hm(n, e, t, r, i) {
  let s = n.node(e), o = i ? n.indexAfter(e) : n.index(e);
  if (o == s.childCount && !t.compatibleContent(s.type))
    return null;
  let a = r.fillBefore(s.content, !0, o);
  return a && !lG(t, s.content, o) ? a : null;
}
function lG(n, e, t) {
  for (let r = t; r < e.childCount; r++)
    if (!n.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function cG(n) {
  return n.spec.defining || n.spec.definingForContent;
}
function uG(n, e, t, r) {
  if (!r.size)
    return n.deleteRange(e, t);
  let i = n.doc.resolve(e), s = n.doc.resolve(t);
  if (qR(i, s, r))
    return n.step(new gn(e, t, r));
  let o = QR(i, s);
  o[o.length - 1] == 0 && o.pop();
  let a = -(i.depth + 1);
  o.unshift(a);
  for (let p = i.depth, g = i.pos - 1; p > 0; p--, g--) {
    let y = i.node(p).type.spec;
    if (y.defining || y.definingAsContext || y.isolating)
      break;
    o.indexOf(p) > -1 ? a = p : i.before(p) == g && o.splice(1, 0, -p);
  }
  let c = o.indexOf(a), u = [], d = r.openStart;
  for (let p = r.content, g = 0; ; g++) {
    let y = p.firstChild;
    if (u.push(y), g == r.openStart)
      break;
    p = y.content;
  }
  for (let p = d - 1; p >= 0; p--) {
    let g = u[p], y = cG(g.type);
    if (y && !g.sameMarkup(i.node(Math.abs(a) - 1)))
      d = p;
    else if (y || !g.type.isTextblock)
      break;
  }
  for (let p = r.openStart; p >= 0; p--) {
    let g = (p + d + 1) % (r.openStart + 1), y = u[g];
    if (y)
      for (let b = 0; b < o.length; b++) {
        let S = o[(b + c) % o.length], w = !0;
        S < 0 && (w = !1, S = -S);
        let T = i.node(S - 1), C = i.index(S - 1);
        if (T.canReplaceWith(C, C, y.type, y.marks))
          return n.replace(i.before(S), w ? s.after(S) : t, new Se(JR(r.content, 0, r.openStart, g), g, r.openEnd));
      }
  }
  let h = n.steps.length;
  for (let p = o.length - 1; p >= 0 && (n.replace(e, t, r), !(n.steps.length > h)); p--) {
    let g = o[p];
    g < 0 || (e = i.before(g), t = s.after(g));
  }
}
function JR(n, e, t, r, i) {
  if (e < t) {
    let s = n.firstChild;
    n = n.replaceChild(0, s.copy(JR(s.content, e + 1, t, r, s)));
  }
  if (e > r) {
    let s = i.contentMatchAt(0), o = s.fillBefore(n).append(n);
    n = o.append(s.matchFragment(o).fillBefore(ce.empty, !0));
  }
  return n;
}
function dG(n, e, t, r) {
  if (!r.isInline && e == t && n.doc.resolve(e).parent.content.size) {
    let i = oG(n.doc, e, r.type);
    i != null && (e = t = i);
  }
  n.replaceRange(e, t, new Se(ce.from(r), 0, 0));
}
function fG(n, e, t) {
  let r = n.doc.resolve(e), i = n.doc.resolve(t), s = QR(r, i);
  for (let o = 0; o < s.length; o++) {
    let a = s[o], c = o == s.length - 1;
    if (c && a == 0 || r.node(a).type.contentMatch.validEnd)
      return n.delete(r.start(a), i.end(a));
    if (a > 0 && (c || r.node(a - 1).canReplace(r.index(a - 1), i.indexAfter(a - 1))))
      return n.delete(r.before(a), i.after(a));
  }
  for (let o = 1; o <= r.depth && o <= i.depth; o++)
    if (e - r.start(o) == r.depth - o && t > r.end(o) && i.end(o) - t != i.depth - o && r.start(o - 1) == i.start(o - 1) && r.node(o - 1).canReplace(r.index(o - 1), i.index(o - 1)))
      return n.delete(r.before(o), t);
  n.delete(e, t);
}
function QR(n, e) {
  let t = [], r = Math.min(n.depth, e.depth);
  for (let i = r; i >= 0; i--) {
    let s = n.start(i);
    if (s < n.pos - (n.depth - i) || e.end(i) > e.pos + (e.depth - i) || n.node(i).type.spec.isolating || e.node(i).type.spec.isolating)
      break;
    (s == e.start(i) || i == n.depth && i == e.depth && n.parent.inlineContent && e.parent.inlineContent && i && e.start(i - 1) == s - 1) && t.push(i);
  }
  return t;
}
class Wa extends $n {
  /**
  Construct an attribute step.
  */
  constructor(e, t, r) {
    super(), this.pos = e, this.attr = t, this.value = r;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return an.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let s in t.attrs)
      r[s] = t.attrs[s];
    r[this.attr] = this.value;
    let i = t.type.create(r, null, t.marks);
    return an.fromReplace(e, this.pos, this.pos + 1, new Se(ce.from(i), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return Cr.empty;
  }
  invert(e) {
    return new Wa(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Wa(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Wa(t.pos, t.attr, t.value);
  }
}
$n.jsonID("attr", Wa);
class Dc extends $n {
  /**
  Construct an attribute step.
  */
  constructor(e, t) {
    super(), this.attr = e, this.value = t;
  }
  apply(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let i in e.attrs)
      t[i] = e.attrs[i];
    t[this.attr] = this.value;
    let r = e.type.create(t, e.content, e.marks);
    return an.ok(r);
  }
  getMap() {
    return Cr.empty;
  }
  invert(e) {
    return new Dc(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Dc(t.attr, t.value);
  }
}
$n.jsonID("docAttr", Dc);
let Qa = class extends Error {
};
Qa = function n(e) {
  let t = Error.call(this, e);
  return t.__proto__ = n.prototype, t;
};
Qa.prototype = Object.create(Error.prototype);
Qa.prototype.constructor = Qa;
Qa.prototype.name = "TransformError";
class ZR {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new Cc();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed)
      throw new Qa(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  Return a single range, in post-transform document positions,
  that covers all content changed by this transform. Returns null
  if no replacements are made. Note that this will ignore changes
  that add/remove marks without replacing the underlying content.
  */
  changedRange() {
    let e = 1e9, t = -1e9;
    for (let r = 0; r < this.mapping.maps.length; r++) {
      let i = this.mapping.maps[r];
      r && (e = i.map(e, 1), t = i.map(t, -1)), i.forEach((s, o, a, c) => {
        e = Math.min(e, a), t = Math.max(t, c);
      });
    }
    return e == 1e9 ? null : { from: e, to: t };
  }
  /**
  @internal
  */
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, t = e, r = Se.empty) {
    let i = th(this.doc, e, t, r);
    return i && this.step(i), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, t, r) {
    return this.replace(e, t, new Se(ce.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, t) {
    return this.replace(e, t, Se.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, t, r) {
    return uG(this, e, t, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, t, r) {
    return dG(this, e, t, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, t) {
    return fG(this, e, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, t) {
    return J6(this, e, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, t = 1) {
    return sG(this, e, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, t) {
    return X6(this, e, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, t = e, r, i = null) {
    return eG(this, e, t, r, i), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, t, r = null, i) {
    return nG(this, e, t, r, i), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, t, r) {
    return this.step(new Wa(e, t, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, t) {
    return this.step(new Dc(e, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, t) {
    return this.step(new Hs(e, t)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, t) {
    let r = this.doc.nodeAt(e);
    if (!r)
      throw new RangeError("No node at position " + e);
    if (t instanceof St)
      t.isInSet(r.marks) && this.step(new Go(e, t));
    else {
      let i = r.marks, s, o = [];
      for (; s = t.isInSet(i); )
        o.push(new Go(e, s)), i = s.removeFromSet(i);
      for (let a = o.length - 1; a >= 0; a--)
        this.step(o[a]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, t = 1, r) {
    return rG(this, e, t, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, t, r) {
    return Y6(this, e, t, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, t, r) {
    return q6(this, e, t, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, t, r) {
    return kv(this, e, t, r), this;
  }
}
const pm = /* @__PURE__ */ Object.create(null);
class Xe {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, t, r) {
    this.$anchor = e, this.$head = t, this.ranges = r || [new hG(e.min(t), e.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, t = Se.empty) {
    let r = t.content.lastChild, i = null;
    for (let a = 0; a < t.openEnd; a++)
      i = r, r = r.lastChild;
    let s = e.steps.length, o = this.ranges;
    for (let a = 0; a < o.length; a++) {
      let { $from: c, $to: u } = o[a], d = e.mapping.slice(s);
      e.replaceRange(d.map(c.pos), d.map(u.pos), a ? Se.empty : t), a == 0 && IE(e, s, (r ? r.isInline : i && i.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, t) {
    let r = e.steps.length, i = this.ranges;
    for (let s = 0; s < i.length; s++) {
      let { $from: o, $to: a } = i[s], c = e.mapping.slice(r), u = c.map(o.pos), d = c.map(a.pos);
      s ? e.deleteRange(u, d) : (e.replaceRangeWith(u, d, t), IE(e, r, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, t, r = !1) {
    let i = e.parent.inlineContent ? new Ve(e) : ka(e.node(0), e.parent, e.pos, e.index(), t, r);
    if (i)
      return i;
    for (let s = e.depth - 1; s >= 0; s--) {
      let o = t < 0 ? ka(e.node(0), e.node(s), e.before(s + 1), e.index(s), t, r) : ka(e.node(0), e.node(s), e.after(s + 1), e.index(s) + 1, t, r);
      if (o)
        return o;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new kr(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return ka(e, e, 0, 0, 1) || new kr(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return ka(e, e, e.content.size, e.childCount, -1) || new kr(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = pm[t.type];
    if (!r)
      throw new RangeError(`No selection type ${t.type} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, t) {
    if (e in pm)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return pm[e] = t, t.prototype.jsonID = e, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Ve.between(this.$anchor, this.$head).getBookmark();
  }
}
Xe.prototype.visible = !0;
class hG {
  /**
  Create a range.
  */
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let _E = !1;
function OE(n) {
  !_E && !n.parent.inlineContent && (_E = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + n.parent.type.name + ")"));
}
class Ve extends Xe {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, t = e) {
    OE(e), OE(t), super(e, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    if (!r.parent.inlineContent)
      return Xe.near(r);
    let i = e.resolve(t.map(this.anchor));
    return new Ve(i.parent.inlineContent ? i : r, r);
  }
  replace(e, t = Se.empty) {
    if (super.replace(e, t), t == Se.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof Ve && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new nh(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Ve(e.resolve(t.anchor), e.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, t, r = t) {
    let i = e.resolve(t);
    return new this(i, r == t ? i : e.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, t, r) {
    let i = e.pos - t.pos;
    if ((!r || i) && (r = i >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let s = Xe.findFrom(t, r, !0) || Xe.findFrom(t, -r, !0);
      if (s)
        t = s.$head;
      else
        return Xe.near(t, r);
    }
    return e.parent.inlineContent || (i == 0 ? e = t : (e = (Xe.findFrom(e, -r, !0) || Xe.findFrom(e, r, !0)).$anchor, e.pos < t.pos != i < 0 && (e = t))), new Ve(e, t);
  }
}
Xe.jsonID("text", Ve);
class nh {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new nh(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return Ve.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class Me extends Xe {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let t = e.nodeAfter, r = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, r), this.node = t;
  }
  map(e, t) {
    let { deleted: r, pos: i } = t.mapResult(this.anchor), s = e.resolve(i);
    return r ? Xe.near(s) : new Me(s);
  }
  content() {
    return new Se(ce.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof Me && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new _v(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new Me(e.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, t) {
    return new Me(e.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
Me.prototype.visible = !1;
Xe.jsonID("node", Me);
class _v {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: r } = e.mapResult(this.anchor);
    return t ? new nh(r, r) : new _v(r);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), r = t.nodeAfter;
    return r && Me.isSelectable(r) ? new Me(t) : Xe.near(t);
  }
}
class kr extends Xe {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = Se.empty) {
    if (t == Se.empty) {
      e.delete(0, e.doc.content.size);
      let r = Xe.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new kr(e);
  }
  map(e) {
    return new kr(e);
  }
  eq(e) {
    return e instanceof kr;
  }
  getBookmark() {
    return pG;
  }
}
Xe.jsonID("all", kr);
const pG = {
  map() {
    return this;
  },
  resolve(n) {
    return new kr(n);
  }
};
function ka(n, e, t, r, i, s = !1) {
  if (e.inlineContent)
    return Ve.create(n, t);
  for (let o = r - (i > 0 ? 0 : 1); i > 0 ? o < e.childCount : o >= 0; o += i) {
    let a = e.child(o);
    if (a.isAtom) {
      if (!s && Me.isSelectable(a))
        return Me.create(n, t - (i < 0 ? a.nodeSize : 0));
    } else {
      let c = ka(n, a, t + i, i < 0 ? a.childCount : 0, i, s);
      if (c)
        return c;
    }
    t += a.nodeSize * i;
  }
  return null;
}
function IE(n, e, t) {
  let r = n.steps.length - 1;
  if (r < e)
    return;
  let i = n.steps[r];
  if (!(i instanceof gn || i instanceof xn))
    return;
  let s = n.mapping.maps[r], o;
  s.forEach((a, c, u, d) => {
    o == null && (o = d);
  }), n.setSelection(Xe.near(n.doc.resolve(o), t));
}
const NE = 1, td = 2, PE = 4;
class mG extends ZR {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | NE) & ~td, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & NE) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= td, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return St.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & td) > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    super.addStep(e, t), this.updated = this.updated & ~td, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, t = !0) {
    let r = this.selection;
    return t && (e = e.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || St.none))), r.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, t, r) {
    let i = this.doc.type.schema;
    if (t == null)
      return e ? this.replaceSelectionWith(i.text(e), !0) : this.deleteSelection();
    {
      if (r == null && (r = t), !e)
        return this.deleteRange(t, r);
      let s = this.storedMarks;
      if (!s) {
        let o = this.doc.resolve(t);
        s = r == t ? o.marks() : o.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(t, r, i.text(e, s)), !this.selection.empty && this.selection.to == t + e.length && this.setSelection(Xe.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, t) {
    return this.meta[typeof e == "string" ? e : e.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= PE, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & PE) > 0;
  }
}
function LE(n, e) {
  return !e || !n ? n : n.bind(e);
}
class Ul {
  constructor(e, t, r) {
    this.name = e, this.init = LE(t.init, r), this.apply = LE(t.apply, r);
  }
}
const gG = [
  new Ul("doc", {
    init(n) {
      return n.doc || n.schema.topNodeType.createAndFill();
    },
    apply(n) {
      return n.doc;
    }
  }),
  new Ul("selection", {
    init(n, e) {
      return n.selection || Xe.atStart(e.doc);
    },
    apply(n) {
      return n.selection;
    }
  }),
  new Ul("storedMarks", {
    init(n) {
      return n.storedMarks || null;
    },
    apply(n, e, t, r) {
      return r.selection.$cursor ? n.storedMarks : null;
    }
  }),
  new Ul("scrollToSelection", {
    init() {
      return 0;
    },
    apply(n, e) {
      return n.scrolledIntoView ? e + 1 : e;
    }
  })
];
class mm {
  constructor(e, t) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = gG.slice(), t && t.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new Ul(r.key, r.spec.state, r));
    });
  }
}
class ja {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, t = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != t) {
        let i = this.config.plugins[r];
        if (i.spec.filterTransaction && !i.spec.filterTransaction.call(i, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let t = [e], r = this.applyInner(e), i = null;
    for (; ; ) {
      let s = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let a = this.config.plugins[o];
        if (a.spec.appendTransaction) {
          let c = i ? i[o].n : 0, u = i ? i[o].state : this, d = c < t.length && a.spec.appendTransaction.call(a, c ? t.slice(c) : t, u, r);
          if (d && r.filterTransaction(d, o)) {
            if (d.setMeta("appendedTransaction", e), !i) {
              i = [];
              for (let h = 0; h < this.config.plugins.length; h++)
                i.push(h < o ? { state: r, n: t.length } : { state: this, n: 0 });
            }
            t.push(d), r = r.applyInner(d), s = !0;
          }
          i && (i[o] = { state: r, n: t.length });
        }
      }
      if (!s)
        return { state: r, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new ja(this.config), r = this.config.fields;
    for (let i = 0; i < r.length; i++) {
      let s = r[i];
      t[s.name] = s.apply(e, this[s.name], this, t);
    }
    return t;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new mG(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let t = new mm(e.doc ? e.doc.type.schema : e.schema, e.plugins), r = new ja(t);
    for (let i = 0; i < t.fields.length; i++)
      r[t.fields[i].name] = t.fields[i].init(e, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let t = new mm(this.schema, e.plugins), r = t.fields, i = new ja(t);
    for (let s = 0; s < r.length; s++) {
      let o = r[s].name;
      i[o] = this.hasOwnProperty(o) ? this[o] : r[s].init(e, i);
    }
    return i;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((r) => r.toJSON())), e && typeof e == "object")
      for (let r in e) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let i = e[r], s = i.spec.state;
        s && s.toJSON && (t[r] = s.toJSON.call(i, this[i.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, t, r) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let i = new mm(e.schema, e.plugins), s = new ja(i);
    return i.fields.forEach((o) => {
      if (o.name == "doc")
        s.doc = Gs.fromJSON(e.schema, t.doc);
      else if (o.name == "selection")
        s.selection = Xe.fromJSON(s.doc, t.selection);
      else if (o.name == "storedMarks")
        t.storedMarks && (s.storedMarks = t.storedMarks.map(e.schema.markFromJSON));
      else {
        if (r)
          for (let a in r) {
            let c = r[a], u = c.spec.state;
            if (c.key == o.name && u && u.fromJSON && Object.prototype.hasOwnProperty.call(t, a)) {
              s[o.name] = u.fromJSON.call(c, e, t[a], s);
              return;
            }
          }
        s[o.name] = o.init(e, s);
      }
    }), s;
  }
}
function XR(n, e, t) {
  for (let r in n) {
    let i = n[r];
    i instanceof Function ? i = i.bind(e) : r == "handleDOMEvents" && (i = XR(i, e, {})), t[r] = i;
  }
  return t;
}
class An {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && XR(e.props, this, this.props), this.key = e.key ? e.key.key : ek("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const gm = /* @__PURE__ */ Object.create(null);
function ek(n) {
  return n in gm ? n + "$" + ++gm[n] : (gm[n] = 0, n + "$");
}
class yr {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = ek(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const On = function(n) {
  for (var e = 0; ; e++)
    if (n = n.previousSibling, !n)
      return e;
}, Za = function(n) {
  let e = n.assignedSlot || n.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let Fg = null;
const Zi = function(n, e, t) {
  let r = Fg || (Fg = document.createRange());
  return r.setEnd(n, t ?? n.nodeValue.length), r.setStart(n, e || 0), r;
}, yG = function() {
  Fg = null;
}, Yo = function(n, e, t, r) {
  return t && (BE(n, e, t, r, -1) || BE(n, e, t, r, 1));
}, vG = /^(img|br|input|textarea|hr)$/i;
function BE(n, e, t, r, i) {
  for (var s; ; ) {
    if (n == t && e == r)
      return !0;
    if (e == (i < 0 ? 0 : Yr(n))) {
      let o = n.parentNode;
      if (!o || o.nodeType != 1 || Yc(n) || vG.test(n.nodeName) || n.contentEditable == "false")
        return !1;
      e = On(n) + (i < 0 ? 0 : 1), n = o;
    } else if (n.nodeType == 1) {
      let o = n.childNodes[e + (i < 0 ? -1 : 0)];
      if (o.nodeType == 1 && o.contentEditable == "false")
        if (!((s = o.pmViewDesc) === null || s === void 0) && s.ignoreForSelection)
          e += i;
        else
          return !1;
      else
        n = o, e = i < 0 ? Yr(n) : 0;
    } else
      return !1;
  }
}
function Yr(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function bG(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e)
      return n;
    if (n.nodeType == 1 && e > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e - 1], e = Yr(n);
    } else if (n.parentNode && !Yc(n))
      e = On(n), n = n.parentNode;
    else
      return null;
  }
}
function xG(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e < n.nodeValue.length)
      return n;
    if (n.nodeType == 1 && e < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e], e = 0;
    } else if (n.parentNode && !Yc(n))
      e = On(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
function SG(n, e, t) {
  for (let r = e == 0, i = e == Yr(n); r || i; ) {
    if (n == t)
      return !0;
    let s = On(n);
    if (n = n.parentNode, !n)
      return !1;
    r = r && s == 0, i = i && s == Yr(n);
  }
}
function Yc(n) {
  let e;
  for (let t = n; t && !(e = t.pmViewDesc); t = t.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == n || e.contentDOM == n);
}
const rh = function(n) {
  return n.focusNode && Yo(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset);
};
function Do(n, e) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = n, t.key = t.code = e, t;
}
function wG(n) {
  let e = n.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function EG(n, e, t) {
  if (n.caretPositionFromPoint)
    try {
      let r = n.caretPositionFromPoint(e, t);
      if (r)
        return { node: r.offsetNode, offset: Math.min(Yr(r.offsetNode), r.offset) };
    } catch {
    }
  if (n.caretRangeFromPoint) {
    let r = n.caretRangeFromPoint(e, t);
    if (r)
      return { node: r.startContainer, offset: Math.min(Yr(r.startContainer), r.startOffset) };
  }
}
const Ii = typeof navigator < "u" ? navigator : null, jE = typeof document < "u" ? document : null, io = Ii && Ii.userAgent || "", zg = /Edge\/(\d+)/.exec(io), tk = /MSIE \d/.exec(io), Vg = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(io), mr = !!(tk || Vg || zg), Ys = tk ? document.documentMode : Vg ? +Vg[1] : zg ? +zg[1] : 0, Qr = !mr && /gecko\/(\d+)/i.test(io);
Qr && +(/Firefox\/(\d+)/.exec(io) || [0, 0])[1];
const Hg = !mr && /Chrome\/(\d+)/.exec(io), vn = !!Hg, nk = Hg ? +Hg[1] : 0, Pn = !mr && !!Ii && /Apple Computer/.test(Ii.vendor), Xa = Pn && (/Mobile\/\w+/.test(io) || !!Ii && Ii.maxTouchPoints > 2), Gr = Xa || (Ii ? /Mac/.test(Ii.platform) : !1), rk = Ii ? /Win/.test(Ii.platform) : !1, ts = /Android \d/.test(io), qc = !!jE && "webkitFontSmoothing" in jE.documentElement.style, AG = qc ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function TG(n) {
  let e = n.defaultView && n.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: n.documentElement.clientWidth,
    top: 0,
    bottom: n.documentElement.clientHeight
  };
}
function qi(n, e) {
  return typeof n == "number" ? n : n[e];
}
function CG(n) {
  let e = n.getBoundingClientRect(), t = e.width / n.offsetWidth || 1, r = e.height / n.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + n.clientWidth * t,
    top: e.top,
    bottom: e.top + n.clientHeight * r
  };
}
function FE(n, e, t) {
  let r = n.someProp("scrollThreshold") || 0, i = n.someProp("scrollMargin") || 5, s = n.dom.ownerDocument;
  for (let o = t || n.dom; o; ) {
    if (o.nodeType != 1) {
      o = Za(o);
      continue;
    }
    let a = o, c = a == s.body, u = c ? TG(s) : CG(a), d = 0, h = 0;
    if (e.top < u.top + qi(r, "top") ? h = -(u.top - e.top + qi(i, "top")) : e.bottom > u.bottom - qi(r, "bottom") && (h = e.bottom - e.top > u.bottom - u.top ? e.top + qi(i, "top") - u.top : e.bottom - u.bottom + qi(i, "bottom")), e.left < u.left + qi(r, "left") ? d = -(u.left - e.left + qi(i, "left")) : e.right > u.right - qi(r, "right") && (d = e.right - u.right + qi(i, "right")), d || h)
      if (c)
        s.defaultView.scrollBy(d, h);
      else {
        let g = a.scrollLeft, y = a.scrollTop;
        h && (a.scrollTop += h), d && (a.scrollLeft += d);
        let b = a.scrollLeft - g, S = a.scrollTop - y;
        e = { left: e.left - b, top: e.top - S, right: e.right - b, bottom: e.bottom - S };
      }
    let p = c ? "fixed" : getComputedStyle(o).position;
    if (/^(fixed|sticky)$/.test(p))
      break;
    o = p == "absolute" ? o.offsetParent : Za(o);
  }
}
function DG(n) {
  let e = n.dom.getBoundingClientRect(), t = Math.max(0, e.top), r, i;
  for (let s = (e.left + e.right) / 2, o = t + 1; o < Math.min(innerHeight, e.bottom); o += 5) {
    let a = n.root.elementFromPoint(s, o);
    if (!a || a == n.dom || !n.dom.contains(a))
      continue;
    let c = a.getBoundingClientRect();
    if (c.top >= t - 20) {
      r = a, i = c.top;
      break;
    }
  }
  return { refDOM: r, refTop: i, stack: ik(n.dom) };
}
function ik(n) {
  let e = [], t = n.ownerDocument;
  for (let r = n; r && (e.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), n != t); r = Za(r))
    ;
  return e;
}
function RG({ refDOM: n, refTop: e, stack: t }) {
  let r = n ? n.getBoundingClientRect().top : 0;
  sk(t, r == 0 ? 0 : r - e);
}
function sk(n, e) {
  for (let t = 0; t < n.length; t++) {
    let { dom: r, top: i, left: s } = n[t];
    r.scrollTop != i + e && (r.scrollTop = i + e), r.scrollLeft != s && (r.scrollLeft = s);
  }
}
let xa = null;
function kG(n) {
  if (n.setActive)
    return n.setActive();
  if (xa)
    return n.focus(xa);
  let e = ik(n);
  n.focus(xa == null ? {
    get preventScroll() {
      return xa = { preventScroll: !0 }, !0;
    }
  } : void 0), xa || (xa = !1, sk(e, 0));
}
function ok(n, e) {
  let t, r = 2e8, i, s = 0, o = e.top, a = e.top, c, u;
  for (let d = n.firstChild, h = 0; d; d = d.nextSibling, h++) {
    let p;
    if (d.nodeType == 1)
      p = d.getClientRects();
    else if (d.nodeType == 3)
      p = Zi(d).getClientRects();
    else
      continue;
    for (let g = 0; g < p.length; g++) {
      let y = p[g];
      if (y.top <= o && y.bottom >= a) {
        o = Math.max(y.bottom, o), a = Math.min(y.top, a);
        let b = y.left > e.left ? y.left - e.left : y.right < e.left ? e.left - y.right : 0;
        if (b < r) {
          t = d, r = b, i = b && t.nodeType == 3 ? {
            left: y.right < e.left ? y.right : y.left,
            top: e.top
          } : e, d.nodeType == 1 && b && (s = h + (e.left >= (y.left + y.right) / 2 ? 1 : 0));
          continue;
        }
      } else y.top > e.top && !c && y.left <= e.left && y.right >= e.left && (c = d, u = { left: Math.max(y.left, Math.min(y.right, e.left)), top: y.top });
      !t && (e.left >= y.right && e.top >= y.top || e.left >= y.left && e.top >= y.bottom) && (s = h + 1);
    }
  }
  return !t && c && (t = c, i = u, r = 0), t && t.nodeType == 3 ? MG(t, i) : !t || r && t.nodeType == 1 ? { node: n, offset: s } : ok(t, i);
}
function MG(n, e) {
  let t = n.nodeValue.length, r = document.createRange(), i;
  for (let s = 0; s < t; s++) {
    r.setEnd(n, s + 1), r.setStart(n, s);
    let o = _s(r, 1);
    if (o.top != o.bottom && Ov(e, o)) {
      i = { node: n, offset: s + (e.left >= (o.left + o.right) / 2 ? 1 : 0) };
      break;
    }
  }
  return r.detach(), i || { node: n, offset: 0 };
}
function Ov(n, e) {
  return n.left >= e.left - 1 && n.left <= e.right + 1 && n.top >= e.top - 1 && n.top <= e.bottom + 1;
}
function _G(n, e) {
  let t = n.parentNode;
  return t && /^li$/i.test(t.nodeName) && e.left < n.getBoundingClientRect().left ? t : n;
}
function OG(n, e, t) {
  let { node: r, offset: i } = ok(e, t), s = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let o = r.getBoundingClientRect();
    s = o.left != o.right && t.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return n.docView.posFromDOM(r, i, s);
}
function IG(n, e, t, r) {
  let i = -1;
  for (let s = e, o = !1; s != n.dom; ) {
    let a = n.docView.nearestDesc(s, !0), c;
    if (!a)
      return null;
    if (a.dom.nodeType == 1 && (a.node.isBlock && a.parent || !a.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((c = a.dom.getBoundingClientRect()).width || c.height) && (a.node.isBlock && a.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(a.dom.nodeName) && (!o && c.left > r.left || c.top > r.top ? i = a.posBefore : (!o && c.right < r.left || c.bottom < r.top) && (i = a.posAfter), o = !0), !a.contentDOM && i < 0 && !a.node.isText))
      return (a.node.isBlock ? r.top < (c.top + c.bottom) / 2 : r.left < (c.left + c.right) / 2) ? a.posBefore : a.posAfter;
    s = a.dom.parentNode;
  }
  return i > -1 ? i : n.docView.posFromDOM(e, t, -1);
}
function ak(n, e, t) {
  let r = n.childNodes.length;
  if (r && t.top < t.bottom)
    for (let i = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - t.top) / (t.bottom - t.top)) - 2)), s = i; ; ) {
      let o = n.childNodes[s];
      if (o.nodeType == 1) {
        let a = o.getClientRects();
        for (let c = 0; c < a.length; c++) {
          let u = a[c];
          if (Ov(e, u))
            return ak(o, e, u);
        }
      }
      if ((s = (s + 1) % r) == i)
        break;
    }
  return n;
}
function NG(n, e) {
  let t = n.dom.ownerDocument, r, i = 0, s = EG(t, e.left, e.top);
  s && ({ node: r, offset: i } = s);
  let o = (n.root.elementFromPoint ? n.root : t).elementFromPoint(e.left, e.top), a;
  if (!o || !n.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let u = n.dom.getBoundingClientRect();
    if (!Ov(e, u) || (o = ak(n.dom, e, u), !o))
      return null;
  }
  if (Pn)
    for (let u = o; r && u; u = Za(u))
      u.draggable && (r = void 0);
  if (o = _G(o, e), r) {
    if (Qr && r.nodeType == 1 && (i = Math.min(i, r.childNodes.length), i < r.childNodes.length)) {
      let d = r.childNodes[i], h;
      d.nodeName == "IMG" && (h = d.getBoundingClientRect()).right <= e.left && h.bottom > e.top && i++;
    }
    let u;
    qc && i && r.nodeType == 1 && (u = r.childNodes[i - 1]).nodeType == 1 && u.contentEditable == "false" && u.getBoundingClientRect().top >= e.top && i--, r == n.dom && i == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && e.top > r.lastChild.getBoundingClientRect().bottom ? a = n.state.doc.content.size : (i == 0 || r.nodeType != 1 || r.childNodes[i - 1].nodeName != "BR") && (a = IG(n, r, i, e));
  }
  a == null && (a = OG(n, o, e));
  let c = n.docView.nearestDesc(o, !0);
  return { pos: a, inside: c ? c.posAtStart - c.border : -1 };
}
function zE(n) {
  return n.top < n.bottom || n.left < n.right;
}
function _s(n, e) {
  let t = n.getClientRects();
  if (t.length) {
    let r = t[e < 0 ? 0 : t.length - 1];
    if (zE(r))
      return r;
  }
  return Array.prototype.find.call(t, zE) || n.getBoundingClientRect();
}
const PG = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function lk(n, e, t) {
  let { node: r, offset: i, atom: s } = n.docView.domFromPos(e, t < 0 ? -1 : 1), o = qc || Qr;
  if (r.nodeType == 3)
    if (o && (PG.test(r.nodeValue) || (t < 0 ? !i : i == r.nodeValue.length))) {
      let c = _s(Zi(r, i, i), t);
      if (Qr && i && /\s/.test(r.nodeValue[i - 1]) && i < r.nodeValue.length) {
        let u = _s(Zi(r, i - 1, i - 1), -1);
        if (u.top == c.top) {
          let d = _s(Zi(r, i, i + 1), -1);
          if (d.top != c.top)
            return Il(d, d.left < u.left);
        }
      }
      return c;
    } else {
      let c = i, u = i, d = t < 0 ? 1 : -1;
      return t < 0 && !i ? (u++, d = -1) : t >= 0 && i == r.nodeValue.length ? (c--, d = 1) : t < 0 ? c-- : u++, Il(_s(Zi(r, c, u), d), d < 0);
    }
  if (!n.state.doc.resolve(e - (s || 0)).parent.inlineContent) {
    if (s == null && i && (t < 0 || i == Yr(r))) {
      let c = r.childNodes[i - 1];
      if (c.nodeType == 1)
        return ym(c.getBoundingClientRect(), !1);
    }
    if (s == null && i < Yr(r)) {
      let c = r.childNodes[i];
      if (c.nodeType == 1)
        return ym(c.getBoundingClientRect(), !0);
    }
    return ym(r.getBoundingClientRect(), t >= 0);
  }
  if (s == null && i && (t < 0 || i == Yr(r))) {
    let c = r.childNodes[i - 1], u = c.nodeType == 3 ? Zi(c, Yr(c) - (o ? 0 : 1)) : c.nodeType == 1 && (c.nodeName != "BR" || !c.nextSibling) ? c : null;
    if (u)
      return Il(_s(u, 1), !1);
  }
  if (s == null && i < Yr(r)) {
    let c = r.childNodes[i];
    for (; c.pmViewDesc && c.pmViewDesc.ignoreForCoords; )
      c = c.nextSibling;
    let u = c ? c.nodeType == 3 ? Zi(c, 0, o ? 0 : 1) : c.nodeType == 1 ? c : null : null;
    if (u)
      return Il(_s(u, -1), !0);
  }
  return Il(_s(r.nodeType == 3 ? Zi(r) : r, -t), t >= 0);
}
function Il(n, e) {
  if (n.width == 0)
    return n;
  let t = e ? n.left : n.right;
  return { top: n.top, bottom: n.bottom, left: t, right: t };
}
function ym(n, e) {
  if (n.height == 0)
    return n;
  let t = e ? n.top : n.bottom;
  return { top: t, bottom: t, left: n.left, right: n.right };
}
function ck(n, e, t) {
  let r = n.state, i = n.root.activeElement;
  r != e && n.updateState(e), i != n.dom && n.focus();
  try {
    return t();
  } finally {
    r != e && n.updateState(r), i != n.dom && i && i.focus();
  }
}
function LG(n, e, t) {
  let r = e.selection, i = t == "up" ? r.$from : r.$to;
  return ck(n, e, () => {
    let { node: s } = n.docView.domFromPos(i.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let a = n.docView.nearestDesc(s, !0);
      if (!a)
        break;
      if (a.node.isBlock) {
        s = a.contentDOM || a.dom;
        break;
      }
      s = a.dom.parentNode;
    }
    let o = lk(n, i.pos, 1);
    for (let a = s.firstChild; a; a = a.nextSibling) {
      let c;
      if (a.nodeType == 1)
        c = a.getClientRects();
      else if (a.nodeType == 3)
        c = Zi(a, 0, a.nodeValue.length).getClientRects();
      else
        continue;
      for (let u = 0; u < c.length; u++) {
        let d = c[u];
        if (d.bottom > d.top + 1 && (t == "up" ? o.top - d.top > (d.bottom - o.top) * 2 : d.bottom - o.bottom > (o.bottom - d.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const BG = /[\u0590-\u08ac]/;
function jG(n, e, t) {
  let { $head: r } = e.selection;
  if (!r.parent.isTextblock)
    return !1;
  let i = r.parentOffset, s = !i, o = i == r.parent.content.size, a = n.domSelection();
  return a ? !BG.test(r.parent.textContent) || !a.modify ? t == "left" || t == "backward" ? s : o : ck(n, e, () => {
    let { focusNode: c, focusOffset: u, anchorNode: d, anchorOffset: h } = n.domSelectionRange(), p = a.caretBidiLevel;
    a.modify("move", t, "character");
    let g = r.depth ? n.docView.domAfterPos(r.before()) : n.dom, { focusNode: y, focusOffset: b } = n.domSelectionRange(), S = y && !g.contains(y.nodeType == 1 ? y : y.parentNode) || c == y && u == b;
    try {
      a.collapse(d, h), c && (c != d || u != h) && a.extend && a.extend(c, u);
    } catch {
    }
    return p != null && (a.caretBidiLevel = p), S;
  }) : r.pos == r.start() || r.pos == r.end();
}
let VE = null, HE = null, UE = !1;
function FG(n, e, t) {
  return VE == e && HE == t ? UE : (VE = e, HE = t, UE = t == "up" || t == "down" ? LG(n, e, t) : jG(n, e, t));
}
const Zr = 0, WE = 1, _o = 2, Ni = 3;
class Kc {
  constructor(e, t, r, i) {
    this.parent = e, this.children = t, this.dom = r, this.contentDOM = i, this.dirty = Zr, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, t, r) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let t = 0; t < this.children.length; t++)
      e += this.children[t].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let t = 0, r = this.posAtStart; ; t++) {
      let i = this.children[t];
      if (i == e)
        return r;
      r += i.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, t, r) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (r < 0) {
        let s, o;
        if (e == this.contentDOM)
          s = e.childNodes[t - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          s = e.previousSibling;
        }
        for (; s && !((o = s.pmViewDesc) && o.parent == this); )
          s = s.previousSibling;
        return s ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let s, o;
        if (e == this.contentDOM)
          s = e.childNodes[t];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          s = e.nextSibling;
        }
        for (; s && !((o = s.pmViewDesc) && o.parent == this); )
          s = s.nextSibling;
        return s ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let i;
    if (e == this.dom && this.contentDOM)
      i = t > On(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      i = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let s = e; ; s = s.parentNode) {
          if (s == this.dom) {
            i = !1;
            break;
          }
          if (s.previousSibling)
            break;
        }
      if (i == null && t == e.childNodes.length)
        for (let s = e; ; s = s.parentNode) {
          if (s == this.dom) {
            i = !0;
            break;
          }
          if (s.nextSibling)
            break;
        }
    }
    return i ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, t = !1) {
    for (let r = !0, i = e; i; i = i.parentNode) {
      let s = this.getDesc(i), o;
      if (s && (!t || s.node))
        if (r && (o = s.nodeDOM) && !(o.nodeType == 1 ? o.contains(e.nodeType == 1 ? e : e.parentNode) : o == e))
          r = !1;
        else
          return s;
    }
  }
  getDesc(e) {
    let t = e.pmViewDesc;
    for (let r = t; r; r = r.parent)
      if (r == this)
        return t;
  }
  posFromDOM(e, t, r) {
    for (let i = e; i; i = i.parentNode) {
      let s = this.getDesc(i);
      if (s)
        return s.localPosFromDOM(e, t, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let t = 0, r = 0; t < this.children.length; t++) {
      let i = this.children[t], s = r + i.size;
      if (r == e && s != r) {
        for (; !i.border && i.children.length; )
          for (let o = 0; o < i.children.length; o++) {
            let a = i.children[o];
            if (a.size) {
              i = a;
              break;
            }
          }
        return i;
      }
      if (e < s)
        return i.descAt(e - r - i.border);
      r = s;
    }
  }
  domFromPos(e, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let r = 0, i = 0;
    for (let s = 0; r < this.children.length; r++) {
      let o = this.children[r], a = s + o.size;
      if (a > e || o instanceof dk) {
        i = e - s;
        break;
      }
      s = a;
    }
    if (i)
      return this.children[r].domFromPos(i - this.children[r].border, t);
    for (let s; r && !(s = this.children[r - 1]).size && s instanceof uk && s.side >= 0; r--)
      ;
    if (t <= 0) {
      let s, o = !0;
      for (; s = r ? this.children[r - 1] : null, !(!s || s.dom.parentNode == this.contentDOM); r--, o = !1)
        ;
      return s && t && o && !s.border && !s.domAtom ? s.domFromPos(s.size, t) : { node: this.contentDOM, offset: s ? On(s.dom) + 1 : 0 };
    } else {
      let s, o = !0;
      for (; s = r < this.children.length ? this.children[r] : null, !(!s || s.dom.parentNode == this.contentDOM); r++, o = !1)
        ;
      return s && o && !s.border && !s.domAtom ? s.domFromPos(0, t) : { node: this.contentDOM, offset: s ? On(s.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, t, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let i = -1, s = -1;
    for (let o = r, a = 0; ; a++) {
      let c = this.children[a], u = o + c.size;
      if (i == -1 && e <= u) {
        let d = o + c.border;
        if (e >= d && t <= u - c.border && c.node && c.contentDOM && this.contentDOM.contains(c.contentDOM))
          return c.parseRange(e, t, d);
        e = o;
        for (let h = a; h > 0; h--) {
          let p = this.children[h - 1];
          if (p.size && p.dom.parentNode == this.contentDOM && !p.emptyChildAt(1)) {
            i = On(p.dom) + 1;
            break;
          }
          e -= p.size;
        }
        i == -1 && (i = 0);
      }
      if (i > -1 && (u > t || a == this.children.length - 1)) {
        t = u;
        for (let d = a + 1; d < this.children.length; d++) {
          let h = this.children[d];
          if (h.size && h.dom.parentNode == this.contentDOM && !h.emptyChildAt(-1)) {
            s = On(h.dom);
            break;
          }
          t += h.size;
        }
        s == -1 && (s = this.contentDOM.childNodes.length);
        break;
      }
      o = u;
    }
    return { node: this.contentDOM, from: e, to: t, fromOffset: i, toOffset: s };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[e < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: t, offset: r } = this.domFromPos(e, 0);
    if (t.nodeType != 1 || r == t.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return t.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, t, r, i = !1) {
    let s = Math.min(e, t), o = Math.max(e, t);
    for (let g = 0, y = 0; g < this.children.length; g++) {
      let b = this.children[g], S = y + b.size;
      if (s > y && o < S)
        return b.setSelection(e - y - b.border, t - y - b.border, r, i);
      y = S;
    }
    let a = this.domFromPos(e, e ? -1 : 1), c = t == e ? a : this.domFromPos(t, t ? -1 : 1), u = r.root.getSelection(), d = r.domSelectionRange(), h = !1;
    if ((Qr || Pn) && e == t) {
      let { node: g, offset: y } = a;
      if (g.nodeType == 3) {
        if (h = !!(y && g.nodeValue[y - 1] == `
`), h && y == g.nodeValue.length)
          for (let b = g, S; b; b = b.parentNode) {
            if (S = b.nextSibling) {
              S.nodeName == "BR" && (a = c = { node: S.parentNode, offset: On(S) + 1 });
              break;
            }
            let w = b.pmViewDesc;
            if (w && w.node && w.node.isBlock)
              break;
          }
      } else {
        let b = g.childNodes[y - 1];
        h = b && (b.nodeName == "BR" || b.contentEditable == "false");
      }
    }
    if (Qr && d.focusNode && d.focusNode != c.node && d.focusNode.nodeType == 1) {
      let g = d.focusNode.childNodes[d.focusOffset];
      g && g.contentEditable == "false" && (i = !0);
    }
    if (!(i || h && Pn) && Yo(a.node, a.offset, d.anchorNode, d.anchorOffset) && Yo(c.node, c.offset, d.focusNode, d.focusOffset))
      return;
    let p = !1;
    if ((u.extend || e == t) && !(h && Qr)) {
      u.collapse(a.node, a.offset);
      try {
        e != t && u.extend(c.node, c.offset), p = !0;
      } catch {
      }
    }
    if (!p) {
      if (e > t) {
        let y = a;
        a = c, c = y;
      }
      let g = document.createRange();
      g.setEnd(c.node, c.offset), g.setStart(a.node, a.offset), u.removeAllRanges(), u.addRange(g);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, t) {
    for (let r = 0, i = 0; i < this.children.length; i++) {
      let s = this.children[i], o = r + s.size;
      if (r == o ? e <= o && t >= r : e < o && t > r) {
        let a = r + s.border, c = o - s.border;
        if (e >= a && t <= c) {
          this.dirty = e == r || t == o ? _o : WE, e == a && t == c && (s.contentLost || s.dom.parentNode != this.contentDOM) ? s.dirty = Ni : s.markDirty(e - a, t - a);
          return;
        } else
          s.dirty = s.dom == s.contentDOM && s.dom.parentNode == this.contentDOM && !s.children.length ? _o : Ni;
      }
      r = o;
    }
    this.dirty = _o;
  }
  markParentsDirty() {
    let e = 1;
    for (let t = this.parent; t; t = t.parent, e++) {
      let r = e == 1 ? _o : WE;
      t.dirty < r && (t.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class uk extends Kc {
  constructor(e, t, r, i) {
    let s, o = t.type.toDOM;
    if (typeof o == "function" && (o = o(r, () => {
      if (!s)
        return i;
      if (s.parent)
        return s.parent.posBeforeChild(s);
    })), !t.type.spec.raw) {
      if (o.nodeType != 1) {
        let a = document.createElement("span");
        a.appendChild(o), o = a;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(e, [], o, null), this.widget = t, this.widget = t, s = this;
  }
  matchesWidget(e) {
    return this.dirty == Zr && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let t = this.widget.spec.stopEvent;
    return t ? t(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class zG extends Kc {
  constructor(e, t, r, i) {
    super(e, [], t, null), this.textDOM = r, this.text = i;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, t) {
    return e != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class qo extends Kc {
  constructor(e, t, r, i, s) {
    super(e, [], r, i), this.mark = t, this.spec = s;
  }
  static create(e, t, r, i) {
    let s = i.nodeViews[t.type.name], o = s && s(t, i, r);
    return (!o || !o.dom) && (o = Xo.renderSpec(document, t.type.spec.toDOM(t, r), null, t.attrs)), new qo(e, t, o.dom, o.contentDOM || o.dom, o);
  }
  parseRule() {
    return this.dirty & Ni || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != Ni && this.mark.eq(e);
  }
  markDirty(e, t) {
    if (super.markDirty(e, t), this.dirty != Zr) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = Zr;
    }
  }
  slice(e, t, r) {
    let i = qo.create(this.parent, this.mark, !0, r), s = this.children, o = this.size;
    t < o && (s = Wg(s, t, o, r)), e > 0 && (s = Wg(s, 0, e, r));
    for (let a = 0; a < s.length; a++)
      s[a].parent = i;
    return i.children = s, i;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class qs extends Kc {
  constructor(e, t, r, i, s, o, a, c, u) {
    super(e, [], s, o), this.node = t, this.outerDeco = r, this.innerDeco = i, this.nodeDOM = a;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, t, r, i, s, o) {
    let a = s.nodeViews[t.type.name], c, u = a && a(t, s, () => {
      if (!c)
        return o;
      if (c.parent)
        return c.parent.posBeforeChild(c);
    }, r, i), d = u && u.dom, h = u && u.contentDOM;
    if (t.isText) {
      if (!d)
        d = document.createTextNode(t.text);
      else if (d.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else d || ({ dom: d, contentDOM: h } = Xo.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !h && !t.isText && d.nodeName != "BR" && (d.hasAttribute("contenteditable") || (d.contentEditable = "false"), t.type.spec.draggable && (d.draggable = !0));
    let p = d;
    return d = pk(d, r, t), u ? c = new VG(e, t, r, i, d, h || null, p, u, s, o + 1) : t.isText ? new ih(e, t, r, i, d, p, s) : new qs(e, t, r, i, d, h || null, p, s, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let r = this.children[t];
        if (this.dom.contains(r.dom.parentNode)) {
          e.contentElement = r.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => ce.empty);
    }
    return e;
  }
  matchesNode(e, t, r) {
    return this.dirty == Zr && e.eq(this.node) && rf(t, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, t) {
    let r = this.node.inlineContent, i = t, s = e.composing ? this.localCompositionInfo(e, t) : null, o = s && s.pos > -1 ? s : null, a = s && s.pos < 0, c = new UG(this, o && o.node, e);
    GG(this.node, this.innerDeco, (u, d, h) => {
      u.spec.marks ? c.syncToMarks(u.spec.marks, r, e, d) : u.type.side >= 0 && !h && c.syncToMarks(d == this.node.childCount ? St.none : this.node.child(d).marks, r, e, d), c.placeWidget(u, e, i);
    }, (u, d, h, p) => {
      c.syncToMarks(u.marks, r, e, p);
      let g;
      c.findNodeMatch(u, d, h, p) || a && e.state.selection.from > i && e.state.selection.to < i + u.nodeSize && (g = c.findIndexWithChild(s.node)) > -1 && c.updateNodeAt(u, d, h, g, e) || c.updateNextNode(u, d, h, e, p, i) || c.addNode(u, d, h, e, i), i += u.nodeSize;
    }), c.syncToMarks([], r, e, 0), this.node.isTextblock && c.addTextblockHacks(), c.destroyRest(), (c.changed || this.dirty == _o) && (o && this.protectLocalComposition(e, o), fk(this.contentDOM, this.children, e), Xa && YG(this.dom));
  }
  localCompositionInfo(e, t) {
    let { from: r, to: i } = e.state.selection;
    if (!(e.state.selection instanceof Ve) || r < t || i > t + this.node.content.size)
      return null;
    let s = e.input.compositionNode;
    if (!s || !this.dom.contains(s.parentNode))
      return null;
    if (this.node.inlineContent) {
      let o = s.nodeValue, a = qG(this.node.content, o, r - t, i - t);
      return a < 0 ? null : { node: s, pos: a, text: o };
    } else
      return { node: s, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: t, pos: r, text: i }) {
    if (this.getDesc(t))
      return;
    let s = t;
    for (; s.parentNode != this.contentDOM; s = s.parentNode) {
      for (; s.previousSibling; )
        s.parentNode.removeChild(s.previousSibling);
      for (; s.nextSibling; )
        s.parentNode.removeChild(s.nextSibling);
      s.pmViewDesc && (s.pmViewDesc = void 0);
    }
    let o = new zG(this, s, t, i);
    e.input.compositionNodes.push(o), this.children = Wg(this.children, r, r + i.length, e, o);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, t, r, i) {
    return this.dirty == Ni || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, t, r, i), !0);
  }
  updateInner(e, t, r, i) {
    this.updateOuterDeco(t), this.node = e, this.innerDeco = r, this.contentDOM && this.updateChildren(i, this.posAtStart), this.dirty = Zr;
  }
  updateOuterDeco(e) {
    if (rf(e, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = hk(this.dom, this.nodeDOM, Ug(this.outerDeco, this.node, t), Ug(e, this.node, t)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function $E(n, e, t, r, i) {
  pk(r, e, n);
  let s = new qs(void 0, n, e, t, r, r, r, i, 0);
  return s.contentDOM && s.updateChildren(i, 0), s;
}
class ih extends qs {
  constructor(e, t, r, i, s, o, a) {
    super(e, t, r, i, s, null, o, a, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, t, r, i) {
    return this.dirty == Ni || this.dirty != Zr && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != Zr || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, i.trackWrites == this.nodeDOM && (i.trackWrites = null)), this.node = e, this.dirty = Zr, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, t, r) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, r);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, t, r) {
    let i = this.node.cut(e, t), s = document.createTextNode(i.text);
    return new ih(this.parent, i, this.outerDeco, this.innerDeco, s, s, r);
  }
  markDirty(e, t) {
    super.markDirty(e, t), this.dom != this.nodeDOM && (e == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = Ni);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class dk extends Kc {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == Zr && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class VG extends qs {
  constructor(e, t, r, i, s, o, a, c, u, d) {
    super(e, t, r, i, s, o, a, u, d), this.spec = c;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, t, r, i) {
    if (this.dirty == Ni)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let s = this.spec.update(e, t, r);
      return s && this.updateInner(e, t, r, i), s;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, t, r, i);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, t, r, i) {
    this.spec.setSelection ? this.spec.setSelection(e, t, r.root) : super.setSelection(e, t, r, i);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function fk(n, e, t) {
  let r = n.firstChild, i = !1;
  for (let s = 0; s < e.length; s++) {
    let o = e[s], a = o.dom;
    if (a.parentNode == n) {
      for (; a != r; )
        r = GE(r), i = !0;
      r = r.nextSibling;
    } else
      i = !0, n.insertBefore(a, r);
    if (o instanceof qo) {
      let c = r ? r.previousSibling : n.lastChild;
      fk(o.contentDOM, o.children, t), r = c ? c.nextSibling : n.firstChild;
    }
  }
  for (; r; )
    r = GE(r), i = !0;
  i && t.trackWrites == n && (t.trackWrites = null);
}
const ic = function(n) {
  n && (this.nodeName = n);
};
ic.prototype = /* @__PURE__ */ Object.create(null);
const Oo = [new ic()];
function Ug(n, e, t) {
  if (n.length == 0)
    return Oo;
  let r = t ? Oo[0] : new ic(), i = [r];
  for (let s = 0; s < n.length; s++) {
    let o = n[s].type.attrs;
    if (o) {
      o.nodeName && i.push(r = new ic(o.nodeName));
      for (let a in o) {
        let c = o[a];
        c != null && (t && i.length == 1 && i.push(r = new ic(e.isInline ? "span" : "div")), a == "class" ? r.class = (r.class ? r.class + " " : "") + c : a == "style" ? r.style = (r.style ? r.style + ";" : "") + c : a != "nodeName" && (r[a] = c));
      }
    }
  }
  return i;
}
function hk(n, e, t, r) {
  if (t == Oo && r == Oo)
    return e;
  let i = e;
  for (let s = 0; s < r.length; s++) {
    let o = r[s], a = t[s];
    if (s) {
      let c;
      a && a.nodeName == o.nodeName && i != n && (c = i.parentNode) && c.nodeName.toLowerCase() == o.nodeName || (c = document.createElement(o.nodeName), c.pmIsDeco = !0, c.appendChild(i), a = Oo[0]), i = c;
    }
    HG(i, a || Oo[0], o);
  }
  return i;
}
function HG(n, e, t) {
  for (let r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in t) && n.removeAttribute(r);
  for (let r in t)
    r != "class" && r != "style" && r != "nodeName" && t[r] != e[r] && n.setAttribute(r, t[r]);
  if (e.class != t.class) {
    let r = e.class ? e.class.split(" ").filter(Boolean) : [], i = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let s = 0; s < r.length; s++)
      i.indexOf(r[s]) == -1 && n.classList.remove(r[s]);
    for (let s = 0; s < i.length; s++)
      r.indexOf(i[s]) == -1 && n.classList.add(i[s]);
    n.classList.length == 0 && n.removeAttribute("class");
  }
  if (e.style != t.style) {
    if (e.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, i;
      for (; i = r.exec(e.style); )
        n.style.removeProperty(i[1]);
    }
    t.style && (n.style.cssText += t.style);
  }
}
function pk(n, e, t) {
  return hk(n, n, Oo, Ug(e, t, n.nodeType != 1));
}
function rf(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!n[t].type.eq(e[t].type))
      return !1;
  return !0;
}
function GE(n) {
  let e = n.nextSibling;
  return n.parentNode.removeChild(n), e;
}
class UG {
  constructor(e, t, r) {
    this.lock = t, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = WG(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, t) {
    if (e != t) {
      for (let r = e; r < t; r++)
        this.top.children[r].destroy();
      this.top.children.splice(e, t - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, t, r, i) {
    let s = 0, o = this.stack.length >> 1, a = Math.min(o, e.length);
    for (; s < a && (s == o - 1 ? this.top : this.stack[s + 1 << 1]).matchesMark(e[s]) && e[s].type.spec.spanning !== !1; )
      s++;
    for (; s < o; )
      this.destroyRest(), this.top.dirty = Zr, this.index = this.stack.pop(), this.top = this.stack.pop(), o--;
    for (; o < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let c = -1, u = this.top.children.length;
      i < this.preMatch.index && (u = Math.min(this.index + 3, u));
      for (let d = this.index; d < u; d++) {
        let h = this.top.children[d];
        if (h.matchesMark(e[o]) && !this.isLocked(h.dom)) {
          c = d;
          break;
        }
      }
      if (c > -1)
        c > this.index && (this.changed = !0, this.destroyBetween(this.index, c)), this.top = this.top.children[this.index];
      else {
        let d = qo.create(this.top, e[o], t, r);
        this.top.children.splice(this.index, 0, d), this.top = d, this.changed = !0;
      }
      this.index = 0, o++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, t, r, i) {
    let s = -1, o;
    if (i >= this.preMatch.index && (o = this.preMatch.matches[i - this.preMatch.index]).parent == this.top && o.matchesNode(e, t, r))
      s = this.top.children.indexOf(o, this.index);
    else
      for (let a = this.index, c = Math.min(this.top.children.length, a + 5); a < c; a++) {
        let u = this.top.children[a];
        if (u.matchesNode(e, t, r) && !this.preMatch.matched.has(u)) {
          s = a;
          break;
        }
      }
    return s < 0 ? !1 : (this.destroyBetween(this.index, s), this.index++, !0);
  }
  updateNodeAt(e, t, r, i, s) {
    let o = this.top.children[i];
    return o.dirty == Ni && o.dom == o.contentDOM && (o.dirty = _o), o.update(e, t, r, s) ? (this.destroyBetween(this.index, i), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let t = e.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let r = e.pmViewDesc;
        if (r) {
          for (let i = this.index; i < this.top.children.length; i++)
            if (this.top.children[i] == r)
              return i;
        }
        return -1;
      }
      e = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, t, r, i, s, o) {
    for (let a = this.index; a < this.top.children.length; a++) {
      let c = this.top.children[a];
      if (c instanceof qs) {
        let u = this.preMatch.matched.get(c);
        if (u != null && u != s)
          return !1;
        let d = c.dom, h, p = this.isLocked(d) && !(e.isText && c.node && c.node.isText && c.nodeDOM.nodeValue == e.text && c.dirty != Ni && rf(t, c.outerDeco));
        if (!p && c.update(e, t, r, i))
          return this.destroyBetween(this.index, a), c.dom != d && (this.changed = !0), this.index++, !0;
        if (!p && (h = this.recreateWrapper(c, e, t, r, i, o)))
          return this.destroyBetween(this.index, a), this.top.children[this.index] = h, h.contentDOM && (h.dirty = _o, h.updateChildren(i, o + 1), h.dirty = Zr), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, t, r, i, s, o) {
    if (e.dirty || t.isAtom || !e.children.length || !e.node.content.eq(t.content) || !rf(r, e.outerDeco) || !i.eq(e.innerDeco))
      return null;
    let a = qs.create(this.top, t, r, i, s, o);
    if (a.contentDOM) {
      a.children = e.children, e.children = [];
      for (let c of a.children)
        c.parent = a;
    }
    return e.destroy(), a;
  }
  // Insert the node as a newly created node desc.
  addNode(e, t, r, i, s) {
    let o = qs.create(this.top, e, t, r, i, s);
    o.contentDOM && o.updateChildren(i, s + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(e, t, r) {
    let i = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (i && i.matchesWidget(e) && (e == i.widget || !i.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let s = new uk(this.top, e, t, r);
      this.top.children.splice(this.index++, 0, s), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], t = this.top;
    for (; e instanceof qo; )
      t = e, e = t.children[t.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof ih) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((Pn || vn) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(e, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e))
      this.index++;
    else {
      let r = document.createElement(e);
      e == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), e == "BR" && (r.className = "ProseMirror-trailingBreak");
      let i = new dk(this.top, [], r, null);
      t != this.top ? t.children.push(i) : t.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function WG(n, e) {
  let t = e, r = t.children.length, i = n.childCount, s = /* @__PURE__ */ new Map(), o = [];
  e: for (; i > 0; ) {
    let a;
    for (; ; )
      if (r) {
        let u = t.children[r - 1];
        if (u instanceof qo)
          t = u, r = u.children.length;
        else {
          a = u, r--;
          break;
        }
      } else {
        if (t == e)
          break e;
        r = t.parent.children.indexOf(t), t = t.parent;
      }
    let c = a.node;
    if (c) {
      if (c != n.child(i - 1))
        break;
      --i, s.set(a, i), o.push(a);
    }
  }
  return { index: i, matched: s, matches: o.reverse() };
}
function $G(n, e) {
  return n.type.side - e.type.side;
}
function GG(n, e, t, r) {
  let i = e.locals(n), s = 0;
  if (i.length == 0) {
    for (let u = 0; u < n.childCount; u++) {
      let d = n.child(u);
      r(d, i, e.forChild(s, d), u), s += d.nodeSize;
    }
    return;
  }
  let o = 0, a = [], c = null;
  for (let u = 0; ; ) {
    let d, h;
    for (; o < i.length && i[o].to == s; ) {
      let S = i[o++];
      S.widget && (d ? (h || (h = [d])).push(S) : d = S);
    }
    if (d)
      if (h) {
        h.sort($G);
        for (let S = 0; S < h.length; S++)
          t(h[S], u, !!c);
      } else
        t(d, u, !!c);
    let p, g;
    if (c)
      g = -1, p = c, c = null;
    else if (u < n.childCount)
      g = u, p = n.child(u++);
    else
      break;
    for (let S = 0; S < a.length; S++)
      a[S].to <= s && a.splice(S--, 1);
    for (; o < i.length && i[o].from <= s && i[o].to > s; )
      a.push(i[o++]);
    let y = s + p.nodeSize;
    if (p.isText) {
      let S = y;
      o < i.length && i[o].from < S && (S = i[o].from);
      for (let w = 0; w < a.length; w++)
        a[w].to < S && (S = a[w].to);
      S < y && (c = p.cut(S - s), p = p.cut(0, S - s), y = S, g = -1);
    } else
      for (; o < i.length && i[o].to < y; )
        o++;
    let b = p.isInline && !p.isLeaf ? a.filter((S) => !S.inline) : a.slice();
    r(p, b, e.forChild(s, p), g), s = y;
  }
}
function YG(n) {
  if (n.nodeName == "UL" || n.nodeName == "OL") {
    let e = n.style.cssText;
    n.style.cssText = e + "; list-style: square !important", window.getComputedStyle(n).listStyle, n.style.cssText = e;
  }
}
function qG(n, e, t, r) {
  for (let i = 0, s = 0; i < n.childCount && s <= r; ) {
    let o = n.child(i++), a = s;
    if (s += o.nodeSize, !o.isText)
      continue;
    let c = o.text;
    for (; i < n.childCount; ) {
      let u = n.child(i++);
      if (s += u.nodeSize, !u.isText)
        break;
      c += u.text;
    }
    if (s >= t) {
      if (s >= r && c.slice(r - e.length - a, r - a) == e)
        return r - e.length;
      let u = a < r ? c.lastIndexOf(e, r - a - 1) : -1;
      if (u >= 0 && u + e.length + a >= t)
        return a + u;
      if (t == r && c.length >= r + e.length - a && c.slice(r - a, r - a + e.length) == e)
        return r;
    }
  }
  return -1;
}
function Wg(n, e, t, r, i) {
  let s = [];
  for (let o = 0, a = 0; o < n.length; o++) {
    let c = n[o], u = a, d = a += c.size;
    u >= t || d <= e ? s.push(c) : (u < e && s.push(c.slice(0, e - u, r)), i && (s.push(i), i = void 0), d > t && s.push(c.slice(t - u, c.size, r)));
  }
  return s;
}
function Iv(n, e = null) {
  let t = n.domSelectionRange(), r = n.state.doc;
  if (!t.focusNode)
    return null;
  let i = n.docView.nearestDesc(t.focusNode), s = i && i.size == 0, o = n.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (o < 0)
    return null;
  let a = r.resolve(o), c, u;
  if (rh(t)) {
    for (c = o; i && !i.node; )
      i = i.parent;
    let h = i.node;
    if (i && h.isAtom && Me.isSelectable(h) && i.parent && !(h.isInline && SG(t.focusNode, t.focusOffset, i.dom))) {
      let p = i.posBefore;
      u = new Me(o == p ? a : r.resolve(p));
    }
  } else {
    if (t instanceof n.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let h = o, p = o;
      for (let g = 0; g < t.rangeCount; g++) {
        let y = t.getRangeAt(g);
        h = Math.min(h, n.docView.posFromDOM(y.startContainer, y.startOffset, 1)), p = Math.max(p, n.docView.posFromDOM(y.endContainer, y.endOffset, -1));
      }
      if (h < 0)
        return null;
      [c, o] = p == n.state.selection.anchor ? [p, h] : [h, p], a = r.resolve(o);
    } else
      c = n.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (c < 0)
      return null;
  }
  let d = r.resolve(c);
  if (!u) {
    let h = e == "pointer" || n.state.selection.head < a.pos && !s ? 1 : -1;
    u = Nv(n, d, a, h);
  }
  return u;
}
function mk(n) {
  return n.editable ? n.hasFocus() : yk(n) && document.activeElement && document.activeElement.contains(n.dom);
}
function is(n, e = !1) {
  let t = n.state.selection;
  if (gk(n, t), !!mk(n)) {
    if (!e && n.input.mouseDown && n.input.mouseDown.allowDefault && vn) {
      let r = n.domSelectionRange(), i = n.domObserver.currentSelection;
      if (r.anchorNode && i.anchorNode && Yo(r.anchorNode, r.anchorOffset, i.anchorNode, i.anchorOffset)) {
        n.input.mouseDown.delayedSelectionSync = !0, n.domObserver.setCurSelection();
        return;
      }
    }
    if (n.domObserver.disconnectSelection(), n.cursorWrapper)
      JG(n);
    else {
      let { anchor: r, head: i } = t, s, o;
      YE && !(t instanceof Ve) && (t.$from.parent.inlineContent || (s = qE(n, t.from)), !t.empty && !t.$from.parent.inlineContent && (o = qE(n, t.to))), n.docView.setSelection(r, i, n, e), YE && (s && KE(s), o && KE(o)), t.visible ? n.dom.classList.remove("ProseMirror-hideselection") : (n.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && KG(n));
    }
    n.domObserver.setCurSelection(), n.domObserver.connectSelection();
  }
}
const YE = Pn || vn && nk < 63;
function qE(n, e) {
  let { node: t, offset: r } = n.docView.domFromPos(e, 0), i = r < t.childNodes.length ? t.childNodes[r] : null, s = r ? t.childNodes[r - 1] : null;
  if (Pn && i && i.contentEditable == "false")
    return vm(i);
  if ((!i || i.contentEditable == "false") && (!s || s.contentEditable == "false")) {
    if (i)
      return vm(i);
    if (s)
      return vm(s);
  }
}
function vm(n) {
  return n.contentEditable = "true", Pn && n.draggable && (n.draggable = !1, n.wasDraggable = !0), n;
}
function KE(n) {
  n.contentEditable = "false", n.wasDraggable && (n.draggable = !0, n.wasDraggable = null);
}
function KG(n) {
  let e = n.dom.ownerDocument;
  e.removeEventListener("selectionchange", n.input.hideSelectionGuard);
  let t = n.domSelectionRange(), r = t.anchorNode, i = t.anchorOffset;
  e.addEventListener("selectionchange", n.input.hideSelectionGuard = () => {
    (t.anchorNode != r || t.anchorOffset != i) && (e.removeEventListener("selectionchange", n.input.hideSelectionGuard), setTimeout(() => {
      (!mk(n) || n.state.selection.visible) && n.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function JG(n) {
  let e = n.domSelection();
  if (!e)
    return;
  let t = n.cursorWrapper.dom, r = t.nodeName == "IMG";
  r ? e.collapse(t.parentNode, On(t) + 1) : e.collapse(t, 0), !r && !n.state.selection.visible && mr && Ys <= 11 && (t.disabled = !0, t.disabled = !1);
}
function gk(n, e) {
  if (e instanceof Me) {
    let t = n.docView.descAt(e.from);
    t != n.lastSelectedViewDesc && (JE(n), t && t.selectNode(), n.lastSelectedViewDesc = t);
  } else
    JE(n);
}
function JE(n) {
  n.lastSelectedViewDesc && (n.lastSelectedViewDesc.parent && n.lastSelectedViewDesc.deselectNode(), n.lastSelectedViewDesc = void 0);
}
function Nv(n, e, t, r) {
  return n.someProp("createSelectionBetween", (i) => i(n, e, t)) || Ve.between(e, t, r);
}
function QE(n) {
  return n.editable && !n.hasFocus() ? !1 : yk(n);
}
function yk(n) {
  let e = n.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return n.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (n.editable || n.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function QG(n) {
  let e = n.docView.domFromPos(n.state.selection.anchor, 0), t = n.domSelectionRange();
  return Yo(e.node, e.offset, t.anchorNode, t.anchorOffset);
}
function $g(n, e) {
  let { $anchor: t, $head: r } = n.selection, i = e > 0 ? t.max(r) : t.min(r), s = i.parent.inlineContent ? i.depth ? n.doc.resolve(e > 0 ? i.after() : i.before()) : null : i;
  return s && Xe.findFrom(s, e);
}
function Os(n, e) {
  return n.dispatch(n.state.tr.setSelection(e).scrollIntoView()), !0;
}
function ZE(n, e, t) {
  let r = n.state.selection;
  if (r instanceof Ve)
    if (t.indexOf("s") > -1) {
      let { $head: i } = r, s = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter;
      if (!s || s.isText || !s.isLeaf)
        return !1;
      let o = n.state.doc.resolve(i.pos + s.nodeSize * (e < 0 ? -1 : 1));
      return Os(n, new Ve(r.$anchor, o));
    } else if (r.empty) {
      if (n.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let i = $g(n.state, e);
        return i && i instanceof Me ? Os(n, i) : !1;
      } else if (!(Gr && t.indexOf("m") > -1)) {
        let i = r.$head, s = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter, o;
        if (!s || s.isText)
          return !1;
        let a = e < 0 ? i.pos - s.nodeSize : i.pos;
        return s.isAtom || (o = n.docView.descAt(a)) && !o.contentDOM ? Me.isSelectable(s) ? Os(n, new Me(e < 0 ? n.state.doc.resolve(i.pos - s.nodeSize) : i)) : qc ? Os(n, new Ve(n.state.doc.resolve(e < 0 ? a : a + s.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (r instanceof Me && r.node.isInline)
      return Os(n, new Ve(e > 0 ? r.$to : r.$from));
    {
      let i = $g(n.state, e);
      return i ? Os(n, i) : !1;
    }
  }
}
function sf(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function sc(n, e) {
  let t = n.pmViewDesc;
  return t && t.size == 0 && (e < 0 || n.nextSibling || n.nodeName != "BR");
}
function Sa(n, e) {
  return e < 0 ? ZG(n) : XG(n);
}
function ZG(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let i, s, o = !1;
  for (Qr && t.nodeType == 1 && r < sf(t) && sc(t.childNodes[r], -1) && (o = !0); ; )
    if (r > 0) {
      if (t.nodeType != 1)
        break;
      {
        let a = t.childNodes[r - 1];
        if (sc(a, -1))
          i = t, s = --r;
        else if (a.nodeType == 3)
          t = a, r = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (vk(t))
        break;
      {
        let a = t.previousSibling;
        for (; a && sc(a, -1); )
          i = t.parentNode, s = On(a), a = a.previousSibling;
        if (a)
          t = a, r = sf(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = 0;
        }
      }
    }
  o ? Gg(n, t, r) : i && Gg(n, i, s);
}
function XG(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let i = sf(t), s, o;
  for (; ; )
    if (r < i) {
      if (t.nodeType != 1)
        break;
      let a = t.childNodes[r];
      if (sc(a, 1))
        s = t, o = ++r;
      else
        break;
    } else {
      if (vk(t))
        break;
      {
        let a = t.nextSibling;
        for (; a && sc(a, 1); )
          s = a.parentNode, o = On(a) + 1, a = a.nextSibling;
        if (a)
          t = a, r = 0, i = sf(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = i = 0;
        }
      }
    }
  s && Gg(n, s, o);
}
function vk(n) {
  let e = n.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function eY(n, e) {
  for (; n && e == n.childNodes.length && !Yc(n); )
    e = On(n) + 1, n = n.parentNode;
  for (; n && e < n.childNodes.length; ) {
    let t = n.childNodes[e];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = 0;
  }
}
function tY(n, e) {
  for (; n && !e && !Yc(n); )
    e = On(n), n = n.parentNode;
  for (; n && e; ) {
    let t = n.childNodes[e - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = n.childNodes.length;
  }
}
function Gg(n, e, t) {
  if (e.nodeType != 3) {
    let s, o;
    (o = eY(e, t)) ? (e = o, t = 0) : (s = tY(e, t)) && (e = s, t = s.nodeValue.length);
  }
  let r = n.domSelection();
  if (!r)
    return;
  if (rh(r)) {
    let s = document.createRange();
    s.setEnd(e, t), s.setStart(e, t), r.removeAllRanges(), r.addRange(s);
  } else r.extend && r.extend(e, t);
  n.domObserver.setCurSelection();
  let { state: i } = n;
  setTimeout(() => {
    n.state == i && is(n);
  }, 50);
}
function XE(n, e) {
  let t = n.state.doc.resolve(e);
  if (!(vn || rk) && t.parent.inlineContent) {
    let i = n.coordsAtPos(e);
    if (e > t.start()) {
      let s = n.coordsAtPos(e - 1), o = (s.top + s.bottom) / 2;
      if (o > i.top && o < i.bottom && Math.abs(s.left - i.left) > 1)
        return s.left < i.left ? "ltr" : "rtl";
    }
    if (e < t.end()) {
      let s = n.coordsAtPos(e + 1), o = (s.top + s.bottom) / 2;
      if (o > i.top && o < i.bottom && Math.abs(s.left - i.left) > 1)
        return s.left > i.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(n.dom).direction == "rtl" ? "rtl" : "ltr";
}
function eA(n, e, t) {
  let r = n.state.selection;
  if (r instanceof Ve && !r.empty || t.indexOf("s") > -1 || Gr && t.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: s } = r;
  if (!i.parent.inlineContent || n.endOfTextblock(e < 0 ? "up" : "down")) {
    let o = $g(n.state, e);
    if (o && o instanceof Me)
      return Os(n, o);
  }
  if (!i.parent.inlineContent) {
    let o = e < 0 ? i : s, a = r instanceof kr ? Xe.near(o, e) : Xe.findFrom(o, e);
    return a ? Os(n, a) : !1;
  }
  return !1;
}
function tA(n, e) {
  if (!(n.state.selection instanceof Ve))
    return !0;
  let { $head: t, $anchor: r, empty: i } = n.state.selection;
  if (!t.sameParent(r))
    return !0;
  if (!i)
    return !1;
  if (n.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let s = !t.textOffset && (e < 0 ? t.nodeBefore : t.nodeAfter);
  if (s && !s.isText) {
    let o = n.state.tr;
    return e < 0 ? o.delete(t.pos - s.nodeSize, t.pos) : o.delete(t.pos, t.pos + s.nodeSize), n.dispatch(o), !0;
  }
  return !1;
}
function nA(n, e, t) {
  n.domObserver.stop(), e.contentEditable = t, n.domObserver.start();
}
function nY(n) {
  if (!Pn || n.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (e && e.nodeType == 1 && t == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    nA(n, r, "true"), setTimeout(() => nA(n, r, "false"), 20);
  }
  return !1;
}
function rY(n) {
  let e = "";
  return n.ctrlKey && (e += "c"), n.metaKey && (e += "m"), n.altKey && (e += "a"), n.shiftKey && (e += "s"), e;
}
function iY(n, e) {
  let t = e.keyCode, r = rY(e);
  if (t == 8 || Gr && t == 72 && r == "c")
    return tA(n, -1) || Sa(n, -1);
  if (t == 46 && !e.shiftKey || Gr && t == 68 && r == "c")
    return tA(n, 1) || Sa(n, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || Gr && t == 66 && r == "c") {
    let i = t == 37 ? XE(n, n.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return ZE(n, i, r) || Sa(n, i);
  } else if (t == 39 || Gr && t == 70 && r == "c") {
    let i = t == 39 ? XE(n, n.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return ZE(n, i, r) || Sa(n, i);
  } else {
    if (t == 38 || Gr && t == 80 && r == "c")
      return eA(n, -1, r) || Sa(n, -1);
    if (t == 40 || Gr && t == 78 && r == "c")
      return nY(n) || eA(n, 1, r) || Sa(n, 1);
    if (r == (Gr ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function Pv(n, e) {
  n.someProp("transformCopied", (g) => {
    e = g(e, n);
  });
  let t = [], { content: r, openStart: i, openEnd: s } = e;
  for (; i > 1 && s > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    i--, s--;
    let g = r.firstChild;
    t.push(g.type.name, g.attrs != g.type.defaultAttrs ? g.attrs : null), r = g.content;
  }
  let o = n.someProp("clipboardSerializer") || Xo.fromSchema(n.state.schema), a = Ak(), c = a.createElement("div");
  c.appendChild(o.serializeFragment(r, { document: a }));
  let u = c.firstChild, d, h = 0;
  for (; u && u.nodeType == 1 && (d = Ek[u.nodeName.toLowerCase()]); ) {
    for (let g = d.length - 1; g >= 0; g--) {
      let y = a.createElement(d[g]);
      for (; c.firstChild; )
        y.appendChild(c.firstChild);
      c.appendChild(y), h++;
    }
    u = c.firstChild;
  }
  u && u.nodeType == 1 && u.setAttribute("data-pm-slice", `${i} ${s}${h ? ` -${h}` : ""} ${JSON.stringify(t)}`);
  let p = n.someProp("clipboardTextSerializer", (g) => g(e, n)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: c, text: p, slice: e };
}
function bk(n, e, t, r, i) {
  let s = i.parent.type.spec.code, o, a;
  if (!t && !e)
    return null;
  let c = !!e && (r || s || !t);
  if (c) {
    if (n.someProp("transformPastedText", (p) => {
      e = p(e, s || r, n);
    }), s)
      return a = new Se(ce.from(n.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0), n.someProp("transformPasted", (p) => {
        a = p(a, n, !0);
      }), a;
    let h = n.someProp("clipboardTextParser", (p) => p(e, i, r, n));
    if (h)
      a = h;
    else {
      let p = i.marks(), { schema: g } = n.state, y = Xo.fromSchema(g);
      o = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((b) => {
        let S = o.appendChild(document.createElement("p"));
        b && S.appendChild(y.serializeNode(g.text(b, p)));
      });
    }
  } else
    n.someProp("transformPastedHTML", (h) => {
      t = h(t, n);
    }), o = lY(t), qc && cY(o);
  let u = o && o.querySelector("[data-pm-slice]"), d = u && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(u.getAttribute("data-pm-slice") || "");
  if (d && d[3])
    for (let h = +d[3]; h > 0; h--) {
      let p = o.firstChild;
      for (; p && p.nodeType != 1; )
        p = p.nextSibling;
      if (!p)
        break;
      o = p;
    }
  if (a || (a = (n.someProp("clipboardParser") || n.someProp("domParser") || nc.fromSchema(n.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(c || d),
    context: i,
    ruleFromNode(p) {
      return p.nodeName == "BR" && !p.nextSibling && p.parentNode && !sY.test(p.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), d)
    a = uY(rA(a, +d[1], +d[2]), d[4]);
  else if (a = Se.maxOpen(oY(a.content, i), !0), a.openStart || a.openEnd) {
    let h = 0, p = 0;
    for (let g = a.content.firstChild; h < a.openStart && !g.type.spec.isolating; h++, g = g.firstChild)
      ;
    for (let g = a.content.lastChild; p < a.openEnd && !g.type.spec.isolating; p++, g = g.lastChild)
      ;
    a = rA(a, h, p);
  }
  return n.someProp("transformPasted", (h) => {
    a = h(a, n, c);
  }), a;
}
const sY = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function oY(n, e) {
  if (n.childCount < 2)
    return n;
  for (let t = e.depth; t >= 0; t--) {
    let i = e.node(t).contentMatchAt(e.index(t)), s, o = [];
    if (n.forEach((a) => {
      if (!o)
        return;
      let c = i.findWrapping(a.type), u;
      if (!c)
        return o = null;
      if (u = o.length && s.length && Sk(c, s, a, o[o.length - 1], 0))
        o[o.length - 1] = u;
      else {
        o.length && (o[o.length - 1] = wk(o[o.length - 1], s.length));
        let d = xk(a, c);
        o.push(d), i = i.matchType(d.type), s = c;
      }
    }), o)
      return ce.from(o);
  }
  return n;
}
function xk(n, e, t = 0) {
  for (let r = e.length - 1; r >= t; r--)
    n = e[r].create(null, ce.from(n));
  return n;
}
function Sk(n, e, t, r, i) {
  if (i < n.length && i < e.length && n[i] == e[i]) {
    let s = Sk(n, e, t, r.lastChild, i + 1);
    if (s)
      return r.copy(r.content.replaceChild(r.childCount - 1, s));
    if (r.contentMatchAt(r.childCount).matchType(i == n.length - 1 ? t.type : n[i + 1]))
      return r.copy(r.content.append(ce.from(xk(t, n, i + 1))));
  }
}
function wk(n, e) {
  if (e == 0)
    return n;
  let t = n.content.replaceChild(n.childCount - 1, wk(n.lastChild, e - 1)), r = n.contentMatchAt(n.childCount).fillBefore(ce.empty, !0);
  return n.copy(t.append(r));
}
function Yg(n, e, t, r, i, s) {
  let o = e < 0 ? n.firstChild : n.lastChild, a = o.content;
  return n.childCount > 1 && (s = 0), i < r - 1 && (a = Yg(a, e, t, r, i + 1, s)), i >= t && (a = e < 0 ? o.contentMatchAt(0).fillBefore(a, s <= i).append(a) : a.append(o.contentMatchAt(o.childCount).fillBefore(ce.empty, !0))), n.replaceChild(e < 0 ? 0 : n.childCount - 1, o.copy(a));
}
function rA(n, e, t) {
  return e < n.openStart && (n = new Se(Yg(n.content, -1, e, n.openStart, 0, n.openEnd), e, n.openEnd)), t < n.openEnd && (n = new Se(Yg(n.content, 1, t, n.openEnd, 0, 0), n.openStart, t)), n;
}
const Ek = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let iA = null;
function Ak() {
  return iA || (iA = document.implementation.createHTMLDocument("title"));
}
let bm = null;
function aY(n) {
  let e = window.trustedTypes;
  return e ? (bm || (bm = e.defaultPolicy || e.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), bm.createHTML(n)) : n;
}
function lY(n) {
  let e = /^(\s*<meta [^>]*>)*/.exec(n);
  e && (n = n.slice(e[0].length));
  let t = Ak().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(n), i;
  if ((i = r && Ek[r[1].toLowerCase()]) && (n = i.map((s) => "<" + s + ">").join("") + n + i.map((s) => "</" + s + ">").reverse().join("")), t.innerHTML = aY(n), i)
    for (let s = 0; s < i.length; s++)
      t = t.querySelector(i[s]) || t;
  return t;
}
function cY(n) {
  let e = n.querySelectorAll(vn ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < e.length; t++) {
    let r = e[t];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(n.ownerDocument.createTextNode(" "), r);
  }
}
function uY(n, e) {
  if (!n.size)
    return n;
  let t = n.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return n;
  }
  let { content: i, openStart: s, openEnd: o } = n;
  for (let a = r.length - 2; a >= 0; a -= 2) {
    let c = t.nodes[r[a]];
    if (!c || c.hasRequiredAttrs())
      break;
    i = ce.from(c.create(r[a + 1], i)), s++, o++;
  }
  return new Se(i, s, o);
}
const tr = {}, nr = {}, dY = { touchstart: !0, touchmove: !0 };
class fY {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.badSafariComposition = !1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function hY(n) {
  for (let e in tr) {
    let t = tr[e];
    n.dom.addEventListener(e, n.input.eventHandlers[e] = (r) => {
      mY(n, r) && !Lv(n, r) && (n.editable || !(r.type in nr)) && t(n, r);
    }, dY[e] ? { passive: !0 } : void 0);
  }
  Pn && n.dom.addEventListener("input", () => null), qg(n);
}
function Us(n, e) {
  n.input.lastSelectionOrigin = e, n.input.lastSelectionTime = Date.now();
}
function pY(n) {
  n.domObserver.stop();
  for (let e in n.input.eventHandlers)
    n.dom.removeEventListener(e, n.input.eventHandlers[e]);
  clearTimeout(n.input.composingTimeout), clearTimeout(n.input.lastIOSEnterFallbackTimeout);
}
function qg(n) {
  n.someProp("handleDOMEvents", (e) => {
    for (let t in e)
      n.input.eventHandlers[t] || n.dom.addEventListener(t, n.input.eventHandlers[t] = (r) => Lv(n, r));
  });
}
function Lv(n, e) {
  return n.someProp("handleDOMEvents", (t) => {
    let r = t[e.type];
    return r ? r(n, e) || e.defaultPrevented : !1;
  });
}
function mY(n, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target; t != n.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function gY(n, e) {
  !Lv(n, e) && tr[e.type] && (n.editable || !(e.type in nr)) && tr[e.type](n, e);
}
nr.keydown = (n, e) => {
  let t = e;
  if (n.input.shiftKey = t.keyCode == 16 || t.shiftKey, !Ck(n, t) && (n.input.lastKeyCode = t.keyCode, n.input.lastKeyCodeTime = Date.now(), !(ts && vn && t.keyCode == 13)))
    if (t.keyCode != 229 && n.domObserver.forceFlush(), Xa && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let r = Date.now();
      n.input.lastIOSEnter = r, n.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        n.input.lastIOSEnter == r && (n.someProp("handleKeyDown", (i) => i(n, Do(13, "Enter"))), n.input.lastIOSEnter = 0);
      }, 200);
    } else n.someProp("handleKeyDown", (r) => r(n, t)) || iY(n, t) ? t.preventDefault() : Us(n, "key");
};
nr.keyup = (n, e) => {
  e.keyCode == 16 && (n.input.shiftKey = !1);
};
nr.keypress = (n, e) => {
  let t = e;
  if (Ck(n, t) || !t.charCode || t.ctrlKey && !t.altKey || Gr && t.metaKey)
    return;
  if (n.someProp("handleKeyPress", (i) => i(n, t))) {
    t.preventDefault();
    return;
  }
  let r = n.state.selection;
  if (!(r instanceof Ve) || !r.$from.sameParent(r.$to)) {
    let i = String.fromCharCode(t.charCode), s = () => n.state.tr.insertText(i).scrollIntoView();
    !/[\r\n]/.test(i) && !n.someProp("handleTextInput", (o) => o(n, r.$from.pos, r.$to.pos, i, s)) && n.dispatch(s()), t.preventDefault();
  }
};
function sh(n) {
  return { left: n.clientX, top: n.clientY };
}
function yY(n, e) {
  let t = e.x - n.clientX, r = e.y - n.clientY;
  return t * t + r * r < 100;
}
function Bv(n, e, t, r, i) {
  if (r == -1)
    return !1;
  let s = n.state.doc.resolve(r);
  for (let o = s.depth + 1; o > 0; o--)
    if (n.someProp(e, (a) => o > s.depth ? a(n, t, s.nodeAfter, s.before(o), i, !0) : a(n, t, s.node(o), s.before(o), i, !1)))
      return !0;
  return !1;
}
function $a(n, e, t) {
  if (n.focused || n.focus(), n.state.selection.eq(e))
    return;
  let r = n.state.tr.setSelection(e);
  r.setMeta("pointer", !0), n.dispatch(r);
}
function vY(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.doc.resolve(e), r = t.nodeAfter;
  return r && r.isAtom && Me.isSelectable(r) ? ($a(n, new Me(t)), !0) : !1;
}
function bY(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.selection, r, i;
  t instanceof Me && (r = t.node);
  let s = n.state.doc.resolve(e);
  for (let o = s.depth + 1; o > 0; o--) {
    let a = o > s.depth ? s.nodeAfter : s.node(o);
    if (Me.isSelectable(a)) {
      r && t.$from.depth > 0 && o >= t.$from.depth && s.before(t.$from.depth + 1) == t.$from.pos ? i = s.before(t.$from.depth) : i = s.before(o);
      break;
    }
  }
  return i != null ? ($a(n, Me.create(n.state.doc, i)), !0) : !1;
}
function xY(n, e, t, r, i) {
  return Bv(n, "handleClickOn", e, t, r) || n.someProp("handleClick", (s) => s(n, e, r)) || (i ? bY(n, t) : vY(n, t));
}
function SY(n, e, t, r) {
  return Bv(n, "handleDoubleClickOn", e, t, r) || n.someProp("handleDoubleClick", (i) => i(n, e, r));
}
function wY(n, e, t, r) {
  return Bv(n, "handleTripleClickOn", e, t, r) || n.someProp("handleTripleClick", (i) => i(n, e, r)) || EY(n, t, r);
}
function EY(n, e, t) {
  if (t.button != 0)
    return !1;
  let r = n.state.doc;
  if (e == -1)
    return r.inlineContent ? ($a(n, Ve.create(r, 0, r.content.size)), !0) : !1;
  let i = r.resolve(e);
  for (let s = i.depth + 1; s > 0; s--) {
    let o = s > i.depth ? i.nodeAfter : i.node(s), a = i.before(s);
    if (o.inlineContent)
      $a(n, Ve.create(r, a + 1, a + 1 + o.content.size));
    else if (Me.isSelectable(o))
      $a(n, Me.create(r, a));
    else
      continue;
    return !0;
  }
}
function jv(n) {
  return of(n);
}
const Tk = Gr ? "metaKey" : "ctrlKey";
tr.mousedown = (n, e) => {
  let t = e;
  n.input.shiftKey = t.shiftKey;
  let r = jv(n), i = Date.now(), s = "singleClick";
  i - n.input.lastClick.time < 500 && yY(t, n.input.lastClick) && !t[Tk] && n.input.lastClick.button == t.button && (n.input.lastClick.type == "singleClick" ? s = "doubleClick" : n.input.lastClick.type == "doubleClick" && (s = "tripleClick")), n.input.lastClick = { time: i, x: t.clientX, y: t.clientY, type: s, button: t.button };
  let o = n.posAtCoords(sh(t));
  o && (s == "singleClick" ? (n.input.mouseDown && n.input.mouseDown.done(), n.input.mouseDown = new AY(n, o, t, !!r)) : (s == "doubleClick" ? SY : wY)(n, o.pos, o.inside, t) ? t.preventDefault() : Us(n, "pointer"));
};
class AY {
  constructor(e, t, r, i) {
    this.view = e, this.pos = t, this.event = r, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[Tk], this.allowDefault = r.shiftKey;
    let s, o;
    if (t.inside > -1)
      s = e.state.doc.nodeAt(t.inside), o = t.inside;
    else {
      let d = e.state.doc.resolve(t.pos);
      s = d.parent, o = d.depth ? d.before() : 0;
    }
    const a = i ? null : r.target, c = a ? e.docView.nearestDesc(a, !0) : null;
    this.target = c && c.nodeDOM.nodeType == 1 ? c.nodeDOM : null;
    let { selection: u } = e.state;
    (r.button == 0 && s.type.spec.draggable && s.type.spec.selectable !== !1 || u instanceof Me && u.from <= o && u.to > o) && (this.mightDrag = {
      node: s,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Qr && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), Us(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => is(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(sh(e))), this.updateAllowDefault(e), this.allowDefault || !t ? Us(this.view, "pointer") : xY(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Pn && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    vn && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? ($a(this.view, Xe.near(this.view.state.doc.resolve(t.pos))), e.preventDefault()) : Us(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), Us(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
tr.touchstart = (n) => {
  n.input.lastTouch = Date.now(), jv(n), Us(n, "pointer");
};
tr.touchmove = (n) => {
  n.input.lastTouch = Date.now(), Us(n, "pointer");
};
tr.contextmenu = (n) => jv(n);
function Ck(n, e) {
  return n.composing ? !0 : Pn && Math.abs(e.timeStamp - n.input.compositionEndedAt) < 500 ? (n.input.compositionEndedAt = -2e8, !0) : !1;
}
const TY = ts ? 5e3 : -1;
nr.compositionstart = nr.compositionupdate = (n) => {
  if (!n.composing) {
    n.domObserver.flush();
    let { state: e } = n, t = e.selection.$to;
    if (e.selection instanceof Ve && (e.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1) || vn && rk && CY(n)))
      n.markCursor = n.state.storedMarks || t.marks(), of(n, !0), n.markCursor = null;
    else if (of(n, !e.selection.empty), Qr && e.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let r = n.domSelectionRange();
      for (let i = r.focusNode, s = r.focusOffset; i && i.nodeType == 1 && s != 0; ) {
        let o = s < 0 ? i.lastChild : i.childNodes[s - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          let a = n.domSelection();
          a && a.collapse(o, o.nodeValue.length);
          break;
        } else
          i = o, s = -1;
      }
    }
    n.input.composing = !0;
  }
  Dk(n, TY);
};
function CY(n) {
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (!e || e.nodeType != 1 || t >= e.childNodes.length)
    return !1;
  let r = e.childNodes[t];
  return r.nodeType == 1 && r.contentEditable == "false";
}
nr.compositionend = (n, e) => {
  n.composing && (n.input.composing = !1, n.input.compositionEndedAt = e.timeStamp, n.input.compositionPendingChanges = n.domObserver.pendingRecords().length ? n.input.compositionID : 0, n.input.compositionNode = null, n.input.badSafariComposition ? n.domObserver.forceFlush() : n.input.compositionPendingChanges && Promise.resolve().then(() => n.domObserver.flush()), n.input.compositionID++, Dk(n, 20));
};
function Dk(n, e) {
  clearTimeout(n.input.composingTimeout), e > -1 && (n.input.composingTimeout = setTimeout(() => of(n), e));
}
function Rk(n) {
  for (n.composing && (n.input.composing = !1, n.input.compositionEndedAt = RY()); n.input.compositionNodes.length > 0; )
    n.input.compositionNodes.pop().markParentsDirty();
}
function DY(n) {
  let e = n.domSelectionRange();
  if (!e.focusNode)
    return null;
  let t = bG(e.focusNode, e.focusOffset), r = xG(e.focusNode, e.focusOffset);
  if (t && r && t != r) {
    let i = r.pmViewDesc, s = n.domObserver.lastChangedTextNode;
    if (t == s || r == s)
      return s;
    if (!i || !i.isText(r.nodeValue))
      return r;
    if (n.input.compositionNode == r) {
      let o = t.pmViewDesc;
      if (!(!o || !o.isText(t.nodeValue)))
        return r;
    }
  }
  return t || r;
}
function RY() {
  let n = document.createEvent("Event");
  return n.initEvent("event", !0, !0), n.timeStamp;
}
function of(n, e = !1) {
  if (!(ts && n.domObserver.flushingSoon >= 0)) {
    if (n.domObserver.forceFlush(), Rk(n), e || n.docView && n.docView.dirty) {
      let t = Iv(n), r = n.state.selection;
      return t && !t.eq(r) ? n.dispatch(n.state.tr.setSelection(t)) : (n.markCursor || e) && !r.$from.node(r.$from.sharedDepth(r.to)).inlineContent ? n.dispatch(n.state.tr.deleteSelection()) : n.updateState(n.state), !0;
    }
    return !1;
  }
}
function kY(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(e), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), i = document.createRange();
  i.selectNodeContents(e), n.dom.blur(), r.removeAllRanges(), r.addRange(i), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), n.focus();
  }, 50);
}
const Rc = mr && Ys < 15 || Xa && AG < 604;
tr.copy = nr.cut = (n, e) => {
  let t = e, r = n.state.selection, i = t.type == "cut";
  if (r.empty)
    return;
  let s = Rc ? null : t.clipboardData, o = r.content(), { dom: a, text: c } = Pv(n, o);
  s ? (t.preventDefault(), s.clearData(), s.setData("text/html", a.innerHTML), s.setData("text/plain", c)) : kY(n, a), i && n.dispatch(n.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function MY(n) {
  return n.openStart == 0 && n.openEnd == 0 && n.content.childCount == 1 ? n.content.firstChild : null;
}
function _Y(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.input.shiftKey || n.state.selection.$from.parent.type.spec.code, r = n.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let i = n.input.shiftKey && n.input.lastKeyCode != 45;
  setTimeout(() => {
    n.focus(), r.parentNode && r.parentNode.removeChild(r), t ? kc(n, r.value, null, i, e) : kc(n, r.textContent, r.innerHTML, i, e);
  }, 50);
}
function kc(n, e, t, r, i) {
  let s = bk(n, e, t, r, n.state.selection.$from);
  if (n.someProp("handlePaste", (c) => c(n, i, s || Se.empty)))
    return !0;
  if (!s)
    return !1;
  let o = MY(s), a = o ? n.state.tr.replaceSelectionWith(o, r) : n.state.tr.replaceSelection(s);
  return n.dispatch(a.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function kk(n) {
  let e = n.getData("text/plain") || n.getData("Text");
  if (e)
    return e;
  let t = n.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
nr.paste = (n, e) => {
  let t = e;
  if (n.composing && !ts)
    return;
  let r = Rc ? null : t.clipboardData, i = n.input.shiftKey && n.input.lastKeyCode != 45;
  r && kc(n, kk(r), r.getData("text/html"), i, t) ? t.preventDefault() : _Y(n, t);
};
class Mk {
  constructor(e, t, r) {
    this.slice = e, this.move = t, this.node = r;
  }
}
const OY = Gr ? "altKey" : "ctrlKey";
function _k(n, e) {
  let t = n.someProp("dragCopies", (r) => !r(e));
  return t ?? !e[OY];
}
tr.dragstart = (n, e) => {
  let t = e, r = n.input.mouseDown;
  if (r && r.done(), !t.dataTransfer)
    return;
  let i = n.state.selection, s = i.empty ? null : n.posAtCoords(sh(t)), o;
  if (!(s && s.pos >= i.from && s.pos <= (i instanceof Me ? i.to - 1 : i.to))) {
    if (r && r.mightDrag)
      o = Me.create(n.state.doc, r.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let h = n.docView.nearestDesc(t.target, !0);
      h && h.node.type.spec.draggable && h != n.docView && (o = Me.create(n.state.doc, h.posBefore));
    }
  }
  let a = (o || n.state.selection).content(), { dom: c, text: u, slice: d } = Pv(n, a);
  (!t.dataTransfer.files.length || !vn || nk > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(Rc ? "Text" : "text/html", c.innerHTML), t.dataTransfer.effectAllowed = "copyMove", Rc || t.dataTransfer.setData("text/plain", u), n.dragging = new Mk(d, _k(n, t), o);
};
tr.dragend = (n) => {
  let e = n.dragging;
  window.setTimeout(() => {
    n.dragging == e && (n.dragging = null);
  }, 50);
};
nr.dragover = nr.dragenter = (n, e) => e.preventDefault();
nr.drop = (n, e) => {
  try {
    IY(n, e, n.dragging);
  } finally {
    n.dragging = null;
  }
};
function IY(n, e, t) {
  if (!e.dataTransfer)
    return;
  let r = n.posAtCoords(sh(e));
  if (!r)
    return;
  let i = n.state.doc.resolve(r.pos), s = t && t.slice;
  s ? n.someProp("transformPasted", (g) => {
    s = g(s, n, !1);
  }) : s = bk(n, kk(e.dataTransfer), Rc ? null : e.dataTransfer.getData("text/html"), !1, i);
  let o = !!(t && _k(n, e));
  if (n.someProp("handleDrop", (g) => g(n, e, s || Se.empty, o))) {
    e.preventDefault();
    return;
  }
  if (!s)
    return;
  e.preventDefault();
  let a = s ? YR(n.state.doc, i.pos, s) : i.pos;
  a == null && (a = i.pos);
  let c = n.state.tr;
  if (o) {
    let { node: g } = t;
    g ? g.replace(c) : c.deleteSelection();
  }
  let u = c.mapping.map(a), d = s.openStart == 0 && s.openEnd == 0 && s.content.childCount == 1, h = c.doc;
  if (d ? c.replaceRangeWith(u, u, s.content.firstChild) : c.replaceRange(u, u, s), c.doc.eq(h))
    return;
  let p = c.doc.resolve(u);
  if (d && Me.isSelectable(s.content.firstChild) && p.nodeAfter && p.nodeAfter.sameMarkup(s.content.firstChild))
    c.setSelection(new Me(p));
  else {
    let g = c.mapping.map(a);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((y, b, S, w) => g = w), c.setSelection(Nv(n, p, c.doc.resolve(g)));
  }
  n.focus(), n.dispatch(c.setMeta("uiEvent", "drop"));
}
tr.focus = (n) => {
  n.input.lastFocus = Date.now(), n.focused || (n.domObserver.stop(), n.dom.classList.add("ProseMirror-focused"), n.domObserver.start(), n.focused = !0, setTimeout(() => {
    n.docView && n.hasFocus() && !n.domObserver.currentSelection.eq(n.domSelectionRange()) && is(n);
  }, 20));
};
tr.blur = (n, e) => {
  let t = e;
  n.focused && (n.domObserver.stop(), n.dom.classList.remove("ProseMirror-focused"), n.domObserver.start(), t.relatedTarget && n.dom.contains(t.relatedTarget) && n.domObserver.currentSelection.clear(), n.focused = !1);
};
tr.beforeinput = (n, e) => {
  if (vn && ts && e.inputType == "deleteContentBackward") {
    n.domObserver.flushSoon();
    let { domChangeCount: r } = n.input;
    setTimeout(() => {
      if (n.input.domChangeCount != r || (n.dom.blur(), n.focus(), n.someProp("handleKeyDown", (s) => s(n, Do(8, "Backspace")))))
        return;
      let { $cursor: i } = n.state.selection;
      i && i.pos > 0 && n.dispatch(n.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let n in nr)
  tr[n] = nr[n];
function Mc(n, e) {
  if (n == e)
    return !0;
  for (let t in n)
    if (n[t] !== e[t])
      return !1;
  for (let t in e)
    if (!(t in n))
      return !1;
  return !0;
}
class af {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || Fo, this.side = this.spec.side || 0;
  }
  map(e, t, r, i) {
    let { pos: s, deleted: o } = e.mapResult(t.from + i, this.side < 0 ? -1 : 1);
    return o ? null : new Dr(s - r, s - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof af && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && Mc(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class Ks {
  constructor(e, t) {
    this.attrs = e, this.spec = t || Fo;
  }
  map(e, t, r, i) {
    let s = e.map(t.from + i, this.spec.inclusiveStart ? -1 : 1) - r, o = e.map(t.to + i, this.spec.inclusiveEnd ? 1 : -1) - r;
    return s >= o ? null : new Dr(s, o, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof Ks && Mc(this.attrs, e.attrs) && Mc(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof Ks;
  }
  destroy() {
  }
}
class Fv {
  constructor(e, t) {
    this.attrs = e, this.spec = t || Fo;
  }
  map(e, t, r, i) {
    let s = e.mapResult(t.from + i, 1);
    if (s.deleted)
      return null;
    let o = e.mapResult(t.to + i, -1);
    return o.deleted || o.pos <= s.pos ? null : new Dr(s.pos - r, o.pos - r, this);
  }
  valid(e, t) {
    let { index: r, offset: i } = e.content.findIndex(t.from), s;
    return i == t.from && !(s = e.child(r)).isText && i + s.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof Fv && Mc(this.attrs, e.attrs) && Mc(this.spec, e.spec);
  }
  destroy() {
  }
}
class Dr {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.from = e, this.to = t, this.type = r;
  }
  /**
  @internal
  */
  copy(e, t) {
    return new Dr(e, t, this.type);
  }
  /**
  @internal
  */
  eq(e, t = 0) {
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  /**
  @internal
  */
  map(e, t, r) {
    return this.type.map(e, this, t, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, t, r) {
    return new Dr(e, e, new af(t, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, t, r, i) {
    return new Dr(e, t, new Ks(r, i));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, t, r, i) {
    return new Dr(e, t, new Fv(r, i));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Ks;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof af;
  }
}
const Ma = [], Fo = {};
class sn {
  /**
  @internal
  */
  constructor(e, t) {
    this.local = e.length ? e : Ma, this.children = t.length ? t : Ma;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, t) {
    return t.length ? lf(t, e, 0, Fo) : Hn;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, t, r) {
    let i = [];
    return this.findInner(e ?? 0, t ?? 1e9, i, 0, r), i;
  }
  findInner(e, t, r, i, s) {
    for (let o = 0; o < this.local.length; o++) {
      let a = this.local[o];
      a.from <= t && a.to >= e && (!s || s(a.spec)) && r.push(a.copy(a.from + i, a.to + i));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < t && this.children[o + 1] > e) {
        let a = this.children[o] + 1;
        this.children[o + 2].findInner(e - a, t - a, r, i + a, s);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, t, r) {
    return this == Hn || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, r || Fo);
  }
  /**
  @internal
  */
  mapInner(e, t, r, i, s) {
    let o;
    for (let a = 0; a < this.local.length; a++) {
      let c = this.local[a].map(e, r, i);
      c && c.type.valid(t, c) ? (o || (o = [])).push(c) : s.onRemove && s.onRemove(this.local[a].spec);
    }
    return this.children.length ? NY(this.children, o || [], e, t, r, i, s) : o ? new sn(o.sort(zo), Ma) : Hn;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, t) {
    return t.length ? this == Hn ? sn.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, r) {
    let i, s = 0;
    e.forEach((a, c) => {
      let u = c + r, d;
      if (d = Ik(t, a, u)) {
        for (i || (i = this.children.slice()); s < i.length && i[s] < c; )
          s += 3;
        i[s] == c ? i[s + 2] = i[s + 2].addInner(a, d, u + 1) : i.splice(s, 0, c, c + a.nodeSize, lf(d, a, u + 1, Fo)), s += 3;
      }
    });
    let o = Ok(s ? Nk(t) : t, -r);
    for (let a = 0; a < o.length; a++)
      o[a].type.valid(e, o[a]) || o.splice(a--, 1);
    return new sn(o.length ? this.local.concat(o).sort(zo) : this.local, i || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == Hn ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let r = this.children, i = this.local;
    for (let s = 0; s < r.length; s += 3) {
      let o, a = r[s] + t, c = r[s + 1] + t;
      for (let d = 0, h; d < e.length; d++)
        (h = e[d]) && h.from > a && h.to < c && (e[d] = null, (o || (o = [])).push(h));
      if (!o)
        continue;
      r == this.children && (r = this.children.slice());
      let u = r[s + 2].removeInner(o, a + 1);
      u != Hn ? r[s + 2] = u : (r.splice(s, 3), s -= 3);
    }
    if (i.length) {
      for (let s = 0, o; s < e.length; s++)
        if (o = e[s])
          for (let a = 0; a < i.length; a++)
            i[a].eq(o, t) && (i == this.local && (i = this.local.slice()), i.splice(a--, 1));
    }
    return r == this.children && i == this.local ? this : i.length || r.length ? new sn(i, r) : Hn;
  }
  forChild(e, t) {
    if (this == Hn)
      return this;
    if (t.isLeaf)
      return sn.empty;
    let r, i;
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] >= e) {
        this.children[a] == e && (r = this.children[a + 2]);
        break;
      }
    let s = e + 1, o = s + t.content.size;
    for (let a = 0; a < this.local.length; a++) {
      let c = this.local[a];
      if (c.from < o && c.to > s && c.type instanceof Ks) {
        let u = Math.max(s, c.from) - s, d = Math.min(o, c.to) - s;
        u < d && (i || (i = [])).push(c.copy(u, d));
      }
    }
    if (i) {
      let a = new sn(i.sort(zo), Ma);
      return r ? new Ps([a, r]) : a;
    }
    return r || Hn;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof sn) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(e.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return zv(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == Hn)
      return Ma;
    if (e.inlineContent || !this.local.some(Ks.is))
      return this.local;
    let t = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof Ks || t.push(this.local[r]);
    return t;
  }
  forEachSet(e) {
    e(this);
  }
}
sn.empty = new sn([], []);
sn.removeOverlap = zv;
const Hn = sn.empty;
class Ps {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const r = this.members.map((i) => i.map(e, t, Fo));
    return Ps.from(r);
  }
  forChild(e, t) {
    if (t.isLeaf)
      return sn.empty;
    let r = [];
    for (let i = 0; i < this.members.length; i++) {
      let s = this.members[i].forChild(e, t);
      s != Hn && (s instanceof Ps ? r = r.concat(s.members) : r.push(s));
    }
    return Ps.from(r);
  }
  eq(e) {
    if (!(e instanceof Ps) || e.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(e.members[t]))
        return !1;
    return !0;
  }
  locals(e) {
    let t, r = !0;
    for (let i = 0; i < this.members.length; i++) {
      let s = this.members[i].localsInner(e);
      if (s.length)
        if (!t)
          t = s;
        else {
          r && (t = t.slice(), r = !1);
          for (let o = 0; o < s.length; o++)
            t.push(s[o]);
        }
    }
    return t ? zv(r ? t : t.sort(zo)) : Ma;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return Hn;
      case 1:
        return e[0];
      default:
        return new Ps(e.every((t) => t instanceof sn) ? e : e.reduce((t, r) => t.concat(r instanceof sn ? r : r.members), []));
    }
  }
  forEachSet(e) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(e);
  }
}
function NY(n, e, t, r, i, s, o) {
  let a = n.slice();
  for (let u = 0, d = s; u < t.maps.length; u++) {
    let h = 0;
    t.maps[u].forEach((p, g, y, b) => {
      let S = b - y - (g - p);
      for (let w = 0; w < a.length; w += 3) {
        let T = a[w + 1];
        if (T < 0 || p > T + d - h)
          continue;
        let C = a[w] + d - h;
        g >= C ? a[w + 1] = p <= C ? -2 : -1 : p >= d && S && (a[w] += S, a[w + 1] += S);
      }
      h += S;
    }), d = t.maps[u].map(d, -1);
  }
  let c = !1;
  for (let u = 0; u < a.length; u += 3)
    if (a[u + 1] < 0) {
      if (a[u + 1] == -2) {
        c = !0, a[u + 1] = -1;
        continue;
      }
      let d = t.map(n[u] + s), h = d - i;
      if (h < 0 || h >= r.content.size) {
        c = !0;
        continue;
      }
      let p = t.map(n[u + 1] + s, -1), g = p - i, { index: y, offset: b } = r.content.findIndex(h), S = r.maybeChild(y);
      if (S && b == h && b + S.nodeSize == g) {
        let w = a[u + 2].mapInner(t, S, d + 1, n[u] + s + 1, o);
        w != Hn ? (a[u] = h, a[u + 1] = g, a[u + 2] = w) : (a[u + 1] = -2, c = !0);
      } else
        c = !0;
    }
  if (c) {
    let u = PY(a, n, e, t, i, s, o), d = lf(u, r, 0, o);
    e = d.local;
    for (let h = 0; h < a.length; h += 3)
      a[h + 1] < 0 && (a.splice(h, 3), h -= 3);
    for (let h = 0, p = 0; h < d.children.length; h += 3) {
      let g = d.children[h];
      for (; p < a.length && a[p] < g; )
        p += 3;
      a.splice(p, 0, d.children[h], d.children[h + 1], d.children[h + 2]);
    }
  }
  return new sn(e.sort(zo), a);
}
function Ok(n, e) {
  if (!e || !n.length)
    return n;
  let t = [];
  for (let r = 0; r < n.length; r++) {
    let i = n[r];
    t.push(new Dr(i.from + e, i.to + e, i.type));
  }
  return t;
}
function PY(n, e, t, r, i, s, o) {
  function a(c, u) {
    for (let d = 0; d < c.local.length; d++) {
      let h = c.local[d].map(r, i, u);
      h ? t.push(h) : o.onRemove && o.onRemove(c.local[d].spec);
    }
    for (let d = 0; d < c.children.length; d += 3)
      a(c.children[d + 2], c.children[d] + u + 1);
  }
  for (let c = 0; c < n.length; c += 3)
    n[c + 1] == -1 && a(n[c + 2], e[c] + s + 1);
  return t;
}
function Ik(n, e, t) {
  if (e.isLeaf)
    return null;
  let r = t + e.nodeSize, i = null;
  for (let s = 0, o; s < n.length; s++)
    (o = n[s]) && o.from > t && o.to < r && ((i || (i = [])).push(o), n[s] = null);
  return i;
}
function Nk(n) {
  let e = [];
  for (let t = 0; t < n.length; t++)
    n[t] != null && e.push(n[t]);
  return e;
}
function lf(n, e, t, r) {
  let i = [], s = !1;
  e.forEach((a, c) => {
    let u = Ik(n, a, c + t);
    if (u) {
      s = !0;
      let d = lf(u, a, t + c + 1, r);
      d != Hn && i.push(c, c + a.nodeSize, d);
    }
  });
  let o = Ok(s ? Nk(n) : n, -t).sort(zo);
  for (let a = 0; a < o.length; a++)
    o[a].type.valid(e, o[a]) || (r.onRemove && r.onRemove(o[a].spec), o.splice(a--, 1));
  return o.length || i.length ? new sn(o, i) : Hn;
}
function zo(n, e) {
  return n.from - e.from || n.to - e.to;
}
function zv(n) {
  let e = n;
  for (let t = 0; t < e.length - 1; t++) {
    let r = e[t];
    if (r.from != r.to)
      for (let i = t + 1; i < e.length; i++) {
        let s = e[i];
        if (s.from == r.from) {
          s.to != r.to && (e == n && (e = n.slice()), e[i] = s.copy(s.from, r.to), sA(e, i + 1, s.copy(r.to, s.to)));
          continue;
        } else {
          s.from < r.to && (e == n && (e = n.slice()), e[t] = r.copy(r.from, s.from), sA(e, i, r.copy(s.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function sA(n, e, t) {
  for (; e < n.length && zo(t, n[e]) > 0; )
    e++;
  n.splice(e, 0, t);
}
function xm(n) {
  let e = [];
  return n.someProp("decorations", (t) => {
    let r = t(n.state);
    r && r != Hn && e.push(r);
  }), n.cursorWrapper && e.push(sn.create(n.state.doc, [n.cursorWrapper.deco])), Ps.from(e);
}
const LY = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, BY = mr && Ys <= 11;
class jY {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class FY {
  constructor(e, t) {
    this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new jY(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let i = 0; i < r.length; i++)
        this.queue.push(r[i]);
      mr && Ys <= 11 && r.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : Pn && e.composing && r.some((i) => i.type == "childList" && i.target.nodeName == "TR") ? (e.input.badSafariComposition = !0, this.flushSoon()) : this.flush();
    }), BY && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, LY)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let t = 0; t < e.length; t++)
          this.queue.push(e[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (QE(this.view)) {
      if (this.suppressingSelectionUpdates)
        return is(this.view);
      if (mr && Ys <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && Yo(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), r;
    for (let s = e.focusNode; s; s = Za(s))
      t.add(s);
    for (let s = e.anchorNode; s; s = Za(s))
      if (t.has(s)) {
        r = s;
        break;
      }
    let i = r && this.view.docView.nearestDesc(r);
    if (i && i.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let r = e.domSelectionRange(), i = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && QE(e) && !this.ignoreSelectionChange(r), s = -1, o = -1, a = !1, c = [];
    if (e.editable)
      for (let d = 0; d < t.length; d++) {
        let h = this.registerMutation(t[d], c);
        h && (s = s < 0 ? h.from : Math.min(h.from, s), o = o < 0 ? h.to : Math.max(h.to, o), h.typeOver && (a = !0));
      }
    if (Qr && c.length) {
      let d = c.filter((h) => h.nodeName == "BR");
      if (d.length == 2) {
        let [h, p] = d;
        h.parentNode && h.parentNode.parentNode == p.parentNode ? p.remove() : h.remove();
      } else {
        let { focusNode: h } = this.currentSelection;
        for (let p of d) {
          let g = p.parentNode;
          g && g.nodeName == "LI" && (!h || HY(e, h) != g) && p.remove();
        }
      }
    } else if ((vn || Pn) && c.some((d) => d.nodeName == "BR") && (e.input.lastKeyCode == 8 || e.input.lastKeyCode == 46)) {
      for (let d of c)
        if (d.nodeName == "BR" && d.parentNode) {
          let h = d.nextSibling;
          h && h.nodeType == 1 && h.contentEditable == "false" && d.parentNode.removeChild(d);
        }
    }
    let u = null;
    s < 0 && i && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && rh(r) && (u = Iv(e)) && u.eq(Xe.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, is(e), this.currentSelection.set(r), e.scrollToSelection()) : (s > -1 || i) && (s > -1 && (e.docView.markDirty(s, o), zY(e)), e.input.badSafariComposition && (e.input.badSafariComposition = !1, UY(e, c)), this.handleDOMChange(s, o, a, c), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(r) || is(e), this.currentSelection.set(r));
  }
  registerMutation(e, t) {
    if (t.indexOf(e.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let d = 0; d < e.addedNodes.length; d++) {
        let h = e.addedNodes[d];
        t.push(h), h.nodeType == 3 && (this.lastChangedTextNode = h);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
        return { from: r.posBefore, to: r.posAfter };
      let i = e.previousSibling, s = e.nextSibling;
      if (mr && Ys <= 11 && e.addedNodes.length)
        for (let d = 0; d < e.addedNodes.length; d++) {
          let { previousSibling: h, nextSibling: p } = e.addedNodes[d];
          (!h || Array.prototype.indexOf.call(e.addedNodes, h) < 0) && (i = h), (!p || Array.prototype.indexOf.call(e.addedNodes, p) < 0) && (s = p);
        }
      let o = i && i.parentNode == e.target ? On(i) + 1 : 0, a = r.localPosFromDOM(e.target, o, -1), c = s && s.parentNode == e.target ? On(s) : e.target.childNodes.length, u = r.localPosFromDOM(e.target, c, 1);
      return { from: a, to: u };
    } else return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = e.target, {
      from: r.posAtStart,
      to: r.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let oA = /* @__PURE__ */ new WeakMap(), aA = !1;
function zY(n) {
  if (!oA.has(n) && (oA.set(n, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(n.dom).whiteSpace) !== -1)) {
    if (n.requiresGeckoHackNode = Qr, aA)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), aA = !0;
  }
}
function lA(n, e) {
  let t = e.startContainer, r = e.startOffset, i = e.endContainer, s = e.endOffset, o = n.domAtPos(n.state.selection.anchor);
  return Yo(o.node, o.offset, i, s) && ([t, r, i, s] = [i, s, t, r]), { anchorNode: t, anchorOffset: r, focusNode: i, focusOffset: s };
}
function VY(n, e) {
  if (e.getComposedRanges) {
    let i = e.getComposedRanges(n.root)[0];
    if (i)
      return lA(n, i);
  }
  let t;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), t = i.getTargetRanges()[0];
  }
  return n.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), n.dom.removeEventListener("beforeinput", r, !0), t ? lA(n, t) : null;
}
function HY(n, e) {
  for (let t = e.parentNode; t && t != n.dom; t = t.parentNode) {
    let r = n.docView.nearestDesc(t, !0);
    if (r && r.node.isBlock)
      return t;
  }
  return null;
}
function UY(n, e) {
  var t;
  let { focusNode: r, focusOffset: i } = n.domSelectionRange();
  for (let s of e)
    if (((t = s.parentNode) === null || t === void 0 ? void 0 : t.nodeName) == "TR") {
      let o = s.nextSibling;
      for (; o && o.nodeName != "TD" && o.nodeName != "TH"; )
        o = o.nextSibling;
      if (o) {
        let a = o;
        for (; ; ) {
          let c = a.firstChild;
          if (!c || c.nodeType != 1 || c.contentEditable == "false" || /^(BR|IMG)$/.test(c.nodeName))
            break;
          a = c;
        }
        a.insertBefore(s, a.firstChild), r == s && n.domSelection().collapse(s, i);
      } else
        s.parentNode.removeChild(s);
    }
}
function WY(n, e, t) {
  let { node: r, fromOffset: i, toOffset: s, from: o, to: a } = n.docView.parseRange(e, t), c = n.domSelectionRange(), u, d = c.anchorNode;
  if (d && n.dom.contains(d.nodeType == 1 ? d : d.parentNode) && (u = [{ node: d, offset: c.anchorOffset }], rh(c) || u.push({ node: c.focusNode, offset: c.focusOffset })), vn && n.input.lastKeyCode === 8)
    for (let S = s; S > i; S--) {
      let w = r.childNodes[S - 1], T = w.pmViewDesc;
      if (w.nodeName == "BR" && !T) {
        s = S;
        break;
      }
      if (!T || T.size)
        break;
    }
  let h = n.state.doc, p = n.someProp("domParser") || nc.fromSchema(n.state.schema), g = h.resolve(o), y = null, b = p.parse(r, {
    topNode: g.parent,
    topMatch: g.parent.contentMatchAt(g.index()),
    topOpen: !0,
    from: i,
    to: s,
    preserveWhitespace: g.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: u,
    ruleFromNode: $Y,
    context: g
  });
  if (u && u[0].pos != null) {
    let S = u[0].pos, w = u[1] && u[1].pos;
    w == null && (w = S), y = { anchor: S + o, head: w + o };
  }
  return { doc: b, sel: y, from: o, to: a };
}
function $Y(n) {
  let e = n.pmViewDesc;
  if (e)
    return e.parseRule();
  if (n.nodeName == "BR" && n.parentNode) {
    if (Pn && /^(ul|ol)$/i.test(n.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (n.parentNode.lastChild == n || Pn && /^(tr|table)$/i.test(n.parentNode.nodeName))
      return { ignore: !0 };
  } else if (n.nodeName == "IMG" && n.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const GY = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function YY(n, e, t, r, i) {
  let s = n.input.compositionPendingChanges || (n.composing ? n.input.compositionID : 0);
  if (n.input.compositionPendingChanges = 0, e < 0) {
    let L = n.input.lastSelectionTime > Date.now() - 50 ? n.input.lastSelectionOrigin : null, j = Iv(n, L);
    if (j && !n.state.selection.eq(j)) {
      if (vn && ts && n.input.lastKeyCode === 13 && Date.now() - 100 < n.input.lastKeyCodeTime && n.someProp("handleKeyDown", (Z) => Z(n, Do(13, "Enter"))))
        return;
      let W = n.state.tr.setSelection(j);
      L == "pointer" ? W.setMeta("pointer", !0) : L == "key" && W.scrollIntoView(), s && W.setMeta("composition", s), n.dispatch(W);
    }
    return;
  }
  let o = n.state.doc.resolve(e), a = o.sharedDepth(t);
  e = o.before(a + 1), t = n.state.doc.resolve(t).after(a + 1);
  let c = n.state.selection, u = WY(n, e, t), d = n.state.doc, h = d.slice(u.from, u.to), p, g;
  n.input.lastKeyCode === 8 && Date.now() - 100 < n.input.lastKeyCodeTime ? (p = n.state.selection.to, g = "end") : (p = n.state.selection.from, g = "start"), n.input.lastKeyCode = null;
  let y = JY(h.content, u.doc.content, u.from, p, g);
  if (y && n.input.domChangeCount++, (Xa && n.input.lastIOSEnter > Date.now() - 225 || ts) && i.some((L) => L.nodeType == 1 && !GY.test(L.nodeName)) && (!y || y.endA >= y.endB) && n.someProp("handleKeyDown", (L) => L(n, Do(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (!y)
    if (r && c instanceof Ve && !c.empty && c.$head.sameParent(c.$anchor) && !n.composing && !(u.sel && u.sel.anchor != u.sel.head))
      y = { start: c.from, endA: c.to, endB: c.to };
    else {
      if (u.sel) {
        let L = cA(n, n.state.doc, u.sel);
        if (L && !L.eq(n.state.selection)) {
          let j = n.state.tr.setSelection(L);
          s && j.setMeta("composition", s), n.dispatch(j);
        }
      }
      return;
    }
  n.state.selection.from < n.state.selection.to && y.start == y.endB && n.state.selection instanceof Ve && (y.start > n.state.selection.from && y.start <= n.state.selection.from + 2 && n.state.selection.from >= u.from ? y.start = n.state.selection.from : y.endA < n.state.selection.to && y.endA >= n.state.selection.to - 2 && n.state.selection.to <= u.to && (y.endB += n.state.selection.to - y.endA, y.endA = n.state.selection.to)), mr && Ys <= 11 && y.endB == y.start + 1 && y.endA == y.start && y.start > u.from && u.doc.textBetween(y.start - u.from - 1, y.start - u.from + 1) == "  " && (y.start--, y.endA--, y.endB--);
  let b = u.doc.resolveNoCache(y.start - u.from), S = u.doc.resolveNoCache(y.endB - u.from), w = d.resolve(y.start), T = b.sameParent(S) && b.parent.inlineContent && w.end() >= y.endA;
  if ((Xa && n.input.lastIOSEnter > Date.now() - 225 && (!T || i.some((L) => L.nodeName == "DIV" || L.nodeName == "P")) || !T && b.pos < u.doc.content.size && (!b.sameParent(S) || !b.parent.inlineContent) && b.pos < S.pos && !/\S/.test(u.doc.textBetween(b.pos, S.pos, "", ""))) && n.someProp("handleKeyDown", (L) => L(n, Do(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (n.state.selection.anchor > y.start && KY(d, y.start, y.endA, b, S) && n.someProp("handleKeyDown", (L) => L(n, Do(8, "Backspace")))) {
    ts && vn && n.domObserver.suppressSelectionUpdates();
    return;
  }
  vn && y.endB == y.start && (n.input.lastChromeDelete = Date.now()), ts && !T && b.start() != S.start() && S.parentOffset == 0 && b.depth == S.depth && u.sel && u.sel.anchor == u.sel.head && u.sel.head == y.endA && (y.endB -= 2, S = u.doc.resolveNoCache(y.endB - u.from), setTimeout(() => {
    n.someProp("handleKeyDown", function(L) {
      return L(n, Do(13, "Enter"));
    });
  }, 20));
  let C = y.start, k = y.endA, R = (L) => {
    let j = L || n.state.tr.replace(C, k, u.doc.slice(y.start - u.from, y.endB - u.from));
    if (u.sel) {
      let W = cA(n, j.doc, u.sel);
      W && !(vn && n.composing && W.empty && (y.start != y.endB || n.input.lastChromeDelete < Date.now() - 100) && (W.head == C || W.head == j.mapping.map(k) - 1) || mr && W.empty && W.head == C) && j.setSelection(W);
    }
    return s && j.setMeta("composition", s), j.scrollIntoView();
  }, N;
  if (T)
    if (b.pos == S.pos) {
      mr && Ys <= 11 && b.parentOffset == 0 && (n.domObserver.suppressSelectionUpdates(), setTimeout(() => is(n), 20));
      let L = R(n.state.tr.delete(C, k)), j = d.resolve(y.start).marksAcross(d.resolve(y.endA));
      j && L.ensureMarks(j), n.dispatch(L);
    } else if (
      // Adding or removing a mark
      y.endA == y.endB && (N = qY(b.parent.content.cut(b.parentOffset, S.parentOffset), w.parent.content.cut(w.parentOffset, y.endA - w.start())))
    ) {
      let L = R(n.state.tr);
      N.type == "add" ? L.addMark(C, k, N.mark) : L.removeMark(C, k, N.mark), n.dispatch(L);
    } else if (b.parent.child(b.index()).isText && b.index() == S.index() - (S.textOffset ? 0 : 1)) {
      let L = b.parent.textBetween(b.parentOffset, S.parentOffset), j = () => R(n.state.tr.insertText(L, C, k));
      n.someProp("handleTextInput", (W) => W(n, C, k, L, j)) || n.dispatch(j());
    } else
      n.dispatch(R());
  else
    n.dispatch(R());
}
function cA(n, e, t) {
  return Math.max(t.anchor, t.head) > e.content.size ? null : Nv(n, e.resolve(t.anchor), e.resolve(t.head));
}
function qY(n, e) {
  let t = n.firstChild.marks, r = e.firstChild.marks, i = t, s = r, o, a, c;
  for (let d = 0; d < r.length; d++)
    i = r[d].removeFromSet(i);
  for (let d = 0; d < t.length; d++)
    s = t[d].removeFromSet(s);
  if (i.length == 1 && s.length == 0)
    a = i[0], o = "add", c = (d) => d.mark(a.addToSet(d.marks));
  else if (i.length == 0 && s.length == 1)
    a = s[0], o = "remove", c = (d) => d.mark(a.removeFromSet(d.marks));
  else
    return null;
  let u = [];
  for (let d = 0; d < e.childCount; d++)
    u.push(c(e.child(d)));
  if (ce.from(u).eq(n))
    return { mark: a, type: o };
}
function KY(n, e, t, r, i) {
  if (
    // The content must have shrunk
    t - e <= i.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    Sm(r, !0, !1) < i.pos
  )
    return !1;
  let s = n.resolve(e);
  if (!r.parent.isTextblock) {
    let a = s.nodeAfter;
    return a != null && t == e + a.nodeSize;
  }
  if (s.parentOffset < s.parent.content.size || !s.parent.isTextblock)
    return !1;
  let o = n.resolve(Sm(s, !0, !0));
  return !o.parent.isTextblock || o.pos > t || Sm(o, !0, !1) < t ? !1 : r.parent.content.cut(r.parentOffset).eq(o.parent.content);
}
function Sm(n, e, t) {
  let r = n.depth, i = e ? n.end() : n.pos;
  for (; r > 0 && (e || n.indexAfter(r) == n.node(r).childCount); )
    r--, i++, e = !1;
  if (t) {
    let s = n.node(r).maybeChild(n.indexAfter(r));
    for (; s && !s.isLeaf; )
      s = s.firstChild, i++;
  }
  return i;
}
function JY(n, e, t, r, i) {
  let s = n.findDiffStart(e, t);
  if (s == null)
    return null;
  let { a: o, b: a } = n.findDiffEnd(e, t + n.size, t + e.size);
  if (i == "end") {
    let c = Math.max(0, s - Math.min(o, a));
    r -= o + c - s;
  }
  if (o < s && n.size < e.size) {
    let c = r <= s && r >= o ? s - r : 0;
    s -= c, s && s < e.size && uA(e.textBetween(s - 1, s + 1)) && (s += c ? 1 : -1), a = s + (a - o), o = s;
  } else if (a < s) {
    let c = r <= s && r >= a ? s - r : 0;
    s -= c, s && s < n.size && uA(n.textBetween(s - 1, s + 1)) && (s += c ? 1 : -1), o = s + (o - a), a = s;
  }
  return { start: s, endA: o, endB: a };
}
function uA(n) {
  if (n.length != 2)
    return !1;
  let e = n.charCodeAt(0), t = n.charCodeAt(1);
  return e >= 56320 && e <= 57343 && t >= 55296 && t <= 56319;
}
class Pk {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new fY(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(mA), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = hA(this), fA(this), this.nodeViews = pA(this), this.docView = $E(this.state.doc, dA(this), xm(this), this.dom, this), this.domObserver = new FY(this, (r, i, s, o) => YY(this, r, i, s, o)), this.domObserver.start(), hY(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let t in e)
        this._props[t] = e[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && qg(this);
    let t = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(mA), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let t = {};
    for (let r in this._props)
      t[r] = this._props[r];
    t.state = this.state;
    for (let r in e)
      t[r] = e[r];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, t) {
    var r;
    let i = this.state, s = !1, o = !1;
    e.storedMarks && this.composing && (Rk(this), o = !0), this.state = e;
    let a = i.plugins != e.plugins || this._props.plugins != t.plugins;
    if (a || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let g = pA(this);
      ZY(g, this.nodeViews) && (this.nodeViews = g, s = !0);
    }
    (a || t.handleDOMEvents != this._props.handleDOMEvents) && qg(this), this.editable = hA(this), fA(this);
    let c = xm(this), u = dA(this), d = i.plugins != e.plugins && !i.doc.eq(e.doc) ? "reset" : e.scrollToSelection > i.scrollToSelection ? "to selection" : "preserve", h = s || !this.docView.matchesNode(e.doc, u, c);
    (h || !e.selection.eq(i.selection)) && (o = !0);
    let p = d == "preserve" && o && this.dom.style.overflowAnchor == null && DG(this);
    if (o) {
      this.domObserver.stop();
      let g = h && (mr || vn) && !this.composing && !i.selection.empty && !e.selection.empty && QY(i.selection, e.selection);
      if (h) {
        let y = vn ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = DY(this)), (s || !this.docView.update(e.doc, u, c, this)) && (this.docView.updateOuterDeco(u), this.docView.destroy(), this.docView = $E(e.doc, u, c, this.dom, this)), y && (!this.trackWrites || !this.dom.contains(this.trackWrites)) && (g = !0);
      }
      g || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && QG(this)) ? is(this, g) : (gk(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(i), !((r = this.dragging) === null || r === void 0) && r.node && !i.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, i), d == "reset" ? this.dom.scrollTop = 0 : d == "to selection" ? this.scrollToSelection() : p && RG(p);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (t) => t(this))) if (this.state.selection instanceof Me) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && FE(this, t.getBoundingClientRect(), e);
      } else
        FE(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let r = this.directPlugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let r = this.state.plugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let r = this.pluginViews[t];
        r.update && r.update(this, e);
      }
  }
  updateDraggedNode(e, t) {
    let r = e.node, i = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      i = r.from;
    else {
      let s = r.from + (this.state.doc.content.size - t.doc.content.size);
      (s > 0 && this.state.doc.nodeAt(s)) == r.node && (i = s);
    }
    this.dragging = new Mk(e.slice, e.move, i < 0 ? void 0 : Me.create(this.state.doc, i));
  }
  someProp(e, t) {
    let r = this._props && this._props[e], i;
    if (r != null && (i = t ? t(r) : r))
      return i;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let a = this.directPlugins[o].props[e];
      if (a != null && (i = t ? t(a) : a))
        return i;
    }
    let s = this.state.plugins;
    if (s)
      for (let o = 0; o < s.length; o++) {
        let a = s[o].props[e];
        if (a != null && (i = t ? t(a) : a))
          return i;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (mr) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && kG(this.dom), is(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return NG(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, t = 1) {
    return lk(this, e, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, t = 0) {
    return this.docView.domFromPos(e, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let t = this.docView.descAt(e);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, t, r = -1) {
    let i = this.docView.posFromDOM(e, t, r);
    if (i == null)
      throw new RangeError("DOM position not inside the editor");
    return i;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, t) {
    return FG(this, t || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, t) {
    return kc(this, "", e, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, t) {
    return kc(this, e, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return Pv(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (pY(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], xm(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, yG());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return gY(this, e);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? Pn && this.root.nodeType === 11 && wG(this.dom.ownerDocument) == this.dom && VY(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
Pk.prototype.dispatch = function(n) {
  let e = this._props.dispatchTransaction;
  e ? e.call(this, n) : this.updateState(this.state.apply(n));
};
function dA(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(n.editable), n.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(n.state)), t)
      for (let r in t)
        r == "class" ? e.class += " " + t[r] : r == "style" ? e.style = (e.style ? e.style + ";" : "") + t[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(t[r]));
  }), e.translate || (e.translate = "no"), [Dr.node(0, n.state.doc.content.size, e)];
}
function fA(n) {
  if (n.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), n.cursorWrapper = { dom: e, deco: Dr.widget(n.state.selection.from, e, { raw: !0, marks: n.markCursor }) };
  } else
    n.cursorWrapper = null;
}
function hA(n) {
  return !n.someProp("editable", (e) => e(n.state) === !1);
}
function QY(n, e) {
  let t = Math.min(n.$anchor.sharedDepth(n.head), e.$anchor.sharedDepth(e.head));
  return n.$anchor.start(t) != e.$anchor.start(t);
}
function pA(n) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(r) {
    for (let i in r)
      Object.prototype.hasOwnProperty.call(e, i) || (e[i] = r[i]);
  }
  return n.someProp("nodeViews", t), n.someProp("markViews", t), e;
}
function ZY(n, e) {
  let t = 0, r = 0;
  for (let i in n) {
    if (n[i] != e[i])
      return !0;
    t++;
  }
  for (let i in e)
    r++;
  return t != r;
}
function mA(n) {
  if (n.spec.state || n.spec.filterTransaction || n.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var Xs = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, cf = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, XY = typeof navigator < "u" && /Mac/.test(navigator.platform), eq = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var In = 0; In < 10; In++) Xs[48 + In] = Xs[96 + In] = String(In);
for (var In = 1; In <= 24; In++) Xs[In + 111] = "F" + In;
for (var In = 65; In <= 90; In++)
  Xs[In] = String.fromCharCode(In + 32), cf[In] = String.fromCharCode(In);
for (var wm in Xs) cf.hasOwnProperty(wm) || (cf[wm] = Xs[wm]);
function tq(n) {
  var e = XY && n.metaKey && n.shiftKey && !n.ctrlKey && !n.altKey || eq && n.shiftKey && n.key && n.key.length == 1 || n.key == "Unidentified", t = !e && n.key || (n.shiftKey ? cf : Xs)[n.keyCode] || n.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const nq = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), rq = typeof navigator < "u" && /Win/.test(navigator.platform);
function iq(n) {
  let e = n.split(/-(?!$)/), t = e[e.length - 1];
  t == "Space" && (t = " ");
  let r, i, s, o;
  for (let a = 0; a < e.length - 1; a++) {
    let c = e[a];
    if (/^(cmd|meta|m)$/i.test(c))
      o = !0;
    else if (/^a(lt)?$/i.test(c))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      i = !0;
    else if (/^s(hift)?$/i.test(c))
      s = !0;
    else if (/^mod$/i.test(c))
      nq ? o = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + c);
  }
  return r && (t = "Alt-" + t), i && (t = "Ctrl-" + t), o && (t = "Meta-" + t), s && (t = "Shift-" + t), t;
}
function sq(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n)
    e[iq(t)] = n[t];
  return e;
}
function Em(n, e, t = !0) {
  return e.altKey && (n = "Alt-" + n), e.ctrlKey && (n = "Ctrl-" + n), e.metaKey && (n = "Meta-" + n), t && e.shiftKey && (n = "Shift-" + n), n;
}
function oq(n) {
  return new An({ props: { handleKeyDown: Lk(n) } });
}
function Lk(n) {
  let e = sq(n);
  return function(t, r) {
    let i = tq(r), s, o = e[Em(i, r)];
    if (o && o(t.state, t.dispatch, t))
      return !0;
    if (i.length == 1 && i != " ") {
      if (r.shiftKey) {
        let a = e[Em(i, r, !1)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
      if ((r.altKey || r.metaKey || r.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(rq && r.ctrlKey && r.altKey) && (s = Xs[r.keyCode]) && s != i) {
        let a = e[Em(s, r)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
const Vv = (n, e) => n.selection.empty ? !1 : (e && e(n.tr.deleteSelection().scrollIntoView()), !0);
function Bk(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("backward", n) : t.parentOffset > 0) ? null : t;
}
const jk = (n, e, t) => {
  let r = Bk(n, t);
  if (!r)
    return !1;
  let i = Hv(r);
  if (!i) {
    let o = r.blockRange(), a = o && al(o);
    return a == null ? !1 : (e && e(n.tr.lift(o, a).scrollIntoView()), !0);
  }
  let s = i.nodeBefore;
  if (Yk(n, i, e, -1))
    return !0;
  if (r.parent.content.size == 0 && (el(s, "end") || Me.isSelectable(s)))
    for (let o = r.depth; ; o--) {
      let a = th(n.doc, r.before(o), r.after(o), Se.empty);
      if (a && a.slice.size < a.to - a.from) {
        if (e) {
          let c = n.tr.step(a);
          c.setSelection(el(s, "end") ? Xe.findFrom(c.doc.resolve(c.mapping.map(i.pos, -1)), -1) : Me.create(c.doc, i.pos - s.nodeSize)), e(c.scrollIntoView());
        }
        return !0;
      }
      if (o == 1 || r.node(o - 1).childCount > 1)
        break;
    }
  return s.isAtom && i.depth == r.depth - 1 ? (e && e(n.tr.delete(i.pos - s.nodeSize, i.pos).scrollIntoView()), !0) : !1;
}, aq = (n, e, t) => {
  let r = Bk(n, t);
  if (!r)
    return !1;
  let i = Hv(r);
  return i ? Fk(n, i, e) : !1;
}, lq = (n, e, t) => {
  let r = Vk(n, t);
  if (!r)
    return !1;
  let i = Uv(r);
  return i ? Fk(n, i, e) : !1;
};
function Fk(n, e, t) {
  let r = e.nodeBefore, i = r, s = e.pos - 1;
  for (; !i.isTextblock; s--) {
    if (i.type.spec.isolating)
      return !1;
    let d = i.lastChild;
    if (!d)
      return !1;
    i = d;
  }
  let o = e.nodeAfter, a = o, c = e.pos + 1;
  for (; !a.isTextblock; c++) {
    if (a.type.spec.isolating)
      return !1;
    let d = a.firstChild;
    if (!d)
      return !1;
    a = d;
  }
  let u = th(n.doc, s, c, Se.empty);
  if (!u || u.from != s || u instanceof gn && u.slice.size >= c - s)
    return !1;
  if (t) {
    let d = n.tr.step(u);
    d.setSelection(Ve.create(d.doc, s)), t(d.scrollIntoView());
  }
  return !0;
}
function el(n, e, t = !1) {
  for (let r = n; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (t && r.childCount != 1)
      return !1;
  }
  return !1;
}
const zk = (n, e, t) => {
  let { $head: r, empty: i } = n.selection, s = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", n) : r.parentOffset > 0)
      return !1;
    s = Hv(r);
  }
  let o = s && s.nodeBefore;
  return !o || !Me.isSelectable(o) ? !1 : (e && e(n.tr.setSelection(Me.create(n.doc, s.pos - o.nodeSize)).scrollIntoView()), !0);
};
function Hv(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      if (n.index(e) > 0)
        return n.doc.resolve(n.before(e + 1));
      if (n.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function Vk(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("forward", n) : t.parentOffset < t.parent.content.size) ? null : t;
}
const Hk = (n, e, t) => {
  let r = Vk(n, t);
  if (!r)
    return !1;
  let i = Uv(r);
  if (!i)
    return !1;
  let s = i.nodeAfter;
  if (Yk(n, i, e, 1))
    return !0;
  if (r.parent.content.size == 0 && (el(s, "start") || Me.isSelectable(s))) {
    let o = th(n.doc, r.before(), r.after(), Se.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let a = n.tr.step(o);
        a.setSelection(el(s, "start") ? Xe.findFrom(a.doc.resolve(a.mapping.map(i.pos)), 1) : Me.create(a.doc, a.mapping.map(i.pos))), e(a.scrollIntoView());
      }
      return !0;
    }
  }
  return s.isAtom && i.depth == r.depth - 1 ? (e && e(n.tr.delete(i.pos, i.pos + s.nodeSize).scrollIntoView()), !0) : !1;
}, Uk = (n, e, t) => {
  let { $head: r, empty: i } = n.selection, s = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", n) : r.parentOffset < r.parent.content.size)
      return !1;
    s = Uv(r);
  }
  let o = s && s.nodeAfter;
  return !o || !Me.isSelectable(o) ? !1 : (e && e(n.tr.setSelection(Me.create(n.doc, s.pos)).scrollIntoView()), !0);
};
function Uv(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      let t = n.node(e);
      if (n.index(e) + 1 < t.childCount)
        return n.doc.resolve(n.after(e + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const cq = (n, e) => {
  let t = n.selection, r = t instanceof Me, i;
  if (r) {
    if (t.node.isTextblock || !ro(n.doc, t.from))
      return !1;
    i = t.from;
  } else if (i = eh(n.doc, t.from, -1), i == null)
    return !1;
  if (e) {
    let s = n.tr.join(i);
    r && s.setSelection(Me.create(s.doc, i - n.doc.resolve(i).nodeBefore.nodeSize)), e(s.scrollIntoView());
  }
  return !0;
}, uq = (n, e) => {
  let t = n.selection, r;
  if (t instanceof Me) {
    if (t.node.isTextblock || !ro(n.doc, t.to))
      return !1;
    r = t.to;
  } else if (r = eh(n.doc, t.to, 1), r == null)
    return !1;
  return e && e(n.tr.join(r).scrollIntoView()), !0;
}, dq = (n, e) => {
  let { $from: t, $to: r } = n.selection, i = t.blockRange(r), s = i && al(i);
  return s == null ? !1 : (e && e(n.tr.lift(i, s).scrollIntoView()), !0);
}, Wk = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  return !t.parent.type.spec.code || !t.sameParent(r) ? !1 : (e && e(n.tr.insertText(`
`).scrollIntoView()), !0);
};
function Wv(n) {
  for (let e = 0; e < n.edgeCount; e++) {
    let { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const fq = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  if (!t.parent.type.spec.code || !t.sameParent(r))
    return !1;
  let i = t.node(-1), s = t.indexAfter(-1), o = Wv(i.contentMatchAt(s));
  if (!o || !i.canReplaceWith(s, s, o))
    return !1;
  if (e) {
    let a = t.after(), c = n.tr.replaceWith(a, a, o.createAndFill());
    c.setSelection(Xe.near(c.doc.resolve(a), 1)), e(c.scrollIntoView());
  }
  return !0;
}, $k = (n, e) => {
  let t = n.selection, { $from: r, $to: i } = t;
  if (t instanceof kr || r.parent.inlineContent || i.parent.inlineContent)
    return !1;
  let s = Wv(i.parent.contentMatchAt(i.indexAfter()));
  if (!s || !s.isTextblock)
    return !1;
  if (e) {
    let o = (!r.parentOffset && i.index() < i.parent.childCount ? r : i).pos, a = n.tr.insert(o, s.createAndFill());
    a.setSelection(Ve.create(a.doc, o + 1)), e(a.scrollIntoView());
  }
  return !0;
}, Gk = (n, e) => {
  let { $cursor: t } = n.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let s = t.before();
    if (rs(n.doc, s))
      return e && e(n.tr.split(s).scrollIntoView()), !0;
  }
  let r = t.blockRange(), i = r && al(r);
  return i == null ? !1 : (e && e(n.tr.lift(r, i).scrollIntoView()), !0);
};
function hq(n) {
  return (e, t) => {
    let { $from: r, $to: i } = e.selection;
    if (e.selection instanceof Me && e.selection.node.isBlock)
      return !r.parentOffset || !rs(e.doc, r.pos) ? !1 : (t && t(e.tr.split(r.pos).scrollIntoView()), !0);
    if (!r.depth)
      return !1;
    let s = [], o, a, c = !1, u = !1;
    for (let g = r.depth; ; g--)
      if (r.node(g).isBlock) {
        c = r.end(g) == r.pos + (r.depth - g), u = r.start(g) == r.pos - (r.depth - g), a = Wv(r.node(g - 1).contentMatchAt(r.indexAfter(g - 1))), s.unshift(c && a ? { type: a } : null), o = g;
        break;
      } else {
        if (g == 1)
          return !1;
        s.unshift(null);
      }
    let d = e.tr;
    (e.selection instanceof Ve || e.selection instanceof kr) && d.deleteSelection();
    let h = d.mapping.map(r.pos), p = rs(d.doc, h, s.length, s);
    if (p || (s[0] = a ? { type: a } : null, p = rs(d.doc, h, s.length, s)), !p)
      return !1;
    if (d.split(h, s.length, s), !c && u && r.node(o).type != a) {
      let g = d.mapping.map(r.before(o)), y = d.doc.resolve(g);
      a && r.node(o - 1).canReplaceWith(y.index(), y.index() + 1, a) && d.setNodeMarkup(d.mapping.map(r.before(o)), a);
    }
    return t && t(d.scrollIntoView()), !0;
  };
}
const pq = hq(), mq = (n, e) => {
  let { $from: t, to: r } = n.selection, i, s = t.sharedDepth(r);
  return s == 0 ? !1 : (i = t.before(s), e && e(n.tr.setSelection(Me.create(n.doc, i))), !0);
};
function gq(n, e, t) {
  let r = e.nodeBefore, i = e.nodeAfter, s = e.index();
  return !r || !i || !r.type.compatibleContent(i.type) ? !1 : !r.content.size && e.parent.canReplace(s - 1, s) ? (t && t(n.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(s, s + 1) || !(i.isTextblock || ro(n.doc, e.pos)) ? !1 : (t && t(n.tr.join(e.pos).scrollIntoView()), !0);
}
function Yk(n, e, t, r) {
  let i = e.nodeBefore, s = e.nodeAfter, o, a, c = i.type.spec.isolating || s.type.spec.isolating;
  if (!c && gq(n, e, t))
    return !0;
  let u = !c && e.parent.canReplace(e.index(), e.index() + 1);
  if (u && (o = (a = i.contentMatchAt(i.childCount)).findWrapping(s.type)) && a.matchType(o[0] || s.type).validEnd) {
    if (t) {
      let g = e.pos + s.nodeSize, y = ce.empty;
      for (let w = o.length - 1; w >= 0; w--)
        y = ce.from(o[w].create(null, y));
      y = ce.from(i.copy(y));
      let b = n.tr.step(new xn(e.pos - 1, g, e.pos, g, new Se(y, 1, 0), o.length, !0)), S = b.doc.resolve(g + 2 * o.length);
      S.nodeAfter && S.nodeAfter.type == i.type && ro(b.doc, S.pos) && b.join(S.pos), t(b.scrollIntoView());
    }
    return !0;
  }
  let d = s.type.spec.isolating || r > 0 && c ? null : Xe.findFrom(e, 1), h = d && d.$from.blockRange(d.$to), p = h && al(h);
  if (p != null && p >= e.depth)
    return t && t(n.tr.lift(h, p).scrollIntoView()), !0;
  if (u && el(s, "start", !0) && el(i, "end")) {
    let g = i, y = [];
    for (; y.push(g), !g.isTextblock; )
      g = g.lastChild;
    let b = s, S = 1;
    for (; !b.isTextblock; b = b.firstChild)
      S++;
    if (g.canReplace(g.childCount, g.childCount, b.content)) {
      if (t) {
        let w = ce.empty;
        for (let C = y.length - 1; C >= 0; C--)
          w = ce.from(y[C].copy(w));
        let T = n.tr.step(new xn(e.pos - y.length, e.pos + s.nodeSize, e.pos + S, e.pos + s.nodeSize - S, new Se(w, y.length, 0), 0, !0));
        t(T.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function qk(n) {
  return function(e, t) {
    let r = e.selection, i = n < 0 ? r.$from : r.$to, s = i.depth;
    for (; i.node(s).isInline; ) {
      if (!s)
        return !1;
      s--;
    }
    return i.node(s).isTextblock ? (t && t(e.tr.setSelection(Ve.create(e.doc, n < 0 ? i.start(s) : i.end(s)))), !0) : !1;
  };
}
const yq = qk(-1), vq = qk(1);
function bq(n, e = null) {
  return function(t, r) {
    let { $from: i, $to: s } = t.selection, o = i.blockRange(s), a = o && Mv(o, n, e);
    return a ? (r && r(t.tr.wrap(o, a).scrollIntoView()), !0) : !1;
  };
}
function gA(n, e = null) {
  return function(t, r) {
    let i = !1;
    for (let s = 0; s < t.selection.ranges.length && !i; s++) {
      let { $from: { pos: o }, $to: { pos: a } } = t.selection.ranges[s];
      t.doc.nodesBetween(o, a, (c, u) => {
        if (i)
          return !1;
        if (!(!c.isTextblock || c.hasMarkup(n, e)))
          if (c.type == n)
            i = !0;
          else {
            let d = t.doc.resolve(u), h = d.index();
            i = d.parent.canReplaceWith(h, h + 1, n);
          }
      });
    }
    if (!i)
      return !1;
    if (r) {
      let s = t.tr;
      for (let o = 0; o < t.selection.ranges.length; o++) {
        let { $from: { pos: a }, $to: { pos: c } } = t.selection.ranges[o];
        s.setBlockType(a, c, n, e);
      }
      r(s.scrollIntoView());
    }
    return !0;
  };
}
function $v(...n) {
  return function(e, t, r) {
    for (let i = 0; i < n.length; i++)
      if (n[i](e, t, r))
        return !0;
    return !1;
  };
}
$v(Vv, jk, zk);
$v(Vv, Hk, Uk);
$v(Wk, $k, Gk, pq);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function xq(n, e = null) {
  return function(t, r) {
    let { $from: i, $to: s } = t.selection, o = i.blockRange(s);
    if (!o)
      return !1;
    let a = r ? t.tr : null;
    return Sq(a, o, n, e) ? (r && r(a.scrollIntoView()), !0) : !1;
  };
}
function Sq(n, e, t, r = null) {
  let i = !1, s = e, o = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(t) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let c = o.resolve(e.start - 2);
    s = new tf(c, c, e.depth), e.endIndex < e.parent.childCount && (e = new tf(e.$from, o.resolve(e.$to.end(e.depth)), e.depth)), i = !0;
  }
  let a = Mv(s, t, r, e);
  return a ? (n && wq(n, e, a, i, t), !0) : !1;
}
function wq(n, e, t, r, i) {
  let s = ce.empty;
  for (let d = t.length - 1; d >= 0; d--)
    s = ce.from(t[d].type.create(t[d].attrs, s));
  n.step(new xn(e.start - (r ? 2 : 0), e.end, e.start, e.end, new Se(s, 0, 0), t.length, !0));
  let o = 0;
  for (let d = 0; d < t.length; d++)
    t[d].type == i && (o = d + 1);
  let a = t.length - o, c = e.start + t.length - (r ? 2 : 0), u = e.parent;
  for (let d = e.startIndex, h = e.endIndex, p = !0; d < h; d++, p = !1)
    !p && rs(n.doc, c, a) && (n.split(c, a), c += 2 * a), c += u.child(d).nodeSize;
  return n;
}
function Eq(n) {
  return function(e, t) {
    let { $from: r, $to: i } = e.selection, s = r.blockRange(i, (o) => o.childCount > 0 && o.firstChild.type == n);
    return s ? t ? r.node(s.depth - 1).type == n ? Aq(e, t, n, s) : Tq(e, t, s) : !0 : !1;
  };
}
function Aq(n, e, t, r) {
  let i = n.tr, s = r.end, o = r.$to.end(r.depth);
  s < o && (i.step(new xn(s - 1, o, s, o, new Se(ce.from(t.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new tf(i.doc.resolve(r.$from.pos), i.doc.resolve(o), r.depth));
  const a = al(r);
  if (a == null)
    return !1;
  i.lift(r, a);
  let c = i.doc.resolve(i.mapping.map(s, -1) - 1);
  return ro(i.doc, c.pos) && c.nodeBefore.type == c.nodeAfter.type && i.join(c.pos), e(i.scrollIntoView()), !0;
}
function Tq(n, e, t) {
  let r = n.tr, i = t.parent;
  for (let g = t.end, y = t.endIndex - 1, b = t.startIndex; y > b; y--)
    g -= i.child(y).nodeSize, r.delete(g - 1, g + 1);
  let s = r.doc.resolve(t.start), o = s.nodeAfter;
  if (r.mapping.map(t.end) != t.start + s.nodeAfter.nodeSize)
    return !1;
  let a = t.startIndex == 0, c = t.endIndex == i.childCount, u = s.node(-1), d = s.index(-1);
  if (!u.canReplace(d + (a ? 0 : 1), d + 1, o.content.append(c ? ce.empty : ce.from(i))))
    return !1;
  let h = s.pos, p = h + o.nodeSize;
  return r.step(new xn(h - (a ? 1 : 0), p + (c ? 1 : 0), h + 1, p - 1, new Se((a ? ce.empty : ce.from(i.copy(ce.empty))).append(c ? ce.empty : ce.from(i.copy(ce.empty))), a ? 0 : 1, c ? 0 : 1), a ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function Cq(n) {
  return function(e, t) {
    let { $from: r, $to: i } = e.selection, s = r.blockRange(i, (u) => u.childCount > 0 && u.firstChild.type == n);
    if (!s)
      return !1;
    let o = s.startIndex;
    if (o == 0)
      return !1;
    let a = s.parent, c = a.child(o - 1);
    if (c.type != n)
      return !1;
    if (t) {
      let u = c.lastChild && c.lastChild.type == a.type, d = ce.from(u ? n.create() : null), h = new Se(ce.from(n.create(null, ce.from(a.type.create(null, d)))), u ? 3 : 1, 0), p = s.start, g = s.end;
      t(e.tr.step(new xn(p - (u ? 3 : 1), g, p, g, h, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function oh(n) {
  const { state: e, transaction: t } = n;
  let { selection: r } = t, { doc: i } = t, { storedMarks: s } = t;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return s;
    },
    get selection() {
      return r;
    },
    get doc() {
      return i;
    },
    get tr() {
      return r = t.selection, i = t.doc, s = t.storedMarks, t;
    }
  };
}
class ah {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: t, state: r } = this, { view: i } = t, { tr: s } = r, o = this.buildProps(s);
    return Object.fromEntries(Object.entries(e).map(([a, c]) => [a, (...d) => {
      const h = c(...d)(o);
      return !s.getMeta("preventDispatch") && !this.hasCustomState && i.dispatch(s), h;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, t = !0) {
    const { rawCommands: r, editor: i, state: s } = this, { view: o } = i, a = [], c = !!e, u = e || s.tr, d = () => (!c && t && !u.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(u), a.every((p) => p === !0)), h = {
      ...Object.fromEntries(Object.entries(r).map(([p, g]) => [p, (...b) => {
        const S = this.buildProps(u, t), w = g(...b)(S);
        return a.push(w), h;
      }])),
      run: d
    };
    return h;
  }
  createCan(e) {
    const { rawCommands: t, state: r } = this, i = !1, s = e || r.tr, o = this.buildProps(s, i);
    return {
      ...Object.fromEntries(Object.entries(t).map(([c, u]) => [c, (...d) => u(...d)({ ...o, dispatch: void 0 })])),
      chain: () => this.createChain(s, i)
    };
  }
  buildProps(e, t = !0) {
    const { rawCommands: r, editor: i, state: s } = this, { view: o } = i, a = {
      tr: e,
      editor: i,
      view: o,
      state: oh({
        state: s,
        transaction: e
      }),
      dispatch: t ? () => {
      } : void 0,
      chain: () => this.createChain(e, t),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([c, u]) => [c, (...d) => u(...d)(a)]));
      }
    };
    return a;
  }
}
class Dq {
  constructor() {
    this.callbacks = {};
  }
  on(e, t) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(t), this;
  }
  emit(e, ...t) {
    const r = this.callbacks[e];
    return r && r.forEach((i) => i.apply(this, t)), this;
  }
  off(e, t) {
    const r = this.callbacks[e];
    return r && (t ? this.callbacks[e] = r.filter((i) => i !== t) : delete this.callbacks[e]), this;
  }
  once(e, t) {
    const r = (...i) => {
      this.off(e, r), t.apply(this, i);
    };
    return this.on(e, r);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function Ce(n, e, t) {
  return n.config[e] === void 0 && n.parent ? Ce(n.parent, e, t) : typeof n.config[e] == "function" ? n.config[e].bind({
    ...t,
    parent: n.parent ? Ce(n.parent, e, t) : null
  }) : n.config[e];
}
function lh(n) {
  const e = n.filter((i) => i.type === "extension"), t = n.filter((i) => i.type === "node"), r = n.filter((i) => i.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: t,
    markExtensions: r
  };
}
function Kk(n) {
  const e = [], { nodeExtensions: t, markExtensions: r } = lh(n), i = [...t, ...r], s = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return n.forEach((o) => {
    const a = {
      name: o.name,
      options: o.options,
      storage: o.storage,
      extensions: i
    }, c = Ce(o, "addGlobalAttributes", a);
    if (!c)
      return;
    c().forEach((d) => {
      d.types.forEach((h) => {
        Object.entries(d.attributes).forEach(([p, g]) => {
          e.push({
            type: h,
            name: p,
            attribute: {
              ...s,
              ...g
            }
          });
        });
      });
    });
  }), i.forEach((o) => {
    const a = {
      name: o.name,
      options: o.options,
      storage: o.storage
    }, c = Ce(o, "addAttributes", a);
    if (!c)
      return;
    const u = c();
    Object.entries(u).forEach(([d, h]) => {
      const p = {
        ...s,
        ...h
      };
      typeof (p == null ? void 0 : p.default) == "function" && (p.default = p.default()), p != null && p.isRequired && (p == null ? void 0 : p.default) === void 0 && delete p.default, e.push({
        type: o.name,
        name: d,
        attribute: p
      });
    });
  }), e;
}
function wn(n, e) {
  if (typeof n == "string") {
    if (!e.nodes[n])
      throw Error(`There is no node type named '${n}'. Maybe you forgot to add the extension?`);
    return e.nodes[n];
  }
  return n;
}
function En(...n) {
  return n.filter((e) => !!e).reduce((e, t) => {
    const r = { ...e };
    return Object.entries(t).forEach(([i, s]) => {
      if (!r[i]) {
        r[i] = s;
        return;
      }
      if (i === "class") {
        const a = s ? String(s).split(" ") : [], c = r[i] ? r[i].split(" ") : [], u = a.filter((d) => !c.includes(d));
        r[i] = [...c, ...u].join(" ");
      } else if (i === "style") {
        const a = s ? s.split(";").map((d) => d.trim()).filter(Boolean) : [], c = r[i] ? r[i].split(";").map((d) => d.trim()).filter(Boolean) : [], u = /* @__PURE__ */ new Map();
        c.forEach((d) => {
          const [h, p] = d.split(":").map((g) => g.trim());
          u.set(h, p);
        }), a.forEach((d) => {
          const [h, p] = d.split(":").map((g) => g.trim());
          u.set(h, p);
        }), r[i] = Array.from(u.entries()).map(([d, h]) => `${d}: ${h}`).join("; ");
      } else
        r[i] = s;
    }), r;
  }, {});
}
function Kg(n, e) {
  return e.filter((t) => t.type === n.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(n.attrs) || {} : {
    [t.name]: n.attrs[t.name]
  }).reduce((t, r) => En(t, r), {});
}
function Jk(n) {
  return typeof n == "function";
}
function tt(n, e = void 0, ...t) {
  return Jk(n) ? e ? n.bind(e)(...t) : n(...t) : n;
}
function Rq(n = {}) {
  return Object.keys(n).length === 0 && n.constructor === Object;
}
function kq(n) {
  return typeof n != "string" ? n : n.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(n) : n === "true" ? !0 : n === "false" ? !1 : n;
}
function yA(n, e) {
  return "style" in n ? n : {
    ...n,
    getAttrs: (t) => {
      const r = n.getAttrs ? n.getAttrs(t) : n.attrs;
      if (r === !1)
        return !1;
      const i = e.reduce((s, o) => {
        const a = o.attribute.parseHTML ? o.attribute.parseHTML(t) : kq(t.getAttribute(o.name));
        return a == null ? s : {
          ...s,
          [o.name]: a
        };
      }, {});
      return { ...r, ...i };
    }
  };
}
function vA(n) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(n).filter(([e, t]) => e === "attrs" && Rq(t) ? !1 : t != null)
  );
}
function Mq(n, e) {
  var t;
  const r = Kk(n), { nodeExtensions: i, markExtensions: s } = lh(n), o = (t = i.find((u) => Ce(u, "topNode"))) === null || t === void 0 ? void 0 : t.name, a = Object.fromEntries(i.map((u) => {
    const d = r.filter((w) => w.type === u.name), h = {
      name: u.name,
      options: u.options,
      storage: u.storage,
      editor: e
    }, p = n.reduce((w, T) => {
      const C = Ce(T, "extendNodeSchema", h);
      return {
        ...w,
        ...C ? C(u) : {}
      };
    }, {}), g = vA({
      ...p,
      content: tt(Ce(u, "content", h)),
      marks: tt(Ce(u, "marks", h)),
      group: tt(Ce(u, "group", h)),
      inline: tt(Ce(u, "inline", h)),
      atom: tt(Ce(u, "atom", h)),
      selectable: tt(Ce(u, "selectable", h)),
      draggable: tt(Ce(u, "draggable", h)),
      code: tt(Ce(u, "code", h)),
      whitespace: tt(Ce(u, "whitespace", h)),
      linebreakReplacement: tt(Ce(u, "linebreakReplacement", h)),
      defining: tt(Ce(u, "defining", h)),
      isolating: tt(Ce(u, "isolating", h)),
      attrs: Object.fromEntries(d.map((w) => {
        var T;
        return [w.name, { default: (T = w == null ? void 0 : w.attribute) === null || T === void 0 ? void 0 : T.default }];
      }))
    }), y = tt(Ce(u, "parseHTML", h));
    y && (g.parseDOM = y.map((w) => yA(w, d)));
    const b = Ce(u, "renderHTML", h);
    b && (g.toDOM = (w) => b({
      node: w,
      HTMLAttributes: Kg(w, d)
    }));
    const S = Ce(u, "renderText", h);
    return S && (g.toText = S), [u.name, g];
  })), c = Object.fromEntries(s.map((u) => {
    const d = r.filter((S) => S.type === u.name), h = {
      name: u.name,
      options: u.options,
      storage: u.storage,
      editor: e
    }, p = n.reduce((S, w) => {
      const T = Ce(w, "extendMarkSchema", h);
      return {
        ...S,
        ...T ? T(u) : {}
      };
    }, {}), g = vA({
      ...p,
      inclusive: tt(Ce(u, "inclusive", h)),
      excludes: tt(Ce(u, "excludes", h)),
      group: tt(Ce(u, "group", h)),
      spanning: tt(Ce(u, "spanning", h)),
      code: tt(Ce(u, "code", h)),
      attrs: Object.fromEntries(d.map((S) => {
        var w;
        return [S.name, { default: (w = S == null ? void 0 : S.attribute) === null || w === void 0 ? void 0 : w.default }];
      }))
    }), y = tt(Ce(u, "parseHTML", h));
    y && (g.parseDOM = y.map((S) => yA(S, d)));
    const b = Ce(u, "renderHTML", h);
    return b && (g.toDOM = (S) => b({
      mark: S,
      HTMLAttributes: Kg(S, d)
    })), [u.name, g];
  }));
  return new LR({
    topNode: o,
    nodes: a,
    marks: c
  });
}
function Am(n, e) {
  return e.nodes[n] || e.marks[n] || null;
}
function bA(n, e) {
  return Array.isArray(e) ? e.some((t) => (typeof t == "string" ? t : t.name) === n.name) : e;
}
function Gv(n, e) {
  const t = Xo.fromSchema(e).serializeFragment(n), i = document.implementation.createHTMLDocument().createElement("div");
  return i.appendChild(t), i.innerHTML;
}
const _q = (n, e = 500) => {
  let t = "";
  const r = n.parentOffset;
  return n.parent.nodesBetween(Math.max(0, r - e), r, (i, s, o, a) => {
    var c, u;
    const d = ((u = (c = i.type.spec).toText) === null || u === void 0 ? void 0 : u.call(c, {
      node: i,
      pos: s,
      parent: o,
      index: a
    })) || i.textContent || "%leaf%";
    t += i.isAtom && !i.isText ? d : d.slice(0, Math.max(0, r - s));
  }), t;
};
function Yv(n) {
  return Object.prototype.toString.call(n) === "[object RegExp]";
}
class ch {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const Oq = (n, e) => {
  if (Yv(e))
    return e.exec(n);
  const t = e(n);
  if (!t)
    return null;
  const r = [t.text];
  return r.index = t.index, r.input = n, r.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(t.replaceWith)), r;
};
function nd(n) {
  var e;
  const { editor: t, from: r, to: i, text: s, rules: o, plugin: a } = n, { view: c } = t;
  if (c.composing)
    return !1;
  const u = c.state.doc.resolve(r);
  if (
    // check for code node
    u.parent.type.spec.code || !((e = u.nodeBefore || u.nodeAfter) === null || e === void 0) && e.marks.find((p) => p.type.spec.code)
  )
    return !1;
  let d = !1;
  const h = _q(u) + s;
  return o.forEach((p) => {
    if (d)
      return;
    const g = Oq(h, p.find);
    if (!g)
      return;
    const y = c.state.tr, b = oh({
      state: c.state,
      transaction: y
    }), S = {
      from: r - (g[0].length - s.length),
      to: i
    }, { commands: w, chain: T, can: C } = new ah({
      editor: t,
      state: b
    });
    p.handler({
      state: b,
      range: S,
      match: g,
      commands: w,
      chain: T,
      can: C
    }) === null || !y.steps.length || (y.setMeta(a, {
      transform: y,
      from: r,
      to: i,
      text: s
    }), c.dispatch(y), d = !0);
  }), d;
}
function Iq(n) {
  const { editor: e, rules: t } = n, r = new An({
    state: {
      init() {
        return null;
      },
      apply(i, s, o) {
        const a = i.getMeta(r);
        if (a)
          return a;
        const c = i.getMeta("applyInputRules");
        return !!c && setTimeout(() => {
          let { text: d } = c;
          typeof d == "string" ? d = d : d = Gv(ce.from(d), o.schema);
          const { from: h } = c, p = h + d.length;
          nd({
            editor: e,
            from: h,
            to: p,
            text: d,
            rules: t,
            plugin: r
          });
        }), i.selectionSet || i.docChanged ? null : s;
      }
    },
    props: {
      handleTextInput(i, s, o, a) {
        return nd({
          editor: e,
          from: s,
          to: o,
          text: a,
          rules: t,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (i) => (setTimeout(() => {
          const { $cursor: s } = i.state.selection;
          s && nd({
            editor: e,
            from: s.pos,
            to: s.pos,
            text: "",
            rules: t,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(i, s) {
        if (s.key !== "Enter")
          return !1;
        const { $cursor: o } = i.state.selection;
        return o ? nd({
          editor: e,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: t,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function Nq(n) {
  return Object.prototype.toString.call(n).slice(8, -1);
}
function rd(n) {
  return Nq(n) !== "Object" ? !1 : n.constructor === Object && Object.getPrototypeOf(n) === Object.prototype;
}
function uh(n, e) {
  const t = { ...n };
  return rd(n) && rd(e) && Object.keys(e).forEach((r) => {
    rd(e[r]) && rd(n[r]) ? t[r] = uh(n[r], e[r]) : t[r] = e[r];
  }), t;
}
class Pi {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = tt(Ce(this, "addOptions", {
      name: this.name
    }))), this.storage = tt(Ce(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Pi(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => uh(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new Pi(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = tt(Ce(t, "addOptions", {
      name: t.name
    })), t.storage = tt(Ce(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  static handleExit({ editor: e, mark: t }) {
    const { tr: r } = e.state, i = e.state.selection.$from;
    if (i.pos === i.end()) {
      const o = i.marks();
      if (!!!o.find((u) => (u == null ? void 0 : u.type.name) === t.name))
        return !1;
      const c = o.find((u) => (u == null ? void 0 : u.type.name) === t.name);
      return c && r.removeStoredMark(c), r.insertText(" ", i.pos), e.view.dispatch(r), !0;
    }
    return !1;
  }
}
function Pq(n) {
  return typeof n == "number";
}
class Lq {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const Bq = (n, e, t) => {
  if (Yv(e))
    return [...n.matchAll(e)];
  const r = e(n, t);
  return r ? r.map((i) => {
    const s = [i.text];
    return s.index = i.index, s.input = n, s.data = i.data, i.replaceWith && (i.text.includes(i.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), s.push(i.replaceWith)), s;
  }) : [];
};
function jq(n) {
  const { editor: e, state: t, from: r, to: i, rule: s, pasteEvent: o, dropEvent: a } = n, { commands: c, chain: u, can: d } = new ah({
    editor: e,
    state: t
  }), h = [];
  return t.doc.nodesBetween(r, i, (g, y) => {
    if (!g.isTextblock || g.type.spec.code)
      return;
    const b = Math.max(r, y), S = Math.min(i, y + g.content.size), w = g.textBetween(b - y, S - y, void 0, "￼");
    Bq(w, s.find, o).forEach((C) => {
      if (C.index === void 0)
        return;
      const k = b + C.index + 1, R = k + C[0].length, N = {
        from: t.tr.mapping.map(k),
        to: t.tr.mapping.map(R)
      }, L = s.handler({
        state: t,
        range: N,
        match: C,
        commands: c,
        chain: u,
        can: d,
        pasteEvent: o,
        dropEvent: a
      });
      h.push(L);
    });
  }), h.every((g) => g !== null);
}
let id = null;
const Fq = (n) => {
  var e;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = t.clipboardData) === null || e === void 0 || e.setData("text/html", n), t;
};
function zq(n) {
  const { editor: e, rules: t } = n;
  let r = null, i = !1, s = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, a;
  try {
    a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    a = null;
  }
  const c = ({ state: d, from: h, to: p, rule: g, pasteEvt: y }) => {
    const b = d.tr, S = oh({
      state: d,
      transaction: b
    });
    if (!(!jq({
      editor: e,
      state: S,
      from: Math.max(h - 1, 0),
      to: p.b - 1,
      rule: g,
      pasteEvent: y,
      dropEvent: a
    }) || !b.steps.length)) {
      try {
        a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        a = null;
      }
      return o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, b;
    }
  };
  return t.map((d) => new An({
    // we register a global drag handler to track the current drag source element
    view(h) {
      const p = (y) => {
        var b;
        r = !((b = h.dom.parentElement) === null || b === void 0) && b.contains(y.target) ? h.dom.parentElement : null, r && (id = e);
      }, g = () => {
        id && (id = null);
      };
      return window.addEventListener("dragstart", p), window.addEventListener("dragend", g), {
        destroy() {
          window.removeEventListener("dragstart", p), window.removeEventListener("dragend", g);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (h, p) => {
          if (s = r === h.dom.parentElement, a = p, !s) {
            const g = id;
            g != null && g.isEditable && setTimeout(() => {
              const y = g.state.selection;
              y && g.commands.deleteRange({ from: y.from, to: y.to });
            }, 10);
          }
          return !1;
        },
        paste: (h, p) => {
          var g;
          const y = (g = p.clipboardData) === null || g === void 0 ? void 0 : g.getData("text/html");
          return o = p, i = !!(y != null && y.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (h, p, g) => {
      const y = h[0], b = y.getMeta("uiEvent") === "paste" && !i, S = y.getMeta("uiEvent") === "drop" && !s, w = y.getMeta("applyPasteRules"), T = !!w;
      if (!b && !S && !T)
        return;
      if (T) {
        let { text: R } = w;
        typeof R == "string" ? R = R : R = Gv(ce.from(R), g.schema);
        const { from: N } = w, L = N + R.length, j = Fq(R);
        return c({
          rule: d,
          state: g,
          from: N,
          to: { b: L },
          pasteEvt: j
        });
      }
      const C = p.doc.content.findDiffStart(g.doc.content), k = p.doc.content.findDiffEnd(g.doc.content);
      if (!(!Pq(C) || !k || C === k.b))
        return c({
          rule: d,
          state: g,
          from: C,
          to: k,
          pasteEvt: o
        });
    }
  }));
}
function Vq(n) {
  const e = n.filter((t, r) => n.indexOf(t) !== r);
  return Array.from(new Set(e));
}
class Fa {
  constructor(e, t) {
    this.splittableMarks = [], this.editor = t, this.extensions = Fa.resolve(e), this.schema = Mq(this.extensions, t), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(e) {
    const t = Fa.sort(Fa.flatten(e)), r = Vq(t.map((i) => i.name));
    return r.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${r.map((i) => `'${i}'`).join(", ")}]. This can lead to issues.`), t;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(e) {
    return e.map((t) => {
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage
      }, i = Ce(t, "addExtensions", r);
      return i ? [t, ...this.flatten(i())] : t;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(e) {
    return e.sort((r, i) => {
      const s = Ce(r, "priority") || 100, o = Ce(i, "priority") || 100;
      return s > o ? -1 : s < o ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, t) => {
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: Am(t.name, this.schema)
      }, i = Ce(t, "addCommands", r);
      return i ? {
        ...e,
        ...i()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this, t = Fa.sort([...this.extensions].reverse()), r = [], i = [], s = t.map((o) => {
      const a = {
        name: o.name,
        options: o.options,
        storage: o.storage,
        editor: e,
        type: Am(o.name, this.schema)
      }, c = [], u = Ce(o, "addKeyboardShortcuts", a);
      let d = {};
      if (o.type === "mark" && Ce(o, "exitable", a) && (d.ArrowRight = () => Pi.handleExit({ editor: e, mark: o })), u) {
        const b = Object.fromEntries(Object.entries(u()).map(([S, w]) => [S, () => w({ editor: e })]));
        d = { ...d, ...b };
      }
      const h = oq(d);
      c.push(h);
      const p = Ce(o, "addInputRules", a);
      bA(o, e.options.enableInputRules) && p && r.push(...p());
      const g = Ce(o, "addPasteRules", a);
      bA(o, e.options.enablePasteRules) && g && i.push(...g());
      const y = Ce(o, "addProseMirrorPlugins", a);
      if (y) {
        const b = y();
        c.push(...b);
      }
      return c;
    }).flat();
    return [
      Iq({
        editor: e,
        rules: r
      }),
      ...zq({
        editor: e,
        rules: i
      }),
      ...s
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Kk(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: t } = lh(this.extensions);
    return Object.fromEntries(t.filter((r) => !!Ce(r, "addNodeView")).map((r) => {
      const i = this.attributes.filter((c) => c.type === r.name), s = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: e,
        type: wn(r.name, this.schema)
      }, o = Ce(r, "addNodeView", s);
      if (!o)
        return [];
      const a = (c, u, d, h, p) => {
        const g = Kg(c, i);
        return o()({
          // pass-through
          node: c,
          view: u,
          getPos: d,
          decorations: h,
          innerDecorations: p,
          // tiptap-specific
          editor: e,
          extension: r,
          HTMLAttributes: g
        });
      };
      return [r.name, a];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((e) => {
      var t;
      this.editor.extensionStorage[e.name] = e.storage;
      const r = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: Am(e.name, this.schema)
      };
      e.type === "mark" && (!((t = tt(Ce(e, "keepOnSplit", r))) !== null && t !== void 0) || t) && this.splittableMarks.push(e.name);
      const i = Ce(e, "onBeforeCreate", r), s = Ce(e, "onCreate", r), o = Ce(e, "onUpdate", r), a = Ce(e, "onSelectionUpdate", r), c = Ce(e, "onTransaction", r), u = Ce(e, "onFocus", r), d = Ce(e, "onBlur", r), h = Ce(e, "onDestroy", r);
      i && this.editor.on("beforeCreate", i), s && this.editor.on("create", s), o && this.editor.on("update", o), a && this.editor.on("selectionUpdate", a), c && this.editor.on("transaction", c), u && this.editor.on("focus", u), d && this.editor.on("blur", d), h && this.editor.on("destroy", h);
    });
  }
}
class Un {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = tt(Ce(this, "addOptions", {
      name: this.name
    }))), this.storage = tt(Ce(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Un(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => uh(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new Un({ ...this.config, ...e });
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = tt(Ce(t, "addOptions", {
      name: t.name
    })), t.storage = tt(Ce(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function Qk(n, e, t) {
  const { from: r, to: i } = e, { blockSeparator: s = `

`, textSerializers: o = {} } = t || {};
  let a = "";
  return n.nodesBetween(r, i, (c, u, d, h) => {
    var p;
    c.isBlock && u > r && (a += s);
    const g = o == null ? void 0 : o[c.type.name];
    if (g)
      return d && (a += g({
        node: c,
        pos: u,
        parent: d,
        index: h,
        range: e
      })), !1;
    c.isText && (a += (p = c == null ? void 0 : c.text) === null || p === void 0 ? void 0 : p.slice(Math.max(r, u) - u, i - u));
  }), a;
}
function Zk(n) {
  return Object.fromEntries(Object.entries(n.nodes).filter(([, e]) => e.spec.toText).map(([e, t]) => [e, t.spec.toText]));
}
const Hq = Un.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new An({
        key: new yr("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: n } = this, { state: e, schema: t } = n, { doc: r, selection: i } = e, { ranges: s } = i, o = Math.min(...s.map((d) => d.$from.pos)), a = Math.max(...s.map((d) => d.$to.pos)), c = Zk(t);
            return Qk(r, { from: o, to: a }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: c
            });
          }
        }
      })
    ];
  }
}), Uq = () => ({ editor: n, view: e }) => (requestAnimationFrame(() => {
  var t;
  n.isDestroyed || (e.dom.blur(), (t = window == null ? void 0 : window.getSelection()) === null || t === void 0 || t.removeAllRanges());
}), !0), Wq = (n = !1) => ({ commands: e }) => e.setContent("", n), $q = () => ({ state: n, tr: e, dispatch: t }) => {
  const { selection: r } = e, { ranges: i } = r;
  return t && i.forEach(({ $from: s, $to: o }) => {
    n.doc.nodesBetween(s.pos, o.pos, (a, c) => {
      if (a.type.isText)
        return;
      const { doc: u, mapping: d } = e, h = u.resolve(d.map(c)), p = u.resolve(d.map(c + a.nodeSize)), g = h.blockRange(p);
      if (!g)
        return;
      const y = al(g);
      if (a.type.isTextblock) {
        const { defaultType: b } = h.parent.contentMatchAt(h.index());
        e.setNodeMarkup(g.start, b);
      }
      (y || y === 0) && e.lift(g, y);
    });
  }), !0;
}, Gq = (n) => (e) => n(e), Yq = () => ({ state: n, dispatch: e }) => $k(n, e), qq = (n, e) => ({ editor: t, tr: r }) => {
  const { state: i } = t, s = i.doc.slice(n.from, n.to);
  r.deleteRange(n.from, n.to);
  const o = r.mapping.map(e);
  return r.insert(o, s.content), r.setSelection(new Ve(r.doc.resolve(Math.max(o - 1, 0)))), !0;
}, Kq = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, r = t.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const i = n.selection.$anchor;
  for (let s = i.depth; s > 0; s -= 1)
    if (i.node(s).type === r.type) {
      if (e) {
        const a = i.before(s), c = i.after(s);
        n.delete(a, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, Jq = (n) => ({ tr: e, state: t, dispatch: r }) => {
  const i = wn(n, t.schema), s = e.selection.$anchor;
  for (let o = s.depth; o > 0; o -= 1)
    if (s.node(o).type === i) {
      if (r) {
        const c = s.before(o), u = s.after(o);
        e.delete(c, u).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, Qq = (n) => ({ tr: e, dispatch: t }) => {
  const { from: r, to: i } = n;
  return t && e.delete(r, i), !0;
}, Zq = () => ({ state: n, dispatch: e }) => Vv(n, e), Xq = () => ({ commands: n }) => n.keyboardShortcut("Enter"), e8 = () => ({ state: n, dispatch: e }) => fq(n, e);
function uf(n, e, t = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((i) => t.strict ? e[i] === n[i] : Yv(e[i]) ? e[i].test(n[i]) : e[i] === n[i]) : !0;
}
function Xk(n, e, t = {}) {
  return n.find((r) => r.type === e && uf(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(t).map((i) => [i, r.attrs[i]])),
    t
  ));
}
function xA(n, e, t = {}) {
  return !!Xk(n, e, t);
}
function qv(n, e, t) {
  var r;
  if (!n || !e)
    return;
  let i = n.parent.childAfter(n.parentOffset);
  if ((!i.node || !i.node.marks.some((d) => d.type === e)) && (i = n.parent.childBefore(n.parentOffset)), !i.node || !i.node.marks.some((d) => d.type === e) || (t = t || ((r = i.node.marks[0]) === null || r === void 0 ? void 0 : r.attrs), !Xk([...i.node.marks], e, t)))
    return;
  let o = i.index, a = n.start() + i.offset, c = o + 1, u = a + i.node.nodeSize;
  for (; o > 0 && xA([...n.parent.child(o - 1).marks], e, t); )
    o -= 1, a -= n.parent.child(o).nodeSize;
  for (; c < n.parent.childCount && xA([...n.parent.child(c).marks], e, t); )
    u += n.parent.child(c).nodeSize, c += 1;
  return {
    from: a,
    to: u
  };
}
function so(n, e) {
  if (typeof n == "string") {
    if (!e.marks[n])
      throw Error(`There is no mark type named '${n}'. Maybe you forgot to add the extension?`);
    return e.marks[n];
  }
  return n;
}
const t8 = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  const s = so(n, r.schema), { doc: o, selection: a } = t, { $from: c, from: u, to: d } = a;
  if (i) {
    const h = qv(c, s, e);
    if (h && h.from <= u && h.to >= d) {
      const p = Ve.create(o, h.from, h.to);
      t.setSelection(p);
    }
  }
  return !0;
}, n8 = (n) => (e) => {
  const t = typeof n == "function" ? n(e) : n;
  for (let r = 0; r < t.length; r += 1)
    if (t[r](e))
      return !0;
  return !1;
};
function eM(n) {
  return n instanceof Ve;
}
function Io(n = 0, e = 0, t = 0) {
  return Math.min(Math.max(n, e), t);
}
function tM(n, e = null) {
  if (!e)
    return null;
  const t = Xe.atStart(n), r = Xe.atEnd(n);
  if (e === "start" || e === !0)
    return t;
  if (e === "end")
    return r;
  const i = t.from, s = r.to;
  return e === "all" ? Ve.create(n, Io(0, i, s), Io(n.content.size, i, s)) : Ve.create(n, Io(e, i, s), Io(e, i, s));
}
function SA() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function df() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function r8() {
  return typeof navigator < "u" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
}
const i8 = (n = null, e = {}) => ({ editor: t, view: r, tr: i, dispatch: s }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const o = () => {
    (df() || SA()) && r.dom.focus(), requestAnimationFrame(() => {
      t.isDestroyed || (r.focus(), r8() && !df() && !SA() && r.dom.focus({ preventScroll: !0 }));
    });
  };
  if (r.hasFocus() && n === null || n === !1)
    return !0;
  if (s && n === null && !eM(t.state.selection))
    return o(), !0;
  const a = tM(i.doc, n) || t.state.selection, c = t.state.selection.eq(a);
  return s && (c || i.setSelection(a), c && i.storedMarks && i.setStoredMarks(i.storedMarks), o()), !0;
}, s8 = (n, e) => (t) => n.every((r, i) => e(r, { ...t, index: i })), o8 = (n, e) => ({ tr: t, commands: r }) => r.insertContentAt({ from: t.selection.from, to: t.selection.to }, n, e), nM = (n) => {
  const e = n.childNodes;
  for (let t = e.length - 1; t >= 0; t -= 1) {
    const r = e[t];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? n.removeChild(r) : r.nodeType === 1 && nM(r);
  }
  return n;
};
function sd(n) {
  const e = `<body>${n}</body>`, t = new window.DOMParser().parseFromString(e, "text/html").body;
  return nM(t);
}
function _c(n, e, t) {
  if (n instanceof Gs || n instanceof ce)
    return n;
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const r = typeof n == "object" && n !== null, i = typeof n == "string";
  if (r)
    try {
      if (Array.isArray(n) && n.length > 0)
        return ce.fromArray(n.map((a) => e.nodeFromJSON(a)));
      const o = e.nodeFromJSON(n);
      return t.errorOnInvalidContent && o.check(), o;
    } catch (s) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: s });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", n, "Error:", s), _c("", e, t);
    }
  if (i) {
    if (t.errorOnInvalidContent) {
      let o = !1, a = "";
      const c = new LR({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (u) => (o = !0, a = typeof u == "string" ? u : u.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? nc.fromSchema(c).parseSlice(sd(n), t.parseOptions) : nc.fromSchema(c).parse(sd(n), t.parseOptions), t.errorOnInvalidContent && o)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${a}`) });
    }
    const s = nc.fromSchema(e);
    return t.slice ? s.parseSlice(sd(n), t.parseOptions).content : s.parse(sd(n), t.parseOptions);
  }
  return _c("", e, t);
}
function a8(n, e, t) {
  const r = n.steps.length - 1;
  if (r < e)
    return;
  const i = n.steps[r];
  if (!(i instanceof gn || i instanceof xn))
    return;
  const s = n.mapping.maps[r];
  let o = 0;
  s.forEach((a, c, u, d) => {
    o === 0 && (o = d);
  }), n.setSelection(Xe.near(n.doc.resolve(o), t));
}
const l8 = (n) => !("type" in n), c8 = (n, e, t) => ({ tr: r, dispatch: i, editor: s }) => {
  var o;
  if (i) {
    t = {
      parseOptions: s.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let a;
    const c = (S) => {
      s.emit("contentError", {
        editor: s,
        error: S,
        disableCollaboration: () => {
          s.storage.collaboration && (s.storage.collaboration.isDisabled = !0);
        }
      });
    }, u = {
      preserveWhitespace: "full",
      ...t.parseOptions
    };
    if (!t.errorOnInvalidContent && !s.options.enableContentCheck && s.options.emitContentError)
      try {
        _c(e, s.schema, {
          parseOptions: u,
          errorOnInvalidContent: !0
        });
      } catch (S) {
        c(S);
      }
    try {
      a = _c(e, s.schema, {
        parseOptions: u,
        errorOnInvalidContent: (o = t.errorOnInvalidContent) !== null && o !== void 0 ? o : s.options.enableContentCheck
      });
    } catch (S) {
      return c(S), !1;
    }
    let { from: d, to: h } = typeof n == "number" ? { from: n, to: n } : { from: n.from, to: n.to }, p = !0, g = !0;
    if ((l8(a) ? a : [a]).forEach((S) => {
      S.check(), p = p ? S.isText && S.marks.length === 0 : !1, g = g ? S.isBlock : !1;
    }), d === h && g) {
      const { parent: S } = r.doc.resolve(d);
      S.isTextblock && !S.type.spec.code && !S.childCount && (d -= 1, h += 1);
    }
    let b;
    if (p) {
      if (Array.isArray(e))
        b = e.map((S) => S.text || "").join("");
      else if (e instanceof ce) {
        let S = "";
        e.forEach((w) => {
          w.text && (S += w.text);
        }), b = S;
      } else typeof e == "object" && e && e.text ? b = e.text : b = e;
      r.insertText(b, d, h);
    } else
      b = a, r.replaceWith(d, h, b);
    t.updateSelection && a8(r, r.steps.length - 1, -1), t.applyInputRules && r.setMeta("applyInputRules", { from: d, text: b }), t.applyPasteRules && r.setMeta("applyPasteRules", { from: d, text: b });
  }
  return !0;
}, u8 = () => ({ state: n, dispatch: e }) => cq(n, e), d8 = () => ({ state: n, dispatch: e }) => uq(n, e), f8 = () => ({ state: n, dispatch: e }) => jk(n, e), h8 = () => ({ state: n, dispatch: e }) => Hk(n, e), p8 = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const r = eh(n.doc, n.selection.$from.pos, -1);
    return r == null ? !1 : (t.join(r, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, m8 = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const r = eh(n.doc, n.selection.$from.pos, 1);
    return r == null ? !1 : (t.join(r, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, g8 = () => ({ state: n, dispatch: e }) => aq(n, e), y8 = () => ({ state: n, dispatch: e }) => lq(n, e);
function rM() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function v8(n) {
  const e = n.split(/-(?!$)/);
  let t = e[e.length - 1];
  t === "Space" && (t = " ");
  let r, i, s, o;
  for (let a = 0; a < e.length - 1; a += 1) {
    const c = e[a];
    if (/^(cmd|meta|m)$/i.test(c))
      o = !0;
    else if (/^a(lt)?$/i.test(c))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      i = !0;
    else if (/^s(hift)?$/i.test(c))
      s = !0;
    else if (/^mod$/i.test(c))
      df() || rM() ? o = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${c}`);
  }
  return r && (t = `Alt-${t}`), i && (t = `Ctrl-${t}`), o && (t = `Meta-${t}`), s && (t = `Shift-${t}`), t;
}
const b8 = (n) => ({ editor: e, view: t, tr: r, dispatch: i }) => {
  const s = v8(n).split(/-(?!$)/), o = s.find((u) => !["Alt", "Ctrl", "Meta", "Shift"].includes(u)), a = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: s.includes("Alt"),
    ctrlKey: s.includes("Ctrl"),
    metaKey: s.includes("Meta"),
    shiftKey: s.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), c = e.captureTransaction(() => {
    t.someProp("handleKeyDown", (u) => u(t, a));
  });
  return c == null || c.steps.forEach((u) => {
    const d = u.map(r.mapping);
    d && i && r.maybeStep(d);
  }), !0;
};
function Oc(n, e, t = {}) {
  const { from: r, to: i, empty: s } = n.selection, o = e ? wn(e, n.schema) : null, a = [];
  n.doc.nodesBetween(r, i, (h, p) => {
    if (h.isText)
      return;
    const g = Math.max(r, p), y = Math.min(i, p + h.nodeSize);
    a.push({
      node: h,
      from: g,
      to: y
    });
  });
  const c = i - r, u = a.filter((h) => o ? o.name === h.node.type.name : !0).filter((h) => uf(h.node.attrs, t, { strict: !1 }));
  return s ? !!u.length : u.reduce((h, p) => h + p.to - p.from, 0) >= c;
}
const x8 = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = wn(n, t.schema);
  return Oc(t, i, e) ? dq(t, r) : !1;
}, S8 = () => ({ state: n, dispatch: e }) => Gk(n, e), w8 = (n) => ({ state: e, dispatch: t }) => {
  const r = wn(n, e.schema);
  return Eq(r)(e, t);
}, E8 = () => ({ state: n, dispatch: e }) => Wk(n, e);
function dh(n, e) {
  return e.nodes[n] ? "node" : e.marks[n] ? "mark" : null;
}
function wA(n, e) {
  const t = typeof e == "string" ? [e] : e;
  return Object.keys(n).reduce((r, i) => (t.includes(i) || (r[i] = n[i]), r), {});
}
const A8 = (n, e) => ({ tr: t, state: r, dispatch: i }) => {
  let s = null, o = null;
  const a = dh(typeof n == "string" ? n : n.name, r.schema);
  return a ? (a === "node" && (s = wn(n, r.schema)), a === "mark" && (o = so(n, r.schema)), i && t.selection.ranges.forEach((c) => {
    r.doc.nodesBetween(c.$from.pos, c.$to.pos, (u, d) => {
      s && s === u.type && t.setNodeMarkup(d, void 0, wA(u.attrs, e)), o && u.marks.length && u.marks.forEach((h) => {
        o === h.type && t.addMark(d, d + u.nodeSize, o.create(wA(h.attrs, e)));
      });
    });
  }), !0) : !1;
}, T8 = () => ({ tr: n, dispatch: e }) => (e && n.scrollIntoView(), !0), C8 = () => ({ tr: n, dispatch: e }) => {
  if (e) {
    const t = new kr(n.doc);
    n.setSelection(t);
  }
  return !0;
}, D8 = () => ({ state: n, dispatch: e }) => zk(n, e), R8 = () => ({ state: n, dispatch: e }) => Uk(n, e), k8 = () => ({ state: n, dispatch: e }) => mq(n, e), M8 = () => ({ state: n, dispatch: e }) => vq(n, e), _8 = () => ({ state: n, dispatch: e }) => yq(n, e);
function Jg(n, e, t = {}, r = {}) {
  return _c(n, e, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
const O8 = (n, e = !1, t = {}, r = {}) => ({ editor: i, tr: s, dispatch: o, commands: a }) => {
  var c, u;
  const { doc: d } = s;
  if (t.preserveWhitespace !== "full") {
    const h = Jg(n, i.schema, t, {
      errorOnInvalidContent: (c = r.errorOnInvalidContent) !== null && c !== void 0 ? c : i.options.enableContentCheck
    });
    return o && s.replaceWith(0, d.content.size, h).setMeta("preventUpdate", !e), !0;
  }
  return o && s.setMeta("preventUpdate", !e), a.insertContentAt({ from: 0, to: d.content.size }, n, {
    parseOptions: t,
    errorOnInvalidContent: (u = r.errorOnInvalidContent) !== null && u !== void 0 ? u : i.options.enableContentCheck
  });
};
function iM(n, e) {
  const t = so(e, n.schema), { from: r, to: i, empty: s } = n.selection, o = [];
  s ? (n.storedMarks && o.push(...n.storedMarks), o.push(...n.selection.$head.marks())) : n.doc.nodesBetween(r, i, (c) => {
    o.push(...c.marks);
  });
  const a = o.find((c) => c.type.name === t.name);
  return a ? { ...a.attrs } : {};
}
function I8(n, e) {
  const t = new ZR(n);
  return e.forEach((r) => {
    r.steps.forEach((i) => {
      t.step(i);
    });
  }), t;
}
function N8(n) {
  for (let e = 0; e < n.edgeCount; e += 1) {
    const { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function P8(n, e, t) {
  const r = [];
  return n.nodesBetween(e.from, e.to, (i, s) => {
    t(i) && r.push({
      node: i,
      pos: s
    });
  }), r;
}
function L8(n, e) {
  for (let t = n.depth; t > 0; t -= 1) {
    const r = n.node(t);
    if (e(r))
      return {
        pos: t > 0 ? n.before(t) : 0,
        start: n.start(t),
        depth: t,
        node: r
      };
  }
}
function Kv(n) {
  return (e) => L8(e.$from, n);
}
function B8(n, e) {
  const t = {
    from: 0,
    to: n.content.size
  };
  return Qk(n, t, e);
}
function j8(n, e) {
  const t = wn(e, n.schema), { from: r, to: i } = n.selection, s = [];
  n.doc.nodesBetween(r, i, (a) => {
    s.push(a);
  });
  const o = s.reverse().find((a) => a.type.name === t.name);
  return o ? { ...o.attrs } : {};
}
function sM(n, e) {
  const t = dh(typeof e == "string" ? e : e.name, n.schema);
  return t === "node" ? j8(n, e) : t === "mark" ? iM(n, e) : {};
}
function F8(n, e = JSON.stringify) {
  const t = {};
  return n.filter((r) => {
    const i = e(r);
    return Object.prototype.hasOwnProperty.call(t, i) ? !1 : t[i] = !0;
  });
}
function z8(n) {
  const e = F8(n);
  return e.length === 1 ? e : e.filter((t, r) => !e.filter((s, o) => o !== r).some((s) => t.oldRange.from >= s.oldRange.from && t.oldRange.to <= s.oldRange.to && t.newRange.from >= s.newRange.from && t.newRange.to <= s.newRange.to));
}
function V8(n) {
  const { mapping: e, steps: t } = n, r = [];
  return e.maps.forEach((i, s) => {
    const o = [];
    if (i.ranges.length)
      i.forEach((a, c) => {
        o.push({ from: a, to: c });
      });
    else {
      const { from: a, to: c } = t[s];
      if (a === void 0 || c === void 0)
        return;
      o.push({ from: a, to: c });
    }
    o.forEach(({ from: a, to: c }) => {
      const u = e.slice(s).map(a, -1), d = e.slice(s).map(c), h = e.invert().map(u, -1), p = e.invert().map(d);
      r.push({
        oldRange: {
          from: h,
          to: p
        },
        newRange: {
          from: u,
          to: d
        }
      });
    });
  }), z8(r);
}
function Jv(n, e, t) {
  const r = [];
  return n === e ? t.resolve(n).marks().forEach((i) => {
    const s = t.resolve(n), o = qv(s, i.type);
    o && r.push({
      mark: i,
      ...o
    });
  }) : t.nodesBetween(n, e, (i, s) => {
    !i || (i == null ? void 0 : i.nodeSize) === void 0 || r.push(...i.marks.map((o) => ({
      from: s,
      to: s + i.nodeSize,
      mark: o
    })));
  }), r;
}
function Cd(n, e, t) {
  return Object.fromEntries(Object.entries(t).filter(([r]) => {
    const i = n.find((s) => s.type === e && s.name === r);
    return i ? i.attribute.keepOnSplit : !1;
  }));
}
function Qg(n, e, t = {}) {
  const { empty: r, ranges: i } = n.selection, s = e ? so(e, n.schema) : null;
  if (r)
    return !!(n.storedMarks || n.selection.$from.marks()).filter((h) => s ? s.name === h.type.name : !0).find((h) => uf(h.attrs, t, { strict: !1 }));
  let o = 0;
  const a = [];
  if (i.forEach(({ $from: h, $to: p }) => {
    const g = h.pos, y = p.pos;
    n.doc.nodesBetween(g, y, (b, S) => {
      if (!b.isText && !b.marks.length)
        return;
      const w = Math.max(g, S), T = Math.min(y, S + b.nodeSize), C = T - w;
      o += C, a.push(...b.marks.map((k) => ({
        mark: k,
        from: w,
        to: T
      })));
    });
  }), o === 0)
    return !1;
  const c = a.filter((h) => s ? s.name === h.mark.type.name : !0).filter((h) => uf(h.mark.attrs, t, { strict: !1 })).reduce((h, p) => h + p.to - p.from, 0), u = a.filter((h) => s ? h.mark.type !== s && h.mark.type.excludes(s) : !0).reduce((h, p) => h + p.to - p.from, 0);
  return (c > 0 ? c + u : c) >= o;
}
function H8(n, e, t = {}) {
  if (!e)
    return Oc(n, null, t) || Qg(n, null, t);
  const r = dh(e, n.schema);
  return r === "node" ? Oc(n, e, t) : r === "mark" ? Qg(n, e, t) : !1;
}
function EA(n, e) {
  const { nodeExtensions: t } = lh(e), r = t.find((o) => o.name === n);
  if (!r)
    return !1;
  const i = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, s = tt(Ce(r, "group", i));
  return typeof s != "string" ? !1 : s.split(" ").includes("list");
}
function fh(n, { checkChildren: e = !0, ignoreWhitespace: t = !1 } = {}) {
  var r;
  if (t) {
    if (n.type.name === "hardBreak")
      return !0;
    if (n.isText)
      return /^\s*$/m.test((r = n.text) !== null && r !== void 0 ? r : "");
  }
  if (n.isText)
    return !n.text;
  if (n.isAtom || n.isLeaf)
    return !1;
  if (n.content.childCount === 0)
    return !0;
  if (e) {
    let i = !0;
    return n.content.forEach((s) => {
      i !== !1 && (fh(s, { ignoreWhitespace: t, checkChildren: e }) || (i = !1));
    }), i;
  }
  return !1;
}
function U8(n) {
  return n instanceof Me;
}
function W8(n, e, t) {
  var r;
  const { selection: i } = e;
  let s = null;
  if (eM(i) && (s = i.$cursor), s) {
    const a = (r = n.storedMarks) !== null && r !== void 0 ? r : s.marks();
    return !!t.isInSet(a) || !a.some((c) => c.type.excludes(t));
  }
  const { ranges: o } = i;
  return o.some(({ $from: a, $to: c }) => {
    let u = a.depth === 0 ? n.doc.inlineContent && n.doc.type.allowsMarkType(t) : !1;
    return n.doc.nodesBetween(a.pos, c.pos, (d, h, p) => {
      if (u)
        return !1;
      if (d.isInline) {
        const g = !p || p.type.allowsMarkType(t), y = !!t.isInSet(d.marks) || !d.marks.some((b) => b.type.excludes(t));
        u = g && y;
      }
      return !u;
    }), u;
  });
}
const $8 = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  const { selection: s } = t, { empty: o, ranges: a } = s, c = so(n, r.schema);
  if (i)
    if (o) {
      const u = iM(r, c);
      t.addStoredMark(c.create({
        ...u,
        ...e
      }));
    } else
      a.forEach((u) => {
        const d = u.$from.pos, h = u.$to.pos;
        r.doc.nodesBetween(d, h, (p, g) => {
          const y = Math.max(g, d), b = Math.min(g + p.nodeSize, h);
          p.marks.find((w) => w.type === c) ? p.marks.forEach((w) => {
            c === w.type && t.addMark(y, b, c.create({
              ...w.attrs,
              ...e
            }));
          }) : t.addMark(y, b, c.create(e));
        });
      });
  return W8(r, t, c);
}, G8 = (n, e) => ({ tr: t }) => (t.setMeta(n, e), !0), Y8 = (n, e = {}) => ({ state: t, dispatch: r, chain: i }) => {
  const s = wn(n, t.schema);
  let o;
  return t.selection.$anchor.sameParent(t.selection.$head) && (o = t.selection.$anchor.parent.attrs), s.isTextblock ? i().command(({ commands: a }) => gA(s, { ...o, ...e })(t) ? !0 : a.clearNodes()).command(({ state: a }) => gA(s, { ...o, ...e })(a, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, q8 = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, i = Io(n, 0, r.content.size), s = Me.create(r, i);
    e.setSelection(s);
  }
  return !0;
}, K8 = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, { from: i, to: s } = typeof n == "number" ? { from: n, to: n } : n, o = Ve.atStart(r).from, a = Ve.atEnd(r).to, c = Io(i, o, a), u = Io(s, o, a), d = Ve.create(r, c, u);
    e.setSelection(d);
  }
  return !0;
}, J8 = (n) => ({ state: e, dispatch: t }) => {
  const r = wn(n, e.schema);
  return Cq(r)(e, t);
};
function AA(n, e) {
  const t = n.storedMarks || n.selection.$to.parentOffset && n.selection.$from.marks();
  if (t) {
    const r = t.filter((i) => e == null ? void 0 : e.includes(i.type.name));
    n.tr.ensureMarks(r);
  }
}
const Q8 = ({ keepMarks: n = !0 } = {}) => ({ tr: e, state: t, dispatch: r, editor: i }) => {
  const { selection: s, doc: o } = e, { $from: a, $to: c } = s, u = i.extensionManager.attributes, d = Cd(u, a.node().type.name, a.node().attrs);
  if (s instanceof Me && s.node.isBlock)
    return !a.parentOffset || !rs(o, a.pos) ? !1 : (r && (n && AA(t, i.extensionManager.splittableMarks), e.split(a.pos).scrollIntoView()), !0);
  if (!a.parent.isBlock)
    return !1;
  const h = c.parentOffset === c.parent.content.size, p = a.depth === 0 ? void 0 : N8(a.node(-1).contentMatchAt(a.indexAfter(-1)));
  let g = h && p ? [
    {
      type: p,
      attrs: d
    }
  ] : void 0, y = rs(e.doc, e.mapping.map(a.pos), 1, g);
  if (!g && !y && rs(e.doc, e.mapping.map(a.pos), 1, p ? [{ type: p }] : void 0) && (y = !0, g = p ? [
    {
      type: p,
      attrs: d
    }
  ] : void 0), r) {
    if (y && (s instanceof Ve && e.deleteSelection(), e.split(e.mapping.map(a.pos), 1, g), p && !h && !a.parentOffset && a.parent.type !== p)) {
      const b = e.mapping.map(a.before()), S = e.doc.resolve(b);
      a.node(-1).canReplaceWith(S.index(), S.index() + 1, p) && e.setNodeMarkup(e.mapping.map(a.before()), p);
    }
    n && AA(t, i.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return y;
}, Z8 = (n, e = {}) => ({ tr: t, state: r, dispatch: i, editor: s }) => {
  var o;
  const a = wn(n, r.schema), { $from: c, $to: u } = r.selection, d = r.selection.node;
  if (d && d.isBlock || c.depth < 2 || !c.sameParent(u))
    return !1;
  const h = c.node(-1);
  if (h.type !== a)
    return !1;
  const p = s.extensionManager.attributes;
  if (c.parent.content.size === 0 && c.node(-1).childCount === c.indexAfter(-1)) {
    if (c.depth === 2 || c.node(-3).type !== a || c.index(-2) !== c.node(-2).childCount - 1)
      return !1;
    if (i) {
      let w = ce.empty;
      const T = c.index(-1) ? 1 : c.index(-2) ? 2 : 3;
      for (let j = c.depth - T; j >= c.depth - 3; j -= 1)
        w = ce.from(c.node(j).copy(w));
      const C = c.indexAfter(-1) < c.node(-2).childCount ? 1 : c.indexAfter(-2) < c.node(-3).childCount ? 2 : 3, k = {
        ...Cd(p, c.node().type.name, c.node().attrs),
        ...e
      }, R = ((o = a.contentMatch.defaultType) === null || o === void 0 ? void 0 : o.createAndFill(k)) || void 0;
      w = w.append(ce.from(a.createAndFill(null, R) || void 0));
      const N = c.before(c.depth - (T - 1));
      t.replace(N, c.after(-C), new Se(w, 4 - T, 0));
      let L = -1;
      t.doc.nodesBetween(N, t.doc.content.size, (j, W) => {
        if (L > -1)
          return !1;
        j.isTextblock && j.content.size === 0 && (L = W + 1);
      }), L > -1 && t.setSelection(Ve.near(t.doc.resolve(L))), t.scrollIntoView();
    }
    return !0;
  }
  const g = u.pos === c.end() ? h.contentMatchAt(0).defaultType : null, y = {
    ...Cd(p, h.type.name, h.attrs),
    ...e
  }, b = {
    ...Cd(p, c.node().type.name, c.node().attrs),
    ...e
  };
  t.delete(c.pos, u.pos);
  const S = g ? [
    { type: a, attrs: y },
    { type: g, attrs: b }
  ] : [{ type: a, attrs: y }];
  if (!rs(t.doc, c.pos, 2))
    return !1;
  if (i) {
    const { selection: w, storedMarks: T } = r, { splittableMarks: C } = s.extensionManager, k = T || w.$to.parentOffset && w.$from.marks();
    if (t.split(c.pos, 2, S).scrollIntoView(), !k || !i)
      return !0;
    const R = k.filter((N) => C.includes(N.type.name));
    t.ensureMarks(R);
  }
  return !0;
}, Tm = (n, e) => {
  const t = Kv((o) => o.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (r === void 0)
    return !0;
  const i = n.doc.nodeAt(r);
  return t.node.type === (i == null ? void 0 : i.type) && ro(n.doc, t.pos) && n.join(t.pos), !0;
}, Cm = (n, e) => {
  const t = Kv((o) => o.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(t.start).after(t.depth);
  if (r === void 0)
    return !0;
  const i = n.doc.nodeAt(r);
  return t.node.type === (i == null ? void 0 : i.type) && ro(n.doc, r) && n.join(r), !0;
}, X8 = (n, e, t, r = {}) => ({ editor: i, tr: s, state: o, dispatch: a, chain: c, commands: u, can: d }) => {
  const { extensions: h, splittableMarks: p } = i.extensionManager, g = wn(n, o.schema), y = wn(e, o.schema), { selection: b, storedMarks: S } = o, { $from: w, $to: T } = b, C = w.blockRange(T), k = S || b.$to.parentOffset && b.$from.marks();
  if (!C)
    return !1;
  const R = Kv((N) => EA(N.type.name, h))(b);
  if (C.depth >= 1 && R && C.depth - R.depth <= 1) {
    if (R.node.type === g)
      return u.liftListItem(y);
    if (EA(R.node.type.name, h) && g.validContent(R.node.content) && a)
      return c().command(() => (s.setNodeMarkup(R.pos, g), !0)).command(() => Tm(s, g)).command(() => Cm(s, g)).run();
  }
  return !t || !k || !a ? c().command(() => d().wrapInList(g, r) ? !0 : u.clearNodes()).wrapInList(g, r).command(() => Tm(s, g)).command(() => Cm(s, g)).run() : c().command(() => {
    const N = d().wrapInList(g, r), L = k.filter((j) => p.includes(j.type.name));
    return s.ensureMarks(L), N ? !0 : u.clearNodes();
  }).wrapInList(g, r).command(() => Tm(s, g)).command(() => Cm(s, g)).run();
}, e9 = (n, e = {}, t = {}) => ({ state: r, commands: i }) => {
  const { extendEmptyMarkRange: s = !1 } = t, o = so(n, r.schema);
  return Qg(r, o, e) ? i.unsetMark(o, { extendEmptyMarkRange: s }) : i.setMark(o, e);
}, t9 = (n, e, t = {}) => ({ state: r, commands: i }) => {
  const s = wn(n, r.schema), o = wn(e, r.schema), a = Oc(r, s, t);
  let c;
  return r.selection.$anchor.sameParent(r.selection.$head) && (c = r.selection.$anchor.parent.attrs), a ? i.setNode(o, c) : i.setNode(s, { ...c, ...t });
}, n9 = (n, e = {}) => ({ state: t, commands: r }) => {
  const i = wn(n, t.schema);
  return Oc(t, i, e) ? r.lift(i) : r.wrapIn(i, e);
}, r9 = () => ({ state: n, dispatch: e }) => {
  const t = n.plugins;
  for (let r = 0; r < t.length; r += 1) {
    const i = t[r];
    let s;
    if (i.spec.isInputRules && (s = i.getState(n))) {
      if (e) {
        const o = n.tr, a = s.transform;
        for (let c = a.steps.length - 1; c >= 0; c -= 1)
          o.step(a.steps[c].invert(a.docs[c]));
        if (s.text) {
          const c = o.doc.resolve(s.from).marks();
          o.replaceWith(s.from, s.to, n.schema.text(s.text, c));
        } else
          o.delete(s.from, s.to);
      }
      return !0;
    }
  }
  return !1;
}, i9 = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, { empty: r, ranges: i } = t;
  return r || e && i.forEach((s) => {
    n.removeMark(s.$from.pos, s.$to.pos);
  }), !0;
}, s9 = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  var s;
  const { extendEmptyMarkRange: o = !1 } = e, { selection: a } = t, c = so(n, r.schema), { $from: u, empty: d, ranges: h } = a;
  if (!i)
    return !0;
  if (d && o) {
    let { from: p, to: g } = a;
    const y = (s = u.marks().find((S) => S.type === c)) === null || s === void 0 ? void 0 : s.attrs, b = qv(u, c, y);
    b && (p = b.from, g = b.to), t.removeMark(p, g, c);
  } else
    h.forEach((p) => {
      t.removeMark(p.$from.pos, p.$to.pos, c);
    });
  return t.removeStoredMark(c), !0;
}, o9 = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  let s = null, o = null;
  const a = dh(typeof n == "string" ? n : n.name, r.schema);
  return a ? (a === "node" && (s = wn(n, r.schema)), a === "mark" && (o = so(n, r.schema)), i && t.selection.ranges.forEach((c) => {
    const u = c.$from.pos, d = c.$to.pos;
    let h, p, g, y;
    t.selection.empty ? r.doc.nodesBetween(u, d, (b, S) => {
      s && s === b.type && (g = Math.max(S, u), y = Math.min(S + b.nodeSize, d), h = S, p = b);
    }) : r.doc.nodesBetween(u, d, (b, S) => {
      S < u && s && s === b.type && (g = Math.max(S, u), y = Math.min(S + b.nodeSize, d), h = S, p = b), S >= u && S <= d && (s && s === b.type && t.setNodeMarkup(S, void 0, {
        ...b.attrs,
        ...e
      }), o && b.marks.length && b.marks.forEach((w) => {
        if (o === w.type) {
          const T = Math.max(S, u), C = Math.min(S + b.nodeSize, d);
          t.addMark(T, C, o.create({
            ...w.attrs,
            ...e
          }));
        }
      }));
    }), p && (h !== void 0 && t.setNodeMarkup(h, void 0, {
      ...p.attrs,
      ...e
    }), o && p.marks.length && p.marks.forEach((b) => {
      o === b.type && t.addMark(g, y, o.create({
        ...b.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, a9 = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = wn(n, t.schema);
  return bq(i, e)(t, r);
}, l9 = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = wn(n, t.schema);
  return xq(i, e)(t, r);
};
var c9 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: Uq,
  clearContent: Wq,
  clearNodes: $q,
  command: Gq,
  createParagraphNear: Yq,
  cut: qq,
  deleteCurrentNode: Kq,
  deleteNode: Jq,
  deleteRange: Qq,
  deleteSelection: Zq,
  enter: Xq,
  exitCode: e8,
  extendMarkRange: t8,
  first: n8,
  focus: i8,
  forEach: s8,
  insertContent: o8,
  insertContentAt: c8,
  joinBackward: f8,
  joinDown: d8,
  joinForward: h8,
  joinItemBackward: p8,
  joinItemForward: m8,
  joinTextblockBackward: g8,
  joinTextblockForward: y8,
  joinUp: u8,
  keyboardShortcut: b8,
  lift: x8,
  liftEmptyBlock: S8,
  liftListItem: w8,
  newlineInCode: E8,
  resetAttributes: A8,
  scrollIntoView: T8,
  selectAll: C8,
  selectNodeBackward: D8,
  selectNodeForward: R8,
  selectParentNode: k8,
  selectTextblockEnd: M8,
  selectTextblockStart: _8,
  setContent: O8,
  setMark: $8,
  setMeta: G8,
  setNode: Y8,
  setNodeSelection: q8,
  setTextSelection: K8,
  sinkListItem: J8,
  splitBlock: Q8,
  splitListItem: Z8,
  toggleList: X8,
  toggleMark: e9,
  toggleNode: t9,
  toggleWrap: n9,
  undoInputRule: r9,
  unsetAllMarks: i9,
  unsetMark: s9,
  updateAttributes: o9,
  wrapIn: a9,
  wrapInList: l9
});
const u9 = Un.create({
  name: "commands",
  addCommands() {
    return {
      ...c9
    };
  }
}), d9 = Un.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new An({
        key: new yr("tiptapDrop"),
        props: {
          handleDrop: (n, e, t, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: t,
              moved: r
            });
          }
        }
      })
    ];
  }
}), f9 = Un.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new An({
        key: new yr("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), h9 = new yr("focusEvents"), p9 = Un.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: n } = this;
    return [
      new An({
        key: h9,
        props: {
          handleDOMEvents: {
            focus: (e, t) => {
              n.isFocused = !0;
              const r = n.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, t) => {
              n.isFocused = !1;
              const r = n.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), m9 = Un.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: a }) => {
        const { selection: c, doc: u } = a, { empty: d, $anchor: h } = c, { pos: p, parent: g } = h, y = h.parent.isTextblock && p > 0 ? a.doc.resolve(p - 1) : h, b = y.parent.type.spec.isolating, S = h.pos - h.parentOffset, w = b && y.parent.childCount === 1 ? S === h.pos : Xe.atStart(u).from === p;
        return !d || !g.type.isTextblock || g.textContent.length || !w || w && h.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: n,
      "Mod-Backspace": n,
      "Shift-Backspace": n,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...r
    }, s = {
      ...r,
      "Ctrl-h": n,
      "Alt-Backspace": n,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return df() || rM() ? s : i;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new An({
        key: new yr("clearDocument"),
        appendTransaction: (n, e, t) => {
          if (n.some((b) => b.getMeta("composition")))
            return;
          const r = n.some((b) => b.docChanged) && !e.doc.eq(t.doc), i = n.some((b) => b.getMeta("preventClearDocument"));
          if (!r || i)
            return;
          const { empty: s, from: o, to: a } = e.selection, c = Xe.atStart(e.doc).from, u = Xe.atEnd(e.doc).to;
          if (s || !(o === c && a === u) || !fh(t.doc))
            return;
          const p = t.tr, g = oh({
            state: t,
            transaction: p
          }), { commands: y } = new ah({
            editor: this.editor,
            state: g
          });
          if (y.clearNodes(), !!p.steps.length)
            return p;
        }
      })
    ];
  }
}), g9 = Un.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new An({
        key: new yr("tiptapPaste"),
        props: {
          handlePaste: (n, e, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: t
            });
          }
        }
      })
    ];
  }
}), y9 = Un.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new An({
        key: new yr("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class Ro {
  get name() {
    return this.node.type.name;
  }
  constructor(e, t, r = !1, i = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = e, this.editor = t, this.currentNode = i;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) !== null && e !== void 0 ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let t = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: r }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(e);
    return new Ro(t, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new Ro(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new Ro(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((t, r) => {
      const i = t.isBlock && !t.isTextblock, s = t.isAtom && !t.isText, o = this.pos + r + (s ? 0 : 1);
      if (o < 0 || o > this.resolvedPos.doc.nodeSize - 2)
        return;
      const a = this.resolvedPos.doc.resolve(o);
      if (!i && a.depth <= this.depth)
        return;
      const c = new Ro(a, this.editor, i, i ? t : null);
      i && (c.actualDepth = this.depth + 1), e.push(new Ro(a, this.editor, i, i ? t : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, t = {}) {
    let r = null, i = this.parent;
    for (; i && !r; ) {
      if (i.node.type.name === e)
        if (Object.keys(t).length > 0) {
          const s = i.node.attrs, o = Object.keys(t);
          for (let a = 0; a < o.length; a += 1) {
            const c = o[a];
            if (s[c] !== t[c])
              break;
          }
        } else
          r = i;
      i = i.parent;
    }
    return r;
  }
  querySelector(e, t = {}) {
    return this.querySelectorAll(e, t, !0)[0] || null;
  }
  querySelectorAll(e, t = {}, r = !1) {
    let i = [];
    if (!this.children || this.children.length === 0)
      return i;
    const s = Object.keys(t);
    return this.children.forEach((o) => {
      r && i.length > 0 || (o.node.type.name === e && s.every((c) => t[c] === o.node.attrs[c]) && i.push(o), !(r && i.length > 0) && (i = i.concat(o.querySelectorAll(e, t, r))));
    }), i;
  }
  setAttribute(e) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(t);
  }
}
const v9 = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function b9(n, e, t) {
  const r = document.querySelector("style[data-tiptap-style]");
  if (r !== null)
    return r;
  const i = document.createElement("style");
  return e && i.setAttribute("nonce", e), i.setAttribute("data-tiptap-style", ""), i.innerHTML = n, document.getElementsByTagName("head")[0].appendChild(i), i;
}
class x9 extends Dq {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: t }) => {
        throw t;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: t, slice: r, moved: i }) => this.options.onDrop(t, r, i)), this.on("paste", ({ event: t, slice: r }) => this.options.onPaste(t, r)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = b9(v9, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, t = !0) {
    this.setOptions({ editable: e }), t && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, t) {
    const r = Jk(t) ? t(e, [...this.state.plugins]) : [...this.state.plugins, e], i = this.state.reconfigure({ plugins: r });
    return this.view.updateState(i), i;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const t = this.state.plugins;
    let r = t;
    if ([].concat(e).forEach((s) => {
      const o = typeof s == "string" ? `${s}$` : s.key;
      r = r.filter((a) => !a.key.startsWith(o));
    }), t.length === r.length)
      return;
    const i = this.state.reconfigure({
      plugins: r
    });
    return this.view.updateState(i), i;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, t;
    const i = [...this.options.enableCoreExtensions ? [
      f9,
      Hq.configure({
        blockSeparator: (t = (e = this.options.coreExtensionOptions) === null || e === void 0 ? void 0 : e.clipboardTextSerializer) === null || t === void 0 ? void 0 : t.blockSeparator
      }),
      u9,
      p9,
      m9,
      y9,
      d9,
      g9
    ].filter((s) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[s.name] !== !1 : !0) : [], ...this.options.extensions].filter((s) => ["extension", "node", "mark"].includes(s == null ? void 0 : s.type));
    this.extensionManager = new Fa(i, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new ah({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    var e;
    let t;
    try {
      t = Jg(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (o) {
      if (!(o instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(o.message))
        throw o;
      this.emit("contentError", {
        editor: this,
        error: o,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((a) => a.name !== "collaboration"), this.createExtensionManager();
        }
      }), t = Jg(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const r = tM(t, this.options.autofocus);
    this.view = new Pk(this.options.element, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(e = this.options.editorProps) === null || e === void 0 ? void 0 : e.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: ja.create({
        doc: t,
        selection: r || void 0
      })
    });
    const i = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(i), this.createNodeViews(), this.prependClass();
    const s = this.view.dom;
    s.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((o) => {
        var a;
        return (a = this.capturedTransaction) === null || a === void 0 ? void 0 : a.step(o);
      });
      return;
    }
    const t = this.state.apply(e), r = !this.state.selection.eq(t.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: t
    }), this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: e
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const i = e.getMeta("focus"), s = e.getMeta("blur");
    i && this.emit("focus", {
      editor: this,
      event: i.event,
      transaction: e
    }), s && this.emit("blur", {
      editor: this,
      event: s.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return sM(this.state, e);
  }
  isActive(e, t) {
    const r = typeof e == "string" ? e : null, i = typeof e == "string" ? t : e;
    return H8(this.state, r, i);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return Gv(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: t = `

`, textSerializers: r = {} } = e || {};
    return B8(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...Zk(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return fh(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const e = this.view.dom;
      e && e.editor && delete e.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
  $node(e, t) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelector(e, t)) || null;
  }
  $nodes(e, t) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelectorAll(e, t)) || null;
  }
  $pos(e) {
    const t = this.state.doc.resolve(e);
    return new Ro(t, this);
  }
  get $doc() {
    return this.$pos(0);
  }
}
function tl(n) {
  return new ch({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = tt(n.getAttributes, void 0, r);
      if (i === !1 || i === null)
        return null;
      const { tr: s } = e, o = r[r.length - 1], a = r[0];
      if (o) {
        const c = a.search(/\S/), u = t.from + a.indexOf(o), d = u + o.length;
        if (Jv(t.from, t.to, e.doc).filter((g) => g.mark.type.excluded.find((b) => b === n.type && b !== g.mark.type)).filter((g) => g.to > u).length)
          return null;
        d < t.to && s.delete(d, t.to), u > t.from && s.delete(t.from + c, u);
        const p = t.from + c + o.length;
        s.addMark(t.from + c, p, n.type.create(i || {})), s.removeStoredMark(n.type);
      }
    }
  });
}
function S9(n) {
  return new ch({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = tt(n.getAttributes, void 0, r) || {}, { tr: s } = e, o = t.from;
      let a = t.to;
      const c = n.type.create(i);
      if (r[1]) {
        const u = r[0].lastIndexOf(r[1]);
        let d = o + u;
        d > a ? d = a : a = d + r[1].length;
        const h = r[0][r[0].length - 1];
        s.insertText(h, o + r[0].length - 1), s.replaceWith(d, a, c);
      } else if (r[0]) {
        const u = n.type.isInline ? o : o - 1;
        s.insert(u, n.type.create(i)).delete(s.mapping.map(o), s.mapping.map(a));
      }
      s.scrollIntoView();
    }
  });
}
function Zg(n) {
  return new ch({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = e.doc.resolve(t.from), s = tt(n.getAttributes, void 0, r) || {};
      if (!i.node(-1).canReplaceWith(i.index(-1), i.indexAfter(-1), n.type))
        return null;
      e.tr.delete(t.from, t.to).setBlockType(t.from, t.from, n.type, s);
    }
  });
}
function Ic(n) {
  return new ch({
    find: n.find,
    handler: ({ state: e, range: t, match: r, chain: i }) => {
      const s = tt(n.getAttributes, void 0, r) || {}, o = e.tr.delete(t.from, t.to), c = o.doc.resolve(t.from).blockRange(), u = c && Mv(c, n.type, s);
      if (!u)
        return null;
      if (o.wrap(c, u), n.keepMarks && n.editor) {
        const { selection: h, storedMarks: p } = e, { splittableMarks: g } = n.editor.extensionManager, y = p || h.$to.parentOffset && h.$from.marks();
        if (y) {
          const b = y.filter((S) => g.includes(S.type.name));
          o.ensureMarks(b);
        }
      }
      if (n.keepAttributes) {
        const h = n.type.name === "bulletList" || n.type.name === "orderedList" ? "listItem" : "taskList";
        i().updateAttributes(h, s).run();
      }
      const d = o.doc.resolve(t.from - 1).nodeBefore;
      d && d.type === n.type && ro(o.doc, t.from - 1) && (!n.joinPredicate || n.joinPredicate(r, d)) && o.join(t.from - 1);
    }
  });
}
class gr {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = tt(Ce(this, "addOptions", {
      name: this.name
    }))), this.storage = tt(Ce(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new gr(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => uh(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new gr(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = tt(Ce(t, "addOptions", {
      name: t.name
    })), t.storage = tt(Ce(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function Ko(n) {
  return new Lq({
    find: n.find,
    handler: ({ state: e, range: t, match: r, pasteEvent: i }) => {
      const s = tt(n.getAttributes, void 0, r, i);
      if (s === !1 || s === null)
        return null;
      const { tr: o } = e, a = r[r.length - 1], c = r[0];
      let u = t.to;
      if (a) {
        const d = c.search(/\S/), h = t.from + c.indexOf(a), p = h + a.length;
        if (Jv(t.from, t.to, e.doc).filter((y) => y.mark.type.excluded.find((S) => S === n.type && S !== y.mark.type)).filter((y) => y.to > h).length)
          return null;
        p < t.to && o.delete(p, t.to), h > t.from && o.delete(t.from + d, h), u = t.from + d + a.length, o.addMark(t.from + d, u, n.type.create(s || {})), o.removeStoredMark(n.type);
      }
    }
  });
}
function w9(n, e) {
  const { selection: t } = n, { $from: r } = t;
  if (t instanceof Me) {
    const s = r.index();
    return r.parent.canReplaceWith(s, s + 1, e);
  }
  let i = r.depth;
  for (; i >= 0; ) {
    const s = r.index(i);
    if (r.node(i).contentMatchAt(s).matchType(e))
      return !0;
    i -= 1;
  }
  return !1;
}
const E9 = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", A9 = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", Xg = "numeric", ey = "ascii", ty = "alpha", oc = "asciinumeric", Wl = "alphanumeric", ny = "domain", oM = "emoji", T9 = "scheme", C9 = "slashscheme", Dm = "whitespace";
function D9(n, e) {
  return n in e || (e[n] = []), e[n];
}
function No(n, e, t) {
  e[Xg] && (e[oc] = !0, e[Wl] = !0), e[ey] && (e[oc] = !0, e[ty] = !0), e[oc] && (e[Wl] = !0), e[ty] && (e[Wl] = !0), e[Wl] && (e[ny] = !0), e[oM] && (e[ny] = !0);
  for (const r in e) {
    const i = D9(r, t);
    i.indexOf(n) < 0 && i.push(n);
  }
}
function R9(n, e) {
  const t = {};
  for (const r in e)
    e[r].indexOf(n) >= 0 && (t[r] = !0);
  return t;
}
function hr(n = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = n;
}
hr.groups = {};
hr.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(n) {
    const e = this, t = e.j[n];
    if (t)
      return t;
    for (let r = 0; r < e.jr.length; r++) {
      const i = e.jr[r][0], s = e.jr[r][1];
      if (s && i.test(n))
        return s;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(n, e = !1) {
    return e ? n in this.j : !!this.go(n);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(n, e, t, r) {
    for (let i = 0; i < n.length; i++)
      this.tt(n[i], e, t, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(n, e, t, r) {
    r = r || hr.groups;
    let i;
    return e && e.j ? i = e : (i = new hr(e), t && r && No(e, t, r)), this.jr.push([n, i]), i;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(n, e, t, r) {
    let i = this;
    const s = n.length;
    if (!s)
      return i;
    for (let o = 0; o < s - 1; o++)
      i = i.tt(n[o]);
    return i.tt(n[s - 1], e, t, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(n, e, t, r) {
    r = r || hr.groups;
    const i = this;
    if (e && e.j)
      return i.j[n] = e, e;
    const s = e;
    let o, a = i.go(n);
    if (a ? (o = new hr(), Object.assign(o.j, a.j), o.jr.push.apply(o.jr, a.jr), o.jd = a.jd, o.t = a.t) : o = new hr(), s) {
      if (r)
        if (o.t && typeof o.t == "string") {
          const c = Object.assign(R9(o.t, r), t);
          No(s, c, r);
        } else t && No(s, t, r);
      o.t = s;
    }
    return i.j[n] = o, o;
  }
};
const Qe = (n, e, t, r, i) => n.ta(e, t, r, i), qt = (n, e, t, r, i) => n.tr(e, t, r, i), TA = (n, e, t, r, i) => n.ts(e, t, r, i), de = (n, e, t, r, i) => n.tt(e, t, r, i), Qi = "WORD", ry = "UWORD", aM = "ASCIINUMERICAL", lM = "ALPHANUMERICAL", Nc = "LOCALHOST", iy = "TLD", sy = "UTLD", Dd = "SCHEME", _a = "SLASH_SCHEME", Qv = "NUM", oy = "WS", Zv = "NL", ac = "OPENBRACE", lc = "CLOSEBRACE", ff = "OPENBRACKET", hf = "CLOSEBRACKET", pf = "OPENPAREN", mf = "CLOSEPAREN", gf = "OPENANGLEBRACKET", yf = "CLOSEANGLEBRACKET", vf = "FULLWIDTHLEFTPAREN", bf = "FULLWIDTHRIGHTPAREN", xf = "LEFTCORNERBRACKET", Sf = "RIGHTCORNERBRACKET", wf = "LEFTWHITECORNERBRACKET", Ef = "RIGHTWHITECORNERBRACKET", Af = "FULLWIDTHLESSTHAN", Tf = "FULLWIDTHGREATERTHAN", Cf = "AMPERSAND", Df = "APOSTROPHE", Rf = "ASTERISK", Is = "AT", kf = "BACKSLASH", Mf = "BACKTICK", _f = "CARET", Ls = "COLON", Xv = "COMMA", Of = "DOLLAR", Ai = "DOT", If = "EQUALS", e0 = "EXCLAMATION", Wr = "HYPHEN", cc = "PERCENT", Nf = "PIPE", Pf = "PLUS", Lf = "POUND", uc = "QUERY", t0 = "QUOTE", cM = "FULLWIDTHMIDDLEDOT", n0 = "SEMI", Ti = "SLASH", dc = "TILDE", Bf = "UNDERSCORE", uM = "EMOJI", jf = "SYM";
var dM = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: lM,
  AMPERSAND: Cf,
  APOSTROPHE: Df,
  ASCIINUMERICAL: aM,
  ASTERISK: Rf,
  AT: Is,
  BACKSLASH: kf,
  BACKTICK: Mf,
  CARET: _f,
  CLOSEANGLEBRACKET: yf,
  CLOSEBRACE: lc,
  CLOSEBRACKET: hf,
  CLOSEPAREN: mf,
  COLON: Ls,
  COMMA: Xv,
  DOLLAR: Of,
  DOT: Ai,
  EMOJI: uM,
  EQUALS: If,
  EXCLAMATION: e0,
  FULLWIDTHGREATERTHAN: Tf,
  FULLWIDTHLEFTPAREN: vf,
  FULLWIDTHLESSTHAN: Af,
  FULLWIDTHMIDDLEDOT: cM,
  FULLWIDTHRIGHTPAREN: bf,
  HYPHEN: Wr,
  LEFTCORNERBRACKET: xf,
  LEFTWHITECORNERBRACKET: wf,
  LOCALHOST: Nc,
  NL: Zv,
  NUM: Qv,
  OPENANGLEBRACKET: gf,
  OPENBRACE: ac,
  OPENBRACKET: ff,
  OPENPAREN: pf,
  PERCENT: cc,
  PIPE: Nf,
  PLUS: Pf,
  POUND: Lf,
  QUERY: uc,
  QUOTE: t0,
  RIGHTCORNERBRACKET: Sf,
  RIGHTWHITECORNERBRACKET: Ef,
  SCHEME: Dd,
  SEMI: n0,
  SLASH: Ti,
  SLASH_SCHEME: _a,
  SYM: jf,
  TILDE: dc,
  TLD: iy,
  UNDERSCORE: Bf,
  UTLD: sy,
  UWORD: ry,
  WORD: Qi,
  WS: oy
});
const Ki = /[a-z]/, Nl = new RegExp("\\p{L}", "u"), Rm = new RegExp("\\p{Emoji}", "u"), Ji = /\d/, km = /\s/, CA = "\r", Mm = `
`, k9 = "️", M9 = "‍", _m = "￼";
let od = null, ad = null;
function _9(n = []) {
  const e = {};
  hr.groups = e;
  const t = new hr();
  od == null && (od = DA(E9)), ad == null && (ad = DA(A9)), de(t, "'", Df), de(t, "{", ac), de(t, "}", lc), de(t, "[", ff), de(t, "]", hf), de(t, "(", pf), de(t, ")", mf), de(t, "<", gf), de(t, ">", yf), de(t, "（", vf), de(t, "）", bf), de(t, "「", xf), de(t, "」", Sf), de(t, "『", wf), de(t, "』", Ef), de(t, "＜", Af), de(t, "＞", Tf), de(t, "&", Cf), de(t, "*", Rf), de(t, "@", Is), de(t, "`", Mf), de(t, "^", _f), de(t, ":", Ls), de(t, ",", Xv), de(t, "$", Of), de(t, ".", Ai), de(t, "=", If), de(t, "!", e0), de(t, "-", Wr), de(t, "%", cc), de(t, "|", Nf), de(t, "+", Pf), de(t, "#", Lf), de(t, "?", uc), de(t, '"', t0), de(t, "/", Ti), de(t, ";", n0), de(t, "~", dc), de(t, "_", Bf), de(t, "\\", kf), de(t, "・", cM);
  const r = qt(t, Ji, Qv, {
    [Xg]: !0
  });
  qt(r, Ji, r);
  const i = qt(r, Ki, aM, {
    [oc]: !0
  }), s = qt(r, Nl, lM, {
    [Wl]: !0
  }), o = qt(t, Ki, Qi, {
    [ey]: !0
  });
  qt(o, Ji, i), qt(o, Ki, o), qt(i, Ji, i), qt(i, Ki, i);
  const a = qt(t, Nl, ry, {
    [ty]: !0
  });
  qt(a, Ki), qt(a, Ji, s), qt(a, Nl, a), qt(s, Ji, s), qt(s, Ki), qt(s, Nl, s);
  const c = de(t, Mm, Zv, {
    [Dm]: !0
  }), u = de(t, CA, oy, {
    [Dm]: !0
  }), d = qt(t, km, oy, {
    [Dm]: !0
  });
  de(t, _m, d), de(u, Mm, c), de(u, _m, d), qt(u, km, d), de(d, CA), de(d, Mm), qt(d, km, d), de(d, _m, d);
  const h = qt(t, Rm, uM, {
    [oM]: !0
  });
  de(h, "#"), qt(h, Rm, h), de(h, k9, h);
  const p = de(h, M9);
  de(p, "#"), qt(p, Rm, h);
  const g = [[Ki, o], [Ji, i]], y = [[Ki, null], [Nl, a], [Ji, s]];
  for (let b = 0; b < od.length; b++)
    ks(t, od[b], iy, Qi, g);
  for (let b = 0; b < ad.length; b++)
    ks(t, ad[b], sy, ry, y);
  No(iy, {
    tld: !0,
    ascii: !0
  }, e), No(sy, {
    utld: !0,
    alpha: !0
  }, e), ks(t, "file", Dd, Qi, g), ks(t, "mailto", Dd, Qi, g), ks(t, "http", _a, Qi, g), ks(t, "https", _a, Qi, g), ks(t, "ftp", _a, Qi, g), ks(t, "ftps", _a, Qi, g), No(Dd, {
    scheme: !0,
    ascii: !0
  }, e), No(_a, {
    slashscheme: !0,
    ascii: !0
  }, e), n = n.sort((b, S) => b[0] > S[0] ? 1 : -1);
  for (let b = 0; b < n.length; b++) {
    const S = n[b][0], T = n[b][1] ? {
      [T9]: !0
    } : {
      [C9]: !0
    };
    S.indexOf("-") >= 0 ? T[ny] = !0 : Ki.test(S) ? Ji.test(S) ? T[oc] = !0 : T[ey] = !0 : T[Xg] = !0, TA(t, S, S, T);
  }
  return TA(t, "localhost", Nc, {
    ascii: !0
  }), t.jd = new hr(jf), {
    start: t,
    tokens: Object.assign({
      groups: e
    }, dM)
  };
}
function fM(n, e) {
  const t = O9(e.replace(/[A-Z]/g, (a) => a.toLowerCase())), r = t.length, i = [];
  let s = 0, o = 0;
  for (; o < r; ) {
    let a = n, c = null, u = 0, d = null, h = -1, p = -1;
    for (; o < r && (c = a.go(t[o])); )
      a = c, a.accepts() ? (h = 0, p = 0, d = a) : h >= 0 && (h += t[o].length, p++), u += t[o].length, s += t[o].length, o++;
    s -= h, o -= p, u -= h, i.push({
      t: d.t,
      // token type/name
      v: e.slice(s - u, s),
      // string value
      s: s - u,
      // start index
      e: s
      // end index (excluding)
    });
  }
  return i;
}
function O9(n) {
  const e = [], t = n.length;
  let r = 0;
  for (; r < t; ) {
    let i = n.charCodeAt(r), s, o = i < 55296 || i > 56319 || r + 1 === t || (s = n.charCodeAt(r + 1)) < 56320 || s > 57343 ? n[r] : n.slice(r, r + 2);
    e.push(o), r += o.length;
  }
  return e;
}
function ks(n, e, t, r, i) {
  let s;
  const o = e.length;
  for (let a = 0; a < o - 1; a++) {
    const c = e[a];
    n.j[c] ? s = n.j[c] : (s = new hr(r), s.jr = i.slice(), n.j[c] = s), n = s;
  }
  return s = new hr(t), s.jr = i.slice(), n.j[e[o - 1]] = s, s;
}
function DA(n) {
  const e = [], t = [];
  let r = 0, i = "0123456789";
  for (; r < n.length; ) {
    let s = 0;
    for (; i.indexOf(n[r + s]) >= 0; )
      s++;
    if (s > 0) {
      e.push(t.join(""));
      for (let o = parseInt(n.substring(r, r + s), 10); o > 0; o--)
        t.pop();
      r += s;
    } else
      t.push(n[r]), r++;
  }
  return e;
}
const Pc = {
  defaultProtocol: "http",
  events: null,
  format: RA,
  formatHref: RA,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function r0(n, e = null) {
  let t = Object.assign({}, Pc);
  n && (t = Object.assign(t, n instanceof r0 ? n.o : n));
  const r = t.ignoreTags, i = [];
  for (let s = 0; s < r.length; s++)
    i.push(r[s].toUpperCase());
  this.o = t, e && (this.defaultRender = e), this.ignoreTags = i;
}
r0.prototype = {
  o: Pc,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(n) {
    return n;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(n) {
    return this.get("validate", n.toString(), n);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(n, e, t) {
    const r = e != null;
    let i = this.o[n];
    return i && (typeof i == "object" ? (i = t.t in i ? i[t.t] : Pc[n], typeof i == "function" && r && (i = i(e, t))) : typeof i == "function" && r && (i = i(e, t.t, t)), i);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(n, e, t) {
    let r = this.o[n];
    return typeof r == "function" && e != null && (r = r(e, t.t, t)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(n) {
    const e = n.render(this);
    return (this.get("render", null, n) || this.defaultRender)(e, n.t, n);
  }
};
function RA(n) {
  return n;
}
function hM(n, e) {
  this.t = "token", this.v = n, this.tk = e;
}
hM.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(n) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(n) {
    const e = this.toString(), t = n.get("truncate", e, this), r = n.get("format", e, this);
    return t && r.length > t ? r.substring(0, t) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(n) {
    return n.get("formatHref", this.toHref(n.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(n = Pc.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(n) {
    return {
      type: this.t,
      value: this.toFormattedString(n),
      isLink: this.isLink,
      href: this.toFormattedHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(n) {
    return n.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(n) {
    const e = this, t = this.toHref(n.get("defaultProtocol")), r = n.get("formatHref", t, this), i = n.get("tagName", t, e), s = this.toFormattedString(n), o = {}, a = n.get("className", t, e), c = n.get("target", t, e), u = n.get("rel", t, e), d = n.getObj("attributes", t, e), h = n.getObj("events", t, e);
    return o.href = r, a && (o.class = a), c && (o.target = c), u && (o.rel = u), d && Object.assign(o, d), {
      tagName: i,
      attributes: o,
      content: s,
      eventListeners: h
    };
  }
};
function hh(n, e) {
  class t extends hM {
    constructor(i, s) {
      super(i, s), this.t = n;
    }
  }
  for (const r in e)
    t.prototype[r] = e[r];
  return t.t = n, t;
}
const kA = hh("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), MA = hh("text"), I9 = hh("nl"), ld = hh("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(n = Pc.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${n}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const n = this.tk;
    return n.length >= 2 && n[0].t !== Nc && n[1].t === Ls;
  }
}), Hr = (n) => new hr(n);
function N9({
  groups: n
}) {
  const e = n.domain.concat([Cf, Rf, Is, kf, Mf, _f, Of, If, Wr, Qv, cc, Nf, Pf, Lf, Ti, jf, dc, Bf]), t = [Df, Ls, Xv, Ai, e0, cc, uc, t0, n0, gf, yf, ac, lc, hf, ff, pf, mf, vf, bf, xf, Sf, wf, Ef, Af, Tf], r = [Cf, Df, Rf, kf, Mf, _f, Of, If, Wr, ac, lc, cc, Nf, Pf, Lf, uc, Ti, jf, dc, Bf], i = Hr(), s = de(i, dc);
  Qe(s, r, s), Qe(s, n.domain, s);
  const o = Hr(), a = Hr(), c = Hr();
  Qe(i, n.domain, o), Qe(i, n.scheme, a), Qe(i, n.slashscheme, c), Qe(o, r, s), Qe(o, n.domain, o);
  const u = de(o, Is);
  de(s, Is, u), de(a, Is, u), de(c, Is, u);
  const d = de(s, Ai);
  Qe(d, r, s), Qe(d, n.domain, s);
  const h = Hr();
  Qe(u, n.domain, h), Qe(h, n.domain, h);
  const p = de(h, Ai);
  Qe(p, n.domain, h);
  const g = Hr(kA);
  Qe(p, n.tld, g), Qe(p, n.utld, g), de(u, Nc, g);
  const y = de(h, Wr);
  de(y, Wr, y), Qe(y, n.domain, h), Qe(g, n.domain, h), de(g, Ai, p), de(g, Wr, y);
  const b = de(g, Ls);
  Qe(b, n.numeric, kA);
  const S = de(o, Wr), w = de(o, Ai);
  de(S, Wr, S), Qe(S, n.domain, o), Qe(w, r, s), Qe(w, n.domain, o);
  const T = Hr(ld);
  Qe(w, n.tld, T), Qe(w, n.utld, T), Qe(T, n.domain, o), Qe(T, r, s), de(T, Ai, w), de(T, Wr, S), de(T, Is, u);
  const C = de(T, Ls), k = Hr(ld);
  Qe(C, n.numeric, k);
  const R = Hr(ld), N = Hr();
  Qe(R, e, R), Qe(R, t, N), Qe(N, e, R), Qe(N, t, N), de(T, Ti, R), de(k, Ti, R);
  const L = de(a, Ls), j = de(c, Ls), W = de(j, Ti), Z = de(W, Ti);
  Qe(a, n.domain, o), de(a, Ai, w), de(a, Wr, S), Qe(c, n.domain, o), de(c, Ai, w), de(c, Wr, S), Qe(L, n.domain, R), de(L, Ti, R), de(L, uc, R), Qe(Z, n.domain, R), Qe(Z, e, R), de(Z, Ti, R);
  const fe = [
    [ac, lc],
    // {}
    [ff, hf],
    // []
    [pf, mf],
    // ()
    [gf, yf],
    // <>
    [vf, bf],
    // （）
    [xf, Sf],
    // 「」
    [wf, Ef],
    // 『』
    [Af, Tf]
    // ＜＞
  ];
  for (let Oe = 0; Oe < fe.length; Oe++) {
    const [Ae, Y] = fe[Oe], re = de(R, Ae);
    de(N, Ae, re), de(re, Y, R);
    const q = Hr(ld);
    Qe(re, e, q);
    const U = Hr();
    Qe(re, t), Qe(q, e, q), Qe(q, t, U), Qe(U, e, q), Qe(U, t, U), de(q, Y, R), de(U, Y, R);
  }
  return de(i, Nc, T), de(i, Zv, I9), {
    start: i,
    tokens: dM
  };
}
function P9(n, e, t) {
  let r = t.length, i = 0, s = [], o = [];
  for (; i < r; ) {
    let a = n, c = null, u = null, d = 0, h = null, p = -1;
    for (; i < r && !(c = a.go(t[i].t)); )
      o.push(t[i++]);
    for (; i < r && (u = c || a.go(t[i].t)); )
      c = null, a = u, a.accepts() ? (p = 0, h = a) : p >= 0 && p++, i++, d++;
    if (p < 0)
      i -= d, i < r && (o.push(t[i]), i++);
    else {
      o.length > 0 && (s.push(Om(MA, e, o)), o = []), i -= p, d -= p;
      const g = h.t, y = t.slice(i - d, i);
      s.push(Om(g, e, y));
    }
  }
  return o.length > 0 && s.push(Om(MA, e, o)), s;
}
function Om(n, e, t) {
  const r = t[0].s, i = t[t.length - 1].e, s = e.slice(r, i);
  return new n(s, t);
}
const L9 = typeof console < "u" && console && console.warn || (() => {
}), B9 = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", _t = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function j9() {
  return hr.groups = {}, _t.scanner = null, _t.parser = null, _t.tokenQueue = [], _t.pluginQueue = [], _t.customSchemes = [], _t.initialized = !1, _t;
}
function _A(n, e = !1) {
  if (_t.initialized && L9(`linkifyjs: already initialized - will not register custom scheme "${n}" ${B9}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(n))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  _t.customSchemes.push([n, e]);
}
function F9() {
  _t.scanner = _9(_t.customSchemes);
  for (let n = 0; n < _t.tokenQueue.length; n++)
    _t.tokenQueue[n][1]({
      scanner: _t.scanner
    });
  _t.parser = N9(_t.scanner.tokens);
  for (let n = 0; n < _t.pluginQueue.length; n++)
    _t.pluginQueue[n][1]({
      scanner: _t.scanner,
      parser: _t.parser
    });
  return _t.initialized = !0, _t;
}
function i0(n) {
  return _t.initialized || F9(), P9(_t.parser.start, n, fM(_t.scanner.start, n));
}
i0.scan = fM;
function pM(n, e = null, t = null) {
  if (e && typeof e == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    t = e, e = null;
  }
  const r = new r0(t), i = i0(n), s = [];
  for (let o = 0; o < i.length; o++) {
    const a = i[o];
    a.isLink && (!e || a.t === e) && r.check(a) && s.push(a.toFormattedObject(r));
  }
  return s;
}
const s0 = "[\0-   ᠎ -\u2029 　]", z9 = new RegExp(s0), V9 = new RegExp(`${s0}$`), H9 = new RegExp(s0, "g");
function U9(n) {
  return n.length === 1 ? n[0].isLink : n.length === 3 && n[1].isLink ? ["()", "[]"].includes(n[0].value + n[2].value) : !1;
}
function W9(n) {
  return new An({
    key: new yr("autolink"),
    appendTransaction: (e, t, r) => {
      const i = e.some((u) => u.docChanged) && !t.doc.eq(r.doc), s = e.some((u) => u.getMeta("preventAutolink"));
      if (!i || s)
        return;
      const { tr: o } = r, a = I8(t.doc, [...e]);
      if (V8(a).forEach(({ newRange: u }) => {
        const d = P8(r.doc, u, (g) => g.isTextblock);
        let h, p;
        if (d.length > 1)
          h = d[0], p = r.doc.textBetween(h.pos, h.pos + h.node.nodeSize, void 0, " ");
        else if (d.length) {
          const g = r.doc.textBetween(u.from, u.to, " ", " ");
          if (!V9.test(g))
            return;
          h = d[0], p = r.doc.textBetween(h.pos, u.to, void 0, " ");
        }
        if (h && p) {
          const g = p.split(z9).filter(Boolean);
          if (g.length <= 0)
            return !1;
          const y = g[g.length - 1], b = h.pos + p.lastIndexOf(y);
          if (!y)
            return !1;
          const S = i0(y).map((w) => w.toObject(n.defaultProtocol));
          if (!U9(S))
            return !1;
          S.filter((w) => w.isLink).map((w) => ({
            ...w,
            from: b + w.start + 1,
            to: b + w.end + 1
          })).filter((w) => r.schema.marks.code ? !r.doc.rangeHasMark(w.from, w.to, r.schema.marks.code) : !0).filter((w) => n.validate(w.value)).filter((w) => n.shouldAutoLink(w.value)).forEach((w) => {
            Jv(w.from, w.to, r.doc).some((T) => T.mark.type === n.type) || o.addMark(w.from, w.to, n.type.create({
              href: w.href
            }));
          });
        }
      }), !!o.steps.length)
        return o;
    }
  });
}
function $9(n) {
  return new An({
    key: new yr("handleClickLink"),
    props: {
      handleClick: (e, t, r) => {
        var i, s;
        if (r.button !== 0 || !e.editable)
          return !1;
        let o = r.target;
        const a = [];
        for (; o.nodeName !== "DIV"; )
          a.push(o), o = o.parentNode;
        if (!a.find((p) => p.nodeName === "A"))
          return !1;
        const c = sM(e.state, n.type.name), u = r.target, d = (i = u == null ? void 0 : u.href) !== null && i !== void 0 ? i : c.href, h = (s = u == null ? void 0 : u.target) !== null && s !== void 0 ? s : c.target;
        return u && d ? (window.open(d, h), !0) : !1;
      }
    }
  });
}
function G9(n) {
  return new An({
    key: new yr("handlePasteLink"),
    props: {
      handlePaste: (e, t, r) => {
        const { state: i } = e, { selection: s } = i, { empty: o } = s;
        if (o)
          return !1;
        let a = "";
        r.content.forEach((u) => {
          a += u.textContent;
        });
        const c = pM(a, { defaultProtocol: n.defaultProtocol }).find((u) => u.isLink && u.value === a);
        return !a || !c ? !1 : n.editor.commands.setMark(n.type, {
          href: c.href
        });
      }
    }
  });
}
function So(n, e) {
  const t = [
    "http",
    "https",
    "ftp",
    "ftps",
    "mailto",
    "tel",
    "callto",
    "sms",
    "cid",
    "xmpp"
  ];
  return e && e.forEach((r) => {
    const i = typeof r == "string" ? r : r.scheme;
    i && t.push(i);
  }), !n || n.replace(H9, "").match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `^(?:(?:${t.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
    "i"
  ));
}
const Y9 = Pi.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((n) => {
      if (typeof n == "string") {
        _A(n);
        return;
      }
      _A(n.scheme, n.optionalSlashes);
    });
  },
  onDestroy() {
    j9();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (n, e) => !!So(n, e.protocols),
      validate: (n) => !!n,
      shouldAutoLink: (n) => !!n
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(n) {
          return n.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (n) => {
          const e = n.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (t) => !!So(t, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return this.options.isAllowedUri(n.href, {
      defaultValidate: (e) => !!So(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", En(this.options.HTMLAttributes, n), 0] : [
      "a",
      En(this.options.HTMLAttributes, { ...n, href: "" }),
      0
    ];
  },
  addCommands() {
    return {
      setLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (r) => !!So(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, n).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (r) => !!So(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().toggleMark(this.name, n, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run() : !1;
      },
      unsetLink: () => ({ chain: n }) => n().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Ko({
        find: (n) => {
          const e = [];
          if (n) {
            const { protocols: t, defaultProtocol: r } = this.options, i = pM(n).filter((s) => s.isLink && this.options.isAllowedUri(s.value, {
              defaultValidate: (o) => !!So(o, t),
              protocols: t,
              defaultProtocol: r
            }));
            i.length && i.forEach((s) => e.push({
              text: s.value,
              data: {
                href: s.href
              },
              index: s.start
            }));
          }
          return e;
        },
        type: this.type,
        getAttributes: (n) => {
          var e;
          return {
            href: (e = n.data) === null || e === void 0 ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const n = [], { protocols: e, defaultProtocol: t } = this.options;
    return this.options.autolink && n.push(W9({
      type: this.type,
      defaultProtocol: this.options.defaultProtocol,
      validate: (r) => this.options.isAllowedUri(r, {
        defaultValidate: (i) => !!So(i, e),
        protocols: e,
        defaultProtocol: t
      }),
      shouldAutoLink: this.options.shouldAutoLink
    })), this.options.openOnClick === !0 && n.push($9({
      type: this.type
    })), this.options.linkOnPaste && n.push(G9({
      editor: this.editor,
      defaultProtocol: this.options.defaultProtocol,
      type: this.type
    })), n;
  }
}), q9 = Un.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new An({
        key: new yr("placeholder"),
        props: {
          decorations: ({ doc: n, selection: e }) => {
            const t = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: r } = e, i = [];
            if (!t)
              return null;
            const s = this.editor.isEmpty;
            return n.descendants((o, a) => {
              const c = r >= a && r <= a + o.nodeSize, u = !o.isLeaf && fh(o);
              if ((c || !this.options.showOnlyCurrent) && u) {
                const d = [this.options.emptyNodeClass];
                s && d.push(this.options.emptyEditorClass);
                const h = Dr.node(a, a + o.nodeSize, {
                  class: d.join(" "),
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: o,
                    pos: a,
                    hasAnchor: c
                  }) : this.options.placeholder
                });
                i.push(h);
              }
              return this.options.includeChildren;
            }), sn.create(n, i);
          }
        }
      })
    ];
  }
}), K9 = Pi.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["u", En(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: n }) => n.setMark(this.name),
      toggleUnderline: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetUnderline: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
function J9(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var ay = { exports: {} }, Im = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var OA;
function Q9() {
  if (OA) return Im;
  OA = 1;
  var n = ze;
  function e(h, p) {
    return h === p && (h !== 0 || 1 / h === 1 / p) || h !== h && p !== p;
  }
  var t = typeof Object.is == "function" ? Object.is : e, r = n.useState, i = n.useEffect, s = n.useLayoutEffect, o = n.useDebugValue;
  function a(h, p) {
    var g = p(), y = r({ inst: { value: g, getSnapshot: p } }), b = y[0].inst, S = y[1];
    return s(function() {
      b.value = g, b.getSnapshot = p, c(b) && S({ inst: b });
    }, [h, g, p]), i(function() {
      return c(b) && S({ inst: b }), h(function() {
        c(b) && S({ inst: b });
      });
    }, [h]), o(g), g;
  }
  function c(h) {
    var p = h.getSnapshot;
    h = h.value;
    try {
      var g = p();
      return !t(h, g);
    } catch {
      return !0;
    }
  }
  function u(h, p) {
    return p();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : a;
  return Im.useSyncExternalStore = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : d, Im;
}
var Nm = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var IA;
function Z9() {
  return IA || (IA = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var n = ze, e = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function t(C) {
      {
        for (var k = arguments.length, R = new Array(k > 1 ? k - 1 : 0), N = 1; N < k; N++)
          R[N - 1] = arguments[N];
        r("error", C, R);
      }
    }
    function r(C, k, R) {
      {
        var N = e.ReactDebugCurrentFrame, L = N.getStackAddendum();
        L !== "" && (k += "%s", R = R.concat([L]));
        var j = R.map(function(W) {
          return String(W);
        });
        j.unshift("Warning: " + k), Function.prototype.apply.call(console[C], console, j);
      }
    }
    function i(C, k) {
      return C === k && (C !== 0 || 1 / C === 1 / k) || C !== C && k !== k;
    }
    var s = typeof Object.is == "function" ? Object.is : i, o = n.useState, a = n.useEffect, c = n.useLayoutEffect, u = n.useDebugValue, d = !1, h = !1;
    function p(C, k, R) {
      d || n.startTransition !== void 0 && (d = !0, t("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var N = k();
      if (!h) {
        var L = k();
        s(N, L) || (t("The result of getSnapshot should be cached to avoid an infinite loop"), h = !0);
      }
      var j = o({
        inst: {
          value: N,
          getSnapshot: k
        }
      }), W = j[0].inst, Z = j[1];
      return c(function() {
        W.value = N, W.getSnapshot = k, g(W) && Z({
          inst: W
        });
      }, [C, N, k]), a(function() {
        g(W) && Z({
          inst: W
        });
        var fe = function() {
          g(W) && Z({
            inst: W
          });
        };
        return C(fe);
      }, [C]), u(N), N;
    }
    function g(C) {
      var k = C.getSnapshot, R = C.value;
      try {
        var N = k();
        return !s(R, N);
      } catch {
        return !0;
      }
    }
    function y(C, k, R) {
      return k();
    }
    var b = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", S = !b, w = S ? y : p, T = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : w;
    Nm.useSyncExternalStore = T, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Nm;
}
process.env.NODE_ENV === "production" ? ay.exports = Q9() : ay.exports = Z9();
var ph = ay.exports;
const X9 = (...n) => (e) => {
  n.forEach((t) => {
    typeof t == "function" ? t(e) : t && (t.current = e);
  });
}, e7 = ({ contentComponent: n }) => {
  const e = ph.useSyncExternalStore(n.subscribe, n.getSnapshot, n.getServerSnapshot);
  return ze.createElement(ze.Fragment, null, Object.values(e));
};
function t7() {
  const n = /* @__PURE__ */ new Set();
  let e = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(t) {
      return n.add(t), () => {
        n.delete(t);
      };
    },
    getSnapshot() {
      return e;
    },
    getServerSnapshot() {
      return e;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(t, r) {
      e = {
        ...e,
        [t]: uB.createPortal(r.reactElement, r.element, t)
      }, n.forEach((i) => i());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(t) {
      const r = { ...e };
      delete r[t], e = r, n.forEach((i) => i());
    }
  };
}
class n7 extends ze.Component {
  constructor(e) {
    var t;
    super(e), this.editorContentRef = ze.createRef(), this.initialized = !1, this.state = {
      hasContentComponentInitialized: !!(!((t = e.editor) === null || t === void 0) && t.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const e = this.props.editor;
    if (e && !e.isDestroyed && e.options.element) {
      if (e.contentComponent)
        return;
      const t = this.editorContentRef.current;
      t.append(...e.options.element.childNodes), e.setOptions({
        element: t
      }), e.contentComponent = t7(), this.state.hasContentComponentInitialized || (this.unsubscribeToContentComponent = e.contentComponent.subscribe(() => {
        this.setState((r) => r.hasContentComponentInitialized ? r : {
          hasContentComponentInitialized: !0
        }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent();
      })), e.createNodeViews(), this.initialized = !0;
    }
  }
  componentWillUnmount() {
    const e = this.props.editor;
    if (!e || (this.initialized = !1, e.isDestroyed || e.view.setProps({
      nodeViews: {}
    }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent(), e.contentComponent = null, !e.options.element.firstChild))
      return;
    const t = document.createElement("div");
    t.append(...e.options.element.childNodes), e.setOptions({
      element: t
    });
  }
  render() {
    const { editor: e, innerRef: t, ...r } = this.props;
    return ze.createElement(
      ze.Fragment,
      null,
      ze.createElement("div", { ref: X9(t, this.editorContentRef), ...r }),
      (e == null ? void 0 : e.contentComponent) && ze.createElement(e7, { contentComponent: e.contentComponent })
    );
  }
}
const r7 = hs((n, e) => {
  const t = ze.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [n.editor]);
  return ze.createElement(n7, {
    key: t,
    innerRef: e,
    ...n
  });
});
ze.memo(r7);
var i7 = function n(e, t) {
  if (e === t) return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor) return !1;
    var r, i, s;
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length) return !1;
      for (i = r; i-- !== 0; )
        if (!n(e[i], t[i])) return !1;
      return !0;
    }
    if (e instanceof Map && t instanceof Map) {
      if (e.size !== t.size) return !1;
      for (i of e.entries())
        if (!t.has(i[0])) return !1;
      for (i of e.entries())
        if (!n(i[1], t.get(i[0]))) return !1;
      return !0;
    }
    if (e instanceof Set && t instanceof Set) {
      if (e.size !== t.size) return !1;
      for (i of e.entries())
        if (!t.has(i[0])) return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (r = e.length, r != t.length) return !1;
      for (i = r; i-- !== 0; )
        if (e[i] !== t[i]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
    if (s = Object.keys(e), r = s.length, r !== Object.keys(t).length) return !1;
    for (i = r; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, s[i])) return !1;
    for (i = r; i-- !== 0; ) {
      var o = s[i];
      if (!(o === "_owner" && e.$$typeof) && !n(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}, s7 = /* @__PURE__ */ J9(i7), ly = { exports: {} }, Pm = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var NA;
function o7() {
  if (NA) return Pm;
  NA = 1;
  var n = ze, e = ph;
  function t(u, d) {
    return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
  }
  var r = typeof Object.is == "function" ? Object.is : t, i = e.useSyncExternalStore, s = n.useRef, o = n.useEffect, a = n.useMemo, c = n.useDebugValue;
  return Pm.useSyncExternalStoreWithSelector = function(u, d, h, p, g) {
    var y = s(null);
    if (y.current === null) {
      var b = { hasValue: !1, value: null };
      y.current = b;
    } else b = y.current;
    y = a(function() {
      function w(N) {
        if (!T) {
          if (T = !0, C = N, N = p(N), g !== void 0 && b.hasValue) {
            var L = b.value;
            if (g(L, N)) return k = L;
          }
          return k = N;
        }
        if (L = k, r(C, N)) return L;
        var j = p(N);
        return g !== void 0 && g(L, j) ? L : (C = N, k = j);
      }
      var T = !1, C, k, R = h === void 0 ? null : h;
      return [function() {
        return w(d());
      }, R === null ? void 0 : function() {
        return w(R());
      }];
    }, [d, h, p, g]);
    var S = i(u, y[0], y[1]);
    return o(function() {
      b.hasValue = !0, b.value = S;
    }, [S]), c(S), S;
  }, Pm;
}
var Lm = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var PA;
function a7() {
  return PA || (PA = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var n = ze, e = ph;
    function t(d, h) {
      return d === h && (d !== 0 || 1 / d === 1 / h) || d !== d && h !== h;
    }
    var r = typeof Object.is == "function" ? Object.is : t, i = e.useSyncExternalStore, s = n.useRef, o = n.useEffect, a = n.useMemo, c = n.useDebugValue;
    function u(d, h, p, g, y) {
      var b = s(null), S;
      b.current === null ? (S = {
        hasValue: !1,
        value: null
      }, b.current = S) : S = b.current;
      var w = a(function() {
        var R = !1, N, L, j = function(Oe) {
          if (!R) {
            R = !0, N = Oe;
            var Ae = g(Oe);
            if (y !== void 0 && S.hasValue) {
              var Y = S.value;
              if (y(Y, Ae))
                return L = Y, Y;
            }
            return L = Ae, Ae;
          }
          var re = N, q = L;
          if (r(re, Oe))
            return q;
          var U = g(Oe);
          return y !== void 0 && y(q, U) ? q : (N = Oe, L = U, U);
        }, W = p === void 0 ? null : p, Z = function() {
          return j(h());
        }, fe = W === null ? void 0 : function() {
          return j(W());
        };
        return [Z, fe];
      }, [h, p, g, y]), T = w[0], C = w[1], k = i(d, T, C);
      return o(function() {
        S.hasValue = !0, S.value = k;
      }, [k]), c(k), k;
    }
    Lm.useSyncExternalStoreWithSelector = u, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Lm;
}
process.env.NODE_ENV === "production" ? ly.exports = o7() : ly.exports = a7();
var l7 = ly.exports;
const c7 = typeof window < "u" ? gy : wt;
class u7 {
  constructor(e) {
    this.transactionNumber = 0, this.lastTransactionNumber = 0, this.subscribers = /* @__PURE__ */ new Set(), this.editor = e, this.lastSnapshot = { editor: e, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscribers.add(e), () => {
      this.subscribers.delete(e);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(e) {
    if (this.editor = e, this.editor) {
      const t = () => {
        this.transactionNumber += 1, this.subscribers.forEach((i) => i());
      }, r = this.editor;
      return r.on("transaction", t), () => {
        r.off("transaction", t);
      };
    }
  }
}
function d7(n) {
  var e;
  const [t] = Et(() => new u7(n.editor)), r = l7.useSyncExternalStoreWithSelector(t.subscribe, t.getSnapshot, t.getServerSnapshot, n.selector, (e = n.equalityFn) !== null && e !== void 0 ? e : s7);
  return c7(() => t.watch(n.editor), [n.editor, t]), x1(r), r;
}
const LA = process.env.NODE_ENV !== "production", cy = typeof window > "u", f7 = cy || !!(typeof window < "u" && window.next);
class o0 {
  constructor(e) {
    this.editor = null, this.subscriptions = /* @__PURE__ */ new Set(), this.isComponentMounted = !1, this.previousDeps = null, this.instanceId = "", this.options = e, this.subscriptions = /* @__PURE__ */ new Set(), this.setEditor(this.getInitialEditor()), this.scheduleDestroy(), this.getEditor = this.getEditor.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.subscribe = this.subscribe.bind(this), this.refreshEditorInstance = this.refreshEditorInstance.bind(this), this.scheduleDestroy = this.scheduleDestroy.bind(this), this.onRender = this.onRender.bind(this), this.createEditor = this.createEditor.bind(this);
  }
  setEditor(e) {
    this.editor = e, this.instanceId = Math.random().toString(36).slice(2, 9), this.subscriptions.forEach((t) => t());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0)
      return cy || f7 ? (LA && console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."), null) : this.createEditor();
    if (this.options.current.immediatelyRender && cy && LA)
      throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
    return this.options.current.immediatelyRender ? this.createEditor() : null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const e = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onBeforeCreate) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onBlur: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onBlur) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onCreate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onCreate) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onDestroy: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onDestroy) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onFocus: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onFocus) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onSelectionUpdate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onSelectionUpdate) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onTransaction: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onTransaction) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onUpdate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onUpdate) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onContentError: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onContentError) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onDrop: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onDrop) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onPaste: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onPaste) === null || s === void 0 ? void 0 : s.call(i, ...r);
      }
    };
    return new x9(e);
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscriptions.add(e), () => {
      this.subscriptions.delete(e);
    };
  }
  static compareOptions(e, t) {
    return Object.keys(e).every((r) => ["onCreate", "onBeforeCreate", "onDestroy", "onUpdate", "onTransaction", "onFocus", "onBlur", "onSelectionUpdate", "onContentError", "onDrop", "onPaste"].includes(r) ? !0 : r === "extensions" && e.extensions && t.extensions ? e.extensions.length !== t.extensions.length ? !1 : e.extensions.every((i, s) => {
      var o;
      return i === ((o = t.extensions) === null || o === void 0 ? void 0 : o[s]);
    }) : e[r] === t[r]);
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(e) {
    return () => (this.isComponentMounted = !0, clearTimeout(this.scheduledDestructionTimeout), this.editor && !this.editor.isDestroyed && e.length === 0 ? o0.compareOptions(this.options.current, this.editor.options) || this.editor.setOptions({
      ...this.options.current,
      editable: this.editor.isEditable
    }) : this.refreshEditorInstance(e), () => {
      this.isComponentMounted = !1, this.scheduleDestroy();
    });
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(e) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = e;
        return;
      }
      if (this.previousDeps.length === e.length && this.previousDeps.every((r, i) => r === e[i]))
        return;
    }
    this.editor && !this.editor.isDestroyed && this.editor.destroy(), this.setEditor(this.createEditor()), this.previousDeps = e;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const e = this.instanceId, t = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === e) {
        t && t.setOptions(this.options.current);
        return;
      }
      t && !t.isDestroyed && (t.destroy(), this.instanceId === e && this.setEditor(null));
    }, 1);
  }
}
function h7(n = {}, e = []) {
  const t = bt(n);
  t.current = n;
  const [r] = Et(() => new o0(t)), i = ph.useSyncExternalStore(r.subscribe, r.getEditor, r.getServerSnapshot);
  return x1(i), wt(r.onRender(e)), d7({
    editor: i,
    selector: ({ transactionNumber: s }) => n.shouldRerenderOnTransaction === !1 ? null : n.immediatelyRender && s === 0 ? 0 : s + 1
  }), i;
}
const p7 = ps({
  editor: null
});
p7.Consumer;
const m7 = ps({
  onDragStart: void 0
}), g7 = () => Nn(m7);
ze.forwardRef((n, e) => {
  const { onDragStart: t } = g7(), r = n.as || "div";
  return (
    // @ts-ignore
    ze.createElement(r, { ...n, ref: e, "data-node-view-wrapper": "", onDragStart: t, style: {
      whiteSpace: "normal",
      ...n.style
    } })
  );
});
const y7 = /^\s*>\s$/, v7 = gr.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["blockquote", En(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: n }) => n.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: n }) => n.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: n }) => n.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Ic({
        find: y7,
        type: this.type
      })
    ];
  }
}), b7 = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, x7 = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, S7 = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, w7 = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, E7 = Pi.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (n) => n.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (n) => /^(bold(er)?|[5-9]\d{2,})$/.test(n) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["strong", En(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: n }) => n.setMark(this.name),
      toggleBold: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetBold: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      tl({
        find: b7,
        type: this.type
      }),
      tl({
        find: S7,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ko({
        find: x7,
        type: this.type
      }),
      Ko({
        find: w7,
        type: this.type
      })
    ];
  }
}), A7 = "listItem", BA = "textStyle", jA = /^\s*([-+*])\s$/, T7 = gr.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", En(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(A7, this.editor.getAttributes(BA)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let n = Ic({
      find: jA,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Ic({
      find: jA,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(BA),
      editor: this.editor
    })), [
      n
    ];
  }
}), C7 = /(^|[^`])`([^`]+)`(?!`)/, D7 = /(^|[^`])`([^`]+)`(?!`)/g, R7 = Pi.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["code", En(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: n }) => n.setMark(this.name),
      toggleCode: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetCode: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      tl({
        find: C7,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ko({
        find: D7,
        type: this.type
      })
    ];
  }
}), k7 = /^```([a-z]+)?[\s\n]$/, M7 = /^~~~([a-z]+)?[\s\n]$/, _7 = gr.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (n) => {
          var e;
          const { languageClassPrefix: t } = this.options, s = [...((e = n.firstElementChild) === null || e === void 0 ? void 0 : e.classList) || []].filter((o) => o.startsWith(t)).map((o) => o.replace(t, ""))[0];
          return s || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [
      "pre",
      En(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: n.attrs.language ? this.options.languageClassPrefix + n.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (n) => ({ commands: e }) => e.setNode(this.name, n),
      toggleCodeBlock: (n) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", n)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: n, $anchor: e } = this.editor.state.selection, t = e.pos === 1;
        return !n || e.parent.type.name !== this.name ? !1 : t || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: n }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = n, { selection: t } = e, { $from: r, empty: i } = t;
        if (!i || r.parent.type !== this.type)
          return !1;
        const s = r.parentOffset === r.parent.nodeSize - 2, o = r.parent.textContent.endsWith(`

`);
        return !s || !o ? !1 : n.chain().command(({ tr: a }) => (a.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: n }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = n, { selection: t, doc: r } = e, { $from: i, empty: s } = t;
        if (!s || i.parent.type !== this.type || !(i.parentOffset === i.parent.nodeSize - 2))
          return !1;
        const a = i.after();
        return a === void 0 ? !1 : r.nodeAt(a) ? n.commands.command(({ tr: u }) => (u.setSelection(Xe.near(r.resolve(a))), !0)) : n.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      Zg({
        find: k7,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      }),
      Zg({
        find: M7,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new An({
        key: new yr("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (n, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const t = e.clipboardData.getData("text/plain"), r = e.clipboardData.getData("vscode-editor-data"), i = r ? JSON.parse(r) : void 0, s = i == null ? void 0 : i.mode;
            if (!t || !s)
              return !1;
            const { tr: o, schema: a } = n.state, c = a.text(t.replace(/\r\n?/g, `
`));
            return o.replaceSelectionWith(this.type.create({ language: s }, c)), o.selection.$from.parent.type !== this.type && o.setSelection(Ve.near(o.doc.resolve(Math.max(0, o.selection.from - 2)))), o.setMeta("paste", !0), n.dispatch(o), !0;
          }
        }
      })
    ];
  }
}), O7 = gr.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function I7(n = {}) {
  return new An({
    view(e) {
      return new N7(e, n);
    }
  });
}
class N7 {
  constructor(e, t) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = t.width) !== null && r !== void 0 ? r : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((i) => {
      let s = (o) => {
        this[i](o);
      };
      return e.dom.addEventListener(i, s), { name: i, handler: s };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: t }) => this.editorView.dom.removeEventListener(e, t));
  }
  update(e, t) {
    this.cursorPos != null && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), t = !e.parent.inlineContent, r, i = this.editorView.dom, s = i.getBoundingClientRect(), o = s.width / i.offsetWidth, a = s.height / i.offsetHeight;
    if (t) {
      let h = e.nodeBefore, p = e.nodeAfter;
      if (h || p) {
        let g = this.editorView.nodeDOM(this.cursorPos - (h ? h.nodeSize : 0));
        if (g) {
          let y = g.getBoundingClientRect(), b = h ? y.bottom : y.top;
          h && p && (b = (b + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let S = this.width / 2 * a;
          r = { left: y.left, right: y.right, top: b - S, bottom: b + S };
        }
      }
    }
    if (!r) {
      let h = this.editorView.coordsAtPos(this.cursorPos), p = this.width / 2 * o;
      r = { left: h.left - p, right: h.left + p, top: h.top, bottom: h.bottom };
    }
    let c = this.editorView.dom.offsetParent;
    this.element || (this.element = c.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let u, d;
    if (!c || c == document.body && getComputedStyle(c).position == "static")
      u = -pageXOffset, d = -pageYOffset;
    else {
      let h = c.getBoundingClientRect(), p = h.width / c.offsetWidth, g = h.height / c.offsetHeight;
      u = h.left - c.scrollLeft * p, d = h.top - c.scrollTop * g;
    }
    this.element.style.left = (r.left - u) / o + "px", this.element.style.top = (r.top - d) / a + "px", this.element.style.width = (r.right - r.left) / o + "px", this.element.style.height = (r.bottom - r.top) / a + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), i = r && r.type.spec.disableDropCursor, s = typeof i == "function" ? i(this.editorView, t, e) : i;
    if (t && !s) {
      let o = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let a = YR(this.editorView.state.doc, o, this.editorView.dragging.slice);
        a != null && (o = a);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    this.editorView.dom.contains(e.relatedTarget) || this.setCursor(null);
  }
}
const P7 = Un.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      I7(this.options)
    ];
  }
});
class Jt extends Xe {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    return Jt.valid(r) ? new Jt(r) : Xe.near(r);
  }
  content() {
    return Se.empty;
  }
  eq(e) {
    return e instanceof Jt && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new Jt(e.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new a0(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let t = e.parent;
    if (t.isTextblock || !L7(e) || !B7(e))
      return !1;
    let r = t.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let i = t.contentMatchAt(e.index()).defaultType;
    return i && i.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, t, r = !1) {
    e: for (; ; ) {
      if (!r && Jt.valid(e))
        return e;
      let i = e.pos, s = null;
      for (let o = e.depth; ; o--) {
        let a = e.node(o);
        if (t > 0 ? e.indexAfter(o) < a.childCount : e.index(o) > 0) {
          s = a.child(t > 0 ? e.indexAfter(o) : e.index(o) - 1);
          break;
        } else if (o == 0)
          return null;
        i += t;
        let c = e.doc.resolve(i);
        if (Jt.valid(c))
          return c;
      }
      for (; ; ) {
        let o = t > 0 ? s.firstChild : s.lastChild;
        if (!o) {
          if (s.isAtom && !s.isText && !Me.isSelectable(s)) {
            e = e.doc.resolve(i + s.nodeSize * t), r = !1;
            continue e;
          }
          break;
        }
        s = o, i += t;
        let a = e.doc.resolve(i);
        if (Jt.valid(a))
          return a;
      }
      return null;
    }
  }
}
Jt.prototype.visible = !1;
Jt.findFrom = Jt.findGapCursorFrom;
Xe.jsonID("gapcursor", Jt);
class a0 {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new a0(e.map(this.pos));
  }
  resolve(e) {
    let t = e.resolve(this.pos);
    return Jt.valid(t) ? new Jt(t) : Xe.near(t);
  }
}
function mM(n) {
  return n.isAtom || n.spec.isolating || n.spec.createGapCursor;
}
function L7(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.index(e), r = n.node(e);
    if (t == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(t - 1); ; i = i.lastChild) {
      if (i.childCount == 0 && !i.inlineContent || mM(i.type))
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function B7(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.indexAfter(e), r = n.node(e);
    if (t == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(t); ; i = i.firstChild) {
      if (i.childCount == 0 && !i.inlineContent || mM(i.type))
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function j7() {
  return new An({
    props: {
      decorations: H7,
      createSelectionBetween(n, e, t) {
        return e.pos == t.pos && Jt.valid(t) ? new Jt(t) : null;
      },
      handleClick: z7,
      handleKeyDown: F7,
      handleDOMEvents: { beforeinput: V7 }
    }
  });
}
const F7 = Lk({
  ArrowLeft: cd("horiz", -1),
  ArrowRight: cd("horiz", 1),
  ArrowUp: cd("vert", -1),
  ArrowDown: cd("vert", 1)
});
function cd(n, e) {
  const t = n == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, i, s) {
    let o = r.selection, a = e > 0 ? o.$to : o.$from, c = o.empty;
    if (o instanceof Ve) {
      if (!s.endOfTextblock(t) || a.depth == 0)
        return !1;
      c = !1, a = r.doc.resolve(e > 0 ? a.after() : a.before());
    }
    let u = Jt.findGapCursorFrom(a, e, c);
    return u ? (i && i(r.tr.setSelection(new Jt(u))), !0) : !1;
  };
}
function z7(n, e, t) {
  if (!n || !n.editable)
    return !1;
  let r = n.state.doc.resolve(e);
  if (!Jt.valid(r))
    return !1;
  let i = n.posAtCoords({ left: t.clientX, top: t.clientY });
  return i && i.inside > -1 && Me.isSelectable(n.state.doc.nodeAt(i.inside)) ? !1 : (n.dispatch(n.state.tr.setSelection(new Jt(r))), !0);
}
function V7(n, e) {
  if (e.inputType != "insertCompositionText" || !(n.state.selection instanceof Jt))
    return !1;
  let { $from: t } = n.state.selection, r = t.parent.contentMatchAt(t.index()).findWrapping(n.state.schema.nodes.text);
  if (!r)
    return !1;
  let i = ce.empty;
  for (let o = r.length - 1; o >= 0; o--)
    i = ce.from(r[o].createAndFill(null, i));
  let s = n.state.tr.replace(t.pos, t.pos, new Se(i, 0, 0));
  return s.setSelection(Ve.near(s.doc.resolve(t.pos + 1))), n.dispatch(s), !1;
}
function H7(n) {
  if (!(n.selection instanceof Jt))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", sn.create(n.doc, [Dr.widget(n.selection.head, e, { key: "gapcursor" })]);
}
const U7 = Un.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      j7()
    ];
  },
  extendNodeSchema(n) {
    var e;
    const t = {
      name: n.name,
      options: n.options,
      storage: n.storage
    };
    return {
      allowGapCursor: (e = tt(Ce(n, "allowGapCursor", t))) !== null && e !== void 0 ? e : null
    };
  }
}), W7 = gr.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", En(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: n, chain: e, state: t, editor: r }) => n.first([
        () => n.exitCode(),
        () => n.command(() => {
          const { selection: i, storedMarks: s } = t;
          if (i.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: o } = this.options, { splittableMarks: a } = r.extensionManager, c = s || i.$to.parentOffset && i.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: u, dispatch: d }) => {
            if (d && c && o) {
              const h = c.filter((p) => a.includes(p.type.name));
              u.ensureMarks(h);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), $7 = gr.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((n) => ({
      tag: `h${n}`,
      attrs: { level: n }
    }));
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(n.attrs.level) ? n.attrs.level : this.options.levels[0]}`, En(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.setNode(this.name, n) : !1,
      toggleHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.toggleNode(this.name, "paragraph", n) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((n, e) => ({
      ...n,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((n) => Zg({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${n}})\\s$`),
      type: this.type,
      getAttributes: {
        level: n
      }
    }));
  }
});
var Ff = 200, Sn = function() {
};
Sn.prototype.append = function(e) {
  return e.length ? (e = Sn.from(e), !this.length && e || e.length < Ff && this.leafAppend(e) || this.length < Ff && e.leafPrepend(this) || this.appendInner(e)) : this;
};
Sn.prototype.prepend = function(e) {
  return e.length ? Sn.from(e).append(this) : this;
};
Sn.prototype.appendInner = function(e) {
  return new G7(this, e);
};
Sn.prototype.slice = function(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = this.length), e >= t ? Sn.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
};
Sn.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
Sn.prototype.forEach = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length), t <= r ? this.forEachInner(e, t, r, 0) : this.forEachInvertedInner(e, t, r, 0);
};
Sn.prototype.map = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length);
  var i = [];
  return this.forEach(function(s, o) {
    return i.push(e(s, o));
  }, t, r), i;
};
Sn.from = function(e) {
  return e instanceof Sn ? e : e && e.length ? new gM(e) : Sn.empty;
};
var gM = /* @__PURE__ */ function(n) {
  function e(r) {
    n.call(this), this.values = r;
  }
  n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(i, s) {
    return i == 0 && s == this.length ? this : new e(this.values.slice(i, s));
  }, e.prototype.getInner = function(i) {
    return this.values[i];
  }, e.prototype.forEachInner = function(i, s, o, a) {
    for (var c = s; c < o; c++)
      if (i(this.values[c], a + c) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(i, s, o, a) {
    for (var c = s - 1; c >= o; c--)
      if (i(this.values[c], a + c) === !1)
        return !1;
  }, e.prototype.leafAppend = function(i) {
    if (this.length + i.length <= Ff)
      return new e(this.values.concat(i.flatten()));
  }, e.prototype.leafPrepend = function(i) {
    if (this.length + i.length <= Ff)
      return new e(i.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, t), e;
}(Sn);
Sn.empty = new gM([]);
var G7 = /* @__PURE__ */ function(n) {
  function e(t, r) {
    n.call(this), this.left = t, this.right = r, this.length = t.length + r.length, this.depth = Math.max(t.depth, r.depth) + 1;
  }
  return n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, i, s, o) {
    var a = this.left.length;
    if (i < a && this.left.forEachInner(r, i, Math.min(s, a), o) === !1 || s > a && this.right.forEachInner(r, Math.max(i - a, 0), Math.min(this.length, s) - a, o + a) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, i, s, o) {
    var a = this.left.length;
    if (i > a && this.right.forEachInvertedInner(r, i - a, Math.max(s, a) - a, o + a) === !1 || s < a && this.left.forEachInvertedInner(r, Math.min(i, a), s, o) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, i) {
    if (r == 0 && i == this.length)
      return this;
    var s = this.left.length;
    return i <= s ? this.left.slice(r, i) : r >= s ? this.right.slice(r - s, i - s) : this.left.slice(r, s).append(this.right.slice(0, i - s));
  }, e.prototype.leafAppend = function(r) {
    var i = this.right.leafAppend(r);
    if (i)
      return new e(this.left, i);
  }, e.prototype.leafPrepend = function(r) {
    var i = this.left.leafPrepend(r);
    if (i)
      return new e(i, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
}(Sn);
const Y7 = 500;
class ui {
  constructor(e, t) {
    this.items = e, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, t) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let i, s;
    t && (i = this.remapping(r, this.items.length), s = i.maps.length);
    let o = e.tr, a, c, u = [], d = [];
    return this.items.forEach((h, p) => {
      if (!h.step) {
        i || (i = this.remapping(r, p + 1), s = i.maps.length), s--, d.push(h);
        return;
      }
      if (i) {
        d.push(new Ci(h.map));
        let g = h.step.map(i.slice(s)), y;
        g && o.maybeStep(g).doc && (y = o.mapping.maps[o.mapping.maps.length - 1], u.push(new Ci(y, void 0, void 0, u.length + d.length))), s--, y && i.appendMap(y, s);
      } else
        o.maybeStep(h.step);
      if (h.selection)
        return a = i ? h.selection.map(i.slice(s)) : h.selection, c = new ui(this.items.slice(0, r).append(d.reverse().concat(u)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: c, transform: o, selection: a };
  }
  // Create a new branch with the given transform added.
  addTransform(e, t, r, i) {
    let s = [], o = this.eventCount, a = this.items, c = !i && a.length ? a.get(a.length - 1) : null;
    for (let d = 0; d < e.steps.length; d++) {
      let h = e.steps[d].invert(e.docs[d]), p = new Ci(e.mapping.maps[d], h, t), g;
      (g = c && c.merge(p)) && (p = g, d ? s.pop() : a = a.slice(0, a.length - 1)), s.push(p), t && (o++, t = void 0), i || (c = p);
    }
    let u = o - r.depth;
    return u > K7 && (a = q7(a, u), o -= u), new ui(a.append(s), o);
  }
  remapping(e, t) {
    let r = new Cc();
    return this.items.forEach((i, s) => {
      let o = i.mirrorOffset != null && s - i.mirrorOffset >= e ? r.maps.length - i.mirrorOffset : void 0;
      r.appendMap(i.map, o);
    }, e, t), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new ui(this.items.append(e.map((t) => new Ci(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, t) {
    if (!this.eventCount)
      return this;
    let r = [], i = Math.max(0, this.items.length - t), s = e.mapping, o = e.steps.length, a = this.eventCount;
    this.items.forEach((p) => {
      p.selection && a--;
    }, i);
    let c = t;
    this.items.forEach((p) => {
      let g = s.getMirror(--c);
      if (g == null)
        return;
      o = Math.min(o, g);
      let y = s.maps[g];
      if (p.step) {
        let b = e.steps[g].invert(e.docs[g]), S = p.selection && p.selection.map(s.slice(c + 1, g));
        S && a++, r.push(new Ci(y, b, S));
      } else
        r.push(new Ci(y));
    }, i);
    let u = [];
    for (let p = t; p < o; p++)
      u.push(new Ci(s.maps[p]));
    let d = this.items.slice(0, i).append(u).append(r), h = new ui(d, a);
    return h.emptyItemCount() > Y7 && (h = h.compress(this.items.length - r.length)), h;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((t) => {
      t.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let t = this.remapping(0, e), r = t.maps.length, i = [], s = 0;
    return this.items.forEach((o, a) => {
      if (a >= e)
        i.push(o), o.selection && s++;
      else if (o.step) {
        let c = o.step.map(t.slice(r)), u = c && c.getMap();
        if (r--, u && t.appendMap(u, r), c) {
          let d = o.selection && o.selection.map(t.slice(r));
          d && s++;
          let h = new Ci(u.invert(), c, d), p, g = i.length - 1;
          (p = i.length && i[g].merge(h)) ? i[g] = p : i.push(h);
        }
      } else o.map && r--;
    }, this.items.length, 0), new ui(Sn.from(i.reverse()), s);
  }
}
ui.empty = new ui(Sn.empty, 0);
function q7(n, e) {
  let t;
  return n.forEach((r, i) => {
    if (r.selection && e-- == 0)
      return t = i, !1;
  }), n.slice(t);
}
class Ci {
  constructor(e, t, r, i) {
    this.map = e, this.step = t, this.selection = r, this.mirrorOffset = i;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let t = e.step.merge(this.step);
      if (t)
        return new Ci(t.getMap().invert(), t, this.selection);
    }
  }
}
class Ns {
  constructor(e, t, r, i, s) {
    this.done = e, this.undone = t, this.prevRanges = r, this.prevTime = i, this.prevComposition = s;
  }
}
const K7 = 20;
function J7(n, e, t, r) {
  let i = t.getMeta(Vo), s;
  if (i)
    return i.historyState;
  t.getMeta(X7) && (n = new Ns(n.done, n.undone, null, 0, -1));
  let o = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return n;
  if (o && o.getMeta(Vo))
    return o.getMeta(Vo).redo ? new Ns(n.done.addTransform(t, void 0, r, Rd(e)), n.undone, FA(t.mapping.maps), n.prevTime, n.prevComposition) : new Ns(n.done, n.undone.addTransform(t, void 0, r, Rd(e)), null, n.prevTime, n.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let a = t.getMeta("composition"), c = n.prevTime == 0 || !o && n.prevComposition != a && (n.prevTime < (t.time || 0) - r.newGroupDelay || !Q7(t, n.prevRanges)), u = o ? Bm(n.prevRanges, t.mapping) : FA(t.mapping.maps);
    return new Ns(n.done.addTransform(t, c ? e.selection.getBookmark() : void 0, r, Rd(e)), ui.empty, u, t.time, a ?? n.prevComposition);
  } else return (s = t.getMeta("rebased")) ? new Ns(n.done.rebased(t, s), n.undone.rebased(t, s), Bm(n.prevRanges, t.mapping), n.prevTime, n.prevComposition) : new Ns(n.done.addMaps(t.mapping.maps), n.undone.addMaps(t.mapping.maps), Bm(n.prevRanges, t.mapping), n.prevTime, n.prevComposition);
}
function Q7(n, e) {
  if (!e)
    return !1;
  if (!n.docChanged)
    return !0;
  let t = !1;
  return n.mapping.maps[0].forEach((r, i) => {
    for (let s = 0; s < e.length; s += 2)
      r <= e[s + 1] && i >= e[s] && (t = !0);
  }), t;
}
function FA(n) {
  let e = [];
  for (let t = n.length - 1; t >= 0 && e.length == 0; t--)
    n[t].forEach((r, i, s, o) => e.push(s, o));
  return e;
}
function Bm(n, e) {
  if (!n)
    return null;
  let t = [];
  for (let r = 0; r < n.length; r += 2) {
    let i = e.map(n[r], 1), s = e.map(n[r + 1], -1);
    i <= s && t.push(i, s);
  }
  return t;
}
function Z7(n, e, t) {
  let r = Rd(e), i = Vo.get(e).spec.config, s = (t ? n.undone : n.done).popEvent(e, r);
  if (!s)
    return null;
  let o = s.selection.resolve(s.transform.doc), a = (t ? n.done : n.undone).addTransform(s.transform, e.selection.getBookmark(), i, r), c = new Ns(t ? a : s.remaining, t ? s.remaining : a, null, 0, -1);
  return s.transform.setSelection(o).setMeta(Vo, { redo: t, historyState: c });
}
let jm = !1, zA = null;
function Rd(n) {
  let e = n.plugins;
  if (zA != e) {
    jm = !1, zA = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].spec.historyPreserveItems) {
        jm = !0;
        break;
      }
  }
  return jm;
}
const Vo = new yr("history"), X7 = new yr("closeHistory");
function eK(n = {}) {
  return n = {
    depth: n.depth || 100,
    newGroupDelay: n.newGroupDelay || 500
  }, new An({
    key: Vo,
    state: {
      init() {
        return new Ns(ui.empty, ui.empty, null, 0, -1);
      },
      apply(e, t, r) {
        return J7(t, r, e, n);
      }
    },
    config: n,
    props: {
      handleDOMEvents: {
        beforeinput(e, t) {
          let r = t.inputType, i = r == "historyUndo" ? vM : r == "historyRedo" ? bM : null;
          return !i || !e.editable ? !1 : (t.preventDefault(), i(e.state, e.dispatch));
        }
      }
    }
  });
}
function yM(n, e) {
  return (t, r) => {
    let i = Vo.getState(t);
    if (!i || (n ? i.undone : i.done).eventCount == 0)
      return !1;
    if (r) {
      let s = Z7(i, t, n);
      s && r(e ? s.scrollIntoView() : s);
    }
    return !0;
  };
}
const vM = yM(!1, !0), bM = yM(!0, !0), tK = Un.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: n, dispatch: e }) => vM(n, e),
      redo: () => ({ state: n, dispatch: e }) => bM(n, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      eK(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), nK = gr.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["hr", En(this.options.HTMLAttributes, n)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: n, state: e }) => {
        if (!w9(e, e.schema.nodes[this.name]))
          return !1;
        const { selection: t } = e, { $from: r, $to: i } = t, s = n();
        return r.parentOffset === 0 ? s.insertContentAt({
          from: Math.max(r.pos - 1, 0),
          to: i.pos
        }, {
          type: this.name
        }) : U8(t) ? s.insertContentAt(i.pos, {
          type: this.name
        }) : s.insertContent({ type: this.name }), s.command(({ tr: o, dispatch: a }) => {
          var c;
          if (a) {
            const { $to: u } = o.selection, d = u.end();
            if (u.nodeAfter)
              u.nodeAfter.isTextblock ? o.setSelection(Ve.create(o.doc, u.pos + 1)) : u.nodeAfter.isBlock ? o.setSelection(Me.create(o.doc, u.pos)) : o.setSelection(Ve.create(o.doc, u.pos));
            else {
              const h = (c = u.parent.type.contentMatch.defaultType) === null || c === void 0 ? void 0 : c.create();
              h && (o.insert(d, h), o.setSelection(Ve.create(o.doc, d + 1)));
            }
            o.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      S9({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), rK = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, iK = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, sK = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, oK = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, aK = Pi.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (n) => n.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["em", En(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: n }) => n.setMark(this.name),
      toggleItalic: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetItalic: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      tl({
        find: rK,
        type: this.type
      }),
      tl({
        find: sK,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ko({
        find: iK,
        type: this.type
      }),
      Ko({
        find: oK,
        type: this.type
      })
    ];
  }
}), lK = gr.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", En(this.options.HTMLAttributes, n), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), cK = "listItem", VA = "textStyle", HA = /^(\d+)\.\s$/, uK = gr.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (n) => n.hasAttribute("start") ? parseInt(n.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (n) => n.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    const { start: e, ...t } = n;
    return e === 1 ? ["ol", En(this.options.HTMLAttributes, t), 0] : ["ol", En(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(cK, this.editor.getAttributes(VA)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let n = Ic({
      find: HA,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Ic({
      find: HA,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(VA) }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1],
      editor: this.editor
    })), [
      n
    ];
  }
}), dK = gr.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["p", En(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: n }) => n.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), fK = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, hK = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, pK = Pi.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["s", En(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: n }) => n.setMark(this.name),
      toggleStrike: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetStrike: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      tl({
        find: fK,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ko({
        find: hK,
        type: this.type
      })
    ];
  }
}), mK = gr.create({
  name: "text",
  group: "inline"
}), gK = Un.create({
  name: "starterKit",
  addExtensions() {
    const n = [];
    return this.options.bold !== !1 && n.push(E7.configure(this.options.bold)), this.options.blockquote !== !1 && n.push(v7.configure(this.options.blockquote)), this.options.bulletList !== !1 && n.push(T7.configure(this.options.bulletList)), this.options.code !== !1 && n.push(R7.configure(this.options.code)), this.options.codeBlock !== !1 && n.push(_7.configure(this.options.codeBlock)), this.options.document !== !1 && n.push(O7.configure(this.options.document)), this.options.dropcursor !== !1 && n.push(P7.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && n.push(U7.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && n.push(W7.configure(this.options.hardBreak)), this.options.heading !== !1 && n.push($7.configure(this.options.heading)), this.options.history !== !1 && n.push(tK.configure(this.options.history)), this.options.horizontalRule !== !1 && n.push(nK.configure(this.options.horizontalRule)), this.options.italic !== !1 && n.push(aK.configure(this.options.italic)), this.options.listItem !== !1 && n.push(lK.configure(this.options.listItem)), this.options.orderedList !== !1 && n.push(uK.configure(this.options.orderedList)), this.options.paragraph !== !1 && n.push(dK.configure(this.options.paragraph)), this.options.strike !== !1 && n.push(pK.configure(this.options.strike)), this.options.text !== !1 && n.push(mK.configure(this.options.text)), n;
  }
});
function fQ({
  value: n,
  onChange: e,
  placeholder: t = "",
  minHeight: r = 150,
  maxHeight: i,
  readOnly: s = !1,
  label: o,
  description: a,
  error: c,
  required: u,
  showInlineControls: d = !0,
  showListControls: h = !0,
  showLinkControls: p = !0,
  showHistoryControls: g = !0,
  showHeadingControls: y = !1,
  showClearFormatting: b = !0,
  sticky: S = !1,
  stickyOffset: w
}) {
  const T = h7({
    extensions: [
      gK,
      K9,
      Y9,
      q9.configure({
        placeholder: t
      })
    ],
    content: n ?? "",
    editable: !s,
    onUpdate: ({ editor: C }) => {
      e == null || e(C.getHTML());
    }
  });
  return wt(() => {
    if (!T) return;
    const C = T.getHTML();
    n !== C && !T.isFocused && T.commands.setContent(n ?? "");
  }, [n, T]), wt(() => {
    T && T.setEditable(!s);
  }, [s, T]), /* @__PURE__ */ x.jsx(fc.Wrapper, { label: o, description: a, error: c, required: u, children: /* @__PURE__ */ x.jsxs(
    jt,
    {
      editor: T,
      styles: {
        root: {
          borderColor: c ? "var(--mantine-color-red-filled)" : void 0,
          overflow: "hidden",
          transition: "border-color 0.2s ease, box-shadow 0.2s ease",
          "&:focus-within": {
            borderColor: c ? "var(--mantine-color-red-filled)" : "var(--mantine-color-blue-filled)",
            boxShadow: c ? "0 0 0 1px var(--mantine-color-red-filled)" : "0 0 0 1px var(--mantine-color-blue-filled)"
          }
        },
        content: {
          "& .ProseMirror": {
            minHeight: typeof r == "number" ? `${r}px` : r,
            maxHeight: typeof i == "number" ? `${i}px` : i,
            padding: "12px",
            outline: "none"
          },
          "& .ProseMirror p.is-editor-empty:first-of-type::before": {
            color: "var(--mantine-color-gray-4)",
            content: "attr(data-placeholder)",
            float: "left",
            height: 0,
            pointerEvents: "none"
          }
        }
      },
      children: [
        !s && /* @__PURE__ */ x.jsxs(jt.Toolbar, { sticky: S, stickyOffset: w, children: [
          d && /* @__PURE__ */ x.jsxs(jt.ControlsGroup, { children: [
            /* @__PURE__ */ x.jsx(jt.Bold, {}),
            /* @__PURE__ */ x.jsx(jt.Italic, {}),
            /* @__PURE__ */ x.jsx(jt.Underline, {}),
            /* @__PURE__ */ x.jsx(jt.Strikethrough, {})
          ] }),
          y && /* @__PURE__ */ x.jsxs(jt.ControlsGroup, { children: [
            /* @__PURE__ */ x.jsx(jt.H1, {}),
            /* @__PURE__ */ x.jsx(jt.H2, {}),
            /* @__PURE__ */ x.jsx(jt.H3, {}),
            /* @__PURE__ */ x.jsx(jt.H4, {})
          ] }),
          h && /* @__PURE__ */ x.jsxs(jt.ControlsGroup, { children: [
            /* @__PURE__ */ x.jsx(jt.BulletList, {}),
            /* @__PURE__ */ x.jsx(jt.OrderedList, {})
          ] }),
          p && /* @__PURE__ */ x.jsxs(jt.ControlsGroup, { children: [
            /* @__PURE__ */ x.jsx(jt.Link, {}),
            /* @__PURE__ */ x.jsx(jt.Unlink, {})
          ] }),
          b && /* @__PURE__ */ x.jsx(jt.ControlsGroup, { children: /* @__PURE__ */ x.jsx(jt.ClearFormatting, {}) }),
          g && /* @__PURE__ */ x.jsxs(jt.ControlsGroup, { children: [
            /* @__PURE__ */ x.jsx(jt.Undo, {}),
            /* @__PURE__ */ x.jsx(jt.Redo, {})
          ] })
        ] }),
        /* @__PURE__ */ x.jsx(jt.Content, {})
      ]
    }
  ) });
}
/*! @license DOMPurify 3.4.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.5/LICENSE */
function UA(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function yK(n) {
  if (Array.isArray(n)) return n;
}
function vK(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], c = !0, u = !1;
    try {
      if (s = (t = t.call(n)).next, e !== 0) for (; !(c = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); c = !0) ;
    } catch (d) {
      u = !0, i = d;
    } finally {
      try {
        if (!c && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (u) throw i;
      }
    }
    return a;
  }
}
function bK() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xK(n, e) {
  return yK(n) || vK(n, e) || SK(n, e) || bK();
}
function SK(n, e) {
  if (n) {
    if (typeof n == "string") return UA(n, e);
    var t = {}.toString.call(n).slice(8, -1);
    return t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set" ? Array.from(n) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? UA(n, e) : void 0;
  }
}
const xM = Object.entries, WA = Object.setPrototypeOf, wK = Object.isFrozen, EK = Object.getPrototypeOf, AK = Object.getOwnPropertyDescriptor;
let rr = Object.freeze, Xr = Object.seal, Oa = Object.create, SM = typeof Reflect < "u" && Reflect, uy = SM.apply, dy = SM.construct;
rr || (rr = function(e) {
  return e;
});
Xr || (Xr = function(e) {
  return e;
});
uy || (uy = function(e, t) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), s = 2; s < r; s++)
    i[s - 2] = arguments[s];
  return e.apply(t, i);
});
dy || (dy = function(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const wa = ln(Array.prototype.forEach), TK = ln(Array.prototype.lastIndexOf), $A = ln(Array.prototype.pop), Ea = ln(Array.prototype.push), CK = ln(Array.prototype.splice), Jn = Array.isArray, $l = ln(String.prototype.toLowerCase), Fm = ln(String.prototype.toString), GA = ln(String.prototype.match), Aa = ln(String.prototype.replace), YA = ln(String.prototype.indexOf), DK = ln(String.prototype.trim), RK = ln(Number.prototype.toString), kK = ln(Boolean.prototype.toString), qA = typeof BigInt > "u" ? null : ln(BigInt.prototype.toString), KA = typeof Symbol > "u" ? null : ln(Symbol.prototype.toString), Kt = ln(Object.prototype.hasOwnProperty), Pl = ln(Object.prototype.toString), kn = ln(RegExp.prototype.test), ud = MK(TypeError);
function ln(n) {
  return function(e) {
    e instanceof RegExp && (e.lastIndex = 0);
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
      r[i - 1] = arguments[i];
    return uy(n, e, r);
  };
}
function MK(n) {
  return function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return dy(n, t);
  };
}
function Ge(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $l;
  if (WA && WA(n, null), !Jn(e))
    return n;
  let r = e.length;
  for (; r--; ) {
    let i = e[r];
    if (typeof i == "string") {
      const s = t(i);
      s !== i && (wK(e) || (e[r] = s), i = s);
    }
    n[i] = !0;
  }
  return n;
}
function _K(n) {
  for (let e = 0; e < n.length; e++)
    Kt(n, e) || (n[e] = null);
  return n;
}
function fr(n) {
  const e = Oa(null);
  for (const r of xM(n)) {
    var t = xK(r, 2);
    const i = t[0], s = t[1];
    Kt(n, i) && (Jn(s) ? e[i] = _K(s) : s && typeof s == "object" && s.constructor === Object ? e[i] = fr(s) : e[i] = s);
  }
  return e;
}
function OK(n) {
  switch (typeof n) {
    case "string":
      return n;
    case "number":
      return RK(n);
    case "boolean":
      return kK(n);
    case "bigint":
      return qA ? qA(n) : "0";
    case "symbol":
      return KA ? KA(n) : "Symbol()";
    case "undefined":
      return Pl(n);
    case "function":
    case "object": {
      if (n === null)
        return Pl(n);
      const e = n, t = To(e, "toString");
      if (typeof t == "function") {
        const r = t(e);
        return typeof r == "string" ? r : Pl(r);
      }
      return Pl(n);
    }
    default:
      return Pl(n);
  }
}
function To(n, e) {
  for (; n !== null; ) {
    const r = AK(n, e);
    if (r) {
      if (r.get)
        return ln(r.get);
      if (typeof r.value == "function")
        return ln(r.value);
    }
    n = EK(n);
  }
  function t() {
    return null;
  }
  return t;
}
function IK(n) {
  try {
    return kn(n, ""), !0;
  } catch {
    return !1;
  }
}
const JA = rr(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), zm = rr(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Vm = rr(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), NK = rr(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Hm = rr(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), PK = rr(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), QA = rr(["#text"]), ZA = rr(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Um = rr(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), XA = rr(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), dd = rr(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), LK = Xr(/{{[\w\W]*|^[\w\W]*}}/g), BK = Xr(/<%[\w\W]*|^[\w\W]*%>/g), jK = Xr(/\${[\w\W]*/g), FK = Xr(/^data-[\-\w.\u00B7-\uFFFF]+$/), zK = Xr(/^aria-[\-\w]+$/), e1 = Xr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), VK = Xr(/^(?:\w+script|data):/i), HK = Xr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), UK = Xr(/^html$/i), WK = Xr(/^[a-z][.\w]*(-[.\w]+)+$/i), Ta = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, $K = function() {
  return typeof window > "u" ? null : window;
}, GK = function(e, t) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  t && t.hasAttribute(i) && (r = t.getAttribute(i));
  const s = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(s, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + s + " could not be created."), null;
  }
}, t1 = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function wM() {
  let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $K();
  const e = (De) => wM(De);
  if (e.version = "3.4.5", e.removed = [], !n || !n.document || n.document.nodeType !== Ta.document || !n.Element)
    return e.isSupported = !1, e;
  let t = n.document;
  const r = t, i = r.currentScript, s = n.DocumentFragment, o = n.HTMLTemplateElement, a = n.Node, c = n.Element, u = n.NodeFilter, d = n.NamedNodeMap, h = d === void 0 ? n.NamedNodeMap || n.MozNamedAttrMap : d, p = n.HTMLFormElement, g = n.DOMParser, y = n.trustedTypes, b = c.prototype, S = To(b, "cloneNode"), w = To(b, "remove"), T = To(b, "nextSibling"), C = To(b, "childNodes"), k = To(b, "parentNode"), R = a && a.prototype ? To(a.prototype, "nodeType") : null;
  if (typeof o == "function") {
    const De = t.createElement("template");
    De.content && De.content.ownerDocument && (t = De.content.ownerDocument);
  }
  let N, L = "";
  const j = t, W = j.implementation, Z = j.createNodeIterator, fe = j.createDocumentFragment, Oe = j.getElementsByTagName, Ae = r.importNode;
  let Y = t1();
  e.isSupported = typeof xM == "function" && typeof k == "function" && W && W.createHTMLDocument !== void 0;
  const re = LK, q = BK, U = jK, J = FK, we = zK, z = VK, X = HK, me = WK;
  let pe = e1, he = null;
  const xe = Ge({}, [...JA, ...zm, ...Vm, ...Hm, ...QA]);
  let H = null;
  const le = Ge({}, [...ZA, ...Um, ...XA, ...dd]);
  let G = Object.seal(Oa(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), oe = null, ue = null;
  const ge = Object.seal(Oa(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Q = !0, ke = !0, Ye = !1, it = !0, It = !1, kt = !0, pn = !1, _r = !1, ir = !1, Qt = !1, Ln = !1, sr = !1, qe = !0, ut = !1;
  const vr = "user-content-";
  let Nt = !0, Tn = !1, Gn = {}, cn = null;
  const ei = Ge({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let or = null;
  const Or = Ge({}, ["audio", "video", "img", "source", "image", "track"]);
  let ti = null;
  const gs = Ge({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), gi = "http://www.w3.org/1998/Math/MathML", yi = "http://www.w3.org/2000/svg", Bn = "http://www.w3.org/1999/xhtml";
  let ni = Bn, Ir = !1, vi = null;
  const ys = Ge({}, [gi, yi, Bn], Fm);
  let vs = Ge({}, ["mi", "mo", "mn", "ms", "mtext"]), oo = Ge({}, ["annotation-xml"]);
  const ea = Ge({}, ["title", "style", "font", "a", "script"]);
  let Bi = null;
  const ao = ["application/xhtml+xml", "text/html"], ta = "text/html";
  let zt = null, bi = null;
  const bs = t.createElement("form"), lo = function(_) {
    return _ instanceof RegExp || _ instanceof Function;
  }, ji = function() {
    let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (bi && bi === _)
      return;
    (!_ || typeof _ != "object") && (_ = {}), _ = fr(_), Bi = // eslint-disable-next-line unicorn/prefer-includes
    ao.indexOf(_.PARSER_MEDIA_TYPE) === -1 ? ta : _.PARSER_MEDIA_TYPE, zt = Bi === "application/xhtml+xml" ? Fm : $l, he = Kt(_, "ALLOWED_TAGS") && Jn(_.ALLOWED_TAGS) ? Ge({}, _.ALLOWED_TAGS, zt) : xe, H = Kt(_, "ALLOWED_ATTR") && Jn(_.ALLOWED_ATTR) ? Ge({}, _.ALLOWED_ATTR, zt) : le, vi = Kt(_, "ALLOWED_NAMESPACES") && Jn(_.ALLOWED_NAMESPACES) ? Ge({}, _.ALLOWED_NAMESPACES, Fm) : ys, ti = Kt(_, "ADD_URI_SAFE_ATTR") && Jn(_.ADD_URI_SAFE_ATTR) ? Ge(fr(gs), _.ADD_URI_SAFE_ATTR, zt) : gs, or = Kt(_, "ADD_DATA_URI_TAGS") && Jn(_.ADD_DATA_URI_TAGS) ? Ge(fr(Or), _.ADD_DATA_URI_TAGS, zt) : Or, cn = Kt(_, "FORBID_CONTENTS") && Jn(_.FORBID_CONTENTS) ? Ge({}, _.FORBID_CONTENTS, zt) : ei, oe = Kt(_, "FORBID_TAGS") && Jn(_.FORBID_TAGS) ? Ge({}, _.FORBID_TAGS, zt) : fr({}), ue = Kt(_, "FORBID_ATTR") && Jn(_.FORBID_ATTR) ? Ge({}, _.FORBID_ATTR, zt) : fr({}), Gn = Kt(_, "USE_PROFILES") ? _.USE_PROFILES && typeof _.USE_PROFILES == "object" ? fr(_.USE_PROFILES) : _.USE_PROFILES : !1, Q = _.ALLOW_ARIA_ATTR !== !1, ke = _.ALLOW_DATA_ATTR !== !1, Ye = _.ALLOW_UNKNOWN_PROTOCOLS || !1, it = _.ALLOW_SELF_CLOSE_IN_ATTR !== !1, It = _.SAFE_FOR_TEMPLATES || !1, kt = _.SAFE_FOR_XML !== !1, pn = _.WHOLE_DOCUMENT || !1, Qt = _.RETURN_DOM || !1, Ln = _.RETURN_DOM_FRAGMENT || !1, sr = _.RETURN_TRUSTED_TYPE || !1, ir = _.FORCE_BODY || !1, qe = _.SANITIZE_DOM !== !1, ut = _.SANITIZE_NAMED_PROPS || !1, Nt = _.KEEP_CONTENT !== !1, Tn = _.IN_PLACE || !1, pe = IK(_.ALLOWED_URI_REGEXP) ? _.ALLOWED_URI_REGEXP : e1, ni = typeof _.NAMESPACE == "string" ? _.NAMESPACE : Bn, vs = Kt(_, "MATHML_TEXT_INTEGRATION_POINTS") && _.MATHML_TEXT_INTEGRATION_POINTS && typeof _.MATHML_TEXT_INTEGRATION_POINTS == "object" ? fr(_.MATHML_TEXT_INTEGRATION_POINTS) : Ge({}, ["mi", "mo", "mn", "ms", "mtext"]), oo = Kt(_, "HTML_INTEGRATION_POINTS") && _.HTML_INTEGRATION_POINTS && typeof _.HTML_INTEGRATION_POINTS == "object" ? fr(_.HTML_INTEGRATION_POINTS) : Ge({}, ["annotation-xml"]);
    const ne = Kt(_, "CUSTOM_ELEMENT_HANDLING") && _.CUSTOM_ELEMENT_HANDLING && typeof _.CUSTOM_ELEMENT_HANDLING == "object" ? fr(_.CUSTOM_ELEMENT_HANDLING) : Oa(null);
    if (G = Oa(null), Kt(ne, "tagNameCheck") && lo(ne.tagNameCheck) && (G.tagNameCheck = ne.tagNameCheck), Kt(ne, "attributeNameCheck") && lo(ne.attributeNameCheck) && (G.attributeNameCheck = ne.attributeNameCheck), Kt(ne, "allowCustomizedBuiltInElements") && typeof ne.allowCustomizedBuiltInElements == "boolean" && (G.allowCustomizedBuiltInElements = ne.allowCustomizedBuiltInElements), It && (ke = !1), Ln && (Qt = !0), Gn && (he = Ge({}, QA), H = Oa(null), Gn.html === !0 && (Ge(he, JA), Ge(H, ZA)), Gn.svg === !0 && (Ge(he, zm), Ge(H, Um), Ge(H, dd)), Gn.svgFilters === !0 && (Ge(he, Vm), Ge(H, Um), Ge(H, dd)), Gn.mathMl === !0 && (Ge(he, Hm), Ge(H, XA), Ge(H, dd))), ge.tagCheck = null, ge.attributeCheck = null, Kt(_, "ADD_TAGS") && (typeof _.ADD_TAGS == "function" ? ge.tagCheck = _.ADD_TAGS : Jn(_.ADD_TAGS) && (he === xe && (he = fr(he)), Ge(he, _.ADD_TAGS, zt))), Kt(_, "ADD_ATTR") && (typeof _.ADD_ATTR == "function" ? ge.attributeCheck = _.ADD_ATTR : Jn(_.ADD_ATTR) && (H === le && (H = fr(H)), Ge(H, _.ADD_ATTR, zt))), Kt(_, "ADD_URI_SAFE_ATTR") && Jn(_.ADD_URI_SAFE_ATTR) && Ge(ti, _.ADD_URI_SAFE_ATTR, zt), Kt(_, "FORBID_CONTENTS") && Jn(_.FORBID_CONTENTS) && (cn === ei && (cn = fr(cn)), Ge(cn, _.FORBID_CONTENTS, zt)), Kt(_, "ADD_FORBID_CONTENTS") && Jn(_.ADD_FORBID_CONTENTS) && (cn === ei && (cn = fr(cn)), Ge(cn, _.ADD_FORBID_CONTENTS, zt)), Nt && (he["#text"] = !0), pn && Ge(he, ["html", "head", "body"]), he.table && (Ge(he, ["tbody"]), delete oe.tbody), _.TRUSTED_TYPES_POLICY) {
      if (typeof _.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw ud('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof _.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw ud('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      N = _.TRUSTED_TYPES_POLICY, L = N.createHTML("");
    } else
      N === void 0 && (N = GK(y, i)), N !== null && typeof L == "string" && (L = N.createHTML(""));
    rr && rr(_), bi = _;
  }, na = Ge({}, [...zm, ...Vm, ...NK]), ra = Ge({}, [...Hm, ...PK]), cl = function(_) {
    let ne = k(_);
    (!ne || !ne.tagName) && (ne = {
      namespaceURI: ni,
      tagName: "template"
    });
    const ve = $l(_.tagName), Ke = $l(ne.tagName);
    return vi[_.namespaceURI] ? _.namespaceURI === yi ? ne.namespaceURI === Bn ? ve === "svg" : ne.namespaceURI === gi ? ve === "svg" && (Ke === "annotation-xml" || vs[Ke]) : !!na[ve] : _.namespaceURI === gi ? ne.namespaceURI === Bn ? ve === "math" : ne.namespaceURI === yi ? ve === "math" && oo[Ke] : !!ra[ve] : _.namespaceURI === Bn ? ne.namespaceURI === yi && !oo[Ke] || ne.namespaceURI === gi && !vs[Ke] ? !1 : !ra[ve] && (ea[ve] || !na[ve]) : !!(Bi === "application/xhtml+xml" && vi[_.namespaceURI]) : !1;
  }, O = function(_) {
    Ea(e.removed, {
      element: _
    });
    try {
      k(_).removeChild(_);
    } catch {
      w(_);
    }
  }, ie = function(_, ne) {
    try {
      Ea(e.removed, {
        attribute: ne.getAttributeNode(_),
        from: ne
      });
    } catch {
      Ea(e.removed, {
        attribute: null,
        from: ne
      });
    }
    if (ne.removeAttribute(_), _ === "is")
      if (Qt || Ln)
        try {
          O(ne);
        } catch {
        }
      else
        try {
          ne.setAttribute(_, "");
        } catch {
        }
  }, be = function(_) {
    let ne = null, ve = null;
    if (ir)
      _ = "<remove></remove>" + _;
    else {
      const Gt = GA(_, /^[\r\n\t ]+/);
      ve = Gt && Gt[0];
    }
    Bi === "application/xhtml+xml" && ni === Bn && (_ = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + _ + "</body></html>");
    const Ke = N ? N.createHTML(_) : _;
    if (ni === Bn)
      try {
        ne = new g().parseFromString(Ke, Bi);
      } catch {
      }
    if (!ne || !ne.documentElement) {
      ne = W.createDocument(ni, "template", null);
      try {
        ne.documentElement.innerHTML = Ir ? L : Ke;
      } catch {
      }
    }
    const Vt = ne.body || ne.documentElement;
    return _ && ve && Vt.insertBefore(t.createTextNode(ve), Vt.childNodes[0] || null), ni === Bn ? Oe.call(ne, pn ? "html" : "body")[0] : pn ? ne.documentElement : Vt;
  }, Ie = function(_) {
    return Z.call(
      _.ownerDocument || _,
      _,
      // eslint-disable-next-line no-bitwise
      u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT | u.SHOW_PROCESSING_INSTRUCTION | u.SHOW_CDATA_SECTION,
      null
    );
  }, st = function(_) {
    _.normalize();
    const ne = Z.call(
      _.ownerDocument || _,
      _,
      // eslint-disable-next-line no-bitwise
      u.SHOW_TEXT | u.SHOW_COMMENT | u.SHOW_CDATA_SECTION | u.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let ve = ne.nextNode();
    for (; ve; ) {
      let Ke = ve.data;
      wa([re, q, U], (Vt) => {
        Ke = Aa(Ke, Vt, " ");
      }), ve.data = Ke, ve = ne.nextNode();
    }
  }, at = function(_) {
    return _ instanceof p && (typeof _.nodeName != "string" || typeof _.textContent != "string" || typeof _.removeChild != "function" || !(_.attributes instanceof h) || typeof _.removeAttribute != "function" || typeof _.setAttribute != "function" || typeof _.namespaceURI != "string" || typeof _.insertBefore != "function" || typeof _.hasChildNodes != "function");
  }, We = function(_) {
    if (!R || typeof _ != "object" || _ === null)
      return !1;
    try {
      return typeof R(_) == "number";
    } catch {
      return !1;
    }
  };
  function je(De, _, ne) {
    wa(De, (ve) => {
      ve.call(e, _, ne, bi);
    });
  }
  const tn = function(_) {
    let ne = null;
    if (je(Y.beforeSanitizeElements, _, null), at(_))
      return O(_), !0;
    const ve = zt(_.nodeName);
    if (je(Y.uponSanitizeElement, _, {
      tagName: ve,
      allowedTags: he
    }), kt && _.hasChildNodes() && !We(_.firstElementChild) && kn(/<[/\w!]/g, _.innerHTML) && kn(/<[/\w!]/g, _.textContent) || kt && _.namespaceURI === Bn && ve === "style" && We(_.firstElementChild) || _.nodeType === Ta.progressingInstruction || kt && _.nodeType === Ta.comment && kn(/<[/\w]/g, _.data))
      return O(_), !0;
    if (oe[ve] || !(ge.tagCheck instanceof Function && ge.tagCheck(ve)) && !he[ve]) {
      if (!oe[ve] && Cn(ve) && (G.tagNameCheck instanceof RegExp && kn(G.tagNameCheck, ve) || G.tagNameCheck instanceof Function && G.tagNameCheck(ve)))
        return !1;
      if (Nt && !cn[ve]) {
        const Ke = k(_) || _.parentNode, Vt = C(_) || _.childNodes;
        if (Vt && Ke) {
          const Gt = Vt.length;
          for (let jn = Gt - 1; jn >= 0; --jn) {
            const xi = S(Vt[jn], !0);
            Ke.insertBefore(xi, T(_));
          }
        }
      }
      return O(_), !0;
    }
    return _ instanceof c && !cl(_) || (ve === "noscript" || ve === "noembed" || ve === "noframes") && kn(/<\/no(script|embed|frames)/i, _.innerHTML) ? (O(_), !0) : (It && _.nodeType === Ta.text && (ne = _.textContent, wa([re, q, U], (Ke) => {
      ne = Aa(ne, Ke, " ");
    }), _.textContent !== ne && (Ea(e.removed, {
      element: _.cloneNode()
    }), _.textContent = ne)), je(Y.afterSanitizeElements, _, null), !1);
  }, At = function(_, ne, ve) {
    if (ue[ne] || qe && (ne === "id" || ne === "name") && (ve in t || ve in bs))
      return !1;
    const Ke = H[ne] || ge.attributeCheck instanceof Function && ge.attributeCheck(ne, _);
    if (!(ke && !ue[ne] && kn(J, ne))) {
      if (!(Q && kn(we, ne))) {
        if (!Ke || ue[ne]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Cn(_) && (G.tagNameCheck instanceof RegExp && kn(G.tagNameCheck, _) || G.tagNameCheck instanceof Function && G.tagNameCheck(_)) && (G.attributeNameCheck instanceof RegExp && kn(G.attributeNameCheck, ne) || G.attributeNameCheck instanceof Function && G.attributeNameCheck(ne, _)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            ne === "is" && G.allowCustomizedBuiltInElements && (G.tagNameCheck instanceof RegExp && kn(G.tagNameCheck, ve) || G.tagNameCheck instanceof Function && G.tagNameCheck(ve)))
          ) return !1;
        } else if (!ti[ne]) {
          if (!kn(pe, Aa(ve, X, ""))) {
            if (!((ne === "src" || ne === "xlink:href" || ne === "href") && _ !== "script" && YA(ve, "data:") === 0 && or[_])) {
              if (!(Ye && !kn(z, Aa(ve, X, "")))) {
                if (ve)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Pt = Ge({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), Cn = function(_) {
    return !Pt[$l(_)] && kn(me, _);
  }, ar = function(_) {
    je(Y.beforeSanitizeAttributes, _, null);
    const ne = _.attributes;
    if (!ne || at(_))
      return;
    const ve = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: H,
      forceKeepAttr: void 0
    };
    let Ke = ne.length;
    for (; Ke--; ) {
      const Vt = ne[Ke], Gt = Vt.name, jn = Vt.namespaceURI, xi = Vt.value, ri = zt(Gt), ia = xi;
      let Zt = Gt === "value" ? ia : DK(ia);
      if (ve.attrName = ri, ve.attrValue = Zt, ve.keepAttr = !0, ve.forceKeepAttr = void 0, je(Y.uponSanitizeAttribute, _, ve), Zt = ve.attrValue, ut && (ri === "id" || ri === "name") && YA(Zt, vr) !== 0 && (ie(Gt, _), Zt = vr + Zt), kt && kn(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Zt)) {
        ie(Gt, _);
        continue;
      }
      if (ri === "attributename" && GA(Zt, "href")) {
        ie(Gt, _);
        continue;
      }
      if (ve.forceKeepAttr)
        continue;
      if (!ve.keepAttr) {
        ie(Gt, _);
        continue;
      }
      if (!it && kn(/\/>/i, Zt)) {
        ie(Gt, _);
        continue;
      }
      It && wa([re, q, U], (sa) => {
        Zt = Aa(Zt, sa, " ");
      });
      const ul = zt(_.nodeName);
      if (!At(ul, ri, Zt)) {
        ie(Gt, _);
        continue;
      }
      if (N && typeof y == "object" && typeof y.getAttributeType == "function" && !jn)
        switch (y.getAttributeType(ul, ri)) {
          case "TrustedHTML": {
            Zt = N.createHTML(Zt);
            break;
          }
          case "TrustedScriptURL": {
            Zt = N.createScriptURL(Zt);
            break;
          }
        }
      if (Zt !== ia)
        try {
          jn ? _.setAttributeNS(jn, Gt, Zt) : _.setAttribute(Gt, Zt), at(_) ? O(_) : $A(e.removed);
        } catch {
          ie(Gt, _);
        }
    }
    je(Y.afterSanitizeAttributes, _, null);
  }, br = function(_) {
    let ne = null;
    const ve = Ie(_);
    for (je(Y.beforeSanitizeShadowDOM, _, null); ne = ve.nextNode(); )
      je(Y.uponSanitizeShadowNode, ne, null), tn(ne), ar(ne), ne.content instanceof s && br(ne.content);
    je(Y.afterSanitizeShadowDOM, _, null);
  }, Lt = function(_) {
    if (_.nodeType === Ta.element && _.shadowRoot instanceof s) {
      const Ke = _.shadowRoot;
      Lt(Ke), br(Ke);
    }
    const ne = _.childNodes;
    if (!ne)
      return;
    const ve = [];
    wa(ne, (Ke) => {
      Ea(ve, Ke);
    });
    for (const Ke of ve)
      Lt(Ke);
  };
  return e.sanitize = function(De) {
    let _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ne = null, ve = null, Ke = null, Vt = null;
    if (Ir = !De, Ir && (De = "<!-->"), typeof De != "string" && !We(De) && (De = OK(De), typeof De != "string"))
      throw ud("dirty is not a string, aborting");
    if (!e.isSupported)
      return De;
    if (_r || ji(_), e.removed = [], typeof De == "string" && (Tn = !1), Tn) {
      const xi = De.nodeName;
      if (typeof xi == "string") {
        const ri = zt(xi);
        if (!he[ri] || oe[ri])
          throw ud("root node is forbidden and cannot be sanitized in-place");
      }
      Lt(De);
    } else if (We(De))
      ne = be("<!---->"), ve = ne.ownerDocument.importNode(De, !0), ve.nodeType === Ta.element && ve.nodeName === "BODY" || ve.nodeName === "HTML" ? ne = ve : ne.appendChild(ve), Lt(ve);
    else {
      if (!Qt && !It && !pn && // eslint-disable-next-line unicorn/prefer-includes
      De.indexOf("<") === -1)
        return N && sr ? N.createHTML(De) : De;
      if (ne = be(De), !ne)
        return Qt ? null : sr ? L : "";
    }
    ne && ir && O(ne.firstChild);
    const Gt = Ie(Tn ? De : ne);
    for (; Ke = Gt.nextNode(); )
      tn(Ke), ar(Ke), Ke.content instanceof s && br(Ke.content);
    if (Tn)
      return It && st(De), De;
    if (Qt) {
      if (It && st(ne), Ln)
        for (Vt = fe.call(ne.ownerDocument); ne.firstChild; )
          Vt.appendChild(ne.firstChild);
      else
        Vt = ne;
      return (H.shadowroot || H.shadowrootmode) && (Vt = Ae.call(r, Vt, !0)), Vt;
    }
    let jn = pn ? ne.outerHTML : ne.innerHTML;
    return pn && he["!doctype"] && ne.ownerDocument && ne.ownerDocument.doctype && ne.ownerDocument.doctype.name && kn(UK, ne.ownerDocument.doctype.name) && (jn = "<!DOCTYPE " + ne.ownerDocument.doctype.name + `>
` + jn), It && wa([re, q, U], (xi) => {
      jn = Aa(jn, xi, " ");
    }), N && sr ? N.createHTML(jn) : jn;
  }, e.setConfig = function() {
    let De = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ji(De), _r = !0;
  }, e.clearConfig = function() {
    bi = null, _r = !1;
  }, e.isValidAttribute = function(De, _, ne) {
    bi || ji({});
    const ve = zt(De), Ke = zt(_);
    return At(ve, Ke, ne);
  }, e.addHook = function(De, _) {
    typeof _ == "function" && Ea(Y[De], _);
  }, e.removeHook = function(De, _) {
    if (_ !== void 0) {
      const ne = TK(Y[De], _);
      return ne === -1 ? void 0 : CK(Y[De], ne, 1)[0];
    }
    return $A(Y[De]);
  }, e.removeHooks = function(De) {
    Y[De] = [];
  }, e.removeAllHooks = function() {
    Y = t1();
  }, e;
}
var YK = wM();
const qK = {
  USE_PROFILES: { html: !0 },
  ALLOW_DATA_ATTR: !1,
  FORBID_TAGS: [
    "button",
    "embed",
    "form",
    "iframe",
    "img",
    "input",
    "link",
    "meta",
    "object",
    "script",
    "select",
    "style",
    "textarea"
  ],
  FORBID_ATTR: ["style", "srcset"]
};
function hQ({ html: n, emptyFallback: e = null, ...t }) {
  const r = Wt(() => YK.sanitize(n, qK), [n]);
  return r.trim() ? /* @__PURE__ */ x.jsx(
    "div",
    {
      ...t,
      dangerouslySetInnerHTML: { __html: r }
    }
  ) : /* @__PURE__ */ x.jsx("div", { ...t, children: e });
}
function pQ({
  children: n,
  minWidth: e = 800,
  page: t,
  onPageChange: r,
  limit: i,
  onLimitChange: s,
  total: o,
  limitOptions: a = [
    { label: "10개씩 보기", value: "10" },
    { label: "20개씩 보기", value: "20" },
    { label: "50개씩 보기", value: "50" }
  ]
}) {
  const c = Math.ceil(o / i);
  return /* @__PURE__ */ x.jsxs("div", { children: [
    /* @__PURE__ */ x.jsx(Ze.ScrollContainer, { minWidth: e, children: n }),
    c > 0 && /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", mt: "lg", gap: "md", wrap: "wrap", children: [
      /* @__PURE__ */ x.jsx(
        py,
        {
          value: String(i),
          onChange: (u) => {
            u && (s(Number(u)), r(1));
          },
          data: a,
          style: { width: 148 },
          allowDeselect: !1
        }
      ),
      /* @__PURE__ */ x.jsx(P2, { total: c, value: t, onChange: r })
    ] })
  ] });
}
function n1(n) {
  const e = (n == null ? void 0 : n.releasedAt) ?? (n == null ? void 0 : n.createdAt);
  if (!e) return (n == null ? void 0 : n.version) ?? "확인 중";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? (n == null ? void 0 : n.version) ?? "확인 중" : new Intl.DateTimeFormat("ko-KR", {
    year: "numeric",
    month: "long",
    day: "numeric"
  }).format(t);
}
function mQ({
  opened: n,
  loading: e,
  terms: t,
  termsLoading: r = !1,
  serviceTermsHref: i = "/terms/service",
  marketingTermsHref: s = "/terms/marketing-info",
  onCancel: o,
  onSubmit: a
}) {
  const [c, u] = Et(!1), [d, h] = Et(!1), p = t == null ? void 0 : t.service, g = t == null ? void 0 : t.marketing, y = !!(p && g), b = e || r;
  wt(() => {
    n || (u(!1), h(!1));
  }, [n]);
  const S = c && d, w = (T) => {
    u(T), h(T);
  };
  return /* @__PURE__ */ x.jsx(
    m1,
    {
      opened: n,
      onClose: o,
      size: "md",
      centered: !0,
      closeOnClickOutside: !e,
      closeOnEscape: !e,
      withCloseButton: !e,
      styles: {
        header: {
          display: "none"
        },
        content: {
          borderRadius: "16px",
          padding: "24px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)"
        },
        body: {
          padding: 0
        }
      },
      children: /* @__PURE__ */ x.jsxs(ct, { gap: "xl", children: [
        /* @__PURE__ */ x.jsxs(yt, { ta: "center", pt: "md", children: [
          /* @__PURE__ */ x.jsx(
            p1,
            {
              size: 56,
              radius: "xl",
              variant: "gradient",
              gradient: { from: "blue.4", to: "blue.7", deg: 135 },
              mb: "md",
              children: /* @__PURE__ */ x.jsx(VU, { size: 32, stroke: 1.5 })
            }
          ),
          /* @__PURE__ */ x.jsx(ae, { size: "xl", fw: 700, c: "gray.9", mb: "xs", children: "약관에 동의해주세요" }),
          /* @__PURE__ */ x.jsx(ae, { size: "sm", c: "gray.5", style: { maxWidth: 300, margin: "0 auto" }, children: "DutyOn 서비스의 안전한 이용을 위해 필수 및 선택 약관에 대한 확인이 필요합니다." })
        ] }),
        /* @__PURE__ */ x.jsxs(ct, { gap: "sm", children: [
          /* @__PURE__ */ x.jsx(
            er,
            {
              withBorder: !0,
              p: "md",
              radius: "md",
              style: {
                backgroundColor: S ? "#f1f3f5" : "#f8f9fa",
                borderColor: S ? "#339af0" : "#dee2e6",
                cursor: "pointer",
                transition: "all 0.2s ease"
              },
              onClick: () => w(!S),
              children: /* @__PURE__ */ x.jsx(Fe, { justify: "space-between", wrap: "nowrap", children: /* @__PURE__ */ x.jsxs(Fe, { gap: "sm", children: [
                /* @__PURE__ */ x.jsx(
                  Gl,
                  {
                    checked: S,
                    onChange: (T) => w(T.currentTarget.checked),
                    onClick: (T) => T.stopPropagation(),
                    styles: { input: { cursor: "pointer" } }
                  }
                ),
                /* @__PURE__ */ x.jsxs(yt, { children: [
                  /* @__PURE__ */ x.jsx(ae, { size: "sm", fw: 700, c: "gray.8", children: "약관 전체 동의" }),
                  /* @__PURE__ */ x.jsx(ae, { size: "xs", c: "gray.5", children: "필수 이용약관 및 선택 마케팅 수신동의에 모두 동의합니다." })
                ] })
              ] }) })
            }
          ),
          /* @__PURE__ */ x.jsx(er, { withBorder: !0, p: "md", radius: "md", style: { borderColor: "#e9ecef" }, children: /* @__PURE__ */ x.jsxs(ct, { gap: "md", children: [
            /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", wrap: "nowrap", align: "center", children: [
              /* @__PURE__ */ x.jsxs(Fe, { gap: "sm", style: { flex: 1 }, children: [
                /* @__PURE__ */ x.jsx(
                  Gl,
                  {
                    checked: c,
                    onChange: (T) => u(T.currentTarget.checked),
                    styles: { input: { cursor: "pointer" } }
                  }
                ),
                /* @__PURE__ */ x.jsxs(yt, { children: [
                  /* @__PURE__ */ x.jsxs(Fe, { gap: "xs", mb: 2, children: [
                    /* @__PURE__ */ x.jsx(on, { size: "xs", color: "blue", variant: "filled", children: "필수" }),
                    /* @__PURE__ */ x.jsx(ae, { size: "sm", fw: 600, c: "gray.8", children: (p == null ? void 0 : p.title) ?? "서비스 이용약관 동의" })
                  ] }),
                  /* @__PURE__ */ x.jsxs(ae, { size: "xs", c: "gray.5", children: [
                    "시행일자: ",
                    n1(p)
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ x.jsxs(
                Rx,
                {
                  href: i,
                  target: "_blank",
                  rel: "noreferrer",
                  c: "blue",
                  size: "xs",
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    fontWeight: 600
                  },
                  children: [
                    "전문보기",
                    /* @__PURE__ */ x.jsx(WS, { size: 14 })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", wrap: "nowrap", align: "center", children: [
              /* @__PURE__ */ x.jsxs(Fe, { gap: "sm", style: { flex: 1 }, children: [
                /* @__PURE__ */ x.jsx(
                  Gl,
                  {
                    checked: d,
                    onChange: (T) => h(T.currentTarget.checked),
                    styles: { input: { cursor: "pointer" } }
                  }
                ),
                /* @__PURE__ */ x.jsxs(yt, { children: [
                  /* @__PURE__ */ x.jsxs(Fe, { gap: "xs", mb: 2, children: [
                    /* @__PURE__ */ x.jsx(on, { size: "xs", color: "gray", variant: "outline", children: "선택" }),
                    /* @__PURE__ */ x.jsx(ae, { size: "sm", fw: 600, c: "gray.8", children: (g == null ? void 0 : g.title) ?? "마케팅 정보 수신 동의" })
                  ] }),
                  /* @__PURE__ */ x.jsxs(ae, { size: "xs", c: "gray.5", children: [
                    "시행일자: ",
                    n1(g)
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ x.jsxs(
                Rx,
                {
                  href: s,
                  target: "_blank",
                  rel: "noreferrer",
                  c: "blue",
                  size: "xs",
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    fontWeight: 600
                  },
                  children: [
                    "전문보기",
                    /* @__PURE__ */ x.jsx(WS, { size: 14 })
                  ]
                }
              )
            ] })
          ] }) })
        ] }),
        /* @__PURE__ */ x.jsx(ae, { size: "xs", c: "gray.5", ta: "center", children: "마케팅 동의를 거부하셔도 서비스 이용이 가능하며, 마이페이지 설정에서 언제든 동의를 철회할 수 있습니다." }),
        /* @__PURE__ */ x.jsxs(Fe, { gap: "sm", grow: !0, children: [
          /* @__PURE__ */ x.jsx(hn, { variant: "default", onClick: o, disabled: e, radius: "md", size: "md", children: "취소" }),
          /* @__PURE__ */ x.jsx(
            hn,
            {
              onClick: () => {
                !p || !g || a({
                  serviceTermsAccepted: !0,
                  serviceTermsVersion: p.version,
                  marketingConsent: d,
                  marketingTermsVersion: g.version
                });
              },
              disabled: !c || !y,
              loading: b,
              radius: "md",
              size: "md",
              variant: "filled",
              children: "동의하고 계속"
            }
          )
        ] })
      ] })
    }
  );
}
function gQ({
  title: n,
  description: e,
  rightSection: t,
  children: r,
  fluid: i = !0,
  p: s = "md",
  pos: o = "relative",
  minHeight: a = "calc(100dvh - 160px)",
  style: c,
  ...u
}) {
  return /* @__PURE__ */ x.jsxs(
    fy,
    {
      fluid: i,
      p: s,
      pos: o,
      style: [
        {
          minHeight: a
        },
        c
      ],
      ...u,
      children: [
        /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", align: "flex-start", wrap: "wrap", gap: "md", mb: "lg", children: [
          /* @__PURE__ */ x.jsxs(yt, { style: { flex: "1 1 280px", minWidth: 0 }, children: [
            typeof n == "string" ? /* @__PURE__ */ x.jsx(Ga, { order: 2, style: { lineHeight: 1.2, wordBreak: "keep-all" }, children: n }) : n,
            e && (typeof e == "string" ? /* @__PURE__ */ x.jsx(ae, { size: "sm", c: "dimmed", mt: 4, children: e }) : e)
          ] }),
          t && /* @__PURE__ */ x.jsx(
            yt,
            {
              style: {
                display: "flex",
                flex: "0 1 auto",
                justifyContent: "flex-end",
                maxWidth: "100%",
                minWidth: 0
              },
              children: t
            }
          )
        ] }),
        r
      ]
    }
  );
}
const Wm = "dutyon-turnstile-api", KK = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
let Ll;
function JK() {
  return window.turnstile ? Promise.resolve(window.turnstile) : Ll || (Ll = new Promise((n, e) => {
    const t = document.getElementById(Wm), r = t instanceof HTMLScriptElement ? t : document.createElement("script"), i = () => {
      if (window.turnstile) {
        n(window.turnstile);
        return;
      }
      e(new Error("Turnstile API를 초기화하지 못했습니다."));
    }, s = () => e(new Error("Turnstile API를 불러오지 못했습니다."));
    r.addEventListener("load", i, { once: !0 }), r.addEventListener("error", s, { once: !0 }), t || (r.id = Wm, r.src = KK, r.async = !0, r.defer = !0, document.head.appendChild(r));
  }).catch((n) => {
    var e;
    throw Ll = void 0, (e = document.getElementById(Wm)) == null || e.remove(), n;
  }), Ll);
}
function yQ({
  siteKey: n,
  action: e,
  required: t,
  onTokenChange: r
}) {
  const i = bt(null), [s, o] = Et(null), [a, c] = Et(!1);
  return wt(() => {
    if (!n) {
      r(null);
      return;
    }
    let u = !1, d;
    return o(null), c(!1), r(null), JK().then((h) => {
      u || !i.current || (d = h.render(i.current, {
        sitekey: n,
        action: e,
        language: "ko",
        theme: "auto",
        size: "flexible",
        callback: (p) => {
          u || (o(null), c(!0), r(p));
        },
        "error-callback": () => (u || (c(!1), o("자동화 방지 확인에 실패했습니다. 잠시 후 다시 시도해 주세요."), r(null)), !0),
        "expired-callback": () => {
          u || (c(!1), o("자동화 방지 확인 시간이 만료되었습니다. 다시 확인해 주세요."), r(null));
        },
        "timeout-callback": () => {
          u || (c(!1), o("자동화 방지 확인 시간이 초과되었습니다. 다시 시도해 주세요."), r(null));
        }
      }));
    }).catch(() => {
      u || (o("자동화 방지 화면을 불러오지 못했습니다. 네트워크를 확인해 주세요."), r(null));
    }), () => {
      u = !0, d && window.turnstile && window.turnstile.remove(d);
    };
  }, [e, r, n]), n ? /* @__PURE__ */ x.jsxs(ct, { gap: "xs", children: [
    /* @__PURE__ */ x.jsx("div", { ref: i }),
    !s && !a && /* @__PURE__ */ x.jsx(ae, { size: "sm", c: "dimmed", ta: "center", "aria-live": "polite", children: "자동화 방지 확인을 준비하고 있습니다." }),
    s && /* @__PURE__ */ x.jsx(Ws, { color: "red", title: "자동화 방지 확인 실패", "aria-live": "assertive", children: s })
  ] }) : t ? /* @__PURE__ */ x.jsx(Ws, { color: "red", title: "자동화 방지 설정 오류", children: "공개 신청을 사용할 수 없습니다. 관리자에게 문의해 주세요." }) : null;
}
var zf = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
zf.exports;
(function(n, e) {
  (function() {
    var t, r = "4.17.23", i = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", o = "Expected a function", a = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", u = 500, d = "__lodash_placeholder__", h = 1, p = 2, g = 4, y = 1, b = 2, S = 1, w = 2, T = 4, C = 8, k = 16, R = 32, N = 64, L = 128, j = 256, W = 512, Z = 30, fe = "...", Oe = 800, Ae = 16, Y = 1, re = 2, q = 3, U = 1 / 0, J = 9007199254740991, we = 17976931348623157e292, z = NaN, X = 4294967295, me = X - 1, pe = X >>> 1, he = [
      ["ary", L],
      ["bind", S],
      ["bindKey", w],
      ["curry", C],
      ["curryRight", k],
      ["flip", W],
      ["partial", R],
      ["partialRight", N],
      ["rearg", j]
    ], xe = "[object Arguments]", H = "[object Array]", le = "[object AsyncFunction]", G = "[object Boolean]", oe = "[object Date]", ue = "[object DOMException]", ge = "[object Error]", Q = "[object Function]", ke = "[object GeneratorFunction]", Ye = "[object Map]", it = "[object Number]", It = "[object Null]", kt = "[object Object]", pn = "[object Promise]", _r = "[object Proxy]", ir = "[object RegExp]", Qt = "[object Set]", Ln = "[object String]", sr = "[object Symbol]", qe = "[object Undefined]", ut = "[object WeakMap]", vr = "[object WeakSet]", Nt = "[object ArrayBuffer]", Tn = "[object DataView]", Gn = "[object Float32Array]", cn = "[object Float64Array]", ei = "[object Int8Array]", or = "[object Int16Array]", Or = "[object Int32Array]", ti = "[object Uint8Array]", gs = "[object Uint8ClampedArray]", gi = "[object Uint16Array]", yi = "[object Uint32Array]", Bn = /\b__p \+= '';/g, ni = /\b(__p \+=) '' \+/g, Ir = /(__e\(.*?\)|\b__t\)) \+\n'';/g, vi = /&(?:amp|lt|gt|quot|#39);/g, ys = /[&<>"']/g, vs = RegExp(vi.source), oo = RegExp(ys.source), ea = /<%-([\s\S]+?)%>/g, Bi = /<%([\s\S]+?)%>/g, ao = /<%=([\s\S]+?)%>/g, ta = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, zt = /^\w*$/, bi = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, bs = /[\\^$.*+?()[\]{}|]/g, lo = RegExp(bs.source), ji = /^\s+/, na = /\s/, ra = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, cl = /\{\n\/\* \[wrapped with (.+)\] \*/, O = /,? & /, ie = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, be = /[()=,{}\[\]\/\s]/, Ie = /\\(\\)?/g, st = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, at = /\w*$/, We = /^[-+]0x[0-9a-f]+$/i, je = /^0b[01]+$/i, tn = /^\[object .+?Constructor\]$/, At = /^0o[0-7]+$/i, Pt = /^(?:0|[1-9]\d*)$/, Cn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ar = /($^)/, br = /['\n\r\u2028\u2029\\]/g, Lt = "\\ud800-\\udfff", De = "\\u0300-\\u036f", _ = "\\ufe20-\\ufe2f", ne = "\\u20d0-\\u20ff", ve = De + _ + ne, Ke = "\\u2700-\\u27bf", Vt = "a-z\\xdf-\\xf6\\xf8-\\xff", Gt = "\\xac\\xb1\\xd7\\xf7", jn = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", xi = "\\u2000-\\u206f", ri = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ia = "A-Z\\xc0-\\xd6\\xd8-\\xde", Zt = "\\ufe0e\\ufe0f", ul = Gt + jn + xi + ri, sa = "['’]", _M = "[" + Lt + "]", l0 = "[" + ul + "]", Jc = "[" + ve + "]", c0 = "\\d+", OM = "[" + Ke + "]", u0 = "[" + Vt + "]", d0 = "[^" + Lt + ul + c0 + Ke + Vt + ia + "]", mh = "\\ud83c[\\udffb-\\udfff]", IM = "(?:" + Jc + "|" + mh + ")", f0 = "[^" + Lt + "]", gh = "(?:\\ud83c[\\udde6-\\uddff]){2}", yh = "[\\ud800-\\udbff][\\udc00-\\udfff]", oa = "[" + ia + "]", h0 = "\\u200d", p0 = "(?:" + u0 + "|" + d0 + ")", NM = "(?:" + oa + "|" + d0 + ")", m0 = "(?:" + sa + "(?:d|ll|m|re|s|t|ve))?", g0 = "(?:" + sa + "(?:D|LL|M|RE|S|T|VE))?", y0 = IM + "?", v0 = "[" + Zt + "]?", PM = "(?:" + h0 + "(?:" + [f0, gh, yh].join("|") + ")" + v0 + y0 + ")*", LM = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", BM = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", b0 = v0 + y0 + PM, jM = "(?:" + [OM, gh, yh].join("|") + ")" + b0, FM = "(?:" + [f0 + Jc + "?", Jc, gh, yh, _M].join("|") + ")", zM = RegExp(sa, "g"), VM = RegExp(Jc, "g"), vh = RegExp(mh + "(?=" + mh + ")|" + FM + b0, "g"), HM = RegExp([
      oa + "?" + u0 + "+" + m0 + "(?=" + [l0, oa, "$"].join("|") + ")",
      NM + "+" + g0 + "(?=" + [l0, oa + p0, "$"].join("|") + ")",
      oa + "?" + p0 + "+" + m0,
      oa + "+" + g0,
      BM,
      LM,
      c0,
      jM
    ].join("|"), "g"), UM = RegExp("[" + h0 + Lt + ve + Zt + "]"), WM = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, $M = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], GM = -1, Mt = {};
    Mt[Gn] = Mt[cn] = Mt[ei] = Mt[or] = Mt[Or] = Mt[ti] = Mt[gs] = Mt[gi] = Mt[yi] = !0, Mt[xe] = Mt[H] = Mt[Nt] = Mt[G] = Mt[Tn] = Mt[oe] = Mt[ge] = Mt[Q] = Mt[Ye] = Mt[it] = Mt[kt] = Mt[ir] = Mt[Qt] = Mt[Ln] = Mt[ut] = !1;
    var Tt = {};
    Tt[xe] = Tt[H] = Tt[Nt] = Tt[Tn] = Tt[G] = Tt[oe] = Tt[Gn] = Tt[cn] = Tt[ei] = Tt[or] = Tt[Or] = Tt[Ye] = Tt[it] = Tt[kt] = Tt[ir] = Tt[Qt] = Tt[Ln] = Tt[sr] = Tt[ti] = Tt[gs] = Tt[gi] = Tt[yi] = !0, Tt[ge] = Tt[Q] = Tt[ut] = !1;
    var YM = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, qM = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, KM = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, JM = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, QM = parseFloat, ZM = parseInt, x0 = typeof Da == "object" && Da && Da.Object === Object && Da, XM = typeof self == "object" && self && self.Object === Object && self, Dn = x0 || XM || Function("return this")(), bh = e && !e.nodeType && e, co = bh && !0 && n && !n.nodeType && n, S0 = co && co.exports === bh, xh = S0 && x0.process, Nr = function() {
      try {
        var B = co && co.require && co.require("util").types;
        return B || xh && xh.binding && xh.binding("util");
      } catch {
      }
    }(), w0 = Nr && Nr.isArrayBuffer, E0 = Nr && Nr.isDate, A0 = Nr && Nr.isMap, T0 = Nr && Nr.isRegExp, C0 = Nr && Nr.isSet, D0 = Nr && Nr.isTypedArray;
    function xr(B, K, V) {
      switch (V.length) {
        case 0:
          return B.call(K);
        case 1:
          return B.call(K, V[0]);
        case 2:
          return B.call(K, V[0], V[1]);
        case 3:
          return B.call(K, V[0], V[1], V[2]);
      }
      return B.apply(K, V);
    }
    function e_(B, K, V, Ee) {
      for (var He = -1, dt = B == null ? 0 : B.length; ++He < dt; ) {
        var un = B[He];
        K(Ee, un, V(un), B);
      }
      return Ee;
    }
    function Pr(B, K) {
      for (var V = -1, Ee = B == null ? 0 : B.length; ++V < Ee && K(B[V], V, B) !== !1; )
        ;
      return B;
    }
    function t_(B, K) {
      for (var V = B == null ? 0 : B.length; V-- && K(B[V], V, B) !== !1; )
        ;
      return B;
    }
    function R0(B, K) {
      for (var V = -1, Ee = B == null ? 0 : B.length; ++V < Ee; )
        if (!K(B[V], V, B))
          return !1;
      return !0;
    }
    function xs(B, K) {
      for (var V = -1, Ee = B == null ? 0 : B.length, He = 0, dt = []; ++V < Ee; ) {
        var un = B[V];
        K(un, V, B) && (dt[He++] = un);
      }
      return dt;
    }
    function Qc(B, K) {
      var V = B == null ? 0 : B.length;
      return !!V && aa(B, K, 0) > -1;
    }
    function Sh(B, K, V) {
      for (var Ee = -1, He = B == null ? 0 : B.length; ++Ee < He; )
        if (V(K, B[Ee]))
          return !0;
      return !1;
    }
    function Bt(B, K) {
      for (var V = -1, Ee = B == null ? 0 : B.length, He = Array(Ee); ++V < Ee; )
        He[V] = K(B[V], V, B);
      return He;
    }
    function Ss(B, K) {
      for (var V = -1, Ee = K.length, He = B.length; ++V < Ee; )
        B[He + V] = K[V];
      return B;
    }
    function wh(B, K, V, Ee) {
      var He = -1, dt = B == null ? 0 : B.length;
      for (Ee && dt && (V = B[++He]); ++He < dt; )
        V = K(V, B[He], He, B);
      return V;
    }
    function n_(B, K, V, Ee) {
      var He = B == null ? 0 : B.length;
      for (Ee && He && (V = B[--He]); He--; )
        V = K(V, B[He], He, B);
      return V;
    }
    function Eh(B, K) {
      for (var V = -1, Ee = B == null ? 0 : B.length; ++V < Ee; )
        if (K(B[V], V, B))
          return !0;
      return !1;
    }
    var r_ = Ah("length");
    function i_(B) {
      return B.split("");
    }
    function s_(B) {
      return B.match(ie) || [];
    }
    function k0(B, K, V) {
      var Ee;
      return V(B, function(He, dt, un) {
        if (K(He, dt, un))
          return Ee = dt, !1;
      }), Ee;
    }
    function Zc(B, K, V, Ee) {
      for (var He = B.length, dt = V + (Ee ? 1 : -1); Ee ? dt-- : ++dt < He; )
        if (K(B[dt], dt, B))
          return dt;
      return -1;
    }
    function aa(B, K, V) {
      return K === K ? y_(B, K, V) : Zc(B, M0, V);
    }
    function o_(B, K, V, Ee) {
      for (var He = V - 1, dt = B.length; ++He < dt; )
        if (Ee(B[He], K))
          return He;
      return -1;
    }
    function M0(B) {
      return B !== B;
    }
    function _0(B, K) {
      var V = B == null ? 0 : B.length;
      return V ? Ch(B, K) / V : z;
    }
    function Ah(B) {
      return function(K) {
        return K == null ? t : K[B];
      };
    }
    function Th(B) {
      return function(K) {
        return B == null ? t : B[K];
      };
    }
    function O0(B, K, V, Ee, He) {
      return He(B, function(dt, un, vt) {
        V = Ee ? (Ee = !1, dt) : K(V, dt, un, vt);
      }), V;
    }
    function a_(B, K) {
      var V = B.length;
      for (B.sort(K); V--; )
        B[V] = B[V].value;
      return B;
    }
    function Ch(B, K) {
      for (var V, Ee = -1, He = B.length; ++Ee < He; ) {
        var dt = K(B[Ee]);
        dt !== t && (V = V === t ? dt : V + dt);
      }
      return V;
    }
    function Dh(B, K) {
      for (var V = -1, Ee = Array(B); ++V < B; )
        Ee[V] = K(V);
      return Ee;
    }
    function l_(B, K) {
      return Bt(K, function(V) {
        return [V, B[V]];
      });
    }
    function I0(B) {
      return B && B.slice(0, B0(B) + 1).replace(ji, "");
    }
    function Sr(B) {
      return function(K) {
        return B(K);
      };
    }
    function Rh(B, K) {
      return Bt(K, function(V) {
        return B[V];
      });
    }
    function dl(B, K) {
      return B.has(K);
    }
    function N0(B, K) {
      for (var V = -1, Ee = B.length; ++V < Ee && aa(K, B[V], 0) > -1; )
        ;
      return V;
    }
    function P0(B, K) {
      for (var V = B.length; V-- && aa(K, B[V], 0) > -1; )
        ;
      return V;
    }
    function c_(B, K) {
      for (var V = B.length, Ee = 0; V--; )
        B[V] === K && ++Ee;
      return Ee;
    }
    var u_ = Th(YM), d_ = Th(qM);
    function f_(B) {
      return "\\" + JM[B];
    }
    function h_(B, K) {
      return B == null ? t : B[K];
    }
    function la(B) {
      return UM.test(B);
    }
    function p_(B) {
      return WM.test(B);
    }
    function m_(B) {
      for (var K, V = []; !(K = B.next()).done; )
        V.push(K.value);
      return V;
    }
    function kh(B) {
      var K = -1, V = Array(B.size);
      return B.forEach(function(Ee, He) {
        V[++K] = [He, Ee];
      }), V;
    }
    function L0(B, K) {
      return function(V) {
        return B(K(V));
      };
    }
    function ws(B, K) {
      for (var V = -1, Ee = B.length, He = 0, dt = []; ++V < Ee; ) {
        var un = B[V];
        (un === K || un === d) && (B[V] = d, dt[He++] = V);
      }
      return dt;
    }
    function Xc(B) {
      var K = -1, V = Array(B.size);
      return B.forEach(function(Ee) {
        V[++K] = Ee;
      }), V;
    }
    function g_(B) {
      var K = -1, V = Array(B.size);
      return B.forEach(function(Ee) {
        V[++K] = [Ee, Ee];
      }), V;
    }
    function y_(B, K, V) {
      for (var Ee = V - 1, He = B.length; ++Ee < He; )
        if (B[Ee] === K)
          return Ee;
      return -1;
    }
    function v_(B, K, V) {
      for (var Ee = V + 1; Ee--; )
        if (B[Ee] === K)
          return Ee;
      return Ee;
    }
    function ca(B) {
      return la(B) ? x_(B) : r_(B);
    }
    function ii(B) {
      return la(B) ? S_(B) : i_(B);
    }
    function B0(B) {
      for (var K = B.length; K-- && na.test(B.charAt(K)); )
        ;
      return K;
    }
    var b_ = Th(KM);
    function x_(B) {
      for (var K = vh.lastIndex = 0; vh.test(B); )
        ++K;
      return K;
    }
    function S_(B) {
      return B.match(vh) || [];
    }
    function w_(B) {
      return B.match(HM) || [];
    }
    var E_ = function B(K) {
      K = K == null ? Dn : ua.defaults(Dn.Object(), K, ua.pick(Dn, $M));
      var V = K.Array, Ee = K.Date, He = K.Error, dt = K.Function, un = K.Math, vt = K.Object, Mh = K.RegExp, A_ = K.String, Lr = K.TypeError, eu = V.prototype, T_ = dt.prototype, da = vt.prototype, tu = K["__core-js_shared__"], nu = T_.toString, ft = da.hasOwnProperty, C_ = 0, j0 = function() {
        var l = /[^.]+$/.exec(tu && tu.keys && tu.keys.IE_PROTO || "");
        return l ? "Symbol(src)_1." + l : "";
      }(), ru = da.toString, D_ = nu.call(vt), R_ = Dn._, k_ = Mh(
        "^" + nu.call(ft).replace(bs, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), iu = S0 ? K.Buffer : t, Es = K.Symbol, su = K.Uint8Array, F0 = iu ? iu.allocUnsafe : t, ou = L0(vt.getPrototypeOf, vt), z0 = vt.create, V0 = da.propertyIsEnumerable, au = eu.splice, H0 = Es ? Es.isConcatSpreadable : t, fl = Es ? Es.iterator : t, uo = Es ? Es.toStringTag : t, lu = function() {
        try {
          var l = go(vt, "defineProperty");
          return l({}, "", {}), l;
        } catch {
        }
      }(), M_ = K.clearTimeout !== Dn.clearTimeout && K.clearTimeout, __ = Ee && Ee.now !== Dn.Date.now && Ee.now, O_ = K.setTimeout !== Dn.setTimeout && K.setTimeout, cu = un.ceil, uu = un.floor, _h = vt.getOwnPropertySymbols, I_ = iu ? iu.isBuffer : t, U0 = K.isFinite, N_ = eu.join, P_ = L0(vt.keys, vt), dn = un.max, Fn = un.min, L_ = Ee.now, B_ = K.parseInt, W0 = un.random, j_ = eu.reverse, Oh = go(K, "DataView"), hl = go(K, "Map"), Ih = go(K, "Promise"), fa = go(K, "Set"), pl = go(K, "WeakMap"), ml = go(vt, "create"), du = pl && new pl(), ha = {}, F_ = yo(Oh), z_ = yo(hl), V_ = yo(Ih), H_ = yo(fa), U_ = yo(pl), fu = Es ? Es.prototype : t, gl = fu ? fu.valueOf : t, $0 = fu ? fu.toString : t;
      function A(l) {
        if (Yt(l) && !Ue(l) && !(l instanceof rt)) {
          if (l instanceof Br)
            return l;
          if (ft.call(l, "__wrapped__"))
            return Gb(l);
        }
        return new Br(l);
      }
      var pa = /* @__PURE__ */ function() {
        function l() {
        }
        return function(f) {
          if (!Ht(f))
            return {};
          if (z0)
            return z0(f);
          l.prototype = f;
          var m = new l();
          return l.prototype = t, m;
        };
      }();
      function hu() {
      }
      function Br(l, f) {
        this.__wrapped__ = l, this.__actions__ = [], this.__chain__ = !!f, this.__index__ = 0, this.__values__ = t;
      }
      A.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: ea,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Bi,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: ao,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: A
        }
      }, A.prototype = hu.prototype, A.prototype.constructor = A, Br.prototype = pa(hu.prototype), Br.prototype.constructor = Br;
      function rt(l) {
        this.__wrapped__ = l, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = X, this.__views__ = [];
      }
      function W_() {
        var l = new rt(this.__wrapped__);
        return l.__actions__ = lr(this.__actions__), l.__dir__ = this.__dir__, l.__filtered__ = this.__filtered__, l.__iteratees__ = lr(this.__iteratees__), l.__takeCount__ = this.__takeCount__, l.__views__ = lr(this.__views__), l;
      }
      function $_() {
        if (this.__filtered__) {
          var l = new rt(this);
          l.__dir__ = -1, l.__filtered__ = !0;
        } else
          l = this.clone(), l.__dir__ *= -1;
        return l;
      }
      function G_() {
        var l = this.__wrapped__.value(), f = this.__dir__, m = Ue(l), v = f < 0, E = m ? l.length : 0, D = iI(0, E, this.__views__), M = D.start, P = D.end, F = P - M, ee = v ? P : M - 1, te = this.__iteratees__, se = te.length, ye = 0, Re = Fn(F, this.__takeCount__);
        if (!m || !v && E == F && Re == F)
          return mb(l, this.__actions__);
        var Le = [];
        e:
          for (; F-- && ye < Re; ) {
            ee += f;
            for (var Je = -1, Be = l[ee]; ++Je < se; ) {
              var nt = te[Je], ot = nt.iteratee, Ar = nt.type, Kn = ot(Be);
              if (Ar == re)
                Be = Kn;
              else if (!Kn) {
                if (Ar == Y)
                  continue e;
                break e;
              }
            }
            Le[ye++] = Be;
          }
        return Le;
      }
      rt.prototype = pa(hu.prototype), rt.prototype.constructor = rt;
      function fo(l) {
        var f = -1, m = l == null ? 0 : l.length;
        for (this.clear(); ++f < m; ) {
          var v = l[f];
          this.set(v[0], v[1]);
        }
      }
      function Y_() {
        this.__data__ = ml ? ml(null) : {}, this.size = 0;
      }
      function q_(l) {
        var f = this.has(l) && delete this.__data__[l];
        return this.size -= f ? 1 : 0, f;
      }
      function K_(l) {
        var f = this.__data__;
        if (ml) {
          var m = f[l];
          return m === c ? t : m;
        }
        return ft.call(f, l) ? f[l] : t;
      }
      function J_(l) {
        var f = this.__data__;
        return ml ? f[l] !== t : ft.call(f, l);
      }
      function Q_(l, f) {
        var m = this.__data__;
        return this.size += this.has(l) ? 0 : 1, m[l] = ml && f === t ? c : f, this;
      }
      fo.prototype.clear = Y_, fo.prototype.delete = q_, fo.prototype.get = K_, fo.prototype.has = J_, fo.prototype.set = Q_;
      function Fi(l) {
        var f = -1, m = l == null ? 0 : l.length;
        for (this.clear(); ++f < m; ) {
          var v = l[f];
          this.set(v[0], v[1]);
        }
      }
      function Z_() {
        this.__data__ = [], this.size = 0;
      }
      function X_(l) {
        var f = this.__data__, m = pu(f, l);
        if (m < 0)
          return !1;
        var v = f.length - 1;
        return m == v ? f.pop() : au.call(f, m, 1), --this.size, !0;
      }
      function eO(l) {
        var f = this.__data__, m = pu(f, l);
        return m < 0 ? t : f[m][1];
      }
      function tO(l) {
        return pu(this.__data__, l) > -1;
      }
      function nO(l, f) {
        var m = this.__data__, v = pu(m, l);
        return v < 0 ? (++this.size, m.push([l, f])) : m[v][1] = f, this;
      }
      Fi.prototype.clear = Z_, Fi.prototype.delete = X_, Fi.prototype.get = eO, Fi.prototype.has = tO, Fi.prototype.set = nO;
      function zi(l) {
        var f = -1, m = l == null ? 0 : l.length;
        for (this.clear(); ++f < m; ) {
          var v = l[f];
          this.set(v[0], v[1]);
        }
      }
      function rO() {
        this.size = 0, this.__data__ = {
          hash: new fo(),
          map: new (hl || Fi)(),
          string: new fo()
        };
      }
      function iO(l) {
        var f = Cu(this, l).delete(l);
        return this.size -= f ? 1 : 0, f;
      }
      function sO(l) {
        return Cu(this, l).get(l);
      }
      function oO(l) {
        return Cu(this, l).has(l);
      }
      function aO(l, f) {
        var m = Cu(this, l), v = m.size;
        return m.set(l, f), this.size += m.size == v ? 0 : 1, this;
      }
      zi.prototype.clear = rO, zi.prototype.delete = iO, zi.prototype.get = sO, zi.prototype.has = oO, zi.prototype.set = aO;
      function ho(l) {
        var f = -1, m = l == null ? 0 : l.length;
        for (this.__data__ = new zi(); ++f < m; )
          this.add(l[f]);
      }
      function lO(l) {
        return this.__data__.set(l, c), this;
      }
      function cO(l) {
        return this.__data__.has(l);
      }
      ho.prototype.add = ho.prototype.push = lO, ho.prototype.has = cO;
      function si(l) {
        var f = this.__data__ = new Fi(l);
        this.size = f.size;
      }
      function uO() {
        this.__data__ = new Fi(), this.size = 0;
      }
      function dO(l) {
        var f = this.__data__, m = f.delete(l);
        return this.size = f.size, m;
      }
      function fO(l) {
        return this.__data__.get(l);
      }
      function hO(l) {
        return this.__data__.has(l);
      }
      function pO(l, f) {
        var m = this.__data__;
        if (m instanceof Fi) {
          var v = m.__data__;
          if (!hl || v.length < i - 1)
            return v.push([l, f]), this.size = ++m.size, this;
          m = this.__data__ = new zi(v);
        }
        return m.set(l, f), this.size = m.size, this;
      }
      si.prototype.clear = uO, si.prototype.delete = dO, si.prototype.get = fO, si.prototype.has = hO, si.prototype.set = pO;
      function G0(l, f) {
        var m = Ue(l), v = !m && vo(l), E = !m && !v && Rs(l), D = !m && !v && !E && va(l), M = m || v || E || D, P = M ? Dh(l.length, A_) : [], F = P.length;
        for (var ee in l)
          (f || ft.call(l, ee)) && !(M && // Safari 9 has enumerable `arguments.length` in strict mode.
          (ee == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          E && (ee == "offset" || ee == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          D && (ee == "buffer" || ee == "byteLength" || ee == "byteOffset") || // Skip index properties.
          Wi(ee, F))) && P.push(ee);
        return P;
      }
      function Y0(l) {
        var f = l.length;
        return f ? l[Wh(0, f - 1)] : t;
      }
      function mO(l, f) {
        return Du(lr(l), po(f, 0, l.length));
      }
      function gO(l) {
        return Du(lr(l));
      }
      function Nh(l, f, m) {
        (m !== t && !oi(l[f], m) || m === t && !(f in l)) && Vi(l, f, m);
      }
      function yl(l, f, m) {
        var v = l[f];
        (!(ft.call(l, f) && oi(v, m)) || m === t && !(f in l)) && Vi(l, f, m);
      }
      function pu(l, f) {
        for (var m = l.length; m--; )
          if (oi(l[m][0], f))
            return m;
        return -1;
      }
      function yO(l, f, m, v) {
        return As(l, function(E, D, M) {
          f(v, E, m(E), M);
        }), v;
      }
      function q0(l, f) {
        return l && wi(f, mn(f), l);
      }
      function vO(l, f) {
        return l && wi(f, ur(f), l);
      }
      function Vi(l, f, m) {
        f == "__proto__" && lu ? lu(l, f, {
          configurable: !0,
          enumerable: !0,
          value: m,
          writable: !0
        }) : l[f] = m;
      }
      function Ph(l, f) {
        for (var m = -1, v = f.length, E = V(v), D = l == null; ++m < v; )
          E[m] = D ? t : mp(l, f[m]);
        return E;
      }
      function po(l, f, m) {
        return l === l && (m !== t && (l = l <= m ? l : m), f !== t && (l = l >= f ? l : f)), l;
      }
      function jr(l, f, m, v, E, D) {
        var M, P = f & h, F = f & p, ee = f & g;
        if (m && (M = E ? m(l, v, E, D) : m(l)), M !== t)
          return M;
        if (!Ht(l))
          return l;
        var te = Ue(l);
        if (te) {
          if (M = oI(l), !P)
            return lr(l, M);
        } else {
          var se = zn(l), ye = se == Q || se == ke;
          if (Rs(l))
            return vb(l, P);
          if (se == kt || se == xe || ye && !E) {
            if (M = F || ye ? {} : Bb(l), !P)
              return F ? KO(l, vO(M, l)) : qO(l, q0(M, l));
          } else {
            if (!Tt[se])
              return E ? l : {};
            M = aI(l, se, P);
          }
        }
        D || (D = new si());
        var Re = D.get(l);
        if (Re)
          return Re;
        D.set(l, M), fx(l) ? l.forEach(function(Be) {
          M.add(jr(Be, f, m, Be, l, D));
        }) : ux(l) && l.forEach(function(Be, nt) {
          M.set(nt, jr(Be, f, m, nt, l, D));
        });
        var Le = ee ? F ? tp : ep : F ? ur : mn, Je = te ? t : Le(l);
        return Pr(Je || l, function(Be, nt) {
          Je && (nt = Be, Be = l[nt]), yl(M, nt, jr(Be, f, m, nt, l, D));
        }), M;
      }
      function bO(l) {
        var f = mn(l);
        return function(m) {
          return K0(m, l, f);
        };
      }
      function K0(l, f, m) {
        var v = m.length;
        if (l == null)
          return !v;
        for (l = vt(l); v--; ) {
          var E = m[v], D = f[E], M = l[E];
          if (M === t && !(E in l) || !D(M))
            return !1;
        }
        return !0;
      }
      function J0(l, f, m) {
        if (typeof l != "function")
          throw new Lr(o);
        return Al(function() {
          l.apply(t, m);
        }, f);
      }
      function vl(l, f, m, v) {
        var E = -1, D = Qc, M = !0, P = l.length, F = [], ee = f.length;
        if (!P)
          return F;
        m && (f = Bt(f, Sr(m))), v ? (D = Sh, M = !1) : f.length >= i && (D = dl, M = !1, f = new ho(f));
        e:
          for (; ++E < P; ) {
            var te = l[E], se = m == null ? te : m(te);
            if (te = v || te !== 0 ? te : 0, M && se === se) {
              for (var ye = ee; ye--; )
                if (f[ye] === se)
                  continue e;
              F.push(te);
            } else D(f, se, v) || F.push(te);
          }
        return F;
      }
      var As = Eb(Si), Q0 = Eb(Bh, !0);
      function xO(l, f) {
        var m = !0;
        return As(l, function(v, E, D) {
          return m = !!f(v, E, D), m;
        }), m;
      }
      function mu(l, f, m) {
        for (var v = -1, E = l.length; ++v < E; ) {
          var D = l[v], M = f(D);
          if (M != null && (P === t ? M === M && !Er(M) : m(M, P)))
            var P = M, F = D;
        }
        return F;
      }
      function SO(l, f, m, v) {
        var E = l.length;
        for (m = $e(m), m < 0 && (m = -m > E ? 0 : E + m), v = v === t || v > E ? E : $e(v), v < 0 && (v += E), v = m > v ? 0 : px(v); m < v; )
          l[m++] = f;
        return l;
      }
      function Z0(l, f) {
        var m = [];
        return As(l, function(v, E, D) {
          f(v, E, D) && m.push(v);
        }), m;
      }
      function Rn(l, f, m, v, E) {
        var D = -1, M = l.length;
        for (m || (m = cI), E || (E = []); ++D < M; ) {
          var P = l[D];
          f > 0 && m(P) ? f > 1 ? Rn(P, f - 1, m, v, E) : Ss(E, P) : v || (E[E.length] = P);
        }
        return E;
      }
      var Lh = Ab(), X0 = Ab(!0);
      function Si(l, f) {
        return l && Lh(l, f, mn);
      }
      function Bh(l, f) {
        return l && X0(l, f, mn);
      }
      function gu(l, f) {
        return xs(f, function(m) {
          return $i(l[m]);
        });
      }
      function mo(l, f) {
        f = Cs(f, l);
        for (var m = 0, v = f.length; l != null && m < v; )
          l = l[Ei(f[m++])];
        return m && m == v ? l : t;
      }
      function eb(l, f, m) {
        var v = f(l);
        return Ue(l) ? v : Ss(v, m(l));
      }
      function Yn(l) {
        return l == null ? l === t ? qe : It : uo && uo in vt(l) ? rI(l) : gI(l);
      }
      function jh(l, f) {
        return l > f;
      }
      function wO(l, f) {
        return l != null && ft.call(l, f);
      }
      function EO(l, f) {
        return l != null && f in vt(l);
      }
      function AO(l, f, m) {
        return l >= Fn(f, m) && l < dn(f, m);
      }
      function Fh(l, f, m) {
        for (var v = m ? Sh : Qc, E = l[0].length, D = l.length, M = D, P = V(D), F = 1 / 0, ee = []; M--; ) {
          var te = l[M];
          M && f && (te = Bt(te, Sr(f))), F = Fn(te.length, F), P[M] = !m && (f || E >= 120 && te.length >= 120) ? new ho(M && te) : t;
        }
        te = l[0];
        var se = -1, ye = P[0];
        e:
          for (; ++se < E && ee.length < F; ) {
            var Re = te[se], Le = f ? f(Re) : Re;
            if (Re = m || Re !== 0 ? Re : 0, !(ye ? dl(ye, Le) : v(ee, Le, m))) {
              for (M = D; --M; ) {
                var Je = P[M];
                if (!(Je ? dl(Je, Le) : v(l[M], Le, m)))
                  continue e;
              }
              ye && ye.push(Le), ee.push(Re);
            }
          }
        return ee;
      }
      function TO(l, f, m, v) {
        return Si(l, function(E, D, M) {
          f(v, m(E), D, M);
        }), v;
      }
      function bl(l, f, m) {
        f = Cs(f, l), l = Vb(l, f);
        var v = l == null ? l : l[Ei(zr(f))];
        return v == null ? t : xr(v, l, m);
      }
      function tb(l) {
        return Yt(l) && Yn(l) == xe;
      }
      function CO(l) {
        return Yt(l) && Yn(l) == Nt;
      }
      function DO(l) {
        return Yt(l) && Yn(l) == oe;
      }
      function xl(l, f, m, v, E) {
        return l === f ? !0 : l == null || f == null || !Yt(l) && !Yt(f) ? l !== l && f !== f : RO(l, f, m, v, xl, E);
      }
      function RO(l, f, m, v, E, D) {
        var M = Ue(l), P = Ue(f), F = M ? H : zn(l), ee = P ? H : zn(f);
        F = F == xe ? kt : F, ee = ee == xe ? kt : ee;
        var te = F == kt, se = ee == kt, ye = F == ee;
        if (ye && Rs(l)) {
          if (!Rs(f))
            return !1;
          M = !0, te = !1;
        }
        if (ye && !te)
          return D || (D = new si()), M || va(l) ? Nb(l, f, m, v, E, D) : tI(l, f, F, m, v, E, D);
        if (!(m & y)) {
          var Re = te && ft.call(l, "__wrapped__"), Le = se && ft.call(f, "__wrapped__");
          if (Re || Le) {
            var Je = Re ? l.value() : l, Be = Le ? f.value() : f;
            return D || (D = new si()), E(Je, Be, m, v, D);
          }
        }
        return ye ? (D || (D = new si()), nI(l, f, m, v, E, D)) : !1;
      }
      function kO(l) {
        return Yt(l) && zn(l) == Ye;
      }
      function zh(l, f, m, v) {
        var E = m.length, D = E, M = !v;
        if (l == null)
          return !D;
        for (l = vt(l); E--; ) {
          var P = m[E];
          if (M && P[2] ? P[1] !== l[P[0]] : !(P[0] in l))
            return !1;
        }
        for (; ++E < D; ) {
          P = m[E];
          var F = P[0], ee = l[F], te = P[1];
          if (M && P[2]) {
            if (ee === t && !(F in l))
              return !1;
          } else {
            var se = new si();
            if (v)
              var ye = v(ee, te, F, l, f, se);
            if (!(ye === t ? xl(te, ee, y | b, v, se) : ye))
              return !1;
          }
        }
        return !0;
      }
      function nb(l) {
        if (!Ht(l) || dI(l))
          return !1;
        var f = $i(l) ? k_ : tn;
        return f.test(yo(l));
      }
      function MO(l) {
        return Yt(l) && Yn(l) == ir;
      }
      function _O(l) {
        return Yt(l) && zn(l) == Qt;
      }
      function OO(l) {
        return Yt(l) && Iu(l.length) && !!Mt[Yn(l)];
      }
      function rb(l) {
        return typeof l == "function" ? l : l == null ? dr : typeof l == "object" ? Ue(l) ? ob(l[0], l[1]) : sb(l) : Tx(l);
      }
      function Vh(l) {
        if (!El(l))
          return P_(l);
        var f = [];
        for (var m in vt(l))
          ft.call(l, m) && m != "constructor" && f.push(m);
        return f;
      }
      function IO(l) {
        if (!Ht(l))
          return mI(l);
        var f = El(l), m = [];
        for (var v in l)
          v == "constructor" && (f || !ft.call(l, v)) || m.push(v);
        return m;
      }
      function Hh(l, f) {
        return l < f;
      }
      function ib(l, f) {
        var m = -1, v = cr(l) ? V(l.length) : [];
        return As(l, function(E, D, M) {
          v[++m] = f(E, D, M);
        }), v;
      }
      function sb(l) {
        var f = rp(l);
        return f.length == 1 && f[0][2] ? Fb(f[0][0], f[0][1]) : function(m) {
          return m === l || zh(m, l, f);
        };
      }
      function ob(l, f) {
        return sp(l) && jb(f) ? Fb(Ei(l), f) : function(m) {
          var v = mp(m, l);
          return v === t && v === f ? gp(m, l) : xl(f, v, y | b);
        };
      }
      function yu(l, f, m, v, E) {
        l !== f && Lh(f, function(D, M) {
          if (E || (E = new si()), Ht(D))
            NO(l, f, M, m, yu, v, E);
          else {
            var P = v ? v(ap(l, M), D, M + "", l, f, E) : t;
            P === t && (P = D), Nh(l, M, P);
          }
        }, ur);
      }
      function NO(l, f, m, v, E, D, M) {
        var P = ap(l, m), F = ap(f, m), ee = M.get(F);
        if (ee) {
          Nh(l, m, ee);
          return;
        }
        var te = D ? D(P, F, m + "", l, f, M) : t, se = te === t;
        if (se) {
          var ye = Ue(F), Re = !ye && Rs(F), Le = !ye && !Re && va(F);
          te = F, ye || Re || Le ? Ue(P) ? te = P : Xt(P) ? te = lr(P) : Re ? (se = !1, te = vb(F, !0)) : Le ? (se = !1, te = bb(F, !0)) : te = [] : Tl(F) || vo(F) ? (te = P, vo(P) ? te = mx(P) : (!Ht(P) || $i(P)) && (te = Bb(F))) : se = !1;
        }
        se && (M.set(F, te), E(te, F, v, D, M), M.delete(F)), Nh(l, m, te);
      }
      function ab(l, f) {
        var m = l.length;
        if (m)
          return f += f < 0 ? m : 0, Wi(f, m) ? l[f] : t;
      }
      function lb(l, f, m) {
        f.length ? f = Bt(f, function(D) {
          return Ue(D) ? function(M) {
            return mo(M, D.length === 1 ? D[0] : D);
          } : D;
        }) : f = [dr];
        var v = -1;
        f = Bt(f, Sr(Ne()));
        var E = ib(l, function(D, M, P) {
          var F = Bt(f, function(ee) {
            return ee(D);
          });
          return { criteria: F, index: ++v, value: D };
        });
        return a_(E, function(D, M) {
          return YO(D, M, m);
        });
      }
      function PO(l, f) {
        return cb(l, f, function(m, v) {
          return gp(l, v);
        });
      }
      function cb(l, f, m) {
        for (var v = -1, E = f.length, D = {}; ++v < E; ) {
          var M = f[v], P = mo(l, M);
          m(P, M) && Sl(D, Cs(M, l), P);
        }
        return D;
      }
      function LO(l) {
        return function(f) {
          return mo(f, l);
        };
      }
      function Uh(l, f, m, v) {
        var E = v ? o_ : aa, D = -1, M = f.length, P = l;
        for (l === f && (f = lr(f)), m && (P = Bt(l, Sr(m))); ++D < M; )
          for (var F = 0, ee = f[D], te = m ? m(ee) : ee; (F = E(P, te, F, v)) > -1; )
            P !== l && au.call(P, F, 1), au.call(l, F, 1);
        return l;
      }
      function ub(l, f) {
        for (var m = l ? f.length : 0, v = m - 1; m--; ) {
          var E = f[m];
          if (m == v || E !== D) {
            var D = E;
            Wi(E) ? au.call(l, E, 1) : Yh(l, E);
          }
        }
        return l;
      }
      function Wh(l, f) {
        return l + uu(W0() * (f - l + 1));
      }
      function BO(l, f, m, v) {
        for (var E = -1, D = dn(cu((f - l) / (m || 1)), 0), M = V(D); D--; )
          M[v ? D : ++E] = l, l += m;
        return M;
      }
      function $h(l, f) {
        var m = "";
        if (!l || f < 1 || f > J)
          return m;
        do
          f % 2 && (m += l), f = uu(f / 2), f && (l += l);
        while (f);
        return m;
      }
      function et(l, f) {
        return lp(zb(l, f, dr), l + "");
      }
      function jO(l) {
        return Y0(ba(l));
      }
      function FO(l, f) {
        var m = ba(l);
        return Du(m, po(f, 0, m.length));
      }
      function Sl(l, f, m, v) {
        if (!Ht(l))
          return l;
        f = Cs(f, l);
        for (var E = -1, D = f.length, M = D - 1, P = l; P != null && ++E < D; ) {
          var F = Ei(f[E]), ee = m;
          if (F === "__proto__" || F === "constructor" || F === "prototype")
            return l;
          if (E != M) {
            var te = P[F];
            ee = v ? v(te, F, P) : t, ee === t && (ee = Ht(te) ? te : Wi(f[E + 1]) ? [] : {});
          }
          yl(P, F, ee), P = P[F];
        }
        return l;
      }
      var db = du ? function(l, f) {
        return du.set(l, f), l;
      } : dr, zO = lu ? function(l, f) {
        return lu(l, "toString", {
          configurable: !0,
          enumerable: !1,
          value: vp(f),
          writable: !0
        });
      } : dr;
      function VO(l) {
        return Du(ba(l));
      }
      function Fr(l, f, m) {
        var v = -1, E = l.length;
        f < 0 && (f = -f > E ? 0 : E + f), m = m > E ? E : m, m < 0 && (m += E), E = f > m ? 0 : m - f >>> 0, f >>>= 0;
        for (var D = V(E); ++v < E; )
          D[v] = l[v + f];
        return D;
      }
      function HO(l, f) {
        var m;
        return As(l, function(v, E, D) {
          return m = f(v, E, D), !m;
        }), !!m;
      }
      function vu(l, f, m) {
        var v = 0, E = l == null ? v : l.length;
        if (typeof f == "number" && f === f && E <= pe) {
          for (; v < E; ) {
            var D = v + E >>> 1, M = l[D];
            M !== null && !Er(M) && (m ? M <= f : M < f) ? v = D + 1 : E = D;
          }
          return E;
        }
        return Gh(l, f, dr, m);
      }
      function Gh(l, f, m, v) {
        var E = 0, D = l == null ? 0 : l.length;
        if (D === 0)
          return 0;
        f = m(f);
        for (var M = f !== f, P = f === null, F = Er(f), ee = f === t; E < D; ) {
          var te = uu((E + D) / 2), se = m(l[te]), ye = se !== t, Re = se === null, Le = se === se, Je = Er(se);
          if (M)
            var Be = v || Le;
          else ee ? Be = Le && (v || ye) : P ? Be = Le && ye && (v || !Re) : F ? Be = Le && ye && !Re && (v || !Je) : Re || Je ? Be = !1 : Be = v ? se <= f : se < f;
          Be ? E = te + 1 : D = te;
        }
        return Fn(D, me);
      }
      function fb(l, f) {
        for (var m = -1, v = l.length, E = 0, D = []; ++m < v; ) {
          var M = l[m], P = f ? f(M) : M;
          if (!m || !oi(P, F)) {
            var F = P;
            D[E++] = M === 0 ? 0 : M;
          }
        }
        return D;
      }
      function hb(l) {
        return typeof l == "number" ? l : Er(l) ? z : +l;
      }
      function wr(l) {
        if (typeof l == "string")
          return l;
        if (Ue(l))
          return Bt(l, wr) + "";
        if (Er(l))
          return $0 ? $0.call(l) : "";
        var f = l + "";
        return f == "0" && 1 / l == -U ? "-0" : f;
      }
      function Ts(l, f, m) {
        var v = -1, E = Qc, D = l.length, M = !0, P = [], F = P;
        if (m)
          M = !1, E = Sh;
        else if (D >= i) {
          var ee = f ? null : XO(l);
          if (ee)
            return Xc(ee);
          M = !1, E = dl, F = new ho();
        } else
          F = f ? [] : P;
        e:
          for (; ++v < D; ) {
            var te = l[v], se = f ? f(te) : te;
            if (te = m || te !== 0 ? te : 0, M && se === se) {
              for (var ye = F.length; ye--; )
                if (F[ye] === se)
                  continue e;
              f && F.push(se), P.push(te);
            } else E(F, se, m) || (F !== P && F.push(se), P.push(te));
          }
        return P;
      }
      function Yh(l, f) {
        f = Cs(f, l);
        var m = -1, v = f.length;
        if (!v)
          return !0;
        for (var E = l == null || typeof l != "object" && typeof l != "function"; ++m < v; ) {
          var D = f[m];
          if (typeof D == "string") {
            if (D === "__proto__" && !ft.call(l, "__proto__"))
              return !1;
            if (D === "constructor" && m + 1 < v && typeof f[m + 1] == "string" && f[m + 1] === "prototype") {
              if (E && m === 0)
                continue;
              return !1;
            }
          }
        }
        var M = Vb(l, f);
        return M == null || delete M[Ei(zr(f))];
      }
      function pb(l, f, m, v) {
        return Sl(l, f, m(mo(l, f)), v);
      }
      function bu(l, f, m, v) {
        for (var E = l.length, D = v ? E : -1; (v ? D-- : ++D < E) && f(l[D], D, l); )
          ;
        return m ? Fr(l, v ? 0 : D, v ? D + 1 : E) : Fr(l, v ? D + 1 : 0, v ? E : D);
      }
      function mb(l, f) {
        var m = l;
        return m instanceof rt && (m = m.value()), wh(f, function(v, E) {
          return E.func.apply(E.thisArg, Ss([v], E.args));
        }, m);
      }
      function qh(l, f, m) {
        var v = l.length;
        if (v < 2)
          return v ? Ts(l[0]) : [];
        for (var E = -1, D = V(v); ++E < v; )
          for (var M = l[E], P = -1; ++P < v; )
            P != E && (D[E] = vl(D[E] || M, l[P], f, m));
        return Ts(Rn(D, 1), f, m);
      }
      function gb(l, f, m) {
        for (var v = -1, E = l.length, D = f.length, M = {}; ++v < E; ) {
          var P = v < D ? f[v] : t;
          m(M, l[v], P);
        }
        return M;
      }
      function Kh(l) {
        return Xt(l) ? l : [];
      }
      function Jh(l) {
        return typeof l == "function" ? l : dr;
      }
      function Cs(l, f) {
        return Ue(l) ? l : sp(l, f) ? [l] : $b(ht(l));
      }
      var UO = et;
      function Ds(l, f, m) {
        var v = l.length;
        return m = m === t ? v : m, !f && m >= v ? l : Fr(l, f, m);
      }
      var yb = M_ || function(l) {
        return Dn.clearTimeout(l);
      };
      function vb(l, f) {
        if (f)
          return l.slice();
        var m = l.length, v = F0 ? F0(m) : new l.constructor(m);
        return l.copy(v), v;
      }
      function Qh(l) {
        var f = new l.constructor(l.byteLength);
        return new su(f).set(new su(l)), f;
      }
      function WO(l, f) {
        var m = f ? Qh(l.buffer) : l.buffer;
        return new l.constructor(m, l.byteOffset, l.byteLength);
      }
      function $O(l) {
        var f = new l.constructor(l.source, at.exec(l));
        return f.lastIndex = l.lastIndex, f;
      }
      function GO(l) {
        return gl ? vt(gl.call(l)) : {};
      }
      function bb(l, f) {
        var m = f ? Qh(l.buffer) : l.buffer;
        return new l.constructor(m, l.byteOffset, l.length);
      }
      function xb(l, f) {
        if (l !== f) {
          var m = l !== t, v = l === null, E = l === l, D = Er(l), M = f !== t, P = f === null, F = f === f, ee = Er(f);
          if (!P && !ee && !D && l > f || D && M && F && !P && !ee || v && M && F || !m && F || !E)
            return 1;
          if (!v && !D && !ee && l < f || ee && m && E && !v && !D || P && m && E || !M && E || !F)
            return -1;
        }
        return 0;
      }
      function YO(l, f, m) {
        for (var v = -1, E = l.criteria, D = f.criteria, M = E.length, P = m.length; ++v < M; ) {
          var F = xb(E[v], D[v]);
          if (F) {
            if (v >= P)
              return F;
            var ee = m[v];
            return F * (ee == "desc" ? -1 : 1);
          }
        }
        return l.index - f.index;
      }
      function Sb(l, f, m, v) {
        for (var E = -1, D = l.length, M = m.length, P = -1, F = f.length, ee = dn(D - M, 0), te = V(F + ee), se = !v; ++P < F; )
          te[P] = f[P];
        for (; ++E < M; )
          (se || E < D) && (te[m[E]] = l[E]);
        for (; ee--; )
          te[P++] = l[E++];
        return te;
      }
      function wb(l, f, m, v) {
        for (var E = -1, D = l.length, M = -1, P = m.length, F = -1, ee = f.length, te = dn(D - P, 0), se = V(te + ee), ye = !v; ++E < te; )
          se[E] = l[E];
        for (var Re = E; ++F < ee; )
          se[Re + F] = f[F];
        for (; ++M < P; )
          (ye || E < D) && (se[Re + m[M]] = l[E++]);
        return se;
      }
      function lr(l, f) {
        var m = -1, v = l.length;
        for (f || (f = V(v)); ++m < v; )
          f[m] = l[m];
        return f;
      }
      function wi(l, f, m, v) {
        var E = !m;
        m || (m = {});
        for (var D = -1, M = f.length; ++D < M; ) {
          var P = f[D], F = v ? v(m[P], l[P], P, m, l) : t;
          F === t && (F = l[P]), E ? Vi(m, P, F) : yl(m, P, F);
        }
        return m;
      }
      function qO(l, f) {
        return wi(l, ip(l), f);
      }
      function KO(l, f) {
        return wi(l, Pb(l), f);
      }
      function xu(l, f) {
        return function(m, v) {
          var E = Ue(m) ? e_ : yO, D = f ? f() : {};
          return E(m, l, Ne(v, 2), D);
        };
      }
      function ma(l) {
        return et(function(f, m) {
          var v = -1, E = m.length, D = E > 1 ? m[E - 1] : t, M = E > 2 ? m[2] : t;
          for (D = l.length > 3 && typeof D == "function" ? (E--, D) : t, M && qn(m[0], m[1], M) && (D = E < 3 ? t : D, E = 1), f = vt(f); ++v < E; ) {
            var P = m[v];
            P && l(f, P, v, D);
          }
          return f;
        });
      }
      function Eb(l, f) {
        return function(m, v) {
          if (m == null)
            return m;
          if (!cr(m))
            return l(m, v);
          for (var E = m.length, D = f ? E : -1, M = vt(m); (f ? D-- : ++D < E) && v(M[D], D, M) !== !1; )
            ;
          return m;
        };
      }
      function Ab(l) {
        return function(f, m, v) {
          for (var E = -1, D = vt(f), M = v(f), P = M.length; P--; ) {
            var F = M[l ? P : ++E];
            if (m(D[F], F, D) === !1)
              break;
          }
          return f;
        };
      }
      function JO(l, f, m) {
        var v = f & S, E = wl(l);
        function D() {
          var M = this && this !== Dn && this instanceof D ? E : l;
          return M.apply(v ? m : this, arguments);
        }
        return D;
      }
      function Tb(l) {
        return function(f) {
          f = ht(f);
          var m = la(f) ? ii(f) : t, v = m ? m[0] : f.charAt(0), E = m ? Ds(m, 1).join("") : f.slice(1);
          return v[l]() + E;
        };
      }
      function ga(l) {
        return function(f) {
          return wh(Ex(wx(f).replace(zM, "")), l, "");
        };
      }
      function wl(l) {
        return function() {
          var f = arguments;
          switch (f.length) {
            case 0:
              return new l();
            case 1:
              return new l(f[0]);
            case 2:
              return new l(f[0], f[1]);
            case 3:
              return new l(f[0], f[1], f[2]);
            case 4:
              return new l(f[0], f[1], f[2], f[3]);
            case 5:
              return new l(f[0], f[1], f[2], f[3], f[4]);
            case 6:
              return new l(f[0], f[1], f[2], f[3], f[4], f[5]);
            case 7:
              return new l(f[0], f[1], f[2], f[3], f[4], f[5], f[6]);
          }
          var m = pa(l.prototype), v = l.apply(m, f);
          return Ht(v) ? v : m;
        };
      }
      function QO(l, f, m) {
        var v = wl(l);
        function E() {
          for (var D = arguments.length, M = V(D), P = D, F = ya(E); P--; )
            M[P] = arguments[P];
          var ee = D < 3 && M[0] !== F && M[D - 1] !== F ? [] : ws(M, F);
          if (D -= ee.length, D < m)
            return Mb(
              l,
              f,
              Su,
              E.placeholder,
              t,
              M,
              ee,
              t,
              t,
              m - D
            );
          var te = this && this !== Dn && this instanceof E ? v : l;
          return xr(te, this, M);
        }
        return E;
      }
      function Cb(l) {
        return function(f, m, v) {
          var E = vt(f);
          if (!cr(f)) {
            var D = Ne(m, 3);
            f = mn(f), m = function(P) {
              return D(E[P], P, E);
            };
          }
          var M = l(f, m, v);
          return M > -1 ? E[D ? f[M] : M] : t;
        };
      }
      function Db(l) {
        return Ui(function(f) {
          var m = f.length, v = m, E = Br.prototype.thru;
          for (l && f.reverse(); v--; ) {
            var D = f[v];
            if (typeof D != "function")
              throw new Lr(o);
            if (E && !M && Tu(D) == "wrapper")
              var M = new Br([], !0);
          }
          for (v = M ? v : m; ++v < m; ) {
            D = f[v];
            var P = Tu(D), F = P == "wrapper" ? np(D) : t;
            F && op(F[0]) && F[1] == (L | C | R | j) && !F[4].length && F[9] == 1 ? M = M[Tu(F[0])].apply(M, F[3]) : M = D.length == 1 && op(D) ? M[P]() : M.thru(D);
          }
          return function() {
            var ee = arguments, te = ee[0];
            if (M && ee.length == 1 && Ue(te))
              return M.plant(te).value();
            for (var se = 0, ye = m ? f[se].apply(this, ee) : te; ++se < m; )
              ye = f[se].call(this, ye);
            return ye;
          };
        });
      }
      function Su(l, f, m, v, E, D, M, P, F, ee) {
        var te = f & L, se = f & S, ye = f & w, Re = f & (C | k), Le = f & W, Je = ye ? t : wl(l);
        function Be() {
          for (var nt = arguments.length, ot = V(nt), Ar = nt; Ar--; )
            ot[Ar] = arguments[Ar];
          if (Re)
            var Kn = ya(Be), Tr = c_(ot, Kn);
          if (v && (ot = Sb(ot, v, E, Re)), D && (ot = wb(ot, D, M, Re)), nt -= Tr, Re && nt < ee) {
            var en = ws(ot, Kn);
            return Mb(
              l,
              f,
              Su,
              Be.placeholder,
              m,
              ot,
              en,
              P,
              F,
              ee - nt
            );
          }
          var ai = se ? m : this, Yi = ye ? ai[l] : l;
          return nt = ot.length, P ? ot = yI(ot, P) : Le && nt > 1 && ot.reverse(), te && F < nt && (ot.length = F), this && this !== Dn && this instanceof Be && (Yi = Je || wl(Yi)), Yi.apply(ai, ot);
        }
        return Be;
      }
      function Rb(l, f) {
        return function(m, v) {
          return TO(m, l, f(v), {});
        };
      }
      function wu(l, f) {
        return function(m, v) {
          var E;
          if (m === t && v === t)
            return f;
          if (m !== t && (E = m), v !== t) {
            if (E === t)
              return v;
            typeof m == "string" || typeof v == "string" ? (m = wr(m), v = wr(v)) : (m = hb(m), v = hb(v)), E = l(m, v);
          }
          return E;
        };
      }
      function Zh(l) {
        return Ui(function(f) {
          return f = Bt(f, Sr(Ne())), et(function(m) {
            var v = this;
            return l(f, function(E) {
              return xr(E, v, m);
            });
          });
        });
      }
      function Eu(l, f) {
        f = f === t ? " " : wr(f);
        var m = f.length;
        if (m < 2)
          return m ? $h(f, l) : f;
        var v = $h(f, cu(l / ca(f)));
        return la(f) ? Ds(ii(v), 0, l).join("") : v.slice(0, l);
      }
      function ZO(l, f, m, v) {
        var E = f & S, D = wl(l);
        function M() {
          for (var P = -1, F = arguments.length, ee = -1, te = v.length, se = V(te + F), ye = this && this !== Dn && this instanceof M ? D : l; ++ee < te; )
            se[ee] = v[ee];
          for (; F--; )
            se[ee++] = arguments[++P];
          return xr(ye, E ? m : this, se);
        }
        return M;
      }
      function kb(l) {
        return function(f, m, v) {
          return v && typeof v != "number" && qn(f, m, v) && (m = v = t), f = Gi(f), m === t ? (m = f, f = 0) : m = Gi(m), v = v === t ? f < m ? 1 : -1 : Gi(v), BO(f, m, v, l);
        };
      }
      function Au(l) {
        return function(f, m) {
          return typeof f == "string" && typeof m == "string" || (f = Vr(f), m = Vr(m)), l(f, m);
        };
      }
      function Mb(l, f, m, v, E, D, M, P, F, ee) {
        var te = f & C, se = te ? M : t, ye = te ? t : M, Re = te ? D : t, Le = te ? t : D;
        f |= te ? R : N, f &= ~(te ? N : R), f & T || (f &= -4);
        var Je = [
          l,
          f,
          E,
          Re,
          se,
          Le,
          ye,
          P,
          F,
          ee
        ], Be = m.apply(t, Je);
        return op(l) && Hb(Be, Je), Be.placeholder = v, Ub(Be, l, f);
      }
      function Xh(l) {
        var f = un[l];
        return function(m, v) {
          if (m = Vr(m), v = v == null ? 0 : Fn($e(v), 292), v && U0(m)) {
            var E = (ht(m) + "e").split("e"), D = f(E[0] + "e" + (+E[1] + v));
            return E = (ht(D) + "e").split("e"), +(E[0] + "e" + (+E[1] - v));
          }
          return f(m);
        };
      }
      var XO = fa && 1 / Xc(new fa([, -0]))[1] == U ? function(l) {
        return new fa(l);
      } : Sp;
      function _b(l) {
        return function(f) {
          var m = zn(f);
          return m == Ye ? kh(f) : m == Qt ? g_(f) : l_(f, l(f));
        };
      }
      function Hi(l, f, m, v, E, D, M, P) {
        var F = f & w;
        if (!F && typeof l != "function")
          throw new Lr(o);
        var ee = v ? v.length : 0;
        if (ee || (f &= -97, v = E = t), M = M === t ? M : dn($e(M), 0), P = P === t ? P : $e(P), ee -= E ? E.length : 0, f & N) {
          var te = v, se = E;
          v = E = t;
        }
        var ye = F ? t : np(l), Re = [
          l,
          f,
          m,
          v,
          E,
          te,
          se,
          D,
          M,
          P
        ];
        if (ye && pI(Re, ye), l = Re[0], f = Re[1], m = Re[2], v = Re[3], E = Re[4], P = Re[9] = Re[9] === t ? F ? 0 : l.length : dn(Re[9] - ee, 0), !P && f & (C | k) && (f &= -25), !f || f == S)
          var Le = JO(l, f, m);
        else f == C || f == k ? Le = QO(l, f, P) : (f == R || f == (S | R)) && !E.length ? Le = ZO(l, f, m, v) : Le = Su.apply(t, Re);
        var Je = ye ? db : Hb;
        return Ub(Je(Le, Re), l, f);
      }
      function Ob(l, f, m, v) {
        return l === t || oi(l, da[m]) && !ft.call(v, m) ? f : l;
      }
      function Ib(l, f, m, v, E, D) {
        return Ht(l) && Ht(f) && (D.set(f, l), yu(l, f, t, Ib, D), D.delete(f)), l;
      }
      function eI(l) {
        return Tl(l) ? t : l;
      }
      function Nb(l, f, m, v, E, D) {
        var M = m & y, P = l.length, F = f.length;
        if (P != F && !(M && F > P))
          return !1;
        var ee = D.get(l), te = D.get(f);
        if (ee && te)
          return ee == f && te == l;
        var se = -1, ye = !0, Re = m & b ? new ho() : t;
        for (D.set(l, f), D.set(f, l); ++se < P; ) {
          var Le = l[se], Je = f[se];
          if (v)
            var Be = M ? v(Je, Le, se, f, l, D) : v(Le, Je, se, l, f, D);
          if (Be !== t) {
            if (Be)
              continue;
            ye = !1;
            break;
          }
          if (Re) {
            if (!Eh(f, function(nt, ot) {
              if (!dl(Re, ot) && (Le === nt || E(Le, nt, m, v, D)))
                return Re.push(ot);
            })) {
              ye = !1;
              break;
            }
          } else if (!(Le === Je || E(Le, Je, m, v, D))) {
            ye = !1;
            break;
          }
        }
        return D.delete(l), D.delete(f), ye;
      }
      function tI(l, f, m, v, E, D, M) {
        switch (m) {
          case Tn:
            if (l.byteLength != f.byteLength || l.byteOffset != f.byteOffset)
              return !1;
            l = l.buffer, f = f.buffer;
          case Nt:
            return !(l.byteLength != f.byteLength || !D(new su(l), new su(f)));
          case G:
          case oe:
          case it:
            return oi(+l, +f);
          case ge:
            return l.name == f.name && l.message == f.message;
          case ir:
          case Ln:
            return l == f + "";
          case Ye:
            var P = kh;
          case Qt:
            var F = v & y;
            if (P || (P = Xc), l.size != f.size && !F)
              return !1;
            var ee = M.get(l);
            if (ee)
              return ee == f;
            v |= b, M.set(l, f);
            var te = Nb(P(l), P(f), v, E, D, M);
            return M.delete(l), te;
          case sr:
            if (gl)
              return gl.call(l) == gl.call(f);
        }
        return !1;
      }
      function nI(l, f, m, v, E, D) {
        var M = m & y, P = ep(l), F = P.length, ee = ep(f), te = ee.length;
        if (F != te && !M)
          return !1;
        for (var se = F; se--; ) {
          var ye = P[se];
          if (!(M ? ye in f : ft.call(f, ye)))
            return !1;
        }
        var Re = D.get(l), Le = D.get(f);
        if (Re && Le)
          return Re == f && Le == l;
        var Je = !0;
        D.set(l, f), D.set(f, l);
        for (var Be = M; ++se < F; ) {
          ye = P[se];
          var nt = l[ye], ot = f[ye];
          if (v)
            var Ar = M ? v(ot, nt, ye, f, l, D) : v(nt, ot, ye, l, f, D);
          if (!(Ar === t ? nt === ot || E(nt, ot, m, v, D) : Ar)) {
            Je = !1;
            break;
          }
          Be || (Be = ye == "constructor");
        }
        if (Je && !Be) {
          var Kn = l.constructor, Tr = f.constructor;
          Kn != Tr && "constructor" in l && "constructor" in f && !(typeof Kn == "function" && Kn instanceof Kn && typeof Tr == "function" && Tr instanceof Tr) && (Je = !1);
        }
        return D.delete(l), D.delete(f), Je;
      }
      function Ui(l) {
        return lp(zb(l, t, Kb), l + "");
      }
      function ep(l) {
        return eb(l, mn, ip);
      }
      function tp(l) {
        return eb(l, ur, Pb);
      }
      var np = du ? function(l) {
        return du.get(l);
      } : Sp;
      function Tu(l) {
        for (var f = l.name + "", m = ha[f], v = ft.call(ha, f) ? m.length : 0; v--; ) {
          var E = m[v], D = E.func;
          if (D == null || D == l)
            return E.name;
        }
        return f;
      }
      function ya(l) {
        var f = ft.call(A, "placeholder") ? A : l;
        return f.placeholder;
      }
      function Ne() {
        var l = A.iteratee || bp;
        return l = l === bp ? rb : l, arguments.length ? l(arguments[0], arguments[1]) : l;
      }
      function Cu(l, f) {
        var m = l.__data__;
        return uI(f) ? m[typeof f == "string" ? "string" : "hash"] : m.map;
      }
      function rp(l) {
        for (var f = mn(l), m = f.length; m--; ) {
          var v = f[m], E = l[v];
          f[m] = [v, E, jb(E)];
        }
        return f;
      }
      function go(l, f) {
        var m = h_(l, f);
        return nb(m) ? m : t;
      }
      function rI(l) {
        var f = ft.call(l, uo), m = l[uo];
        try {
          l[uo] = t;
          var v = !0;
        } catch {
        }
        var E = ru.call(l);
        return v && (f ? l[uo] = m : delete l[uo]), E;
      }
      var ip = _h ? function(l) {
        return l == null ? [] : (l = vt(l), xs(_h(l), function(f) {
          return V0.call(l, f);
        }));
      } : wp, Pb = _h ? function(l) {
        for (var f = []; l; )
          Ss(f, ip(l)), l = ou(l);
        return f;
      } : wp, zn = Yn;
      (Oh && zn(new Oh(new ArrayBuffer(1))) != Tn || hl && zn(new hl()) != Ye || Ih && zn(Ih.resolve()) != pn || fa && zn(new fa()) != Qt || pl && zn(new pl()) != ut) && (zn = function(l) {
        var f = Yn(l), m = f == kt ? l.constructor : t, v = m ? yo(m) : "";
        if (v)
          switch (v) {
            case F_:
              return Tn;
            case z_:
              return Ye;
            case V_:
              return pn;
            case H_:
              return Qt;
            case U_:
              return ut;
          }
        return f;
      });
      function iI(l, f, m) {
        for (var v = -1, E = m.length; ++v < E; ) {
          var D = m[v], M = D.size;
          switch (D.type) {
            case "drop":
              l += M;
              break;
            case "dropRight":
              f -= M;
              break;
            case "take":
              f = Fn(f, l + M);
              break;
            case "takeRight":
              l = dn(l, f - M);
              break;
          }
        }
        return { start: l, end: f };
      }
      function sI(l) {
        var f = l.match(cl);
        return f ? f[1].split(O) : [];
      }
      function Lb(l, f, m) {
        f = Cs(f, l);
        for (var v = -1, E = f.length, D = !1; ++v < E; ) {
          var M = Ei(f[v]);
          if (!(D = l != null && m(l, M)))
            break;
          l = l[M];
        }
        return D || ++v != E ? D : (E = l == null ? 0 : l.length, !!E && Iu(E) && Wi(M, E) && (Ue(l) || vo(l)));
      }
      function oI(l) {
        var f = l.length, m = new l.constructor(f);
        return f && typeof l[0] == "string" && ft.call(l, "index") && (m.index = l.index, m.input = l.input), m;
      }
      function Bb(l) {
        return typeof l.constructor == "function" && !El(l) ? pa(ou(l)) : {};
      }
      function aI(l, f, m) {
        var v = l.constructor;
        switch (f) {
          case Nt:
            return Qh(l);
          case G:
          case oe:
            return new v(+l);
          case Tn:
            return WO(l, m);
          case Gn:
          case cn:
          case ei:
          case or:
          case Or:
          case ti:
          case gs:
          case gi:
          case yi:
            return bb(l, m);
          case Ye:
            return new v();
          case it:
          case Ln:
            return new v(l);
          case ir:
            return $O(l);
          case Qt:
            return new v();
          case sr:
            return GO(l);
        }
      }
      function lI(l, f) {
        var m = f.length;
        if (!m)
          return l;
        var v = m - 1;
        return f[v] = (m > 1 ? "& " : "") + f[v], f = f.join(m > 2 ? ", " : " "), l.replace(ra, `{
/* [wrapped with ` + f + `] */
`);
      }
      function cI(l) {
        return Ue(l) || vo(l) || !!(H0 && l && l[H0]);
      }
      function Wi(l, f) {
        var m = typeof l;
        return f = f ?? J, !!f && (m == "number" || m != "symbol" && Pt.test(l)) && l > -1 && l % 1 == 0 && l < f;
      }
      function qn(l, f, m) {
        if (!Ht(m))
          return !1;
        var v = typeof f;
        return (v == "number" ? cr(m) && Wi(f, m.length) : v == "string" && f in m) ? oi(m[f], l) : !1;
      }
      function sp(l, f) {
        if (Ue(l))
          return !1;
        var m = typeof l;
        return m == "number" || m == "symbol" || m == "boolean" || l == null || Er(l) ? !0 : zt.test(l) || !ta.test(l) || f != null && l in vt(f);
      }
      function uI(l) {
        var f = typeof l;
        return f == "string" || f == "number" || f == "symbol" || f == "boolean" ? l !== "__proto__" : l === null;
      }
      function op(l) {
        var f = Tu(l), m = A[f];
        if (typeof m != "function" || !(f in rt.prototype))
          return !1;
        if (l === m)
          return !0;
        var v = np(m);
        return !!v && l === v[0];
      }
      function dI(l) {
        return !!j0 && j0 in l;
      }
      var fI = tu ? $i : Ep;
      function El(l) {
        var f = l && l.constructor, m = typeof f == "function" && f.prototype || da;
        return l === m;
      }
      function jb(l) {
        return l === l && !Ht(l);
      }
      function Fb(l, f) {
        return function(m) {
          return m == null ? !1 : m[l] === f && (f !== t || l in vt(m));
        };
      }
      function hI(l) {
        var f = _u(l, function(v) {
          return m.size === u && m.clear(), v;
        }), m = f.cache;
        return f;
      }
      function pI(l, f) {
        var m = l[1], v = f[1], E = m | v, D = E < (S | w | L), M = v == L && m == C || v == L && m == j && l[7].length <= f[8] || v == (L | j) && f[7].length <= f[8] && m == C;
        if (!(D || M))
          return l;
        v & S && (l[2] = f[2], E |= m & S ? 0 : T);
        var P = f[3];
        if (P) {
          var F = l[3];
          l[3] = F ? Sb(F, P, f[4]) : P, l[4] = F ? ws(l[3], d) : f[4];
        }
        return P = f[5], P && (F = l[5], l[5] = F ? wb(F, P, f[6]) : P, l[6] = F ? ws(l[5], d) : f[6]), P = f[7], P && (l[7] = P), v & L && (l[8] = l[8] == null ? f[8] : Fn(l[8], f[8])), l[9] == null && (l[9] = f[9]), l[0] = f[0], l[1] = E, l;
      }
      function mI(l) {
        var f = [];
        if (l != null)
          for (var m in vt(l))
            f.push(m);
        return f;
      }
      function gI(l) {
        return ru.call(l);
      }
      function zb(l, f, m) {
        return f = dn(f === t ? l.length - 1 : f, 0), function() {
          for (var v = arguments, E = -1, D = dn(v.length - f, 0), M = V(D); ++E < D; )
            M[E] = v[f + E];
          E = -1;
          for (var P = V(f + 1); ++E < f; )
            P[E] = v[E];
          return P[f] = m(M), xr(l, this, P);
        };
      }
      function Vb(l, f) {
        return f.length < 2 ? l : mo(l, Fr(f, 0, -1));
      }
      function yI(l, f) {
        for (var m = l.length, v = Fn(f.length, m), E = lr(l); v--; ) {
          var D = f[v];
          l[v] = Wi(D, m) ? E[D] : t;
        }
        return l;
      }
      function ap(l, f) {
        if (!(f === "constructor" && typeof l[f] == "function") && f != "__proto__")
          return l[f];
      }
      var Hb = Wb(db), Al = O_ || function(l, f) {
        return Dn.setTimeout(l, f);
      }, lp = Wb(zO);
      function Ub(l, f, m) {
        var v = f + "";
        return lp(l, lI(v, vI(sI(v), m)));
      }
      function Wb(l) {
        var f = 0, m = 0;
        return function() {
          var v = L_(), E = Ae - (v - m);
          if (m = v, E > 0) {
            if (++f >= Oe)
              return arguments[0];
          } else
            f = 0;
          return l.apply(t, arguments);
        };
      }
      function Du(l, f) {
        var m = -1, v = l.length, E = v - 1;
        for (f = f === t ? v : f; ++m < f; ) {
          var D = Wh(m, E), M = l[D];
          l[D] = l[m], l[m] = M;
        }
        return l.length = f, l;
      }
      var $b = hI(function(l) {
        var f = [];
        return l.charCodeAt(0) === 46 && f.push(""), l.replace(bi, function(m, v, E, D) {
          f.push(E ? D.replace(Ie, "$1") : v || m);
        }), f;
      });
      function Ei(l) {
        if (typeof l == "string" || Er(l))
          return l;
        var f = l + "";
        return f == "0" && 1 / l == -U ? "-0" : f;
      }
      function yo(l) {
        if (l != null) {
          try {
            return nu.call(l);
          } catch {
          }
          try {
            return l + "";
          } catch {
          }
        }
        return "";
      }
      function vI(l, f) {
        return Pr(he, function(m) {
          var v = "_." + m[0];
          f & m[1] && !Qc(l, v) && l.push(v);
        }), l.sort();
      }
      function Gb(l) {
        if (l instanceof rt)
          return l.clone();
        var f = new Br(l.__wrapped__, l.__chain__);
        return f.__actions__ = lr(l.__actions__), f.__index__ = l.__index__, f.__values__ = l.__values__, f;
      }
      function bI(l, f, m) {
        (m ? qn(l, f, m) : f === t) ? f = 1 : f = dn($e(f), 0);
        var v = l == null ? 0 : l.length;
        if (!v || f < 1)
          return [];
        for (var E = 0, D = 0, M = V(cu(v / f)); E < v; )
          M[D++] = Fr(l, E, E += f);
        return M;
      }
      function xI(l) {
        for (var f = -1, m = l == null ? 0 : l.length, v = 0, E = []; ++f < m; ) {
          var D = l[f];
          D && (E[v++] = D);
        }
        return E;
      }
      function SI() {
        var l = arguments.length;
        if (!l)
          return [];
        for (var f = V(l - 1), m = arguments[0], v = l; v--; )
          f[v - 1] = arguments[v];
        return Ss(Ue(m) ? lr(m) : [m], Rn(f, 1));
      }
      var wI = et(function(l, f) {
        return Xt(l) ? vl(l, Rn(f, 1, Xt, !0)) : [];
      }), EI = et(function(l, f) {
        var m = zr(f);
        return Xt(m) && (m = t), Xt(l) ? vl(l, Rn(f, 1, Xt, !0), Ne(m, 2)) : [];
      }), AI = et(function(l, f) {
        var m = zr(f);
        return Xt(m) && (m = t), Xt(l) ? vl(l, Rn(f, 1, Xt, !0), t, m) : [];
      });
      function TI(l, f, m) {
        var v = l == null ? 0 : l.length;
        return v ? (f = m || f === t ? 1 : $e(f), Fr(l, f < 0 ? 0 : f, v)) : [];
      }
      function CI(l, f, m) {
        var v = l == null ? 0 : l.length;
        return v ? (f = m || f === t ? 1 : $e(f), f = v - f, Fr(l, 0, f < 0 ? 0 : f)) : [];
      }
      function DI(l, f) {
        return l && l.length ? bu(l, Ne(f, 3), !0, !0) : [];
      }
      function RI(l, f) {
        return l && l.length ? bu(l, Ne(f, 3), !0) : [];
      }
      function kI(l, f, m, v) {
        var E = l == null ? 0 : l.length;
        return E ? (m && typeof m != "number" && qn(l, f, m) && (m = 0, v = E), SO(l, f, m, v)) : [];
      }
      function Yb(l, f, m) {
        var v = l == null ? 0 : l.length;
        if (!v)
          return -1;
        var E = m == null ? 0 : $e(m);
        return E < 0 && (E = dn(v + E, 0)), Zc(l, Ne(f, 3), E);
      }
      function qb(l, f, m) {
        var v = l == null ? 0 : l.length;
        if (!v)
          return -1;
        var E = v - 1;
        return m !== t && (E = $e(m), E = m < 0 ? dn(v + E, 0) : Fn(E, v - 1)), Zc(l, Ne(f, 3), E, !0);
      }
      function Kb(l) {
        var f = l == null ? 0 : l.length;
        return f ? Rn(l, 1) : [];
      }
      function MI(l) {
        var f = l == null ? 0 : l.length;
        return f ? Rn(l, U) : [];
      }
      function _I(l, f) {
        var m = l == null ? 0 : l.length;
        return m ? (f = f === t ? 1 : $e(f), Rn(l, f)) : [];
      }
      function OI(l) {
        for (var f = -1, m = l == null ? 0 : l.length, v = {}; ++f < m; ) {
          var E = l[f];
          v[E[0]] = E[1];
        }
        return v;
      }
      function Jb(l) {
        return l && l.length ? l[0] : t;
      }
      function II(l, f, m) {
        var v = l == null ? 0 : l.length;
        if (!v)
          return -1;
        var E = m == null ? 0 : $e(m);
        return E < 0 && (E = dn(v + E, 0)), aa(l, f, E);
      }
      function NI(l) {
        var f = l == null ? 0 : l.length;
        return f ? Fr(l, 0, -1) : [];
      }
      var PI = et(function(l) {
        var f = Bt(l, Kh);
        return f.length && f[0] === l[0] ? Fh(f) : [];
      }), LI = et(function(l) {
        var f = zr(l), m = Bt(l, Kh);
        return f === zr(m) ? f = t : m.pop(), m.length && m[0] === l[0] ? Fh(m, Ne(f, 2)) : [];
      }), BI = et(function(l) {
        var f = zr(l), m = Bt(l, Kh);
        return f = typeof f == "function" ? f : t, f && m.pop(), m.length && m[0] === l[0] ? Fh(m, t, f) : [];
      });
      function jI(l, f) {
        return l == null ? "" : N_.call(l, f);
      }
      function zr(l) {
        var f = l == null ? 0 : l.length;
        return f ? l[f - 1] : t;
      }
      function FI(l, f, m) {
        var v = l == null ? 0 : l.length;
        if (!v)
          return -1;
        var E = v;
        return m !== t && (E = $e(m), E = E < 0 ? dn(v + E, 0) : Fn(E, v - 1)), f === f ? v_(l, f, E) : Zc(l, M0, E, !0);
      }
      function zI(l, f) {
        return l && l.length ? ab(l, $e(f)) : t;
      }
      var VI = et(Qb);
      function Qb(l, f) {
        return l && l.length && f && f.length ? Uh(l, f) : l;
      }
      function HI(l, f, m) {
        return l && l.length && f && f.length ? Uh(l, f, Ne(m, 2)) : l;
      }
      function UI(l, f, m) {
        return l && l.length && f && f.length ? Uh(l, f, t, m) : l;
      }
      var WI = Ui(function(l, f) {
        var m = l == null ? 0 : l.length, v = Ph(l, f);
        return ub(l, Bt(f, function(E) {
          return Wi(E, m) ? +E : E;
        }).sort(xb)), v;
      });
      function $I(l, f) {
        var m = [];
        if (!(l && l.length))
          return m;
        var v = -1, E = [], D = l.length;
        for (f = Ne(f, 3); ++v < D; ) {
          var M = l[v];
          f(M, v, l) && (m.push(M), E.push(v));
        }
        return ub(l, E), m;
      }
      function cp(l) {
        return l == null ? l : j_.call(l);
      }
      function GI(l, f, m) {
        var v = l == null ? 0 : l.length;
        return v ? (m && typeof m != "number" && qn(l, f, m) ? (f = 0, m = v) : (f = f == null ? 0 : $e(f), m = m === t ? v : $e(m)), Fr(l, f, m)) : [];
      }
      function YI(l, f) {
        return vu(l, f);
      }
      function qI(l, f, m) {
        return Gh(l, f, Ne(m, 2));
      }
      function KI(l, f) {
        var m = l == null ? 0 : l.length;
        if (m) {
          var v = vu(l, f);
          if (v < m && oi(l[v], f))
            return v;
        }
        return -1;
      }
      function JI(l, f) {
        return vu(l, f, !0);
      }
      function QI(l, f, m) {
        return Gh(l, f, Ne(m, 2), !0);
      }
      function ZI(l, f) {
        var m = l == null ? 0 : l.length;
        if (m) {
          var v = vu(l, f, !0) - 1;
          if (oi(l[v], f))
            return v;
        }
        return -1;
      }
      function XI(l) {
        return l && l.length ? fb(l) : [];
      }
      function eN(l, f) {
        return l && l.length ? fb(l, Ne(f, 2)) : [];
      }
      function tN(l) {
        var f = l == null ? 0 : l.length;
        return f ? Fr(l, 1, f) : [];
      }
      function nN(l, f, m) {
        return l && l.length ? (f = m || f === t ? 1 : $e(f), Fr(l, 0, f < 0 ? 0 : f)) : [];
      }
      function rN(l, f, m) {
        var v = l == null ? 0 : l.length;
        return v ? (f = m || f === t ? 1 : $e(f), f = v - f, Fr(l, f < 0 ? 0 : f, v)) : [];
      }
      function iN(l, f) {
        return l && l.length ? bu(l, Ne(f, 3), !1, !0) : [];
      }
      function sN(l, f) {
        return l && l.length ? bu(l, Ne(f, 3)) : [];
      }
      var oN = et(function(l) {
        return Ts(Rn(l, 1, Xt, !0));
      }), aN = et(function(l) {
        var f = zr(l);
        return Xt(f) && (f = t), Ts(Rn(l, 1, Xt, !0), Ne(f, 2));
      }), lN = et(function(l) {
        var f = zr(l);
        return f = typeof f == "function" ? f : t, Ts(Rn(l, 1, Xt, !0), t, f);
      });
      function cN(l) {
        return l && l.length ? Ts(l) : [];
      }
      function uN(l, f) {
        return l && l.length ? Ts(l, Ne(f, 2)) : [];
      }
      function dN(l, f) {
        return f = typeof f == "function" ? f : t, l && l.length ? Ts(l, t, f) : [];
      }
      function up(l) {
        if (!(l && l.length))
          return [];
        var f = 0;
        return l = xs(l, function(m) {
          if (Xt(m))
            return f = dn(m.length, f), !0;
        }), Dh(f, function(m) {
          return Bt(l, Ah(m));
        });
      }
      function Zb(l, f) {
        if (!(l && l.length))
          return [];
        var m = up(l);
        return f == null ? m : Bt(m, function(v) {
          return xr(f, t, v);
        });
      }
      var fN = et(function(l, f) {
        return Xt(l) ? vl(l, f) : [];
      }), hN = et(function(l) {
        return qh(xs(l, Xt));
      }), pN = et(function(l) {
        var f = zr(l);
        return Xt(f) && (f = t), qh(xs(l, Xt), Ne(f, 2));
      }), mN = et(function(l) {
        var f = zr(l);
        return f = typeof f == "function" ? f : t, qh(xs(l, Xt), t, f);
      }), gN = et(up);
      function yN(l, f) {
        return gb(l || [], f || [], yl);
      }
      function vN(l, f) {
        return gb(l || [], f || [], Sl);
      }
      var bN = et(function(l) {
        var f = l.length, m = f > 1 ? l[f - 1] : t;
        return m = typeof m == "function" ? (l.pop(), m) : t, Zb(l, m);
      });
      function Xb(l) {
        var f = A(l);
        return f.__chain__ = !0, f;
      }
      function xN(l, f) {
        return f(l), l;
      }
      function Ru(l, f) {
        return f(l);
      }
      var SN = Ui(function(l) {
        var f = l.length, m = f ? l[0] : 0, v = this.__wrapped__, E = function(D) {
          return Ph(D, l);
        };
        return f > 1 || this.__actions__.length || !(v instanceof rt) || !Wi(m) ? this.thru(E) : (v = v.slice(m, +m + (f ? 1 : 0)), v.__actions__.push({
          func: Ru,
          args: [E],
          thisArg: t
        }), new Br(v, this.__chain__).thru(function(D) {
          return f && !D.length && D.push(t), D;
        }));
      });
      function wN() {
        return Xb(this);
      }
      function EN() {
        return new Br(this.value(), this.__chain__);
      }
      function AN() {
        this.__values__ === t && (this.__values__ = hx(this.value()));
        var l = this.__index__ >= this.__values__.length, f = l ? t : this.__values__[this.__index__++];
        return { done: l, value: f };
      }
      function TN() {
        return this;
      }
      function CN(l) {
        for (var f, m = this; m instanceof hu; ) {
          var v = Gb(m);
          v.__index__ = 0, v.__values__ = t, f ? E.__wrapped__ = v : f = v;
          var E = v;
          m = m.__wrapped__;
        }
        return E.__wrapped__ = l, f;
      }
      function DN() {
        var l = this.__wrapped__;
        if (l instanceof rt) {
          var f = l;
          return this.__actions__.length && (f = new rt(this)), f = f.reverse(), f.__actions__.push({
            func: Ru,
            args: [cp],
            thisArg: t
          }), new Br(f, this.__chain__);
        }
        return this.thru(cp);
      }
      function RN() {
        return mb(this.__wrapped__, this.__actions__);
      }
      var kN = xu(function(l, f, m) {
        ft.call(l, m) ? ++l[m] : Vi(l, m, 1);
      });
      function MN(l, f, m) {
        var v = Ue(l) ? R0 : xO;
        return m && qn(l, f, m) && (f = t), v(l, Ne(f, 3));
      }
      function _N(l, f) {
        var m = Ue(l) ? xs : Z0;
        return m(l, Ne(f, 3));
      }
      var ON = Cb(Yb), IN = Cb(qb);
      function NN(l, f) {
        return Rn(ku(l, f), 1);
      }
      function PN(l, f) {
        return Rn(ku(l, f), U);
      }
      function LN(l, f, m) {
        return m = m === t ? 1 : $e(m), Rn(ku(l, f), m);
      }
      function ex(l, f) {
        var m = Ue(l) ? Pr : As;
        return m(l, Ne(f, 3));
      }
      function tx(l, f) {
        var m = Ue(l) ? t_ : Q0;
        return m(l, Ne(f, 3));
      }
      var BN = xu(function(l, f, m) {
        ft.call(l, m) ? l[m].push(f) : Vi(l, m, [f]);
      });
      function jN(l, f, m, v) {
        l = cr(l) ? l : ba(l), m = m && !v ? $e(m) : 0;
        var E = l.length;
        return m < 0 && (m = dn(E + m, 0)), Nu(l) ? m <= E && l.indexOf(f, m) > -1 : !!E && aa(l, f, m) > -1;
      }
      var FN = et(function(l, f, m) {
        var v = -1, E = typeof f == "function", D = cr(l) ? V(l.length) : [];
        return As(l, function(M) {
          D[++v] = E ? xr(f, M, m) : bl(M, f, m);
        }), D;
      }), zN = xu(function(l, f, m) {
        Vi(l, m, f);
      });
      function ku(l, f) {
        var m = Ue(l) ? Bt : ib;
        return m(l, Ne(f, 3));
      }
      function VN(l, f, m, v) {
        return l == null ? [] : (Ue(f) || (f = f == null ? [] : [f]), m = v ? t : m, Ue(m) || (m = m == null ? [] : [m]), lb(l, f, m));
      }
      var HN = xu(function(l, f, m) {
        l[m ? 0 : 1].push(f);
      }, function() {
        return [[], []];
      });
      function UN(l, f, m) {
        var v = Ue(l) ? wh : O0, E = arguments.length < 3;
        return v(l, Ne(f, 4), m, E, As);
      }
      function WN(l, f, m) {
        var v = Ue(l) ? n_ : O0, E = arguments.length < 3;
        return v(l, Ne(f, 4), m, E, Q0);
      }
      function $N(l, f) {
        var m = Ue(l) ? xs : Z0;
        return m(l, Ou(Ne(f, 3)));
      }
      function GN(l) {
        var f = Ue(l) ? Y0 : jO;
        return f(l);
      }
      function YN(l, f, m) {
        (m ? qn(l, f, m) : f === t) ? f = 1 : f = $e(f);
        var v = Ue(l) ? mO : FO;
        return v(l, f);
      }
      function qN(l) {
        var f = Ue(l) ? gO : VO;
        return f(l);
      }
      function KN(l) {
        if (l == null)
          return 0;
        if (cr(l))
          return Nu(l) ? ca(l) : l.length;
        var f = zn(l);
        return f == Ye || f == Qt ? l.size : Vh(l).length;
      }
      function JN(l, f, m) {
        var v = Ue(l) ? Eh : HO;
        return m && qn(l, f, m) && (f = t), v(l, Ne(f, 3));
      }
      var QN = et(function(l, f) {
        if (l == null)
          return [];
        var m = f.length;
        return m > 1 && qn(l, f[0], f[1]) ? f = [] : m > 2 && qn(f[0], f[1], f[2]) && (f = [f[0]]), lb(l, Rn(f, 1), []);
      }), Mu = __ || function() {
        return Dn.Date.now();
      };
      function ZN(l, f) {
        if (typeof f != "function")
          throw new Lr(o);
        return l = $e(l), function() {
          if (--l < 1)
            return f.apply(this, arguments);
        };
      }
      function nx(l, f, m) {
        return f = m ? t : f, f = l && f == null ? l.length : f, Hi(l, L, t, t, t, t, f);
      }
      function rx(l, f) {
        var m;
        if (typeof f != "function")
          throw new Lr(o);
        return l = $e(l), function() {
          return --l > 0 && (m = f.apply(this, arguments)), l <= 1 && (f = t), m;
        };
      }
      var dp = et(function(l, f, m) {
        var v = S;
        if (m.length) {
          var E = ws(m, ya(dp));
          v |= R;
        }
        return Hi(l, v, f, m, E);
      }), ix = et(function(l, f, m) {
        var v = S | w;
        if (m.length) {
          var E = ws(m, ya(ix));
          v |= R;
        }
        return Hi(f, v, l, m, E);
      });
      function sx(l, f, m) {
        f = m ? t : f;
        var v = Hi(l, C, t, t, t, t, t, f);
        return v.placeholder = sx.placeholder, v;
      }
      function ox(l, f, m) {
        f = m ? t : f;
        var v = Hi(l, k, t, t, t, t, t, f);
        return v.placeholder = ox.placeholder, v;
      }
      function ax(l, f, m) {
        var v, E, D, M, P, F, ee = 0, te = !1, se = !1, ye = !0;
        if (typeof l != "function")
          throw new Lr(o);
        f = Vr(f) || 0, Ht(m) && (te = !!m.leading, se = "maxWait" in m, D = se ? dn(Vr(m.maxWait) || 0, f) : D, ye = "trailing" in m ? !!m.trailing : ye);
        function Re(en) {
          var ai = v, Yi = E;
          return v = E = t, ee = en, M = l.apply(Yi, ai), M;
        }
        function Le(en) {
          return ee = en, P = Al(nt, f), te ? Re(en) : M;
        }
        function Je(en) {
          var ai = en - F, Yi = en - ee, Cx = f - ai;
          return se ? Fn(Cx, D - Yi) : Cx;
        }
        function Be(en) {
          var ai = en - F, Yi = en - ee;
          return F === t || ai >= f || ai < 0 || se && Yi >= D;
        }
        function nt() {
          var en = Mu();
          if (Be(en))
            return ot(en);
          P = Al(nt, Je(en));
        }
        function ot(en) {
          return P = t, ye && v ? Re(en) : (v = E = t, M);
        }
        function Ar() {
          P !== t && yb(P), ee = 0, v = F = E = P = t;
        }
        function Kn() {
          return P === t ? M : ot(Mu());
        }
        function Tr() {
          var en = Mu(), ai = Be(en);
          if (v = arguments, E = this, F = en, ai) {
            if (P === t)
              return Le(F);
            if (se)
              return yb(P), P = Al(nt, f), Re(F);
          }
          return P === t && (P = Al(nt, f)), M;
        }
        return Tr.cancel = Ar, Tr.flush = Kn, Tr;
      }
      var XN = et(function(l, f) {
        return J0(l, 1, f);
      }), eP = et(function(l, f, m) {
        return J0(l, Vr(f) || 0, m);
      });
      function tP(l) {
        return Hi(l, W);
      }
      function _u(l, f) {
        if (typeof l != "function" || f != null && typeof f != "function")
          throw new Lr(o);
        var m = function() {
          var v = arguments, E = f ? f.apply(this, v) : v[0], D = m.cache;
          if (D.has(E))
            return D.get(E);
          var M = l.apply(this, v);
          return m.cache = D.set(E, M) || D, M;
        };
        return m.cache = new (_u.Cache || zi)(), m;
      }
      _u.Cache = zi;
      function Ou(l) {
        if (typeof l != "function")
          throw new Lr(o);
        return function() {
          var f = arguments;
          switch (f.length) {
            case 0:
              return !l.call(this);
            case 1:
              return !l.call(this, f[0]);
            case 2:
              return !l.call(this, f[0], f[1]);
            case 3:
              return !l.call(this, f[0], f[1], f[2]);
          }
          return !l.apply(this, f);
        };
      }
      function nP(l) {
        return rx(2, l);
      }
      var rP = UO(function(l, f) {
        f = f.length == 1 && Ue(f[0]) ? Bt(f[0], Sr(Ne())) : Bt(Rn(f, 1), Sr(Ne()));
        var m = f.length;
        return et(function(v) {
          for (var E = -1, D = Fn(v.length, m); ++E < D; )
            v[E] = f[E].call(this, v[E]);
          return xr(l, this, v);
        });
      }), fp = et(function(l, f) {
        var m = ws(f, ya(fp));
        return Hi(l, R, t, f, m);
      }), lx = et(function(l, f) {
        var m = ws(f, ya(lx));
        return Hi(l, N, t, f, m);
      }), iP = Ui(function(l, f) {
        return Hi(l, j, t, t, t, f);
      });
      function sP(l, f) {
        if (typeof l != "function")
          throw new Lr(o);
        return f = f === t ? f : $e(f), et(l, f);
      }
      function oP(l, f) {
        if (typeof l != "function")
          throw new Lr(o);
        return f = f == null ? 0 : dn($e(f), 0), et(function(m) {
          var v = m[f], E = Ds(m, 0, f);
          return v && Ss(E, v), xr(l, this, E);
        });
      }
      function aP(l, f, m) {
        var v = !0, E = !0;
        if (typeof l != "function")
          throw new Lr(o);
        return Ht(m) && (v = "leading" in m ? !!m.leading : v, E = "trailing" in m ? !!m.trailing : E), ax(l, f, {
          leading: v,
          maxWait: f,
          trailing: E
        });
      }
      function lP(l) {
        return nx(l, 1);
      }
      function cP(l, f) {
        return fp(Jh(f), l);
      }
      function uP() {
        if (!arguments.length)
          return [];
        var l = arguments[0];
        return Ue(l) ? l : [l];
      }
      function dP(l) {
        return jr(l, g);
      }
      function fP(l, f) {
        return f = typeof f == "function" ? f : t, jr(l, g, f);
      }
      function hP(l) {
        return jr(l, h | g);
      }
      function pP(l, f) {
        return f = typeof f == "function" ? f : t, jr(l, h | g, f);
      }
      function mP(l, f) {
        return f == null || K0(l, f, mn(f));
      }
      function oi(l, f) {
        return l === f || l !== l && f !== f;
      }
      var gP = Au(jh), yP = Au(function(l, f) {
        return l >= f;
      }), vo = tb(/* @__PURE__ */ function() {
        return arguments;
      }()) ? tb : function(l) {
        return Yt(l) && ft.call(l, "callee") && !V0.call(l, "callee");
      }, Ue = V.isArray, vP = w0 ? Sr(w0) : CO;
      function cr(l) {
        return l != null && Iu(l.length) && !$i(l);
      }
      function Xt(l) {
        return Yt(l) && cr(l);
      }
      function bP(l) {
        return l === !0 || l === !1 || Yt(l) && Yn(l) == G;
      }
      var Rs = I_ || Ep, xP = E0 ? Sr(E0) : DO;
      function SP(l) {
        return Yt(l) && l.nodeType === 1 && !Tl(l);
      }
      function wP(l) {
        if (l == null)
          return !0;
        if (cr(l) && (Ue(l) || typeof l == "string" || typeof l.splice == "function" || Rs(l) || va(l) || vo(l)))
          return !l.length;
        var f = zn(l);
        if (f == Ye || f == Qt)
          return !l.size;
        if (El(l))
          return !Vh(l).length;
        for (var m in l)
          if (ft.call(l, m))
            return !1;
        return !0;
      }
      function EP(l, f) {
        return xl(l, f);
      }
      function AP(l, f, m) {
        m = typeof m == "function" ? m : t;
        var v = m ? m(l, f) : t;
        return v === t ? xl(l, f, t, m) : !!v;
      }
      function hp(l) {
        if (!Yt(l))
          return !1;
        var f = Yn(l);
        return f == ge || f == ue || typeof l.message == "string" && typeof l.name == "string" && !Tl(l);
      }
      function TP(l) {
        return typeof l == "number" && U0(l);
      }
      function $i(l) {
        if (!Ht(l))
          return !1;
        var f = Yn(l);
        return f == Q || f == ke || f == le || f == _r;
      }
      function cx(l) {
        return typeof l == "number" && l == $e(l);
      }
      function Iu(l) {
        return typeof l == "number" && l > -1 && l % 1 == 0 && l <= J;
      }
      function Ht(l) {
        var f = typeof l;
        return l != null && (f == "object" || f == "function");
      }
      function Yt(l) {
        return l != null && typeof l == "object";
      }
      var ux = A0 ? Sr(A0) : kO;
      function CP(l, f) {
        return l === f || zh(l, f, rp(f));
      }
      function DP(l, f, m) {
        return m = typeof m == "function" ? m : t, zh(l, f, rp(f), m);
      }
      function RP(l) {
        return dx(l) && l != +l;
      }
      function kP(l) {
        if (fI(l))
          throw new He(s);
        return nb(l);
      }
      function MP(l) {
        return l === null;
      }
      function _P(l) {
        return l == null;
      }
      function dx(l) {
        return typeof l == "number" || Yt(l) && Yn(l) == it;
      }
      function Tl(l) {
        if (!Yt(l) || Yn(l) != kt)
          return !1;
        var f = ou(l);
        if (f === null)
          return !0;
        var m = ft.call(f, "constructor") && f.constructor;
        return typeof m == "function" && m instanceof m && nu.call(m) == D_;
      }
      var pp = T0 ? Sr(T0) : MO;
      function OP(l) {
        return cx(l) && l >= -J && l <= J;
      }
      var fx = C0 ? Sr(C0) : _O;
      function Nu(l) {
        return typeof l == "string" || !Ue(l) && Yt(l) && Yn(l) == Ln;
      }
      function Er(l) {
        return typeof l == "symbol" || Yt(l) && Yn(l) == sr;
      }
      var va = D0 ? Sr(D0) : OO;
      function IP(l) {
        return l === t;
      }
      function NP(l) {
        return Yt(l) && zn(l) == ut;
      }
      function PP(l) {
        return Yt(l) && Yn(l) == vr;
      }
      var LP = Au(Hh), BP = Au(function(l, f) {
        return l <= f;
      });
      function hx(l) {
        if (!l)
          return [];
        if (cr(l))
          return Nu(l) ? ii(l) : lr(l);
        if (fl && l[fl])
          return m_(l[fl]());
        var f = zn(l), m = f == Ye ? kh : f == Qt ? Xc : ba;
        return m(l);
      }
      function Gi(l) {
        if (!l)
          return l === 0 ? l : 0;
        if (l = Vr(l), l === U || l === -U) {
          var f = l < 0 ? -1 : 1;
          return f * we;
        }
        return l === l ? l : 0;
      }
      function $e(l) {
        var f = Gi(l), m = f % 1;
        return f === f ? m ? f - m : f : 0;
      }
      function px(l) {
        return l ? po($e(l), 0, X) : 0;
      }
      function Vr(l) {
        if (typeof l == "number")
          return l;
        if (Er(l))
          return z;
        if (Ht(l)) {
          var f = typeof l.valueOf == "function" ? l.valueOf() : l;
          l = Ht(f) ? f + "" : f;
        }
        if (typeof l != "string")
          return l === 0 ? l : +l;
        l = I0(l);
        var m = je.test(l);
        return m || At.test(l) ? ZM(l.slice(2), m ? 2 : 8) : We.test(l) ? z : +l;
      }
      function mx(l) {
        return wi(l, ur(l));
      }
      function jP(l) {
        return l ? po($e(l), -J, J) : l === 0 ? l : 0;
      }
      function ht(l) {
        return l == null ? "" : wr(l);
      }
      var FP = ma(function(l, f) {
        if (El(f) || cr(f)) {
          wi(f, mn(f), l);
          return;
        }
        for (var m in f)
          ft.call(f, m) && yl(l, m, f[m]);
      }), gx = ma(function(l, f) {
        wi(f, ur(f), l);
      }), Pu = ma(function(l, f, m, v) {
        wi(f, ur(f), l, v);
      }), zP = ma(function(l, f, m, v) {
        wi(f, mn(f), l, v);
      }), VP = Ui(Ph);
      function HP(l, f) {
        var m = pa(l);
        return f == null ? m : q0(m, f);
      }
      var UP = et(function(l, f) {
        l = vt(l);
        var m = -1, v = f.length, E = v > 2 ? f[2] : t;
        for (E && qn(f[0], f[1], E) && (v = 1); ++m < v; )
          for (var D = f[m], M = ur(D), P = -1, F = M.length; ++P < F; ) {
            var ee = M[P], te = l[ee];
            (te === t || oi(te, da[ee]) && !ft.call(l, ee)) && (l[ee] = D[ee]);
          }
        return l;
      }), WP = et(function(l) {
        return l.push(t, Ib), xr(yx, t, l);
      });
      function $P(l, f) {
        return k0(l, Ne(f, 3), Si);
      }
      function GP(l, f) {
        return k0(l, Ne(f, 3), Bh);
      }
      function YP(l, f) {
        return l == null ? l : Lh(l, Ne(f, 3), ur);
      }
      function qP(l, f) {
        return l == null ? l : X0(l, Ne(f, 3), ur);
      }
      function KP(l, f) {
        return l && Si(l, Ne(f, 3));
      }
      function JP(l, f) {
        return l && Bh(l, Ne(f, 3));
      }
      function QP(l) {
        return l == null ? [] : gu(l, mn(l));
      }
      function ZP(l) {
        return l == null ? [] : gu(l, ur(l));
      }
      function mp(l, f, m) {
        var v = l == null ? t : mo(l, f);
        return v === t ? m : v;
      }
      function XP(l, f) {
        return l != null && Lb(l, f, wO);
      }
      function gp(l, f) {
        return l != null && Lb(l, f, EO);
      }
      var eL = Rb(function(l, f, m) {
        f != null && typeof f.toString != "function" && (f = ru.call(f)), l[f] = m;
      }, vp(dr)), tL = Rb(function(l, f, m) {
        f != null && typeof f.toString != "function" && (f = ru.call(f)), ft.call(l, f) ? l[f].push(m) : l[f] = [m];
      }, Ne), nL = et(bl);
      function mn(l) {
        return cr(l) ? G0(l) : Vh(l);
      }
      function ur(l) {
        return cr(l) ? G0(l, !0) : IO(l);
      }
      function rL(l, f) {
        var m = {};
        return f = Ne(f, 3), Si(l, function(v, E, D) {
          Vi(m, f(v, E, D), v);
        }), m;
      }
      function iL(l, f) {
        var m = {};
        return f = Ne(f, 3), Si(l, function(v, E, D) {
          Vi(m, E, f(v, E, D));
        }), m;
      }
      var sL = ma(function(l, f, m) {
        yu(l, f, m);
      }), yx = ma(function(l, f, m, v) {
        yu(l, f, m, v);
      }), oL = Ui(function(l, f) {
        var m = {};
        if (l == null)
          return m;
        var v = !1;
        f = Bt(f, function(D) {
          return D = Cs(D, l), v || (v = D.length > 1), D;
        }), wi(l, tp(l), m), v && (m = jr(m, h | p | g, eI));
        for (var E = f.length; E--; )
          Yh(m, f[E]);
        return m;
      });
      function aL(l, f) {
        return vx(l, Ou(Ne(f)));
      }
      var lL = Ui(function(l, f) {
        return l == null ? {} : PO(l, f);
      });
      function vx(l, f) {
        if (l == null)
          return {};
        var m = Bt(tp(l), function(v) {
          return [v];
        });
        return f = Ne(f), cb(l, m, function(v, E) {
          return f(v, E[0]);
        });
      }
      function cL(l, f, m) {
        f = Cs(f, l);
        var v = -1, E = f.length;
        for (E || (E = 1, l = t); ++v < E; ) {
          var D = l == null ? t : l[Ei(f[v])];
          D === t && (v = E, D = m), l = $i(D) ? D.call(l) : D;
        }
        return l;
      }
      function uL(l, f, m) {
        return l == null ? l : Sl(l, f, m);
      }
      function dL(l, f, m, v) {
        return v = typeof v == "function" ? v : t, l == null ? l : Sl(l, f, m, v);
      }
      var bx = _b(mn), xx = _b(ur);
      function fL(l, f, m) {
        var v = Ue(l), E = v || Rs(l) || va(l);
        if (f = Ne(f, 4), m == null) {
          var D = l && l.constructor;
          E ? m = v ? new D() : [] : Ht(l) ? m = $i(D) ? pa(ou(l)) : {} : m = {};
        }
        return (E ? Pr : Si)(l, function(M, P, F) {
          return f(m, M, P, F);
        }), m;
      }
      function hL(l, f) {
        return l == null ? !0 : Yh(l, f);
      }
      function pL(l, f, m) {
        return l == null ? l : pb(l, f, Jh(m));
      }
      function mL(l, f, m, v) {
        return v = typeof v == "function" ? v : t, l == null ? l : pb(l, f, Jh(m), v);
      }
      function ba(l) {
        return l == null ? [] : Rh(l, mn(l));
      }
      function gL(l) {
        return l == null ? [] : Rh(l, ur(l));
      }
      function yL(l, f, m) {
        return m === t && (m = f, f = t), m !== t && (m = Vr(m), m = m === m ? m : 0), f !== t && (f = Vr(f), f = f === f ? f : 0), po(Vr(l), f, m);
      }
      function vL(l, f, m) {
        return f = Gi(f), m === t ? (m = f, f = 0) : m = Gi(m), l = Vr(l), AO(l, f, m);
      }
      function bL(l, f, m) {
        if (m && typeof m != "boolean" && qn(l, f, m) && (f = m = t), m === t && (typeof f == "boolean" ? (m = f, f = t) : typeof l == "boolean" && (m = l, l = t)), l === t && f === t ? (l = 0, f = 1) : (l = Gi(l), f === t ? (f = l, l = 0) : f = Gi(f)), l > f) {
          var v = l;
          l = f, f = v;
        }
        if (m || l % 1 || f % 1) {
          var E = W0();
          return Fn(l + E * (f - l + QM("1e-" + ((E + "").length - 1))), f);
        }
        return Wh(l, f);
      }
      var xL = ga(function(l, f, m) {
        return f = f.toLowerCase(), l + (m ? Sx(f) : f);
      });
      function Sx(l) {
        return yp(ht(l).toLowerCase());
      }
      function wx(l) {
        return l = ht(l), l && l.replace(Cn, u_).replace(VM, "");
      }
      function SL(l, f, m) {
        l = ht(l), f = wr(f);
        var v = l.length;
        m = m === t ? v : po($e(m), 0, v);
        var E = m;
        return m -= f.length, m >= 0 && l.slice(m, E) == f;
      }
      function wL(l) {
        return l = ht(l), l && oo.test(l) ? l.replace(ys, d_) : l;
      }
      function EL(l) {
        return l = ht(l), l && lo.test(l) ? l.replace(bs, "\\$&") : l;
      }
      var AL = ga(function(l, f, m) {
        return l + (m ? "-" : "") + f.toLowerCase();
      }), TL = ga(function(l, f, m) {
        return l + (m ? " " : "") + f.toLowerCase();
      }), CL = Tb("toLowerCase");
      function DL(l, f, m) {
        l = ht(l), f = $e(f);
        var v = f ? ca(l) : 0;
        if (!f || v >= f)
          return l;
        var E = (f - v) / 2;
        return Eu(uu(E), m) + l + Eu(cu(E), m);
      }
      function RL(l, f, m) {
        l = ht(l), f = $e(f);
        var v = f ? ca(l) : 0;
        return f && v < f ? l + Eu(f - v, m) : l;
      }
      function kL(l, f, m) {
        l = ht(l), f = $e(f);
        var v = f ? ca(l) : 0;
        return f && v < f ? Eu(f - v, m) + l : l;
      }
      function ML(l, f, m) {
        return m || f == null ? f = 0 : f && (f = +f), B_(ht(l).replace(ji, ""), f || 0);
      }
      function _L(l, f, m) {
        return (m ? qn(l, f, m) : f === t) ? f = 1 : f = $e(f), $h(ht(l), f);
      }
      function OL() {
        var l = arguments, f = ht(l[0]);
        return l.length < 3 ? f : f.replace(l[1], l[2]);
      }
      var IL = ga(function(l, f, m) {
        return l + (m ? "_" : "") + f.toLowerCase();
      });
      function NL(l, f, m) {
        return m && typeof m != "number" && qn(l, f, m) && (f = m = t), m = m === t ? X : m >>> 0, m ? (l = ht(l), l && (typeof f == "string" || f != null && !pp(f)) && (f = wr(f), !f && la(l)) ? Ds(ii(l), 0, m) : l.split(f, m)) : [];
      }
      var PL = ga(function(l, f, m) {
        return l + (m ? " " : "") + yp(f);
      });
      function LL(l, f, m) {
        return l = ht(l), m = m == null ? 0 : po($e(m), 0, l.length), f = wr(f), l.slice(m, m + f.length) == f;
      }
      function BL(l, f, m) {
        var v = A.templateSettings;
        m && qn(l, f, m) && (f = t), l = ht(l), f = Pu({}, f, v, Ob);
        var E = Pu({}, f.imports, v.imports, Ob), D = mn(E), M = Rh(E, D), P, F, ee = 0, te = f.interpolate || ar, se = "__p += '", ye = Mh(
          (f.escape || ar).source + "|" + te.source + "|" + (te === ao ? st : ar).source + "|" + (f.evaluate || ar).source + "|$",
          "g"
        ), Re = "//# sourceURL=" + (ft.call(f, "sourceURL") ? (f.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++GM + "]") + `
`;
        l.replace(ye, function(Be, nt, ot, Ar, Kn, Tr) {
          return ot || (ot = Ar), se += l.slice(ee, Tr).replace(br, f_), nt && (P = !0, se += `' +
__e(` + nt + `) +
'`), Kn && (F = !0, se += `';
` + Kn + `;
__p += '`), ot && (se += `' +
((__t = (` + ot + `)) == null ? '' : __t) +
'`), ee = Tr + Be.length, Be;
        }), se += `';
`;
        var Le = ft.call(f, "variable") && f.variable;
        if (!Le)
          se = `with (obj) {
` + se + `
}
`;
        else if (be.test(Le))
          throw new He(a);
        se = (F ? se.replace(Bn, "") : se).replace(ni, "$1").replace(Ir, "$1;"), se = "function(" + (Le || "obj") + `) {
` + (Le ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (P ? ", __e = _.escape" : "") + (F ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + se + `return __p
}`;
        var Je = Ax(function() {
          return dt(D, Re + "return " + se).apply(t, M);
        });
        if (Je.source = se, hp(Je))
          throw Je;
        return Je;
      }
      function jL(l) {
        return ht(l).toLowerCase();
      }
      function FL(l) {
        return ht(l).toUpperCase();
      }
      function zL(l, f, m) {
        if (l = ht(l), l && (m || f === t))
          return I0(l);
        if (!l || !(f = wr(f)))
          return l;
        var v = ii(l), E = ii(f), D = N0(v, E), M = P0(v, E) + 1;
        return Ds(v, D, M).join("");
      }
      function VL(l, f, m) {
        if (l = ht(l), l && (m || f === t))
          return l.slice(0, B0(l) + 1);
        if (!l || !(f = wr(f)))
          return l;
        var v = ii(l), E = P0(v, ii(f)) + 1;
        return Ds(v, 0, E).join("");
      }
      function HL(l, f, m) {
        if (l = ht(l), l && (m || f === t))
          return l.replace(ji, "");
        if (!l || !(f = wr(f)))
          return l;
        var v = ii(l), E = N0(v, ii(f));
        return Ds(v, E).join("");
      }
      function UL(l, f) {
        var m = Z, v = fe;
        if (Ht(f)) {
          var E = "separator" in f ? f.separator : E;
          m = "length" in f ? $e(f.length) : m, v = "omission" in f ? wr(f.omission) : v;
        }
        l = ht(l);
        var D = l.length;
        if (la(l)) {
          var M = ii(l);
          D = M.length;
        }
        if (m >= D)
          return l;
        var P = m - ca(v);
        if (P < 1)
          return v;
        var F = M ? Ds(M, 0, P).join("") : l.slice(0, P);
        if (E === t)
          return F + v;
        if (M && (P += F.length - P), pp(E)) {
          if (l.slice(P).search(E)) {
            var ee, te = F;
            for (E.global || (E = Mh(E.source, ht(at.exec(E)) + "g")), E.lastIndex = 0; ee = E.exec(te); )
              var se = ee.index;
            F = F.slice(0, se === t ? P : se);
          }
        } else if (l.indexOf(wr(E), P) != P) {
          var ye = F.lastIndexOf(E);
          ye > -1 && (F = F.slice(0, ye));
        }
        return F + v;
      }
      function WL(l) {
        return l = ht(l), l && vs.test(l) ? l.replace(vi, b_) : l;
      }
      var $L = ga(function(l, f, m) {
        return l + (m ? " " : "") + f.toUpperCase();
      }), yp = Tb("toUpperCase");
      function Ex(l, f, m) {
        return l = ht(l), f = m ? t : f, f === t ? p_(l) ? w_(l) : s_(l) : l.match(f) || [];
      }
      var Ax = et(function(l, f) {
        try {
          return xr(l, t, f);
        } catch (m) {
          return hp(m) ? m : new He(m);
        }
      }), GL = Ui(function(l, f) {
        return Pr(f, function(m) {
          m = Ei(m), Vi(l, m, dp(l[m], l));
        }), l;
      });
      function YL(l) {
        var f = l == null ? 0 : l.length, m = Ne();
        return l = f ? Bt(l, function(v) {
          if (typeof v[1] != "function")
            throw new Lr(o);
          return [m(v[0]), v[1]];
        }) : [], et(function(v) {
          for (var E = -1; ++E < f; ) {
            var D = l[E];
            if (xr(D[0], this, v))
              return xr(D[1], this, v);
          }
        });
      }
      function qL(l) {
        return bO(jr(l, h));
      }
      function vp(l) {
        return function() {
          return l;
        };
      }
      function KL(l, f) {
        return l == null || l !== l ? f : l;
      }
      var JL = Db(), QL = Db(!0);
      function dr(l) {
        return l;
      }
      function bp(l) {
        return rb(typeof l == "function" ? l : jr(l, h));
      }
      function ZL(l) {
        return sb(jr(l, h));
      }
      function XL(l, f) {
        return ob(l, jr(f, h));
      }
      var e2 = et(function(l, f) {
        return function(m) {
          return bl(m, l, f);
        };
      }), t2 = et(function(l, f) {
        return function(m) {
          return bl(l, m, f);
        };
      });
      function xp(l, f, m) {
        var v = mn(f), E = gu(f, v);
        m == null && !(Ht(f) && (E.length || !v.length)) && (m = f, f = l, l = this, E = gu(f, mn(f)));
        var D = !(Ht(m) && "chain" in m) || !!m.chain, M = $i(l);
        return Pr(E, function(P) {
          var F = f[P];
          l[P] = F, M && (l.prototype[P] = function() {
            var ee = this.__chain__;
            if (D || ee) {
              var te = l(this.__wrapped__), se = te.__actions__ = lr(this.__actions__);
              return se.push({ func: F, args: arguments, thisArg: l }), te.__chain__ = ee, te;
            }
            return F.apply(l, Ss([this.value()], arguments));
          });
        }), l;
      }
      function n2() {
        return Dn._ === this && (Dn._ = R_), this;
      }
      function Sp() {
      }
      function r2(l) {
        return l = $e(l), et(function(f) {
          return ab(f, l);
        });
      }
      var i2 = Zh(Bt), s2 = Zh(R0), o2 = Zh(Eh);
      function Tx(l) {
        return sp(l) ? Ah(Ei(l)) : LO(l);
      }
      function a2(l) {
        return function(f) {
          return l == null ? t : mo(l, f);
        };
      }
      var l2 = kb(), c2 = kb(!0);
      function wp() {
        return [];
      }
      function Ep() {
        return !1;
      }
      function u2() {
        return {};
      }
      function d2() {
        return "";
      }
      function f2() {
        return !0;
      }
      function h2(l, f) {
        if (l = $e(l), l < 1 || l > J)
          return [];
        var m = X, v = Fn(l, X);
        f = Ne(f), l -= X;
        for (var E = Dh(v, f); ++m < l; )
          f(m);
        return E;
      }
      function p2(l) {
        return Ue(l) ? Bt(l, Ei) : Er(l) ? [l] : lr($b(ht(l)));
      }
      function m2(l) {
        var f = ++C_;
        return ht(l) + f;
      }
      var g2 = wu(function(l, f) {
        return l + f;
      }, 0), y2 = Xh("ceil"), v2 = wu(function(l, f) {
        return l / f;
      }, 1), b2 = Xh("floor");
      function x2(l) {
        return l && l.length ? mu(l, dr, jh) : t;
      }
      function S2(l, f) {
        return l && l.length ? mu(l, Ne(f, 2), jh) : t;
      }
      function w2(l) {
        return _0(l, dr);
      }
      function E2(l, f) {
        return _0(l, Ne(f, 2));
      }
      function A2(l) {
        return l && l.length ? mu(l, dr, Hh) : t;
      }
      function T2(l, f) {
        return l && l.length ? mu(l, Ne(f, 2), Hh) : t;
      }
      var C2 = wu(function(l, f) {
        return l * f;
      }, 1), D2 = Xh("round"), R2 = wu(function(l, f) {
        return l - f;
      }, 0);
      function k2(l) {
        return l && l.length ? Ch(l, dr) : 0;
      }
      function M2(l, f) {
        return l && l.length ? Ch(l, Ne(f, 2)) : 0;
      }
      return A.after = ZN, A.ary = nx, A.assign = FP, A.assignIn = gx, A.assignInWith = Pu, A.assignWith = zP, A.at = VP, A.before = rx, A.bind = dp, A.bindAll = GL, A.bindKey = ix, A.castArray = uP, A.chain = Xb, A.chunk = bI, A.compact = xI, A.concat = SI, A.cond = YL, A.conforms = qL, A.constant = vp, A.countBy = kN, A.create = HP, A.curry = sx, A.curryRight = ox, A.debounce = ax, A.defaults = UP, A.defaultsDeep = WP, A.defer = XN, A.delay = eP, A.difference = wI, A.differenceBy = EI, A.differenceWith = AI, A.drop = TI, A.dropRight = CI, A.dropRightWhile = DI, A.dropWhile = RI, A.fill = kI, A.filter = _N, A.flatMap = NN, A.flatMapDeep = PN, A.flatMapDepth = LN, A.flatten = Kb, A.flattenDeep = MI, A.flattenDepth = _I, A.flip = tP, A.flow = JL, A.flowRight = QL, A.fromPairs = OI, A.functions = QP, A.functionsIn = ZP, A.groupBy = BN, A.initial = NI, A.intersection = PI, A.intersectionBy = LI, A.intersectionWith = BI, A.invert = eL, A.invertBy = tL, A.invokeMap = FN, A.iteratee = bp, A.keyBy = zN, A.keys = mn, A.keysIn = ur, A.map = ku, A.mapKeys = rL, A.mapValues = iL, A.matches = ZL, A.matchesProperty = XL, A.memoize = _u, A.merge = sL, A.mergeWith = yx, A.method = e2, A.methodOf = t2, A.mixin = xp, A.negate = Ou, A.nthArg = r2, A.omit = oL, A.omitBy = aL, A.once = nP, A.orderBy = VN, A.over = i2, A.overArgs = rP, A.overEvery = s2, A.overSome = o2, A.partial = fp, A.partialRight = lx, A.partition = HN, A.pick = lL, A.pickBy = vx, A.property = Tx, A.propertyOf = a2, A.pull = VI, A.pullAll = Qb, A.pullAllBy = HI, A.pullAllWith = UI, A.pullAt = WI, A.range = l2, A.rangeRight = c2, A.rearg = iP, A.reject = $N, A.remove = $I, A.rest = sP, A.reverse = cp, A.sampleSize = YN, A.set = uL, A.setWith = dL, A.shuffle = qN, A.slice = GI, A.sortBy = QN, A.sortedUniq = XI, A.sortedUniqBy = eN, A.split = NL, A.spread = oP, A.tail = tN, A.take = nN, A.takeRight = rN, A.takeRightWhile = iN, A.takeWhile = sN, A.tap = xN, A.throttle = aP, A.thru = Ru, A.toArray = hx, A.toPairs = bx, A.toPairsIn = xx, A.toPath = p2, A.toPlainObject = mx, A.transform = fL, A.unary = lP, A.union = oN, A.unionBy = aN, A.unionWith = lN, A.uniq = cN, A.uniqBy = uN, A.uniqWith = dN, A.unset = hL, A.unzip = up, A.unzipWith = Zb, A.update = pL, A.updateWith = mL, A.values = ba, A.valuesIn = gL, A.without = fN, A.words = Ex, A.wrap = cP, A.xor = hN, A.xorBy = pN, A.xorWith = mN, A.zip = gN, A.zipObject = yN, A.zipObjectDeep = vN, A.zipWith = bN, A.entries = bx, A.entriesIn = xx, A.extend = gx, A.extendWith = Pu, xp(A, A), A.add = g2, A.attempt = Ax, A.camelCase = xL, A.capitalize = Sx, A.ceil = y2, A.clamp = yL, A.clone = dP, A.cloneDeep = hP, A.cloneDeepWith = pP, A.cloneWith = fP, A.conformsTo = mP, A.deburr = wx, A.defaultTo = KL, A.divide = v2, A.endsWith = SL, A.eq = oi, A.escape = wL, A.escapeRegExp = EL, A.every = MN, A.find = ON, A.findIndex = Yb, A.findKey = $P, A.findLast = IN, A.findLastIndex = qb, A.findLastKey = GP, A.floor = b2, A.forEach = ex, A.forEachRight = tx, A.forIn = YP, A.forInRight = qP, A.forOwn = KP, A.forOwnRight = JP, A.get = mp, A.gt = gP, A.gte = yP, A.has = XP, A.hasIn = gp, A.head = Jb, A.identity = dr, A.includes = jN, A.indexOf = II, A.inRange = vL, A.invoke = nL, A.isArguments = vo, A.isArray = Ue, A.isArrayBuffer = vP, A.isArrayLike = cr, A.isArrayLikeObject = Xt, A.isBoolean = bP, A.isBuffer = Rs, A.isDate = xP, A.isElement = SP, A.isEmpty = wP, A.isEqual = EP, A.isEqualWith = AP, A.isError = hp, A.isFinite = TP, A.isFunction = $i, A.isInteger = cx, A.isLength = Iu, A.isMap = ux, A.isMatch = CP, A.isMatchWith = DP, A.isNaN = RP, A.isNative = kP, A.isNil = _P, A.isNull = MP, A.isNumber = dx, A.isObject = Ht, A.isObjectLike = Yt, A.isPlainObject = Tl, A.isRegExp = pp, A.isSafeInteger = OP, A.isSet = fx, A.isString = Nu, A.isSymbol = Er, A.isTypedArray = va, A.isUndefined = IP, A.isWeakMap = NP, A.isWeakSet = PP, A.join = jI, A.kebabCase = AL, A.last = zr, A.lastIndexOf = FI, A.lowerCase = TL, A.lowerFirst = CL, A.lt = LP, A.lte = BP, A.max = x2, A.maxBy = S2, A.mean = w2, A.meanBy = E2, A.min = A2, A.minBy = T2, A.stubArray = wp, A.stubFalse = Ep, A.stubObject = u2, A.stubString = d2, A.stubTrue = f2, A.multiply = C2, A.nth = zI, A.noConflict = n2, A.noop = Sp, A.now = Mu, A.pad = DL, A.padEnd = RL, A.padStart = kL, A.parseInt = ML, A.random = bL, A.reduce = UN, A.reduceRight = WN, A.repeat = _L, A.replace = OL, A.result = cL, A.round = D2, A.runInContext = B, A.sample = GN, A.size = KN, A.snakeCase = IL, A.some = JN, A.sortedIndex = YI, A.sortedIndexBy = qI, A.sortedIndexOf = KI, A.sortedLastIndex = JI, A.sortedLastIndexBy = QI, A.sortedLastIndexOf = ZI, A.startCase = PL, A.startsWith = LL, A.subtract = R2, A.sum = k2, A.sumBy = M2, A.template = BL, A.times = h2, A.toFinite = Gi, A.toInteger = $e, A.toLength = px, A.toLower = jL, A.toNumber = Vr, A.toSafeInteger = jP, A.toString = ht, A.toUpper = FL, A.trim = zL, A.trimEnd = VL, A.trimStart = HL, A.truncate = UL, A.unescape = WL, A.uniqueId = m2, A.upperCase = $L, A.upperFirst = yp, A.each = ex, A.eachRight = tx, A.first = Jb, xp(A, function() {
        var l = {};
        return Si(A, function(f, m) {
          ft.call(A.prototype, m) || (l[m] = f);
        }), l;
      }(), { chain: !1 }), A.VERSION = r, Pr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(l) {
        A[l].placeholder = A;
      }), Pr(["drop", "take"], function(l, f) {
        rt.prototype[l] = function(m) {
          m = m === t ? 1 : dn($e(m), 0);
          var v = this.__filtered__ && !f ? new rt(this) : this.clone();
          return v.__filtered__ ? v.__takeCount__ = Fn(m, v.__takeCount__) : v.__views__.push({
            size: Fn(m, X),
            type: l + (v.__dir__ < 0 ? "Right" : "")
          }), v;
        }, rt.prototype[l + "Right"] = function(m) {
          return this.reverse()[l](m).reverse();
        };
      }), Pr(["filter", "map", "takeWhile"], function(l, f) {
        var m = f + 1, v = m == Y || m == q;
        rt.prototype[l] = function(E) {
          var D = this.clone();
          return D.__iteratees__.push({
            iteratee: Ne(E, 3),
            type: m
          }), D.__filtered__ = D.__filtered__ || v, D;
        };
      }), Pr(["head", "last"], function(l, f) {
        var m = "take" + (f ? "Right" : "");
        rt.prototype[l] = function() {
          return this[m](1).value()[0];
        };
      }), Pr(["initial", "tail"], function(l, f) {
        var m = "drop" + (f ? "" : "Right");
        rt.prototype[l] = function() {
          return this.__filtered__ ? new rt(this) : this[m](1);
        };
      }), rt.prototype.compact = function() {
        return this.filter(dr);
      }, rt.prototype.find = function(l) {
        return this.filter(l).head();
      }, rt.prototype.findLast = function(l) {
        return this.reverse().find(l);
      }, rt.prototype.invokeMap = et(function(l, f) {
        return typeof l == "function" ? new rt(this) : this.map(function(m) {
          return bl(m, l, f);
        });
      }), rt.prototype.reject = function(l) {
        return this.filter(Ou(Ne(l)));
      }, rt.prototype.slice = function(l, f) {
        l = $e(l);
        var m = this;
        return m.__filtered__ && (l > 0 || f < 0) ? new rt(m) : (l < 0 ? m = m.takeRight(-l) : l && (m = m.drop(l)), f !== t && (f = $e(f), m = f < 0 ? m.dropRight(-f) : m.take(f - l)), m);
      }, rt.prototype.takeRightWhile = function(l) {
        return this.reverse().takeWhile(l).reverse();
      }, rt.prototype.toArray = function() {
        return this.take(X);
      }, Si(rt.prototype, function(l, f) {
        var m = /^(?:filter|find|map|reject)|While$/.test(f), v = /^(?:head|last)$/.test(f), E = A[v ? "take" + (f == "last" ? "Right" : "") : f], D = v || /^find/.test(f);
        E && (A.prototype[f] = function() {
          var M = this.__wrapped__, P = v ? [1] : arguments, F = M instanceof rt, ee = P[0], te = F || Ue(M), se = function(nt) {
            var ot = E.apply(A, Ss([nt], P));
            return v && ye ? ot[0] : ot;
          };
          te && m && typeof ee == "function" && ee.length != 1 && (F = te = !1);
          var ye = this.__chain__, Re = !!this.__actions__.length, Le = D && !ye, Je = F && !Re;
          if (!D && te) {
            M = Je ? M : new rt(this);
            var Be = l.apply(M, P);
            return Be.__actions__.push({ func: Ru, args: [se], thisArg: t }), new Br(Be, ye);
          }
          return Le && Je ? l.apply(this, P) : (Be = this.thru(se), Le ? v ? Be.value()[0] : Be.value() : Be);
        });
      }), Pr(["pop", "push", "shift", "sort", "splice", "unshift"], function(l) {
        var f = eu[l], m = /^(?:push|sort|unshift)$/.test(l) ? "tap" : "thru", v = /^(?:pop|shift)$/.test(l);
        A.prototype[l] = function() {
          var E = arguments;
          if (v && !this.__chain__) {
            var D = this.value();
            return f.apply(Ue(D) ? D : [], E);
          }
          return this[m](function(M) {
            return f.apply(Ue(M) ? M : [], E);
          });
        };
      }), Si(rt.prototype, function(l, f) {
        var m = A[f];
        if (m) {
          var v = m.name + "";
          ft.call(ha, v) || (ha[v] = []), ha[v].push({ name: f, func: m });
        }
      }), ha[Su(t, w).name] = [{
        name: "wrapper",
        func: t
      }], rt.prototype.clone = W_, rt.prototype.reverse = $_, rt.prototype.value = G_, A.prototype.at = SN, A.prototype.chain = wN, A.prototype.commit = EN, A.prototype.next = AN, A.prototype.plant = CN, A.prototype.reverse = DN, A.prototype.toJSON = A.prototype.valueOf = A.prototype.value = RN, A.prototype.first = A.prototype.head, fl && (A.prototype[fl] = TN), A;
    }, ua = E_();
    co ? ((co.exports = ua)._ = ua, bh._ = ua) : Dn._ = ua;
  }).call(Da);
})(zf, zf.exports);
var QK = zf.exports;
const r1 = (n) => {
  let e;
  const t = /* @__PURE__ */ new Set(), r = (u, d) => {
    const h = typeof u == "function" ? u(e) : u;
    if (!Object.is(h, e)) {
      const p = e;
      e = d ?? (typeof h != "object" || h === null) ? h : Object.assign({}, e, h), t.forEach((g) => g(e, p));
    }
  }, i = () => e, a = { setState: r, getState: i, getInitialState: () => c, subscribe: (u) => (t.add(u), () => t.delete(u)) }, c = e = n(r, i, a);
  return a;
}, ZK = (n) => n ? r1(n) : r1, XK = (n) => n;
function eJ(n, e = XK) {
  const t = ze.useSyncExternalStore(
    n.subscribe,
    ze.useCallback(() => e(n.getState()), [n, e]),
    ze.useCallback(() => e(n.getInitialState()), [n, e])
  );
  return ze.useDebugValue(t), t;
}
const i1 = (n) => {
  const e = ZK(n), t = (r) => eJ(e, r);
  return Object.assign(t, e), t;
}, tJ = (n) => n ? i1(n) : i1, EM = tJ((n) => ({
  visible: {},
  setVisible: (e, t) => {
    n((r) => ({ visible: { ...r.visible, [e]: t } }));
  },
  clear: () => n({ visible: {} })
})), vQ = (n, e) => {
  const { setVisible: t } = EM();
  wt(() => (t(n, e), () => {
    t(n, !1);
  }), [e, n, t]);
}, nJ = (n) => {
  const { children: e } = n, { visible: t } = EM(), r = Wt(() => QK.pickBy(t, (o) => o), [t]), i = Wt(() => Object.values(t).some((o) => o), [t]), s = Wt(() => Object.keys(r), [r]);
  return wt(() => {
    document.body.style.overflow = i ? "hidden" : "inherit";
  }, [i]), /* @__PURE__ */ x.jsxs(yt, { className: "loading-overlay-provider", children: [
    /* @__PURE__ */ x.jsx(
      Wf,
      {
        className: s.map((o) => `loading-${o}`).join(" "),
        visible: !!i
      }
    ),
    e
  ] });
}, s1 = {
  border: "1px solid rgba(203, 213, 225, 0.95)",
  borderRadius: 16,
  background: "rgba(255, 255, 255, 0.86)",
  color: "#111827",
  fontSize: 15,
  fontWeight: 500,
  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
  transition: "border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease"
}, o1 = L2({
  primaryColor: "blue",
  primaryShade: { light: 6, dark: 7 },
  defaultRadius: "md",
  radius: {
    xs: "4px",
    sm: "6px",
    md: "8px",
    lg: "14px",
    xl: "18px"
  },
  defaultGradient: {
    from: "#1c7ed6",
    to: "#1564bf",
    deg: 135
  },
  cursorType: "pointer",
  components: {
    Input: {
      defaultProps: {
        size: "md",
        radius: "lg"
      },
      styles: {
        input: {
          ...s1,
          minHeight: 54
        },
        section: {
          color: "#6b7280"
        }
      }
    },
    InputWrapper: {
      defaultProps: {
        size: "md"
      },
      styles: {
        label: {
          color: "#374151",
          fontSize: 13,
          fontWeight: 700,
          marginBottom: 8
        },
        description: {
          color: "#6b7280",
          fontSize: 12,
          marginTop: 4
        },
        error: {
          color: "#e03131",
          fontSize: 12,
          fontWeight: 600,
          marginTop: 7
        }
      }
    },
    TextInput: {
      defaultProps: {
        size: "md",
        radius: "lg"
      }
    },
    PasswordInput: {
      defaultProps: {
        size: "md",
        radius: "lg"
      },
      styles: {
        innerInput: {
          fontSize: 15,
          fontWeight: 500
        },
        visibilityToggle: {
          borderRadius: 12,
          color: "#6b7280"
        }
      }
    },
    Textarea: {
      defaultProps: {
        size: "md",
        radius: "lg",
        minRows: 4
      },
      styles: {
        input: {
          ...s1
        }
      }
    },
    Select: {
      defaultProps: {
        size: "md",
        radius: "lg"
      },
      styles: {
        dropdown: {
          border: "1px solid rgba(203, 213, 225, 0.95)",
          borderRadius: 14,
          boxShadow: "0 18px 40px rgba(15, 23, 42, 0.12)"
        },
        option: {
          borderRadius: 10,
          fontWeight: 500
        }
      }
    },
    NumberInput: {
      defaultProps: {
        size: "md",
        radius: "lg"
      }
    },
    DateInput: {
      defaultProps: {
        size: "md",
        radius: "lg"
      }
    },
    DatePickerInput: {
      defaultProps: {
        size: "md",
        radius: "lg"
      }
    },
    TimeInput: {
      defaultProps: {
        size: "md",
        radius: "lg"
      }
    },
    Checkbox: {
      defaultProps: {
        size: "md",
        radius: "sm"
      },
      styles: {
        input: {
          borderColor: "#cbd5e1"
        },
        label: {
          color: "#4b5563",
          lineHeight: 1.5
        },
        error: {
          color: "#e03131",
          fontSize: 12,
          fontWeight: 600,
          marginTop: 6
        }
      }
    },
    Switch: {
      defaultProps: {
        size: "md",
        radius: "xl",
        color: "blue"
      },
      styles: {
        label: {
          color: "#4b5563",
          lineHeight: 1.5
        },
        track: {
          borderColor: "#cbd5e1"
        }
      }
    },
    Button: {
      defaultProps: {
        size: "md",
        radius: "lg"
      },
      styles: {
        root: {
          minHeight: 44,
          fontWeight: 700,
          transition: "transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease"
        },
        label: {
          minWidth: 0
        }
      }
    },
    ActionIcon: {
      defaultProps: {
        radius: "lg",
        variant: "subtle"
      },
      styles: {
        root: {
          transition: "transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease"
        }
      }
    },
    ThemeIcon: {
      defaultProps: {
        radius: "lg"
      }
    },
    Card: {
      defaultProps: {
        radius: "md",
        withBorder: !0,
        padding: "lg"
      },
      styles: {
        root: {
          borderColor: "rgba(229, 231, 235, 0.9)",
          boxShadow: "0 12px 30px rgba(15, 23, 42, 0.06)"
        }
      }
    },
    Paper: {
      defaultProps: {
        radius: "md",
        withBorder: !0
      },
      styles: {
        root: {
          borderColor: "rgba(229, 231, 235, 0.9)",
          boxShadow: "0 10px 24px rgba(15, 23, 42, 0.05)"
        }
      }
    },
    Alert: {
      defaultProps: {
        radius: "lg"
      },
      styles: {
        root: {
          borderColor: "rgba(203, 213, 225, 0.9)"
        },
        title: {
          fontWeight: 700
        }
      }
    },
    Modal: {
      defaultProps: {
        radius: "xl",
        centered: !0
      },
      styles: {
        content: {
          boxShadow: "0 24px 70px rgba(15, 23, 42, 0.18)"
        },
        title: {
          fontWeight: 800
        }
      }
    }
  }
});
function bQ({ children: n, theme: e }) {
  const [t] = Et(
    () => new dB({
      defaultOptions: {
        queries: {
          staleTime: 6e4
        }
      }
    })
  );
  return /* @__PURE__ */ x.jsxs(B2, { theme: e ? j2(o1, e) : o1, children: [
    /* @__PURE__ */ x.jsx($2, {}),
    /* @__PURE__ */ x.jsx(nJ, { children: /* @__PURE__ */ x.jsx(fB, { client: t, children: /* @__PURE__ */ x.jsx(W2, { children: n }) }) })
  ] });
}
function xQ({
  name: n,
  symbol: e,
  color: t = "gray",
  size: r = "lg",
  radius: i = "sm",
  variant: s = "filled",
  ...o
}) {
  return /* @__PURE__ */ x.jsxs(on, { variant: s, color: t, size: r, radius: i, ...o, children: [
    n,
    " (",
    e,
    ")"
  ] });
}
function SQ({ workShift: n, onClick: e, size: t = 32 }) {
  const r = e ? Lc : yt, i = (n == null ? void 0 : n.symbol) || "O", s = (n == null ? void 0 : n.color) || "#ced4da";
  return /* @__PURE__ */ x.jsx(
    r,
    {
      onClick: e,
      style: {
        width: t,
        height: t,
        borderRadius: "50%",
        backgroundColor: s,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: e ? "pointer" : "default",
        border: "1px solid rgba(0, 0, 0, 0.05)",
        flexShrink: 0
      },
      children: /* @__PURE__ */ x.jsx(
        ae,
        {
          c: "white",
          fw: 700,
          size: "sm",
          style: {
            lineHeight: 1,
            textShadow: "0px 0px 2px rgba(0,0,0,0.3)"
            // Slight shadow for visibility on light colors
          },
          children: i
        }
      )
    }
  );
}
function AM(n, e) {
  var t;
  return !((t = n.availableWorkShifts) != null && t.length) || n.availableWorkShifts.some((r) => r.id === e);
}
const rJ = (n) => /* @__PURE__ */ x.jsx(
  yt,
  {
    py: "xs",
    style: {
      backgroundColor: "var(--mantine-color-gray-1)",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      opacity: 0.65,
      cursor: "not-allowed"
    },
    children: /* @__PURE__ */ x.jsx(ae, { size: "xs", c: "dimmed", fw: 500, style: { zIndex: 1, whiteSpace: "nowrap" }, children: n || "근무불가" })
  }
), iJ = ({
  shift: n,
  isPlaceholder: e,
  isFixed: t,
  wanted: r,
  wantedWorkShift: i,
  highlightBorder: s,
  highlightColor: o
}) => /* @__PURE__ */ x.jsxs(
  yt,
  {
    py: "xs",
    style: {
      backgroundColor: n != null && n.color ? e ? `${n.color}10` : `${n.color}20` : void 0,
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      border: t ? `2px solid ${(n == null ? void 0 : n.color) || "gray"}` : void 0,
      opacity: e ? 0.6 : 1,
      boxShadow: s ? `inset 0 0 0 ${s}px ${o || "var(--mantine-color-red-6)"}` : void 0
    },
    children: [
      t && /* @__PURE__ */ x.jsx(
        yt,
        {
          style: {
            position: "absolute",
            top: 2,
            right: 2,
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: "var(--mantine-color-red-6)"
          }
        }
      ),
      r && /* @__PURE__ */ x.jsx(
        yt,
        {
          style: {
            position: "absolute",
            bottom: 0,
            right: 0,
            fontSize: 8,
            lineHeight: 1,
            padding: "1px 2px",
            borderTopLeftRadius: 4,
            backgroundColor: (i == null ? void 0 : i.color) || "var(--mantine-color-violet-1)",
            color: i != null && i.color ? "white" : "var(--mantine-color-violet-9)"
          },
          children: (i == null ? void 0 : i.symbol) || "O"
        }
      ),
      /* @__PURE__ */ x.jsx(ae, { size: "sm", fw: n ? 700 : 400, c: (n == null ? void 0 : n.color) || "dimmed", style: { zIndex: 1 }, children: n ? n.symbol : "-" })
    ]
  }
), sJ = jc(function({
  nurse: e,
  dateStr: t,
  entry: r,
  wanted: i,
  workShifts: s,
  onSelect: o,
  highlights: a,
  readOnly: c = !1,
  disabled: u = !1,
  disabledReason: d
}) {
  var W;
  const h = r == null ? void 0 : r.workShiftId, p = i == null ? void 0 : i.workShiftId, g = s.find((Z) => Z.isOff), y = i ? p ? s.find((Z) => Z.id === p) : g : void 0, b = h || (y == null ? void 0 : y.id), S = s.find((Z) => Z.id === b), w = r == null ? void 0 : r.isFixed, T = !h && !!i, C = (a == null ? void 0 : a.map((Z) => Z.label).filter(Boolean)) || [], k = (W = a == null ? void 0 : a[0]) == null ? void 0 : W.color, R = a ? Math.max(...a.map((Z) => Z.borderSize ?? 2)) : 0, N = u ? rJ(d) : iJ({
    shift: S,
    isPlaceholder: T,
    isFixed: w,
    wanted: i,
    wantedWorkShift: y,
    highlightBorder: R,
    highlightColor: k
  }), L = c || u ? N : /* @__PURE__ */ x.jsxs(Ct, { shadow: "md", width: 200, withinPortal: !0, children: [
    /* @__PURE__ */ x.jsx(Ct.Target, { children: N }),
    /* @__PURE__ */ x.jsxs(Ct.Dropdown, { children: [
      /* @__PURE__ */ x.jsx(Ct.Label, { children: "근무 선택" }),
      s.map((Z) => {
        const fe = AM(e, Z.id);
        return /* @__PURE__ */ x.jsx(
          Ct.Item,
          {
            onClick: () => o(e.id, t, Z.id),
            color: Z.color || "",
            disabled: !fe,
            style: {
              backgroundColor: fe ? void 0 : "var(--mantine-color-gray-2)"
            },
            children: /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", children: [
              /* @__PURE__ */ x.jsx(ae, { children: Z.name }),
              /* @__PURE__ */ x.jsx(ae, { fw: 700, children: Z.symbol })
            ] })
          },
          Z.id
        );
      }),
      /* @__PURE__ */ x.jsx(Ct.Divider, {}),
      /* @__PURE__ */ x.jsx(Ct.Item, { color: "red", onClick: () => o(e.id, t, void 0), children: "삭제" })
    ] })
  ] }), j = i && !u ? /* @__PURE__ */ x.jsxs(Ct, { shadow: "md", width: 220, trigger: "hover", openDelay: 100, closeDelay: 400, withinPortal: !0, children: [
    /* @__PURE__ */ x.jsx(Ct.Target, { children: /* @__PURE__ */ x.jsx("div", { style: { height: "100%" }, children: L }) }),
    /* @__PURE__ */ x.jsxs(Ct.Dropdown, { children: [
      /* @__PURE__ */ x.jsx(Ct.Label, { children: "원티드(희망근무) 정보" }),
      /* @__PURE__ */ x.jsxs(ct, { gap: "xs", p: "xs", children: [
        /* @__PURE__ */ x.jsxs(ae, { size: "xs", children: [
          /* @__PURE__ */ x.jsx("strong", { children: "신청자:" }),
          " ",
          e.user.name
        ] }),
        /* @__PURE__ */ x.jsxs(ae, { size: "xs", children: [
          /* @__PURE__ */ x.jsx("strong", { children: "희망일:" }),
          " ",
          xt(i.targetDate).format("YYYY-MM-DD")
        ] }),
        /* @__PURE__ */ x.jsxs(ae, { size: "xs", children: [
          /* @__PURE__ */ x.jsx("strong", { children: "신청일:" }),
          " ",
          xt(i.createdAt).format("YYYY-MM-DD")
        ] }),
        /* @__PURE__ */ x.jsxs(ae, { size: "xs", children: [
          /* @__PURE__ */ x.jsx("strong", { children: "희망근무:" }),
          " ",
          (y == null ? void 0 : y.name) || "오프(Off)"
        ] }),
        /* @__PURE__ */ x.jsxs(ae, { size: "xs", children: [
          /* @__PURE__ */ x.jsx("strong", { children: "사유:" }),
          " ",
          i.reason || "없음"
        ] })
      ] })
    ] })
  ] }) : L;
  return /* @__PURE__ */ x.jsx(Ze.Td, { p: 0, className: "duty-cell", children: /* @__PURE__ */ x.jsx(
    ss,
    {
      label: /* @__PURE__ */ x.jsx(ct, { gap: 2, children: C.map((Z, fe) => /* @__PURE__ */ x.jsx(ae, { size: "xs", children: Z }, `${fe}-${Z}`)) }),
      disabled: C.length === 0,
      withArrow: !0,
      withinPortal: !0,
      multiline: !0,
      children: /* @__PURE__ */ x.jsx("div", { style: { height: "100%" }, children: j })
    }
  ) });
}), TM = jc(
  ({
    nurseId: n,
    onSetWeeklyD: e,
    onSetAllOff: t,
    onClearSchedule: r,
    nurses: i = [],
    onCopySchedule: s
  }) => {
    const o = i.find((u) => u.id === n), c = (o == null ? void 0 : o.preceptorType) === "PRECEPEE" ? i.filter((u) => u.preceptorType === "PRECEPTOR") : [];
    return /* @__PURE__ */ x.jsxs(Ct, { shadow: "md", width: 220, position: "bottom-end", children: [
      /* @__PURE__ */ x.jsx(Ct.Target, { children: /* @__PURE__ */ x.jsx(hi, { variant: "subtle", color: "gray", size: "sm", children: /* @__PURE__ */ x.jsx(BU, { size: 16 }) }) }),
      /* @__PURE__ */ x.jsxs(Ct.Dropdown, { children: [
        /* @__PURE__ */ x.jsx(Ct.Item, { onClick: () => e(n), children: "주간 D 근무 설정" }),
        /* @__PURE__ */ x.jsx(Ct.Item, { onClick: () => t(n), children: "모든 날짜 Off 설정" }),
        /* @__PURE__ */ x.jsx(Ct.Divider, {}),
        /* @__PURE__ */ x.jsx(Ct.Item, { color: "red", onClick: () => r(n), children: "일정 초기화" }),
        c.length > 0 && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
          /* @__PURE__ */ x.jsx(Ct.Divider, {}),
          /* @__PURE__ */ x.jsx(Ct.Label, { children: "프리셉터 듀티 복사" }),
          c.map((u) => /* @__PURE__ */ x.jsxs(
            Ct.Item,
            {
              leftSection: /* @__PURE__ */ x.jsx(pC, { size: 14 }),
              onClick: () => s == null ? void 0 : s(u.id),
              children: [
                u.user.name,
                "의 듀티 복사"
              ]
            },
            u.id
          ))
        ] })
      ] })
    ] });
  }
);
TM.displayName = "NurseActionMenu";
const CM = jc(
  ({
    nurse: n,
    days: e,
    workShifts: t,
    dutyData: r = {},
    wantedMap: i = {},
    highlightMap: s = {},
    userCounts: o,
    disabledDates: a = {},
    readOnly: c = !1,
    nameColWidth: u,
    summaryColWidth: d,
    onShiftSelect: h,
    onSetWeeklyD: p,
    onSetAllOff: g,
    onClearSchedule: y,
    nurses: b = [],
    onCopySchedule: S
  }) => {
    const w = n.preceptorType === "PRECEPEE";
    return /* @__PURE__ */ x.jsxs(
      Ze.Tr,
      {
        style: w ? {
          opacity: 0.6,
          backgroundColor: "var(--mantine-color-gray-1)"
        } : void 0,
        children: [
          /* @__PURE__ */ x.jsx(
            Ze.Td,
            {
              style: {
                position: "sticky",
                left: 0,
                zIndex: 15,
                backgroundColor: w ? "var(--mantine-color-gray-1)" : "var(--mantine-color-body)",
                borderRight: "1px solid var(--mantine-color-gray-3)",
                minWidth: u,
                width: u
              },
              children: /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", align: "center", wrap: "nowrap", gap: "xs", children: [
                /* @__PURE__ */ x.jsxs(yt, { style: { flex: 1 }, children: [
                  /* @__PURE__ */ x.jsxs(Fe, { gap: 6, align: "center", wrap: "nowrap", children: [
                    /* @__PURE__ */ x.jsx(ae, { size: "sm", fw: 500, children: n.user.name }),
                    n.preceptorType === "PRECEPTOR" && /* @__PURE__ */ x.jsx(on, { size: "xs", color: "blue", variant: "light", children: "프리셉터" }),
                    n.preceptorType === "PRECEPEE" && /* @__PURE__ */ x.jsx(on, { size: "xs", color: "teal", variant: "light", children: "프리셉티" })
                  ] }),
                  n.position && /* @__PURE__ */ x.jsx(ae, { size: "xs", c: "dimmed", children: n.position.name })
                ] }),
                !c && /* @__PURE__ */ x.jsx(
                  TM,
                  {
                    nurseId: n.id,
                    onSetWeeklyD: p,
                    onSetAllOff: g,
                    onClearSchedule: y,
                    nurses: b,
                    onCopySchedule: S ? (T) => S(T, n.id) : void 0
                  }
                )
              ] })
            }
          ),
          e.map((T) => {
            const C = T.format("YYYY-MM-DD"), k = a[C];
            return /* @__PURE__ */ x.jsx(
              sJ,
              {
                nurse: n,
                dateStr: C,
                entry: r[C],
                wanted: i[C],
                workShifts: t,
                onSelect: h,
                highlights: s[C],
                readOnly: c,
                disabled: !!k,
                disabledReason: k
              },
              C
            );
          }),
          t.map((T) => /* @__PURE__ */ x.jsx(
            Ze.Td,
            {
              style: {
                textAlign: "center",
                backgroundColor: "#fff8db",
                minWidth: d,
                width: d
              },
              children: /* @__PURE__ */ x.jsx(ae, { size: "sm", fw: 500, c: T.color || void 0, children: o[T.id] || 0 })
            },
            T.id
          ))
        ]
      }
    );
  }
);
CM.displayName = "DutyEditorRow";
function oJ({
  value: n,
  nurses: e,
  days: t,
  workShifts: r
}) {
  const i = [];
  return e.forEach((s, o) => {
    let a = [], c = null;
    const u = (d, h) => {
      const p = d.length;
      if (p === 0 || !h) return;
      const g = r.find((w) => w.id === h), y = g ? g.name : "";
      let b, S;
      p >= 7 ? (b = "var(--mantine-color-red-9)", S = `⛔ 동일 근무(${y}) 연속 ${p}일 (불가)`) : p === 6 ? (b = "var(--mantine-color-red-6)", S = `⚠️ 동일 근무(${y}) 연속 6일 (경고)`) : p === 5 && (b = "var(--mantine-color-orange-6)", S = `💡 동일 근무(${y}) 연속 5일 (주의)`), b && d.forEach((w) => {
        i.push({
          nurseIndex: o,
          dayIndex: w,
          color: b,
          label: S
        });
      });
    };
    t.forEach((d, h) => {
      var S;
      const p = d.format("YYYY-MM-DD"), g = (S = n[s.id]) == null ? void 0 : S[p], y = g == null ? void 0 : g.workShiftId, b = y ? r.find((w) => w.id === y) : null;
      b && !b.isOff ? c === y ? a.push(h) : (u(a, c), a = [h], c = y) : (u(a, c), a = [], c = null);
    }), u(a, c);
  }), i;
}
function aJ({
  value: n,
  nurses: e,
  days: t,
  workShifts: r
}) {
  const i = [];
  return e.forEach((s, o) => {
    var a, c, u, d;
    for (let h = 0; h < t.length - 1; h++) {
      const p = (c = (a = n[s.id]) == null ? void 0 : a[t[h].format("YYYY-MM-DD")]) == null ? void 0 : c.workShiftId, g = (d = (u = n[s.id]) == null ? void 0 : u[t[h + 1].format("YYYY-MM-DD")]) == null ? void 0 : d.workShiftId;
      if (!p || !g) continue;
      const y = r.find((T) => T.id === p), b = r.find((T) => T.id === g);
      if (!y || !b) continue;
      const S = y.symbol, w = b.symbol;
      if (S === "N" && w === "E" || S === "E" && w === "D" || S === "N" && w === "D") {
        const T = `🚫 금지 패턴 (${S}→${w})`;
        i.push({
          nurseIndex: o,
          dayIndex: h,
          color: "var(--mantine-color-red-6)",
          label: T
        }), i.push({
          nurseIndex: o,
          dayIndex: h + 1,
          color: "var(--mantine-color-red-6)",
          label: T
        });
      }
    }
  }), i;
}
function lJ({
  value: n,
  nurses: e,
  days: t,
  workShifts: r
}) {
  const i = [];
  return e.forEach((s, o) => {
    for (let a = 0; a < t.length; a++) {
      const c = (p) => {
        var b, S, w;
        const g = t[a + p];
        if (!g) return null;
        const y = (S = (b = n[s.id]) == null ? void 0 : b[g.format("YYYY-MM-DD")]) == null ? void 0 : S.workShiftId;
        return ((w = r.find((T) => T.id === y)) == null ? void 0 : w.symbol) || null;
      }, u = c(0), d = c(1), h = c(2);
      if (u === "N" && d === "N" && h === "N" && [a, a + 1, a + 2].forEach((p) => {
        i.push({
          nurseIndex: o,
          dayIndex: p,
          color: "var(--mantine-color-red-4)",
          borderSize: 1,
          label: "⚠️ 기피 패턴 (NNN)"
        });
      }), u === "N" && d === "O" && (h === "D" || h === "E")) {
        const p = `NO${h}`;
        [a, a + 1, a + 2].forEach((g) => {
          i.push({
            nurseIndex: o,
            dayIndex: g,
            color: "var(--mantine-color-red-4)",
            borderSize: 1,
            label: `⚠️ 기피 패턴 (${p})`
          });
        });
      }
    }
  }), i;
}
function cJ({
  value: n,
  nurses: e,
  days: t,
  workShifts: r
}) {
  const i = [];
  return e.forEach((s, o) => {
    for (let a = 0; a < t.length - 3; a++) {
      const c = (g) => {
        var S, w, T;
        const y = t[a + g];
        if (!y) return null;
        const b = (w = (S = n[s.id]) == null ? void 0 : S[y.format("YYYY-MM-DD")]) == null ? void 0 : w.workShiftId;
        return ((T = r.find((C) => C.id === b)) == null ? void 0 : T.symbol) || null;
      }, u = c(0), d = c(1), h = c(2), p = c(3);
      u === "N" && d === "O" && h === "N" && p === "O" && [a, a + 1, a + 2, a + 3].forEach((g) => {
        i.push({
          nurseIndex: o,
          dayIndex: g,
          color: "var(--mantine-color-orange-6)",
          label: "💡 퐁당퐁당 패턴 (NONO)"
        });
      });
    }
  }), i;
}
function uJ(n) {
  const { options: e, value: t, nurses: r, days: i, workShifts: s } = n;
  let o = [];
  return e.showFiveDayConsecutive && (o = o.concat(
    oJ({ value: t, nurses: r, days: i, workShifts: s })
  )), e.showConsecutiveDuty && (o = o.concat(
    aJ({ value: t, nurses: r, days: i, workShifts: s })
  )), e.showAvoidanceDuty && (o = o.concat(
    lJ({ value: t, nurses: r, days: i, workShifts: s })
  )), e.showPongDangPongDang && (o = o.concat(
    cJ({ value: t, nurses: r, days: i, workShifts: s })
  )), o;
}
function dJ(n, e, t, r) {
  const i = Wt(() => {
    const o = {};
    return n.forEach((a) => {
      o[a.id] = {}, e.forEach((u) => {
        o[a.id][u.id] = 0;
      });
      const c = t[a.id] || {};
      Object.values(c).forEach((u) => {
        u != null && u.workShiftId && o[a.id][u.workShiftId] !== void 0 && o[a.id][u.workShiftId]++;
      });
    }), o;
  }, [n, e, t]), s = Wt(() => {
    const o = {};
    return r.forEach((a) => {
      const c = a.format("YYYY-MM-DD");
      o[c] = {}, e.forEach((u) => {
        o[c][u.id] = 0;
      }), n.forEach((u) => {
        var h;
        const d = (h = t[u.id]) == null ? void 0 : h[c];
        d != null && d.workShiftId && o[c][d.workShiftId] !== void 0 && o[c][d.workShiftId]++;
      });
    }), o;
  }, [r, n, e, t]);
  return { userCounts: i, dailyCounts: s };
}
const fJ = (n, e) => {
  const t = xt(n), r = xt(e), i = [];
  let s = t;
  for (; s.isBefore(r) || s.isSame(r, "day"); )
    i.push(s), s = s.add(1, "day");
  return i;
}, hJ = (n) => {
  const e = {};
  return n.forEach((t) => {
    const r = xt(t.targetDate).format("YYYY-MM-DD"), i = t.nurseId;
    e[i] || (e[i] = {}), e[i][r] = t;
  }), e;
}, pJ = (n, e) => {
  const t = n.day();
  if (t === 0 || e) return "red";
  if (t === 6) return "blue";
}, mJ = (n, e) => {
  const t = xt(n), r = xt(e);
  return t.isSame(r, "month") ? t.format("YYYY년 MM월 근무") : `${t.format("YYYY-MM-DD")} ~ ${r.format("YYYY-MM-DD")} 근무`;
}, Bl = 180, Ca = 60, jl = 60, wQ = jc(
  ({
    nurses: n,
    workShifts: e,
    wanteds: t = [],
    requirements: r,
    holidays: i = [],
    startDate: s,
    endDate: o,
    value: a = {},
    defaultIsFixed: c = !1,
    actions: u,
    description: d,
    cellHighlights: h,
    showTooltip: p = !1,
    validationOptions: g,
    onChange: y,
    readOnly: b = !1,
    disabledDates: S = {}
  }) => {
    const w = Wt(() => [...e].sort((H, le) => {
      if (H.isOff && !le.isOff) return 1;
      if (!H.isOff && le.isOff) return -1;
      if (H.isOff && le.isOff) return 0;
      const G = new Date(H.startTime).getTime(), oe = new Date(le.startTime).getTime();
      return G - oe;
    }), [e]), T = Wt(() => fJ(s, o), [s, o]), C = Wt(() => {
      const H = {};
      return i.forEach((le) => {
        const G = xt(le.date).format("YYYY-MM-DD");
        H[G] = le;
      }), H;
    }, [i]), k = Wt(() => hJ(t), [t]), R = Wt(() => [...n].sort((H, le) => {
      var Q, ke;
      const G = ((Q = H.position) == null ? void 0 : Q.order) ?? 999, oe = ((ke = le.position) == null ? void 0 : ke.order) ?? 999;
      if (G !== oe) return G - oe;
      const ue = H.createdAt ? new Date(H.createdAt).getTime() : 0, ge = le.createdAt ? new Date(le.createdAt).getTime() : 0;
      return ue - ge;
    }), [n]), { userCounts: N, dailyCounts: L } = dJ(R, w, a, T), j = Wt(() => {
      const le = uJ({
        options: g || {
          showFiveDayConsecutive: p
        },
        value: a,
        nurses: R,
        days: T,
        workShifts: w
      }), G = {};
      return le.forEach((oe) => {
        var Q, ke;
        const ue = (Q = R[oe.nurseIndex]) == null ? void 0 : Q.id, ge = (ke = T[oe.dayIndex]) == null ? void 0 : ke.format("YYYY-MM-DD");
        !ue || !ge || (G[ue] || (G[ue] = {}), G[ue][ge] || (G[ue][ge] = []), G[ue][ge].push(oe));
      }), h && R.forEach((oe, ue) => {
        const ge = h[oe.id];
        ge && T.forEach((Q, ke) => {
          const Ye = Q.format("YYYY-MM-DD"), it = ge[Ye];
          if (!it) return;
          const It = Array.isArray(it.label) ? it.label : it.label ? [it.label] : [void 0];
          G[oe.id] || (G[oe.id] = {}), G[oe.id][Ye] = [
            ...It.map((kt) => ({
              nurseIndex: ue,
              dayIndex: ke,
              color: it.color,
              label: kt,
              borderSize: it.borderSize ?? 2
            })),
            ...G[oe.id][Ye] ?? []
          ];
        });
      }), G;
    }, [a, R, T, w, p, g, h]), [W, Z] = Et(0), fe = bt(R);
    fe.current = R;
    const Oe = bt(b);
    Oe.current = b;
    const Ae = bt(y);
    Ae.current = y;
    const Y = bt(a);
    Y.current = a;
    const re = bt(S);
    re.current = S;
    const q = bt(c);
    q.current = c;
    const U = bt(w);
    U.current = w;
    const J = bt(T);
    J.current = T;
    const we = bt(C);
    we.current = C;
    const z = fn((H, le) => {
      const G = fe.current.find((oe) => oe.id === H);
      return !!G && U.current.some((oe) => oe.id === le) && AM(G, le);
    }, []), X = fn(
      (H, le, G) => {
        var ue, ge, Q;
        if (Oe.current || (ge = (ue = re.current) == null ? void 0 : ue[H]) != null && ge[le] || G && !z(H, G)) return;
        Z(0);
        const oe = { ...Y.current[H] || {} };
        G ? oe[le] = {
          workShiftId: G,
          isFixed: q.current
        } : delete oe[le], (Q = Ae.current) == null || Q.call(Ae, {
          ...Y.current,
          [H]: oe
        });
      },
      [z]
    ), me = fn(
      (H) => {
        var ge;
        if (Oe.current) return;
        Z(0);
        const le = U.current.find((Q) => Q.symbol === "D"), G = U.current.find((Q) => Q.isOff);
        if (!le || !G) return;
        const oe = { ...Y.current[H] || {} };
        let ue = 0;
        J.current.forEach((Q) => {
          var kt, pn;
          const ke = Q.format("YYYY-MM-DD");
          if ((pn = (kt = re.current) == null ? void 0 : kt[H]) != null && pn[ke]) return;
          const Ye = Q.day() === 0 || Q.day() === 6, it = !!we.current[ke], It = Ye || it ? G.id : le.id;
          if (!z(H, It)) {
            ue++;
            return;
          }
          oe[ke] = {
            workShiftId: It,
            isFixed: q.current
          };
        }), Z(ue), (ge = Ae.current) == null || ge.call(Ae, {
          ...Y.current,
          [H]: oe
        });
      },
      [z]
    ), pe = fn(
      (H) => {
        var ue;
        if (Oe.current) return;
        Z(0);
        const le = U.current.find((ge) => ge.isOff) || U.current.find((ge) => ge.symbol === "Off") || U.current.find((ge) => ge.symbol === "O") || U.current[0];
        if (!le) return;
        const G = { ...Y.current[H] || {} };
        let oe = 0;
        J.current.forEach((ge) => {
          var ke, Ye;
          const Q = ge.format("YYYY-MM-DD");
          if (!((Ye = (ke = re.current) == null ? void 0 : ke[H]) != null && Ye[Q])) {
            if (!z(H, le.id)) {
              oe++;
              return;
            }
            G[Q] = {
              workShiftId: le.id,
              isFixed: q.current
            };
          }
        }), Z(oe), (ue = Ae.current) == null || ue.call(Ae, {
          ...Y.current,
          [H]: G
        });
      },
      [z]
    ), he = fn((H) => {
      var G;
      if (Oe.current) return;
      Z(0);
      const le = { ...Y.current[H] || {} };
      J.current.forEach((oe) => {
        var ge, Q;
        const ue = oe.format("YYYY-MM-DD");
        (Q = (ge = re.current) == null ? void 0 : ge[H]) != null && Q[ue] || delete le[ue];
      }), (G = Ae.current) == null || G.call(Ae, {
        ...Y.current,
        [H]: le
      });
    }, []), xe = fn(
      (H, le) => {
        var ge;
        if (Oe.current) return;
        let G = 0;
        const oe = Y.current[H] || {}, ue = { ...Y.current[le] || {} };
        J.current.forEach((Q) => {
          var Ye, it;
          const ke = Q.format("YYYY-MM-DD");
          if (!((it = (Ye = re.current) == null ? void 0 : Ye[le]) != null && it[ke]))
            if (oe[ke]) {
              if (!z(le, oe[ke].workShiftId)) {
                G++;
                return;
              }
              ue[ke] = { ...oe[ke] };
            } else
              delete ue[ke];
        }), Z(G), (ge = Ae.current) == null || ge.call(Ae, {
          ...Y.current,
          [le]: ue
        });
      },
      [z]
    );
    return /* @__PURE__ */ x.jsxs(ct, { gap: "md", children: [
      !b && W > 0 && /* @__PURE__ */ x.jsxs(Ws, { color: "yellow", role: "status", title: "일부 근무를 적용하지 않았습니다", children: [
        "가능 근무타입에 없는 근무 ",
        W,
        "건을 건너뛰고 기존 일정을 유지했습니다."
      ] }),
      /* @__PURE__ */ x.jsx("style", { children: `
        .duty-cell {
          cursor: ${b ? "default" : "pointer"};
          text-align: center;
          transition: background-color 0.2s;
          min-width: ${Ca}px;
          width: ${Ca}px;
        }
        ${b ? "" : `
        .duty-cell:hover {
          background-color: var(--mantine-color-gray-1);
        }
        `}
      ` }),
      /* @__PURE__ */ x.jsxs($m, { justify: "space-between", align: "center", children: [
        /* @__PURE__ */ x.jsxs(yt, { children: [
          /* @__PURE__ */ x.jsx(ae, { size: "xl", fw: 700, children: mJ(s, o) }),
          d !== void 0 ? typeof d == "string" ? /* @__PURE__ */ x.jsx(ae, { size: "sm", c: "dimmed", children: d }) : d : /* @__PURE__ */ x.jsx(ae, { size: "sm", c: "dimmed", children: b ? "기존 요청된 근무표 내역입니다." : "셀을 클릭하여 수동으로 근무타입을 설정하세요. 자동 생성 시 이 설정은 보존됩니다." })
        ] }),
        u
      ] }),
      /* @__PURE__ */ x.jsx(er, { withBorder: !0, shadow: "sm", radius: "md", p: 0, style: { overflow: "hidden" }, children: /* @__PURE__ */ x.jsx(Bc, { children: /* @__PURE__ */ x.jsxs(Ze, { withTableBorder: !0, withColumnBorders: !0, verticalSpacing: "xs", horizontalSpacing: "xs", children: [
        /* @__PURE__ */ x.jsx(
          Ze.Thead,
          {
            style: {
              position: "sticky",
              top: 0,
              zIndex: 20,
              backgroundColor: "var(--mantine-color-body)"
            },
            children: /* @__PURE__ */ x.jsxs(Ze.Tr, { children: [
              /* @__PURE__ */ x.jsx(
                Ze.Th,
                {
                  style: {
                    minWidth: Bl,
                    width: Bl,
                    position: "sticky",
                    top: 0,
                    left: 0,
                    zIndex: 30,
                    backgroundColor: "var(--mantine-color-body)",
                    borderRight: "1px solid var(--mantine-color-gray-3)"
                  },
                  children: "이름"
                }
              ),
              T.map((H) => {
                const le = H.format("YYYY-MM-DD"), G = C[le], oe = pJ(H, !!G), ue = /* @__PURE__ */ x.jsxs(ct, { gap: 0, align: "center", children: [
                  /* @__PURE__ */ x.jsx(ae, { size: "xs", fw: 700, c: oe, children: H.date() }),
                  /* @__PURE__ */ x.jsx(ae, { size: "xs", c: oe, children: H.format("dd") })
                ] });
                return /* @__PURE__ */ x.jsx(
                  Ze.Th,
                  {
                    style: {
                      minWidth: Ca,
                      width: Ca,
                      textAlign: "center"
                    },
                    children: G ? /* @__PURE__ */ x.jsx(ss, { label: G.name, withArrow: !0, children: /* @__PURE__ */ x.jsx(yt, { style: { cursor: "default" }, children: ue }) }) : ue
                  },
                  H.toString()
                );
              }),
              w.map((H) => /* @__PURE__ */ x.jsx(
                Ze.Th,
                {
                  style: {
                    backgroundColor: H.color || "gray",
                    textAlign: "center",
                    color: "white",
                    minWidth: jl,
                    width: jl
                  },
                  children: H.symbol
                },
                H.id
              ))
            ] })
          }
        ),
        /* @__PURE__ */ x.jsx(Ze.Tbody, { children: R.map((H) => /* @__PURE__ */ x.jsx(
          CM,
          {
            nurse: H,
            days: T,
            workShifts: w,
            dutyData: a[H.id],
            wantedMap: k[H.id],
            highlightMap: j[H.id],
            userCounts: N[H.id],
            disabledDates: S[H.id],
            readOnly: b,
            nameColWidth: Bl,
            summaryColWidth: jl,
            onShiftSelect: X,
            onSetWeeklyD: me,
            onSetAllOff: pe,
            onClearSchedule: he,
            nurses: R,
            onCopySchedule: xe
          },
          H.id
        )) }),
        /* @__PURE__ */ x.jsx(Ze.Tfoot, { children: w.map((H) => /* @__PURE__ */ x.jsxs(Ze.Tr, { children: [
          /* @__PURE__ */ x.jsx(
            Ze.Th,
            {
              style: {
                backgroundColor: H.color || "#333",
                color: "white",
                position: "sticky",
                left: 0,
                zIndex: 15,
                minWidth: Bl,
                width: Bl
              },
              children: /* @__PURE__ */ x.jsx(Fe, { justify: "center", children: /* @__PURE__ */ x.jsx(ae, { size: "sm", children: H.symbol }) })
            }
          ),
          T.map((le) => {
            var Q, ke, Ye;
            const G = le.format("YYYY-MM-DD"), oe = L[G][H.id] || 0;
            let ue = "dimmed", ge = "normal";
            if (r && ((Q = r[G]) == null ? void 0 : Q[H.id]) !== void 0) {
              const it = (ke = r[G]) == null ? void 0 : ke[H.id];
              it !== void 0 && (oe === it ? (ue = "blue.6", ge = 700) : oe > it && (ue = "red.6", ge = 700));
            }
            return /* @__PURE__ */ x.jsx(
              Ze.Td,
              {
                style: {
                  textAlign: "center",
                  backgroundColor: "var(--mantine-color-gray-0)",
                  minWidth: Ca,
                  width: Ca
                },
                children: /* @__PURE__ */ x.jsx(
                  gJ,
                  {
                    label: (Ye = C[G]) == null ? void 0 : Ye.name,
                    disabled: !C[G],
                    children: /* @__PURE__ */ x.jsx(ae, { size: "xs", c: ue, fw: ge, children: oe })
                  }
                )
              },
              G
            );
          }),
          w.map((le) => /* @__PURE__ */ x.jsx(
            Ze.Td,
            {
              style: {
                backgroundColor: "#f1f3f5",
                minWidth: jl,
                width: jl
              },
              children: /* @__PURE__ */ x.jsx(ae, { size: "xs", ta: "center", children: "-" })
            },
            `footer-empty-${H.id}-${le.id}`
          ))
        ] }, `footer-${H.id}`)) })
      ] }) }) })
    ] });
  }
), gJ = ({
  children: n,
  label: e,
  disabled: t
}) => t || !e ? /* @__PURE__ */ x.jsx(x.Fragment, { children: n }) : /* @__PURE__ */ x.jsx(ss, { label: e, withArrow: !0, children: /* @__PURE__ */ x.jsx(yt, { children: n }) }), yJ = jc(function({
  ws: e,
  days: t,
  nurses: r,
  data: i,
  dailyErrors: s,
  workShifts: o,
  readOnly: a,
  disabled: c,
  holidayMap: u,
  onBatchUpdate: d,
  onInputChange: h
}) {
  const p = t.every((g) => {
    var k;
    const y = g.format("YYYY-MM-DD"), b = ((k = i[y]) == null ? void 0 : k[e.id]) ?? 0, S = r.filter((R) => {
      const N = R.statusPeriods || [];
      return Ri(N, g.toDate()) === "ACTIVE";
    }).length, w = o.filter((R) => !R.isOff && R.id !== e.id).reduce((R, N) => {
      var L;
      return R + (((L = i[y]) == null ? void 0 : L[N.id]) ?? 0);
    }, 0), T = r.filter((R) => {
      const N = R.statusPeriods || [];
      return Ri(N, g.toDate()) !== "ACTIVE" ? !1 : !R.availableWorkShifts || R.availableWorkShifts.length === 0 || R.availableWorkShifts.some((L) => L.id === e.id);
    }).length, C = Math.min(T, Math.max(0, S - w));
    return b >= C;
  });
  return /* @__PURE__ */ x.jsxs(Ze.Tr, { children: [
    /* @__PURE__ */ x.jsx(Ze.Td, { children: /* @__PURE__ */ x.jsxs(Fe, { gap: "xs", justify: "space-between", wrap: "nowrap", children: [
      /* @__PURE__ */ x.jsxs(Fe, { gap: 6, wrap: "nowrap", children: [
        /* @__PURE__ */ x.jsx(
          on,
          {
            circle: !0,
            size: "sm",
            color: e.color || "gray",
            styles: { root: { width: 10, height: 10, minWidth: 10 } }
          }
        ),
        /* @__PURE__ */ x.jsx(ae, { fw: 700, size: "sm", children: e.symbol })
      ] }),
      !e.isOff && /* @__PURE__ */ x.jsxs(Fe, { gap: 2, wrap: "nowrap", children: [
        /* @__PURE__ */ x.jsx(
          ss,
          {
            label: "모든 날짜의 필요 인원이 이미 최대 배치 가능 인원에 도달했습니다.",
            disabled: !p,
            withArrow: !0,
            children: /* @__PURE__ */ x.jsx(yt, { style: { display: "inline-block" }, children: /* @__PURE__ */ x.jsx(
              hi,
              {
                size: "xs",
                variant: "subtle",
                color: "gray",
                onClick: () => d(e.id, 1),
                disabled: p,
                children: /* @__PURE__ */ x.jsx(hC, { size: 12 })
              }
            ) })
          }
        ),
        /* @__PURE__ */ x.jsx(
          hi,
          {
            size: "xs",
            variant: "subtle",
            color: "gray",
            onClick: () => d(e.id, -1),
            children: /* @__PURE__ */ x.jsx($y, { size: 12 })
          }
        )
      ] })
    ] }) }),
    t.map((g) => {
      var N;
      const y = g.format("YYYY-MM-DD"), b = !!u[y], S = DM(g, b), w = s[y], T = r.filter((L) => {
        const j = L.statusPeriods || [];
        return Ri(j, g.toDate()) === "ACTIVE";
      }).length;
      if (e.isOff) {
        const L = o.filter((W) => !W.isOff).reduce((W, Z) => {
          var fe;
          return W + (((fe = i[y]) == null ? void 0 : fe[Z.id]) ?? 0);
        }, 0), j = Math.max(0, T - L);
        return /* @__PURE__ */ x.jsx(
          Ze.Td,
          {
            style: {
              padding: 0,
              backgroundColor: w ? "#fff0f0" : S.cellBg,
              boxShadow: w ? "inset 2px 0 0 0 red, inset -2px 0 0 0 red" : void 0
            },
            children: /* @__PURE__ */ x.jsx(
              ae,
              {
                size: "sm",
                fw: 500,
                ta: "center",
                style: { height: "40px", lineHeight: "40px", margin: 0 },
                c: "dimmed",
                children: j
              }
            )
          },
          y
        );
      }
      const C = o.filter((L) => !L.isOff && L.id !== e.id).reduce((L, j) => {
        var W;
        return L + (((W = i[y]) == null ? void 0 : W[j.id]) ?? 0);
      }, 0), k = r.filter((L) => {
        const j = L.statusPeriods || [];
        return Ri(j, g.toDate()) !== "ACTIVE" ? !1 : !L.availableWorkShifts || L.availableWorkShifts.length === 0 || L.availableWorkShifts.some((W) => W.id === e.id);
      }).length, R = Math.min(
        k,
        Math.max(0, T - C)
      );
      return /* @__PURE__ */ x.jsx(
        Ze.Td,
        {
          style: {
            padding: 0,
            backgroundColor: w ? "#fff0f0" : S.cellBg,
            boxShadow: w ? "inset 2px 0 0 0 red, inset -2px 0 0 0 red" : void 0
          },
          children: /* @__PURE__ */ x.jsx(
            g1,
            {
              variant: "unstyled",
              size: "sm",
              min: 0,
              max: R,
              value: ((N = i[y]) == null ? void 0 : N[e.id]) ?? 0,
              onChange: (L) => h(y, e.id, Number(L)),
              disabled: a || c,
              styles: {
                input: {
                  textAlign: "center",
                  padding: 0,
                  height: "40px",
                  fontSize: "14px",
                  opacity: a || c ? 0.7 : 1,
                  cursor: a || c ? "not-allowed" : "default"
                }
              },
              hideControls: !0
            }
          )
        },
        y
      );
    })
  ] });
}), DM = (n, e) => {
  const t = n.day(), r = t === 0 || e, i = t === 6;
  return r ? {
    headerBg: "#ffe3e3",
    cellBg: "#fff0f0",
    color: "red"
  } : i ? {
    headerBg: "#e7f5ff",
    cellBg: "#f0f8ff",
    color: "blue"
  } : {
    headerBg: void 0,
    cellBg: void 0,
    color: void 0
  };
}, Ri = (n, e) => {
  const t = xt(e), r = n.find((i) => {
    const s = xt(i.startDate), o = xt(i.endDate);
    return (t.isAfter(s) || t.isSame(s, "day")) && (t.isBefore(o) || t.isSame(o, "day"));
  });
  return (r == null ? void 0 : r.status) ?? "ACTIVE";
};
function EQ({
  nurses: n,
  startDate: e,
  endDate: t,
  workShifts: r,
  value: i,
  onChange: s,
  readOnly: o = !1,
  disabled: a = !1,
  holidays: c = []
}) {
  const u = Wt(() => [...r].sort((C, k) => {
    if (C.isOff && !k.isOff) return 1;
    if (!C.isOff && k.isOff) return -1;
    if (C.isOff && k.isOff) return 0;
    const R = new Date(C.startTime).getTime();
    return new Date(k.startTime).getTime() - R;
  }), [r]), [d, h] = Et(i || {});
  wt(() => {
    i && h(i);
  }, [i]);
  const p = Wt(() => {
    const C = {};
    return c.forEach((k) => {
      const R = xt(k.date).format("YYYY-MM-DD");
      C[R] = k;
    }), C;
  }, [c]), g = Wt(() => {
    if (!e || !t) return [];
    const C = [];
    let k = xt(e);
    const R = xt(t);
    for (; k.isBefore(R) || k.isSame(R, "day"); )
      C.push(k), k = k.add(1, "day");
    return C;
  }, [e, t]), y = Wt(() => {
    const C = {};
    return g.length && g.forEach((k) => {
      const R = k.format("YYYY-MM-DD"), N = u.filter((j) => !j.isOff).reduce((j, W) => {
        var Z;
        return j + (((Z = d[R]) == null ? void 0 : Z[W.id]) ?? 0);
      }, 0), L = n.filter((j) => {
        const W = j.statusPeriods || [];
        return Ri(W, k.toDate()) === "ACTIVE";
      }).length;
      N > L && (C[R] = !0);
    }), C;
  }, [g, u, d, n]), b = Object.keys(y).length > 0, S = fn(
    (C, k, R) => {
      if (o || a) return;
      const N = xt(C), L = n.filter((W) => {
        const Z = W.statusPeriods || [];
        return Ri(Z, N.toDate()) === "ACTIVE";
      }).length, j = n.filter((W) => {
        const Z = W.statusPeriods || [];
        return Ri(Z, N.toDate()) !== "ACTIVE" ? !1 : !W.availableWorkShifts || W.availableWorkShifts.length === 0 || W.availableWorkShifts.some((fe) => fe.id === k);
      }).length;
      h((W) => {
        const Z = u.filter((Y) => !Y.isOff && Y.id !== k).reduce((Y, re) => {
          var q;
          return Y + (((q = W[C]) == null ? void 0 : q[re.id]) ?? 0);
        }, 0), fe = Math.min(
          j,
          Math.max(0, L - Z)
        ), Oe = Math.min(fe, Math.max(0, R)), Ae = { ...W };
        return Ae[C] || (Ae[C] = {}), Ae[C][k] = Oe, s == null || s(Ae), Ae;
      });
    },
    [o, a, n, u, s]
  ), w = fn(
    (C, k) => {
      o || a || h((R) => {
        const N = { ...R };
        return g.forEach((L) => {
          const j = L.format("YYYY-MM-DD");
          N[j] || (N[j] = {});
          const W = N[j][C] ?? 0, Z = n.filter((Y) => {
            const re = Y.statusPeriods || [];
            return Ri(re, L.toDate()) === "ACTIVE";
          }).length, fe = u.filter((Y) => !Y.isOff && Y.id !== C).reduce((Y, re) => {
            var q;
            return Y + (((q = N[j]) == null ? void 0 : q[re.id]) ?? 0);
          }, 0), Oe = n.filter((Y) => {
            const re = Y.statusPeriods || [];
            return Ri(re, L.toDate()) !== "ACTIVE" ? !1 : !Y.availableWorkShifts || Y.availableWorkShifts.length === 0 || Y.availableWorkShifts.some((q) => q.id === C);
          }).length, Ae = Math.min(
            Oe,
            Math.max(0, Z - fe)
          );
          N[j][C] = Math.min(Ae, Math.max(0, W + k));
        }), s == null || s(N), N;
      });
    },
    [o, a, g, n, u, s]
  ), T = Wt(() => e ? xt(e).format("YYYY년 MM월 근무 인원수 설정") : "", [e]);
  return !e || !t ? /* @__PURE__ */ x.jsx(ae, { c: "dimmed", children: "날짜를 먼저 선택해주세요." }) : /* @__PURE__ */ x.jsxs(er, { withBorder: !0, shadow: "sm", radius: "md", p: "md", children: [
    /* @__PURE__ */ x.jsx(ae, { size: "lg", fw: 700, mb: "md", children: T }),
    b && /* @__PURE__ */ x.jsx(
      Ws,
      {
        icon: /* @__PURE__ */ x.jsx(OU, { size: "1rem" }),
        title: "인원 초과",
        color: "red",
        mb: "md",
        variant: "light",
        children: "일부 날짜의 투입 인원이 전체 간호사 수를 초과했습니다. 빨간색으로 표시된 날짜를 확인해주세요."
      }
    ),
    /* @__PURE__ */ x.jsx(Bc, { children: /* @__PURE__ */ x.jsxs(Ze, { withTableBorder: !0, withColumnBorders: !0, children: [
      /* @__PURE__ */ x.jsx(Ze.Thead, { children: /* @__PURE__ */ x.jsxs(Ze.Tr, { children: [
        /* @__PURE__ */ x.jsx(Ze.Th, { style: { minWidth: 120 }, children: "근무" }),
        g.map((C) => {
          const k = C.format("YYYY-MM-DD"), R = p[k], N = DM(C, !!R), L = y[k], j = /* @__PURE__ */ x.jsxs(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: R ? "default" : void 0
              },
              children: [
                /* @__PURE__ */ x.jsx(ae, { size: "sm", fw: 700, c: L ? "red" : N.color, children: C.date() }),
                /* @__PURE__ */ x.jsx(ae, { size: "xs", c: L ? "red" : N.color, children: C.format("dd") })
              ]
            }
          );
          return /* @__PURE__ */ x.jsx(
            Ze.Th,
            {
              style: {
                minWidth: 50,
                textAlign: "center",
                backgroundColor: L ? "#ffe3e3" : N.headerBg,
                boxShadow: L ? "inset 2px 0 0 0 red, inset -2px 0 0 0 red, inset 0 2px 0 0 red" : void 0
              },
              children: R ? /* @__PURE__ */ x.jsx(ss, { label: R.name, withArrow: !0, children: /* @__PURE__ */ x.jsx("div", { children: j }) }) : j
            },
            k
          );
        })
      ] }) }),
      /* @__PURE__ */ x.jsx(Ze.Tbody, { children: u.map((C) => /* @__PURE__ */ x.jsx(
        yJ,
        {
          ws: C,
          days: g,
          nurses: n,
          data: d,
          dailyErrors: y,
          workShifts: u,
          readOnly: o,
          disabled: a,
          holidayMap: p,
          onBatchUpdate: w,
          onInputChange: S
        },
        C.id
      )) }),
      /* @__PURE__ */ x.jsx(Ze.Tfoot, { children: /* @__PURE__ */ x.jsxs(Ze.Tr, { children: [
        /* @__PURE__ */ x.jsx(Ze.Th, { children: /* @__PURE__ */ x.jsx(ae, { size: "sm", fw: 700, ta: "center", children: "합계" }) }),
        g.map((C) => {
          const k = C.format("YYYY-MM-DD"), R = y[k], N = n.filter((j) => {
            const W = j.statusPeriods || [];
            return Ri(W, C.toDate()) === "ACTIVE";
          }).length, L = u.reduce((j, W) => {
            var Z;
            if (W.isOff) {
              const fe = u.filter((Oe) => !Oe.isOff).reduce((Oe, Ae) => {
                var Y;
                return Oe + (((Y = d[k]) == null ? void 0 : Y[Ae.id]) ?? 0);
              }, 0);
              return j + Math.max(0, N - fe);
            }
            return j + (((Z = d[k]) == null ? void 0 : Z[W.id]) ?? 0);
          }, 0);
          return /* @__PURE__ */ x.jsx(
            Ze.Th,
            {
              style: {
                textAlign: "center",
                backgroundColor: R ? "#ffe3e3" : "#f8f9fa",
                boxShadow: R ? "inset 2px 0 0 0 red, inset -2px 0 0 0 red, inset 0 -2px 0 0 red" : void 0
              },
              children: /* @__PURE__ */ x.jsx(ae, { size: "sm", fw: 700, c: R ? "red" : void 0, children: L })
            },
            k
          );
        })
      ] }) })
    ] }) }),
    /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", mt: "xs", children: [
      /* @__PURE__ */ x.jsx(ae, { size: "xs", c: "dimmed", children: "사용법: ↑↓ 전체 조정, 각 셀 직접 입력 가능" }),
      /* @__PURE__ */ x.jsx(ae, { size: "xs", c: "dimmed", children: "주말: 파란색/빨간색 배경" })
    ] })
  ] });
}
function a1({
  initialValue: n = "",
  placeholder: e = "댓글을 입력하세요...",
  onSubmit: t,
  onCancel: r,
  submitLabel: i = "등록",
  cancelLabel: s = "취소",
  loading: o = !1,
  autoFocus: a = !1
}) {
  const [c, u] = Et(n), d = async (p) => {
    if (p.preventDefault(), !!c.trim())
      try {
        await t(c), u("");
      } catch (g) {
        console.error(g);
      }
  }, h = !c.trim() || o;
  return /* @__PURE__ */ x.jsx("form", { onSubmit: d, style: { width: "100%" }, children: /* @__PURE__ */ x.jsxs(ct, { gap: "xs", children: [
    /* @__PURE__ */ x.jsx(
      F2,
      {
        placeholder: e,
        value: c,
        onChange: (p) => u(p.currentTarget.value),
        minRows: 4,
        maxLength: 5e3,
        autosize: !0,
        autoFocus: a,
        disabled: o,
        styles: {
          input: {
            transition: "border-color 0.2s ease, box-shadow 0.2s ease",
            borderRadius: "var(--mantine-radius-md)",
            "&:focus": {
              borderColor: "var(--mantine-color-blue-filled)",
              boxShadow: "0 0 0 2px rgba(34, 139, 230, 0.15)"
            }
          }
        }
      }
    ),
    /* @__PURE__ */ x.jsxs(Fe, { justify: "flex-end", gap: "xs", children: [
      r && /* @__PURE__ */ x.jsx(
        hn,
        {
          type: "button",
          variant: "subtle",
          color: "gray",
          size: "xs",
          onClick: r,
          disabled: o,
          style: { borderRadius: "var(--mantine-radius-md)" },
          children: s
        }
      ),
      /* @__PURE__ */ x.jsx(
        hn,
        {
          type: "submit",
          size: "xs",
          disabled: h,
          loading: o,
          style: { borderRadius: "var(--mantine-radius-md)" },
          children: i
        }
      )
    ] })
  ] }) });
}
var RM = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, l1 = ze.createContext && /* @__PURE__ */ ze.createContext(RM), vJ = ["attr", "size", "title"];
function bJ(n, e) {
  if (n == null) return {};
  var t = xJ(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function xJ(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
function Vf() {
  return Vf = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, Vf.apply(this, arguments);
}
function c1(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Hf(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? c1(Object(t), !0).forEach(function(r) {
      SJ(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : c1(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function SJ(n, e, t) {
  return e = wJ(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function wJ(n) {
  var e = EJ(n, "string");
  return typeof e == "symbol" ? e : e + "";
}
function EJ(n, e) {
  if (typeof n != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function kM(n) {
  return n && n.map((e, t) => /* @__PURE__ */ ze.createElement(e.tag, Hf({
    key: t
  }, e.attr), kM(e.child)));
}
function ll(n) {
  return (e) => /* @__PURE__ */ ze.createElement(AJ, Vf({
    attr: Hf({}, n.attr)
  }, e), kM(n.child));
}
function AJ(n) {
  var e = (t) => {
    var {
      attr: r,
      size: i,
      title: s
    } = n, o = bJ(n, vJ), a = i || t.size || "1em", c;
    return t.className && (c = t.className), n.className && (c = (c ? c + " " : "") + n.className), /* @__PURE__ */ ze.createElement("svg", Vf({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, t.attr, r, o, {
      className: c,
      style: Hf(Hf({
        color: n.color || t.color
      }, t.style), n.style),
      height: a,
      width: a,
      xmlns: "http://www.w3.org/2000/svg"
    }), s && /* @__PURE__ */ ze.createElement("title", null, s), n.children);
  };
  return l1 !== void 0 ? /* @__PURE__ */ ze.createElement(l1.Consumer, null, (t) => e(t)) : e(RM);
}
function TJ(n) {
  return ll({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" }, child: [] }] })(n);
}
function CJ(n) {
  return ll({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z" }, child: [] }] })(n);
}
function DJ(n) {
  return ll({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" }, child: [] }] })(n);
}
function RJ(n) {
  return ll({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "m7 10 5 5 5-5z" }, child: [] }] })(n);
}
function kJ(n) {
  return ll({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "m7 14 5-5 5 5z" }, child: [] }] })(n);
}
function MJ(n) {
  return ll({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" }, child: [] }] })(n);
}
function AQ({
  comments: n,
  currentUserId: e,
  onCreateComment: t,
  onUpdateComment: r,
  onDeleteComment: i,
  loading: s = !1
}) {
  const [o, a] = Et(null), [c, u] = Et(null), [d, h] = Et(null);
  wt(() => {
    if (n.length === 0) return;
    const w = decodeURIComponent(window.location.hash.slice(1));
    w.startsWith("comment-") && requestAnimationFrame(() => {
      var T;
      (T = document.getElementById(w)) == null || T.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }, [n.length]);
  const p = async (w, T) => {
    h(`reply-${w}`);
    try {
      await t(T, w), a(null);
    } finally {
      h(null);
    }
  }, g = async (w, T) => {
    h(`edit-${w}`);
    try {
      await r(w, T), u(null);
    } finally {
      h(null);
    }
  }, y = async (w) => {
    if (window.confirm("정말 삭제하시겠습니까?")) {
      h(`delete-${w}`);
      try {
        await i(w);
      } finally {
        h(null);
      }
    }
  }, b = (w) => {
    const T = new Date(w);
    return `${T.toLocaleDateString("ko-KR")} ${T.toLocaleTimeString("ko-KR", {
      hour: "2-digit",
      minute: "2-digit"
    })}`;
  }, S = (w, T = !1) => {
    const C = e && w.user.id === e, k = c === w.id, R = o === w.id, N = d == null ? void 0 : d.includes(w.id);
    return /* @__PURE__ */ x.jsxs(
      ct,
      {
        id: `comment-${w.id}`,
        gap: "xs",
        style: { width: "100%", scrollMarginTop: "96px" },
        children: [
          /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", align: "flex-start", wrap: "nowrap", children: [
            /* @__PURE__ */ x.jsxs(Fe, { gap: "sm", align: "center", wrap: "nowrap", children: [
              /* @__PURE__ */ x.jsx(
                hy,
                {
                  src: w.user.profileImage,
                  alt: w.user.name,
                  radius: "xl",
                  size: T ? "sm" : "md",
                  color: "blue",
                  children: w.user.name.slice(0, 2)
                }
              ),
              /* @__PURE__ */ x.jsxs("div", { children: [
                /* @__PURE__ */ x.jsxs(Fe, { gap: "xs", align: "center", children: [
                  /* @__PURE__ */ x.jsx(ae, { size: "sm", fw: 600, children: w.user.name }),
                  C && /* @__PURE__ */ x.jsx(
                    ae,
                    {
                      size: "10px",
                      bg: "blue.1",
                      c: "blue.7",
                      px: "xs",
                      style: { borderRadius: "10px", fontWeight: 700 },
                      children: "작성자"
                    }
                  )
                ] }),
                /* @__PURE__ */ x.jsx(ae, { size: "xs", c: "dimmed", children: b(w.createdAt) })
              ] })
            ] }),
            !w.isDeleted && C && !k && /* @__PURE__ */ x.jsxs(Ct, { shadow: "md", width: 110, position: "bottom-end", children: [
              /* @__PURE__ */ x.jsx(Ct.Target, { children: /* @__PURE__ */ x.jsx(hi, { variant: "subtle", color: "gray", size: "sm", loading: N, children: /* @__PURE__ */ x.jsx(MJ, { size: 16 }) }) }),
              /* @__PURE__ */ x.jsxs(Ct.Dropdown, { children: [
                /* @__PURE__ */ x.jsx(
                  Ct.Item,
                  {
                    leftSection: /* @__PURE__ */ x.jsx(DJ, { size: 14 }),
                    onClick: () => u(w.id),
                    children: "수정"
                  }
                ),
                /* @__PURE__ */ x.jsx(
                  Ct.Item,
                  {
                    leftSection: /* @__PURE__ */ x.jsx(TJ, { size: 14 }),
                    color: "red",
                    onClick: () => y(w.id),
                    children: "삭제"
                  }
                )
              ] })
            ] })
          ] }),
          /* @__PURE__ */ x.jsx(yt, { pl: T ? "38px" : "46px", pr: "xs", children: k ? /* @__PURE__ */ x.jsx(
            a1,
            {
              initialValue: w.content,
              onSubmit: (L) => g(w.id, L),
              onCancel: () => u(null),
              loading: N,
              autoFocus: !0
            }
          ) : w.isDeleted ? /* @__PURE__ */ x.jsx(ae, { size: "sm", c: "dimmed", fs: "italic", children: "삭제된 댓글입니다." }) : /* @__PURE__ */ x.jsx(ae, { size: "sm", style: { whiteSpace: "pre-wrap", wordBreak: "break-all" }, children: w.content }) }),
          !T && !w.isDeleted && !k && /* @__PURE__ */ x.jsx(Fe, { gap: "xs", pl: "46px", children: /* @__PURE__ */ x.jsx(
            hn,
            {
              variant: "subtle",
              color: "blue",
              size: "xs",
              leftSection: /* @__PURE__ */ x.jsx(CJ, { size: 14 }),
              onClick: () => a(w.id),
              style: { height: "auto", padding: "4px 8px" },
              children: "답글 달기"
            }
          ) }),
          R && /* @__PURE__ */ x.jsx(yt, { pl: "46px", pr: "xs", mt: "xs", children: /* @__PURE__ */ x.jsx(
            a1,
            {
              placeholder: "답글을 남겨주세요...",
              onSubmit: (L) => p(w.id, L),
              onCancel: () => a(null),
              loading: N,
              autoFocus: !0
            }
          ) })
        ]
      },
      w.id
    );
  };
  return /* @__PURE__ */ x.jsxs(ct, { gap: "lg", style: { width: "100%" }, children: [
    n.map((w) => /* @__PURE__ */ x.jsx(er, { withBorder: !1, bg: "transparent", style: { width: "100%" }, children: /* @__PURE__ */ x.jsxs(ct, { gap: "md", children: [
      S(w),
      w.replies && w.replies.length > 0 && /* @__PURE__ */ x.jsxs(yt, { style: { paddingLeft: "24px", position: "relative" }, children: [
        /* @__PURE__ */ x.jsx(
          "div",
          {
            style: {
              position: "absolute",
              left: "12px",
              top: "0px",
              bottom: "20px",
              width: "2px",
              backgroundColor: "var(--mantine-color-gray-2)",
              borderRadius: "2px"
            }
          }
        ),
        /* @__PURE__ */ x.jsx(ct, { gap: "md", mt: "sm", children: w.replies.map((T) => S(T, !0)) })
      ] }),
      /* @__PURE__ */ x.jsx(z2, { color: "gray.1" })
    ] }) }, w.id)),
    n.length === 0 && !s && /* @__PURE__ */ x.jsx(er, { withBorder: !0, p: "xl", radius: "md", style: { textAlign: "center" }, children: /* @__PURE__ */ x.jsx(ae, { size: "sm", c: "dimmed", children: "등록된 댓글이 없습니다. 첫 번째 댓글을 남겨보세요!" }) })
  ] });
}
const _J = "_scroll_dji5w_1", OJ = "_table_dji5w_10", Uf = {
  scroll: _J,
  table: OJ
}, IJ = {
  QUEUED: "접수됨",
  RUNNING: "생성 중",
  SUCCEEDED: "생성 결과 확정",
  FAILED: "생성 실패",
  CANCELLED: "생성 취소",
  TIMED_OUT: "생성 만료"
}, NJ = new Map(
  Object.entries({
    ORGANIZATION_GPU_TIMEOUT: "작업 제한 시간이 지났습니다.",
    ORGANIZATION_GPU_CANCELLED: "생성 요청을 취소했습니다.",
    ORGANIZATION_GPU_INTERRUPTED: "GPU 작업이 중단되었습니다.",
    ORGANIZATION_GPU_EXECUTION_FAILED: "GPU가 최종 실행 실패를 반환했습니다."
  })
), u1 = (n) => !n || !Number.isFinite(Date.parse(n)) ? "미확인" : `${new Intl.DateTimeFormat("ko-KR", { timeZone: "Asia/Seoul", dateStyle: "medium", timeStyle: "medium" }).format(new Date(n))} KST`;
function TQ({
  app: n,
  state: e,
  job: t,
  refreshing: r,
  onRefresh: i
}) {
  var u;
  const s = e === "ready" && (t == null ? void 0 : t.app) === n ? t : void 0, o = s ? Array.from(
    { length: s.input.duration },
    (d, h) => new Date(Date.parse(`${s.input.startDayString}T00:00:00Z`) + h * 864e5).toISOString().slice(0, 10)
  ) : [], a = new Map((u = s == null ? void 0 : s.workShiftLabels) == null ? void 0 : u.map((d) => [d.id, d.symbol])), c = new Map(
    s == null ? void 0 : s.input.workShiftIds.map((d, h) => [
      d,
      a.get(d) || `근무 타입 ${h + 1}`
    ])
  );
  return /* @__PURE__ */ x.jsx(fy, { size: "xl", py: "xl", children: /* @__PURE__ */ x.jsxs(ct, { children: [
    /* @__PURE__ */ x.jsx(Ga, { order: 1, children: "생성 작업 상세" }),
    /* @__PURE__ */ x.jsx(ae, { children: "이 작업의 생성 상태와 확정된 결과를 확인합니다. 이 화면에서 표를 수정하거나 새로 생성하지 않습니다." }),
    /* @__PURE__ */ x.jsxs(Fe, { children: [
      /* @__PURE__ */ x.jsx(hn, { component: "a", href: n === "dashboard" ? "/" : "/home", variant: "subtle", children: "홈으로" }),
      i && e !== "invalid" && /* @__PURE__ */ x.jsx(hn, { variant: "light", loading: r, onClick: i, children: "작업 다시 조회" })
    ] }),
    e === "invalid" ? /* @__PURE__ */ x.jsx(Ws, { color: "red", title: "작업 주소를 확인해 주세요", children: "올바르지 않은 생성 작업 주소입니다." }) : e === "error" ? /* @__PURE__ */ x.jsx(Ws, { color: "red", title: "작업을 불러오지 못했습니다", children: "요청한 계정인지 확인해 주세요. 권한이 없거나 보관 기간이 지난 작업은 표시하지 않습니다. 연결 문제라면 같은 작업을 다시 조회해 주세요." }) : s ? /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(er, { withBorder: !0, p: "md", children: /* @__PURE__ */ x.jsxs(ct, { gap: "xs", children: [
        /* @__PURE__ */ x.jsx(on, { children: IJ[s.status] }),
        /* @__PURE__ */ x.jsxs(ae, { children: [
          "작업 번호: ",
          s.id
        ] }),
        /* @__PURE__ */ x.jsxs(ae, { children: [
          "접수: ",
          u1(s.createdAt)
        ] }),
        /* @__PURE__ */ x.jsxs(ae, { children: [
          "최종 처리: ",
          u1(s.finishedAt)
        ] }),
        /* @__PURE__ */ x.jsxs(ae, { children: [
          "대상: ",
          s.input.startDayString,
          "부터 ",
          s.input.duration,
          "일 ·",
          " ",
          s.input.nurseIds.length,
          "명"
        ] }),
        /* @__PURE__ */ x.jsx(ae, { children: "대상 번호는 신청 당시 선택한 순서입니다. 신청 당시 이름을 저장하지 않아 이름을 추정하지 않습니다." }),
        s.status === "SUCCEEDED" ? /* @__PURE__ */ x.jsx(ae, { children: "생성 결과가 확정되었습니다. 표 저장·적용과 수동 요청 최종 승인은 별도입니다." }) : s.errorCode && /* @__PURE__ */ x.jsx(ae, { children: NJ.get(s.errorCode) ?? "원인 확인이 필요합니다. 작업 번호와 함께 문의해 주세요." }),
        s.input.sourceRequestId && n === "backoffice" && /* @__PURE__ */ x.jsx(
          hn,
          {
            component: "a",
            variant: "light",
            href: `/duty-requests/${encodeURIComponent(s.input.sourceRequestId)}#duty-response-${encodeURIComponent(s.input.sourceResponseId ?? "")}`,
            children: "원본 수동 요청 보기"
          }
        )
      ] }) }),
      s.status === "SUCCEEDED" && s.result && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
        /* @__PURE__ */ x.jsx(Ga, { order: 2, children: "이 작업의 생성 결과" }),
        /* @__PURE__ */ x.jsxs(ae, { children: [
          "검토 경고 ",
          s.result.warningCount,
          "건",
          s.result.warningsTruncated ? " · 일부 경고만 표시됩니다." : ""
        ] }),
        s.result.history && /* @__PURE__ */ x.jsxs(ae, { children: [
          "이전 근무 ",
          s.result.history.dayCount,
          "일 참조 ·",
          " ",
          s.result.history.complete ? "이력 확인됨" : `이력 ${s.result.history.missingAssignments}칸 미확인`,
          ". 점수는 이전 이력을 포함한 전체 기간 기준입니다."
        ] }),
        /* @__PURE__ */ x.jsx("section", { className: Uf.scroll, "aria-label": "생성 결과 가로 스크롤", tabIndex: 0, children: /* @__PURE__ */ x.jsxs("table", { className: Uf.table, children: [
          /* @__PURE__ */ x.jsx("caption", { children: "신청 당시 대상 순서로 표시한 생성 결과" }),
          /* @__PURE__ */ x.jsx("thead", { children: /* @__PURE__ */ x.jsxs("tr", { children: [
            /* @__PURE__ */ x.jsx("th", { scope: "col", children: "대상" }),
            o.map((d) => /* @__PURE__ */ x.jsx("th", { scope: "col", children: d }, d))
          ] }) }),
          /* @__PURE__ */ x.jsx("tbody", { children: s.input.nurseIds.map((d, h) => /* @__PURE__ */ x.jsxs("tr", { children: [
            /* @__PURE__ */ x.jsxs("th", { scope: "row", children: [
              "대상 ",
              h + 1
            ] }),
            o.map((p) => {
              var y;
              const g = Object.entries(((y = s.result) == null ? void 0 : y.schedule[p]) ?? {}).filter(([, b]) => b.includes(d)).map(([b]) => c.get(b) ?? "근무 타입 미확인");
              return /* @__PURE__ */ x.jsx("td", { children: g.length ? g.join(" / ") : "미배정" }, p);
            })
          ] }, d)) })
        ] }) }),
        !s.workShiftLabels && /* @__PURE__ */ x.jsx(Ws, { color: "orange", children: "신청 당시 근무 기호를 확인할 수 없어 선택 순서의 번호로 표시합니다." }),
        /* @__PURE__ */ x.jsxs("details", { children: [
          /* @__PURE__ */ x.jsx("summary", { children: "대상 식별번호 보기" }),
          s.input.nurseIds.map((d, h) => /* @__PURE__ */ x.jsxs(ae, { size: "sm", children: [
            "대상 ",
            h + 1,
            ": ",
            d
          ] }, d))
        ] }),
        s.result.warnings.map((d, h) => /* @__PURE__ */ x.jsxs(ae, { size: "sm", children: [
          d.dayString,
          ":",
          " ",
          d.code === "staffing" ? "필요 인원 검토" : "근무 조건 검토",
          d.nurseId ? ` · 대상 ${s.input.nurseIds.indexOf(d.nurseId) + 1}` : ""
        ] }, `${d.code}:${h}`))
      ] })
    ] }) : /* @__PURE__ */ x.jsx(ae, { role: "status", children: "생성 작업을 불러오고 있습니다." })
  ] }) });
}
function CQ({
  summary: n
}) {
  if (!(n != null && n.entries.length)) return null;
  const e = n.entries.some((r) => r.status !== "complete"), t = n.entries.some(
    (r) => r.status === "complete" || r.status === "incomplete"
  );
  return /* @__PURE__ */ x.jsx(Ws, { title: "이전 근무 이력 안내", color: e ? "orange" : "blue", children: /* @__PURE__ */ x.jsxs(ct, { gap: "xs", children: [
    n.entries.some((r) => r.status !== "unavailable") && /* @__PURE__ */ x.jsx(ae, { size: "sm", children: "새 근무표는 정상적으로 생성되었습니다. 아래 안내는 생성 시작일 이전의 근무 기록에 관한 내용이며, 생성 실패나 새 근무표의 누락을 의미하지 않습니다." }),
    n.entries.slice(0, 10).map((r, i) => {
      var s;
      return /* @__PURE__ */ x.jsxs(ae, { size: "sm", children: [
        r.startDayString,
        "부터 ",
        r.duration,
        "일:",
        " ",
        r.status === "complete" ? `시작 전 ${r.historyDays}일의 이전 근무 이력을 반영했습니다.` : r.status === "incomplete" ? `시작 전 ${r.historyDays}일의 이전 근무 기록 중 ${(s = r.missingAssignments) == null ? void 0 : s.toLocaleString("ko-KR")}칸이 없어, 확인 가능한 기록만 반영했습니다. 이전 기간과 이어지는 연속 근무 등은 완전히 검사할 수 없습니다.` : r.status === "independent" ? "생성 시작 전 이전 근무 이력은 계산에 포함되지 않았습니다. 이전 기간과의 연결을 별도로 확인해 주세요." : "이전 근무 반영 여부와 점수 범위를 확인할 수 없습니다. 결과 적용 전 다시 확인해 주세요."
      ] }, `${r.startDayString}:${i}`);
    }),
    n.entries.length > 10 && /* @__PURE__ */ x.jsxs(ae, { size: "xs", children: [
      "나머지 ",
      n.entries.length - 10,
      "개 기간의 안내는 생략했습니다."
    ] }),
    t && /* @__PURE__ */ x.jsx(ae, { size: "sm", children: "점수는 확인 가능한 이전 근무 기록과 새로 생성한 기간을 함께 평가한 값입니다. 이전 기록의 반영 범위가 다른 결과끼리는 점수를 직접 비교하지 마세요." })
  ] }) });
}
function DQ({
  failureId: n,
  onRetry: e,
  retryDisabled: t = !1,
  preservationMessage: r = "입력한 명단과 근무 조건을 보존했습니다."
}) {
  const [i, s] = Et(null);
  return /* @__PURE__ */ x.jsx(
    m1,
    {
      opened: n !== null && n !== i,
      onClose: () => s(n),
      title: "근무표 생성 실패",
      centered: !0,
      children: /* @__PURE__ */ x.jsxs(ct, { children: [
        /* @__PURE__ */ x.jsx(ae, { role: "alert", children: "작업을 완료하지 못했습니다. 잠시 후 다시 시도해 주세요." }),
        /* @__PURE__ */ x.jsx(ae, { size: "sm", children: r }),
        /* @__PURE__ */ x.jsxs(Fe, { justify: "flex-end", children: [
          /* @__PURE__ */ x.jsx(hn, { variant: "default", onClick: () => s(n), children: "닫기" }),
          /* @__PURE__ */ x.jsx(
            hn,
            {
              disabled: t,
              onClick: () => {
                t || (s(n), e());
              },
              children: "같은 조건으로 다시 시도"
            }
          )
        ] })
      ] })
    }
  );
}
function RQ(n) {
  const e = n.version ?? n.generation, t = e ? Array.from(
    {
      length: new Date(
        Date.UTC(
          Number(e.input.month.slice(0, 4)),
          Number(e.input.month.slice(5, 7)),
          0
        )
      ).getUTCDate()
    },
    (a, c) => `${e.input.month}-${String(c + 1).padStart(2, "0")}`
  ) : [], r = new Map(e == null ? void 0 : e.cells.map((a) => [`${a.nurseId}:${a.date}`, a])), i = new Map(e == null ? void 0 : e.input.workShifts.map((a) => [a.id, a])), s = (e == null ? void 0 : e.issues.filter((a) => a.severity === "ERROR")) ?? [], o = (e == null ? void 0 : e.issues.filter((a) => a.severity === "WARNING")) ?? [];
  return /* @__PURE__ */ x.jsxs(ct, { children: [
    /* @__PURE__ */ x.jsxs(ae, { children: [
      n.version ? `내용 버전 ${n.version.revision} · ${n.version.completedAt ? "완료본" : "미완료 초안"}` : "검증된 생성 결과 · 읽기 전용",
      " ",
      "· 미배정 ",
      e.cells.filter((a) => !a.workShiftId).length,
      "개"
    ] }),
    /* @__PURE__ */ x.jsx(er, { withBorder: !0, p: "md", children: /* @__PURE__ */ x.jsxs(ct, { gap: "xs", children: [
      /* @__PURE__ */ x.jsx(Ga, { order: 2, children: "저장된 근무타입" }),
      /* @__PURE__ */ x.jsx(Fe, { children: e.input.workShifts.map((a) => /* @__PURE__ */ x.jsxs(
        ae,
        {
          style: { borderLeft: `4px solid ${a.color}`, paddingLeft: 8 },
          children: [
            a.name,
            " (",
            a.symbol,
            ")",
            a.kind !== "OFF" && ` · ${String(Math.floor((a.startMinute ?? 0) / 60)).padStart(2, "0")}:${String((a.startMinute ?? 0) % 60).padStart(2, "0")}~${a.endsNextDay ? "다음 날 " : ""}${String(Math.floor((a.endMinute ?? 0) / 60)).padStart(2, "0")}:${String((a.endMinute ?? 0) % 60).padStart(2, "0")}`
          ]
        },
        a.id
      )) })
    ] }) }),
    /* @__PURE__ */ x.jsx("section", { className: Uf.scroll, "aria-label": "월간 근무표 가로 스크롤", tabIndex: 0, children: /* @__PURE__ */ x.jsxs("table", { className: Uf.table, children: [
      /* @__PURE__ */ x.jsxs("caption", { children: [
        e.input.month,
        " ",
        n.version ? "저장된 근무표" : "생성 결과 근무표"
      ] }),
      /* @__PURE__ */ x.jsx("thead", { children: /* @__PURE__ */ x.jsxs("tr", { children: [
        /* @__PURE__ */ x.jsx("th", { scope: "col", children: "가상 간호사" }),
        t.map((a) => /* @__PURE__ */ x.jsxs("th", { scope: "col", children: [
          Number(a.slice(-2)),
          "일"
        ] }, a))
      ] }) }),
      /* @__PURE__ */ x.jsx("tbody", { children: e.input.nurses.map((a) => {
        var c;
        return /* @__PURE__ */ x.jsxs("tr", { children: [
          /* @__PURE__ */ x.jsxs("th", { scope: "row", children: [
            a.name,
            /* @__PURE__ */ x.jsxs("small", { children: [
              ((c = a.position) == null ? void 0 : c.name) ?? "직급 없음",
              " · 경력 ",
              a.careerMonthsAtMonth,
              "개월"
            ] })
          ] }),
          t.map((u) => {
            const d = r.get(`${a.id}:${u}`), h = d != null && d.workShiftId ? i.get(d.workShiftId) : void 0;
            return /* @__PURE__ */ x.jsxs("td", { children: [
              /* @__PURE__ */ x.jsx("span", { children: (h == null ? void 0 : h.symbol) ?? "미배정" }),
              (d == null ? void 0 : d.fixed) && /* @__PURE__ */ x.jsx("small", { children: "고정" })
            ] }, u);
          })
        ] }, a.id);
      }) })
    ] }) }),
    /* @__PURE__ */ x.jsx(er, { withBorder: !0, p: "md", children: /* @__PURE__ */ x.jsxs(ct, { gap: "xs", children: [
      /* @__PURE__ */ x.jsx(Ga, { order: 2, children: "검토 결과" }),
      /* @__PURE__ */ x.jsxs(ae, { children: [
        "구조 오류 ",
        s.length,
        "개 · 경고 ",
        o.length,
        "개"
      ] }),
      /* @__PURE__ */ x.jsx(ae, { size: "sm", children: "근무 규칙이나 인원 경고는 사용자 배정을 자동으로 바꾸지 않습니다." }),
      e.issues.map((a, c) => {
        var u;
        return /* @__PURE__ */ x.jsxs(ae, { size: "sm", children: [
          a.severity === "ERROR" ? "오류" : "경고",
          ": ",
          a.message,
          (u = a.dates) != null && u.length ? ` (${a.dates.join(", ")})` : ""
        ] }, `${a.code}:${c}`);
      })
    ] }) })
  ] });
}
const d1 = {
  APPROVED: { color: "green", label: "승인됨" },
  REJECTED: { color: "red", label: "반려됨" },
  PENDING: { color: "yellow", label: "대기중" },
  CANCELED: { color: "gray", label: "취소됨" }
};
function kQ({ status: n }) {
  const e = d1[n] || d1.PENDING;
  return /* @__PURE__ */ x.jsx(on, { color: e.color, children: e.label });
}
const PJ = (n) => n ? typeof n == "object" ? n.name || "-" : n : "-", MQ = (n, e) => n ? xt(n).format(e || "YYYY-MM-DD") : "-";
function _Q({ position: n, ...e }) {
  const t = PJ(n);
  if (t === "-")
    return /* @__PURE__ */ x.jsx("span", { style: { color: "var(--mantine-color-gray-5)" }, children: "-" });
  const r = ["blue", "teal", "violet", "indigo", "cyan", "grape", "orange", "pink"];
  let i = 0;
  for (let o = 0; o < t.length; o++)
    i = t.charCodeAt(o) + ((i << 5) - i);
  const s = r[Math.abs(i) % r.length];
  return /* @__PURE__ */ x.jsx(on, { color: s, variant: "light", ...e, children: t });
}
function OQ({ companyId: n, ...e }) {
  const { data: t = [], isLoading: r } = E1({
    queryKey: iB.jobPositions.byCompany(n),
    queryFn: () => {
      if (!n) throw new Error("병원 ID가 필요합니다.");
      return rB({ companyId: n });
    },
    enabled: !!n
  }), i = t.map((s) => ({
    value: s.id,
    label: s.name
  }));
  return /* @__PURE__ */ x.jsx(
    py,
    {
      label: "직책",
      placeholder: r ? "로딩 중..." : "직책 선택",
      disabled: r || !n,
      data: i,
      ...e
    }
  );
}
function IQ({
  nurses: n,
  selectedIds: e,
  isFetching: t,
  onChange: r,
  error: i
}) {
  const s = n.length > 0 && e.length === n.length, o = Wt(() => {
    const d = xt().startOf("day"), h = {};
    for (const p of n) {
      const y = (p.statusPeriods || []).find((S) => {
        const w = xt(S.startDate).startOf("day"), T = xt(S.endDate).startOf("day");
        return (d.isAfter(w) || d.isSame(w, "day")) && (d.isBefore(T) || d.isSame(T, "day"));
      }), b = (y == null ? void 0 : y.status) ?? "ACTIVE";
      if (b !== "ACTIVE") {
        const S = {
          PRE_JOIN: "입사 예정",
          LEAVE: "휴직 중",
          RESIGNED: "퇴사 완료"
        }, w = {
          PRE_JOIN: "blue",
          LEAVE: "yellow",
          RESIGNED: "orange"
        };
        h[p.id] = {
          label: S[b] || "근무 불가",
          color: w[b] || "gray"
        };
      }
    }
    return h;
  }, [n]), a = () => {
    r(n.map((d) => d.id));
  }, c = () => {
    r([]);
  }, u = (d) => {
    e.includes(d) ? r(e.filter((h) => h !== d)) : r([...e, d]);
  };
  return /* @__PURE__ */ x.jsxs(ct, { gap: "xs", children: [
    /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", align: "center", children: [
      /* @__PURE__ */ x.jsxs(ae, { size: "sm", fw: 500, children: [
        "대상 간호사 (",
        e.length,
        "/",
        n.length,
        ")"
      ] }),
      /* @__PURE__ */ x.jsxs(Fe, { gap: "xs", children: [
        /* @__PURE__ */ x.jsx(
          hn,
          {
            variant: "light",
            size: "xs",
            onClick: a,
            disabled: s || n.length === 0,
            children: "전체 선택"
          }
        ),
        /* @__PURE__ */ x.jsx(
          hn,
          {
            variant: "subtle",
            color: "gray",
            size: "xs",
            onClick: c,
            disabled: e.length === 0,
            children: "선택 해제"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ x.jsxs(er, { withBorder: !0, radius: "md", children: [
      /* @__PURE__ */ x.jsx(Bc, { h: 300, offsetScrollbars: !0, children: /* @__PURE__ */ x.jsxs(ct, { gap: 0, children: [
        n.map((d, h) => {
          var g;
          const p = e.includes(d.id);
          return /* @__PURE__ */ x.jsx(
            Lc,
            {
              type: "button",
              "aria-pressed": p,
              onClick: () => u(d.id),
              style: (y) => ({
                padding: y.spacing.sm,
                cursor: "pointer",
                borderBottom: h !== n.length - 1 ? `${Vn(1)} solid ${y.colors.gray[2]}` : void 0,
                backgroundColor: p ? y.colors.blue[0] : "transparent",
                transition: "background-color 0.2s ease",
                width: "100%"
              }),
              children: /* @__PURE__ */ x.jsxs(Fe, { wrap: "nowrap", children: [
                /* @__PURE__ */ x.jsx(
                  Gl,
                  {
                    checked: p,
                    onChange: () => {
                    },
                    "aria-hidden": "true",
                    tabIndex: -1,
                    style: { pointerEvents: "none" }
                  }
                ),
                /* @__PURE__ */ x.jsx(hy, { radius: "xl", color: "blue", src: null, alt: d.user.name, children: d.user.name.slice(0, 1) }),
                /* @__PURE__ */ x.jsxs("div", { style: { flex: 1 }, children: [
                  /* @__PURE__ */ x.jsxs(Fe, { gap: "xs", align: "center", children: [
                    /* @__PURE__ */ x.jsx(ae, { size: "sm", fw: 500, children: d.user.name }),
                    (o == null ? void 0 : o[d.id]) && /* @__PURE__ */ x.jsx(on, { size: "xs", color: o[d.id].color, variant: "light", children: o[d.id].label }),
                    d.preceptorType === "PRECEPTOR" && /* @__PURE__ */ x.jsx(on, { size: "xs", color: "blue", variant: "light", children: "프리셉터" }),
                    d.preceptorType === "PRECEPEE" && /* @__PURE__ */ x.jsx(on, { size: "xs", color: "teal", variant: "light", children: "프리셉티" })
                  ] }),
                  /* @__PURE__ */ x.jsx(ae, { size: "xs", c: "dimmed", children: ((g = d.position) == null ? void 0 : g.name) || "-" })
                ] })
              ] })
            },
            d.id
          );
        }),
        n.length === 0 && /* @__PURE__ */ x.jsx(yt, { p: "xl", ta: "center", children: /* @__PURE__ */ x.jsx(ae, { c: "dimmed", size: "sm", children: "표시할 간호사가 없습니다." }) })
      ] }) }),
      /* @__PURE__ */ x.jsx(Wf, { visible: t })
    ] }),
    i && /* @__PURE__ */ x.jsx(ae, { c: "red", size: "xs", children: i })
  ] });
}
function NQ({ value: n, onChange: e, ...t }) {
  return /* @__PURE__ */ x.jsx(
    py,
    {
      value: n || "NONE",
      onChange: (r) => e == null ? void 0 : e(r),
      data: [
        { value: "NONE", label: "일반" },
        { value: "PRECEPTOR", label: "프리셉터" },
        { value: "PRECEPEE", label: "프리셉티" }
      ],
      ...t
    }
  );
}
function PQ({ role: n, ...e }) {
  let t = "gray", r = n;
  return n === "SUPER_ADMIN" ? (t = "red", r = "최고 관리자") : n === "HOSPITAL_ADMIN" ? (t = "blue", r = "병원 관리자") : n === "TEAM_ADMIN" ? (t = "cyan", r = "팀 관리자") : n === "NORMAL_USER" && (t = "gray", r = "일반 사용자"), /* @__PURE__ */ x.jsx(on, { color: t, variant: "light", ...e, children: r });
}
const LJ = "_bounce_1296f_1", BJ = {
  bounce: LJ
}, LQ = (n) => {
  const { workShift: e, isSelected: t, disabled: r, onClick: i } = n;
  return /* @__PURE__ */ x.jsx(ss, { label: (e == null ? void 0 : e.name) || "", disabled: !e, withArrow: !0, hidden: r, children: /* @__PURE__ */ x.jsx(
    yt,
    {
      className: t ? BJ.bounce : void 0,
      w: 22,
      h: 22,
      mx: "auto",
      onClick: r ? void 0 : i,
      style: {
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: (e == null ? void 0 : e.color) || void 0,
        color: "white",
        textShadow: "0 1px 1px rgba(0,0,0,0.3)",
        border: "1px solid var(--mantine-color-gray-3)",
        transition: "transform 0.1s",
        opacity: r ? 0.4 : 1,
        cursor: r ? "not-allowed" : i ? "pointer" : "default",
        zIndex: r ? void 0 : 2
      },
      children: /* @__PURE__ */ x.jsx(ae, { size: "xs", span: !0, children: (e == null ? void 0 : e.symbol.charAt(0)) || "-" })
    }
  ) });
}, jJ = ["일", "월", "화", "수", "목", "금", "토"], BQ = "duty-requirements-table", jQ = ({
  tableRef: n,
  workShifts: e,
  startDate: t,
  endDate: r,
  requirements: i,
  onRequirementsChange: s
}) => {
  const o = xt(t).startOf("month"), a = xt(r).endOf("month"), c = Array.from({ length: a.diff(o, "day") + 1 }, () => 0);
  return /* @__PURE__ */ x.jsxs(er, { shadow: "sm", radius: "md", withBorder: !0, bg: "white", children: [
    /* @__PURE__ */ x.jsx(
      yt,
      {
        px: "md",
        py: "sm",
        bg: "gray.0",
        style: {
          borderBottom: "1px solid var(--mantine-color-gray-3)",
          borderTopLeftRadius: "var(--mantine-radius-md)",
          borderTopRightRadius: "var(--mantine-radius-md)"
        },
        children: /* @__PURE__ */ x.jsxs(ae, { size: "sm", fw: 600, c: "gray.9", children: [
          o.format("YYYY년 MM월"),
          " 근무 인원수 설정"
        ] })
      }
    ),
    /* @__PURE__ */ x.jsx(Bc, { children: /* @__PURE__ */ x.jsxs(
      Ze,
      {
        className: ["duty-requirements-table"].join(" "),
        ref: n,
        withTableBorder: !0,
        withColumnBorders: !0,
        style: { borderTop: "none", borderBottom: "none" },
        children: [
          /* @__PURE__ */ x.jsx(Ze.Thead, { bg: "gray.0", children: /* @__PURE__ */ x.jsxs(Ze.Tr, { children: [
            /* @__PURE__ */ x.jsx(
              Ze.Th,
              {
                w: 100,
                style: {
                  position: "sticky",
                  left: 0,
                  zIndex: 1,
                  backgroundColor: "var(--mantine-color-gray-0)",
                  boxShadow: "2px 0 4px rgba(0,0,0,0.05)"
                },
                children: /* @__PURE__ */ x.jsx(ae, { size: "xs", fw: 500, c: "gray.7", children: "근무" })
              }
            ),
            c.map((u, d) => {
              const h = o.add(d, "day"), p = h.day() === 0 ? "sun" : h.day() === 6 ? "sat" : null, g = p ? p === "sat" ? "var(--mantine-color-blue-0)" : "var(--mantine-color-red-1)" : "transparent", y = p ? p === "sat" ? "var(--mantine-color-blue-7)" : "var(--mantine-color-red-8)" : "var(--mantine-color-gray-7)";
              return /* @__PURE__ */ x.jsx(
                Ze.Th,
                {
                  p: 4,
                  bg: g,
                  style: {
                    textAlign: "center",
                    minWidth: Vn(40)
                  },
                  children: /* @__PURE__ */ x.jsxs(ct, { gap: 0, align: "center", children: [
                    /* @__PURE__ */ x.jsx(ae, { size: "xs", fw: 700, c: y, children: h.date() }),
                    /* @__PURE__ */ x.jsx(ae, { size: Vn(9), c: y, fw: "normal", children: jJ[h.day()] })
                  ] })
                },
                h.toISOString()
              );
            })
          ] }) }),
          /* @__PURE__ */ x.jsx(Ze.Tbody, { bg: "white", children: e.map((u) => /* @__PURE__ */ x.jsxs(Ze.Tr, { children: [
            /* @__PURE__ */ x.jsx(
              Ze.Td,
              {
                p: Vn(8),
                style: {
                  position: "sticky",
                  left: 0,
                  zIndex: 1,
                  backgroundColor: "white",
                  boxShadow: "2px 0 4px rgba(0,0,0,0.05)",
                  borderRight: "1px solid var(--mantine-color-gray-3)"
                },
                children: /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", gap: "xs", wrap: "nowrap", children: [
                  /* @__PURE__ */ x.jsxs($m, { gap: 6, align: "center", children: [
                    /* @__PURE__ */ x.jsx(V2, { color: u.color || "#FFF", size: 10, withShadow: !1 }),
                    /* @__PURE__ */ x.jsx(ae, { size: "xs", fw: 700, children: u.symbol })
                  ] }),
                  /* @__PURE__ */ x.jsxs($m, { gap: 2, align: "center", children: [
                    /* @__PURE__ */ x.jsx(ss, { label: "전체 +1", openDelay: 500, children: /* @__PURE__ */ x.jsx(
                      hi,
                      {
                        size: "xs",
                        variant: "subtle",
                        color: "gray",
                        onClick: () => {
                          var d;
                          s({
                            ...i,
                            [u.id]: {
                              dailyRequirements: [
                                ...((d = i[u.id]) == null ? void 0 : d.dailyRequirements) || []
                              ].map((h) => h + 1)
                            }
                          });
                        },
                        children: /* @__PURE__ */ x.jsx(kJ, { size: 12 })
                      }
                    ) }),
                    /* @__PURE__ */ x.jsx(ss, { label: "전체 -1", openDelay: 500, children: /* @__PURE__ */ x.jsx(
                      hi,
                      {
                        size: "xs",
                        variant: "subtle",
                        color: "gray",
                        onClick: () => {
                          var d;
                          s({
                            ...i,
                            [u.id]: {
                              dailyRequirements: [
                                ...((d = i[u.id]) == null ? void 0 : d.dailyRequirements) || []
                              ].map((h) => Math.max(0, h - 1))
                            }
                          });
                        },
                        children: /* @__PURE__ */ x.jsx(RJ, { size: 12 })
                      }
                    ) })
                  ] })
                ] })
              }
            ),
            c.map((d, h) => {
              var w;
              const p = ((w = i[u.id]) == null ? void 0 : w.dailyRequirements[h]) || 0, g = o.add(h, "day"), y = g.day() === 0 ? "sun" : g.day() === 6 ? "sat" : null, b = y ? y === "sat" ? "var(--mantine-color-blue-0)" : "var(--mantine-color-red-1)" : "transparent", S = y ? y === "sat" ? "var(--mantine-color-blue-7)" : "var(--mantine-color-red-8)" : "var(--mantine-color-gray-7)";
              return /* @__PURE__ */ x.jsx(Ze.Td, { p: 2, bg: b, children: /* @__PURE__ */ x.jsx(
                g1,
                {
                  value: p,
                  onChange: (T) => {
                    var C;
                    s({
                      ...i,
                      [u.id]: {
                        dailyRequirements: [
                          ...((C = i[u.id]) == null ? void 0 : C.dailyRequirements) || []
                        ]
                      }
                    });
                  },
                  min: 0,
                  c: S,
                  allowNegative: !1,
                  hideControls: !0,
                  variant: "unstyled",
                  styles: {
                    input: {
                      textAlign: "center",
                      fontSize: "0.75rem",
                      // text-xs
                      height: Vn(24),
                      minHeight: Vn(24),
                      padding: 0,
                      backgroundColor: "transparent",
                      border: "1px solid transparent",
                      borderRadius: "4px",
                      transition: "border-color 0.2s, background-color 0.2s"
                    }
                  }
                }
              ) }, g.toISOString());
            })
          ] }, u.id)) })
        ]
      }
    ) }),
    /* @__PURE__ */ x.jsx(
      yt,
      {
        px: "md",
        py: "xs",
        bg: "gray.0",
        style: {
          borderTop: "1px solid var(--mantine-color-gray-3)",
          borderBottomLeftRadius: "var(--mantine-radius-md)",
          borderBottomRightRadius: "var(--mantine-radius-md)"
        },
        children: /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", children: [
          /* @__PURE__ */ x.jsxs(ae, { size: "xs", c: "gray.6", children: [
            /* @__PURE__ */ x.jsx(ae, { span: !0, fw: 600, children: "사용법:" }),
            " ",
            "↑↓ 전체 조정, 각 셀 직접 입력 가능"
          ] }),
          /* @__PURE__ */ x.jsx(ae, { size: "xs", c: "gray.5", children: "주말: 파란색 배경" })
        ] })
      }
    )
  ] });
};
function FQ({ status: n, ...e }) {
  switch (n) {
    case "APPROVED":
      return /* @__PURE__ */ x.jsx(on, { color: "green", ...e, children: "승인" });
    case "REJECTED":
      return /* @__PURE__ */ x.jsx(on, { color: "red", ...e, children: "거절" });
    case "PENDING":
      return /* @__PURE__ */ x.jsx(on, { color: "gray", ...e, children: "미확인" });
    case "CANCELED":
      return /* @__PURE__ */ x.jsx(on, { color: "gray", variant: "outline", ...e, children: "취소" });
    default:
      return /* @__PURE__ */ x.jsx(on, { color: "gray", ...e, children: n });
  }
}
function zQ({
  workShifts: n,
  value: e = [],
  onChange: t,
  label: r = "근무 가능 타입 선택",
  description: i,
  error: s
}) {
  const o = (a) => {
    t && (e.includes(a) ? t(e.filter((c) => c !== a)) : t([...e, a]));
  };
  return /* @__PURE__ */ x.jsx(fc.Wrapper, { label: r, description: i, error: s, children: /* @__PURE__ */ x.jsx(H2, { cols: { base: 1, xs: 2, sm: 3 }, spacing: "sm", mt: "xs", children: n.map((a) => {
    const c = e.includes(a.id), u = a.color || "#bfbfbf";
    return /* @__PURE__ */ x.jsx(
      er,
      {
        withBorder: !0,
        p: "sm",
        radius: "md",
        onClick: () => o(a.id),
        style: {
          cursor: "pointer",
          transition: "all 0.2s ease",
          borderColor: c ? u : "var(--mantine-color-gray-3)",
          borderWidth: c ? "2px" : "1px",
          padding: c ? "11px" : "12px",
          // maintain same outer size
          backgroundColor: c ? `${u}08` : "white",
          // Soft color background
          boxShadow: c ? `0 0 0 1px ${u}` : "none"
        },
        onMouseEnter: (d) => {
          d.currentTarget.style.transform = "translateY(-2px)", d.currentTarget.style.boxShadow = "var(--mantine-shadow-xs)";
        },
        onMouseLeave: (d) => {
          d.currentTarget.style.transform = "none", d.currentTarget.style.boxShadow = c ? `0 0 0 1px ${u}` : "none";
        },
        children: /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", wrap: "nowrap", children: [
          /* @__PURE__ */ x.jsxs(Fe, { gap: "xs", wrap: "nowrap", children: [
            /* @__PURE__ */ x.jsx(
              "div",
              {
                style: {
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  backgroundColor: u,
                  flexShrink: 0
                }
              }
            ),
            /* @__PURE__ */ x.jsx(
              "div",
              {
                style: {
                  backgroundColor: c ? u : "var(--mantine-color-gray-1)",
                  color: c ? "white" : "var(--mantine-color-gray-7)",
                  width: 24,
                  height: 24,
                  borderRadius: 6,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 12,
                  fontWeight: 700,
                  flexShrink: 0,
                  transition: "all 0.2s ease"
                },
                children: a.symbol
              }
            ),
            /* @__PURE__ */ x.jsx(ct, { gap: 0, children: /* @__PURE__ */ x.jsx(ae, { size: "sm", fw: 600, style: { lineHeight: 1.2 }, children: a.name }) })
          ] }),
          /* @__PURE__ */ x.jsx(
            "div",
            {
              style: {
                width: 20,
                height: 20,
                borderRadius: "50%",
                border: `1.5px solid ${c ? u : "var(--mantine-color-gray-4)"}`,
                backgroundColor: c ? u : "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                transition: "all 0.15s ease"
              },
              children: c && /* @__PURE__ */ x.jsx(Wy, { size: 12, strokeWidth: 3 })
            }
          )
        ] })
      },
      a.id
    );
  }) }) });
}
function FJ({
  value: n,
  onChange: e,
  teamId: t,
  label: r = "근무 가능한 근무 유형",
  description: i = "선택된 근무 유형만 근무표 생성 시 배정됩니다.",
  error: s,
  disabled: o = !1,
  style: a,
  className: c,
  loading: u
}) {
  const {
    data: d = [],
    isLoading: h,
    isFetching: p
  } = E1({
    queryKey: ["workShifts", t],
    queryFn: () => sB({ teamId: t }),
    enabled: !!t
  }), g = p, y = u !== void 0 ? u : h, b = n || [], S = d.length > 0 && b.length === d.length, w = (k) => {
    e && (b.includes(k) ? e(b.filter((R) => R !== k)) : e([...b, k]));
  }, T = () => {
    e && e(d.map((k) => k.id));
  }, C = () => {
    e && e([]);
  };
  return /* @__PURE__ */ x.jsx(
    fc.Wrapper,
    {
      label: r,
      description: i,
      error: s,
      style: a,
      className: c,
      children: /* @__PURE__ */ x.jsxs(ct, { gap: "xs", mt: "xs", children: [
        /* @__PURE__ */ x.jsxs(Fe, { justify: "space-between", align: "center", children: [
          /* @__PURE__ */ x.jsxs(ae, { size: "xs", c: "dimmed", children: [
            "선택됨: ",
            b.length,
            "개 / 전체: ",
            d.length,
            "개"
          ] }),
          /* @__PURE__ */ x.jsxs(Fe, { gap: "xs", children: [
            /* @__PURE__ */ x.jsx(
              hn,
              {
                variant: "light",
                size: "xs",
                styles: {
                  root: {
                    height: Vn(24),
                    paddingLeft: Vn(8),
                    paddingRight: Vn(8),
                    fontSize: Vn(11)
                  }
                },
                onClick: T,
                disabled: S || d.length === 0 || o,
                children: "전체 선택"
              }
            ),
            /* @__PURE__ */ x.jsx(
              hn,
              {
                variant: "subtle",
                color: "gray",
                size: "xs",
                styles: {
                  root: {
                    height: Vn(24),
                    paddingLeft: Vn(8),
                    paddingRight: Vn(8),
                    fontSize: Vn(11)
                  }
                },
                onClick: C,
                disabled: b.length === 0 || o,
                children: "선택 해제"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ x.jsxs(er, { withBorder: !0, radius: "md", style: { position: "relative", overflow: "hidden" }, children: [
          /* @__PURE__ */ x.jsx(Bc, { h: 200, offsetScrollbars: !0, p: 0, children: /* @__PURE__ */ x.jsxs(ct, { gap: 0, children: [
            d.map((k, R) => {
              const N = b.includes(k.id);
              return /* @__PURE__ */ x.jsx(
                yt,
                {
                  onClick: () => !o && w(k.id),
                  style: (L) => ({
                    padding: L.spacing.sm,
                    cursor: o ? "not-allowed" : "pointer",
                    borderBottom: R !== d.length - 1 ? `${Vn(1)} solid ${L.colors.gray[2]}` : void 0,
                    backgroundColor: N ? L.colors.blue[0] : "transparent",
                    opacity: o ? 0.6 : 1,
                    transition: "background-color 0.2s ease"
                  }),
                  children: /* @__PURE__ */ x.jsxs(Fe, { wrap: "nowrap", children: [
                    /* @__PURE__ */ x.jsx(
                      Gl,
                      {
                        checked: N,
                        onChange: () => {
                        },
                        tabIndex: -1,
                        disabled: o,
                        style: { pointerEvents: "none" }
                      }
                    ),
                    /* @__PURE__ */ x.jsxs(Fe, { gap: "xs", style: { flex: 1 }, children: [
                      /* @__PURE__ */ x.jsx(
                        on,
                        {
                          color: k.color ?? "gray",
                          variant: "light",
                          style: { minWidth: Vn(48) },
                          children: k.symbol
                        }
                      ),
                      /* @__PURE__ */ x.jsx(ae, { size: "sm", fw: 500, children: k.name }),
                      k.isOff && /* @__PURE__ */ x.jsx(on, { size: "xs", color: "gray", variant: "outline", children: "휴무" })
                    ] })
                  ] })
                },
                k.id
              );
            }),
            d.length === 0 && !y && /* @__PURE__ */ x.jsx(yt, { p: "xl", ta: "center", children: /* @__PURE__ */ x.jsx(ae, { c: "dimmed", size: "sm", children: "표시할 근무 형태가 없습니다." }) })
          ] }) }),
          /* @__PURE__ */ x.jsx(Wf, { visible: y || g, overlayProps: { blur: 1 } })
        ] })
      ] })
    }
  );
}
FJ.displayName = "WorkShiftSelect";
function VQ() {
  const n = fn((r) => {
    const i = r.modalId || `modal-${Math.random().toString(36).substring(2, 9)}`;
    return Ap.open({
      modalId: i,
      centered: !0,
      closeOnClickOutside: !1,
      closeOnEscape: !1,
      ...r
    }), i;
  }, []), e = fn((r) => {
    Ap.close(r);
  }, []), t = fn(() => {
    Ap.closeAll();
  }, []);
  return {
    open: n,
    close: e,
    closeAll: t
  };
}
function HQ(n) {
  return /* @__PURE__ */ x.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 16 19",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      "aria-hidden": "true",
      focusable: "false",
      children: [
        /* @__PURE__ */ x.jsx("path", { d: "M12.8228 9.99849C12.8624 11.7589 14.4069 12.9272 14.4663 12.9668C14.4465 13.0658 14.2089 13.9767 13.6347 14.8282C13.1396 15.5411 12.605 16.2737 11.7535 16.2935C10.902 16.3133 10.6248 15.7787 9.65451 15.7787C8.66444 15.7787 8.36742 16.2737 7.55557 16.3133C6.70411 16.3331 6.09026 15.6203 5.59523 14.8876C4.58536 13.3826 3.8131 11.0857 4.88237 9.18664C5.417 8.23618 6.36748 7.64214 7.43676 7.62234C8.24861 7.60254 9.02087 8.19658 9.5357 8.19658C9.99113 8.19658 10.9614 7.50353 11.9515 7.58274C12.3674 7.60254 13.5158 7.74115 14.3673 9.02823C14.2881 9.06783 12.7832 10.0579 12.8228 9.99849Z" }),
        /* @__PURE__ */ x.jsx("path", { d: "M10.7436 5.8601C11.199 5.26606 11.4961 4.49381 11.3971 3.66216C10.6842 3.68196 9.81295 4.15719 9.31792 4.77103C8.88229 5.30566 8.52587 6.13732 8.64468 6.90956C9.43674 6.96896 10.2882 6.45414 10.7436 5.8601Z" })
      ]
    }
  );
}
function UQ(n) {
  return /* @__PURE__ */ x.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      "aria-hidden": "true",
      focusable: "false",
      children: [
        /* @__PURE__ */ x.jsx(
          "path",
          {
            d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z",
            fill: "#4285F4"
          }
        ),
        /* @__PURE__ */ x.jsx(
          "path",
          {
            d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z",
            fill: "#34A853"
          }
        ),
        /* @__PURE__ */ x.jsx(
          "path",
          {
            d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z",
            fill: "#FBBC05"
          }
        ),
        /* @__PURE__ */ x.jsx(
          "path",
          {
            d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z",
            fill: "#EA4335"
          }
        )
      ]
    }
  );
}
const WQ = (n) => {
  const e = xt(n), t = xt(), r = t.diff(e, "hour"), i = t.diff(e, "minute");
  return r >= 0 && r < 24 ? r > 0 ? `${r}시간 전` : i > 0 ? `${i}분 전` : "방금 전" : e.format("YYYY-MM-DD HH:mm:ss");
}, zJ = new TextEncoder();
function $Q(n) {
  return String(n ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
function GQ(n) {
  if (!n) return "FFFFFFFF";
  const e = n.trim().replace(/^#/, "");
  return /^[0-9a-f]{3}$/i.test(e) ? `FF${e.split("").map((t) => t + t).join("").toUpperCase()}` : /^[0-9a-f]{6}$/i.test(e) ? `FF${e.toUpperCase()}` : /^[0-9a-f]{8}$/i.test(e) ? e.toUpperCase() : "FFFFFFFF";
}
function YQ(n) {
  let e = "", t = n;
  for (; t > 0; ) {
    const r = (t - 1) % 26;
    e = String.fromCharCode(65 + r) + e, t = Math.floor((t - 1) / 26);
  }
  return e;
}
const VJ = (() => {
  const n = new Uint32Array(256);
  for (let e = 0; e < 256; e += 1) {
    let t = e;
    for (let r = 0; r < 8; r += 1)
      t = t & 1 ? 3988292384 ^ t >>> 1 : t >>> 1;
    n[e] = t >>> 0;
  }
  return n;
})();
function HJ(n) {
  let e = 4294967295;
  for (const t of n)
    e = VJ[(e ^ t) & 255] ^ e >>> 8;
  return (e ^ 4294967295) >>> 0;
}
function qQ(n) {
  const e = [], t = [];
  let r = 0;
  for (const d of n) {
    const h = zJ.encode(d.name), p = HJ(d.data), g = new Uint8Array(30 + h.length), y = new DataView(g.buffer);
    y.setUint32(0, 67324752, !0), y.setUint16(4, 20, !0), y.setUint16(6, 2048, !0), y.setUint16(8, 0, !0), y.setUint32(14, p, !0), y.setUint32(18, d.data.length, !0), y.setUint32(22, d.data.length, !0), y.setUint16(26, h.length, !0), g.set(h, 30), e.push(g, d.data);
    const b = new Uint8Array(46 + h.length), S = new DataView(b.buffer);
    S.setUint32(0, 33639248, !0), S.setUint16(4, 20, !0), S.setUint16(6, 20, !0), S.setUint16(8, 2048, !0), S.setUint16(10, 0, !0), S.setUint32(16, p, !0), S.setUint32(20, d.data.length, !0), S.setUint32(24, d.data.length, !0), S.setUint16(28, h.length, !0), S.setUint32(42, r, !0), b.set(h, 46), t.push(b), r += g.length + d.data.length;
  }
  const i = t.reduce((d, h) => d + h.length, 0), s = new Uint8Array(22), o = new DataView(s.buffer);
  o.setUint32(0, 101010256, !0), o.setUint16(8, n.length, !0), o.setUint16(10, n.length, !0), o.setUint32(12, i, !0), o.setUint32(16, r, !0);
  const a = e.reduce((d, h) => d + h.length, 0) + i + s.length, c = new Uint8Array(a);
  let u = 0;
  for (const d of [...e, ...t, s])
    c.set(d, u), u += d.length;
  return c;
}
const MM = new TextDecoder();
async function UJ(n) {
  const e = new Blob([n]).stream().pipeThrough(new DecompressionStream("deflate-raw"));
  return new Uint8Array(await new Response(e).arrayBuffer());
}
async function WJ(n) {
  const e = new Uint8Array(n), t = new DataView(n);
  let r = -1;
  for (let a = e.length - 22; a >= Math.max(0, e.length - 65557); a -= 1)
    if (t.getUint32(a, !0) === 101010256) {
      r = a;
      break;
    }
  if (r < 0) throw new Error("올바른 xlsx 파일이 아닙니다.");
  const i = t.getUint16(r + 10, !0);
  let s = t.getUint32(r + 16, !0);
  const o = /* @__PURE__ */ new Map();
  for (let a = 0; a < i; a += 1) {
    if (t.getUint32(s, !0) !== 33639248) throw new Error("손상된 xlsx 파일입니다.");
    const c = t.getUint16(s + 10, !0), u = t.getUint32(s + 20, !0), d = t.getUint16(s + 28, !0), h = t.getUint16(s + 30, !0), p = t.getUint16(s + 32, !0), g = t.getUint32(s + 42, !0), y = MM.decode(e.subarray(s + 46, s + 46 + d));
    s += 46 + d + h + p;
    const b = t.getUint16(g + 26, !0), S = t.getUint16(g + 28, !0), w = g + 30 + b + S, T = e.subarray(w, w + u);
    if (c === 0) o.set(y, T);
    else if (c === 8) o.set(y, await UJ(T));
    else throw new Error("지원하지 않는 xlsx 압축 형식입니다.");
  }
  return o;
}
function $J(n) {
  var r;
  const e = ((r = n.match(/^[A-Z]+/i)) == null ? void 0 : r[0].toUpperCase()) ?? "";
  let t = 0;
  for (const i of e) t = t * 26 + (i.charCodeAt(0) - 64);
  return t - 1;
}
function fd(n) {
  if (n)
    return new DOMParser().parseFromString(MM.decode(n), "application/xml");
}
function f1(n) {
  return Array.from(n.getElementsByTagNameNS("*", "t")).filter(
    (t) => {
      var r;
      return ((r = t.parentElement) == null ? void 0 : r.localName) !== "rPh";
    }
  ).map((t) => t.textContent ?? "").join("");
}
async function KQ(n) {
  var p, g, y;
  const e = n instanceof ArrayBuffer ? n : await n.arrayBuffer(), t = await WJ(e), r = fd(t.get("xl/workbook.xml")), i = fd(t.get("xl/_rels/workbook.xml.rels")), s = r == null ? void 0 : r.getElementsByTagNameNS("*", "sheet")[0], o = (s == null ? void 0 : s.getAttribute("r:id")) ?? (s == null ? void 0 : s.getAttributeNS(
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
    "id"
  )), a = (p = Array.from((i == null ? void 0 : i.getElementsByTagNameNS("*", "Relationship")) ?? []).find((b) => b.getAttribute("Id") === o)) == null ? void 0 : p.getAttribute("Target"), c = a ? a.startsWith("/") ? a.slice(1) : `xl/${a.replace(/^\.\//, "")}` : "xl/worksheets/sheet1.xml", u = fd(t.get(c) ?? t.get("xl/worksheets/sheet1.xml"));
  if (!u) throw new Error("엑셀 시트를 찾을 수 없습니다.");
  const d = Array.from(
    ((g = fd(t.get("xl/sharedStrings.xml"))) == null ? void 0 : g.getElementsByTagNameNS("*", "si")) ?? []
  ).map(f1), h = [];
  for (const b of Array.from(u.getElementsByTagNameNS("*", "row"))) {
    const S = Number(b.getAttribute("r")) || h.length + 1, w = [];
    let T = 0;
    for (const C of Array.from(b.getElementsByTagNameNS("*", "c"))) {
      const k = C.getAttribute("r"), R = k ? $J(k) : T;
      T = R + 1;
      const N = C.getAttribute("t"), L = ((y = C.getElementsByTagNameNS("*", "v")[0]) == null ? void 0 : y.textContent) ?? "";
      let j;
      N === "s" ? j = d[Number(L)] ?? "" : N === "inlineStr" ? j = f1(C) : j = L, w[R] = j;
    }
    h[S - 1] = Array.from(w, (C) => C ?? "");
  }
  return Array.from(h, (b) => b ?? []);
}
export {
  oQ as AnalyticsTracker,
  HQ as AppleIcon,
  aQ as AuthGuard,
  zQ as AvailableWorkShiftSelector,
  XQ as Button,
  S6 as DtSelect,
  wQ as DutyEditor,
  LQ as DutyIndicator,
  kQ as DutyRequestBadge,
  jQ as DutyRequirementsCalendar,
  EQ as DutyRequirementsEditor,
  BQ as DutyRequirementsTableId,
  a1 as DutyResponseCommentEditor,
  AQ as DutyResponseCommentList,
  rQ as DutyScheduleCalendar,
  cQ as ErrorBoundary,
  xR as ErrorPage,
  DQ as GenerationFailureNotice,
  UQ as GoogleIcon,
  nJ as LoadingOverlayProvider,
  nZ as MonthPickerInput,
  _Q as NursePositionBadge,
  OQ as NursePositionSelect,
  IQ as NurseSelect,
  TQ as OrganizationGenerationJobDetails,
  CQ as OrganizationGpuHistoryNotice,
  NQ as PreceptorTypeSelect,
  RQ as ProScheduleSnapshot,
  dQ as ProfileImageEdit,
  fQ as RichEditor,
  PQ as RoleBadge,
  uQ as RouteErrorBoundary,
  hQ as SafeHtml,
  pQ as TableContainer,
  mQ as TermsConsentModal,
  rZ as TimeInput,
  gQ as TitleContainer,
  yQ as TurnstileWidget,
  bQ as UikitProvider,
  FQ as WantedStatusBadge,
  xQ as WorkShiftBadge,
  FJ as WorkShiftSelect,
  SQ as WorkShiftSymbol,
  qQ as createZip,
  o1 as dutyonTheme,
  $Q as escapeXml,
  MQ as formatDate,
  YQ as getColumnName,
  DM as getDayStyles,
  Ri as getNurseStatusOnDate,
  PJ as getPositionName,
  WQ as getRelativeOrFormattedDate,
  iQ as initGA,
  GQ as normalizeArgbColor,
  KQ as readXlsxFirstSheetRows,
  WJ as readZip,
  sQ as trackDutyAutoGeneration,
  GU as trackEvent,
  YU as trackPageView,
  vQ as useLoader,
  EM as useLoaderState,
  VQ as useModal
};
//# sourceMappingURL=index.es.js.map
